import { jsx as x, jsxs as j, Fragment as _o } from "react/jsx-runtime";
import { c as J, a as le, b as ye } from "./utils-B9z9WPG8.js";
import * as v from "react";
import Ae, { createElement as Sf, useState as Mt, useEffect as rr, Children as d0, isValidElement as f0, useRef as kt, useLayoutEffect as Zi, createContext as xa, use as Jg, useId as bn, useContext as em, useCallback as Rn, useMemo as Wi, Fragment as p0 } from "react";
import * as tn from "react-dom";
function wa() {
  return typeof window < "u";
}
function nn(t) {
  return Oc(t) ? (t.nodeName || "").toLowerCase() : "#document";
}
function vt(t) {
  var e;
  return (t == null || (e = t.ownerDocument) == null ? void 0 : e.defaultView) || window;
}
function io(t) {
  var e;
  return (e = (Oc(t) ? t.ownerDocument : t.document) || window.document) == null ? void 0 : e.documentElement;
}
function Oc(t) {
  return wa() ? t instanceof Node || t instanceof vt(t).Node : !1;
}
function lt(t) {
  return wa() ? t instanceof Element || t instanceof vt(t).Element : !1;
}
function bt(t) {
  return wa() ? t instanceof HTMLElement || t instanceof vt(t).HTMLElement : !1;
}
function kr(t) {
  return !wa() || typeof ShadowRoot > "u" ? !1 : t instanceof ShadowRoot || t instanceof vt(t).ShadowRoot;
}
function Lo(t) {
  const {
    overflow: e,
    overflowX: n,
    overflowY: o,
    display: r
  } = an(t);
  return /auto|scroll|overlay|hidden|clip/.test(e + o + n) && r !== "inline" && r !== "contents";
}
function g0(t) {
  return /^(table|td|th)$/.test(nn(t));
}
function Ca(t) {
  try {
    if (t.matches(":popover-open"))
      return !0;
  } catch {
  }
  try {
    return t.matches(":modal");
  } catch {
    return !1;
  }
}
const m0 = /transform|translate|scale|rotate|perspective|filter/, h0 = /paint|layout|strict|content/, Uo = (t) => !!t && t !== "none";
let fl;
function Dc(t) {
  const e = lt(t) ? an(t) : t;
  return Uo(e.transform) || Uo(e.translate) || Uo(e.scale) || Uo(e.rotate) || Uo(e.perspective) || !Sa() && (Uo(e.backdropFilter) || Uo(e.filter)) || m0.test(e.willChange || "") || h0.test(e.contain || "");
}
function b0(t) {
  let e = ro(t);
  for (; bt(e) && !to(e); ) {
    if (Dc(e))
      return e;
    if (Ca(e))
      return null;
    e = ro(e);
  }
  return null;
}
function Sa() {
  return fl == null && (fl = typeof CSS < "u" && CSS.supports && CSS.supports("-webkit-backdrop-filter", "none")), fl;
}
function to(t) {
  return /^(html|body|#document)$/.test(nn(t));
}
function an(t) {
  return vt(t).getComputedStyle(t);
}
function Ra(t) {
  return lt(t) ? {
    scrollLeft: t.scrollLeft,
    scrollTop: t.scrollTop
  } : {
    scrollLeft: t.scrollX,
    scrollTop: t.scrollY
  };
}
function ro(t) {
  if (nn(t) === "html")
    return t;
  const e = (
    // Step into the shadow DOM of the parent of a slotted node.
    t.assignedSlot || // DOM Element detected.
    t.parentNode || // ShadowRoot detected.
    kr(t) && t.host || // Fallback.
    io(t)
  );
  return kr(e) ? e.host : e;
}
function tm(t) {
  const e = ro(t);
  return to(e) ? t.ownerDocument ? t.ownerDocument.body : t.body : bt(e) && Lo(e) ? e : tm(e);
}
function bs(t, e, n) {
  var o;
  e === void 0 && (e = []), n === void 0 && (n = !0);
  const r = tm(t), s = r === ((o = t.ownerDocument) == null ? void 0 : o.body), i = vt(r);
  if (s) {
    const a = ac(i);
    return e.concat(i, i.visualViewport || [], Lo(r) ? r : [], a && n ? bs(a) : []);
  } else
    return e.concat(r, bs(r, [], n));
}
function ac(t) {
  return t.parent && Object.getPrototypeOf(t.parent) ? t.frameElement : null;
}
const Rf = {};
function Pt(t, e) {
  const n = v.useRef(Rf);
  return n.current === Rf && (n.current = t(e)), n;
}
const pl = v[`useInsertionEffect${Math.random().toFixed(1)}`.slice(0, -3)], v0 = (
  // React 17 doesn't have useInsertionEffect.
  pl && // Preact replaces useInsertionEffect with useLayoutEffect and fires too late.
  pl !== v.useLayoutEffect ? pl : (t) => t()
);
function ge(t) {
  const e = Pt(y0).current;
  return e.next = t, v0(e.effect), e.trampoline;
}
function y0() {
  const t = {
    next: void 0,
    callback: x0,
    trampoline: (...e) => t.callback?.(...e),
    effect: () => {
      t.callback = t.next;
    }
  };
  return t;
}
function x0() {
  if (process.env.NODE_ENV !== "production")
    throw (
      /* minify-error-disabled */
      new Error("Base UI: Cannot call an event handler while rendering.")
    );
}
let lc;
process.env.NODE_ENV !== "production" && (lc = /* @__PURE__ */ new Set());
function Vo(...t) {
  if (process.env.NODE_ENV !== "production") {
    const e = t.join(" ");
    lc.has(e) || (lc.add(e), console.error(`Base UI: ${e}`));
  }
}
const Jo = {
  ...v
}, w0 = () => {
}, xe = typeof document < "u" ? v.useLayoutEffect : w0;
function cc(t, e) {
  if (t && !e)
    return t;
  if (!t && e)
    return e;
  if (t || e)
    return {
      ...t,
      ...e
    };
}
const _c = {};
function on(t, e, n, o, r) {
  if (!n && !o && !r && !t)
    return Qi(e);
  let s = Qi(t);
  return e && (s = cs(s, e)), n && (s = cs(s, n)), o && (s = cs(s, o)), r && (s = cs(s, r)), s;
}
function C0(t) {
  if (t.length === 0)
    return _c;
  if (t.length === 1)
    return Qi(t[0]);
  let e = Qi(t[0]);
  for (let n = 1; n < t.length; n += 1)
    e = cs(e, t[n]);
  return e;
}
function Qi(t) {
  return Vc(t) ? {
    ...om(t, _c)
  } : S0(t);
}
function cs(t, e) {
  return Vc(e) ? om(e, t) : R0(t, e);
}
function S0(t) {
  const e = {
    ...t
  };
  for (const n in e) {
    const o = e[n];
    nm(n, o) && (e[n] = rm(o));
  }
  return e;
}
function R0(t, e) {
  if (!e)
    return t;
  for (const n in e) {
    const o = e[n];
    switch (n) {
      case "style": {
        t[n] = cc(t.style, o);
        break;
      }
      case "className": {
        t[n] = sm(t.className, o);
        break;
      }
      default:
        nm(n, o) ? t[n] = E0(t[n], o) : t[n] = o;
    }
  }
  return t;
}
function nm(t, e) {
  const n = t.charCodeAt(0), o = t.charCodeAt(1), r = t.charCodeAt(2);
  return n === 111 && o === 110 && r >= 65 && r <= 90 && (typeof e == "function" || typeof e > "u");
}
function Vc(t) {
  return typeof t == "function";
}
function om(t, e) {
  return Vc(t) ? t(e) : t ?? _c;
}
function E0(t, e) {
  return e ? t ? (...n) => {
    const o = n[0];
    if (im(o)) {
      const s = o;
      Ji(s);
      const i = e(...n);
      return s.baseUIHandlerPrevented || t?.(...n), i;
    }
    const r = e(...n);
    return t?.(...n), r;
  } : rm(e) : t;
}
function rm(t) {
  return t && ((...e) => {
    const n = e[0];
    return im(n) && Ji(n), t(...e);
  });
}
function Ji(t) {
  return t.preventBaseUIHandler = () => {
    t.baseUIHandlerPrevented = !0;
  }, t;
}
function sm(t, e) {
  return e ? t ? e + " " + t : e : t;
}
function im(t) {
  return t != null && typeof t == "object" && "nativeEvent" in t;
}
function P0(t, e) {
  return function(o, ...r) {
    const s = new URL(t);
    return s.searchParams.set("code", o.toString()), r.forEach((i) => s.searchParams.append("args[]", i)), `${e} error #${o}; visit ${s} for the full message.`;
  };
}
const Xe = P0("https://base-ui.com/production-error", "Base UI"), Ac = /* @__PURE__ */ v.createContext(void 0);
process.env.NODE_ENV !== "production" && (Ac.displayName = "CompositeRootContext");
function Fc(t = !1) {
  const e = v.useContext(Ac);
  if (e === void 0 && !t)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: CompositeRootContext is missing. Composite parts must be placed within <Composite.Root>." : Xe(16));
  return e;
}
function N0(t) {
  const {
    focusableWhenDisabled: e,
    disabled: n,
    composite: o = !1,
    tabIndex: r = 0,
    isNativeButton: s
  } = t, i = o && e !== !1, a = o && e === !1;
  return {
    props: v.useMemo(() => {
      const c = {
        // allow Tabbing away from focusableWhenDisabled elements
        onKeyDown(u) {
          n && e && u.key !== "Tab" && u.preventDefault();
        }
      };
      return o || (c.tabIndex = r, !s && n && (c.tabIndex = e ? r : -1)), (s && (e || i) || !s && n) && (c["aria-disabled"] = n), s && (!e || a) && (c.disabled = n), c;
    }, [o, n, e, i, a, s, r])
  };
}
function Ft(t = {}) {
  const {
    disabled: e = !1,
    focusableWhenDisabled: n,
    tabIndex: o = 0,
    native: r = !0,
    composite: s
  } = t, i = v.useRef(null), a = Fc(!0), l = s ?? a !== void 0, {
    props: c
  } = N0({
    focusableWhenDisabled: n,
    disabled: e,
    composite: l,
    tabIndex: o,
    isNativeButton: r
  });
  process.env.NODE_ENV !== "production" && v.useEffect(() => {
    if (!i.current)
      return;
    const p = pi(i.current);
    if (r) {
      if (!p) {
        const g = Jo.captureOwnerStack?.() || "";
        Vo(`A component that acts as a button expected a native <button> because the \`nativeButton\` prop is true. Rendering a non-<button> removes native button semantics, which can impact forms and accessibility. Use a real <button> in the \`render\` prop, or set \`nativeButton\` to \`false\`.${g}`);
      }
    } else if (p) {
      const g = Jo.captureOwnerStack?.() || "";
      Vo(`A component that acts as a button expected a non-<button> because the \`nativeButton\` prop is false. Rendering a <button> keeps native behavior while Base UI applies non-native attributes and handlers, which can add unintended extra attributes (such as \`role\` or \`aria-disabled\`). Use a non-<button> in the \`render\` prop, or set \`nativeButton\` to \`true\`.${g}`);
    }
  }, [r]);
  const u = v.useCallback(() => {
    const p = i.current;
    pi(p) && l && e && c.disabled === void 0 && p.disabled && (p.disabled = !1);
  }, [e, c.disabled, l]);
  xe(u, [u]);
  const d = v.useCallback((p = {}) => {
    const {
      onClick: g,
      onMouseDown: m,
      onKeyUp: h,
      onKeyDown: b,
      onPointerDown: w,
      ...y
    } = p;
    return on({
      type: r ? "button" : void 0,
      onClick(R) {
        if (e) {
          R.preventDefault();
          return;
        }
        g?.(R);
      },
      onMouseDown(R) {
        e || m?.(R);
      },
      onKeyDown(R) {
        if (e || (Ji(R), b?.(R), R.baseUIHandlerPrevented))
          return;
        const S = R.target === R.currentTarget, E = R.currentTarget, P = pi(E), N = !r && I0(E), I = S && (r ? P : !N), M = R.key === "Enter", T = R.key === " ", k = E.getAttribute("role"), D = k?.startsWith("menuitem") || k === "option" || k === "gridcell";
        if (S && l && T) {
          if (R.defaultPrevented && D)
            return;
          R.preventDefault(), N || r && P ? (E.click(), R.preventBaseUIHandler()) : I && (g?.(R), R.preventBaseUIHandler());
          return;
        }
        I && (!r && (T || M) && R.preventDefault(), !r && M && g?.(R));
      },
      onKeyUp(R) {
        if (!e) {
          if (Ji(R), h?.(R), R.target === R.currentTarget && r && l && pi(R.currentTarget) && R.key === " ") {
            R.preventDefault();
            return;
          }
          R.baseUIHandlerPrevented || R.target === R.currentTarget && !r && !l && R.key === " " && g?.(R);
        }
      },
      onPointerDown(R) {
        if (e) {
          R.preventDefault();
          return;
        }
        w?.(R);
      }
    }, r ? void 0 : {
      role: "button"
    }, c, y);
  }, [e, c, l, r]), f = ge((p) => {
    i.current = p, u();
  });
  return {
    getButtonProps: d,
    buttonRef: f
  };
}
function pi(t) {
  return bt(t) && t.tagName === "BUTTON";
}
function I0(t) {
  return !!(t?.tagName === "A" && t?.href);
}
function ln(t, e, n, o) {
  const r = Pt(am).current;
  return T0(r, t, e, n, o) && lm(r, [t, e, n, o]), r.callback;
}
function M0(t) {
  const e = Pt(am).current;
  return k0(e, t) && lm(e, t), e.callback;
}
function am() {
  return {
    callback: null,
    cleanup: null,
    refs: []
  };
}
function T0(t, e, n, o, r) {
  return t.refs[0] !== e || t.refs[1] !== n || t.refs[2] !== o || t.refs[3] !== r;
}
function k0(t, e) {
  return t.refs.length !== e.length || t.refs.some((n, o) => n !== e[o]);
}
function lm(t, e) {
  if (t.refs = e, e.every((n) => n == null)) {
    t.callback = null;
    return;
  }
  t.callback = (n) => {
    if (t.cleanup && (t.cleanup(), t.cleanup = null), n != null) {
      const o = Array(e.length).fill(null);
      for (let r = 0; r < e.length; r += 1) {
        const s = e[r];
        if (s != null)
          switch (typeof s) {
            case "function": {
              const i = s(n);
              typeof i == "function" && (o[r] = i);
              break;
            }
            case "object": {
              s.current = n;
              break;
            }
          }
      }
      t.cleanup = () => {
        for (let r = 0; r < e.length; r += 1) {
          const s = e[r];
          if (s != null)
            switch (typeof s) {
              case "function": {
                const i = o[r];
                typeof i == "function" ? i() : s(null);
                break;
              }
              case "object": {
                s.current = null;
                break;
              }
            }
        }
      };
    }
  };
}
const O0 = parseInt(v.version, 10);
function Lc(t) {
  return O0 >= t;
}
function Ef(t) {
  if (!/* @__PURE__ */ v.isValidElement(t))
    return null;
  const e = t, n = e.props;
  return (Lc(19) ? n?.ref : e.ref) ?? null;
}
let uc;
process.env.NODE_ENV !== "production" && (uc = /* @__PURE__ */ new Set());
function Ea(...t) {
  if (process.env.NODE_ENV !== "production") {
    const e = t.join(" ");
    uc.has(e) || (uc.add(e), console.warn(`Base UI: ${e}`));
  }
}
function ht() {
}
const Nn = Object.freeze([]), yt = Object.freeze({});
function D0(t, e) {
  const n = {};
  for (const o in t) {
    const r = t[o];
    if (e?.hasOwnProperty(o)) {
      const s = e[o](r);
      s != null && Object.assign(n, s);
      continue;
    }
    r === !0 ? n[`data-${o.toLowerCase()}`] = "" : r && (n[`data-${o.toLowerCase()}`] = r.toString());
  }
  return n;
}
function _0(t, e) {
  return typeof t == "function" ? t(e) : t;
}
function V0(t, e) {
  return typeof t == "function" ? t(e) : t;
}
function Te(t, e, n = {}) {
  const o = e.render, r = A0(e, n);
  if (n.enabled === !1)
    return null;
  const s = n.state ?? yt;
  return H0(t, o, r, s);
}
function A0(t, e = {}) {
  const {
    className: n,
    style: o,
    render: r
  } = t, {
    state: s = yt,
    ref: i,
    props: a,
    stateAttributesMapping: l,
    enabled: c = !0
  } = e, u = c ? _0(n, s) : void 0, d = c ? V0(o, s) : void 0, f = c ? D0(s, l) : yt, p = c && a ? F0(a) : void 0, g = c ? cc(f, p) ?? {} : yt;
  return typeof document < "u" && (c ? Array.isArray(i) ? g.ref = M0([g.ref, Ef(r), ...i]) : g.ref = ln(g.ref, Ef(r), i) : ln(null, null)), c ? (u !== void 0 && (g.className = sm(g.className, u)), d !== void 0 && (g.style = cc(g.style, d)), g) : yt;
}
function F0(t) {
  return Array.isArray(t) ? C0(t) : on(void 0, t);
}
const L0 = /* @__PURE__ */ Symbol.for("react.lazy"), $0 = /^[A-Z][A-Za-z0-9$]*$/, z0 = /[a-z]/;
function H0(t, e, n, o) {
  if (e) {
    if (typeof e == "function")
      return process.env.NODE_ENV !== "production" && B0(e), e(n, o);
    const r = on(n, e.props);
    r.ref = n.ref;
    let s = e;
    if (s?.$$typeof === L0 && (s = v.Children.toArray(e)[0]), process.env.NODE_ENV !== "production" && !/* @__PURE__ */ v.isValidElement(s))
      throw new Error(["Base UI: The `render` prop was provided an invalid React element as `React.isValidElement(render)` is `false`.", "A valid React element must be provided to the `render` prop because it is cloned with props to replace the default element.", "https://base-ui.com/r/invalid-render-prop"].join(`
`));
    return /* @__PURE__ */ v.cloneElement(s, r);
  }
  if (t && typeof t == "string")
    return W0(t, n);
  throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: Render element or function are not defined." : Xe(8));
}
function B0(t) {
  const e = t.name;
  e.length !== 0 && $0.test(e) && z0.test(e) && Ea(`The \`render\` prop received a function named \`${e}\` that starts with an uppercase letter.`, "This usually means a React component was passed directly as `render={Component}`.", "Base UI calls `render` as a plain function, which can break the Rules of Hooks during reconciliation.", "If this is an intentional render callback, rename it to start with a lowercase letter.", "Use `render={<Component />}` or `render={(props) => <Component {...props} />}` instead.", "https://base-ui.com/r/invalid-render-prop");
}
function W0(t, e) {
  return t === "button" ? /* @__PURE__ */ Sf("button", {
    type: "button",
    ...e,
    key: e.key
  }) : t === "img" ? /* @__PURE__ */ Sf("img", {
    alt: "",
    ...e,
    key: e.key
  }) : /* @__PURE__ */ v.createElement(t, e);
}
const Un = /* @__PURE__ */ v.forwardRef(function(e, n) {
  const {
    render: o,
    className: r,
    disabled: s = !1,
    focusableWhenDisabled: i = !1,
    nativeButton: a = !0,
    style: l,
    ...c
  } = e, {
    getButtonProps: u,
    buttonRef: d
  } = Ft({
    disabled: s,
    focusableWhenDisabled: i,
    native: a
  });
  return Te("button", e, {
    state: {
      disabled: s
    },
    ref: [n, d],
    props: [c, u]
  });
});
process.env.NODE_ENV !== "production" && (Un.displayName = "Button");
function U0(t) {
  const e = J.c(3);
  let n;
  e[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (n = /* @__PURE__ */ x("path", { d: "M 12.72 5.9998 C 12.72 5.6008 12.399 5.2798 12 5.2798 C 11.601 5.2798 11.28 5.6008 11.28 5.9998 V 11.2798 H 6 C 5.601 11.2798 5.28 11.6008 5.28 11.9998 C 5.28 12.3988 5.601 12.7198 6 12.7198 H 11.28 V 17.9998 C 11.28 18.3988 11.601 18.7198 12 18.7198 C 12.399 18.7198 12.72 18.3988 12.72 17.9998 V 12.7198 H 18 C 18.399 12.7198 18.72 12.3988 18.72 11.9998 C 18.72 11.6008 18.399 11.2798 18 11.2798 H 12.72 V 5.9998 Z", fill: "currentColor" }), e[0] = n) : n = e[0];
  let o;
  return e[1] !== t ? (o = /* @__PURE__ */ x("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", fill: "none", ...t, children: n }), e[1] = t, e[2] = o) : o = e[2], o;
}
function Y0(t) {
  const e = J.c(3);
  let n;
  e[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (n = /* @__PURE__ */ x("path", { d: "M 2.275 10.8332 C 1.908 11.2004 1.908 11.7942 2.275 12.1575 L 8.837 18.7246 C 9.204 19.0918 9.798 19.0918 10.161 18.7246 C 10.525 18.3574 10.528 17.7636 10.161 17.4002 L 5.201 12.4349 H 21.063 C 21.582 12.4349 22 12.0169 22 11.4973 C 22 10.9777 21.582 10.5597 21.063 10.5597 H 5.201 L 10.165 5.5983 C 10.532 5.2311 10.532 4.6373 10.165 4.274 C 9.798 3.9106 9.204 3.9067 8.841 4.274 L 2.275 10.8332 Z", fill: "currentColor" }), e[0] = n) : n = e[0];
  let o;
  return e[1] !== t ? (o = /* @__PURE__ */ x("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", fill: "none", ...t, children: n }), e[1] = t, e[2] = o) : o = e[2], o;
}
function G0(t) {
  const e = J.c(3);
  let n;
  e[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (n = /* @__PURE__ */ x("path", { d: "M 19 4 C 19.554 4 20 4.4459 20 5.0001 V 15.0014 C 20 15.5557 19.554 16.0016 19 16.0016 C 18.446 16.0016 18 15.5557 18 15.0014 V 7.4129 L 5.706 19.7062 C 5.314 20.0979 4.68 20.0979 4.293 19.7062 C 3.905 19.3145 3.901 18.6852 4.289 18.2935 L 16.583 6.0003 H 8.994 C 8.439 6.0003 7.993 5.5544 7.993 5.0001 C 7.993 4.4459 8.439 4 8.994 4 H 18.996 H 19 Z", fill: "currentColor" }), e[0] = n) : n = e[0];
  let o;
  return e[1] !== t ? (o = /* @__PURE__ */ x("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", fill: "none", ...t, children: n }), e[1] = t, e[2] = o) : o = e[2], o;
}
function j0(t) {
  const e = J.c(3);
  let n;
  e[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (n = /* @__PURE__ */ x("path", { d: "M 2 5.0714 C 2 4.4777 2.478 4 3.071 4 H 20.929 C 21.522 4 22 4.4777 22 5.0714 C 22 5.6652 21.522 6.1429 20.929 6.1429 H 3.071 C 2.478 6.1429 2 5.6652 2 5.0714 Z M 4.857 12.2143 C 4.857 11.6205 5.335 11.1429 5.929 11.1429 H 18.071 C 18.665 11.1429 19.143 11.6205 19.143 12.2143 C 19.143 12.808 18.665 13.2857 18.071 13.2857 H 5.929 C 5.335 13.2857 4.857 12.808 4.857 12.2143 Z M 14.857 19.3571 C 14.857 19.9509 14.379 20.4286 13.786 20.4286 H 10.214 C 9.621 20.4286 9.143 19.9509 9.143 19.3571 C 9.143 18.7634 9.621 18.2857 10.214 18.2857 H 13.786 C 14.379 18.2857 14.857 18.7634 14.857 19.3571 Z", fill: "currentColor" }), e[0] = n) : n = e[0];
  let o;
  return e[1] !== t ? (o = /* @__PURE__ */ x("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", fill: "none", ...t, children: n }), e[1] = t, e[2] = o) : o = e[2], o;
}
function K0(t) {
  const e = J.c(3);
  let n;
  e[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (n = /* @__PURE__ */ x("path", { d: "M 20.66 17 C 21.512 15.5312 22 13.8203 22 12 C 22 6.4766 17.523 2 12 2 V 3.875 C 16.488 3.875 20.125 7.5117 20.125 12 C 20.125 13.4805 19.73 14.8672 19.039 16.0625 L 20.664 17 H 20.66 Z", fill: "currentColor" }), e[0] = n) : n = e[0];
  let o;
  return e[1] !== t ? (o = /* @__PURE__ */ x("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", fill: "none", ...t, children: n }), e[1] = t, e[2] = o) : o = e[2], o;
}
function q0(t) {
  const e = J.c(3);
  let n;
  e[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (n = /* @__PURE__ */ x("path", { d: "M 7.357 2 C 7.951 2 8.429 2.4681 8.429 3.05 V 4.8 H 15.571 V 3.05 C 15.571 2.4681 16.049 2 16.643 2 C 17.237 2 17.714 2.4681 17.714 3.05 V 4.8 H 19.143 C 20.719 4.8 22 6.0556 22 7.6 V 20.2 C 22 21.7444 20.719 23 19.143 23 H 4.857 C 3.281 23 2 21.7444 2 20.2 V 7.6 C 2 6.0556 3.281 4.8 4.857 4.8 H 6.286 V 3.05 C 6.286 2.4681 6.763 2 7.357 2 Z M 7.357 6.9 H 4.857 C 4.464 6.9 4.143 7.215 4.143 7.6 V 9.7 H 19.857 V 7.6 C 19.857 7.215 19.536 6.9 19.143 6.9 H 7.357 Z M 4.143 11.8 V 20.2 C 4.143 20.585 4.464 20.9 4.857 20.9 H 19.143 C 19.536 20.9 19.857 20.585 19.857 20.2 V 11.8 H 4.143 Z", fill: "currentColor" }), e[0] = n) : n = e[0];
  let o;
  return e[1] !== t ? (o = /* @__PURE__ */ x("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", fill: "none", ...t, children: n }), e[1] = t, e[2] = o) : o = e[2], o;
}
function X0(t) {
  const e = J.c(3);
  let n;
  e[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (n = /* @__PURE__ */ x("path", { d: "M 8.17 16.6234 L 3.194 11.648 L 1.5 13.3303 L 8.17 20 L 22.487 5.6823 L 20.805 4 L 8.17 16.6234 Z", fill: "currentColor" }), e[0] = n) : n = e[0];
  let o;
  return e[1] !== t ? (o = /* @__PURE__ */ x("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", fill: "none", ...t, children: n }), e[1] = t, e[2] = o) : o = e[2], o;
}
function Z0(t) {
  const e = J.c(3);
  let n;
  e[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (n = /* @__PURE__ */ x("path", { d: "M 11.505 16.5898 C 11.787 16.8718 12.243 16.8718 12.522 16.5898 L 18.522 10.5898 C 18.804 10.3078 18.804 9.8518 18.522 9.5728 C 18.24 9.2938 17.784 9.2908 17.505 9.5728 L 12.015 15.0628 L 6.525 9.5728 C 6.243 9.2908 5.787 9.2908 5.508 9.5728 C 5.229 9.8548 5.226 10.3108 5.508 10.5898 L 11.508 16.5898 H 11.505 Z", fill: "currentColor" }), e[0] = n) : n = e[0];
  let o;
  return e[1] !== t ? (o = /* @__PURE__ */ x("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", fill: "none", ...t, children: n }), e[1] = t, e[2] = o) : o = e[2], o;
}
function Q0(t) {
  const e = J.c(3);
  let n;
  e[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (n = /* @__PURE__ */ x("path", { d: "M 7.313 11.778 C 6.896 12.1768 6.896 12.8216 7.313 13.2162 L 16.184 21.7009 C 16.601 22.0997 17.275 22.0997 17.687 21.7009 C 18.1 21.3021 18.104 20.6573 17.687 20.2627 L 9.57 12.4992 L 17.687 4.7357 C 18.104 4.3369 18.104 3.692 17.687 3.2975 C 17.27 2.903 16.596 2.8987 16.184 3.2975 L 7.313 11.778 Z", fill: "currentColor" }), e[0] = n) : n = e[0];
  let o;
  return e[1] !== t ? (o = /* @__PURE__ */ x("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", fill: "none", ...t, children: n }), e[1] = t, e[2] = o) : o = e[2], o;
}
function J0(t) {
  const e = J.c(3);
  let n;
  e[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (n = /* @__PURE__ */ x("path", { d: "M 17.687 11.778 C 18.104 12.1768 18.104 12.8216 17.687 13.2162 L 8.816 21.7009 C 8.399 22.0997 7.725 22.0997 7.313 21.7009 C 6.9 21.3021 6.896 20.6573 7.313 20.2627 L 15.43 12.4992 L 7.313 4.7357 C 6.896 4.3369 6.896 3.692 7.313 3.2975 C 7.73 2.903 8.404 2.8987 8.816 3.2975 L 17.687 11.7822 V 11.778 Z", fill: "currentColor" }), e[0] = n) : n = e[0];
  let o;
  return e[1] !== t ? (o = /* @__PURE__ */ x("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", fill: "none", ...t, children: n }), e[1] = t, e[2] = o) : o = e[2], o;
}
function ev(t) {
  const e = J.c(3);
  let n;
  e[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (n = /* @__PURE__ */ x("path", { d: "M 11.505 7.41 C 11.787 7.128 12.243 7.128 12.522 7.41 L 18.522 13.41 C 18.804 13.692 18.804 14.148 18.522 14.427 C 18.24 14.706 17.784 14.709 17.505 14.427 L 12.015 8.937 L 6.525 14.427 C 6.243 14.709 5.787 14.709 5.508 14.427 C 5.229 14.145 5.226 13.689 5.508 13.41 L 11.508 7.41 H 11.505 Z", fill: "currentColor" }), e[0] = n) : n = e[0];
  let o;
  return e[1] !== t ? (o = /* @__PURE__ */ x("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", fill: "none", ...t, children: n }), e[1] = t, e[2] = o) : o = e[2], o;
}
function tv(t) {
  const e = J.c(3);
  let n;
  e[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (n = /* @__PURE__ */ x("path", { d: "M 12 3.875 C 14.155 3.875 16.222 4.731 17.745 6.2548 C 19.269 7.7785 20.125 9.8451 20.125 12 C 20.125 14.1549 19.269 16.2215 17.745 17.7452 C 16.222 19.269 14.155 20.125 12 20.125 C 9.845 20.125 7.778 19.269 6.255 17.7452 C 4.731 16.2215 3.875 14.1549 3.875 12 C 3.875 9.8451 4.731 7.7785 6.255 6.2548 C 7.778 4.731 9.845 3.875 12 3.875 Z M 12 22 C 14.652 22 17.196 20.9464 19.071 19.0711 C 20.946 17.1957 22 14.6522 22 12 C 22 9.3478 20.946 6.8043 19.071 4.9289 C 17.196 3.0536 14.652 2 12 2 C 9.348 2 6.804 3.0536 4.929 4.9289 C 3.054 6.8043 2 9.3478 2 12 C 2 14.6522 3.054 17.1957 4.929 19.0711 C 6.804 20.9464 9.348 22 12 22 Z M 16.414 10.1641 C 16.781 9.7969 16.781 9.2031 16.414 8.8398 C 16.047 8.4766 15.453 8.4727 15.09 8.8398 L 10.754 13.1758 L 8.918 11.3398 C 8.551 10.9727 7.957 10.9727 7.594 11.3398 C 7.23 11.707 7.227 12.3008 7.594 12.6641 L 10.094 15.1641 C 10.461 15.5312 11.055 15.5312 11.418 15.1641 L 16.414 10.1641 Z", fill: "currentColor" }), e[0] = n) : n = e[0];
  let o;
  return e[1] !== t ? (o = /* @__PURE__ */ x("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", fill: "none", ...t, children: n }), e[1] = t, e[2] = o) : o = e[2], o;
}
function nv(t) {
  const e = J.c(3);
  let n;
  e[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (n = /* @__PURE__ */ x("path", { d: "M 12 21.6 C 6.697 21.6 2.4 17.3025 2.4 12 C 2.4 6.6975 6.697 2.4 12 2.4 C 17.302 2.4 21.6 6.6975 21.6 12 C 21.6 17.3025 17.302 21.6 12 21.6 Z M 12 4.2 C 7.691 4.2 4.2 7.6913 4.2 12 C 4.2 16.3088 7.691 19.8 12 19.8 C 16.309 19.8 19.8 16.3088 19.8 12 C 19.8 7.6913 16.309 4.2 12 4.2 Z M 14.651 8.7713 C 14.944 8.37 15.506 8.28 15.907 8.5725 C 16.309 8.865 16.399 9.4275 16.106 9.8288 L 11.527 16.1288 C 11.374 16.3425 11.134 16.4775 10.871 16.4963 C 10.609 16.515 10.35 16.4213 10.166 16.2375 L 8.07 14.1413 C 7.717 13.7888 7.717 13.2188 8.07 12.87 C 8.422 12.5213 8.992 12.5175 9.341 12.87 L 10.691 14.22 L 14.651 8.775 V 8.7713 Z", fill: "currentColor" }), e[0] = n) : n = e[0];
  let o;
  return e[1] !== t ? (o = /* @__PURE__ */ x("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", fill: "none", ...t, children: n }), e[1] = t, e[2] = o) : o = e[2], o;
}
function ov(t) {
  const e = J.c(3);
  let n;
  e[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (n = /* @__PURE__ */ x("path", { d: "M 12 3.875 C 14.155 3.875 16.222 4.731 17.745 6.2548 C 19.269 7.7785 20.125 9.8451 20.125 12 C 20.125 14.1549 19.269 16.2215 17.745 17.7452 C 16.222 19.269 14.155 20.125 12 20.125 C 9.845 20.125 7.778 19.269 6.255 17.7452 C 4.731 16.2215 3.875 14.1549 3.875 12 C 3.875 9.8451 4.731 7.7785 6.255 6.2548 C 7.778 4.731 9.845 3.875 12 3.875 Z M 12 22 C 14.652 22 17.196 20.9464 19.071 19.0711 C 20.946 17.1957 22 14.6522 22 12 C 22 9.3478 20.946 6.8043 19.071 4.9289 C 17.196 3.0536 14.652 2 12 2 C 9.348 2 6.804 3.0536 4.929 4.9289 C 3.054 6.8043 2 9.3478 2 12 C 2 14.6522 3.054 17.1957 4.929 19.0711 C 6.804 20.9464 9.348 22 12 22 Z M 12 7 C 11.48 7 11.062 7.418 11.062 7.9375 V 12.3125 C 11.062 12.832 11.48 13.25 12 13.25 C 12.52 13.25 12.938 12.832 12.938 12.3125 V 7.9375 C 12.938 7.418 12.52 7 12 7 Z M 13.25 15.75 C 13.25 15.4185 13.118 15.1005 12.884 14.8661 C 12.649 14.6317 12.332 14.5 12 14.5 C 11.668 14.5 11.351 14.6317 11.116 14.8661 C 10.882 15.1005 10.75 15.4185 10.75 15.75 C 10.75 16.0815 10.882 16.3995 11.116 16.6339 C 11.351 16.8683 11.668 17 12 17 C 12.332 17 12.649 16.8683 12.884 16.6339 C 13.118 16.3995 13.25 16.0815 13.25 15.75 Z", fill: "currentColor" }), e[0] = n) : n = e[0];
  let o;
  return e[1] !== t ? (o = /* @__PURE__ */ x("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", fill: "none", ...t, children: n }), e[1] = t, e[2] = o) : o = e[2], o;
}
function rv(t) {
  const e = J.c(3);
  let n;
  e[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (n = /* @__PURE__ */ x("path", { d: "M 10.9 6.5 H 13.1 V 8.7 H 10.9 V 6.5 Z M 10.9 10.9 H 13.1 V 17.5 H 10.9 V 10.9 Z M 12 1 C 5.928 1 1 5.928 1 12 C 1 18.072 5.928 23 12 23 C 18.072 23 23 18.072 23 12 C 23 5.928 18.072 1 12 1 Z M 12 20.8 C 7.149 20.8 3.2 16.851 3.2 12 C 3.2 7.149 7.149 3.2 12 3.2 C 16.851 3.2 20.8 7.149 20.8 12 C 20.8 16.851 16.851 20.8 12 20.8 Z", fill: "currentColor" }), e[0] = n) : n = e[0];
  let o;
  return e[1] !== t ? (o = /* @__PURE__ */ x("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", fill: "none", ...t, children: n }), e[1] = t, e[2] = o) : o = e[2], o;
}
function sv(t) {
  const e = J.c(3);
  let n;
  e[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (n = /* @__PURE__ */ x("path", { d: "M 18 15.125 H 10.5 C 10.156 15.125 9.875 14.8438 9.875 14.5 V 4.5 C 9.875 4.1562 10.156 3.875 10.5 3.875 H 15.973 L 18.625 6.5273 V 14.5 C 18.625 14.8438 18.344 15.125 18 15.125 Z M 10.5 17 H 18 C 19.379 17 20.5 15.8789 20.5 14.5 V 6.5273 C 20.5 6.0312 20.301 5.5547 19.949 5.2031 L 17.301 2.5508 C 16.949 2.1992 16.473 2 15.977 2 H 10.5 C 9.121 2 8 3.1211 8 4.5 V 14.5 C 8 15.8789 9.121 17 10.5 17 Z M 5.5 7 C 4.121 7 3 8.1211 3 9.5 V 19.5 C 3 20.8789 4.121 22 5.5 22 H 13 C 14.379 22 15.5 20.8789 15.5 19.5 V 18.25 H 13.625 V 19.5 C 13.625 19.8438 13.344 20.125 13 20.125 H 5.5 C 5.156 20.125 4.875 19.8438 4.875 19.5 V 9.5 C 4.875 9.1562 5.156 8.875 5.5 8.875 H 6.75 V 7 H 5.5 Z", fill: "currentColor" }), e[0] = n) : n = e[0];
  let o;
  return e[1] !== t ? (o = /* @__PURE__ */ x("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", fill: "none", ...t, children: n }), e[1] = t, e[2] = o) : o = e[2], o;
}
function iv(t) {
  const e = J.c(3);
  let n;
  e[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (n = /* @__PURE__ */ x("path", { d: "M 19.071 22 C 19.665 22 20.143 21.5223 20.143 20.9286 C 20.143 20.3348 19.665 19.8571 19.071 19.8571 H 4.071 C 3.478 19.8571 3 20.3348 3 20.9286 C 3 21.5223 3.478 22 4.071 22 H 19.071 Z M 10.79 15.9464 C 10.991 16.1607 11.277 16.2857 11.571 16.2857 C 11.866 16.2857 12.147 16.1652 12.353 15.9464 L 18.067 9.875 C 18.473 9.442 18.451 8.7679 18.022 8.3616 C 17.594 7.9554 16.915 7.9777 16.509 8.4062 L 12.643 12.5134 V 8.7857 V 3.0714 C 12.643 2.4777 12.165 2 11.571 2 C 10.978 2 10.5 2.4777 10.5 3.0714 V 8.7857 V 12.5134 L 6.638 8.4107 C 6.232 7.9777 5.554 7.9598 5.125 8.3661 C 4.696 8.7723 4.674 9.4509 5.08 9.8795 L 10.795 15.9509 L 10.79 15.9464 Z", fill: "currentColor" }), e[0] = n) : n = e[0];
  let o;
  return e[1] !== t ? (o = /* @__PURE__ */ x("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", fill: "none", ...t, children: n }), e[1] = t, e[2] = o) : o = e[2], o;
}
function av(t) {
  const e = J.c(3);
  let n;
  e[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (n = /* @__PURE__ */ x("path", { d: "M17.366 12.0832C16.2569 12.0832 15.3571 11.15 15.3571 9.99987C15.3571 8.84971 16.2569 7.91656 17.366 7.91656C18.4751 7.91656 19.3749 8.84971 19.3749 9.99987C19.3749 11.15 18.4751 12.0832 17.366 12.0832ZM10 7.91656C11.1091 7.91656 12.0089 8.84971 12.0089 9.99987C12.0089 11.15 11.1091 12.0832 10 12.0832C8.89092 12.0832 7.99109 11.15 7.99109 9.99987C7.99109 8.84971 8.89092 7.91656 10 7.91656ZM2.634 12.0832C1.52492 12.0832 0.625095 11.15 0.625095 9.99987C0.625095 8.84971 1.52492 7.91656 2.634 7.91656C3.74309 7.91656 4.64291 8.84971 4.64291 9.99987C4.64291 11.15 3.74309 12.0832 2.634 12.0832Z", fill: "currentColor" }), e[0] = n) : n = e[0];
  let o;
  return e[1] !== t ? (o = /* @__PURE__ */ x("svg", { viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...t, children: n }), e[1] = t, e[2] = o) : o = e[2], o;
}
function lv(t) {
  const e = J.c(3);
  let n;
  e[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (n = /* @__PURE__ */ x("path", { d: "M12.0833 2.634C12.0833 3.74309 11.1502 4.64291 10 4.64291C8.84984 4.64291 7.91669 3.74309 7.91669 2.634C7.91669 1.52492 8.84984 0.625095 10 0.625095C11.1502 0.625095 12.0833 1.52492 12.0833 2.634ZM7.91669 10C7.91669 8.89092 8.84984 7.99109 10 7.99109C11.1502 7.99109 12.0833 8.89092 12.0833 10C12.0833 11.1091 11.1502 12.0089 10 12.0089C8.84984 12.0089 7.91669 11.1091 7.91669 10ZM12.0833 17.366C12.0833 18.4751 11.1502 19.3749 10 19.3749C8.84984 19.3749 7.91669 18.4751 7.91669 17.366C7.91669 16.2569 8.84984 15.3571 10 15.3571C11.1502 15.3571 12.0833 16.2569 12.0833 17.366Z", fill: "currentColor" }), e[0] = n) : n = e[0];
  let o;
  return e[1] !== t ? (o = /* @__PURE__ */ x("svg", { viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...t, children: n }), e[1] = t, e[2] = o) : o = e[2], o;
}
function cv(t) {
  const e = J.c(4);
  let n;
  e[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (n = /* @__PURE__ */ x("defs", { children: /* @__PURE__ */ x("clipPath", { id: "clip2_9481_7966", children: /* @__PURE__ */ x("rect", { width: "19.2", height: "19.2", fill: "white", transform: "translate(2.4 2.3999)" }) }) }), e[0] = n) : n = e[0];
  let o;
  e[1] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (o = /* @__PURE__ */ x("g", { clipPath: "url(#clip2_9481_7966)", children: /* @__PURE__ */ x("path", { d: "M 12 21.5999 C 9.454 21.5999 7.012 20.5885 5.212 18.7881 C 3.411 16.9878 2.4 14.546 2.4 11.9999 C 2.4 9.4538 3.411 7.012 5.212 5.2117 C 7.012 3.4113 9.454 2.3999 12 2.3999 C 14.546 2.3999 16.988 3.4113 18.788 5.2117 C 20.588 7.012 21.6 9.4538 21.6 11.9999 C 21.6 14.546 20.588 16.9878 18.788 18.7881 C 16.988 20.5885 14.546 21.5999 12 21.5999 Z M 12 14.3999 C 11.682 14.3999 11.376 14.5263 11.151 14.7514 C 10.926 14.9764 10.8 15.2816 10.8 15.5999 C 10.8 15.9182 10.926 16.2234 11.151 16.4484 C 11.376 16.6735 11.682 16.7999 12 16.7999 C 12.318 16.7999 12.623 16.6735 12.848 16.4484 C 13.073 16.2234 13.2 15.9182 13.2 15.5999 C 13.2 15.2816 13.073 14.9764 12.848 14.7514 C 12.623 14.5263 12.318 14.3999 12 14.3999 Z M 12 7.1999 C 11.317 7.1999 10.774 7.7812 10.822 8.4637 L 11.1 12.3637 C 11.134 12.8362 11.527 13.1999 11.996 13.1999 C 12.469 13.1999 12.859 12.8362 12.892 12.3637 L 13.17 8.4637 C 13.219 7.7812 12.679 7.1999 11.992 7.1999 H 12 Z", fill: "currentColor" }) }), e[1] = o) : o = e[1];
  let r;
  return e[2] !== t ? (r = /* @__PURE__ */ j("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", fill: "none", ...t, children: [
    n,
    o
  ] }), e[2] = t, e[3] = r) : r = e[3], r;
}
function uv(t) {
  const e = J.c(4);
  let n;
  e[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (n = /* @__PURE__ */ x("defs", { children: /* @__PURE__ */ x("clipPath", { id: "clip2_9481_7947", children: /* @__PURE__ */ x("rect", { width: "19.2", height: "19.2", fill: "white", transform: "translate(2.4 2.3999)" }) }) }), e[0] = n) : n = e[0];
  let o;
  e[1] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (o = /* @__PURE__ */ x("g", { clipPath: "url(#clip2_9481_7947)", children: /* @__PURE__ */ x("path", { d: "M 12 21.5999 C 9.454 21.5999 7.012 20.5885 5.212 18.7881 C 3.411 16.9878 2.4 14.546 2.4 11.9999 C 2.4 9.4538 3.411 7.012 5.212 5.2117 C 7.012 3.4113 9.454 2.3999 12 2.3999 C 14.546 2.3999 16.988 3.4113 18.788 5.2117 C 20.588 7.012 21.6 9.4538 21.6 11.9999 C 21.6 14.546 20.588 16.9878 18.788 18.7881 C 16.988 20.5885 14.546 21.5999 12 21.5999 Z M 12 4.1999 C 9.931 4.1999 7.947 5.0217 6.484 6.4845 C 5.022 7.9473 4.2 9.9312 4.2 11.9999 C 4.2 14.0686 5.022 16.0526 6.484 17.5153 C 7.947 18.9781 9.931 19.7999 12 19.7999 C 14.069 19.7999 16.053 18.9781 17.515 17.5153 C 18.978 16.0526 19.8 14.0686 19.8 11.9999 C 19.8 9.9312 18.978 7.9473 17.515 6.4845 C 16.053 5.0217 14.069 4.1999 12 4.1999 Z M 12 16.7999 C 11.682 16.7999 11.376 16.6735 11.151 16.4484 C 10.926 16.2234 10.8 15.9182 10.8 15.5999 C 10.8 15.2816 10.926 14.9764 11.151 14.7514 C 11.376 14.5263 11.682 14.3999 12 14.3999 C 12.318 14.3999 12.623 14.5263 12.848 14.7514 C 13.073 14.9764 13.2 15.2816 13.2 15.5999 C 13.2 15.9182 13.073 16.2234 12.848 16.4484 C 12.623 16.6735 12.318 16.7999 12 16.7999 Z M 12 7.1999 C 12.682 7.1999 13.226 7.7812 13.177 8.4637 L 12.9 12.3637 C 12.866 12.8362 12.472 13.1999 12.004 13.1999 C 11.531 13.1999 11.141 12.8362 11.107 12.3637 L 10.83 8.4637 C 10.774 7.7812 11.317 7.1999 12 7.1999 Z", fill: "currentColor" }) }), e[1] = o) : o = e[1];
  let r;
  return e[2] !== t ? (r = /* @__PURE__ */ j("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", fill: "none", ...t, children: [
    n,
    o
  ] }), e[2] = t, e[3] = r) : r = e[3], r;
}
function dv(t) {
  const e = J.c(3);
  let n;
  e[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (n = /* @__PURE__ */ x("path", { d: "M 11.998 5.3214 C 9.508 5.3214 7.461 6.4446 5.891 7.8904 C 4.421 9.2489 3.405 10.8616 2.886 12 C 3.405 13.1384 4.421 14.7511 5.888 16.1096 C 7.461 17.5554 9.508 18.6786 11.998 18.6786 C 14.488 18.6786 16.535 17.5554 18.105 16.1096 C 19.575 14.7511 20.591 13.1384 21.11 12 C 20.591 10.8616 19.575 9.2489 18.109 7.8904 C 16.535 6.4446 14.488 5.3214 11.998 5.3214 Z M 4.642 6.5585 C 6.441 4.8964 8.912 3.5 11.998 3.5 C 15.084 3.5 17.555 4.8964 19.354 6.5585 C 21.141 8.2092 22.336 10.1786 22.905 11.5333 C 23.032 11.833 23.032 12.167 22.905 12.4667 C 22.336 13.8214 21.141 15.7946 19.354 17.4415 C 17.555 19.1036 15.084 20.5 11.998 20.5 C 8.912 20.5 6.441 19.1036 4.642 17.4415 C 2.855 15.7946 1.66 13.8214 1.095 12.4667 C 0.968 12.167 0.968 11.833 1.095 11.5333 C 1.66 10.1786 2.855 8.2054 4.642 6.5585 Z M 11.998 15.0357 C 13.686 15.0357 15.053 13.6772 15.053 12 C 15.053 10.3228 13.686 8.9643 11.998 8.9643 C 11.971 8.9643 11.948 8.9643 11.922 8.9643 C 11.971 9.1578 11.998 9.3627 11.998 9.5714 C 11.998 10.9109 10.902 12 9.554 12 C 9.344 12 9.138 11.9734 8.943 11.9241 C 8.943 11.9507 8.943 11.9734 8.943 12 C 8.943 13.6772 10.31 15.0357 11.998 15.0357 Z M 11.998 7.1429 C 13.295 7.1429 14.538 7.6546 15.455 8.5655 C 16.372 9.4764 16.887 10.7118 16.887 12 C 16.887 13.2882 16.372 14.5236 15.455 15.4345 C 14.538 16.3454 13.295 16.8571 11.998 16.8571 C 10.702 16.8571 9.458 16.3454 8.541 15.4345 C 7.625 14.5236 7.11 13.2882 7.11 12 C 7.11 10.7118 7.625 9.4764 8.541 8.5655 C 9.458 7.6546 10.702 7.1429 11.998 7.1429 Z", fill: "currentColor" }), e[0] = n) : n = e[0];
  let o;
  return e[1] !== t ? (o = /* @__PURE__ */ x("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", fill: "none", ...t, children: n }), e[1] = t, e[2] = o) : o = e[2], o;
}
function fv(t) {
  const e = J.c(3);
  let n;
  e[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (n = /* @__PURE__ */ x("path", { d: "M 4.32 7.131 C 4.32 6.639 4.719 6.24 5.211 6.24 H 18.792 C 19.284 6.24 19.683 6.639 19.683 7.131 C 19.683 7.368 19.59 7.593 19.422 7.761 L 14.4 12.777 V 18.789 C 14.4 19.281 14.001 19.68 13.509 19.68 C 13.272 19.68 13.047 19.587 12.879 19.419 L 9.81 16.35 C 9.675 16.215 9.6 16.032 9.6 15.84 V 12.777 L 4.581 7.758 C 4.413 7.593 4.32 7.365 4.32 7.131 Z M 6.537 7.68 L 10.83 11.97 C 10.965 12.105 11.04 12.288 11.04 12.48 V 15.543 L 12.96 17.463 V 12.48 C 12.96 12.288 13.035 12.105 13.17 11.97 L 17.46 7.68 H 6.537 Z", fill: "currentColor" }), e[0] = n) : n = e[0];
  let o;
  return e[1] !== t ? (o = /* @__PURE__ */ x("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", fill: "none", ...t, children: n }), e[1] = t, e[2] = o) : o = e[2], o;
}
function pv(t) {
  const e = J.c(3);
  let n;
  e[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (n = /* @__PURE__ */ x("path", { d: "M 5.28 6.96 C 5.28 6.561 5.601 6.24 6 6.24 H 18 C 18.399 6.24 18.72 6.561 18.72 6.96 C 18.72 7.359 18.399 7.68 18 7.68 H 6 C 5.601 7.68 5.28 7.359 5.28 6.96 Z M 5.28 12 C 5.28 11.601 5.601 11.28 6 11.28 H 18 C 18.399 11.28 18.72 11.601 18.72 12 C 18.72 12.399 18.399 12.72 18 12.72 H 6 C 5.601 12.72 5.28 12.399 5.28 12 Z M 18.72 17.04 C 18.72 17.439 18.399 17.76 18 17.76 H 6 C 5.601 17.76 5.28 17.439 5.28 17.04 C 5.28 16.641 5.601 16.32 6 16.32 H 18 C 18.399 16.32 18.72 16.641 18.72 17.04 Z", fill: "currentColor" }), e[0] = n) : n = e[0];
  let o;
  return e[1] !== t ? (o = /* @__PURE__ */ x("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", fill: "none", ...t, children: n }), e[1] = t, e[2] = o) : o = e[2], o;
}
function gv(t) {
  const e = J.c(3);
  let n;
  e[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (n = /* @__PURE__ */ x("path", { d: "M 12 4.3199 C 11.601 4.3199 11.28 4.6409 11.28 5.0399 V 5.3309 C 8.838 5.6789 6.96 7.7819 6.96 10.3199 V 10.7549 C 6.96 11.8859 6.66 12.9959 6.09 13.9739 L 5.433 15.0959 C 5.334 15.2699 5.28 15.4649 5.28 15.6659 C 5.28 16.2929 5.787 16.7999 6.414 16.7999 H 17.586 C 18.213 16.7999 18.72 16.2929 18.72 15.6659 C 18.72 15.4649 18.666 15.2669 18.567 15.0959 L 17.91 13.9709 C 17.34 12.9929 17.04 11.8829 17.04 10.7519 V 10.3169 C 17.04 7.7789 15.162 5.6759 12.72 5.3279 V 5.0369 C 12.72 4.6379 12.399 4.3169 12 4.3169 V 4.3199 Z M 17.052 15.3599 H 6.945 L 7.332 14.6969 C 8.031 13.4999 8.4 12.1379 8.4 10.7549 V 10.3199 C 8.4 8.3309 10.011 6.7199 12 6.7199 C 13.989 6.7199 15.6 8.3309 15.6 10.3199 V 10.7549 C 15.6 12.1409 15.969 13.4999 16.665 14.6969 L 17.052 15.3599 Z M 9.963 18.2399 C 10.26 19.0799 11.061 19.6799 12 19.6799 C 12.939 19.6799 13.74 19.0799 14.037 18.2399 H 9.963 Z", fill: "currentColor" }), e[0] = n) : n = e[0];
  let o;
  return e[1] !== t ? (o = /* @__PURE__ */ x("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", fill: "none", ...t, children: n }), e[1] = t, e[2] = o) : o = e[2], o;
}
function mv(t) {
  const e = J.c(3);
  let n;
  e[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (n = /* @__PURE__ */ x("path", { d: "M 9.6 1 C 8.936 1 8.4 1.5462 8.4 2.2222 C 8.4 2.6729 8.64 3.0701 9 3.2802 V 7.9285 C 7.208 8.9865 6 10.9573 6 13.2222 V 19.6389 C 6 21.4951 7.478 23 9.3 23 H 14.7 C 16.523 23 18 21.4951 18 19.6389 V 13.2222 C 18 10.9573 16.793 8.9865 15 7.9285 V 3.2802 C 15.36 3.0701 15.6 2.6729 15.6 2.2222 C 15.6 1.5462 15.064 1 14.4 1 H 9.6 Z M 10.8 3.4444 H 13.2 V 8.4861 C 13.2 8.8451 13.406 9.1736 13.729 9.3226 C 15.188 9.9948 16.2 11.4882 16.2 13.2222 V 19.6389 C 16.2 20.483 15.529 21.1667 14.7 21.1667 H 9.3 C 8.471 21.1667 7.8 20.483 7.8 19.6389 V 13.2222 C 7.8 11.4882 8.812 9.9948 10.271 9.3226 C 10.594 9.1736 10.8 8.849 10.8 8.4861 V 3.4444 Z M 14.4 15.6667 C 14.4 14.8569 13.316 13.2031 12.604 12.2062 C 12.3 11.7823 11.696 11.7823 11.393 12.2062 C 10.68 13.2031 9.596 14.8569 9.596 15.6667 C 9.596 16.8736 10.673 18.1111 11.996 18.1111 C 13.32 18.1111 14.396 16.8736 14.396 15.6667 H 14.4 Z", fill: "currentColor" }), e[0] = n) : n = e[0];
  let o;
  return e[1] !== t ? (o = /* @__PURE__ */ x("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", fill: "none", ...t, children: n }), e[1] = t, e[2] = o) : o = e[2], o;
}
function hv(t) {
  const e = J.c(3);
  let n;
  e[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (n = /* @__PURE__ */ x("path", { d: "M 13.212 2.7115 C 13.212 2.0401 12.671 1.5 12 1.5 C 11.329 1.5 10.788 2.0401 10.788 2.7115 V 10.7885 H 2.712 C 2.04 10.7885 1.5 11.3286 1.5 12 C 1.5 12.6714 2.04 13.2115 2.712 13.2115 H 10.788 V 21.2885 C 10.788 21.9599 11.329 22.5 12 22.5 C 12.671 22.5 13.212 21.9599 13.212 21.2885 V 13.2115 H 21.288 C 21.96 13.2115 22.5 12.6714 22.5 12 C 22.5 11.3286 21.96 10.7885 21.288 10.7885 H 13.212 V 2.7115 Z", fill: "currentColor" }), e[0] = n) : n = e[0];
  let o;
  return e[1] !== t ? (o = /* @__PURE__ */ x("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", fill: "none", ...t, children: n }), e[1] = t, e[2] = o) : o = e[2], o;
}
function bv(t) {
  const e = J.c(3);
  let n;
  e[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (n = /* @__PURE__ */ x("path", { d: "M7.19979 5.27982V4.31982H5.27979V19.6798H7.19979V15.0718L9.08079 14.5078C10.3378 14.1298 11.6938 14.2468 12.8668 14.8348C14.1478 15.4768 15.6418 15.5548 16.9828 15.0508L18.7198 14.3998V4.79982L17.0218 5.64882C15.6748 6.32382 14.0878 6.32382 12.7378 5.64882C11.6458 5.10282 10.3888 4.99482 9.22178 5.34582L7.19979 5.95182V5.27982Z", fill: "currentColor" }), e[0] = n) : n = e[0];
  let o;
  return e[1] !== t ? (o = /* @__PURE__ */ x("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", fill: "none", ...t, children: n }), e[1] = t, e[2] = o) : o = e[2], o;
}
function vv(t) {
  const e = J.c(3);
  let n;
  e[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (n = /* @__PURE__ */ x("path", { d: "M 16.199 10.2018 C 16.199 6.8871 13.514 4.2024 10.199 4.2024 C 6.884 4.2024 4.2 6.8871 4.2 10.2018 C 4.2 13.5165 6.884 16.2012 10.199 16.2012 C 13.514 16.2012 16.199 13.5165 16.199 10.2018 Z M 15.04 16.3175 C 13.713 17.3711 12.029 18.0011 10.199 18.0011 C 5.891 18.0011 2.4 14.5102 2.4 10.2018 C 2.4 5.8935 5.891 2.4026 10.199 2.4026 C 14.507 2.4026 17.998 5.8935 17.998 10.2018 C 17.998 12.0316 17.368 13.7152 16.315 15.0426 L 21.336 20.0634 C 21.688 20.4158 21.688 20.9858 21.336 21.3345 C 20.983 21.6832 20.413 21.687 20.064 21.3345 L 15.04 16.3175 Z", fill: "currentColor" }), e[0] = n) : n = e[0];
  let o;
  return e[1] !== t ? (o = /* @__PURE__ */ x("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", fill: "none", ...t, children: n }), e[1] = t, e[2] = o) : o = e[2], o;
}
function yv(t) {
  const e = J.c(3);
  let n;
  e[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (n = /* @__PURE__ */ x("path", { d: "M 10.485 7.1008 L 10.896 5.2798 H 13.104 L 13.515 7.1008 C 13.566 7.3228 13.719 7.5088 13.929 7.6018 C 14.253 7.7458 14.559 7.9228 14.841 8.1298 C 15.024 8.2648 15.264 8.3068 15.483 8.2378 L 17.268 7.6828 L 18.372 9.5968 L 16.998 10.8658 C 16.83 11.0218 16.746 11.2468 16.77 11.4718 C 16.809 11.8168 16.809 12.1828 16.77 12.5278 C 16.746 12.7558 16.83 12.9808 16.998 13.1338 L 18.372 14.4028 L 17.268 16.3168 L 15.483 15.7618 C 15.264 15.6928 15.027 15.7348 14.841 15.8698 C 14.559 16.0768 14.253 16.2568 13.929 16.3978 C 13.719 16.4908 13.566 16.6768 13.515 16.8988 L 13.104 18.7198 H 10.896 L 10.485 16.8988 C 10.434 16.6768 10.281 16.4908 10.071 16.3978 C 9.747 16.2538 9.441 16.0768 9.159 15.8698 C 8.976 15.7348 8.736 15.6928 8.517 15.7618 L 6.732 16.3168 L 5.628 14.4028 L 7.002 13.1338 C 7.17 12.9778 7.254 12.7528 7.23 12.5278 C 7.191 12.1828 7.191 11.8168 7.23 11.4718 C 7.254 11.2438 7.17 11.0188 7.002 10.8658 L 5.628 9.5968 L 6.732 7.6828 L 8.517 8.2378 C 8.736 8.3068 8.973 8.2648 9.159 8.1298 C 9.441 7.9228 9.747 7.7428 10.071 7.6018 C 10.281 7.5088 10.434 7.3228 10.485 7.1008 Z M 10.704 3.8398 C 10.143 3.8398 9.657 4.2298 9.534 4.7758 L 9.156 6.4438 C 8.967 6.5398 8.787 6.6448 8.61 6.7588 L 6.978 6.2518 C 6.441 6.0838 5.862 6.3118 5.583 6.7978 L 4.287 9.0418 C 4.008 9.5278 4.101 10.1428 4.512 10.5238 L 5.769 11.6848 C 5.76 11.8918 5.76 12.1048 5.769 12.3148 L 4.512 13.4758 C 4.101 13.8568 4.005 14.4718 4.287 14.9578 L 5.583 17.2018 C 5.862 17.6878 6.444 17.9128 6.978 17.7478 L 8.613 17.2408 C 8.79 17.3548 8.97 17.4598 9.159 17.5558 L 9.537 19.2238 C 9.66 19.7698 10.146 20.1598 10.707 20.1598 H 13.299 C 13.86 20.1598 14.346 19.7698 14.469 19.2238 L 14.847 17.5558 C 15.036 17.4598 15.216 17.3548 15.393 17.2408 L 17.028 17.7478 C 17.565 17.9158 18.144 17.6878 18.423 17.2018 L 19.719 14.9578 C 19.998 14.4718 19.905 13.8568 19.494 13.4758 L 18.237 12.3148 C 18.246 12.1078 18.246 11.8948 18.237 11.6848 L 19.494 10.5238 C 19.905 10.1428 19.998 9.5278 19.719 9.0418 L 18.42 6.7978 C 18.138 6.3118 17.559 6.0868 17.025 6.2518 L 15.39 6.7588 C 15.213 6.6448 15.033 6.5398 14.844 6.4438 L 14.469 4.7758 C 14.343 4.2298 13.857 3.8398 13.296 3.8398 H 10.704 Z M 13.44 11.9998 C 13.44 12.7948 12.795 13.4398 12 13.4398 C 11.205 13.4398 10.56 12.7948 10.56 11.9998 C 10.56 11.2048 11.205 10.5598 12 10.5598 C 12.795 10.5598 13.44 11.2048 13.44 11.9998 Z M 12 9.1198 C 10.41 9.1198 9.12 10.4098 9.12 11.9998 C 9.12 13.5898 10.41 14.8798 12 14.8798 C 13.59 14.8798 14.88 13.5898 14.88 11.9998 C 14.88 10.4098 13.59 9.1198 12 9.1198 Z", fill: "currentColor" }), e[0] = n) : n = e[0];
  let o;
  return e[1] !== t ? (o = /* @__PURE__ */ x("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", fill: "none", ...t, children: n }), e[1] = t, e[2] = o) : o = e[2], o;
}
function xv(t) {
  const e = J.c(3);
  let n;
  e[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (n = /* @__PURE__ */ x("path", { d: "M 13.539 7.8393 C 13.187 8.1918 12.617 8.1918 12.268 7.8393 C 11.919 7.4868 11.916 6.9168 12.268 6.5681 L 16.164 2.6643 C 16.517 2.3118 17.087 2.3118 17.436 2.6643 L 21.336 6.5643 C 21.688 6.9168 21.688 7.4868 21.336 7.8356 C 20.983 8.1843 20.413 8.1881 20.064 7.8356 L 17.702 5.4731 V 20.7018 C 17.702 21.2006 17.301 21.6018 16.802 21.6018 C 16.303 21.6018 15.902 21.2006 15.902 20.7018 V 5.4731 L 13.539 7.8356 V 7.8393 Z M 3.939 16.1643 L 6.302 18.5268 V 3.2981 C 6.302 2.7993 6.703 2.3981 7.202 2.3981 C 7.701 2.3981 8.102 2.7993 8.102 3.2981 V 18.5268 L 10.464 16.1643 C 10.817 15.8118 11.387 15.8118 11.736 16.1643 C 12.084 16.5168 12.088 17.0868 11.736 17.4356 L 7.836 21.3356 C 7.483 21.6881 6.913 21.6881 6.564 21.3356 L 2.664 17.4393 C 2.312 17.0868 2.312 16.5168 2.664 16.1681 C 3.017 15.8193 3.587 15.8156 3.936 16.1681 L 3.939 16.1643 Z", fill: "currentColor" }), e[0] = n) : n = e[0];
  let o;
  return e[1] !== t ? (o = /* @__PURE__ */ x("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", fill: "none", ...t, children: n }), e[1] = t, e[2] = o) : o = e[2], o;
}
function wv(t) {
  const e = J.c(3);
  let n;
  e[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (n = /* @__PURE__ */ x("path", { d: "M 16.024 4.395 C 15.855 4.4587 15.743 4.62 15.743 4.8 C 15.743 4.98 15.855 5.1412 16.024 5.205 L 18.143 6 L 18.938 8.1187 C 19.002 8.2875 19.163 8.4 19.343 8.4 C 19.523 8.4 19.684 8.2875 19.748 8.1187 L 20.543 6 L 22.662 5.205 C 22.83 5.1412 22.943 4.98 22.943 4.8 C 22.943 4.62 22.83 4.4587 22.662 4.395 L 20.543 3.6 L 19.748 1.4812 C 19.684 1.3125 19.523 1.2 19.343 1.2 C 19.163 1.2 19.002 1.3125 18.938 1.4812 L 18.143 3.6 L 16.024 4.395 Z M 7.639 10.2187 L 8.543 8.265 L 9.447 10.2187 C 9.627 10.6087 9.938 10.92 10.328 11.1 L 12.282 12.0037 L 10.328 12.9075 C 9.938 13.0875 9.627 13.3987 9.447 13.7887 L 8.543 15.7425 L 7.639 13.7887 C 7.459 13.3987 7.148 13.0875 6.758 12.9075 L 4.804 12 L 6.762 11.0962 C 7.152 10.9162 7.463 10.605 7.643 10.215 L 7.639 10.2187 Z M 7.553 6.1162 L 6.008 9.465 L 2.659 11.01 L 2.637 11.0212 C 2.49 11.0887 2.175 11.235 1.692 11.4562 C 1.478 11.5537 1.343 11.7675 1.343 12 C 1.343 12.2325 1.478 12.4462 1.692 12.5437 C 2.175 12.765 2.487 12.9112 2.637 12.9787 L 2.659 12.99 L 6.008 14.535 L 7.553 17.8837 L 7.564 17.9062 C 7.632 18.0525 7.778 18.3675 7.999 18.8512 C 8.097 19.065 8.31 19.2 8.543 19.2 C 8.775 19.2 8.989 19.065 9.087 18.8512 C 9.627 17.685 9.653 17.625 11.078 14.5387 L 14.427 12.9937 L 14.449 12.9825 C 14.595 12.915 14.91 12.7687 15.394 12.5475 C 15.608 12.45 15.743 12.2362 15.743 12.0037 C 15.743 11.7712 15.608 11.5575 15.394 11.46 C 14.228 10.92 14.168 10.8937 11.082 9.4687 L 9.537 6.12 L 9.525 6.0975 C 9.458 5.9512 9.312 5.6362 9.09 5.1525 C 8.993 4.9387 8.779 4.8037 8.547 4.8037 C 8.314 4.8037 8.1 4.9387 8.003 5.1525 C 7.485 6.27 7.572 6.09 7.557 6.12 L 7.553 6.1162 Z M 16.943 18 L 14.824 18.795 C 14.655 18.8587 14.543 19.02 14.543 19.2 C 14.543 19.38 14.655 19.5412 14.824 19.605 L 16.943 20.4 L 17.738 22.5187 C 17.802 22.6875 17.963 22.8 18.143 22.8 C 18.323 22.8 18.484 22.6875 18.548 22.5187 L 19.343 20.4 L 21.462 19.605 C 21.63 19.5412 21.743 19.38 21.743 19.2 C 21.743 19.02 21.63 18.8587 21.462 18.795 L 19.343 18 L 18.548 15.8812 C 18.484 15.7125 18.323 15.6 18.143 15.6 C 17.963 15.6 17.802 15.7125 17.738 15.8812 L 16.943 18 Z", fill: "currentColor" }), e[0] = n) : n = e[0];
  let o;
  return e[1] !== t ? (o = /* @__PURE__ */ x("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", fill: "none", ...t, children: n }), e[1] = t, e[2] = o) : o = e[2], o;
}
function Cv(t) {
  const e = J.c(3);
  let n;
  e[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (n = /* @__PURE__ */ x("path", { d: "M 12.72 14.1599 C 12.72 14.5589 12.399 14.8799 12 14.8799 C 11.601 14.8799 11.28 14.5589 11.28 14.1599 V 6.7769 L 9.39 8.6669 C 9.108 8.9489 8.652 8.9489 8.373 8.6669 C 8.094 8.3849 8.091 7.9289 8.373 7.6499 L 11.49 4.5299 C 11.772 4.2479 12.228 4.2479 12.507 4.5299 L 15.63 7.6499 C 15.912 7.9319 15.912 8.3879 15.63 8.6669 C 15.348 8.9459 14.892 8.9489 14.613 8.6669 L 12.723 6.7769 V 14.1599 H 12.72 Z M 9.84 13.9199 H 7.2 C 6.936 13.9199 6.72 14.1359 6.72 14.3999 V 16.7999 C 6.72 17.0639 6.936 17.2799 7.2 17.2799 H 16.8 C 17.064 17.2799 17.28 17.0639 17.28 16.7999 V 14.3999 C 17.28 14.1359 17.064 13.9199 16.8 13.9199 H 14.16 V 12.4799 H 16.8 C 17.859 12.4799 18.72 13.3409 18.72 14.3999 V 16.7999 C 18.72 17.8589 17.859 18.7199 16.8 18.7199 H 7.2 C 6.141 18.7199 5.28 17.8589 5.28 16.7999 V 14.3999 C 5.28 13.3409 6.141 12.4799 7.2 12.4799 H 9.84 V 13.9199 Z M 14.88 15.5999 C 14.88 15.2009 15.201 14.8799 15.6 14.8799 C 15.999 14.8799 16.32 15.2009 16.32 15.5999 C 16.32 15.9989 15.999 16.3199 15.6 16.3199 C 15.201 16.3199 14.88 15.9989 14.88 15.5999 Z", fill: "currentColor" }), e[0] = n) : n = e[0];
  let o;
  return e[1] !== t ? (o = /* @__PURE__ */ x("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", fill: "none", ...t, children: n }), e[1] = t, e[2] = o) : o = e[2], o;
}
function Sv(t) {
  const e = J.c(3);
  let n;
  e[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (n = /* @__PURE__ */ x("path", { d: "M 11.103 3.2971 C 15.44 3.2971 19.037 6.4723 19.697 10.6231 C 19.353 10.7931 19.047 11.0446 18.806 11.3778 L 18.167 12.2515 C 18.17 12.1665 18.174 12.0849 18.174 11.9999 C 18.174 8.0938 15.009 4.9289 11.103 4.9289 C 7.197 4.9289 4.032 8.0938 4.032 11.9999 C 4.032 15.9059 7.197 19.0709 11.103 19.0709 C 12.33 19.0709 13.482 18.7581 14.485 18.2108 L 15.542 19.3055 C 15.58 19.3428 15.621 19.3802 15.661 19.4142 C 14.336 20.2301 12.775 20.7027 11.103 20.7027 C 6.296 20.7027 2.4 16.8068 2.4 11.9999 C 2.4 7.193 6.296 3.2971 11.103 3.2971 Z M 20.125 12.3364 C 20.39 11.9727 20.9 11.8911 21.264 12.1563 C 21.628 12.4214 21.709 12.9314 21.444 13.2951 L 17.963 18.0816 C 17.82 18.2754 17.599 18.4012 17.361 18.4148 C 17.123 18.4284 16.885 18.34 16.719 18.1666 L 15.141 16.5348 C 14.829 16.2119 14.835 15.6952 15.162 15.3824 C 15.488 15.0697 16.001 15.0799 16.314 15.4028 L 17.215 16.3343 L 20.125 12.333 V 12.3364 Z M 11.103 16.3513 C 10.501 16.3513 10.015 15.8651 10.015 15.2634 C 10.015 14.6617 10.501 14.1756 11.103 14.1756 C 11.704 14.1756 12.191 14.6617 12.191 15.2634 C 12.191 15.8651 11.704 16.3513 11.103 16.3513 Z M 11.103 7.6485 C 11.721 7.6485 12.214 8.1754 12.17 8.7941 L 11.919 12.3296 C 11.888 12.758 11.531 13.0877 11.106 13.0877 C 10.678 13.0877 10.324 12.758 10.294 12.3296 L 10.042 8.7941 C 9.998 8.1754 10.487 7.6485 11.109 7.6485 H 11.103 Z", fill: "currentColor" }), e[0] = n) : n = e[0];
  let o;
  return e[1] !== t ? (o = /* @__PURE__ */ x("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", fill: "none", ...t, children: n }), e[1] = t, e[2] = o) : o = e[2], o;
}
function Rv(t) {
  const e = J.c(3);
  let n;
  e[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (n = /* @__PURE__ */ x("path", { d: "M 6.465 7.47 C 6.183 7.188 6.183 6.732 6.465 6.453 C 6.747 6.174 7.203 6.171 7.482 6.453 L 12.012 10.983 L 16.542 6.453 C 16.824 6.171 17.28 6.171 17.559 6.453 C 17.838 6.735 17.841 7.191 17.559 7.47 L 13.029 12 L 17.559 16.53 C 17.841 16.812 17.841 17.268 17.559 17.547 C 17.277 17.826 16.821 17.829 16.542 17.547 L 12.012 13.017 L 7.482 17.547 C 7.2 17.829 6.744 17.829 6.465 17.547 C 6.186 17.265 6.183 16.809 6.465 16.53 L 10.995 12 L 6.465 7.47 Z", fill: "currentColor" }), e[0] = n) : n = e[0];
  let o;
  return e[1] !== t ? (o = /* @__PURE__ */ x("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", fill: "none", ...t, children: n }), e[1] = t, e[2] = o) : o = e[2], o;
}
const cm = {
  "add-plus": U0,
  "arrow-left": Y0,
  "arrow-up-right": G0,
  "bars-filter-regular": j0,
  "button-load-spinner": K0,
  calendar: q0,
  "check-mark": X0,
  "chevron-down": Z0,
  "chevron-left": Q0,
  "chevron-right": J0,
  "chevron-up": ev,
  "circle-check-regular": tv,
  "circle-check": nv,
  "circle-exclamation": ov,
  "circle-info": rv,
  "copy-regular": sv,
  download: iv,
  "ellipsis-dots-horiz": av,
  "ellipsis-dots": lv,
  "error-solid": cv,
  error: uv,
  "eye-watching": dv,
  filter: fv,
  "menu-hamburger": pv,
  "notification-bell": gv,
  "oil-analysis-bottle": mv,
  "plus-regular": hv,
  priority: bv,
  search: vv,
  "settings-cog": yv,
  sort: xv,
  sparkles: wv,
  upload: Cv,
  warning: Sv,
  "x-close": Rv
}, Ev = {
  "add-photo": () => import("./add-photo-UE3i3aw7.js"),
  "ai-filled": () => import("./ai-filled-1J1gMDKF.js"),
  ai: () => import("./ai-CruGGRMf.js"),
  "alert-exclamation": () => import("./alert-exclamation-C9YLD8Y5.js"),
  "alerts-outline": () => import("./alerts-outline-u0BE6BKG.js"),
  alerts: () => import("./alerts-_Yw0VcAR.js"),
  "angles-up-down-solid": () => import("./angles-up-down-solid-abyxkTyM.js"),
  api: () => import("./api-Cq21Vyn5.js"),
  "arrow-drop-down": () => import("./arrow-drop-down-CvUuwgsF.js"),
  "arrow-left-shrink-sidebar": () => import("./arrow-left-shrink-sidebar-CRPi0bxb.js"),
  "arrow-right-expand-sidebar": () => import("./arrow-right-expand-sidebar-BfZkZzGl.js"),
  "arrow-right-regular": () => import("./arrow-right-regular-ClIL3B0L.js"),
  "arrow-right": () => import("./arrow-right-BB9ZosBM.js"),
  "art-service": () => import("./art-service-D9k-QhdX.js"),
  asset: () => import("./asset-B19Xem3z.js"),
  "assign-link": () => import("./assign-link-Cz8DBNIP.js"),
  "barcode-scan-regular": () => import("./barcode-scan-regular-CRMPw43a.js"),
  binoculars: () => import("./binoculars-BaEFhFtH.js"),
  "bookmark-regular": () => import("./bookmark-regular-ErqXaTnq.js"),
  "bookmark-solid": () => import("./bookmark-solid-XxMmOSH8.js"),
  "calendar-solid": () => import("./calendar-solid-BKuAZoMG.js"),
  "camera-regular": () => import("./camera-regular-DCn5NMis.js"),
  "chart-line": () => import("./chart-line-adT1FhfC.js"),
  "check-circle": () => import("./check-circle-pcTXVe3m.js"),
  checklist: () => import("./checklist-Bopnj5hn.js"),
  "circle-minus-solid": () => import("./circle-minus-solid-DKh4s7Vy.js"),
  "circle-navigation": () => import("./circle-navigation-C_N1sdOv.js"),
  "circle-play-solid": () => import("./circle-play-solid-5RxV5EWv.js"),
  "circle-plus-regular": () => import("./circle-plus-regular-zl6C5_zW.js"),
  "circle-question": () => import("./circle-question-BInzI22Q.js"),
  "circle-stop-regular": () => import("./circle-stop-regular-C_JIeCcl.js"),
  "circle-xmark-solid": () => import("./circle-xmark-solid--KBWCnKI.js"),
  "clock-seven": () => import("./clock-seven-BO_QNMDA.js"),
  "cloud-slash-regular": () => import("./cloud-slash-regular-DoTIr8Oz.js"),
  collect: () => import("./collect-Co2HYlGr.js"),
  "collection-taken": () => import("./collection-taken-Cy4xrGCl.js"),
  "command-search": () => import("./command-search-C2xsNRgD.js"),
  component: () => import("./component-DPrBUJTp.js"),
  "configure-slider": () => import("./configure-slider-bFpbIHj4.js"),
  "cost-savings-dollar": () => import("./cost-savings-dollar-WugkrpTl.js"),
  customers: () => import("./customers-BeIVwCsd.js"),
  "document-upload": () => import("./document-upload-BGJdqBn4.js"),
  document: () => import("./document-ByADL7LW.js"),
  "dollar-sign": () => import("./dollar-sign-DrSDp3MT.js"),
  dot: () => import("./dot-Bsti8OLe.js"),
  drag: () => import("./drag-BZplXPTC.js"),
  "edit-pen": () => import("./edit-pen-CxBiIwxm.js"),
  "email-envelope": () => import("./email-envelope-DiLoHzY9.js"),
  "expand-regular": () => import("./expand-regular-C05q6RBY.js"),
  expand: () => import("./expand-Ar2qxbi8.js"),
  "eye-slash-regular": () => import("./eye-slash-regular-BL-pt4ts.js"),
  facilities: () => import("./facilities-rrXql8UO.js"),
  "flash-auto": () => import("./flash-auto-COJnXXcG.js"),
  "flash-off": () => import("./flash-off-DxAJx4CC.js"),
  "flash-on": () => import("./flash-on-D41TNyqb.js"),
  "gauge-max-solid-full": () => import("./gauge-max-solid-full-DVsU73t4.js"),
  grid: () => import("./grid-BnvfXTkX.js"),
  "grip-drag": () => import("./grip-drag-T3n9XLV-.js"),
  hardware: () => import("./hardware-BNCoZ_bt.js"),
  hazardous: () => import("./hazardous-DMmCTvnj.js"),
  home: () => import("./home-Zcw7DEya.js"),
  "hwe-sensor-triangle": () => import("./hwe-sensor-triangle-BwAq5IX-.js"),
  "image-regular": () => import("./image-regular-Bsg0ZFYZ.js"),
  integrations: () => import("./integrations-BEIAsn9j.js"),
  "invoke-reading-bolt-regular": () => import("./invoke-reading-bolt-regular-Cp5QGlzd.js"),
  "invoke-reading-bolt-solid": () => import("./invoke-reading-bolt-solid-B9yq2sii.js"),
  line: () => import("./line-bZnGeTu-.js"),
  list: () => import("./list-410cdSHm.js"),
  "location-pin-solid": () => import("./location-pin-solid-BgnBR0Q7.js"),
  "logout-exit": () => import("./logout-exit-CJdNt9zY.js"),
  maintenance: () => import("./maintenance-Cdgp6dk4.js"),
  marketplace: () => import("./marketplace-DjGN6iKj.js"),
  message: () => import("./message-CnKMpyxz.js"),
  "microphone-solid": () => import("./microphone-solid-BN1BAqyC.js"),
  minus: () => import("./minus-Ck_rUujj.js"),
  "monitoring-point": () => import("./monitoring-point-4dssObz2.js"),
  "new-message": () => import("./new-message-COl6FN29.js"),
  "new-nxt-step": () => import("./new-nxt-step-DdKIQhHf.js"),
  "note-regular": () => import("./note-regular-DtG3iBud.js"),
  "paper-plane-top": () => import("./paper-plane-top-UvtbOAeS.js"),
  partners: () => import("./partners-qveXf0qH.js"),
  phone: () => import("./phone-bdISCoGZ.js"),
  "qr-code-scan": () => import("./qr-code-scan-CRAz-Oyn.js"),
  "quarterly-collection": () => import("./quarterly-collection-CxUmYmn_.js"),
  "report-error-square-regular": () => import("./report-error-square-regular-BVmNOQPD.js"),
  rotate: () => import("./rotate-BZY99ywR.js"),
  save: () => import("./save-BMS6Tjxq.js"),
  send: () => import("./send-iYh4V9VL.js"),
  service: () => import("./service-D19lNwJd.js"),
  "settings-cog-solid": () => import("./settings-cog-solid-DzBAvMJm.js"),
  share: () => import("./share-DR74k9ao.js"),
  "signal-connection": () => import("./signal-connection-D2TXKNXS.js"),
  signal: () => import("./signal-ClsGNY50.js"),
  "sort-lines": () => import("./sort-lines-BqsmDERv.js"),
  "stacked-images-regular": () => import("./stacked-images-regular-C7r2AhI2.js"),
  "star-recommended": () => import("./star-recommended-D6nF25YJ.js"),
  sync: () => import("./sync-DCq2I0rc.js"),
  tag: () => import("./tag-C-1U0rZc.js"),
  "temperature-high-regular-full": () => import("./temperature-high-regular-full-CGdfPnlm.js"),
  "thumbs-down": () => import("./thumbs-down-CFpQbdTQ.js"),
  "thumbs-up": () => import("./thumbs-up-BA7gZye6.js"),
  "trash-delete-bin": () => import("./trash-delete-bin-BRaP7obb.js"),
  "trend-down": () => import("./trend-down-B81Xe2bK.js"),
  "trend-no-change": () => import("./trend-no-change-BXWLdfQB.js"),
  "trend-up": () => import("./trend-up-BwERaJGs.js"),
  "triangle-exclamation-solid": () => import("./triangle-exclamation-solid-DFLVYwfr.js"),
  "up-down": () => import("./up-down-BgbgwQHo.js"),
  user: () => import("./user-Cislk-h2.js"),
  vero: () => import("./vero-BgxkNmbD.js"),
  vibration: () => import("./vibration-DHXAEqfO.js"),
  watching: () => import("./watching-C6VbFi_c.js"),
  "wifi-exclamation-sharp-solid": () => import("./wifi-exclamation-sharp-solid-B2lRByzu.js"),
  wifi: () => import("./wifi-8GgIkdeE.js"),
  workorder: () => import("./workorder-Dp1QwIZP.js"),
  "zoom-in": () => import("./zoom-in-B26X0B3W.js"),
  "zoom-out": () => import("./zoom-out-5iqiIT_e.js")
}, Pv = {
  neutral: "text-icon-main",
  secondary: "text-icon-secondary",
  brand: "text-primary",
  warning: "text-accessibility-warning",
  negative: "text-negative",
  positive: "text-positive",
  informative: "text-informative",
  inherit: "text-current"
}, Nv = {
  xs: "var(--icon-xs)",
  sm: "var(--icon-sm)",
  md: "var(--icon-md)",
  lg: "var(--icon-lg)",
  xl: "var(--icon-xl)",
  xxl: "var(--icon-xxl)"
}, ea = /* @__PURE__ */ new Map(), gi = /* @__PURE__ */ new Map();
function gl(t) {
  return t in cm;
}
function Iv(t) {
  const e = ea.get(t);
  if (e)
    return Promise.resolve(e);
  const n = gi.get(t);
  if (n)
    return n;
  const o = Ev[t], r = o().then((s) => (ea.set(t, s.default), gi.delete(t), s.default)).catch((s) => {
    throw gi.delete(t), s;
  });
  return gi.set(t, r), r;
}
function Ye(t) {
  const e = J.c(31);
  let n, o, r, s, i, a, l;
  e[0] !== t ? ({
    name: r,
    size: a,
    tone: l,
    style: i,
    "aria-label": o,
    "aria-hidden": n,
    ...s
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r, e[4] = s, e[5] = i, e[6] = a, e[7] = l) : (n = e[1], o = e[2], r = e[3], s = e[4], i = e[5], a = e[6], l = e[7]);
  const c = a === void 0 ? "md" : a, u = l === void 0 ? "neutral" : l, d = !o, f = Nv[c];
  let p;
  e[8] !== r ? (p = () => {
    if (gl(r))
      return;
    const N = ea.get(r);
    return N ? {
      name: r,
      Component: N
    } : void 0;
  }, e[8] = r, e[9] = p) : p = e[9];
  const [g, m] = Mt(p), h = Pv[u];
  let b;
  e[10] !== f || e[11] !== i ? (b = {
    width: f,
    height: f,
    flexShrink: 0,
    ...i
  }, e[10] = f, e[11] = i, e[12] = b) : b = e[12];
  const w = n ?? (d ? !0 : void 0), y = d ? void 0 : "img";
  let C;
  e[13] !== o || e[14] !== s || e[15] !== h || e[16] !== b || e[17] !== w || e[18] !== y ? (C = {
    className: h,
    style: b,
    "aria-hidden": w,
    "aria-label": o,
    role: y,
    ...s
  }, e[13] = o, e[14] = s, e[15] = h, e[16] = b, e[17] = w, e[18] = y, e[19] = C) : C = e[19];
  const R = C;
  let S, E;
  if (e[20] !== r ? (E = () => {
    if (gl(r)) {
      m(void 0);
      return;
    }
    let N = !0;
    const I = r, M = ea.get(I);
    if (M) {
      m({
        name: I,
        Component: M
      });
      return;
    }
    return m(void 0), Iv(I).then((T) => {
      N && m({
        name: I,
        Component: T
      });
    }).catch(() => {
      N && m(void 0);
    }), () => {
      N = !1;
    };
  }, S = [r], e[20] = r, e[21] = S, e[22] = E) : (S = e[21], E = e[22]), rr(E, S), gl(r)) {
    const N = cm[r];
    let I;
    return e[23] !== N || e[24] !== R ? (I = /* @__PURE__ */ x(N, { ...R }), e[23] = N, e[24] = R, e[25] = I) : I = e[25], I;
  }
  if (g?.name === r) {
    const N = g.Component;
    let I;
    return e[26] !== N || e[27] !== R ? (I = /* @__PURE__ */ x(N, { ...R }), e[26] = N, e[27] = R, e[28] = I) : I = e[28], I;
  }
  let P;
  return e[29] !== R ? (P = /* @__PURE__ */ x("svg", { ...R }), e[29] = R, e[30] = P) : P = e[30], P;
}
function $c(t) {
  const e = J.c(2), {
    size: n
  } = t, o = n === void 0 ? "sm" : n;
  let r;
  return e[0] !== o ? (r = /* @__PURE__ */ x("span", { className: "aw-spinner inline-flex", "aria-hidden": "true", children: /* @__PURE__ */ x(Ye, { name: "button-load-spinner", size: o, tone: "inherit" }) }), e[0] = o, e[1] = r) : r = e[1], r;
}
const Mv = ye(["inline-flex", "items-center", "justify-center", "whitespace-nowrap", "shrink-0", "rounded-(--radius-sm)", "px-(--spacing-12)", "border", "border-solid", "font-(family-name:--font-family-label)", "font-(number:--font-weight-medium)", "cursor-pointer", "select-none", "transition-colors", "duration-200", "ease-in-out", "outline-none", "[&_svg]:pointer-events-none", "[&_svg]:shrink-0"], {
  variants: {
    variant: {
      primary: ["bg-button-primary-default-background", "text-button-primary-default-text", "border-button-primary-default-background", "hover:bg-button-primary-hover-background", "hover:border-button-primary-hover-background", "active:bg-button-primary-pressed-background", "active:border-button-primary-pressed-background", "focus-visible:ring-2", "focus-visible:ring-offset-1", "focus-visible:ring-offset-surface", "focus-visible:ring-button-focus-ring"],
      outline: ["bg-button-outline-default-background", "text-button-outline-default-text", "border-button-outline-default-border", "hover:bg-button-outline-hover-background", "hover:border-button-outline-hover-border", "active:bg-button-outline-pressed-background", "active:border-button-outline-pressed-border", "data-[mouse-down]:bg-button-outline-pressed-background", "data-[mouse-down]:border-button-outline-pressed-border", "focus-visible:ring-2", "focus-visible:ring-offset-1", "focus-visible:ring-offset-surface", "focus-visible:ring-button-focus-ring"],
      ghost: ["bg-transparent", "text-button-ghost-default-text", "border-transparent", "hover:bg-button-ghost-hover-background", "active:bg-button-ghost-pressed-background", "focus-visible:ring-2", "focus-visible:ring-offset-1", "focus-visible:ring-offset-surface", "focus-visible:ring-button-focus-ring"],
      info: ["bg-button-info-default-background", "text-button-info-default-text", "border-button-info-default-background", "hover:bg-button-info-hover-background", "hover:border-button-info-hover-background", "active:bg-button-info-pressed-background", "active:border-button-info-pressed-background", "focus-visible:ring-2", "focus-visible:ring-offset-1", "focus-visible:ring-offset-surface", "focus-visible:ring-button-focus-ring"]
    },
    intent: {
      default: null,
      destructive: null
    },
    size: {
      sm: ["h-(--spacing-32)", "gap-(--spacing-8)", "text-(length:--font-size-body-medium)", "leading-(--font-line-height-20)"],
      md: ["h-(--spacing-40)", "gap-(--spacing-8)", "text-(length:--font-size-body-large)", "leading-(--font-line-height-24)"],
      lg: ["h-[44px]", "gap-(--spacing-8)", "px-(--spacing-16)", "text-(length:--font-size-body-large)", "leading-(--font-line-height-24)"]
    }
  },
  compoundVariants: [{
    variant: "primary",
    intent: "destructive",
    class: ["bg-button-primary-destructive-default-background", "text-button-primary-destructive-text", "border-button-primary-destructive-default-background", "hover:bg-button-primary-destructive-hover-background", "hover:border-button-primary-destructive-hover-background", "active:bg-button-primary-destructive-pressed-background", "active:border-button-primary-destructive-pressed-background"]
  }, {
    variant: "ghost",
    intent: "destructive",
    class: ["text-text-destructive"]
  }],
  defaultVariants: {
    variant: "primary",
    intent: "default",
    size: "md"
  }
});
function Hn(t) {
  const e = J.c(33);
  let n, o, r, s, i, a, l, c, u, d;
  e[0] !== t ? ({
    children: n,
    variant: d,
    intent: r,
    size: i,
    icon: o,
    loading: a,
    loadingText: l,
    fullWidth: c,
    disabled: u,
    ...s
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r, e[4] = s, e[5] = i, e[6] = a, e[7] = l, e[8] = c, e[9] = u, e[10] = d) : (n = e[1], o = e[2], r = e[3], s = e[4], i = e[5], a = e[6], l = e[7], c = e[8], u = e[9], d = e[10]);
  const f = a === void 0 ? !1 : a, p = l === void 0 ? "Loading" : l, g = c === void 0 ? !1 : c, m = u === void 0 ? !1 : u, h = m || f;
  let b;
  e[11] !== m || e[12] !== g || e[13] !== r || e[14] !== h || e[15] !== f || e[16] !== i || e[17] !== d ? (b = le(Mv({
    variant: d,
    intent: r,
    size: i
  }), g && "w-full", h && "opacity-40 pointer-events-none", m && "cursor-not-allowed", f && !m && "cursor-default"), e[11] = m, e[12] = g, e[13] = r, e[14] = h, e[15] = f, e[16] = i, e[17] = d, e[18] = b) : b = e[18];
  const w = h || void 0, y = f || void 0, C = h ? -1 : void 0, R = f ? `${p}...` : n;
  let S;
  e[19] !== o || e[20] !== f ? (S = f ? /* @__PURE__ */ x($c, { size: "sm" }) : o ? /* @__PURE__ */ x(Ye, { name: o, size: "sm", tone: "inherit" }) : null, e[19] = o, e[20] = f, e[21] = S) : S = e[21];
  let E;
  return e[22] !== h || e[23] !== s || e[24] !== i || e[25] !== S || e[26] !== b || e[27] !== w || e[28] !== y || e[29] !== C || e[30] !== R || e[31] !== d ? (E = /* @__PURE__ */ j(Un, { "data-slot": "button", "data-variant": d, "data-size": i, className: b, disabled: h, "aria-disabled": w, "aria-busy": y, tabIndex: C, ...s, children: [
    R,
    S
  ] }), e[22] = h, e[23] = s, e[24] = i, e[25] = S, e[26] = b, e[27] = w, e[28] = y, e[29] = C, e[30] = R, e[31] = d, e[32] = E) : E = e[32], E;
}
const Pf = le("relative", "flex", "flex-col", "items-start", "w-full", "rounded-(--radius-sm)", "border", "border-outline-subtle", "bg-surface", "shadow-elevation-1"), ml = {
  none: "p-0",
  compact: "p-(--spacing-12)",
  comfortable: "px-(--spacing-20) py-(--spacing-16)"
};
le("flex", "w-full", "items-center", "[&>[data-slot=card-group-item]:first-child:not(:last-child)>[data-slot=card]]:rounded-r-none", "[&>[data-slot=card-group-item]:first-child:not(:last-child)>[data-slot=card]]:border-r-0", "[&>[data-slot=card-group-item]:not(:first-child):not(:last-child)>[data-slot=card]]:rounded-none", "[&>[data-slot=card-group-item]:not(:first-child):not(:last-child)>[data-slot=card]]:border-r-0", "[&>[data-slot=card-group-item]:last-child:not(:first-child)>[data-slot=card]]:rounded-l-none");
le("min-w-0", "flex-1");
const Tv = le("cursor-pointer", "select-none", "outline-none", "transition-colors", "duration-200", "ease-in-out", "text-left", "hover:bg-surface-hover", "active:bg-surface-container-highest", "focus-visible:ring-2", "focus-visible:ring-button-focus-ring", "focus-visible:ring-offset-1", "focus-visible:ring-offset-surface"), kv = le("flex", "w-full", "flex-col", "items-start", "overflow-hidden", "rounded-(--radius-sm)"), Ov = {
  brand: "bg-primary",
  positive: "bg-positive",
  warning: "bg-accessibility-warning",
  negative: "bg-negative",
  informative: "bg-informative"
};
function Dv(t) {
  const e = J.c(4), {
    tone: n
  } = t, o = Ov[n];
  let r;
  e[0] !== o ? (r = le("pointer-events-none absolute -top-px -left-px -right-px z-10 h-(--spacing-8) rounded-tl-(--radius-sm) rounded-tr-(--radius-sm)", o), e[0] = o, e[1] = r) : r = e[1];
  let s;
  return e[2] !== r ? (s = /* @__PURE__ */ x("div", { "data-slot": "card-border-fill", className: r }), e[2] = r, e[3] = s) : s = e[3], s;
}
function um(t) {
  return f0(t) && t.type === Dv;
}
function KP(t) {
  const e = J.c(2), {
    children: n
  } = t;
  let o;
  return e[0] !== n ? (o = /* @__PURE__ */ x("div", { "data-slot": "card-image-slot", className: "w-full shrink-0 overflow-hidden", children: n }), e[0] = n, e[1] = o) : o = e[1], o;
}
function Pa(t) {
  const e = J.c(26);
  let n, o, r, s, i, a, l;
  if (e[0] !== t) {
    l = /* @__PURE__ */ Symbol.for("react.early_return_sentinel");
    e: {
      const {
        children: g,
        fillHeight: m,
        padding: h,
        ...b
      } = t;
      a = b;
      const w = m === void 0 ? !1 : m;
      i = h === void 0 ? "comfortable" : h;
      let y;
      if (e[8] !== g) {
        const S = d0.toArray(g);
        n = S.filter(um), r = n.length > 0, y = S.filter(_v), e[8] = g, e[9] = n, e[10] = r, e[11] = y;
      } else
        n = e[9], r = e[10], y = e[11];
      const C = y;
      let R;
      if (e[12] !== g || e[13] !== C || e[14] !== r || e[15] !== i ? (R = r ? /* @__PURE__ */ x("div", { "data-slot": "card-content", className: le(kv, ml[i]), children: C }) : g, e[12] = g, e[13] = C, e[14] = r, e[15] = i, e[16] = R) : R = e[16], o = R, s = w ? "h-full" : null, "onClick" in a && a.onClick !== void 0) {
        const {
          onClick: S,
          disabled: E,
          ...P
        } = a;
        l = /* @__PURE__ */ j(Un, { "data-slot": "card", className: le(Pf, r ? "overflow-visible" : "overflow-hidden", !r && ml[i], s, Tv, E && "opacity-50 pointer-events-none"), onClick: S, disabled: E, "aria-disabled": E || void 0, ...P, children: [
          n,
          o
        ] });
        break e;
      }
    }
    e[0] = t, e[1] = n, e[2] = o, e[3] = r, e[4] = s, e[5] = i, e[6] = a, e[7] = l;
  } else
    n = e[1], o = e[2], r = e[3], s = e[4], i = e[5], a = e[6], l = e[7];
  if (l !== /* @__PURE__ */ Symbol.for("react.early_return_sentinel"))
    return l;
  const c = r ? "overflow-visible" : "overflow-hidden", u = !r && ml[i];
  let d;
  e[17] !== s || e[18] !== c || e[19] !== u ? (d = le(Pf, c, u, s), e[17] = s, e[18] = c, e[19] = u, e[20] = d) : d = e[20];
  const f = a;
  let p;
  return e[21] !== n || e[22] !== o || e[23] !== d || e[24] !== f ? (p = /* @__PURE__ */ j("div", { "data-slot": "card", className: d, ...f, children: [
    n,
    o
  ] }), e[21] = n, e[22] = o, e[23] = d, e[24] = f, e[25] = p) : p = e[25], p;
}
function _v(t) {
  return !um(t);
}
const Vv = ye(["inline-flex", "items-center", "justify-center", "max-w-full", "gap-(--spacing-4)", "h-(--spacing-24)", "rounded-(--radius-sm)", "overflow-hidden", "font-(family-name:--font-family-label)", "text-(length:--font-size-label-medium)", "leading-(--font-line-height-16)", "font-(--font-weight-medium)", "whitespace-nowrap"], {
  variants: {
    tone: {
      positive: ["bg-chip-positive-container", "text-chip-positive-label"],
      neutral: ["bg-chip-neutral-container", "text-chip-neutral-label"],
      negative: ["bg-chip-negative-container", "text-chip-negative-label"],
      warning: ["bg-chip-warning-container", "text-chip-warning-label"],
      informative: ["bg-chip-informative-container", "text-chip-informative-label"],
      brand: ["bg-chip-brand-container", "text-chip-brand-label"]
    },
    iconOnly: {
      true: ["px-(--spacing-4)", "py-(--spacing-4)"],
      false: ["px-(--spacing-6)", "py-(--spacing-4)"]
    }
  },
  defaultVariants: {
    tone: "neutral",
    iconOnly: !1
  }
}), Av = {
  informative: "text-chip-informative-label-icon",
  positive: "text-chip-positive-label-icon",
  warning: "text-chip-warning-label-icon",
  negative: "text-chip-negative-label-icon"
};
function dm(t) {
  const e = J.c(22);
  let n, o, r, s, i, a;
  e[0] !== t ? ({
    tone: a,
    icon: o,
    label: r,
    children: n,
    truncate: i,
    ...s
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r, e[4] = s, e[5] = i, e[6] = a) : (n = e[1], o = e[2], r = e[3], s = e[4], i = e[5], a = e[6]);
  const l = i === void 0 ? !0 : i, c = o !== void 0 && r === void 0;
  let u;
  e[7] !== c || e[8] !== a ? (u = Vv({
    tone: a,
    iconOnly: c
  }), e[7] = c, e[8] = a, e[9] = u) : u = e[9];
  let d;
  e[10] !== o || e[11] !== a ? (d = o && /* @__PURE__ */ x("span", { className: le("inline-flex shrink-0 items-center", Av[a]), children: /* @__PURE__ */ x(Ye, { name: o, size: "xs", tone: "inherit" }) }), e[10] = o, e[11] = a, e[12] = d) : d = e[12];
  let f;
  e[13] !== r || e[14] !== l ? (f = r !== void 0 && /* @__PURE__ */ x("span", { className: l ? "min-w-0 flex-1 truncate" : void 0, children: String(r) }), e[13] = r, e[14] = l, e[15] = f) : f = e[15];
  let p;
  return e[16] !== n || e[17] !== s || e[18] !== u || e[19] !== d || e[20] !== f ? (p = /* @__PURE__ */ j("span", { className: u, ...s, children: [
    d,
    f,
    n
  ] }), e[16] = n, e[17] = s, e[18] = u, e[19] = d, e[20] = f, e[21] = p) : p = e[21], p;
}
function er(t) {
  const e = J.c(2);
  let n;
  return e[0] !== t ? (n = /* @__PURE__ */ x(dm, { ...t }), e[0] = t, e[1] = n) : n = e[1], n;
}
function Fv(t) {
  const e = J.c(15);
  let n, o, r, s;
  e[0] !== t ? ({
    label: n,
    onClose: o,
    removeAriaLabel: s,
    ...r
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r, e[4] = s) : (n = e[1], o = e[2], r = e[3], s = e[4]);
  const i = s ?? `Remove ${n}`;
  let a;
  e[5] !== o ? (a = (d) => {
    d.stopPropagation(), o();
  }, e[5] = o, e[6] = a) : a = e[6];
  let l;
  e[7] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (l = /* @__PURE__ */ x(Ye, { name: "x-close", size: "xs", tone: "inherit" }), e[7] = l) : l = e[7];
  let c;
  e[8] !== i || e[9] !== a ? (c = /* @__PURE__ */ x("button", { type: "button", "aria-label": i, className: "inline-flex shrink-0 cursor-pointer items-center text-icon-main rounded-(--radius-xs) focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-1 focus-visible:ring-offset-surface focus-visible:ring-button-focus-ring", onClick: a, children: l }), e[8] = i, e[9] = a, e[10] = c) : c = e[10];
  let u;
  return e[11] !== n || e[12] !== r || e[13] !== c ? (u = /* @__PURE__ */ x(dm, { tone: "neutral", label: n, ...r, children: c }), e[11] = n, e[12] = r, e[13] = c, e[14] = u) : u = e[14], u;
}
const Lv = ye("mx-auto w-full px-(--spacing-16)", {
  variants: {
    size: {
      sm: "max-w-[600px]",
      md: "max-w-[905px]",
      lg: "max-w-[1240px]",
      xl: "max-w-[1440px]",
      full: "max-w-none"
    }
  },
  defaultVariants: {
    size: "lg"
  }
});
function qP(t) {
  const e = J.c(10);
  let n, o, r;
  e[0] !== t ? ({
    size: r,
    children: n,
    ...o
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r) : (n = e[1], o = e[2], r = e[3]);
  let s;
  e[4] !== r ? (s = le(Lv({
    size: r
  })), e[4] = r, e[5] = s) : s = e[5];
  let i;
  return e[6] !== n || e[7] !== o || e[8] !== s ? (i = /* @__PURE__ */ x("div", { className: s, ...o, children: n }), e[6] = n, e[7] = o, e[8] = s, e[9] = i) : i = e[9], i;
}
const fm = {
  0: "gap-(--spacing-0)",
  2: "gap-(--spacing-2)",
  4: "gap-(--spacing-4)",
  6: "gap-(--spacing-6)",
  8: "gap-(--spacing-8)",
  10: "gap-(--spacing-10)",
  12: "gap-(--spacing-12)",
  16: "gap-(--spacing-16)",
  20: "gap-(--spacing-20)",
  24: "gap-(--spacing-24)",
  32: "gap-(--spacing-32)",
  40: "gap-(--spacing-40)",
  64: "gap-(--spacing-64)",
  80: "gap-(--spacing-80)"
}, pm = {
  start: "items-start",
  center: "items-center",
  end: "items-end",
  stretch: "items-stretch",
  baseline: "items-baseline"
}, $v = {
  start: "justify-start",
  center: "justify-center",
  end: "justify-end",
  between: "justify-between",
  around: "justify-around",
  evenly: "justify-evenly"
}, zv = {
  wrap: "flex-wrap",
  nowrap: "flex-nowrap",
  "wrap-reverse": "flex-wrap-reverse"
}, Hv = ye("flex flex-row", {
  variants: {
    align: pm,
    justify: $v,
    gap: fm,
    wrap: zv
  },
  defaultVariants: {
    gap: 8,
    align: "center"
  }
});
function tr(t) {
  const e = J.c(18);
  let n, o, r, s, i, a, l;
  e[0] !== t ? ({
    gap: r,
    align: n,
    justify: s,
    wrap: l,
    grow: a,
    children: o,
    ...i
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r, e[4] = s, e[5] = i, e[6] = a, e[7] = l) : (n = e[1], o = e[2], r = e[3], s = e[4], i = e[5], a = e[6], l = e[7]);
  const c = a === void 0 ? !1 : a;
  let u;
  e[8] !== n || e[9] !== r || e[10] !== c || e[11] !== s || e[12] !== l ? (u = le(Hv({
    gap: r,
    align: n,
    justify: s,
    wrap: l
  }), c && "[&>*]:flex-1"), e[8] = n, e[9] = r, e[10] = c, e[11] = s, e[12] = l, e[13] = u) : u = e[13];
  let d;
  return e[14] !== o || e[15] !== i || e[16] !== u ? (d = /* @__PURE__ */ x("div", { className: u, ...i, children: o }), e[14] = o, e[15] = i, e[16] = u, e[17] = d) : d = e[17], d;
}
const Bv = ye("flex flex-col", {
  variants: {
    align: pm,
    gap: fm,
    fullWidth: {
      true: "w-full",
      false: null
    }
  },
  defaultVariants: {
    gap: 16,
    fullWidth: !1
  }
});
function vs(t) {
  const e = J.c(14);
  let n, o, r, s, i;
  e[0] !== t ? ({
    gap: r,
    align: n,
    fullWidth: i,
    children: o,
    ...s
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r, e[4] = s, e[5] = i) : (n = e[1], o = e[2], r = e[3], s = e[4], i = e[5]);
  const a = i === void 0 ? !1 : i;
  let l;
  e[6] !== n || e[7] !== a || e[8] !== r ? (l = le(Bv({
    gap: r,
    align: n,
    fullWidth: a
  })), e[6] = n, e[7] = a, e[8] = r, e[9] = l) : l = e[9];
  let c;
  return e[10] !== o || e[11] !== s || e[12] !== l ? (c = /* @__PURE__ */ x("div", { className: l, ...s, children: o }), e[10] = o, e[11] = s, e[12] = l, e[13] = c) : c = e[13], c;
}
const Os = {
  default: "text-text-default",
  subtle: "text-text-subtle",
  subtext: "text-text-subtext",
  disabled: "text-text-disabled",
  inverse: "text-text-inverse",
  inherit: "text-inherit",
  negative: "text-negative",
  positive: "text-positive",
  warning: "text-text-warning",
  informative: "text-text-informative"
}, Ds = {
  start: "text-start",
  center: "text-center",
  end: "text-end"
}, Wv = {
  ...Ds,
  justify: "text-justify"
}, _s = {
  true: "truncate",
  false: ""
}, Uv = {
  2: "line-clamp-2",
  3: "line-clamp-3",
  4: "line-clamp-4"
}, Yv = ye("", {
  variants: {
    size: {
      lg: ["font-(family-name:--font-family-display)", "text-(length:--font-size-display-lg)", "leading-(--line-height-64)", "font-medium", "tracking-[-0.25px]"],
      md: ["font-(family-name:--font-family-display)", "text-(length:--font-size-display-md)", "leading-(--line-height-52)", "font-medium", "tracking-normal"],
      sm: ["font-(family-name:--font-family-display)", "text-(length:--font-size-display-sm)", "leading-(--line-height-44)", "font-medium", "tracking-normal"]
    },
    tone: Os,
    align: Ds,
    truncate: _s
  },
  defaultVariants: {
    size: "md",
    tone: "default"
  }
}), Gv = {
  lg: "h1",
  md: "h1",
  sm: "h2"
};
function XP({
  size: t = "md",
  tone: e,
  align: n,
  truncate: o,
  as: r,
  ...s
}) {
  const i = t ? Gv[t] : "h1", a = r || i;
  return v.createElement(a, {
    className: Yv({
      size: t,
      tone: e,
      align: n,
      truncate: o
    }),
    ...s
  });
}
const jv = ye("", {
  variants: {
    size: {
      lg: ["font-(family-name:--font-family-headline)", "text-(length:--font-size-headline-lg)", "leading-(--line-height-40)", "font-medium", "tracking-normal"],
      md: ["font-(family-name:--font-family-headline)", "text-(length:--font-size-headline-md)", "leading-(--line-height-36)", "font-medium", "tracking-normal"],
      sm: ["font-(family-name:--font-family-headline)", "text-(length:--font-size-headline-sm)", "leading-(--line-height-32)", "font-medium", "tracking-normal"]
    },
    tone: Os,
    align: Ds,
    truncate: _s
  },
  defaultVariants: {
    size: "md",
    tone: "default"
  }
}), Kv = {
  lg: "h2",
  md: "h3",
  sm: "h4"
};
function ZP({
  size: t = "md",
  tone: e,
  align: n,
  truncate: o,
  as: r,
  ...s
}) {
  const i = t ? Kv[t] : "h3", a = r || i;
  return v.createElement(a, {
    className: jv({
      size: t,
      tone: e,
      align: n,
      truncate: o
    }),
    ...s
  });
}
const qv = ye("font-(family-name:--font-family-label) font-semibold", {
  variants: {
    size: {
      lg: ["text-(length:--font-size-label-lg)", "leading-(--line-height-20)"],
      md: ["text-(length:--font-size-label-md)", "leading-(--line-height-16)"],
      sm: ["text-(length:--font-size-label-sm)", "leading-(--line-height-16)"],
      xs: ["text-(length:--font-size-label-xs)", "leading-(--line-height-16)"]
    },
    tone: Os,
    align: Ds,
    truncate: _s
  },
  defaultVariants: {
    size: "md",
    tone: "default"
  }
});
function QP({
  size: t = "md",
  tone: e,
  align: n,
  truncate: o,
  as: r = "span",
  ...s
}) {
  return v.createElement(r, {
    className: qv({
      size: t,
      tone: e,
      align: n,
      truncate: o
    }),
    ...s
  });
}
const Xv = ye("", {
  variants: {
    size: {
      lg: ["font-(family-name:--font-family-body)", "text-(length:--font-size-body-lg)", "leading-(--line-height-24)", "font-normal", "tracking-[0.5px]"],
      md: ["font-(family-name:--font-family-body)", "text-(length:--font-size-body-md)", "leading-(--line-height-20)", "font-normal", "tracking-[0.25px]"],
      sm: ["font-(family-name:--font-family-body)", "text-(length:--font-size-body-sm)", "leading-(--line-height-16)", "font-normal", "tracking-[0.4px]"]
    },
    tone: Os,
    align: Wv,
    truncate: _s,
    lineClamp: Uv
  },
  defaultVariants: {
    size: "md",
    tone: "default"
  }
});
function ys({
  size: t = "md",
  tone: e,
  align: n,
  truncate: o,
  lineClamp: r,
  as: s = "p",
  ...i
}) {
  return v.createElement(s, {
    className: Xv({
      size: t,
      tone: e,
      align: n,
      truncate: o,
      lineClamp: r
    }),
    ...i
  });
}
const Zv = ye("", {
  variants: {
    size: {
      xl: ["font-(family-name:--font-family-title)", "text-(length:--font-size-title-xl)", "font-medium", "tracking-normal"],
      lg: ["font-(family-name:--font-family-title)", "text-(length:--font-size-title-lg)", "font-medium", "tracking-[0.15px]"],
      md: ["font-(family-name:--font-family-title)", "text-(length:--font-size-title-md)", "font-medium", "tracking-[0.15px]"],
      sm: ["font-(family-name:--font-family-title)", "text-(length:--font-size-title-sm)", "font-medium", "tracking-[0.1px]"],
      xs: ["font-(family-name:--font-family-title)", "text-(length:--font-size-title-xs)", "leading-(--line-height-16)", "font-medium", "tracking-[0.1px]"]
    },
    tone: Os,
    align: Ds,
    truncate: _s
  },
  defaultVariants: {
    size: "md",
    tone: "default"
  }
}), Qv = {
  xl: "h4",
  lg: "h5",
  md: "h5",
  sm: "h6",
  xs: "h6"
};
function Vr({
  size: t = "md",
  tone: e,
  align: n,
  truncate: o,
  as: r,
  ...s
}) {
  const i = t ? Qv[t] : "h5", a = r || i;
  return v.createElement(a, {
    className: Zv({
      size: t,
      tone: e,
      align: n,
      truncate: o
    }),
    ...s
  });
}
const Jv = {
  urgent: "Urgent",
  high: "High",
  medium: "Medium"
}, ey = {
  urgent: "negative",
  high: "warning",
  medium: "informative"
};
function ty(t) {
  const e = J.c(2), {
    count: n
  } = t;
  let o;
  return e[0] !== n ? (o = /* @__PURE__ */ x("span", { className: "flex w-[60px] items-center justify-center rounded-(--radius-sm) bg-surface-container px-(--spacing-8) py-(--spacing-6) font-(family-name:--font-family-title) font-(number:--font-weight-bold) text-(length:--font-size-headline-xsmall) leading-(--font-line-height-24) text-text-default", children: n }), e[0] = n, e[1] = o) : o = e[1], o;
}
function JP(t) {
  const e = J.c(31);
  let n, o, r, s, i, a, l;
  e[0] !== t ? ({
    count: r,
    actionItemName: n,
    priority: i,
    buttonLabel: o,
    onButtonClick: s,
    style: l,
    ...a
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r, e[4] = s, e[5] = i, e[6] = a, e[7] = l) : (n = e[1], o = e[2], r = e[3], s = e[4], i = e[5], a = e[6], l = e[7]);
  let c;
  e[8] !== l ? (c = {
    width: "100%",
    ...l
  }, e[8] = l, e[9] = c) : c = e[9];
  let u;
  e[10] !== r ? (u = /* @__PURE__ */ x(ty, { count: r }), e[10] = r, e[11] = u) : u = e[11];
  let d;
  e[12] !== n ? (d = /* @__PURE__ */ x(Vr, { size: "md", as: "h3", children: n }), e[12] = n, e[13] = d) : d = e[13];
  const f = ey[i], p = Jv[i];
  let g;
  e[14] !== f || e[15] !== p ? (g = /* @__PURE__ */ x(er, { tone: f, icon: "priority", label: p }), e[14] = f, e[15] = p, e[16] = g) : g = e[16];
  let m;
  e[17] !== u || e[18] !== d || e[19] !== g ? (m = /* @__PURE__ */ j(tr, { gap: 12, align: "center", wrap: "nowrap", children: [
    u,
    d,
    g
  ] }), e[17] = u, e[18] = d, e[19] = g, e[20] = m) : m = e[20];
  let h;
  e[21] !== o || e[22] !== s ? (h = /* @__PURE__ */ x("div", { className: "hidden sm:block", children: /* @__PURE__ */ x(Hn, { variant: "outline", size: "sm", onClick: s, children: o }) }), e[21] = o, e[22] = s, e[23] = h) : h = e[23];
  let b;
  e[24] !== m || e[25] !== h ? (b = /* @__PURE__ */ x("div", { className: "w-full", children: /* @__PURE__ */ j(tr, { justify: "between", align: "center", wrap: "nowrap", children: [
    m,
    h
  ] }) }), e[24] = m, e[25] = h, e[26] = b) : b = e[26];
  let w;
  return e[27] !== a || e[28] !== c || e[29] !== b ? (w = /* @__PURE__ */ x(Pa, { ...a, padding: "compact", style: c, children: b }), e[27] = a, e[28] = c, e[29] = b, e[30] = w) : w = e[30], w;
}
const ny = {
  positive: "text-positive",
  negative: "text-negative"
}, oy = "text-text-subtle";
function gm(t) {
  const e = J.c(16), {
    label: n,
    showIcon: o
  } = t, r = o === void 0 ? !0 : o, {
    value: s
  } = t, i = s === void 0, a = !i && (!("tone" in t) || t.tone === void 0), l = i || a;
  let c = oy, u = "trend-no-change", d = "sm";
  !l && t.tone && t.direction && (c = ny[t.tone], u = t.direction === "up" ? "trend-up" : "trend-down", d = "md");
  const f = `inline-flex items-center gap-(--spacing-4) ${c}`;
  let p;
  e[0] !== u || e[1] !== d || e[2] !== i || e[3] !== r ? (p = r ? i ? /* @__PURE__ */ x("span", { className: "inline-block w-(--icon-sm) text-center font-(family-name:--font-family-title) font-(number:--font-weight-semibold) text-(length:--font-size-title-inter-xsmall) leading-(--font-line-height-20)", children: "--" }) : /* @__PURE__ */ x(Ye, { name: u, size: d, tone: "inherit" }) : null, e[0] = u, e[1] = d, e[2] = i, e[3] = r, e[4] = p) : p = e[4];
  let g;
  e[5] !== s ? (g = s ? /* @__PURE__ */ x("span", { className: "font-(family-name:--font-family-title) font-(number:--font-weight-semibold) text-(length:--font-size-title-inter-xsmall) leading-(--font-line-height-20)", children: s }) : null, e[5] = s, e[6] = g) : g = e[6];
  let m;
  e[7] !== f || e[8] !== p || e[9] !== g ? (m = /* @__PURE__ */ j("span", { className: f, children: [
    p,
    g
  ] }), e[7] = f, e[8] = p, e[9] = g, e[10] = m) : m = e[10];
  let h;
  e[11] !== n ? (h = /* @__PURE__ */ x("span", { className: "font-(family-name:--font-family-title) font-(number:--font-weight-medium) text-(length:--font-size-title-inter-xsmall) leading-(--font-line-height-20) text-text-subtext", children: n }), e[11] = n, e[12] = h) : h = e[12];
  let b;
  return e[13] !== m || e[14] !== h ? (b = /* @__PURE__ */ j("div", { className: "inline-flex items-center gap-(--spacing-4)", children: [
    m,
    h
  ] }), e[13] = m, e[14] = h, e[15] = b) : b = e[15], b;
}
const ry = ye(["font-(family-name:--font-family-body)", "font-(number:--font-weight-semibold)", "text-(length:--font-size-title-inter-large)", "leading-(--font-line-height-20)", "tracking-(--font-letter-spacing-default)"], {
  variants: {
    tone: {
      neutral: "text-text-default",
      positive: "text-positive",
      warning: "text-accessibility-warning",
      negative: "text-negative"
    }
  },
  defaultVariants: {
    tone: "positive"
  }
});
function sy(t) {
  const e = J.c(5), {
    value: n,
    tone: o
  } = t;
  let r;
  e[0] !== o ? (r = ry({
    tone: o
  }), e[0] = o, e[1] = r) : r = e[1];
  let s;
  return e[2] !== r || e[3] !== n ? (s = /* @__PURE__ */ x("span", { className: r, children: n }), e[2] = r, e[3] = n, e[4] = s) : s = e[4], s;
}
function eN(t) {
  const e = J.c(26);
  let n, o, r, s, i, a;
  e[0] !== t ? ({
    label: o,
    value: a,
    tone: s,
    detail: n,
    trend: i,
    ...r
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r, e[4] = s, e[5] = i, e[6] = a) : (n = e[1], o = e[2], r = e[3], s = e[4], i = e[5], a = e[6]);
  let l;
  e[7] !== n ? (l = n ? /* @__PURE__ */ j("span", { className: "font-(number:--font-weight-semibold) text-(length:--font-size-label-small) leading-(--font-line-height-16) text-text-subtle", children: [
    " ",
    n
  ] }) : null, e[7] = n, e[8] = l) : l = e[8];
  let c;
  e[9] !== o || e[10] !== l ? (c = /* @__PURE__ */ j(Vr, { size: "sm", as: "h3", children: [
    o,
    l
  ] }), e[9] = o, e[10] = l, e[11] = c) : c = e[11];
  let u;
  e[12] !== s || e[13] !== a ? (u = /* @__PURE__ */ x(sy, { value: a, tone: s }), e[12] = s, e[13] = a, e[14] = u) : u = e[14];
  let d;
  e[15] !== c || e[16] !== u ? (d = /* @__PURE__ */ j(tr, { justify: "between", align: "center", wrap: "nowrap", children: [
    c,
    u
  ] }), e[15] = c, e[16] = u, e[17] = d) : d = e[17];
  let f;
  e[18] !== i ? (f = i ? /* @__PURE__ */ x(gm, { ...i }) : null, e[18] = i, e[19] = f) : f = e[19];
  let p;
  e[20] !== d || e[21] !== f ? (p = /* @__PURE__ */ x("div", { className: "w-full", children: /* @__PURE__ */ j(vs, { gap: 8, children: [
    d,
    f
  ] }) }), e[20] = d, e[21] = f, e[22] = p) : p = e[22];
  let g;
  return e[23] !== r || e[24] !== p ? (g = /* @__PURE__ */ x(Pa, { ...r, padding: "compact", children: p }), e[23] = r, e[24] = p, e[25] = g) : g = e[25], g;
}
const iy = ye(["inline-flex", "items-center", "justify-center", "shrink-0", "rounded-(--radius-sm)", "border", "border-solid", "cursor-pointer", "select-none", "transition-colors", "duration-200", "ease-in-out", "outline-none", "[&_svg]:pointer-events-none", "[&_svg]:shrink-0"], {
  variants: {
    variant: {
      primary: ["bg-button-primary-default-background", "text-button-primary-default-text", "border-button-primary-default-background", "hover:bg-button-primary-hover-background", "hover:border-button-primary-hover-background", "active:bg-button-primary-pressed-background", "active:border-button-primary-pressed-background", "focus-visible:ring-2", "focus-visible:ring-offset-1", "focus-visible:ring-offset-surface", "focus-visible:ring-button-focus-ring"],
      outline: ["bg-button-outline-default-background", "text-button-outline-default-text", "border-button-outline-default-border", "hover:bg-button-outline-hover-background", "hover:border-button-outline-hover-border", "active:bg-button-outline-pressed-background", "active:border-button-outline-pressed-border", "data-[mouse-down]:bg-button-outline-pressed-background", "data-[mouse-down]:border-button-outline-pressed-border", "focus-visible:ring-2", "focus-visible:ring-offset-1", "focus-visible:ring-offset-surface", "focus-visible:ring-button-focus-ring"],
      ghost: ["bg-transparent", "text-button-ghost-default-text", "border-transparent", "hover:bg-button-ghost-hover-background", "active:bg-button-ghost-pressed-background", "focus-visible:ring-2", "focus-visible:ring-offset-1", "focus-visible:ring-offset-surface", "focus-visible:ring-button-focus-ring"],
      info: ["bg-button-info-default-background", "text-button-info-default-text", "border-button-info-default-background", "hover:bg-button-info-hover-background", "hover:border-button-info-hover-background", "active:bg-button-info-pressed-background", "active:border-button-info-pressed-background", "focus-visible:ring-2", "focus-visible:ring-offset-1", "focus-visible:ring-offset-surface", "focus-visible:ring-button-focus-ring"]
    },
    intent: {
      default: null,
      destructive: null
    },
    size: {
      sm: ["size-(--spacing-32)"],
      md: ["size-(--spacing-40)"]
    }
  },
  compoundVariants: [{
    variant: "primary",
    intent: "destructive",
    class: ["bg-button-primary-destructive-default-background", "text-button-primary-destructive-text", "border-button-primary-destructive-default-background", "hover:bg-button-primary-destructive-hover-background", "hover:border-button-primary-destructive-hover-background", "active:bg-button-primary-destructive-pressed-background", "active:border-button-primary-destructive-pressed-background"]
  }, {
    variant: "ghost",
    intent: "destructive",
    class: ["text-text-destructive"]
  }],
  defaultVariants: {
    variant: "primary",
    intent: "default",
    size: "md"
  }
});
function Kt(t) {
  const e = J.c(28);
  let n, o, r, s, i, a, l;
  e[0] !== t ? ({
    icon: n,
    variant: l,
    intent: o,
    size: s,
    loading: i,
    disabled: a,
    ...r
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r, e[4] = s, e[5] = i, e[6] = a, e[7] = l) : (n = e[1], o = e[2], r = e[3], s = e[4], i = e[5], a = e[6], l = e[7]);
  const c = i === void 0 ? !1 : i, u = a === void 0 ? !1 : a, d = u || c;
  let f;
  e[8] !== u || e[9] !== o || e[10] !== d || e[11] !== c || e[12] !== s || e[13] !== l ? (f = le(iy({
    variant: l,
    intent: o,
    size: s
  }), d && "opacity-40 pointer-events-none", u && "cursor-not-allowed", c && !u && "cursor-default"), e[8] = u, e[9] = o, e[10] = d, e[11] = c, e[12] = s, e[13] = l, e[14] = f) : f = e[14];
  const p = d || void 0, g = c || void 0, m = d ? -1 : void 0;
  let h;
  e[15] !== n || e[16] !== c ? (h = c ? /* @__PURE__ */ x($c, { size: "sm" }) : /* @__PURE__ */ x(Ye, { name: n, size: "sm", tone: "inherit" }), e[15] = n, e[16] = c, e[17] = h) : h = e[17];
  let b;
  return e[18] !== d || e[19] !== r || e[20] !== s || e[21] !== f || e[22] !== p || e[23] !== g || e[24] !== m || e[25] !== h || e[26] !== l ? (b = /* @__PURE__ */ x(Un, { "data-slot": "icon-button", "data-variant": l, "data-size": s, className: f, disabled: d, "aria-disabled": p, "aria-busy": g, tabIndex: m, ...r, children: h }), e[18] = d, e[19] = r, e[20] = s, e[21] = f, e[22] = p, e[23] = g, e[24] = m, e[25] = h, e[26] = l, e[27] = b) : b = e[27], b;
}
const ay = {
  urgent: "negative",
  high: "warning",
  medium: "informative"
}, ly = ye(["font-(family-name:--font-family-headline)", "font-(number:--font-weight-semibold)", "text-(length:--font-size-headline-large)", "leading-(--font-line-height-40)", "tracking-(--font-letter-spacing-default)"], {
  variants: {
    tone: {
      neutral: "text-text-default",
      positive: "text-positive",
      negative: "text-negative"
    }
  },
  defaultVariants: {
    tone: "neutral"
  }
});
function cy(t) {
  const e = J.c(5), {
    value: n,
    tone: o
  } = t, r = o === void 0 ? "neutral" : o;
  let s;
  e[0] !== r ? (s = ly({
    tone: r
  }), e[0] = r, e[1] = s) : s = e[1];
  let i;
  return e[2] !== s || e[3] !== n ? (i = /* @__PURE__ */ x("span", { className: s, children: n }), e[2] = s, e[3] = n, e[4] = i) : i = e[4], i;
}
function tN(t) {
  const e = J.c(34);
  let n, o, r, s, i, a, l, c, u;
  e[0] !== t ? ({
    label: o,
    value: u,
    tone: a,
    trend: c,
    actionLabel: n,
    onActionClick: r,
    priority: s,
    fillHeight: l,
    ...i
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r, e[4] = s, e[5] = i, e[6] = a, e[7] = l, e[8] = c, e[9] = u) : (n = e[1], o = e[2], r = e[3], s = e[4], i = e[5], a = e[6], l = e[7], c = e[8], u = e[9]);
  const d = a === void 0 ? "neutral" : a, f = l === void 0 ? !1 : l;
  let p;
  e[10] !== o ? (p = /* @__PURE__ */ x(Vr, { size: "md", as: "h3", children: o }), e[10] = o, e[11] = p) : p = e[11];
  let g;
  e[12] !== n || e[13] !== r || e[14] !== s ? (g = r ? /* @__PURE__ */ x(Kt, { variant: "outline", size: "sm", icon: "arrow-up-right", "aria-label": n, onClick: r }) : s ? /* @__PURE__ */ x(Ye, { name: "priority", size: "sm", tone: ay[s] }) : null, e[12] = n, e[13] = r, e[14] = s, e[15] = g) : g = e[15];
  let m;
  e[16] !== p || e[17] !== g ? (m = /* @__PURE__ */ j(tr, { justify: "between", align: "start", wrap: "nowrap", children: [
    p,
    g
  ] }), e[16] = p, e[17] = g, e[18] = m) : m = e[18];
  let h;
  e[19] !== d || e[20] !== u ? (h = /* @__PURE__ */ x(cy, { value: u, tone: d }), e[19] = d, e[20] = u, e[21] = h) : h = e[21];
  let b;
  e[22] !== c ? (b = c ? /* @__PURE__ */ x(gm, { ...c }) : null, e[22] = c, e[23] = b) : b = e[23];
  let w;
  e[24] !== h || e[25] !== b ? (w = /* @__PURE__ */ j(vs, { gap: 4, children: [
    h,
    b
  ] }), e[24] = h, e[25] = b, e[26] = w) : w = e[26];
  let y;
  e[27] !== m || e[28] !== w ? (y = /* @__PURE__ */ x("div", { className: "w-full", children: /* @__PURE__ */ j(vs, { gap: 12, children: [
    m,
    w
  ] }) }), e[27] = m, e[28] = w, e[29] = y) : y = e[29];
  let C;
  return e[30] !== f || e[31] !== i || e[32] !== y ? (C = /* @__PURE__ */ x(Pa, { fillHeight: f, ...i, children: y }), e[30] = f, e[31] = i, e[32] = y, e[33] = C) : C = e[33], C;
}
function nN(t) {
  const e = J.c(33);
  let n;
  e[0] !== t.chipLabel || e[1] !== t.mpCount || e[2] !== t.variant ? (n = t.variant === "add" ? /* @__PURE__ */ x(er, { tone: "informative", label: t.chipLabel ?? "Recommended" }) : t.mpCount != null ? /* @__PURE__ */ x(er, { tone: "neutral", label: t.mpCount === 1 ? "1 MP" : `${t.mpCount} MPs` }) : null, e[0] = t.chipLabel, e[1] = t.mpCount, e[2] = t.variant, e[3] = n) : n = e[3];
  const o = n;
  let r, s, i, a, l, c;
  if (e[4] !== t) {
    const {
      serviceName: C,
      icon: R,
      variant: S,
      chipLabel: E,
      mpCount: P,
      showIcon: N,
      style: I,
      ...M
    } = t;
    i = C, s = R, l = S, c = N, a = I, r = M, e[4] = t, e[5] = r, e[6] = s, e[7] = i, e[8] = a, e[9] = l, e[10] = c;
  } else
    r = e[5], s = e[6], i = e[7], a = e[8], l = e[9], c = e[10];
  const u = l === void 0 ? "default" : l, d = c === void 0 ? !0 : c;
  let f;
  e[11] !== a ? (f = {
    width: "100%",
    ...a
  }, e[11] = a, e[12] = f) : f = e[12];
  let p;
  e[13] !== s ? (p = /* @__PURE__ */ x(Ye, { name: s, size: "sm", tone: "neutral", "aria-hidden": !0 }), e[13] = s, e[14] = p) : p = e[14];
  let g;
  e[15] !== i ? (g = /* @__PURE__ */ x(Vr, { size: "sm", as: "h3", children: i }), e[15] = i, e[16] = g) : g = e[16];
  let m;
  e[17] !== p || e[18] !== g ? (m = /* @__PURE__ */ j("div", { className: "flex min-w-0 flex-1 items-start gap-(--spacing-4)", children: [
    p,
    g
  ] }), e[17] = p, e[18] = g, e[19] = m) : m = e[19];
  let h;
  e[20] !== m || e[21] !== o ? (h = /* @__PURE__ */ j(tr, { gap: 8, justify: "between", wrap: "wrap", align: "start", children: [
    m,
    o
  ] }), e[20] = m, e[21] = o, e[22] = h) : h = e[22];
  let b;
  e[23] !== u || e[24] !== d ? (b = u === "add" ? /* @__PURE__ */ j("div", { className: "flex w-full items-center justify-center gap-(--spacing-10) border border-dashed border-outline-subtle bg-surface py-(--spacing-6)", children: [
    d ? /* @__PURE__ */ x(Ye, { name: "marketplace", size: "md", tone: "neutral", "aria-hidden": !0 }) : null,
    /* @__PURE__ */ x("span", { className: "font-(family-name:--font-family-title) font-(number:--font-weight-medium) text-(length:--font-size-title-inter-xsmall) leading-(--font-line-height-24) text-text-default", children: "Add" })
  ] }) : null, e[23] = u, e[24] = d, e[25] = b) : b = e[25];
  let w;
  e[26] !== h || e[27] !== b ? (w = /* @__PURE__ */ x("div", { className: "w-full", children: /* @__PURE__ */ j(vs, { gap: 12, children: [
    h,
    b
  ] }) }), e[26] = h, e[27] = b, e[28] = w) : w = e[28];
  let y;
  return e[29] !== r || e[30] !== f || e[31] !== w ? (y = /* @__PURE__ */ x(Pa, { ...r, padding: "compact", style: f, children: w }), e[29] = r, e[30] = f, e[31] = w, e[32] = y) : y = e[32], y;
}
const uy = ye(["w-full", "flex", "items-start", "justify-between", "gap-(--spacing-24)", "p-(--spacing-12)", "rounded-(--radius-sm)"], {
  variants: {
    tone: {
      neutral: ["bg-surface-container-low", "text-surface-on-surface"],
      positive: ["bg-positive-container", "text-positive-on-container"],
      warning: ["bg-accessibility-warning-container", "text-warning-on-container"],
      negative: ["bg-negative-container", "text-negative-on-container"],
      informative: ["bg-informative-container", "text-informative-on-container"]
    }
  },
  defaultVariants: {
    tone: "neutral"
  }
}), dy = {
  neutral: "circle-info",
  informative: "circle-info",
  positive: "circle-check",
  warning: "warning",
  negative: "warning"
};
function Nf(t) {
  const e = J.c(33);
  let n, o, r, s, i, a;
  e[0] !== t ? ({
    tone: i,
    title: a,
    subtext: s,
    action: n,
    onDismiss: o,
    ...r
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r, e[4] = s, e[5] = i, e[6] = a) : (n = e[1], o = e[2], r = e[3], s = e[4], i = e[5], a = e[6]);
  const l = i === void 0 ? "neutral" : i, c = l === "negative", u = !!(n || o), d = c ? "alert" : "note", f = c ? "assertive" : void 0;
  let p;
  e[7] !== l ? (p = le(uy({
    tone: l
  })), e[7] = l, e[8] = p) : p = e[8];
  const g = dy[l];
  let m;
  e[9] !== g ? (m = /* @__PURE__ */ x(Ye, { name: g, size: "md", tone: "inherit" }), e[9] = g, e[10] = m) : m = e[10];
  let h;
  e[11] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (h = {
    color: "inherit"
  }, e[11] = h) : h = e[11];
  let b;
  e[12] !== a ? (b = /* @__PURE__ */ x(Vr, { as: "span", size: "sm", style: h, children: a }), e[12] = a, e[13] = b) : b = e[13];
  let w;
  e[14] !== s ? (w = s ? /* @__PURE__ */ x(ys, { as: "span", size: "sm", style: {
    color: "inherit"
  }, children: s }) : null, e[14] = s, e[15] = w) : w = e[15];
  let y;
  e[16] !== b || e[17] !== w ? (y = /* @__PURE__ */ j("div", { className: "flex flex-col gap-(--spacing-8) min-w-0", children: [
    b,
    w
  ] }), e[16] = b, e[17] = w, e[18] = y) : y = e[18];
  let C;
  e[19] !== y || e[20] !== m ? (C = /* @__PURE__ */ j("div", { className: "flex flex-1 items-start gap-(--spacing-8) min-w-0", children: [
    m,
    y
  ] }), e[19] = y, e[20] = m, e[21] = C) : C = e[21];
  let R;
  e[22] !== n || e[23] !== u || e[24] !== o ? (R = u ? /* @__PURE__ */ j("div", { className: "flex shrink-0 items-start gap-(--spacing-8)", children: [
    n,
    o ? /* @__PURE__ */ x(Kt, { icon: "x-close", "aria-label": "Dismiss alert", variant: "ghost", size: "sm", onClick: o }) : null
  ] }) : null, e[22] = n, e[23] = u, e[24] = o, e[25] = R) : R = e[25];
  let S;
  return e[26] !== r || e[27] !== C || e[28] !== R || e[29] !== d || e[30] !== f || e[31] !== p ? (S = /* @__PURE__ */ j("div", { role: d, "aria-live": f, className: p, ...r, children: [
    C,
    R
  ] }), e[26] = r, e[27] = C, e[28] = R, e[29] = d, e[30] = f, e[31] = p, e[32] = S) : S = e[32], S;
}
function fy(t) {
  const e = J.c(14), {
    stableCount: n,
    watchingCount: o,
    maintenanceCount: r
  } = t, s = n + o + r;
  if (s === 0) {
    let p;
    return e[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (p = /* @__PURE__ */ x("div", { "aria-hidden": "true", "data-testid": "asset-status-bar", className: "h-(--spacing-8) w-full rounded-(--radius-none) bg-surface-inverse-surface/20" }), e[0] = p) : p = e[0], p;
  }
  const i = n / s * 100, a = o / s * 100, l = r / s * 100;
  let c;
  e[1] !== n || e[2] !== i ? (c = n > 0 && /* @__PURE__ */ x("div", { "data-testid": "asset-status-bar-stable", className: "h-full rounded-(--radius-none) bg-datavis-crit-green", style: {
    width: `${i}%`
  } }), e[1] = n, e[2] = i, e[3] = c) : c = e[3];
  let u;
  e[4] !== o || e[5] !== a ? (u = o > 0 && /* @__PURE__ */ x("div", { "data-testid": "asset-status-bar-watching", className: "h-full rounded-(--radius-none) bg-datavis-crit-yellow", style: {
    width: `${a}%`
  } }), e[4] = o, e[5] = a, e[6] = u) : u = e[6];
  let d;
  e[7] !== r || e[8] !== l ? (d = r > 0 && /* @__PURE__ */ x("div", { "data-testid": "asset-status-bar-maintenance", className: "h-full rounded-(--radius-none) bg-datavis-crit-red", style: {
    width: `${l}%`
  } }), e[7] = r, e[8] = l, e[9] = d) : d = e[9];
  let f;
  return e[10] !== c || e[11] !== u || e[12] !== d ? (f = /* @__PURE__ */ j("div", { "aria-hidden": "true", "data-testid": "asset-status-bar", className: "flex h-(--spacing-8) w-full gap-(--spacing-6)", children: [
    c,
    u,
    d
  ] }), e[10] = c, e[11] = u, e[12] = d, e[13] = f) : f = e[13], f;
}
const Ui = 6, py = 4;
function gy(t) {
  return py / (2 * Math.PI * t) * 360;
}
function If(t, e, n, o) {
  const r = (o - 90) * Math.PI / 180;
  return {
    x: t + n * Math.cos(r),
    y: e + n * Math.sin(r)
  };
}
function my(t, e, n, o, r) {
  const s = If(t, e, n, r), i = If(t, e, n, o), a = r - o > 180 ? 1 : 0;
  return `M ${s.x} ${s.y} A ${n} ${n} 0 ${a} 0 ${i.x} ${i.y}`;
}
const hy = ["Stable", "Watching", "Maintenance Recommended"], by = ["stroke-datavis-crit-green", "stroke-datavis-crit-yellow", "stroke-datavis-crit-red"];
function vy(t) {
  const e = J.c(51), {
    size: n,
    unit: o,
    stableCount: r,
    watchingCount: s,
    maintenanceCount: i
  } = t, a = n / 2, l = n / 2, c = (n - Ui) / 2, u = r + s + i, d = u === 0;
  let f;
  e[0] !== d || e[1] !== u ? (f = d ? "--" : u >= 1e4 ? `${Math.round(u / 1e3)}k` : String(u), e[0] = d, e[1] = u, e[2] = f) : f = e[2];
  const p = f, g = n >= 80 ? "var(--font-size-title-inter-xlarge)" : "var(--font-size-title-inter-small)", m = n >= 80 ? "var(--font-size-title-inter-small)" : "var(--font-size-title-inter-xsmall)", h = l - 4;
  let b;
  e[3] !== p || e[4] !== g || e[5] !== a || e[6] !== h ? (b = /* @__PURE__ */ x("text", { x: a, y: h, textAnchor: "middle", dominantBaseline: "auto", fontFamily: "var(--font-family-title)", fontWeight: "var(--font-weight-medium)", fontSize: g, className: "fill-text-default", "data-testid": "asset-status-donut-count", children: p }), e[3] = p, e[4] = g, e[5] = a, e[6] = h, e[7] = b) : b = e[7];
  const w = l + 4;
  let y;
  e[8] !== a || e[9] !== w || e[10] !== o || e[11] !== m ? (y = /* @__PURE__ */ x("text", { x: a, y: w, textAnchor: "middle", dominantBaseline: "hanging", fontFamily: "var(--font-family-title)", fontWeight: "var(--font-weight-medium)", fontSize: m, className: "fill-text-subtext", "data-testid": "asset-status-donut-unit", children: o }), e[8] = a, e[9] = w, e[10] = o, e[11] = m, e[12] = y) : y = e[12];
  let C;
  e[13] !== b || e[14] !== y ? (C = /* @__PURE__ */ j(_o, { children: [
    b,
    y
  ] }), e[13] = b, e[14] = y, e[15] = C) : C = e[15];
  const R = C;
  if (d) {
    let V;
    e[16] !== a || e[17] !== l || e[18] !== c ? (V = /* @__PURE__ */ x("circle", { cx: a, cy: l, r: c, fill: "none", className: "stroke-surface-inverse-surface/20", strokeWidth: Ui }), e[16] = a, e[17] = l, e[18] = c, e[19] = V) : V = e[19];
    let _;
    return e[20] !== R || e[21] !== n || e[22] !== V ? (_ = /* @__PURE__ */ j("svg", { width: n, height: n, role: "img", "aria-label": "No asset status data available", "data-testid": "asset-status-donut", children: [
      V,
      R
    ] }), e[20] = R, e[21] = n, e[22] = V, e[23] = _) : _ = e[23], _;
  }
  let S;
  e[24] !== i || e[25] !== r || e[26] !== s ? (S = [r, s, i].map(wy).filter(xy), e[24] = i, e[25] = r, e[26] = s, e[27] = S) : S = e[27];
  const E = S;
  let P;
  e[28] !== c || e[29] !== E.length ? (P = E.length > 1 ? gy(c) : 0, e[28] = c, e[29] = E.length, e[30] = P) : P = e[30];
  const N = P, M = 360 - E.length * N;
  let T;
  if (e[31] !== M || e[32] !== a || e[33] !== l || e[34] !== N || e[35] !== c || e[36] !== E || e[37] !== u) {
    T = [];
    let V = 0;
    for (const _ of E) {
      const A = _.count / u * M;
      T.push({
        path: my(a, l, c, V, V + A),
        strokeClassName: _.strokeClassName,
        label: `${_.label}: ${_.count}`
      }), V = V + (A + N);
    }
    e[31] = M, e[32] = a, e[33] = l, e[34] = N, e[35] = c, e[36] = E, e[37] = u, e[38] = T;
  } else
    T = e[38];
  const k = `Asset status: ${r} stable, ${s} watching, ${i} maintenance`;
  let D;
  e[39] !== T || e[40] !== a || e[41] !== l || e[42] !== c || e[43] !== E[0] || e[44] !== E.length ? (D = E.length === 1 ? /* @__PURE__ */ x("circle", { cx: a, cy: l, r: c, fill: "none", className: E[0].strokeClassName, strokeWidth: Ui, "aria-label": `${E[0].label}: ${E[0].count}`, "data-testid": "asset-status-donut-segment" }) : T.map(yy), e[39] = T, e[40] = a, e[41] = l, e[42] = c, e[43] = E[0], e[44] = E.length, e[45] = D) : D = e[45];
  let O;
  return e[46] !== R || e[47] !== n || e[48] !== D || e[49] !== k ? (O = /* @__PURE__ */ j("svg", { width: n, height: n, role: "img", "aria-label": k, "data-testid": "asset-status-donut", children: [
    D,
    R
  ] }), e[46] = R, e[47] = n, e[48] = D, e[49] = k, e[50] = O) : O = e[50], O;
}
function yy(t) {
  return /* @__PURE__ */ x("path", { d: t.path, fill: "none", className: t.strokeClassName, strokeWidth: Ui, "aria-label": t.label, "data-testid": "asset-status-donut-segment" }, t.label);
}
function xy(t) {
  return t.count > 0;
}
function wy(t, e) {
  return {
    count: t,
    strokeClassName: by[e],
    label: hy[e]
  };
}
const Cy = {
  md: "var(--font-size-title-inter-small)",
  sm: "var(--font-size-title-inter-xsmall)"
};
function hl(t) {
  const e = J.c(20), {
    size: n,
    icon: o,
    iconColor: r,
    chipTone: s,
    label: i,
    count: a
  } = t;
  let l;
  e[0] !== o ? (l = /* @__PURE__ */ x(Ye, { name: o, size: "xs", tone: "inherit" }), e[0] = o, e[1] = l) : l = e[1];
  let c;
  e[2] !== r || e[3] !== l ? (c = /* @__PURE__ */ x("span", { className: r, "aria-hidden": "true", children: l }), e[2] = r, e[3] = l, e[4] = c) : c = e[4];
  const u = Cy[n];
  let d;
  e[5] !== u ? (d = {
    fontSize: u
  }, e[5] = u, e[6] = d) : d = e[6];
  let f;
  e[7] !== i || e[8] !== d ? (f = /* @__PURE__ */ x("span", { className: "truncate font-(family-name:--font-family-title) font-(number:--font-weight-medium) leading-(--font-line-height-24) text-text-default", style: d, children: i }), e[7] = i, e[8] = d, e[9] = f) : f = e[9];
  let p;
  e[10] !== c || e[11] !== f ? (p = /* @__PURE__ */ j("div", { className: "flex items-center gap-(--spacing-6) min-w-0", children: [
    c,
    f
  ] }), e[10] = c, e[11] = f, e[12] = p) : p = e[12];
  const g = n === "md" ? o : void 0;
  let m;
  e[13] !== s || e[14] !== a || e[15] !== g ? (m = /* @__PURE__ */ x(er, { tone: s, icon: g, label: a }), e[13] = s, e[14] = a, e[15] = g, e[16] = m) : m = e[16];
  let h;
  return e[17] !== p || e[18] !== m ? (h = /* @__PURE__ */ j("div", { className: "grid w-full grid-cols-[minmax(0,1fr)_max-content] items-center gap-(--spacing-8)", "data-testid": "asset-status-key-row", children: [
    p,
    m
  ] }), e[17] = p, e[18] = m, e[19] = h) : h = e[19], h;
}
function Mf(t) {
  const e = J.c(19), {
    labels: n,
    size: o,
    stableCount: r,
    watchingCount: s,
    maintenanceCount: i
  } = t;
  let a;
  e[0] !== n ? (a = n === void 0 ? {
    stable: "Stable",
    watching: "Watching",
    maintenance: "Maintenance Recommended"
  } : n, e[0] = n, e[1] = a) : a = e[1];
  const l = a, u = `flex w-full min-w-0 flex-col ${o === "md" ? "gap-(--spacing-6)" : "gap-(--spacing-4)"}`;
  let d;
  e[2] !== l.stable || e[3] !== o || e[4] !== r ? (d = /* @__PURE__ */ x(hl, { size: o, icon: "circle-check", iconColor: "text-datavis-crit-green", chipTone: "positive", label: l.stable, count: r }), e[2] = l.stable, e[3] = o, e[4] = r, e[5] = d) : d = e[5];
  let f;
  e[6] !== l.watching || e[7] !== o || e[8] !== s ? (f = /* @__PURE__ */ x(hl, { size: o, icon: "eye-watching", iconColor: "text-datavis-crit-yellow", chipTone: "warning", label: l.watching, count: s }), e[6] = l.watching, e[7] = o, e[8] = s, e[9] = f) : f = e[9];
  let p;
  e[10] !== l.maintenance || e[11] !== i || e[12] !== o ? (p = /* @__PURE__ */ x(hl, { size: o, icon: "maintenance", iconColor: "text-datavis-crit-red", chipTone: "negative", label: l.maintenance, count: i }), e[10] = l.maintenance, e[11] = i, e[12] = o, e[13] = p) : p = e[13];
  let g;
  return e[14] !== u || e[15] !== d || e[16] !== f || e[17] !== p ? (g = /* @__PURE__ */ j("div", { className: u, "data-testid": "asset-status-key", children: [
    d,
    f,
    p
  ] }), e[14] = u, e[15] = d, e[16] = f, e[17] = p, e[18] = g) : g = e[18], g;
}
const Sy = {
  md: 88,
  sm: 80
};
function Ry({
  stableCount: t,
  watchingCount: e,
  maintenanceCount: n
}) {
  const o = [t < 0 ? "stableCount" : null, e < 0 ? "watchingCount" : null, n < 0 ? "maintenanceCount" : null].filter((r) => r !== null);
  if (o.length > 0)
    throw new RangeError(`AssetStatusCard counts cannot be negative: ${o.join(", ")}`);
}
function Ey(t) {
  return t.borderBoxSize[0]?.inlineSize ?? t.contentRect.width;
}
function oN(t) {
  const e = J.c(20), {
    variant: n,
    unit: o,
    stableCount: r,
    watchingCount: s,
    maintenanceCount: i,
    labels: a
  } = t;
  Ry({
    stableCount: r,
    watchingCount: s,
    maintenanceCount: i
  });
  const l = kt(null), [c, u] = Mt("md"), d = n === "donut", f = r + s + i, p = f === 0, g = d ? "p-(--spacing-12)" : "p-(--spacing-20)";
  let m, h;
  e[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (m = () => {
    const R = l.current;
    if (!R || typeof ResizeObserver > "u")
      return;
    const S = (P) => {
      u(P <= 380 ? "sm" : "md");
    };
    S(R.getBoundingClientRect().width);
    const E = new ResizeObserver((P) => {
      const [N] = P;
      N && S(Ey(N));
    });
    return E.observe(R), () => {
      E.disconnect();
    };
  }, h = [], e[0] = m, e[1] = h) : (m = e[0], h = e[1]), rr(m, h);
  const b = `flex h-full w-full min-w-0 flex-col gap-(--spacing-16) rounded-(--radius-sm) border border-outline-subtle bg-surface shadow-elevation-1 ${g}`;
  let w;
  e[2] !== d || e[3] !== p || e[4] !== f || e[5] !== o ? (w = !d && /* @__PURE__ */ j("div", { className: "flex items-baseline gap-(--spacing-6)", "data-testid": "asset-status-card-header", children: [
    /* @__PURE__ */ x("span", { className: "font-(family-name:--font-family-title) font-(number:--font-weight-medium) text-(length:--font-size-title-inter-xlarge) leading-(--font-line-height-28) text-text-default", children: p ? "--" : f }),
    /* @__PURE__ */ x("span", { className: "font-(family-name:--font-family-title) font-(number:--font-weight-regular) text-(length:--font-size-title-inter-small) leading-(--font-line-height-24) text-text-subtext", children: o })
  ] }), e[2] = d, e[3] = p, e[4] = f, e[5] = o, e[6] = w) : w = e[6];
  let y;
  e[7] !== d || e[8] !== p || e[9] !== a || e[10] !== i || e[11] !== c || e[12] !== r || e[13] !== o || e[14] !== s ? (y = d ? /* @__PURE__ */ j("div", { className: "flex items-center gap-(--spacing-16)", "data-testid": "asset-status-card-body", children: [
    /* @__PURE__ */ x("div", { className: "shrink-0", children: /* @__PURE__ */ x(vy, { size: Sy[c], unit: o, stableCount: r, watchingCount: s, maintenanceCount: i }) }),
    p ? /* @__PURE__ */ x(Nf, { tone: "neutral", title: "No available asset status data. Check back later." }) : /* @__PURE__ */ x(Mf, { labels: a, size: c, stableCount: r, watchingCount: s, maintenanceCount: i })
  ] }) : /* @__PURE__ */ j("div", { className: "flex flex-col gap-(--spacing-16)", "data-testid": "asset-status-card-body", children: [
    /* @__PURE__ */ x(fy, { stableCount: r, watchingCount: s, maintenanceCount: i }),
    p ? /* @__PURE__ */ x(Nf, { tone: "neutral", title: "No available asset status data. Check back later." }) : /* @__PURE__ */ x(Mf, { labels: a, size: c, stableCount: r, watchingCount: s, maintenanceCount: i })
  ] }), e[7] = d, e[8] = p, e[9] = a, e[10] = i, e[11] = c, e[12] = r, e[13] = o, e[14] = s, e[15] = y) : y = e[15];
  let C;
  return e[16] !== b || e[17] !== w || e[18] !== y ? (C = /* @__PURE__ */ j("div", { ref: l, "data-testid": "asset-status-card", className: b, children: [
    w,
    y
  ] }), e[16] = b, e[17] = w, e[18] = y, e[19] = C) : C = e[19], C;
}
function sr(t) {
  const e = v.useRef(!0);
  e.current && (e.current = !1, t());
}
const Py = [];
function Ar(t) {
  v.useEffect(t, Py);
}
const es = 0;
class gn {
  static create() {
    return new gn();
  }
  currentId = es;
  /**
   * Executes `fn` after `delay`, clearing any previously scheduled call.
   */
  start(e, n) {
    this.clear(), this.currentId = setTimeout(() => {
      this.currentId = es, n();
    }, e);
  }
  isStarted() {
    return this.currentId !== es;
  }
  clear = () => {
    this.currentId !== es && (clearTimeout(this.currentId), this.currentId = es);
  };
  disposeEffect = () => this.clear;
}
function Vt() {
  const t = Pt(gn.create).current;
  return Ar(t.disposeEffect), t;
}
const ir = typeof navigator < "u", bl = Ny(), mm = My(), zc = Iy(), Hc = typeof CSS > "u" || !CSS.supports ? !1 : CSS.supports("-webkit-backdrop-filter:none"), hm = (
  // iPads can claim to be MacIntel
  bl.platform === "MacIntel" && bl.maxTouchPoints > 1 ? !0 : /iP(hone|ad|od)|iOS/.test(bl.platform)
), Tf = ir && /firefox/i.test(zc), bm = ir && /apple/i.test(navigator.vendor), xs = ir && /android/i.test(mm) || /android/i.test(zc), vm = ir && mm.toLowerCase().startsWith("mac") && !navigator.maxTouchPoints, ym = zc.includes("jsdom/");
function Ny() {
  if (!ir)
    return {
      platform: "",
      maxTouchPoints: -1
    };
  const t = navigator.userAgentData;
  return t?.platform ? {
    platform: t.platform,
    maxTouchPoints: navigator.maxTouchPoints
  } : {
    platform: navigator.platform ?? "",
    maxTouchPoints: navigator.maxTouchPoints ?? -1
  };
}
function Iy() {
  if (!ir)
    return "";
  const t = navigator.userAgentData;
  return t && Array.isArray(t.brands) ? t.brands.map(({
    brand: e,
    version: n
  }) => `${e}/${n}`).join(" ") : navigator.userAgent;
}
function My() {
  if (!ir)
    return "";
  const t = navigator.userAgentData;
  return t?.platform ? t.platform : navigator.platform ?? "";
}
function Ot(t) {
  t.preventDefault(), t.stopPropagation();
}
function Ty(t) {
  return "nativeEvent" in t;
}
function xm(t) {
  return t.pointerType === "" && t.isTrusted ? !0 : xs && t.pointerType ? t.type === "click" && t.buttons === 1 : t.detail === 0 && !t.pointerType;
}
function wm(t) {
  return ym ? !1 : !xs && t.width === 0 && t.height === 0 || xs && t.width === 1 && t.height === 1 && t.pressure === 0 && t.detail === 0 && t.pointerType === "mouse" || // iOS VoiceOver returns 0.333• for width/height.
  t.width < 1 && t.height < 1 && t.pressure === 0 && t.detail === 0 && t.pointerType === "touch";
}
function Or(t, e) {
  const n = ["mouse", "pen"];
  return e || n.push("", void 0), n.includes(t);
}
function Cm(t) {
  const e = t.type;
  return e === "click" || e === "mousedown" || e === "keydown" || e === "keyup";
}
function ky(t, e) {
  return e != null && !Or(e) ? 0 : typeof t == "function" ? t() : t;
}
function ta(t, e, n) {
  const o = ky(t, n);
  return typeof o == "number" ? o : o?.[e];
}
function kf(t) {
  return typeof t == "function" ? t() : t;
}
function Sm(t, e) {
  return e || t === "click" || t === "mousedown";
}
const Et = "none", Bn = "trigger-press", Dt = "trigger-hover", Qo = "trigger-focus", Vs = "outside-press", ko = "item-press", Rm = "close-press", Of = "clear-press", Oy = "chip-remove-press", wr = "input-change", Io = "input-clear", Em = "input-press", yo = "focus-out", ar = "escape-key", Dy = "close-watcher", Er = "list-navigation", _y = "pointer", Pm = "cancel-open", us = "sibling-open", Vy = "disabled", As = "imperative-action", mi = "swipe", Ay = "window-resize";
function Pe(t, e, n, o) {
  let r = !1, s = !1;
  const i = o ?? yt;
  return {
    reason: t,
    event: e ?? new Event("base-ui"),
    cancel() {
      r = !0;
    },
    allowPropagation() {
      s = !0;
    },
    get isCanceled() {
      return r;
    },
    get isPropagationAllowed() {
      return s;
    },
    trigger: n,
    ...i
  };
}
function ts(t, e, n) {
  const o = n ?? yt;
  return {
    reason: t,
    event: e ?? new Event("base-ui"),
    ...o
  };
}
const Bc = /* @__PURE__ */ v.createContext({
  hasProvider: !1,
  timeoutMs: 0,
  delayRef: {
    current: 0
  },
  initialDelayRef: {
    current: 0
  },
  timeout: new gn(),
  currentIdRef: {
    current: null
  },
  currentContextRef: {
    current: null
  }
});
process.env.NODE_ENV !== "production" && (Bc.displayName = "FloatingDelayGroupContext");
function Fy(t) {
  const {
    children: e,
    delay: n,
    timeoutMs: o = 0
  } = t, r = v.useRef(n), s = v.useRef(n), i = v.useRef(null), a = v.useRef(null), l = Vt();
  return /* @__PURE__ */ x(Bc.Provider, {
    value: v.useMemo(() => ({
      hasProvider: !0,
      delayRef: r,
      initialDelayRef: s,
      currentIdRef: i,
      timeoutMs: o,
      currentContextRef: a,
      timeout: l
    }), [o, l]),
    children: e
  });
}
function Ly(t, e = {
  open: !1
}) {
  const n = "rootStore" in t ? t.rootStore : t, o = n.useState("floatingId"), {
    open: r
  } = e, s = v.useContext(Bc), {
    currentIdRef: i,
    delayRef: a,
    timeoutMs: l,
    initialDelayRef: c,
    currentContextRef: u,
    hasProvider: d,
    timeout: f
  } = s, [p, g] = v.useState(!1);
  return xe(() => {
    function m() {
      g(!1), u.current?.setIsInstantPhase(!1), i.current = null, u.current = null, a.current = c.current;
    }
    if (i.current && !r && i.current === o) {
      if (g(!1), l) {
        const h = o;
        return f.start(l, () => {
          n.select("open") || i.current && i.current !== h || m();
        }), () => {
          f.clear();
        };
      }
      m();
    }
  }, [r, o, i, a, l, c, u, f, n]), xe(() => {
    if (!r)
      return;
    const m = u.current, h = i.current;
    f.clear(), u.current = {
      onOpenChange: n.setOpen,
      setIsInstantPhase: g
    }, i.current = o, a.current = {
      open: 0,
      close: ta(c.current, "close")
    }, h !== null && h !== o ? (g(!0), m?.setIsInstantPhase(!0), m?.onOpenChange(!1, Pe(Et))) : (g(!1), m?.setIsInstantPhase(!1));
  }, [r, o, n, i, a, l, c, u, f]), xe(() => () => {
    u.current = null;
  }, [u]), v.useMemo(() => ({
    hasProvider: d,
    delayRef: a,
    isInstantPhase: p
  }), [d, a, p]);
}
function rt(t, e, n, o) {
  return t.addEventListener(e, n, o), () => {
    t.removeEventListener(e, n, o);
  };
}
function $n(...t) {
  return () => {
    for (let e = 0; e < t.length; e += 1) {
      const n = t[e];
      n && n();
    }
  };
}
function _t(t) {
  const e = Pt($y, t).current;
  return e.next = t, xe(e.effect), e;
}
function $y(t) {
  const e = {
    current: t,
    next: t,
    effect: () => {
      e.current = e.next;
    }
  };
  return e;
}
const hi = null;
let Df = globalThis.requestAnimationFrame;
class zy {
  /* This implementation uses an array as a backing data-structure for frame callbacks.
   * It allows `O(1)` callback cancelling by inserting a `null` in the array, though it
   * never calls the native `cancelAnimationFrame` if there are no frames left. This can
   * be much more efficient if there is a call pattern that alterns as
   * "request-cancel-request-cancel-…".
   * But in the case of "request-request-…-cancel-cancel-…", it leaves the final animation
   * frame to run anyway. We turn that frame into a `O(1)` no-op via `callbacksCount`. */
  callbacks = [];
  callbacksCount = 0;
  nextId = 1;
  startId = 1;
  isScheduled = !1;
  tick = (e) => {
    this.isScheduled = !1;
    const n = this.callbacks, o = this.callbacksCount;
    if (this.callbacks = [], this.callbacksCount = 0, this.startId = this.nextId, o > 0)
      for (let r = 0; r < n.length; r += 1)
        n[r]?.(e);
  };
  request(e) {
    const n = this.nextId;
    this.nextId += 1, this.callbacks.push(e), this.callbacksCount += 1;
    const o = process.env.NODE_ENV !== "production" && Df !== requestAnimationFrame && (Df = requestAnimationFrame, !0);
    return (!this.isScheduled || o) && (requestAnimationFrame(this.tick), this.isScheduled = !0), n;
  }
  cancel(e) {
    const n = e - this.startId;
    n < 0 || n >= this.callbacks.length || (this.callbacks[n] = null, this.callbacksCount -= 1);
  }
}
const bi = new zy();
class Tt {
  static create() {
    return new Tt();
  }
  static request(e) {
    return bi.request(e);
  }
  static cancel(e) {
    return bi.cancel(e);
  }
  currentId = hi;
  /**
   * Executes `fn` after `delay`, clearing any previously scheduled call.
   */
  request(e) {
    this.cancel(), this.currentId = bi.request(() => {
      this.currentId = hi, e();
    });
  }
  cancel = () => {
    this.currentId !== hi && (bi.cancel(this.currentId), this.currentId = hi);
  };
  disposeEffect = () => this.cancel;
}
function Fr() {
  const t = Pt(Tt.create).current;
  return Ar(t.disposeEffect), t;
}
function Ke(t) {
  return t?.ownerDocument || document;
}
const Nm = {
  clipPath: "inset(50%)",
  overflow: "hidden",
  whiteSpace: "nowrap",
  border: 0,
  padding: 0,
  width: 1,
  height: 1,
  margin: -1
}, $o = {
  ...Nm,
  position: "fixed",
  top: 0,
  left: 0
}, Lr = {
  ...Nm,
  position: "absolute"
}, Mn = /* @__PURE__ */ v.forwardRef(function(e, n) {
  const [o, r] = v.useState();
  return xe(() => {
    bm && r("button");
  }, []), /* @__PURE__ */ x("span", {
    ...e,
    ref: n,
    style: $o,
    "aria-hidden": o ? void 0 : !0,
    ...{
      tabIndex: 0,
      // Role is only for VoiceOver
      role: o
    },
    "data-base-ui-focus-guard": ""
  });
});
process.env.NODE_ENV !== "production" && (Mn.displayName = "FocusGuard");
const dc = "data-base-ui-focusable", Im = "active", Mm = "selected", Tm = "input:not([type='hidden']):not([disabled]),[contenteditable]:not([contenteditable='false']),textarea:not([disabled])", Oo = "ArrowLeft", Do = "ArrowRight", Wc = "ArrowUp", Fs = "ArrowDown";
function zt(t) {
  let e = t.activeElement;
  for (; e?.shadowRoot?.activeElement != null; )
    e = e.shadowRoot.activeElement;
  return e;
}
function De(t, e) {
  if (!t || !e)
    return !1;
  const n = e.getRootNode?.();
  if (t.contains(e))
    return !0;
  if (n && kr(n)) {
    let o = e;
    for (; o; ) {
      if (t === o)
        return !0;
      o = o.parentNode || o.host;
    }
  }
  return !1;
}
function gt(t) {
  return "composedPath" in t ? t.composedPath()[0] : t.target;
}
function na(t, e) {
  if (!lt(t))
    return !1;
  const n = t;
  if (e.hasElement(n))
    return !n.hasAttribute("data-trigger-disabled");
  for (const [, o] of e.entries())
    if (De(o, n))
      return !o.hasAttribute("data-trigger-disabled");
  return !1;
}
function _n(t, e) {
  if (e == null)
    return !1;
  if ("composedPath" in t)
    return t.composedPath().includes(e);
  const n = t;
  return n.target != null && e.contains(n.target);
}
function Hy(t) {
  return t.matches("html,body");
}
function Na(t) {
  return bt(t) && t.matches(Tm);
}
function km(t) {
  return t?.closest(`button,a[href],[role="button"],select,[tabindex]:not([tabindex="-1"]),${Tm}`) != null;
}
function fc(t) {
  return t ? t.getAttribute("role") === "combobox" && Na(t) : !1;
}
function oa(t) {
  if (!t || ym)
    return !0;
  try {
    return t.matches(":focus-visible");
  } catch {
    return !0;
  }
}
function ws(t) {
  return t ? t.hasAttribute(dc) ? t : t.querySelector(`[${dc}]`) || t : null;
}
const By = ["top", "right", "bottom", "left"], Dr = Math.min, hn = Math.max, ra = Math.round, qo = Math.floor, no = (t) => ({
  x: t,
  y: t
}), Wy = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
};
function pc(t, e, n) {
  return hn(t, Dr(e, n));
}
function xo(t, e) {
  return typeof t == "function" ? t(e) : t;
}
function pn(t) {
  return t.split("-")[0];
}
function zo(t) {
  return t.split("-")[1];
}
function Uc(t) {
  return t === "x" ? "y" : "x";
}
function Yc(t) {
  return t === "y" ? "height" : "width";
}
function In(t) {
  const e = t[0];
  return e === "t" || e === "b" ? "y" : "x";
}
function Gc(t) {
  return Uc(In(t));
}
function Uy(t, e, n) {
  n === void 0 && (n = !1);
  const o = zo(t), r = Gc(t), s = Yc(r);
  let i = r === "x" ? o === (n ? "end" : "start") ? "right" : "left" : o === "start" ? "bottom" : "top";
  return e.reference[s] > e.floating[s] && (i = sa(i)), [i, sa(i)];
}
function Yy(t) {
  const e = sa(t);
  return [gc(t), e, gc(e)];
}
function gc(t) {
  return t.includes("start") ? t.replace("start", "end") : t.replace("end", "start");
}
const _f = ["left", "right"], Vf = ["right", "left"], Gy = ["top", "bottom"], jy = ["bottom", "top"];
function Ky(t, e, n) {
  switch (t) {
    case "top":
    case "bottom":
      return n ? e ? Vf : _f : e ? _f : Vf;
    case "left":
    case "right":
      return e ? Gy : jy;
    default:
      return [];
  }
}
function qy(t, e, n, o) {
  const r = zo(t);
  let s = Ky(pn(t), n === "start", o);
  return r && (s = s.map((i) => i + "-" + r), e && (s = s.concat(s.map(gc)))), s;
}
function sa(t) {
  const e = pn(t);
  return Wy[e] + t.slice(e.length);
}
function Xy(t) {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...t
  };
}
function Om(t) {
  return typeof t != "number" ? Xy(t) : {
    top: t,
    right: t,
    bottom: t,
    left: t
  };
}
function Cs(t) {
  const {
    x: e,
    y: n,
    width: o,
    height: r
  } = t;
  return {
    width: o,
    height: r,
    top: n,
    left: e,
    right: e + o,
    bottom: n + r,
    x: e,
    y: n
  };
}
function vi(t, e, n) {
  return Math.floor(t / e) !== n;
}
function Ss(t, e) {
  return e < 0 || e >= t.length;
}
function Yi(t, e) {
  return Jt(t.current, {
    disabledIndices: e
  });
}
function mc(t, e) {
  return Jt(t.current, {
    decrement: !0,
    startingIndex: t.current.length,
    disabledIndices: e
  });
}
function Jt(t, {
  startingIndex: e = -1,
  decrement: n = !1,
  disabledIndices: o,
  amount: r = 1
} = {}) {
  let s = e;
  do
    s += n ? -r : r;
  while (s >= 0 && s <= t.length - 1 && bo(t, s, o));
  return s;
}
function Dm(t, {
  event: e,
  orientation: n,
  loopFocus: o,
  onLoop: r,
  rtl: s,
  cols: i,
  disabledIndices: a,
  minIndex: l,
  maxIndex: c,
  prevIndex: u,
  stopEvent: d = !1
}) {
  let f = u, p;
  if (e.key === Wc ? p = "up" : e.key === Fs && (p = "down"), p) {
    const g = [], m = [];
    let h = !1, b = 0;
    {
      let N = null, I = -1;
      t.forEach((M, T) => {
        if (M == null)
          return;
        b += 1;
        const k = M.closest('[role="row"]');
        k && (h = !0), (k !== N || I === -1) && (N = k, I += 1, g[I] = []), g[I].push(T), m[T] = I;
      });
    }
    let w = !1, y = 0;
    if (h)
      for (const N of g) {
        const I = N.length;
        I > y && (y = I), I !== i && (w = !0);
      }
    const C = w && b < t.length, R = y || i, S = (N) => {
      if (!w || u === -1)
        return;
      const I = m[u];
      if (I == null)
        return;
      const M = g[I].indexOf(u), T = N === "up" ? -1 : 1;
      for (let k = I + T, D = 0; D < g.length; D += 1, k += T) {
        if (k < 0 || k >= g.length) {
          if (!o || C)
            return;
          if (k = k < 0 ? g.length - 1 : 0, r) {
            const V = Math.min(M, g[k].length - 1), _ = g[k][V] ?? g[k][0], A = r(e, u, _);
            k = m[A] ?? k;
          }
        }
        const O = g[k];
        for (let V = Math.min(M, O.length - 1); V >= 0; V -= 1) {
          const _ = O[V];
          if (!bo(t, _, a))
            return _;
        }
      }
    }, E = (N) => {
      if (!C || u === -1)
        return;
      const I = u % R, M = N === "up" ? -R : R, T = c - c % R, k = qo(c / R) + 1;
      for (let D = u - I + M, O = 0; O < k; O += 1, D += M) {
        if (D < 0 || D > c) {
          if (!o)
            return;
          D = D < 0 ? T : 0;
        }
        const V = Math.min(D + R - 1, c);
        for (let _ = Math.min(D + I, V); _ >= D; _ -= 1)
          if (!bo(t, _, a))
            return _;
      }
    };
    d && Ot(e);
    const P = S(p) ?? E(p);
    if (P !== void 0)
      f = P;
    else if (u === -1)
      f = p === "up" ? c : l;
    else if (f = Jt(t, {
      startingIndex: u,
      amount: R,
      decrement: p === "up",
      disabledIndices: a
    }), o) {
      if (p === "up" && (u - R < l || f < 0)) {
        const N = u % R, I = c % R, M = c - (I - N);
        I === N ? f = c : f = I > N ? M : M - R, r && (f = r(e, u, f));
      }
      p === "down" && u + R > c && (f = Jt(t, {
        startingIndex: u % R - R,
        amount: R,
        disabledIndices: a
      }), r && (f = r(e, u, f)));
    }
    Ss(t, f) && (f = u);
  }
  if (n === "both") {
    const g = qo(u / i);
    e.key === (s ? Oo : Do) && (d && Ot(e), u % i !== i - 1 ? (f = Jt(t, {
      startingIndex: u,
      disabledIndices: a
    }), o && vi(f, i, g) && (f = Jt(t, {
      startingIndex: u - u % i - 1,
      disabledIndices: a
    }), r && (f = r(e, u, f)))) : o && (f = Jt(t, {
      startingIndex: u - u % i - 1,
      disabledIndices: a
    }), r && (f = r(e, u, f))), vi(f, i, g) && (f = u)), e.key === (s ? Do : Oo) && (d && Ot(e), u % i !== 0 ? (f = Jt(t, {
      startingIndex: u,
      decrement: !0,
      disabledIndices: a
    }), o && vi(f, i, g) && (f = Jt(t, {
      startingIndex: u + (i - u % i),
      decrement: !0,
      disabledIndices: a
    }), r && (f = r(e, u, f)))) : o && (f = Jt(t, {
      startingIndex: u + (i - u % i),
      decrement: !0,
      disabledIndices: a
    }), r && (f = r(e, u, f))), vi(f, i, g) && (f = u));
    const m = qo(c / i) === g;
    Ss(t, f) && (o && m ? (f = e.key === (s ? Do : Oo) ? c : Jt(t, {
      startingIndex: u - u % i - 1,
      disabledIndices: a
    }), r && (f = r(e, u, f))) : f = u);
  }
  return f;
}
function _m(t, e, n) {
  const o = [];
  let r = 0;
  return t.forEach(({
    width: s,
    height: i
  }, a) => {
    if (s > e && process.env.NODE_ENV !== "production")
      throw new Error(`[Floating UI]: Invalid grid - item width at index ${a} is greater than grid columns`);
    let l = !1;
    for (n && (r = 0); !l; ) {
      const c = [];
      for (let u = 0; u < s; u += 1)
        for (let d = 0; d < i; d += 1)
          c.push(r + u + d * e);
      r % e + s <= e && c.every((u) => o[u] == null) ? (c.forEach((u) => {
        o[u] = a;
      }), l = !0) : r += 1;
    }
  }), [...o];
}
function Vm(t, e, n, o, r) {
  if (t === -1)
    return -1;
  const s = n.indexOf(t), i = e[t];
  switch (r) {
    case "tl":
      return s;
    case "tr":
      return i ? s + i.width - 1 : s;
    case "bl":
      return i ? s + (i.height - 1) * o : s;
    case "br":
      return n.lastIndexOf(t);
    default:
      return -1;
  }
}
function Am(t, e) {
  return e.flatMap((n, o) => t.includes(n) ? [o] : []);
}
function bo(t, e, n) {
  if (typeof n == "function" ? n(e) : n?.includes(e) ?? !1)
    return !0;
  const r = t[e];
  return r ? Ia(r) ? !n && (r.hasAttribute("disabled") || r.getAttribute("aria-disabled") === "true") : !0 : !1;
}
function Zy(t) {
  return t.visibility === "hidden" || t.visibility === "collapse";
}
function Ia(t, e = t ? an(t) : null) {
  return !t || !t.isConnected || !e || Zy(e) ? !1 : typeof t.checkVisibility == "function" ? t.checkVisibility() : e.display !== "none" && e.display !== "contents";
}
const Qy = 'a[href],button,input,select,textarea,summary,details,iframe,object,embed,[tabindex],[contenteditable]:not([contenteditable="false"]),audio[controls],video[controls]';
function Jy(t) {
  const e = t.assignedSlot;
  if (e)
    return e;
  if (t.parentElement)
    return t.parentElement;
  const n = t.getRootNode();
  return kr(n) ? n.host : null;
}
function hc(t) {
  for (const e of Array.from(t.children))
    if (nn(e) === "summary")
      return e;
  return null;
}
function ex(t, e) {
  const n = hc(e);
  return !!n && (t === n || De(n, t));
}
function Fm(t) {
  const e = t ? nn(t) : "";
  return t != null && t.matches(Qy) && (e !== "summary" || t.parentElement != null && nn(t.parentElement) === "details" && hc(t.parentElement) === t) && (e !== "details" || hc(t) == null) && (e !== "input" || t.type !== "hidden");
}
function Lm(t) {
  if (!Fm(t) || !t.isConnected || t.matches(":disabled"))
    return !1;
  for (let e = t; e; e = Jy(e)) {
    const n = e !== t, o = nn(e) === "slot";
    if (e.hasAttribute("inert") || n && nn(e) === "details" && !e.open && !ex(t, e) || e.hasAttribute("hidden") || !o && !tx(e, n))
      return !1;
  }
  return !0;
}
function tx(t, e) {
  const n = an(t);
  return e ? n.display !== "none" : Ia(t, n);
}
function $m(t) {
  const e = t.tabIndex;
  if (e < 0) {
    const n = nn(t);
    if (n === "details" || n === "audio" || n === "video" || bt(t) && t.isContentEditable)
      return 0;
  }
  return e;
}
function vl(t) {
  if (nn(t) !== "input")
    return null;
  const e = t;
  return e.type === "radio" && e.name !== "" ? e : null;
}
function nx(t, e) {
  const n = vl(t);
  if (!n)
    return !0;
  const o = e.find((r) => {
    const s = vl(r);
    return s?.name === n.name && s.form === n.form && s.checked;
  });
  return o ? o === n : e.find((r) => {
    const s = vl(r);
    return s?.name === n.name && s.form === n.form;
  }) === n;
}
function zm(t) {
  if (bt(t) && nn(t) === "slot") {
    const e = t.assignedElements({
      flatten: !0
    });
    if (e.length > 0)
      return e;
  }
  return bt(t) && t.shadowRoot ? Array.from(t.shadowRoot.children) : Array.from(t.children);
}
function Hm(t, e) {
  zm(t).forEach((n) => {
    Fm(n) && e.push(n), Hm(n, e);
  });
}
function Bm(t, e, n) {
  zm(t).forEach((o) => {
    bt(o) && o.matches(e) && n.push(o), Bm(o, e, n);
  });
}
function jc(t) {
  return Lm(t) && $m(t) >= 0;
}
function Wm(t) {
  const e = [];
  return Hm(t, e), e.filter(Lm);
}
function Ls(t) {
  const e = Wm(t);
  return e.filter((n) => $m(n) >= 0 && nx(n, e));
}
function Um(t, e) {
  const n = Ls(t), o = n.length;
  if (o === 0)
    return;
  const r = zt(Ke(t)), s = n.indexOf(r), i = s === -1 ? e === 1 ? 0 : o - 1 : s + e;
  return n[i];
}
function Kc(t) {
  return Um(Ke(t).body, 1) || t;
}
function Ym(t) {
  return Um(Ke(t).body, -1) || t;
}
function Gm(t, e) {
  if (!t)
    return null;
  const n = Ls(Ke(t).body), o = n.length;
  if (o === 0)
    return null;
  const r = n.indexOf(t);
  if (r === -1)
    return null;
  const s = (r + e + o) % o;
  return n[s];
}
function ox(t) {
  return Gm(t, 1);
}
function rx(t) {
  return Gm(t, -1);
}
function Pr(t, e) {
  const n = e || t.currentTarget, o = t.relatedTarget;
  return !o || !De(n, o);
}
function sx(t) {
  Ls(t).forEach((n) => {
    n.dataset.tabindex = n.getAttribute("tabindex") || "", n.setAttribute("tabindex", "-1");
  });
}
function Af(t) {
  const e = [];
  Bm(t, "[data-tabindex]", e), e.forEach((n) => {
    const o = n.dataset.tabindex;
    delete n.dataset.tabindex, o ? n.setAttribute("tabindex", o) : n.removeAttribute("tabindex");
  });
}
function oo(t, e, n = !0) {
  return t.filter((r) => r.parentId === e).flatMap((r) => [...!n || r.context?.open ? [r] : [], ...oo(t, r.id, n)]);
}
function Ff(t, e) {
  let n = [], o = t.find((r) => r.id === e)?.parentId;
  for (; o; ) {
    const r = t.find((s) => s.id === o);
    o = r?.parentId, r && (n = n.concat(r));
  }
  return n;
}
function Rs(t) {
  return `data-base-ui-${t}`;
}
let yi = 0;
function Gi(t, e = {}) {
  const {
    preventScroll: n = !1,
    cancelPrevious: o = !0,
    sync: r = !1
  } = e;
  o && cancelAnimationFrame(yi);
  const s = () => t?.focus({
    preventScroll: n
  });
  if (r)
    return s(), ht;
  const i = requestAnimationFrame(s);
  return yi = i, () => {
    yi === i && (cancelAnimationFrame(i), yi = 0);
  };
}
const yl = {
  inert: /* @__PURE__ */ new WeakMap(),
  "aria-hidden": /* @__PURE__ */ new WeakMap()
}, Lf = "data-base-ui-inert", bc = {
  inert: /* @__PURE__ */ new WeakSet(),
  "aria-hidden": /* @__PURE__ */ new WeakSet()
};
let ns = /* @__PURE__ */ new WeakMap(), xl = 0;
function ix(t) {
  return bc[t];
}
function jm(t) {
  return t ? kr(t) ? t.host : jm(t.parentNode) : null;
}
const wl = (t, e) => e.map((n) => {
  if (t.contains(n))
    return n;
  const o = jm(n);
  return t.contains(o) ? o : null;
}).filter((n) => n != null), $f = (t) => {
  const e = /* @__PURE__ */ new Set();
  return t.forEach((n) => {
    let o = n;
    for (; o && !e.has(o); )
      e.add(o), o = o.parentNode;
  }), e;
}, zf = (t, e, n) => {
  const o = [], r = (s) => {
    !s || n.has(s) || Array.from(s.children).forEach((i) => {
      nn(i) !== "script" && (e.has(i) ? r(i) : o.push(i));
    });
  };
  return r(t), o;
};
function ax(t, e, n, o, {
  mark: r = !0,
  markerIgnoreElements: s = []
}) {
  const i = o ? "inert" : n ? "aria-hidden" : null;
  let a = null, l = null;
  const c = wl(e, t), u = r ? wl(e, s) : [], d = new Set(u), f = r ? zf(e, $f(c), new Set(c)).filter((m) => !d.has(m)) : [], p = [], g = [];
  if (i) {
    const m = yl[i], h = ix(i);
    l = h, a = m;
    const b = wl(e, Array.from(e.querySelectorAll("[aria-live]"))), w = c.concat(b);
    zf(e, $f(w), new Set(w)).forEach((C) => {
      const R = C.getAttribute(i), S = R !== null && R !== "false", E = (m.get(C) || 0) + 1;
      m.set(C, E), p.push(C), E === 1 && S && h.add(C), S || C.setAttribute(i, i === "inert" ? "" : "true");
    });
  }
  return r && f.forEach((m) => {
    const h = (ns.get(m) || 0) + 1;
    ns.set(m, h), g.push(m), h === 1 && m.setAttribute(Lf, "");
  }), xl += 1, () => {
    a && p.forEach((m) => {
      const b = (a.get(m) || 0) - 1;
      a.set(m, b), b || (!l?.has(m) && i && m.removeAttribute(i), l?.delete(m));
    }), r && g.forEach((m) => {
      const h = (ns.get(m) || 0) - 1;
      ns.set(m, h), h || m.removeAttribute(Lf);
    }), xl -= 1, xl || (yl.inert = /* @__PURE__ */ new WeakMap(), yl["aria-hidden"] = /* @__PURE__ */ new WeakMap(), bc.inert = /* @__PURE__ */ new WeakSet(), bc["aria-hidden"] = /* @__PURE__ */ new WeakSet(), ns = /* @__PURE__ */ new WeakMap());
  };
}
function Hf(t, e = {}) {
  const {
    ariaHidden: n = !1,
    inert: o = !1,
    mark: r = !0,
    markerIgnoreElements: s = []
  } = e, i = Ke(t[0]).body;
  return ax(t, i, n, o, {
    mark: r,
    markerIgnoreElements: s
  });
}
let Bf = 0;
function lx(t, e = "mui") {
  const [n, o] = v.useState(t), r = t || n;
  return v.useEffect(() => {
    n == null && (Bf += 1, o(`${e}-${Bf}`));
  }, [n, e]), r;
}
const Wf = Jo.useId;
function wo(t, e) {
  if (Wf !== void 0) {
    const n = Wf();
    return t ?? (e ? `${e}-${n}` : n);
  }
  return lx(t, e);
}
const cx = 500, Km = 500, ux = {
  style: {
    transition: "none"
  }
}, qc = "data-base-ui-click-trigger", dx = "data-base-ui-swipe-ignore", fx = "data-swipe-ignore", qm = `[${dx}]`, px = `[${fx}]`, Xc = {
  fallbackAxisSide: "none"
}, Ma = {
  fallbackAxisSide: "end"
}, gx = {
  clipPath: "inset(50%)",
  position: "fixed",
  top: 0,
  left: 0
}, Zc = /* @__PURE__ */ v.createContext(null);
process.env.NODE_ENV !== "production" && (Zc.displayName = "PortalContext");
const Xm = () => v.useContext(Zc), mx = Rs("portal");
function Zm(t = {}) {
  const {
    ref: e,
    container: n,
    componentProps: o = yt,
    elementProps: r
  } = t, s = wo(), a = Xm()?.portalNode, [l, c] = v.useState(null), [u, d] = v.useState(null), f = ge((h) => {
    h !== null && d(h);
  }), p = v.useRef(null);
  xe(() => {
    if (n === null) {
      p.current && (p.current = null, d(null), c(null));
      return;
    }
    if (s == null)
      return;
    const h = (n && (Oc(n) ? n : n.current)) ?? a ?? document.body;
    if (h == null) {
      p.current && (p.current = null, d(null), c(null));
      return;
    }
    p.current !== h && (p.current = h, d(null), c(h));
  }, [n, a, s]);
  const g = Te("div", o, {
    ref: [e, f],
    props: [{
      id: s,
      [mx]: ""
    }, r]
  });
  return {
    portalNode: u,
    portalSubtree: l && g ? /* @__PURE__ */ tn.createPortal(g, l) : null
  };
}
const $r = /* @__PURE__ */ v.forwardRef(function(e, n) {
  const {
    children: o,
    container: r,
    className: s,
    render: i,
    renderGuards: a,
    style: l,
    ...c
  } = e, {
    portalNode: u,
    portalSubtree: d
  } = Zm({
    container: r,
    ref: n,
    componentProps: e,
    elementProps: c
  }), f = v.useRef(null), p = v.useRef(null), g = v.useRef(null), m = v.useRef(null), [h, b] = v.useState(null), w = v.useRef(!1), y = h?.modal, C = h?.open, R = typeof a == "boolean" ? a : !!h && !h.modal && h.open && !!u;
  v.useEffect(() => {
    if (!u || y)
      return;
    function E(P) {
      u && P.relatedTarget && Pr(P) && (P.type === "focusin" ? w.current && (Af(u), w.current = !1) : (sx(u), w.current = !0));
    }
    return $n(rt(u, "focusin", E, !0), rt(u, "focusout", E, !0));
  }, [u, y]), v.useEffect(() => {
    !u || C !== !1 || (Af(u), w.current = !1);
  }, [C, u]);
  const S = v.useMemo(() => ({
    beforeOutsideRef: f,
    afterOutsideRef: p,
    beforeInsideRef: g,
    afterInsideRef: m,
    portalNode: u,
    setFocusManagerState: b
  }), [u]);
  return /* @__PURE__ */ j(v.Fragment, {
    children: [d, /* @__PURE__ */ j(Zc.Provider, {
      value: S,
      children: [R && u && /* @__PURE__ */ x(Mn, {
        "data-type": "outside",
        ref: f,
        onFocus: (E) => {
          if (Pr(E, u))
            g.current?.focus();
          else {
            const P = h ? h.domReference : null;
            Ym(P)?.focus();
          }
        }
      }), R && u && /* @__PURE__ */ x("span", {
        "aria-owns": u.id,
        style: gx
      }), u && /* @__PURE__ */ tn.createPortal(o, u), R && u && /* @__PURE__ */ x(Mn, {
        "data-type": "outside",
        ref: p,
        onFocus: (E) => {
          if (Pr(E, u))
            m.current?.focus();
          else {
            const P = h ? h.domReference : null;
            Kc(P)?.focus(), h?.closeOnFocusOut && h?.onOpenChange(!1, Pe(yo, E.nativeEvent));
          }
        }
      })]
    })]
  });
});
process.env.NODE_ENV !== "production" && ($r.displayName = "FloatingPortal");
function Qm() {
  const t = /* @__PURE__ */ new Map();
  return {
    emit(e, n) {
      t.get(e)?.forEach((o) => o(n));
    },
    on(e, n) {
      t.has(e) || t.set(e, /* @__PURE__ */ new Set()), t.get(e).add(n);
    },
    off(e, n) {
      t.get(e)?.delete(n);
    }
  };
}
class Qc {
  nodesRef = {
    current: []
  };
  events = Qm();
  addNode(e) {
    this.nodesRef.current.push(e);
  }
  removeNode(e) {
    const n = this.nodesRef.current.findIndex((o) => o === e);
    n !== -1 && this.nodesRef.current.splice(n, 1);
  }
}
const Jc = /* @__PURE__ */ v.createContext(null);
process.env.NODE_ENV !== "production" && (Jc.displayName = "FloatingNodeContext");
const eu = /* @__PURE__ */ v.createContext(null);
process.env.NODE_ENV !== "production" && (eu.displayName = "FloatingTreeContext");
const ao = () => v.useContext(Jc)?.id || null, Ho = (t) => {
  const e = v.useContext(eu);
  return t ?? e;
};
function Ta(t) {
  const e = wo(), n = Ho(t), o = ao();
  return xe(() => {
    if (!e)
      return;
    const r = {
      id: e,
      parentId: o
    };
    return n?.addNode(r), () => {
      n?.removeNode(r);
    };
  }, [n, e, o]), e;
}
function tu(t) {
  const {
    children: e,
    id: n
  } = t, o = ao();
  return /* @__PURE__ */ x(Jc.Provider, {
    value: v.useMemo(() => ({
      id: n,
      parentId: o
    }), [n, o]),
    children: e
  });
}
function nu(t) {
  const {
    children: e,
    externalTree: n
  } = t, o = Pt(() => n ?? new Qc()).current;
  return /* @__PURE__ */ x(eu.Provider, {
    value: o,
    children: e
  });
}
function co(t) {
  return t == null ? t : "current" in t ? t.current : t;
}
function hx(t, e) {
  const n = vt(gt(t));
  return t instanceof n.KeyboardEvent ? "keyboard" : t instanceof n.FocusEvent ? e || "keyboard" : "pointerType" in t ? t.pointerType || "keyboard" : "touches" in t ? "touch" : t instanceof n.MouseEvent ? e || (t.detail === 0 ? "keyboard" : "mouse") : "";
}
const Uf = 20;
let Mo = [];
function ou() {
  Mo = Mo.filter((t) => t.deref()?.isConnected);
}
function bx(t) {
  ou(), t && nn(t) !== "body" && (Mo.push(new WeakRef(t)), Mo.length > Uf && (Mo = Mo.slice(-Uf)));
}
function Cl() {
  return ou(), Mo[Mo.length - 1]?.deref();
}
function vx(t) {
  return t ? jc(t) ? t : Ls(t)[0] || t : null;
}
function Yf(t, e) {
  if (t.hasAttribute("tabindex") && !t.hasAttribute("data-tabindex") || !e.current.includes("floating") && !t.getAttribute("role")?.includes("dialog"))
    return;
  const o = Wm(t).filter((s) => {
    const i = s.getAttribute("data-tabindex") || "";
    return jc(s) || s.hasAttribute("data-tabindex") && !i.startsWith("-");
  }), r = t.getAttribute("tabindex");
  e.current.includes("floating") || o.length === 0 ? r !== "0" && t.setAttribute("tabindex", "0") : (r !== "-1" || t.hasAttribute("data-tabindex") && t.getAttribute("data-tabindex") !== "-1") && (t.setAttribute("tabindex", "-1"), t.setAttribute("data-tabindex", "-1"));
}
function zr(t) {
  const {
    context: e,
    children: n,
    disabled: o = !1,
    initialFocus: r = !0,
    returnFocus: s = !0,
    restoreFocus: i = !1,
    modal: a = !0,
    closeOnFocusOut: l = !0,
    openInteractionType: c = "",
    nextFocusableElement: u,
    previousFocusableElement: d,
    beforeContentFocusGuardRef: f,
    externalTree: p,
    getInsideElements: g
  } = t, m = "rootStore" in e ? e.rootStore : e, h = m.useState("open"), b = m.useState("domReferenceElement"), w = m.useState("floatingElement"), {
    events: y,
    dataRef: C
  } = m.context, R = ge(() => C.current.floatingContext?.nodeId), S = r === !1, E = fc(b) && S, P = v.useRef(["content"]), N = _t(r), I = _t(s), M = _t(c), T = Ho(p), k = Xm(), D = v.useRef(!1), O = v.useRef(!1), V = v.useRef(!1), _ = v.useRef(null), A = v.useRef(""), F = v.useRef(""), H = v.useRef(null), Y = v.useRef(null), B = ln(H, f, k?.beforeInsideRef), U = ln(Y, k?.afterInsideRef), q = Vt(), W = Vt(), K = Fr(), te = k != null, z = ws(w), Q = ge((X = z) => X ? Ls(X) : []), ee = ge(() => g?.().filter((X) => X != null) ?? []);
  v.useEffect(() => {
    if (o || !a)
      return;
    function X(ue) {
      ue.key === "Tab" && De(z, zt(Ke(z))) && Q().length === 0 && !E && Ot(ue);
    }
    const se = Ke(z);
    return rt(se, "keydown", X);
  }, [o, b, z, a, P, E, Q]), v.useEffect(() => {
    if (o || !h)
      return;
    const X = Ke(z);
    function se() {
      V.current = !1;
    }
    function ue(ne) {
      const oe = gt(ne), me = ee(), de = De(w, oe) || De(b, oe) || De(k?.portalNode, oe) || me.some((he) => he === oe || De(he, oe));
      V.current = !de, F.current = ne.pointerType || "keyboard", oe?.closest(`[${qc}]`) && (O.current = !0);
    }
    function re() {
      F.current = "keyboard";
    }
    return $n(rt(X, "pointerdown", ue, !0), rt(X, "pointerup", se, !0), rt(X, "pointercancel", se, !0), rt(X, "keydown", re, !0));
  }, [o, w, b, z, h, k, ee]), v.useEffect(() => {
    if (o || !l)
      return;
    const X = Ke(z);
    function se() {
      O.current = !0, W.start(0, () => {
        O.current = !1;
      });
    }
    function ue(me) {
      const de = gt(me);
      jc(de) && (_.current = de);
    }
    function re(me) {
      const de = me.relatedTarget, he = me.currentTarget, $ = gt(me);
      queueMicrotask(() => {
        const Z = R(), L = m.context.triggerElements, G = ee(), ie = de?.hasAttribute(Rs("focus-guard")) && [H.current, Y.current, k?.beforeInsideRef.current, k?.afterInsideRef.current, k?.beforeOutsideRef.current, k?.afterOutsideRef.current, co(d), co(u)].includes(de), pe = !(De(b, de) || De(w, de) || De(de, w) || De(k?.portalNode, de) || G.some((be) => be === de || De(be, de)) || de != null && L.hasElement(de) || L.hasMatchingElement((be) => De(be, de)) || ie || T && (oo(T.nodesRef.current, Z).find((be) => De(be.context?.elements.floating, de) || De(be.context?.elements.domReference, de)) || Ff(T.nodesRef.current, Z).find((be) => [be.context?.elements.floating, ws(be.context?.elements.floating)].includes(de) || be.context?.elements.domReference === de)));
        if (he === b && z && Yf(z, P), i && he !== b && !Ia($) && zt(X) === X.body) {
          if (bt(z) && (z.focus(), i === "popup")) {
            K.request(() => {
              z.focus();
            });
            return;
          }
          const be = Q(), Re = _.current, _e = (Re && be.includes(Re) ? Re : null) || be[be.length - 1] || z;
          bt(_e) && _e.focus();
        }
        if (C.current.insideReactTree) {
          C.current.insideReactTree = !1;
          return;
        }
        (E || !a) && de && pe && !O.current && // Fix React 18 Strict Mode returnFocus due to double rendering.
        // For an "untrapped" typeable combobox (input role=combobox with
        // initialFocus=false), re-opening the popup and tabbing out should still close it even
        // when the previously focused element (e.g. the next tabbable outside the popup) is
        // focused again. Otherwise, the popup remains open on the second Tab sequence:
        // click input -> Tab (closes) -> click input -> Tab.
        // Allow closing when `isUntrappedTypeableCombobox` regardless of the previously focused element.
        (E || de !== Cl()) && (D.current = !0, m.setOpen(!1, Pe(yo, me)));
      });
    }
    function ne() {
      V.current || (C.current.insideReactTree = !0, q.start(0, () => {
        C.current.insideReactTree = !1;
      }));
    }
    const oe = bt(b) ? b : null;
    if (!(!w && !oe))
      return $n(oe && rt(oe, "focusout", re), oe && rt(oe, "pointerdown", se), w && rt(w, "focusin", ue), w && rt(w, "focusout", re), w && k && rt(w, "focusout", ne, !0));
  }, [o, b, w, z, a, T, k, m, l, i, Q, E, R, P, C, q, W, K, u, d, ee]), v.useEffect(() => {
    if (o || !w || !h)
      return;
    const X = Array.from(k?.portalNode?.querySelectorAll(`[${Rs("portal")}]`) || []), ue = (T ? Ff(T.nodesRef.current, R()) : []).find((he) => fc(he.context?.elements.domReference || null))?.context?.elements.domReference, ne = [...[w, ...X, H.current, Y.current, k?.beforeOutsideRef.current, k?.afterOutsideRef.current, ...ee()], ue, co(d), co(u), E ? b : null].filter((he) => he != null), oe = Hf(ne, {
      ariaHidden: a || E,
      mark: !1
    }), me = [w, ...X].filter((he) => he != null), de = Hf(me);
    return () => {
      de(), oe();
    };
  }, [h, o, b, w, a, P, k, E, T, R, u, d, ee]), xe(() => {
    if (!h || o || !bt(z))
      return;
    const X = Ke(z), se = zt(X);
    queueMicrotask(() => {
      const ue = N.current, re = typeof ue == "function" ? ue(M.current || "") : ue;
      if (re === void 0 || re === !1 || De(z, se))
        return;
      let oe = null;
      const me = () => (oe == null && (oe = Q(z)), oe[0] || z);
      let de;
      re === !0 || re === null ? de = me() : de = co(re), de = de || me(), Gi(de, {
        preventScroll: de === z
      });
    });
  }, [o, h, z, S, Q, N, M]), xe(() => {
    if (o || !z)
      return;
    const X = Ke(z), se = zt(X);
    bx(se);
    function ue(ne) {
      if (ne.open || (A.current = hx(ne.nativeEvent, F.current)), ne.reason === Dt && ne.nativeEvent.type === "mouseleave" && (D.current = !0), ne.reason === Vs)
        if (ne.nested)
          D.current = !1;
        else if (xm(ne.nativeEvent) || wm(ne.nativeEvent))
          D.current = !1;
        else {
          let oe = !1;
          Ke(z).createElement("div").focus({
            get preventScroll() {
              return oe = !0, !1;
            }
          }), oe ? D.current = !1 : D.current = !0;
        }
    }
    y.on("openchange", ue);
    function re() {
      const ne = I.current;
      let oe = typeof ne == "function" ? ne(A.current) : ne;
      if (oe === void 0 || oe === !1)
        return null;
      if (oe === null && (oe = !0), typeof oe == "boolean") {
        const de = b || Cl();
        return de && de.isConnected ? de : null;
      }
      const me = b || Cl();
      return co(oe) || me || null;
    }
    return () => {
      y.off("openchange", ue);
      const ne = zt(X), oe = ee(), me = De(w, ne) || oe.some(($) => $ === ne || De($, ne)) || T && oo(T.nodesRef.current, R(), !1).some(($) => De($.context?.elements.floating, ne)), de = I.current, he = re();
      queueMicrotask(() => {
        const $ = vx(he), Z = typeof de != "boolean";
        de && !D.current && bt($) && // If the focus moved somewhere else after mount, avoid returning focus
        // since it likely entered a different element which should be
        // respected: https://github.com/floating-ui/floating-ui/issues/2607
        (!(!Z && $ !== ne && ne !== X.body) || me) && $.focus({
          preventScroll: !0
        }), D.current = !1;
      });
    };
  }, [o, w, z, I, C, y, T, b, R, ee]), xe(() => {
    if (!Hc || h || !w)
      return;
    const X = zt(Ke(w));
    !bt(X) || !Na(X) || De(w, X) && X.blur();
  }, [h, w]), xe(() => {
    if (!(o || !k))
      return k.setFocusManagerState({
        modal: a,
        closeOnFocusOut: l,
        open: h,
        onOpenChange: m.setOpen,
        domReference: b
      }), () => {
        k.setFocusManagerState(null);
      };
  }, [o, k, a, h, m, l, b]), xe(() => {
    if (!(o || !z))
      return Yf(z, P), () => {
        queueMicrotask(ou);
      };
  }, [o, z, P]);
  const ae = !o && (a ? !E : !0) && (te || a);
  return /* @__PURE__ */ j(v.Fragment, {
    children: [ae && /* @__PURE__ */ x(Mn, {
      "data-type": "inside",
      ref: B,
      onFocus: (X) => {
        if (a) {
          const se = Q();
          Gi(se[se.length - 1]);
        } else k?.portalNode && (D.current = !1, Pr(X, k.portalNode) ? Kc(b)?.focus() : co(d ?? k.beforeOutsideRef)?.focus());
      }
    }), n, ae && /* @__PURE__ */ x(Mn, {
      "data-type": "inside",
      ref: U,
      onFocus: (X) => {
        a ? Gi(Q()[0]) : k?.portalNode && (l && (D.current = !0), Pr(X, k.portalNode) ? Ym(b)?.focus() : co(u ?? k.afterOutsideRef)?.focus());
      }
    })]
  });
}
function lr(t, e = {}) {
  const n = "rootStore" in t ? t.rootStore : t, o = n.context.dataRef, {
    enabled: r = !0,
    event: s = "click",
    toggle: i = !0,
    ignoreMouse: a = !1,
    stickIfOpen: l = !0,
    touchOpenDelay: c = 0,
    reason: u = Bn
  } = e, d = v.useRef(void 0), f = Fr(), p = Vt(), g = v.useMemo(() => ({
    onPointerDown(m) {
      d.current = m.pointerType;
    },
    onMouseDown(m) {
      const h = d.current, b = m.nativeEvent, w = n.select("open");
      if (m.button !== 0 || s === "click" || Or(h, !0) && a)
        return;
      const y = o.current.openEvent, C = y?.type, R = n.select("domReferenceElement") !== m.currentTarget, S = w && R || !(w && i && (!(y && l) || C === "click" || C === "mousedown")), E = gt(b);
      if (Na(E)) {
        const N = Pe(u, b, E);
        S && h === "touch" && c > 0 ? p.start(c, () => {
          n.setOpen(!0, N);
        }) : n.setOpen(S, N);
        return;
      }
      const P = m.currentTarget;
      f.request(() => {
        const N = Pe(u, b, P);
        S && h === "touch" && c > 0 ? p.start(c, () => {
          n.setOpen(!0, N);
        }) : n.setOpen(S, N);
      });
    },
    onClick(m) {
      if (s === "mousedown-only")
        return;
      const h = d.current;
      if (s === "mousedown" && h) {
        d.current = void 0;
        return;
      }
      if (Or(h, !0) && a)
        return;
      const b = n.select("open"), w = o.current.openEvent, y = n.select("domReferenceElement") !== m.currentTarget, C = b && y || !(b && i && (!(w && l) || Cm(w))), R = Pe(u, m.nativeEvent, m.currentTarget);
      C && h === "touch" && c > 0 ? p.start(c, () => {
        n.setOpen(!0, R);
      }) : n.setOpen(C, R);
    },
    onKeyDown() {
      d.current = void 0;
    }
  }), [o, s, a, n, l, i, f, p, c, u]);
  return v.useMemo(() => r ? {
    reference: g
  } : yt, [r, g]);
}
function yx(t, e) {
  let n = null, o = null, r = !1;
  return {
    contextElement: t || void 0,
    getBoundingClientRect() {
      const s = t?.getBoundingClientRect() || {
        width: 0,
        height: 0,
        x: 0,
        y: 0
      }, i = e.axis === "x" || e.axis === "both", a = e.axis === "y" || e.axis === "both", l = ["mouseenter", "mousemove"].includes(e.dataRef.current.openEvent?.type || "") && e.pointerType !== "touch";
      let c = s.width, u = s.height, d = s.x, f = s.y;
      return n == null && e.x && i && (n = s.x - e.x), o == null && e.y && a && (o = s.y - e.y), d -= n || 0, f -= o || 0, c = 0, u = 0, !r || l ? (c = e.axis === "y" ? s.width : 0, u = e.axis === "x" ? s.height : 0, d = i && e.x != null ? e.x : d, f = a && e.y != null ? e.y : f) : r && !l && (u = e.axis === "x" ? s.height : u, c = e.axis === "y" ? s.width : c), r = !0, {
        width: c,
        height: u,
        x: d,
        y: f,
        top: f,
        right: d + c,
        bottom: f + u,
        left: d
      };
    }
  };
}
function Gf(t) {
  return t != null && t.clientX != null;
}
function xx(t, e = {}) {
  const n = "rootStore" in t ? t.rootStore : t, o = n.useState("open"), r = n.useState("floatingElement"), s = n.useState("domReferenceElement"), i = n.context.dataRef, {
    enabled: a = !0,
    axis: l = "both"
  } = e, c = v.useRef(!1), u = v.useRef(null), [d, f] = v.useState(), [p, g] = v.useState([]), m = ge((C, R, S) => {
    c.current || i.current.openEvent && !Gf(i.current.openEvent) || n.set("positionReference", yx(S ?? s, {
      x: C,
      y: R,
      axis: l,
      dataRef: i,
      pointerType: d
    }));
  }), h = ge((C) => {
    o ? u.current || g([]) : m(C.clientX, C.clientY, C.currentTarget);
  }), b = Or(d) ? r : o, w = v.useCallback(() => {
    if (!b || !a)
      return;
    const C = vt(r);
    function R(S) {
      const E = gt(S);
      De(r, E) ? (u.current?.(), u.current = null) : m(S.clientX, S.clientY);
    }
    if (!i.current.openEvent || Gf(i.current.openEvent)) {
      const S = () => {
        u.current?.(), u.current = null;
      };
      return u.current = rt(C, "mousemove", R), S;
    }
    n.set("positionReference", s);
  }, [b, a, r, i, s, n, m]);
  v.useEffect(() => w(), [w, p]), v.useEffect(() => {
    a && !r && (c.current = !1);
  }, [a, r]), v.useEffect(() => {
    !a && o && (c.current = !0);
  }, [a, o]);
  const y = v.useMemo(() => {
    function C(R) {
      f(R.pointerType);
    }
    return {
      onPointerDown: C,
      onPointerEnter: C,
      onMouseMove: h,
      onMouseEnter: h
    };
  }, [h]);
  return v.useMemo(() => a ? {
    reference: y,
    trigger: y
  } : {}, [a, y]);
}
const wx = {
  intentional: "onClick",
  sloppy: "onPointerDown"
};
function Cx() {
  return !1;
}
function Sx(t) {
  return {
    escapeKey: typeof t == "boolean" ? t : t?.escapeKey ?? !1,
    outsidePress: typeof t == "boolean" ? t : t?.outsidePress ?? !0
  };
}
function cr(t, e = {}) {
  const n = "rootStore" in t ? t.rootStore : t, o = n.useState("open"), r = n.useState("floatingElement"), {
    dataRef: s
  } = n.context, {
    enabled: i = !0,
    escapeKey: a = !0,
    outsidePress: l = !0,
    outsidePressEvent: c = "sloppy",
    referencePress: u = Cx,
    referencePressEvent: d = "sloppy",
    bubbles: f,
    externalTree: p
  } = e, g = Ho(p), m = ge(typeof l == "function" ? l : () => !1), h = typeof l == "function" ? m : l, b = h !== !1, w = ge(() => c), y = v.useRef(!1), C = v.useRef(!1), R = v.useRef(!1), {
    escapeKey: S,
    outsidePress: E
  } = Sx(f), P = v.useRef(null), N = Vt(), I = Vt(), M = ge(() => {
    I.clear(), s.current.insideReactTree = !1;
  }), T = v.useRef(!1), k = v.useRef(""), D = ge(u), O = ge((Y) => {
    if (!o || !i || !a || Y.key !== "Escape" || T.current)
      return;
    const B = s.current.floatingContext?.nodeId, U = g ? oo(g.nodesRef.current, B) : [];
    if (!S && U.length > 0) {
      let K = !0;
      if (U.forEach((te) => {
        te.context?.open && !te.context.dataRef.current.__escapeKeyBubbles && (K = !1);
      }), !K)
        return;
    }
    const q = Ty(Y) ? Y.nativeEvent : Y, W = Pe(ar, q);
    n.setOpen(!1, W), !S && !W.isPropagationAllowed && Y.stopPropagation();
  }), V = ge(() => {
    s.current.insideReactTree = !0, I.start(0, M);
  });
  v.useEffect(() => {
    if (!o || !i)
      return;
    s.current.__escapeKeyBubbles = S, s.current.__outsidePressBubbles = E;
    const Y = new gn(), B = new gn();
    function U() {
      Y.clear(), T.current = !0;
    }
    function q() {
      Y.start(
        // 0ms or 1ms don't work in Safari. 5ms appears to consistently work.
        // Only apply to WebKit for the test to remain 0ms.
        Sa() ? 5 : 0,
        () => {
          T.current = !1;
        }
      );
    }
    function W() {
      R.current = !0, B.start(0, () => {
        R.current = !1;
      });
    }
    function K() {
      y.current = !1, C.current = !1;
    }
    function te() {
      const L = k.current, G = L === "pen" || !L ? "mouse" : L, ie = w(), pe = typeof ie == "function" ? ie() : ie;
      return typeof pe == "string" ? pe : pe[G];
    }
    function z(L) {
      const G = te();
      return G === "intentional" && L.type !== "click" || G === "sloppy" && L.type === "click";
    }
    function Q(L) {
      const G = s.current.floatingContext?.nodeId, ie = g && oo(g.nodesRef.current, G).some((pe) => _n(L, pe.context?.elements.floating));
      return _n(L, n.select("floatingElement")) || _n(L, n.select("domReferenceElement")) || ie;
    }
    function ee(L) {
      if (z(L)) {
        M();
        return;
      }
      if (s.current.insideReactTree) {
        M();
        return;
      }
      const G = gt(L), ie = `[${Rs("inert")}]`, pe = lt(G) ? G.getRootNode() : null, be = Array.from((kr(pe) ? pe : Ke(n.select("floatingElement"))).querySelectorAll(ie)), Re = n.context.triggerElements;
      if (G && (Re.hasElement(G) || Re.hasMatchingElement((Ie) => De(Ie, G))))
        return;
      let _e = lt(G) ? G : null;
      for (; _e && !to(_e); ) {
        const Ie = ro(_e);
        if (to(Ie) || !lt(Ie))
          break;
        _e = Ie;
      }
      if (be.length && lt(G) && !Hy(G) && // Clicked on a direct ancestor (e.g. FloatingOverlay).
      !De(G, n.select("floatingElement")) && // If the target root element contains none of the markers, then the
      // element was injected after the floating element rendered.
      be.every((Ie) => !De(_e, Ie)))
        return;
      if (bt(G) && !("touches" in L)) {
        const Ie = to(G), Le = an(G), Ze = /auto|scroll/, tt = Ie || Ze.test(Le.overflowX), ut = Ie || Ze.test(Le.overflowY), at = tt && G.clientWidth > 0 && G.scrollWidth > G.clientWidth, $e = ut && G.clientHeight > 0 && G.scrollHeight > G.clientHeight, Ce = Le.direction === "rtl", Oe = $e && (Ce ? L.offsetX <= G.offsetWidth - G.clientWidth : L.offsetX > G.clientWidth), Ne = at && L.offsetY > G.clientHeight;
        if (Oe || Ne)
          return;
      }
      if (Q(L))
        return;
      if (te() === "intentional" && R.current) {
        B.clear(), R.current = !1;
        return;
      }
      if (typeof h == "function" && !h(L))
        return;
      const ke = s.current.floatingContext?.nodeId, Se = g ? oo(g.nodesRef.current, ke) : [];
      if (Se.length > 0) {
        let Ie = !0;
        if (Se.forEach((Le) => {
          Le.context?.open && !Le.context.dataRef.current.__outsidePressBubbles && (Ie = !1);
        }), !Ie)
          return;
      }
      n.setOpen(!1, Pe(Vs, L)), M();
    }
    function ae(L) {
      te() !== "sloppy" || L.pointerType === "touch" || !n.select("open") || !i || _n(L, n.select("floatingElement")) || _n(L, n.select("domReferenceElement")) || ee(L);
    }
    function X(L) {
      if (te() !== "sloppy" || !n.select("open") || !i || _n(L, n.select("floatingElement")) || _n(L, n.select("domReferenceElement")))
        return;
      const G = L.touches[0];
      G && (P.current = {
        startTime: Date.now(),
        startX: G.clientX,
        startY: G.clientY,
        dismissOnTouchEnd: !1,
        dismissOnMouseDown: !0
      }, N.start(1e3, () => {
        P.current && (P.current.dismissOnTouchEnd = !1, P.current.dismissOnMouseDown = !1);
      }));
    }
    function se(L, G) {
      const ie = gt(L);
      if (!ie)
        return;
      const pe = rt(ie, L.type, () => {
        G(L), pe();
      });
    }
    function ue(L) {
      k.current = "touch", se(L, X);
    }
    function re(L) {
      N.clear(), L.type === "pointerdown" && (k.current = L.pointerType), !(L.type === "mousedown" && P.current && !P.current.dismissOnMouseDown) && se(L, (G) => {
        G.type === "pointerdown" ? ae(G) : ee(G);
      });
    }
    function ne(L) {
      if (!y.current)
        return;
      const G = C.current;
      if (K(), te() === "intentional") {
        if (L.type === "pointercancel") {
          G && W();
          return;
        }
        if (!Q(L)) {
          if (G) {
            W();
            return;
          }
          typeof h == "function" && !h(L) || (B.clear(), R.current = !0, M());
        }
      }
    }
    function oe(L) {
      if (te() !== "sloppy" || !P.current || _n(L, n.select("floatingElement")) || _n(L, n.select("domReferenceElement")))
        return;
      const G = L.touches[0];
      if (!G)
        return;
      const ie = Math.abs(G.clientX - P.current.startX), pe = Math.abs(G.clientY - P.current.startY), be = Math.sqrt(ie * ie + pe * pe);
      be > 5 && (P.current.dismissOnTouchEnd = !0), be > 10 && (ee(L), N.clear(), P.current = null);
    }
    function me(L) {
      se(L, oe);
    }
    function de(L) {
      te() !== "sloppy" || !P.current || _n(L, n.select("floatingElement")) || _n(L, n.select("domReferenceElement")) || (P.current.dismissOnTouchEnd && ee(L), N.clear(), P.current = null);
    }
    function he(L) {
      se(L, de);
    }
    const $ = Ke(r), Z = $n(a && $n(rt($, "keydown", O), rt($, "compositionstart", U), rt($, "compositionend", q)), b && $n(rt($, "click", re, !0), rt($, "pointerdown", re, !0), rt($, "pointerup", ne, !0), rt($, "pointercancel", ne, !0), rt($, "mousedown", re, !0), rt($, "mouseup", ne, !0), rt($, "touchstart", ue, !0), rt($, "touchmove", me, !0), rt($, "touchend", he, !0)));
    return () => {
      Z(), Y.clear(), B.clear(), K(), R.current = !1;
    };
  }, [s, r, a, b, h, o, i, S, E, O, M, w, g, n, N]), v.useEffect(M, [h, M]);
  const _ = v.useMemo(() => ({
    onKeyDown: O,
    [wx[d]]: (Y) => {
      D() && n.setOpen(!1, Pe(Bn, Y.nativeEvent));
    },
    ...d !== "intentional" && {
      onClick(Y) {
        D() && n.setOpen(!1, Pe(Bn, Y.nativeEvent));
      }
    }
  }), [O, n, d, D]), A = ge((Y) => {
    if (!o || !i || Y.button !== 0)
      return;
    const B = gt(Y.nativeEvent);
    De(n.select("floatingElement"), B) && (y.current || (y.current = !0, C.current = !1));
  }), F = ge((Y) => {
    !o || !i || (Y.defaultPrevented || Y.nativeEvent.defaultPrevented) && y.current && (C.current = !0);
  }), H = v.useMemo(() => ({
    onKeyDown: O,
    // `onMouseDown` may be blocked if `event.preventDefault()` is called in
    // `onPointerDown`, such as with <NumberField.ScrubArea>.
    // See https://github.com/mui/base-ui/pull/3379
    onPointerDown: F,
    onMouseDown: F,
    onClickCapture: V,
    onMouseDownCapture(Y) {
      V(), A(Y);
    },
    onPointerDownCapture(Y) {
      V(), A(Y);
    },
    onMouseUpCapture: V,
    onTouchEndCapture: V,
    onTouchMoveCapture: V
  }), [O, V, A, F]);
  return v.useMemo(() => i ? {
    reference: _,
    floating: H,
    trigger: _
  } : {}, [i, _, H]);
}
function jf(t, e, n) {
  let {
    reference: o,
    floating: r
  } = t;
  const s = In(e), i = Gc(e), a = Yc(i), l = pn(e), c = s === "y", u = o.x + o.width / 2 - r.width / 2, d = o.y + o.height / 2 - r.height / 2, f = o[a] / 2 - r[a] / 2;
  let p;
  switch (l) {
    case "top":
      p = {
        x: u,
        y: o.y - r.height
      };
      break;
    case "bottom":
      p = {
        x: u,
        y: o.y + o.height
      };
      break;
    case "right":
      p = {
        x: o.x + o.width,
        y: d
      };
      break;
    case "left":
      p = {
        x: o.x - r.width,
        y: d
      };
      break;
    default:
      p = {
        x: o.x,
        y: o.y
      };
  }
  switch (zo(e)) {
    case "start":
      p[i] -= f * (n && c ? -1 : 1);
      break;
    case "end":
      p[i] += f * (n && c ? -1 : 1);
      break;
  }
  return p;
}
async function Rx(t, e) {
  var n;
  e === void 0 && (e = {});
  const {
    x: o,
    y: r,
    platform: s,
    rects: i,
    elements: a,
    strategy: l
  } = t, {
    boundary: c = "clippingAncestors",
    rootBoundary: u = "viewport",
    elementContext: d = "floating",
    altBoundary: f = !1,
    padding: p = 0
  } = xo(e, t), g = Om(p), h = a[f ? d === "floating" ? "reference" : "floating" : d], b = Cs(await s.getClippingRect({
    element: (n = await (s.isElement == null ? void 0 : s.isElement(h))) == null || n ? h : h.contextElement || await (s.getDocumentElement == null ? void 0 : s.getDocumentElement(a.floating)),
    boundary: c,
    rootBoundary: u,
    strategy: l
  })), w = d === "floating" ? {
    x: o,
    y: r,
    width: i.floating.width,
    height: i.floating.height
  } : i.reference, y = await (s.getOffsetParent == null ? void 0 : s.getOffsetParent(a.floating)), C = await (s.isElement == null ? void 0 : s.isElement(y)) ? await (s.getScale == null ? void 0 : s.getScale(y)) || {
    x: 1,
    y: 1
  } : {
    x: 1,
    y: 1
  }, R = Cs(s.convertOffsetParentRelativeRectToViewportRelativeRect ? await s.convertOffsetParentRelativeRectToViewportRelativeRect({
    elements: a,
    rect: w,
    offsetParent: y,
    strategy: l
  }) : w);
  return {
    top: (b.top - R.top + g.top) / C.y,
    bottom: (R.bottom - b.bottom + g.bottom) / C.y,
    left: (b.left - R.left + g.left) / C.x,
    right: (R.right - b.right + g.right) / C.x
  };
}
const Ex = 50, Px = async (t, e, n) => {
  const {
    placement: o = "bottom",
    strategy: r = "absolute",
    middleware: s = [],
    platform: i
  } = n, a = i.detectOverflow ? i : {
    ...i,
    detectOverflow: Rx
  }, l = await (i.isRTL == null ? void 0 : i.isRTL(e));
  let c = await i.getElementRects({
    reference: t,
    floating: e,
    strategy: r
  }), {
    x: u,
    y: d
  } = jf(c, o, l), f = o, p = 0;
  const g = {};
  for (let m = 0; m < s.length; m++) {
    const h = s[m];
    if (!h)
      continue;
    const {
      name: b,
      fn: w
    } = h, {
      x: y,
      y: C,
      data: R,
      reset: S
    } = await w({
      x: u,
      y: d,
      initialPlacement: o,
      placement: f,
      strategy: r,
      middlewareData: g,
      rects: c,
      platform: a,
      elements: {
        reference: t,
        floating: e
      }
    });
    u = y ?? u, d = C ?? d, g[b] = {
      ...g[b],
      ...R
    }, S && p < Ex && (p++, typeof S == "object" && (S.placement && (f = S.placement), S.rects && (c = S.rects === !0 ? await i.getElementRects({
      reference: t,
      floating: e,
      strategy: r
    }) : S.rects), {
      x: u,
      y: d
    } = jf(c, f, l)), m = -1);
  }
  return {
    x: u,
    y: d,
    placement: f,
    strategy: r,
    middlewareData: g
  };
}, Nx = function(t) {
  return t === void 0 && (t = {}), {
    name: "flip",
    options: t,
    async fn(e) {
      var n, o;
      const {
        placement: r,
        middlewareData: s,
        rects: i,
        initialPlacement: a,
        platform: l,
        elements: c
      } = e, {
        mainAxis: u = !0,
        crossAxis: d = !0,
        fallbackPlacements: f,
        fallbackStrategy: p = "bestFit",
        fallbackAxisSideDirection: g = "none",
        flipAlignment: m = !0,
        ...h
      } = xo(t, e);
      if ((n = s.arrow) != null && n.alignmentOffset)
        return {};
      const b = pn(r), w = In(a), y = pn(a) === a, C = await (l.isRTL == null ? void 0 : l.isRTL(c.floating)), R = f || (y || !m ? [sa(a)] : Yy(a)), S = g !== "none";
      !f && S && R.push(...qy(a, m, g, C));
      const E = [a, ...R], P = await l.detectOverflow(e, h), N = [];
      let I = ((o = s.flip) == null ? void 0 : o.overflows) || [];
      if (u && N.push(P[b]), d) {
        const D = Uy(r, i, C);
        N.push(P[D[0]], P[D[1]]);
      }
      if (I = [...I, {
        placement: r,
        overflows: N
      }], !N.every((D) => D <= 0)) {
        var M, T;
        const D = (((M = s.flip) == null ? void 0 : M.index) || 0) + 1, O = E[D];
        if (O && (!(d === "alignment" ? w !== In(O) : !1) || // We leave the current main axis only if every placement on that axis
        // overflows the main axis.
        I.every((A) => In(A.placement) === w ? A.overflows[0] > 0 : !0)))
          return {
            data: {
              index: D,
              overflows: I
            },
            reset: {
              placement: O
            }
          };
        let V = (T = I.filter((_) => _.overflows[0] <= 0).sort((_, A) => _.overflows[1] - A.overflows[1])[0]) == null ? void 0 : T.placement;
        if (!V)
          switch (p) {
            case "bestFit": {
              var k;
              const _ = (k = I.filter((A) => {
                if (S) {
                  const F = In(A.placement);
                  return F === w || // Create a bias to the `y` side axis due to horizontal
                  // reading directions favoring greater width.
                  F === "y";
                }
                return !0;
              }).map((A) => [A.placement, A.overflows.filter((F) => F > 0).reduce((F, H) => F + H, 0)]).sort((A, F) => A[1] - F[1])[0]) == null ? void 0 : k[0];
              _ && (V = _);
              break;
            }
            case "initialPlacement":
              V = a;
              break;
          }
        if (r !== V)
          return {
            reset: {
              placement: V
            }
          };
      }
      return {};
    }
  };
};
function Kf(t, e) {
  return {
    top: t.top - e.height,
    right: t.right - e.width,
    bottom: t.bottom - e.height,
    left: t.left - e.width
  };
}
function qf(t) {
  return By.some((e) => t[e] >= 0);
}
const Ix = function(t) {
  return t === void 0 && (t = {}), {
    name: "hide",
    options: t,
    async fn(e) {
      const {
        rects: n,
        platform: o
      } = e, {
        strategy: r = "referenceHidden",
        ...s
      } = xo(t, e);
      switch (r) {
        case "referenceHidden": {
          const i = await o.detectOverflow(e, {
            ...s,
            elementContext: "reference"
          }), a = Kf(i, n.reference);
          return {
            data: {
              referenceHiddenOffsets: a,
              referenceHidden: qf(a)
            }
          };
        }
        case "escaped": {
          const i = await o.detectOverflow(e, {
            ...s,
            altBoundary: !0
          }), a = Kf(i, n.floating);
          return {
            data: {
              escapedOffsets: a,
              escaped: qf(a)
            }
          };
        }
        default:
          return {};
      }
    }
  };
}, Jm = /* @__PURE__ */ new Set(["left", "top"]);
async function Mx(t, e) {
  const {
    placement: n,
    platform: o,
    elements: r
  } = t, s = await (o.isRTL == null ? void 0 : o.isRTL(r.floating)), i = pn(n), a = zo(n), l = In(n) === "y", c = Jm.has(i) ? -1 : 1, u = s && l ? -1 : 1, d = xo(e, t);
  let {
    mainAxis: f,
    crossAxis: p,
    alignmentAxis: g
  } = typeof d == "number" ? {
    mainAxis: d,
    crossAxis: 0,
    alignmentAxis: null
  } : {
    mainAxis: d.mainAxis || 0,
    crossAxis: d.crossAxis || 0,
    alignmentAxis: d.alignmentAxis
  };
  return a && typeof g == "number" && (p = a === "end" ? g * -1 : g), l ? {
    x: p * u,
    y: f * c
  } : {
    x: f * c,
    y: p * u
  };
}
const Tx = function(t) {
  return t === void 0 && (t = 0), {
    name: "offset",
    options: t,
    async fn(e) {
      var n, o;
      const {
        x: r,
        y: s,
        placement: i,
        middlewareData: a
      } = e, l = await Mx(e, t);
      return i === ((n = a.offset) == null ? void 0 : n.placement) && (o = a.arrow) != null && o.alignmentOffset ? {} : {
        x: r + l.x,
        y: s + l.y,
        data: {
          ...l,
          placement: i
        }
      };
    }
  };
}, kx = function(t) {
  return t === void 0 && (t = {}), {
    name: "shift",
    options: t,
    async fn(e) {
      const {
        x: n,
        y: o,
        placement: r,
        platform: s
      } = e, {
        mainAxis: i = !0,
        crossAxis: a = !1,
        limiter: l = {
          fn: (b) => {
            let {
              x: w,
              y
            } = b;
            return {
              x: w,
              y
            };
          }
        },
        ...c
      } = xo(t, e), u = {
        x: n,
        y: o
      }, d = await s.detectOverflow(e, c), f = In(pn(r)), p = Uc(f);
      let g = u[p], m = u[f];
      if (i) {
        const b = p === "y" ? "top" : "left", w = p === "y" ? "bottom" : "right", y = g + d[b], C = g - d[w];
        g = pc(y, g, C);
      }
      if (a) {
        const b = f === "y" ? "top" : "left", w = f === "y" ? "bottom" : "right", y = m + d[b], C = m - d[w];
        m = pc(y, m, C);
      }
      const h = l.fn({
        ...e,
        [p]: g,
        [f]: m
      });
      return {
        ...h,
        data: {
          x: h.x - n,
          y: h.y - o,
          enabled: {
            [p]: i,
            [f]: a
          }
        }
      };
    }
  };
}, Ox = function(t) {
  return t === void 0 && (t = {}), {
    options: t,
    fn(e) {
      const {
        x: n,
        y: o,
        placement: r,
        rects: s,
        middlewareData: i
      } = e, {
        offset: a = 0,
        mainAxis: l = !0,
        crossAxis: c = !0
      } = xo(t, e), u = {
        x: n,
        y: o
      }, d = In(r), f = Uc(d);
      let p = u[f], g = u[d];
      const m = xo(a, e), h = typeof m == "number" ? {
        mainAxis: m,
        crossAxis: 0
      } : {
        mainAxis: 0,
        crossAxis: 0,
        ...m
      };
      if (l) {
        const y = f === "y" ? "height" : "width", C = s.reference[f] - s.floating[y] + h.mainAxis, R = s.reference[f] + s.reference[y] - h.mainAxis;
        p < C ? p = C : p > R && (p = R);
      }
      if (c) {
        var b, w;
        const y = f === "y" ? "width" : "height", C = Jm.has(pn(r)), R = s.reference[d] - s.floating[y] + (C && ((b = i.offset) == null ? void 0 : b[d]) || 0) + (C ? 0 : h.crossAxis), S = s.reference[d] + s.reference[y] + (C ? 0 : ((w = i.offset) == null ? void 0 : w[d]) || 0) - (C ? h.crossAxis : 0);
        g < R ? g = R : g > S && (g = S);
      }
      return {
        [f]: p,
        [d]: g
      };
    }
  };
}, Dx = function(t) {
  return t === void 0 && (t = {}), {
    name: "size",
    options: t,
    async fn(e) {
      var n, o;
      const {
        placement: r,
        rects: s,
        platform: i,
        elements: a
      } = e, {
        apply: l = () => {
        },
        ...c
      } = xo(t, e), u = await i.detectOverflow(e, c), d = pn(r), f = zo(r), p = In(r) === "y", {
        width: g,
        height: m
      } = s.floating;
      let h, b;
      d === "top" || d === "bottom" ? (h = d, b = f === (await (i.isRTL == null ? void 0 : i.isRTL(a.floating)) ? "start" : "end") ? "left" : "right") : (b = d, h = f === "end" ? "top" : "bottom");
      const w = m - u.top - u.bottom, y = g - u.left - u.right, C = Dr(m - u[h], w), R = Dr(g - u[b], y), S = !e.middlewareData.shift;
      let E = C, P = R;
      if ((n = e.middlewareData.shift) != null && n.enabled.x && (P = y), (o = e.middlewareData.shift) != null && o.enabled.y && (E = w), S && !f) {
        const I = hn(u.left, 0), M = hn(u.right, 0), T = hn(u.top, 0), k = hn(u.bottom, 0);
        p ? P = g - 2 * (I !== 0 || M !== 0 ? I + M : hn(u.left, u.right)) : E = m - 2 * (T !== 0 || k !== 0 ? T + k : hn(u.top, u.bottom));
      }
      await l({
        ...e,
        availableWidth: P,
        availableHeight: E
      });
      const N = await i.getDimensions(a.floating);
      return g !== N.width || m !== N.height ? {
        reset: {
          rects: !0
        }
      } : {};
    }
  };
};
function e1(t) {
  const e = an(t);
  let n = parseFloat(e.width) || 0, o = parseFloat(e.height) || 0;
  const r = bt(t), s = r ? t.offsetWidth : n, i = r ? t.offsetHeight : o, a = ra(n) !== s || ra(o) !== i;
  return a && (n = s, o = i), {
    width: n,
    height: o,
    $: a
  };
}
function ru(t) {
  return lt(t) ? t : t.contextElement;
}
function Nr(t) {
  const e = ru(t);
  if (!bt(e))
    return no(1);
  const n = e.getBoundingClientRect(), {
    width: o,
    height: r,
    $: s
  } = e1(e);
  let i = (s ? ra(n.width) : n.width) / o, a = (s ? ra(n.height) : n.height) / r;
  return (!i || !Number.isFinite(i)) && (i = 1), (!a || !Number.isFinite(a)) && (a = 1), {
    x: i,
    y: a
  };
}
const _x = /* @__PURE__ */ no(0);
function t1(t) {
  const e = vt(t);
  return !Sa() || !e.visualViewport ? _x : {
    x: e.visualViewport.offsetLeft,
    y: e.visualViewport.offsetTop
  };
}
function Vx(t, e, n) {
  return e === void 0 && (e = !1), !n || e && n !== vt(t) ? !1 : e;
}
function nr(t, e, n, o) {
  e === void 0 && (e = !1), n === void 0 && (n = !1);
  const r = t.getBoundingClientRect(), s = ru(t);
  let i = no(1);
  e && (o ? lt(o) && (i = Nr(o)) : i = Nr(t));
  const a = Vx(s, n, o) ? t1(s) : no(0);
  let l = (r.left + a.x) / i.x, c = (r.top + a.y) / i.y, u = r.width / i.x, d = r.height / i.y;
  if (s) {
    const f = vt(s), p = o && lt(o) ? vt(o) : o;
    let g = f, m = ac(g);
    for (; m && o && p !== g; ) {
      const h = Nr(m), b = m.getBoundingClientRect(), w = an(m), y = b.left + (m.clientLeft + parseFloat(w.paddingLeft)) * h.x, C = b.top + (m.clientTop + parseFloat(w.paddingTop)) * h.y;
      l *= h.x, c *= h.y, u *= h.x, d *= h.y, l += y, c += C, g = vt(m), m = ac(g);
    }
  }
  return Cs({
    width: u,
    height: d,
    x: l,
    y: c
  });
}
function ka(t, e) {
  const n = Ra(t).scrollLeft;
  return e ? e.left + n : nr(io(t)).left + n;
}
function n1(t, e) {
  const n = t.getBoundingClientRect(), o = n.left + e.scrollLeft - ka(t, n), r = n.top + e.scrollTop;
  return {
    x: o,
    y: r
  };
}
function Ax(t) {
  let {
    elements: e,
    rect: n,
    offsetParent: o,
    strategy: r
  } = t;
  const s = r === "fixed", i = io(o), a = e ? Ca(e.floating) : !1;
  if (o === i || a && s)
    return n;
  let l = {
    scrollLeft: 0,
    scrollTop: 0
  }, c = no(1);
  const u = no(0), d = bt(o);
  if ((d || !d && !s) && ((nn(o) !== "body" || Lo(i)) && (l = Ra(o)), d)) {
    const p = nr(o);
    c = Nr(o), u.x = p.x + o.clientLeft, u.y = p.y + o.clientTop;
  }
  const f = i && !d && !s ? n1(i, l) : no(0);
  return {
    width: n.width * c.x,
    height: n.height * c.y,
    x: n.x * c.x - l.scrollLeft * c.x + u.x + f.x,
    y: n.y * c.y - l.scrollTop * c.y + u.y + f.y
  };
}
function Fx(t) {
  return Array.from(t.getClientRects());
}
function Lx(t) {
  const e = io(t), n = Ra(t), o = t.ownerDocument.body, r = hn(e.scrollWidth, e.clientWidth, o.scrollWidth, o.clientWidth), s = hn(e.scrollHeight, e.clientHeight, o.scrollHeight, o.clientHeight);
  let i = -n.scrollLeft + ka(t);
  const a = -n.scrollTop;
  return an(o).direction === "rtl" && (i += hn(e.clientWidth, o.clientWidth) - r), {
    width: r,
    height: s,
    x: i,
    y: a
  };
}
const Xf = 25;
function $x(t, e) {
  const n = vt(t), o = io(t), r = n.visualViewport;
  let s = o.clientWidth, i = o.clientHeight, a = 0, l = 0;
  if (r) {
    s = r.width, i = r.height;
    const u = Sa();
    (!u || u && e === "fixed") && (a = r.offsetLeft, l = r.offsetTop);
  }
  const c = ka(o);
  if (c <= 0) {
    const u = o.ownerDocument, d = u.body, f = getComputedStyle(d), p = u.compatMode === "CSS1Compat" && parseFloat(f.marginLeft) + parseFloat(f.marginRight) || 0, g = Math.abs(o.clientWidth - d.clientWidth - p);
    g <= Xf && (s -= g);
  } else c <= Xf && (s += c);
  return {
    width: s,
    height: i,
    x: a,
    y: l
  };
}
function zx(t, e) {
  const n = nr(t, !0, e === "fixed"), o = n.top + t.clientTop, r = n.left + t.clientLeft, s = bt(t) ? Nr(t) : no(1), i = t.clientWidth * s.x, a = t.clientHeight * s.y, l = r * s.x, c = o * s.y;
  return {
    width: i,
    height: a,
    x: l,
    y: c
  };
}
function Zf(t, e, n) {
  let o;
  if (e === "viewport")
    o = $x(t, n);
  else if (e === "document")
    o = Lx(io(t));
  else if (lt(e))
    o = zx(e, n);
  else {
    const r = t1(t);
    o = {
      x: e.x - r.x,
      y: e.y - r.y,
      width: e.width,
      height: e.height
    };
  }
  return Cs(o);
}
function o1(t, e) {
  const n = ro(t);
  return n === e || !lt(n) || to(n) ? !1 : an(n).position === "fixed" || o1(n, e);
}
function Hx(t, e) {
  const n = e.get(t);
  if (n)
    return n;
  let o = bs(t, [], !1).filter((a) => lt(a) && nn(a) !== "body"), r = null;
  const s = an(t).position === "fixed";
  let i = s ? ro(t) : t;
  for (; lt(i) && !to(i); ) {
    const a = an(i), l = Dc(i);
    !l && a.position === "fixed" && (r = null), (s ? !l && !r : !l && a.position === "static" && !!r && (r.position === "absolute" || r.position === "fixed") || Lo(i) && !l && o1(t, i)) ? o = o.filter((u) => u !== i) : r = a, i = ro(i);
  }
  return e.set(t, o), o;
}
function Bx(t) {
  let {
    element: e,
    boundary: n,
    rootBoundary: o,
    strategy: r
  } = t;
  const i = [...n === "clippingAncestors" ? Ca(e) ? [] : Hx(e, this._c) : [].concat(n), o], a = Zf(e, i[0], r);
  let l = a.top, c = a.right, u = a.bottom, d = a.left;
  for (let f = 1; f < i.length; f++) {
    const p = Zf(e, i[f], r);
    l = hn(p.top, l), c = Dr(p.right, c), u = Dr(p.bottom, u), d = hn(p.left, d);
  }
  return {
    width: c - d,
    height: u - l,
    x: d,
    y: l
  };
}
function Wx(t) {
  const {
    width: e,
    height: n
  } = e1(t);
  return {
    width: e,
    height: n
  };
}
function Ux(t, e, n) {
  const o = bt(e), r = io(e), s = n === "fixed", i = nr(t, !0, s, e);
  let a = {
    scrollLeft: 0,
    scrollTop: 0
  };
  const l = no(0);
  function c() {
    l.x = ka(r);
  }
  if (o || !o && !s)
    if ((nn(e) !== "body" || Lo(r)) && (a = Ra(e)), o) {
      const p = nr(e, !0, s, e);
      l.x = p.x + e.clientLeft, l.y = p.y + e.clientTop;
    } else r && c();
  s && !o && r && c();
  const u = r && !o && !s ? n1(r, a) : no(0), d = i.left + a.scrollLeft - l.x - u.x, f = i.top + a.scrollTop - l.y - u.y;
  return {
    x: d,
    y: f,
    width: i.width,
    height: i.height
  };
}
function Sl(t) {
  return an(t).position === "static";
}
function Qf(t, e) {
  if (!bt(t) || an(t).position === "fixed")
    return null;
  if (e)
    return e(t);
  let n = t.offsetParent;
  return io(t) === n && (n = n.ownerDocument.body), n;
}
function r1(t, e) {
  const n = vt(t);
  if (Ca(t))
    return n;
  if (!bt(t)) {
    let r = ro(t);
    for (; r && !to(r); ) {
      if (lt(r) && !Sl(r))
        return r;
      r = ro(r);
    }
    return n;
  }
  let o = Qf(t, e);
  for (; o && g0(o) && Sl(o); )
    o = Qf(o, e);
  return o && to(o) && Sl(o) && !Dc(o) ? n : o || b0(t) || n;
}
const Yx = async function(t) {
  const e = this.getOffsetParent || r1, n = this.getDimensions, o = await n(t.floating);
  return {
    reference: Ux(t.reference, await e(t.floating), t.strategy),
    floating: {
      x: 0,
      y: 0,
      width: o.width,
      height: o.height
    }
  };
};
function Gx(t) {
  return an(t).direction === "rtl";
}
const s1 = {
  convertOffsetParentRelativeRectToViewportRelativeRect: Ax,
  getDocumentElement: io,
  getClippingRect: Bx,
  getOffsetParent: r1,
  getElementRects: Yx,
  getClientRects: Fx,
  getDimensions: Wx,
  getScale: Nr,
  isElement: lt,
  isRTL: Gx
};
function i1(t, e) {
  return t.x === e.x && t.y === e.y && t.width === e.width && t.height === e.height;
}
function jx(t, e) {
  let n = null, o;
  const r = io(t);
  function s() {
    var a;
    clearTimeout(o), (a = n) == null || a.disconnect(), n = null;
  }
  function i(a, l) {
    a === void 0 && (a = !1), l === void 0 && (l = 1), s();
    const c = t.getBoundingClientRect(), {
      left: u,
      top: d,
      width: f,
      height: p
    } = c;
    if (a || e(), !f || !p)
      return;
    const g = qo(d), m = qo(r.clientWidth - (u + f)), h = qo(r.clientHeight - (d + p)), b = qo(u), y = {
      rootMargin: -g + "px " + -m + "px " + -h + "px " + -b + "px",
      threshold: hn(0, Dr(1, l)) || 1
    };
    let C = !0;
    function R(S) {
      const E = S[0].intersectionRatio;
      if (E !== l) {
        if (!C)
          return i();
        E ? i(!1, E) : o = setTimeout(() => {
          i(!1, 1e-7);
        }, 1e3);
      }
      E === 1 && !i1(c, t.getBoundingClientRect()) && i(), C = !1;
    }
    try {
      n = new IntersectionObserver(R, {
        ...y,
        // Handle <iframe>s
        root: r.ownerDocument
      });
    } catch {
      n = new IntersectionObserver(R, y);
    }
    n.observe(t);
  }
  return i(!0), s;
}
function Jf(t, e, n, o) {
  o === void 0 && (o = {});
  const {
    ancestorScroll: r = !0,
    ancestorResize: s = !0,
    elementResize: i = typeof ResizeObserver == "function",
    layoutShift: a = typeof IntersectionObserver == "function",
    animationFrame: l = !1
  } = o, c = ru(t), u = r || s ? [...c ? bs(c) : [], ...e ? bs(e) : []] : [];
  u.forEach((b) => {
    r && b.addEventListener("scroll", n, {
      passive: !0
    }), s && b.addEventListener("resize", n);
  });
  const d = c && a ? jx(c, n) : null;
  let f = -1, p = null;
  i && (p = new ResizeObserver((b) => {
    let [w] = b;
    w && w.target === c && p && e && (p.unobserve(e), cancelAnimationFrame(f), f = requestAnimationFrame(() => {
      var y;
      (y = p) == null || y.observe(e);
    })), n();
  }), c && !l && p.observe(c), e && p.observe(e));
  let g, m = l ? nr(t) : null;
  l && h();
  function h() {
    const b = nr(t);
    m && !i1(m, b) && n(), m = b, g = requestAnimationFrame(h);
  }
  return n(), () => {
    var b;
    u.forEach((w) => {
      r && w.removeEventListener("scroll", n), s && w.removeEventListener("resize", n);
    }), d?.(), (b = p) == null || b.disconnect(), p = null, l && cancelAnimationFrame(g);
  };
}
const Kx = Tx, qx = kx, Xx = Nx, Zx = Dx, Qx = Ix, Jx = Ox, ew = (t, e, n) => {
  const o = /* @__PURE__ */ new Map(), r = {
    platform: s1,
    ...n
  }, s = {
    ...r.platform,
    _c: o
  };
  return Px(t, e, {
    ...r,
    platform: s
  });
};
var tw = typeof document < "u", nw = function() {
}, ji = tw ? Zi : nw;
function ia(t, e) {
  if (t === e)
    return !0;
  if (typeof t != typeof e)
    return !1;
  if (typeof t == "function" && t.toString() === e.toString())
    return !0;
  let n, o, r;
  if (t && e && typeof t == "object") {
    if (Array.isArray(t)) {
      if (n = t.length, n !== e.length) return !1;
      for (o = n; o-- !== 0; )
        if (!ia(t[o], e[o]))
          return !1;
      return !0;
    }
    if (r = Object.keys(t), n = r.length, n !== Object.keys(e).length)
      return !1;
    for (o = n; o-- !== 0; )
      if (!{}.hasOwnProperty.call(e, r[o]))
        return !1;
    for (o = n; o-- !== 0; ) {
      const s = r[o];
      if (!(s === "_owner" && t.$$typeof) && !ia(t[s], e[s]))
        return !1;
    }
    return !0;
  }
  return t !== t && e !== e;
}
function a1(t) {
  return typeof window > "u" ? 1 : (t.ownerDocument.defaultView || window).devicePixelRatio || 1;
}
function ep(t, e) {
  const n = a1(t);
  return Math.round(e * n) / n;
}
function Rl(t) {
  const e = v.useRef(t);
  return ji(() => {
    e.current = t;
  }), e;
}
function ow(t) {
  t === void 0 && (t = {});
  const {
    placement: e = "bottom",
    strategy: n = "absolute",
    middleware: o = [],
    platform: r,
    elements: {
      reference: s,
      floating: i
    } = {},
    transform: a = !0,
    whileElementsMounted: l,
    open: c
  } = t, [u, d] = v.useState({
    x: 0,
    y: 0,
    strategy: n,
    placement: e,
    middlewareData: {},
    isPositioned: !1
  }), [f, p] = v.useState(o);
  ia(f, o) || p(o);
  const [g, m] = v.useState(null), [h, b] = v.useState(null), w = v.useCallback((A) => {
    A !== S.current && (S.current = A, m(A));
  }, []), y = v.useCallback((A) => {
    A !== E.current && (E.current = A, b(A));
  }, []), C = s || g, R = i || h, S = v.useRef(null), E = v.useRef(null), P = v.useRef(u), N = l != null, I = Rl(l), M = Rl(r), T = Rl(c), k = v.useCallback(() => {
    if (!S.current || !E.current)
      return;
    const A = {
      placement: e,
      strategy: n,
      middleware: f
    };
    M.current && (A.platform = M.current), ew(S.current, E.current, A).then((F) => {
      const H = {
        ...F,
        // The floating element's position may be recomputed while it's closed
        // but still mounted (such as when transitioning out). To ensure
        // `isPositioned` will be `false` initially on the next open, avoid
        // setting it to `true` when `open === false` (must be specified).
        isPositioned: T.current !== !1
      };
      D.current && !ia(P.current, H) && (P.current = H, tn.flushSync(() => {
        d(H);
      }));
    });
  }, [f, e, n, M, T]);
  ji(() => {
    c === !1 && P.current.isPositioned && (P.current.isPositioned = !1, d((A) => ({
      ...A,
      isPositioned: !1
    })));
  }, [c]);
  const D = v.useRef(!1);
  ji(() => (D.current = !0, () => {
    D.current = !1;
  }), []), ji(() => {
    if (C && (S.current = C), R && (E.current = R), C && R) {
      if (I.current)
        return I.current(C, R, k);
      k();
    }
  }, [C, R, k, I, N]);
  const O = v.useMemo(() => ({
    reference: S,
    floating: E,
    setReference: w,
    setFloating: y
  }), [w, y]), V = v.useMemo(() => ({
    reference: C,
    floating: R
  }), [C, R]), _ = v.useMemo(() => {
    const A = {
      position: n,
      left: 0,
      top: 0
    };
    if (!V.floating)
      return A;
    const F = ep(V.floating, u.x), H = ep(V.floating, u.y);
    return a ? {
      ...A,
      transform: "translate(" + F + "px, " + H + "px)",
      ...a1(V.floating) >= 1.5 && {
        willChange: "transform"
      }
    } : {
      position: n,
      left: F,
      top: H
    };
  }, [n, a, V.floating, u.x, u.y]);
  return v.useMemo(() => ({
    ...u,
    update: k,
    refs: O,
    elements: V,
    floatingStyles: _
  }), [u, k, O, V, _]);
}
const rw = (t, e) => {
  const n = Kx(t);
  return {
    name: n.name,
    fn: n.fn,
    options: [t, e]
  };
}, sw = (t, e) => {
  const n = qx(t);
  return {
    name: n.name,
    fn: n.fn,
    options: [t, e]
  };
}, iw = (t, e) => ({
  fn: Jx(t).fn,
  options: [t, e]
}), aw = (t, e) => {
  const n = Xx(t);
  return {
    name: n.name,
    fn: n.fn,
    options: [t, e]
  };
}, lw = (t, e) => {
  const n = Zx(t);
  return {
    name: n.name,
    fn: n.fn,
    options: [t, e]
  };
}, cw = (t, e) => {
  const n = Qx(t);
  return {
    name: n.name,
    fn: n.fn,
    options: [t, e]
  };
}, ce = (t, e, n, o, r, s, ...i) => {
  if (i.length > 0)
    throw new Error(process.env.NODE_ENV !== "production" ? "Unsupported number of selectors" : Xe(1));
  let a;
  if (t && e)
    a = (l, c, u, d) => {
      const f = t(l, c, u, d);
      return e(f, c, u, d);
    };
  else if (t)
    a = t;
  else
    throw (
      /* minify-error-disabled */
      new Error("Missing arguments")
    );
  return a;
};
var uw = (t, e, n) => {
  if (e.length === 1 && e[0] === n) {
    let o = !1;
    try {
      const r = {};
      t(r) === r && (o = !0);
    } catch {
    }
    if (o) {
      let r;
      try {
        throw new Error();
      } catch (s) {
        ({ stack: r } = s);
      }
      console.warn(
        `The result function returned its own inputs without modification. e.g
\`createSelector([state => state.todos], todos => todos)\`
This could lead to inefficient memoization and unnecessary re-renders.
Ensure transformation logic is in the result function, and extraction logic is in the input selectors.`,
        { stack: r }
      );
    }
  }
}, dw = (t, e, n) => {
  const { memoize: o, memoizeOptions: r } = e, { inputSelectorResults: s, inputSelectorResultsCopy: i } = t, a = o(() => ({}), ...r);
  if (!(a.apply(null, s) === a.apply(null, i))) {
    let c;
    try {
      throw new Error();
    } catch (u) {
      ({ stack: c } = u);
    }
    console.warn(
      `An input selector returned a different result when passed same arguments.
This means your output selector will likely run more frequently than intended.
Avoid returning a new reference inside your input selector, e.g.
\`createSelector([state => state.todos.map(todo => todo.id)], todoIds => todoIds.length)\``,
      {
        arguments: n,
        firstInputs: s,
        secondInputs: i,
        stack: c
      }
    );
  }
}, fw = {
  inputStabilityCheck: "once",
  identityFunctionCheck: "once"
}, aa = /* @__PURE__ */ Symbol("NOT_FOUND");
function pw(t, e = `expected a function, instead received ${typeof t}`) {
  if (typeof t != "function")
    throw new TypeError(e);
}
function gw(t, e = `expected an object, instead received ${typeof t}`) {
  if (typeof t != "object")
    throw new TypeError(e);
}
function mw(t, e = "expected all items to be functions, instead received the following types: ") {
  if (!t.every((n) => typeof n == "function")) {
    const n = t.map(
      (o) => typeof o == "function" ? `function ${o.name || "unnamed"}()` : typeof o
    ).join(", ");
    throw new TypeError(`${e}[${n}]`);
  }
}
var tp = (t) => Array.isArray(t) ? t : [t];
function hw(t) {
  const e = Array.isArray(t[0]) ? t[0] : t;
  return mw(
    e,
    "createSelector expects all input-selectors to be functions, but received the following types: "
  ), e;
}
function np(t, e) {
  const n = [], { length: o } = t;
  for (let r = 0; r < o; r++)
    n.push(t[r].apply(null, e));
  return n;
}
var bw = (t, e) => {
  const { identityFunctionCheck: n, inputStabilityCheck: o } = {
    ...fw,
    ...e
  };
  return {
    identityFunctionCheck: {
      shouldRun: n === "always" || n === "once" && t,
      run: uw
    },
    inputStabilityCheck: {
      shouldRun: o === "always" || o === "once" && t,
      run: dw
    }
  };
};
function vw(t) {
  let e;
  return {
    get(n) {
      return e && t(e.key, n) ? e.value : aa;
    },
    put(n, o) {
      e = { key: n, value: o };
    },
    getEntries() {
      return e ? [e] : [];
    },
    clear() {
      e = void 0;
    }
  };
}
function yw(t, e) {
  let n = [];
  function o(a) {
    const l = n.findIndex((c) => e(a, c.key));
    if (l > -1) {
      const c = n[l];
      return l > 0 && (n.splice(l, 1), n.unshift(c)), c.value;
    }
    return aa;
  }
  function r(a, l) {
    o(a) === aa && (n.unshift({ key: a, value: l }), n.length > t && n.pop());
  }
  function s() {
    return n;
  }
  function i() {
    n = [];
  }
  return { get: o, put: r, getEntries: s, clear: i };
}
var xw = (t, e) => t === e;
function ww(t) {
  return function(n, o) {
    if (n === null || o === null || n.length !== o.length)
      return !1;
    const { length: r } = n;
    for (let s = 0; s < r; s++)
      if (!t(n[s], o[s]))
        return !1;
    return !0;
  };
}
function Cw(t, e) {
  const n = typeof e == "object" ? e : { equalityCheck: e }, {
    equalityCheck: o = xw,
    maxSize: r = 1,
    resultEqualityCheck: s
  } = n, i = ww(o);
  let a = 0;
  const l = r <= 1 ? vw(i) : yw(r, i);
  function c() {
    let u = l.get(arguments);
    if (u === aa) {
      if (u = t.apply(null, arguments), a++, s) {
        const f = l.getEntries().find(
          (p) => s(p.value, u)
        );
        f && (u = f.value, a !== 0 && a--);
      }
      l.put(arguments, u);
    }
    return u;
  }
  return c.clearCache = () => {
    l.clear(), c.resetResultsCount();
  }, c.resultsCount = () => a, c.resetResultsCount = () => {
    a = 0;
  }, c;
}
var Sw = class {
  constructor(t) {
    this.value = t;
  }
  deref() {
    return this.value;
  }
}, Rw = typeof WeakRef < "u" ? WeakRef : Sw, Ew = 0, op = 1;
function xi() {
  return {
    s: Ew,
    v: void 0,
    o: null,
    p: null
  };
}
function l1(t, e = {}) {
  let n = xi();
  const { resultEqualityCheck: o } = e;
  let r, s = 0;
  function i() {
    let a = n;
    const { length: l } = arguments;
    for (let d = 0, f = l; d < f; d++) {
      const p = arguments[d];
      if (typeof p == "function" || typeof p == "object" && p !== null) {
        let g = a.o;
        g === null && (a.o = g = /* @__PURE__ */ new WeakMap());
        const m = g.get(p);
        m === void 0 ? (a = xi(), g.set(p, a)) : a = m;
      } else {
        let g = a.p;
        g === null && (a.p = g = /* @__PURE__ */ new Map());
        const m = g.get(p);
        m === void 0 ? (a = xi(), g.set(p, a)) : a = m;
      }
    }
    const c = a;
    let u;
    if (a.s === op)
      u = a.v;
    else if (u = t.apply(null, arguments), s++, o) {
      const d = r?.deref?.() ?? r;
      d != null && o(d, u) && (u = d, s !== 0 && s--), r = typeof u == "object" && u !== null || typeof u == "function" ? new Rw(u) : u;
    }
    return c.s = op, c.v = u, u;
  }
  return i.clearCache = () => {
    n = xi(), i.resetResultsCount();
  }, i.resultsCount = () => s, i.resetResultsCount = () => {
    s = 0;
  }, i;
}
function c1(t, ...e) {
  const n = typeof t == "function" ? {
    memoize: t,
    memoizeOptions: e
  } : t, o = (...r) => {
    let s = 0, i = 0, a, l = {}, c = r.pop();
    typeof c == "object" && (l = c, c = r.pop()), pw(
      c,
      `createSelector expects an output function after the inputs, but received: [${typeof c}]`
    );
    const u = {
      ...n,
      ...l
    }, {
      memoize: d,
      memoizeOptions: f = [],
      argsMemoize: p = l1,
      argsMemoizeOptions: g = [],
      devModeChecks: m = {}
    } = u, h = tp(f), b = tp(g), w = hw(r), y = d(function() {
      return s++, c.apply(
        null,
        arguments
      );
    }, ...h);
    let C = !0;
    const R = p(function() {
      i++;
      const E = np(
        w,
        arguments
      );
      if (a = y.apply(null, E), process.env.NODE_ENV !== "production") {
        const { identityFunctionCheck: P, inputStabilityCheck: N } = bw(C, m);
        if (P.shouldRun && P.run(
          c,
          E,
          a
        ), N.shouldRun) {
          const I = np(
            w,
            arguments
          );
          N.run(
            { inputSelectorResults: E, inputSelectorResultsCopy: I },
            { memoize: d, memoizeOptions: h },
            arguments
          );
        }
        C && (C = !1);
      }
      return a;
    }, ...b);
    return Object.assign(R, {
      resultFunc: c,
      memoizedResultFunc: y,
      dependencies: w,
      dependencyRecomputations: () => i,
      resetDependencyRecomputations: () => {
        i = 0;
      },
      lastResult: () => a,
      recomputations: () => s,
      resetRecomputations: () => {
        s = 0;
      },
      memoize: d,
      argsMemoize: p
    });
  };
  return Object.assign(o, {
    withTypes: () => o
  }), o;
}
var Pw = /* @__PURE__ */ c1(l1), Nw = Object.assign(
  (t, e = Pw) => {
    gw(
      t,
      `createStructuredSelector expects first argument to be an object where each property is a selector, instead received a ${typeof t}`
    );
    const n = Object.keys(t), o = n.map(
      (s) => t[s]
    );
    return e(
      o,
      (...s) => s.reduce((i, a, l) => (i[n[l]] = a, i), {})
    );
  },
  { withTypes: () => Nw }
);
const Iw = c1({
  memoize: Cw,
  memoizeOptions: {
    maxSize: 1,
    equalityCheck: Object.is
  }
}), Mw = (...t) => {
  const e = /* @__PURE__ */ new WeakMap();
  let n = 1;
  const o = t[t.length - 1], r = t.length - 1 || 1, s = o.length - r;
  if (s > 3)
    throw new Error(process.env.NODE_ENV !== "production" ? "Unsupported number of arguments" : Xe(2));
  return (a, l, c, u) => {
    let d = a.__cacheKey__;
    d || (d = {
      id: n
    }, a.__cacheKey__ = d, n += 1);
    let f = e.get(d);
    if (!f) {
      let p = t;
      const g = [void 0, void 0, void 0];
      switch (s) {
        case 0:
          break;
        case 1: {
          p = [...t.slice(0, -1), () => g[0], o];
          break;
        }
        case 2: {
          p = [...t.slice(0, -1), () => g[0], () => g[1], o];
          break;
        }
        case 3: {
          p = [...t.slice(0, -1), () => g[0], () => g[1], () => g[2], o];
          break;
        }
        default:
          throw new Error(process.env.NODE_ENV !== "production" ? "Unsupported number of arguments" : Xe(2));
      }
      f = Iw(...p), f.selectorArgs = g, e.set(d, f);
    }
    switch (f.selectorArgs[0] = l, f.selectorArgs[1] = c, f.selectorArgs[2] = u, s) {
      case 0:
        return f(a);
      case 1:
        return f(a, l);
      case 2:
        return f(a, l, c);
      case 3:
        return f(a, l, c, u);
      default:
        throw (
          /* minify-error-disabled */
          new Error("unreachable")
        );
    }
  };
};
var wi = { exports: {} }, El = {};
/**
 * @license React
 * use-sync-external-store-shim.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var rp;
function Tw() {
  if (rp) return El;
  rp = 1;
  var t = Ae;
  function e(d, f) {
    return d === f && (d !== 0 || 1 / d === 1 / f) || d !== d && f !== f;
  }
  var n = typeof Object.is == "function" ? Object.is : e, o = t.useState, r = t.useEffect, s = t.useLayoutEffect, i = t.useDebugValue;
  function a(d, f) {
    var p = f(), g = o({ inst: { value: p, getSnapshot: f } }), m = g[0].inst, h = g[1];
    return s(
      function() {
        m.value = p, m.getSnapshot = f, l(m) && h({ inst: m });
      },
      [d, p, f]
    ), r(
      function() {
        return l(m) && h({ inst: m }), d(function() {
          l(m) && h({ inst: m });
        });
      },
      [d]
    ), i(p), p;
  }
  function l(d) {
    var f = d.getSnapshot;
    d = d.value;
    try {
      var p = f();
      return !n(d, p);
    } catch {
      return !0;
    }
  }
  function c(d, f) {
    return f();
  }
  var u = typeof window > "u" || typeof window.document > "u" || typeof window.document.createElement > "u" ? c : a;
  return El.useSyncExternalStore = t.useSyncExternalStore !== void 0 ? t.useSyncExternalStore : u, El;
}
var Pl = {};
/**
 * @license React
 * use-sync-external-store-shim.development.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var sp;
function kw() {
  return sp || (sp = 1, process.env.NODE_ENV !== "production" && (function() {
    function t(p, g) {
      return p === g && (p !== 0 || 1 / p === 1 / g) || p !== p && g !== g;
    }
    function e(p, g) {
      u || r.startTransition === void 0 || (u = !0, console.error(
        "You are using an outdated, pre-release alpha of React 18 that does not support useSyncExternalStore. The use-sync-external-store shim will not work correctly. Upgrade to a newer pre-release."
      ));
      var m = g();
      if (!d) {
        var h = g();
        s(m, h) || (console.error(
          "The result of getSnapshot should be cached to avoid an infinite loop"
        ), d = !0);
      }
      h = i({
        inst: { value: m, getSnapshot: g }
      });
      var b = h[0].inst, w = h[1];
      return l(
        function() {
          b.value = m, b.getSnapshot = g, n(b) && w({ inst: b });
        },
        [p, m, g]
      ), a(
        function() {
          return n(b) && w({ inst: b }), p(function() {
            n(b) && w({ inst: b });
          });
        },
        [p]
      ), c(m), m;
    }
    function n(p) {
      var g = p.getSnapshot;
      p = p.value;
      try {
        var m = g();
        return !s(p, m);
      } catch {
        return !0;
      }
    }
    function o(p, g) {
      return g();
    }
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(Error());
    var r = Ae, s = typeof Object.is == "function" ? Object.is : t, i = r.useState, a = r.useEffect, l = r.useLayoutEffect, c = r.useDebugValue, u = !1, d = !1, f = typeof window > "u" || typeof window.document > "u" || typeof window.document.createElement > "u" ? o : e;
    Pl.useSyncExternalStore = r.useSyncExternalStore !== void 0 ? r.useSyncExternalStore : f, typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(Error());
  })()), Pl;
}
var ip;
function su() {
  return ip || (ip = 1, process.env.NODE_ENV === "production" ? wi.exports = Tw() : wi.exports = kw()), wi.exports;
}
var iu = su(), Ci = { exports: {} }, Nl = {};
/**
 * @license React
 * use-sync-external-store-shim/with-selector.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var ap;
function Ow() {
  if (ap) return Nl;
  ap = 1;
  var t = Ae, e = su();
  function n(c, u) {
    return c === u && (c !== 0 || 1 / c === 1 / u) || c !== c && u !== u;
  }
  var o = typeof Object.is == "function" ? Object.is : n, r = e.useSyncExternalStore, s = t.useRef, i = t.useEffect, a = t.useMemo, l = t.useDebugValue;
  return Nl.useSyncExternalStoreWithSelector = function(c, u, d, f, p) {
    var g = s(null);
    if (g.current === null) {
      var m = { hasValue: !1, value: null };
      g.current = m;
    } else m = g.current;
    g = a(
      function() {
        function b(S) {
          if (!w) {
            if (w = !0, y = S, S = f(S), p !== void 0 && m.hasValue) {
              var E = m.value;
              if (p(E, S))
                return C = E;
            }
            return C = S;
          }
          if (E = C, o(y, S)) return E;
          var P = f(S);
          return p !== void 0 && p(E, P) ? (y = S, E) : (y = S, C = P);
        }
        var w = !1, y, C, R = d === void 0 ? null : d;
        return [
          function() {
            return b(u());
          },
          R === null ? void 0 : function() {
            return b(R());
          }
        ];
      },
      [u, d, f, p]
    );
    var h = r(c, g[0], g[1]);
    return i(
      function() {
        m.hasValue = !0, m.value = h;
      },
      [h]
    ), l(h), h;
  }, Nl;
}
var Il = {};
/**
 * @license React
 * use-sync-external-store-shim/with-selector.development.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var lp;
function Dw() {
  return lp || (lp = 1, process.env.NODE_ENV !== "production" && (function() {
    function t(c, u) {
      return c === u && (c !== 0 || 1 / c === 1 / u) || c !== c && u !== u;
    }
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(Error());
    var e = Ae, n = su(), o = typeof Object.is == "function" ? Object.is : t, r = n.useSyncExternalStore, s = e.useRef, i = e.useEffect, a = e.useMemo, l = e.useDebugValue;
    Il.useSyncExternalStoreWithSelector = function(c, u, d, f, p) {
      var g = s(null);
      if (g.current === null) {
        var m = { hasValue: !1, value: null };
        g.current = m;
      } else m = g.current;
      g = a(
        function() {
          function b(S) {
            if (!w) {
              if (w = !0, y = S, S = f(S), p !== void 0 && m.hasValue) {
                var E = m.value;
                if (p(E, S))
                  return C = E;
              }
              return C = S;
            }
            if (E = C, o(y, S))
              return E;
            var P = f(S);
            return p !== void 0 && p(E, P) ? (y = S, E) : (y = S, C = P);
          }
          var w = !1, y, C, R = d === void 0 ? null : d;
          return [
            function() {
              return b(u());
            },
            R === null ? void 0 : function() {
              return b(R());
            }
          ];
        },
        [u, d, f, p]
      );
      var h = r(c, g[0], g[1]);
      return i(
        function() {
          m.hasValue = !0, m.value = h;
        },
        [h]
      ), l(h), h;
    }, typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(Error());
  })()), Il;
}
var cp;
function _w() {
  return cp || (cp = 1, process.env.NODE_ENV === "production" ? Ci.exports = Ow() : Ci.exports = Dw()), Ci.exports;
}
var Vw = _w();
const vc = [];
let yc;
function Aw() {
  return yc;
}
function Fw(t) {
  vc.push(t);
}
function au(t) {
  const e = (n, o) => {
    const r = Pt(Lw).current;
    let s;
    try {
      yc = r;
      for (const i of vc)
        i.before(r);
      s = t(n, o);
      for (const i of vc)
        i.after(r);
      r.didInitialize = !0;
    } finally {
      yc = void 0;
    }
    return s;
  };
  return e.displayName = t.displayName || t.name, e;
}
function u1(t) {
  return /* @__PURE__ */ v.forwardRef(au(t));
}
function Lw() {
  return {
    didInitialize: !1
  };
}
const $w = Lc(19), zw = $w ? Bw : Ww;
function fe(t, e, n, o, r) {
  return zw(t, e, n, o, r);
}
function Hw(t, e, n, o, r) {
  const s = v.useCallback(() => e(t.getSnapshot(), n, o, r), [t, e, n, o, r]);
  return iu.useSyncExternalStore(t.subscribe, s, s);
}
Fw({
  before(t) {
    t.syncIndex = 0, t.didInitialize || (t.syncTick = 1, t.syncHooks = [], t.didChangeStore = !0, t.getSnapshot = () => {
      let e = !1;
      for (let n = 0; n < t.syncHooks.length; n += 1) {
        const o = t.syncHooks[n], r = o.selector(o.store.state, o.a1, o.a2, o.a3);
        (o.didChange || !Object.is(o.value, r)) && (e = !0, o.value = r, o.didChange = !1);
      }
      return e && (t.syncTick += 1), t.syncTick;
    });
  },
  after(t) {
    t.syncHooks.length > 0 && (t.didChangeStore && (t.didChangeStore = !1, t.subscribe = (e) => {
      const n = /* @__PURE__ */ new Set();
      for (const r of t.syncHooks)
        n.add(r.store);
      const o = [];
      for (const r of n)
        o.push(r.subscribe(e));
      return () => {
        for (const r of o)
          r();
      };
    }), iu.useSyncExternalStore(t.subscribe, t.getSnapshot, t.getSnapshot));
  }
});
function Bw(t, e, n, o, r) {
  const s = Aw();
  if (!s)
    return Hw(t, e, n, o, r);
  const i = s.syncIndex;
  s.syncIndex += 1;
  let a;
  return s.didInitialize ? (a = s.syncHooks[i], (a.store !== t || a.selector !== e || !Object.is(a.a1, n) || !Object.is(a.a2, o) || !Object.is(a.a3, r)) && (a.store !== t && (s.didChangeStore = !0), a.store = t, a.selector = e, a.a1 = n, a.a2 = o, a.a3 = r, a.didChange = !0)) : (a = {
    store: t,
    selector: e,
    a1: n,
    a2: o,
    a3: r,
    value: e(t.getSnapshot(), n, o, r),
    didChange: !1
  }, s.syncHooks.push(a)), a.value;
}
function Ww(t, e, n, o, r) {
  return Vw.useSyncExternalStoreWithSelector(t.subscribe, t.getSnapshot, t.getSnapshot, (s) => e(s, n, o, r));
}
class lu {
  /**
   * The current state of the store.
   * This property is updated immediately when the state changes as a result of calling {@link setState}, {@link update}, or {@link set}.
   * To subscribe to state changes, use the {@link useState} method. The value returned by {@link useState} is updated after the component renders (similarly to React's useState).
   * The values can be used directly (to avoid subscribing to the store) in effects or event handlers.
   *
   * Do not modify properties in state directly. Instead, use the provided methods to ensure proper state management and listener notification.
   */
  // Internal state to handle recursive `setState()` calls
  constructor(e) {
    this.state = e, this.listeners = /* @__PURE__ */ new Set(), this.updateTick = 0;
  }
  /**
   * Registers a listener that will be called whenever the store's state changes.
   *
   * @param fn The listener function to be called on state changes.
   * @returns A function to unsubscribe the listener.
   */
  subscribe = (e) => (this.listeners.add(e), () => {
    this.listeners.delete(e);
  });
  /**
   * Returns the current state of the store.
   */
  getSnapshot = () => this.state;
  /**
   * Updates the entire store's state and notifies all registered listeners.
   *
   * @param newState The new state to set for the store.
   */
  setState(e) {
    if (this.state === e)
      return;
    this.state = e, this.updateTick += 1;
    const n = this.updateTick;
    for (const o of this.listeners) {
      if (n !== this.updateTick)
        return;
      o(e);
    }
  }
  /**
   * Merges the provided changes into the current state and notifies listeners if there are changes.
   *
   * @param changes An object containing the changes to apply to the current state.
   */
  update(e) {
    for (const n in e)
      if (!Object.is(this.state[n], e[n])) {
        this.setState({
          ...this.state,
          ...e
        });
        return;
      }
  }
  /**
   * Sets a specific key in the store's state to a new value and notifies listeners if the value has changed.
   *
   * @param key The key in the store's state to update.
   * @param value The new value to set for the specified key.
   */
  set(e, n) {
    Object.is(this.state[e], n) || this.setState({
      ...this.state,
      [e]: n
    });
  }
  /**
   * Gives the state a new reference and updates all registered listeners.
   */
  notifyAll() {
    const e = {
      ...this.state
    };
    this.setState(e);
  }
  use(e, n, o, r) {
    return fe(this, e, n, o, r);
  }
}
class ur extends lu {
  /**
   * Creates a new ReactStore instance.
   *
   * @param state Initial state of the store.
   * @param context Non-reactive context values.
   * @param selectors Optional selectors for use with `useState`.
   */
  constructor(e, n = {}, o) {
    super(e), this.context = n, this.selectors = o;
  }
  /**
   * Non-reactive values such as refs, callbacks, etc.
   */
  /**
   * Synchronizes a single external value into the store.
   *
   * Note that the while the value in `state` is updated immediately, the value returned
   * by `useState` is updated before the next render (similarly to React's `useState`).
   */
  useSyncedValue(e, n) {
    v.useDebugValue(e), xe(() => {
      this.state[e] !== n && this.set(e, n);
    }, [e, n]);
  }
  /**
   * Synchronizes a single external value into the store and
   * cleans it up (sets to `undefined`) on unmount.
   *
   * Note that the while the value in `state` is updated immediately, the value returned
   * by `useState` is updated before the next render (similarly to React's `useState`).
   */
  useSyncedValueWithCleanup(e, n) {
    const o = this;
    xe(() => (o.state[e] !== n && o.set(e, n), () => {
      o.set(e, void 0);
    }), [o, e, n]);
  }
  /**
   * Synchronizes multiple external values into the store.
   *
   * Note that the while the values in `state` are updated immediately, the values returned
   * by `useState` are updated before the next render (similarly to React's `useState`).
   */
  useSyncedValues(e) {
    const n = this;
    if (process.env.NODE_ENV !== "production") {
      v.useDebugValue(e, (i) => Object.keys(i));
      const r = v.useRef(Object.keys(e)).current, s = Object.keys(e);
      (r.length !== s.length || r.some((i, a) => i !== s[a])) && console.error("ReactStore.useSyncedValues expects the same prop keys on every render. Keys should be stable.");
    }
    const o = Object.values(e);
    xe(() => {
      n.update(e);
    }, [n, ...o]);
  }
  /**
   * Registers a controllable prop pair (`controlled`, `defaultValue`) for a specific key. If `controlled`
   * is non-undefined, the store's state at `key` is updated to match `controlled`.
   */
  useControlledProp(e, n) {
    v.useDebugValue(e);
    const o = n !== void 0;
    if (xe(() => {
      o && !Object.is(this.state[e], n) && super.setState({
        ...this.state,
        [e]: n
      });
    }, [e, n, o]), process.env.NODE_ENV !== "production") {
      const r = this.controlledValues ??= /* @__PURE__ */ new Map();
      r.has(e) || r.set(e, o);
      const s = r.get(e);
      s !== void 0 && s !== o && console.error(`A component is changing the ${o ? "" : "un"}controlled state of ${e.toString()} to be ${o ? "un" : ""}controlled. Elements should not switch from uncontrolled to controlled (or vice versa).`);
    }
  }
  /** Gets the current value from the store using a selector with the provided key.
   *
   * @param key Key of the selector to use.
   */
  select(e, n, o, r) {
    const s = this.selectors[e];
    return s(this.state, n, o, r);
  }
  /**
   * Returns a value from the store's state using a selector function.
   * Used to subscribe to specific parts of the state.
   * This methods causes a rerender whenever the selected state changes.
   *
   * @param key Key of the selector to use.
   */
  useState(e, n, o, r) {
    return v.useDebugValue(e), fe(this, this.selectors[e], n, o, r);
  }
  /**
   * Wraps a function with `useStableCallback` to ensure it has a stable reference
   * and assigns it to the context.
   *
   * @param key Key of the event callback. Must be a function in the context.
   * @param fn Function to assign.
   */
  useContextCallback(e, n) {
    v.useDebugValue(e);
    const o = ge(n ?? ht);
    this.context[e] = o;
  }
  /**
   * Returns a stable setter function for a specific key in the store's state.
   * It's commonly used to pass as a ref callback to React elements.
   *
   * @param key Key of the state to set.
   */
  useStateSetter(e) {
    const n = v.useRef(void 0);
    return n.current === void 0 && (n.current = (o) => {
      this.set(e, o);
    }), n.current;
  }
  /**
   * Observes changes derived from the store's selectors and calls the listener when the selected value changes.
   *
   * @param key Key of the selector to observe.
   * @param listener Listener function called when the selector result changes.
   */
  observe(e, n) {
    let o;
    typeof e == "function" ? o = e : o = this.selectors[e];
    let r = o(this.state);
    return n(r, r, this), this.subscribe((s) => {
      const i = o(s);
      if (!Object.is(r, i)) {
        const a = r;
        r = i, n(i, a, this);
      }
    });
  }
}
const Uw = {
  open: ce((t) => t.open),
  transitionStatus: ce((t) => t.transitionStatus),
  domReferenceElement: ce((t) => t.domReferenceElement),
  referenceElement: ce((t) => t.positionReference ?? t.referenceElement),
  floatingElement: ce((t) => t.floatingElement),
  floatingId: ce((t) => t.floatingId)
};
class cu extends ur {
  constructor(e) {
    const {
      syncOnly: n,
      nested: o,
      onOpenChange: r,
      triggerElements: s,
      ...i
    } = e;
    super({
      ...i,
      positionReference: i.referenceElement,
      domReferenceElement: i.referenceElement
    }, {
      onOpenChange: r,
      dataRef: {
        current: {}
      },
      events: Qm(),
      nested: o,
      triggerElements: s
    }, Uw), this.syncOnly = n;
  }
  /**
   * Syncs the event used by hover logic to distinguish hover-open from click-like interaction.
   */
  syncOpenEvent = (e, n) => {
    (!e || !this.state.open || // Prevent a pending hover-open from overwriting a click-open event, while allowing
    // click events to upgrade a hover-open.
    n != null && Cm(n)) && (this.context.dataRef.current.openEvent = e ? n : void 0);
  };
  /**
   * Runs the root-owned side effects for an open state change.
   */
  dispatchOpenChange = (e, n) => {
    this.syncOpenEvent(e, n.event);
    const o = {
      open: e,
      reason: n.reason,
      nativeEvent: n.event,
      nested: this.context.nested,
      triggerElement: n.trigger
    };
    this.context.events.emit("openchange", o);
  };
  /**
   * Emits the `openchange` event through the internal event emitter and calls the `onOpenChange` handler with the provided arguments.
   *
   * @param newOpen The new open state.
   * @param eventDetails Details about the event that triggered the open state change.
   */
  setOpen = (e, n) => {
    if (this.syncOnly) {
      this.context.onOpenChange?.(e, n);
      return;
    }
    this.dispatchOpenChange(e, n), this.context.onOpenChange?.(e, n);
  };
}
function Yn(t, e = !1, n = !1) {
  const [o, r] = v.useState(t && e ? "idle" : void 0), [s, i] = v.useState(t);
  return t && !s && (i(!0), r("starting")), !t && s && o !== "ending" && !n && r("ending"), !t && !s && o === "ending" && r(void 0), xe(() => {
    if (!t && s && o !== "ending" && n) {
      const a = Tt.request(() => {
        r("ending");
      });
      return () => {
        Tt.cancel(a);
      };
    }
  }, [t, s, o, n]), xe(() => {
    if (!t || e)
      return;
    const a = Tt.request(() => {
      r(void 0);
    });
    return () => {
      Tt.cancel(a);
    };
  }, [e, t]), xe(() => {
    if (!t || !e)
      return;
    t && s && o !== "idle" && r("starting");
    const a = Tt.request(() => {
      r("idle");
    });
    return () => {
      Tt.cancel(a);
    };
  }, [e, t, s, o]), {
    mounted: s,
    setMounted: i,
    transitionStatus: o
  };
}
let Wn = /* @__PURE__ */ (function(t) {
  return t.startingStyle = "data-starting-style", t.endingStyle = "data-ending-style", t;
})({});
const Yw = {
  [Wn.startingStyle]: ""
}, Gw = {
  [Wn.endingStyle]: ""
}, Lt = {
  transitionStatus(t) {
    return t === "starting" ? Yw : t === "ending" ? Gw : null;
  }
};
function Oa(t, e = !1, n = !0) {
  const o = Fr();
  return ge((r, s = null) => {
    o.cancel();
    const i = co(t);
    if (i == null)
      return;
    const a = i, l = () => {
      tn.flushSync(r);
    };
    if (typeof a.getAnimations != "function" || globalThis.BASE_UI_ANIMATIONS_DISABLED) {
      r();
      return;
    }
    function c() {
      Promise.all(a.getAnimations().map((u) => u.finished)).then(() => {
        s?.aborted || l();
      }).catch(() => {
        if (n) {
          s?.aborted || l();
          return;
        }
        const u = a.getAnimations();
        !s?.aborted && u.length > 0 && u.some((d) => d.pending || d.playState !== "finished") && c();
      });
    }
    if (e) {
      const u = Wn.startingStyle;
      if (!a.hasAttribute(u)) {
        o.request(c);
        return;
      }
      const d = new MutationObserver(() => {
        a.hasAttribute(u) || (d.disconnect(), c());
      });
      d.observe(a, {
        attributes: !0,
        attributeFilter: [u]
      }), s?.addEventListener("abort", () => d.disconnect(), {
        once: !0
      });
      return;
    }
    o.request(c);
  });
}
function Bt(t) {
  const {
    enabled: e = !0,
    open: n,
    ref: o,
    onComplete: r
  } = t, s = ge(r), i = Oa(o, n, !1);
  v.useEffect(() => {
    if (!e)
      return;
    const a = new AbortController();
    return i(s, a.signal), () => {
      a.abort();
    };
  }, [e, n, s, i]);
}
function d1(t, e) {
  const n = v.useRef(null), o = v.useRef(null);
  return v.useCallback((r) => {
    if (t !== void 0) {
      if (n.current !== null) {
        const s = n.current, i = o.current, a = e.context.triggerElements.getById(s);
        i && a === i && e.context.triggerElements.delete(s), n.current = null, o.current = null;
      }
      r !== null && (n.current = t, o.current = r, e.context.triggerElements.add(t, r));
    }
  }, [e, t]);
}
function $s(t, e, n, o) {
  const r = n.useState("isMountedByTrigger", t), s = d1(t, n), i = ge((a) => {
    if (s(a), !a || !n.select("open"))
      return;
    const l = n.select("activeTriggerId");
    if (l === t) {
      n.update({
        activeTriggerElement: a,
        ...o
      });
      return;
    }
    l == null && n.update({
      activeTriggerId: t,
      activeTriggerElement: a,
      ...o
    });
  });
  return xe(() => {
    r && n.update({
      activeTriggerElement: e.current,
      ...o
    });
  }, [r, n, e, ...Object.values(o)]), {
    registerTrigger: i,
    isMountedByThisTrigger: r
  };
}
function zs(t) {
  const e = t.useState("open");
  xe(() => {
    if (e && !t.select("activeTriggerId") && t.context.triggerElements.size === 1) {
      const n = t.context.triggerElements.entries().next();
      if (!n.done) {
        const [o, r] = n.value;
        t.update({
          activeTriggerId: o,
          activeTriggerElement: r
        });
      }
    }
  }, [e, t]);
}
function Hs(t, e, n) {
  const {
    mounted: o,
    setMounted: r,
    transitionStatus: s
  } = Yn(t);
  e.useSyncedValues({
    mounted: o,
    transitionStatus: s
  });
  const i = ge(() => {
    r(!1), e.update({
      activeTriggerId: null,
      activeTriggerElement: null,
      mounted: !1
    }), n?.(), e.context.onOpenChangeComplete?.(!1);
  }), a = e.useState("preventUnmountingOnClose");
  return Bt({
    enabled: !a,
    open: t,
    ref: e.context.popupRef,
    onComplete() {
      t || i();
    }
  }), {
    forceUnmount: i,
    transitionStatus: s
  };
}
class dr {
  constructor() {
    this.elementsSet = /* @__PURE__ */ new Set(), this.idMap = /* @__PURE__ */ new Map();
  }
  /**
   * Adds a trigger element with the given ID.
   *
   * Note: The provided element is assumed to not be registered under multiple IDs.
   */
  add(e, n) {
    const o = this.idMap.get(e);
    if (o !== n && (o !== void 0 && this.elementsSet.delete(o), this.elementsSet.add(n), this.idMap.set(e, n), process.env.NODE_ENV !== "production" && this.elementsSet.size !== this.idMap.size))
      throw new Error("Base UI: A trigger element cannot be registered under multiple IDs in PopupTriggerMap.");
  }
  /**
   * Removes the trigger element with the given ID.
   */
  delete(e) {
    const n = this.idMap.get(e);
    n && (this.elementsSet.delete(n), this.idMap.delete(e));
  }
  /**
   * Whether the given element is registered as a trigger.
   */
  hasElement(e) {
    return this.elementsSet.has(e);
  }
  /**
   * Whether there is a registered trigger element matching the given predicate.
   */
  hasMatchingElement(e) {
    for (const n of this.elementsSet)
      if (e(n))
        return !0;
    return !1;
  }
  /**
   * Returns the trigger element associated with the given ID, or undefined if no such element exists.
   */
  getById(e) {
    return this.idMap.get(e);
  }
  /**
   * Returns an iterable of all registered trigger entries, where each entry is a tuple of [id, element].
   */
  entries() {
    return this.idMap.entries();
  }
  /**
   * Returns an iterable of all registered trigger elements.
   */
  elements() {
    return this.elementsSet.values();
  }
  /**
   * Returns the number of registered trigger elements.
   */
  get size() {
    return this.idMap.size;
  }
}
function jw() {
  return new cu({
    open: !1,
    transitionStatus: void 0,
    floatingElement: null,
    referenceElement: null,
    triggerElements: new dr(),
    floatingId: "",
    syncOnly: !1,
    nested: !1,
    onOpenChange: void 0
  });
}
function Bs() {
  return {
    open: !1,
    openProp: void 0,
    mounted: !1,
    transitionStatus: void 0,
    floatingRootContext: jw(),
    preventUnmountingOnClose: !1,
    payload: void 0,
    activeTriggerId: null,
    activeTriggerElement: null,
    triggerIdProp: void 0,
    popupElement: null,
    positionerElement: null,
    activeTriggerProps: yt,
    inactiveTriggerProps: yt,
    popupProps: yt
  };
}
const Si = ce((t) => t.triggerIdProp ?? t.activeTriggerId), Ws = {
  open: ce((t) => t.openProp ?? t.open),
  mounted: ce((t) => t.mounted),
  transitionStatus: ce((t) => t.transitionStatus),
  floatingRootContext: ce((t) => t.floatingRootContext),
  preventUnmountingOnClose: ce((t) => t.preventUnmountingOnClose),
  payload: ce((t) => t.payload),
  activeTriggerId: Si,
  activeTriggerElement: ce((t) => t.mounted ? t.activeTriggerElement : null),
  /**
   * Whether the trigger with the given ID was used to open the popup.
   */
  isTriggerActive: ce((t, e) => e !== void 0 && Si(t) === e),
  /**
   * Whether the popup is open and was activated by a trigger with the given ID.
   */
  isOpenedByTrigger: ce((t, e) => e !== void 0 && Si(t) === e && t.open),
  /**
   * Whether the popup is mounted and was activated by a trigger with the given ID.
   */
  isMountedByTrigger: ce((t, e) => e !== void 0 && Si(t) === e && t.mounted),
  triggerProps: ce((t, e) => e ? t.activeTriggerProps : t.inactiveTriggerProps),
  popupProps: ce((t) => t.popupProps),
  popupElement: ce((t) => t.popupElement),
  positionerElement: ce((t) => t.positionerElement)
};
function uu(t) {
  const {
    open: e = !1,
    onOpenChange: n,
    elements: o = {}
  } = t, r = wo(), s = ao() != null;
  if (process.env.NODE_ENV !== "production") {
    const a = o.reference;
    a && !lt(a) && console.error("Cannot pass a virtual element to the `elements.reference` option,", "as it must be a real DOM element. Use `context.setPositionReference()`", "instead.");
  }
  const i = Pt(() => new cu({
    open: e,
    transitionStatus: void 0,
    onOpenChange: n,
    referenceElement: o.reference ?? null,
    floatingElement: o.floating ?? null,
    triggerElements: new dr(),
    floatingId: r,
    syncOnly: !1,
    nested: s
  })).current;
  return xe(() => {
    const a = {
      open: e,
      floatingId: r
    };
    o.reference !== void 0 && (a.referenceElement = o.reference, a.domReferenceElement = lt(o.reference) ? o.reference : null), o.floating !== void 0 && (a.floatingElement = o.floating), i.update(a);
  }, [e, r, o.reference, o.floating, i]), i.context.onOpenChange = n, i.context.nested = s, i;
}
function Kw(t = {}) {
  const {
    nodeId: e,
    externalTree: n
  } = t, o = uu(t), r = t.rootContext || o, s = {
    reference: r.useState("referenceElement"),
    floating: r.useState("floatingElement"),
    domReference: r.useState("domReferenceElement")
  }, [i, a] = v.useState(null), l = v.useRef(null), c = Ho(n);
  xe(() => {
    s.domReference && (l.current = s.domReference);
  }, [s.domReference]);
  const u = ow({
    ...t,
    elements: {
      ...s,
      ...i && {
        reference: i
      }
    }
  }), d = v.useCallback((P) => {
    const N = lt(P) ? {
      getBoundingClientRect: () => P.getBoundingClientRect(),
      getClientRects: () => P.getClientRects(),
      contextElement: P
    } : P;
    a(N), u.refs.setReference(N);
  }, [u.refs]), [f, p] = v.useState(void 0), [g, m] = v.useState(null);
  r.useSyncedValue("referenceElement", f ?? null);
  const h = lt(f) ? f : null;
  r.useSyncedValue("domReferenceElement", f === void 0 ? s.domReference : h), r.useSyncedValue("floatingElement", g);
  const b = v.useCallback((P) => {
    (lt(P) || P === null) && (l.current = P, p(P)), (lt(u.refs.reference.current) || u.refs.reference.current === null || // Don't allow setting virtual elements using the old technique back to
    // `null` to support `positionReference` + an unstable `reference`
    // callback ref.
    P !== null && !lt(P)) && u.refs.setReference(P);
  }, [u.refs, p]), w = v.useCallback((P) => {
    m(P), u.refs.setFloating(P);
  }, [u.refs]), y = v.useMemo(() => ({
    ...u.refs,
    setReference: b,
    setFloating: w,
    setPositionReference: d,
    domReference: l
  }), [u.refs, b, w, d]), C = v.useMemo(() => ({
    ...u.elements,
    domReference: s.domReference
  }), [u.elements, s.domReference]), R = r.useState("open"), S = r.useState("floatingId"), E = v.useMemo(() => ({
    ...u,
    dataRef: r.context.dataRef,
    open: R,
    onOpenChange: r.setOpen,
    events: r.context.events,
    floatingId: S,
    refs: y,
    elements: C,
    nodeId: e,
    rootStore: r
  }), [u, y, C, e, r, R, S]);
  return xe(() => {
    r.context.dataRef.current.floatingContext = E;
    const P = c?.nodesRef.current.find((N) => N.id === e);
    P && (P.context = E);
  }), v.useMemo(() => ({
    ...u,
    context: E,
    refs: y,
    elements: C,
    rootStore: r
  }), [u, y, C, E, r]);
}
function Us(t) {
  const {
    popupStore: e,
    treatPopupAsFloatingElement: n = !1,
    onOpenChange: o
  } = t, r = wo(), s = ao() != null, i = e.useState("open"), a = e.useState("activeTriggerElement"), l = e.useState(n ? "popupElement" : "positionerElement"), c = e.context.triggerElements, u = Pt(() => new cu({
    open: i,
    transitionStatus: void 0,
    referenceElement: a,
    floatingElement: l,
    triggerElements: c,
    onOpenChange: o,
    floatingId: r,
    syncOnly: !0,
    nested: s
  })).current;
  return xe(() => {
    const d = {
      open: i,
      floatingId: r,
      referenceElement: a,
      floatingElement: l
    };
    lt(a) && (d.domReferenceElement = a), u.state.positionReference === u.state.referenceElement && (d.positionReference = a), u.update(d);
  }, [i, r, a, l, u]), u.context.onOpenChange = o, u.context.nested = s, u;
}
const Ml = vm && bm;
function du(t, e = {}) {
  const n = "rootStore" in t ? t.rootStore : t, {
    events: o,
    dataRef: r
  } = n.context, {
    enabled: s = !0,
    delay: i
  } = e, a = v.useRef(!1), l = v.useRef(null), c = Vt(), u = v.useRef(!0);
  v.useEffect(() => {
    const f = n.select("domReferenceElement");
    if (!s)
      return;
    const p = vt(f);
    function g() {
      const b = n.select("domReferenceElement");
      !n.select("open") && bt(b) && b === zt(Ke(b)) && (a.current = !0);
    }
    function m() {
      u.current = !0;
    }
    function h() {
      u.current = !1;
    }
    return $n(rt(p, "blur", g), Ml && rt(p, "keydown", m, !0), Ml && rt(p, "pointerdown", h, !0));
  }, [n, s]), v.useEffect(() => {
    if (!s)
      return;
    function f(p) {
      if (p.reason === Bn || p.reason === ar) {
        const g = n.select("domReferenceElement");
        lt(g) && (l.current = g, a.current = !0);
      }
    }
    return o.on("openchange", f), () => {
      o.off("openchange", f);
    };
  }, [o, s, n]);
  const d = v.useMemo(() => ({
    onMouseLeave() {
      a.current = !1, l.current = null;
    },
    onFocus(f) {
      const p = f.currentTarget;
      if (a.current) {
        if (l.current === p)
          return;
        a.current = !1, l.current = null;
      }
      const g = gt(f.nativeEvent);
      if (lt(g)) {
        if (Ml && !f.relatedTarget) {
          if (!u.current && !Na(g))
            return;
        } else if (!oa(g))
          return;
      }
      const m = na(f.relatedTarget, n.context.triggerElements), {
        nativeEvent: h,
        currentTarget: b
      } = f, w = typeof i == "function" ? i() : i;
      if (n.select("open") && m || w === 0 || w === void 0) {
        n.setOpen(!0, Pe(Qo, h, b));
        return;
      }
      c.start(w, () => {
        a.current || n.setOpen(!0, Pe(Qo, h, b));
      });
    },
    onBlur(f) {
      a.current = !1, l.current = null;
      const p = f.relatedTarget, g = f.nativeEvent, m = lt(p) && p.hasAttribute(Rs("focus-guard")) && p.getAttribute("data-type") === "outside";
      c.start(0, () => {
        const h = n.select("domReferenceElement"), b = zt(Ke(h));
        !p && b === h || De(r.current.floatingContext?.refs.floating.current, b) || De(h, b) || m || na(p ?? b, n.context.triggerElements) || n.setOpen(!1, Pe(Qo, g));
      });
    }
  }), [r, n, c, i]);
  return v.useMemo(() => s ? {
    reference: d,
    trigger: d
  } : {}, [s, d]);
}
class fu {
  constructor() {
    this.pointerType = void 0, this.interactedInside = !1, this.handler = void 0, this.blockMouseMove = !0, this.performedPointerEventsMutation = !1, this.pointerEventsScopeElement = null, this.pointerEventsReferenceElement = null, this.pointerEventsFloatingElement = null, this.restTimeoutPending = !1, this.openChangeTimeout = new gn(), this.restTimeout = new gn(), this.handleCloseOptions = void 0;
  }
  static create() {
    return new fu();
  }
  dispose = () => {
    this.openChangeTimeout.clear(), this.restTimeout.clear();
  };
  disposeEffect = () => this.dispose;
}
const la = /* @__PURE__ */ new WeakMap();
function ca(t) {
  if (!t.performedPointerEventsMutation)
    return;
  const e = t.pointerEventsScopeElement;
  e && la.get(e) === t && (t.pointerEventsScopeElement?.style.removeProperty("pointer-events"), t.pointerEventsReferenceElement?.style.removeProperty("pointer-events"), t.pointerEventsFloatingElement?.style.removeProperty("pointer-events"), la.delete(e)), t.performedPointerEventsMutation = !1, t.pointerEventsScopeElement = null, t.pointerEventsReferenceElement = null, t.pointerEventsFloatingElement = null;
}
function f1(t, e) {
  const {
    scopeElement: n,
    referenceElement: o,
    floatingElement: r
  } = e, s = la.get(n);
  s && s !== t && ca(s), ca(t), t.performedPointerEventsMutation = !0, t.pointerEventsScopeElement = n, t.pointerEventsReferenceElement = o, t.pointerEventsFloatingElement = r, la.set(n, t), n.style.pointerEvents = "none", o.style.pointerEvents = "auto", r.style.pointerEvents = "auto";
}
function p1(t) {
  const e = Pt(fu.create).current, n = t.context.dataRef.current;
  return n.hoverInteractionState || (n.hoverInteractionState = e), Ar(n.hoverInteractionState.disposeEffect), n.hoverInteractionState;
}
function Da(t, e = {}) {
  const n = "rootStore" in t ? t.rootStore : t, o = n.useState("open"), r = n.useState("floatingElement"), s = n.useState("domReferenceElement"), {
    dataRef: i
  } = n.context, {
    enabled: a = !0,
    closeDelay: l = 0,
    nodeId: c
  } = e, u = p1(n), d = Ho(), f = ao(), p = ge(() => Sm(i.current.openEvent?.type, u.interactedInside)), g = ge(() => {
    const C = i.current.openEvent?.type;
    return C?.includes("mouse") && C !== "mousedown";
  }), m = ge((C) => na(C, n.context.triggerElements)), h = v.useCallback((C) => {
    const R = ta(l, "close", u.pointerType), S = () => {
      n.setOpen(!1, Pe(Dt, C)), d?.events.emit("floating.closed", C);
    };
    R ? u.openChangeTimeout.start(R, S) : (u.openChangeTimeout.clear(), S());
  }, [l, n, u, d]), b = ge(() => {
    ca(u);
  }), w = ge((C) => {
    const R = gt(C);
    if (!km(R)) {
      u.interactedInside = !1;
      return;
    }
    u.interactedInside = R?.closest("[aria-haspopup]") != null;
  });
  xe(() => {
    o || (u.pointerType = void 0, u.restTimeoutPending = !1, u.interactedInside = !1, b());
  }, [o, u, b]), v.useEffect(() => b, [b]), xe(() => {
    if (a && o && u.handleCloseOptions?.blockPointerEvents && g() && lt(s) && r) {
      const C = s, R = r, S = Ke(r), E = d?.nodesRef.current.find((N) => N.id === f)?.context?.elements.floating;
      E && (E.style.pointerEvents = "");
      const P = u.handleCloseOptions?.getScope?.() ?? u.pointerEventsScopeElement ?? E ?? C.closest("[data-rootownerid]") ?? S.body;
      return f1(u, {
        scopeElement: P,
        referenceElement: C,
        floatingElement: R
      }), () => {
        b();
      };
    }
  }, [a, o, s, r, u, g, d, f, b]);
  const y = Vt();
  v.useEffect(() => {
    if (!a)
      return;
    function C() {
      u.openChangeTimeout.clear(), y.clear(), d?.events.off("floating.closed", S), b();
    }
    function R(P) {
      if (d && f && oo(d.nodesRef.current, f).length > 0) {
        d.events.on("floating.closed", S);
        return;
      }
      if (m(P.relatedTarget))
        return;
      const N = i.current.floatingContext?.nodeId ?? c, I = P.relatedTarget;
      if (!(d && N && lt(I) && oo(d.nodesRef.current, N, !1).some((T) => De(T.context?.elements.floating, I)))) {
        if (u.handler) {
          u.handler(P);
          return;
        }
        b(), p() || h(P);
      }
    }
    function S(P) {
      !d || !f || oo(d.nodesRef.current, f).length > 0 || y.start(0, () => {
        d.events.off("floating.closed", S), n.setOpen(!1, Pe(Dt, P)), d.events.emit("floating.closed", P);
      });
    }
    const E = r;
    return $n(E && rt(E, "mouseenter", C), E && rt(E, "mouseleave", R), E && rt(E, "pointerdown", w, !0), () => {
      d?.events.off("floating.closed", S);
    });
  }, [a, r, n, i, c, p, m, h, b, w, u, d, f, y]);
}
const qw = {
  current: null
};
function Ys(t, e = {}) {
  const n = "rootStore" in t ? t.rootStore : t, {
    dataRef: o,
    events: r
  } = n.context, {
    enabled: s = !0,
    delay: i = 0,
    handleClose: a = null,
    mouseOnly: l = !1,
    restMs: c = 0,
    move: u = !0,
    triggerElementRef: d = qw,
    externalTree: f,
    isActiveTrigger: p = !0,
    getHandleCloseContext: g,
    isClosing: m
  } = e, h = Ho(f), b = p1(n), w = v.useRef(!1), y = _t(a), C = _t(i), R = _t(c), S = _t(s), E = _t(m);
  p && (b.handleCloseOptions = y.current?.__options);
  const P = ge(() => Sm(o.current.openEvent?.type, b.interactedInside)), N = ge((D) => na(D, n.context.triggerElements)), I = ge((D, O, V) => {
    const _ = n.context.triggerElements;
    if (_.hasElement(O))
      return !D || !De(D, O);
    if (!lt(V))
      return !1;
    const A = V;
    return _.hasMatchingElement((F) => De(F, A)) && (!D || !De(D, A));
  }), M = ge((D, O = !0) => {
    const V = ta(C.current, "close", b.pointerType);
    V ? b.openChangeTimeout.start(V, () => {
      n.setOpen(!1, Pe(Dt, D)), h?.events.emit("floating.closed", D);
    }) : O && (b.openChangeTimeout.clear(), n.setOpen(!1, Pe(Dt, D)), h?.events.emit("floating.closed", D));
  }), T = ge(() => {
    if (!b.handler)
      return;
    Ke(n.select("domReferenceElement")).removeEventListener("mousemove", b.handler), b.handler = void 0;
  }), k = ge(() => {
    ca(b);
  });
  return v.useEffect(() => T, [T]), v.useEffect(() => {
    if (!s)
      return;
    function D(O) {
      O.open ? w.current = !1 : (w.current = O.reason === Dt, T(), b.openChangeTimeout.clear(), b.restTimeout.clear(), b.blockMouseMove = !0, b.restTimeoutPending = !1);
    }
    return r.on("openchange", D), () => {
      r.off("openchange", D);
    };
  }, [s, r, b, T]), v.useEffect(() => {
    if (!s)
      return;
    const D = d.current ?? (p ? n.select("domReferenceElement") : null);
    if (!lt(D))
      return;
    function O(_) {
      if (b.openChangeTimeout.clear(), b.blockMouseMove = !1, l && !Or(b.pointerType))
        return;
      const A = kf(R.current), F = ta(C.current, "open", b.pointerType), H = gt(_), Y = _.currentTarget ?? null, B = n.select("domReferenceElement");
      let U = Y;
      if (lt(H) && !n.context.triggerElements.hasElement(H)) {
        for (const X of n.context.triggerElements.elements())
          if (De(X, H)) {
            U = X;
            break;
          }
      }
      lt(Y) && lt(B) && !n.context.triggerElements.hasElement(Y) && De(Y, B) && (U = B);
      const q = U == null ? !1 : I(B, U, H), W = n.select("open"), K = E.current?.() ?? n.select("transitionStatus") === "ending", te = !W && K && w.current, z = !q && lt(U) && lt(B) && De(B, U) && te, Q = A > 0 && !F, ee = q && (W || te) || z, ae = !W || q;
      if (ee) {
        n.setOpen(!0, Pe(Dt, _, U));
        return;
      }
      Q || (F ? b.openChangeTimeout.start(F, () => {
        ae && n.setOpen(!0, Pe(Dt, _, U));
      }) : ae && n.setOpen(!0, Pe(Dt, _, U)));
    }
    function V(_) {
      if (P()) {
        k();
        return;
      }
      T();
      const A = n.select("domReferenceElement"), F = Ke(A);
      b.restTimeout.clear(), b.restTimeoutPending = !1;
      const H = o.current.floatingContext ?? g?.();
      if (N(_.relatedTarget))
        return;
      if (y.current && H) {
        n.select("open") || b.openChangeTimeout.clear();
        const U = d.current;
        b.handler = y.current({
          ...H,
          tree: h,
          x: _.clientX,
          y: _.clientY,
          onClose() {
            k(), T(), S.current && !P() && U === n.select("domReferenceElement") && M(_, !0);
          }
        }), F.addEventListener("mousemove", b.handler), b.handler(_);
        return;
      }
      (b.pointerType !== "touch" || !De(n.select("floatingElement"), _.relatedTarget)) && M(_);
    }
    return u ? $n(rt(D, "mousemove", O, {
      once: !0
    }), rt(D, "mouseenter", O), rt(D, "mouseleave", V)) : $n(rt(D, "mouseenter", O), rt(D, "mouseleave", V));
  }, [T, k, o, C, M, n, s, y, b, p, I, P, N, l, u, R, d, h, S, g, E]), v.useMemo(() => {
    if (!s)
      return;
    function D(O) {
      b.pointerType = O.pointerType;
    }
    return {
      onPointerDown: D,
      onPointerEnter: D,
      onMouseMove(O) {
        const {
          nativeEvent: V
        } = O, _ = O.currentTarget, A = n.select("domReferenceElement"), F = n.select("open"), H = I(A, _, O.target);
        if (l && !Or(b.pointerType))
          return;
        if (F && H && b.handleCloseOptions?.blockPointerEvents) {
          const U = n.select("floatingElement");
          if (U) {
            const q = b.handleCloseOptions?.getScope?.() ?? _.ownerDocument.body;
            f1(b, {
              scopeElement: q,
              referenceElement: _,
              floatingElement: U
            });
          }
        }
        const Y = kf(R.current);
        if (F && !H || Y === 0 || !H && b.restTimeoutPending && O.movementX ** 2 + O.movementY ** 2 < 2)
          return;
        b.restTimeout.clear();
        function B() {
          if (b.restTimeoutPending = !1, P())
            return;
          const U = n.select("open");
          !b.blockMouseMove && (!U || H) && n.setOpen(!0, Pe(Dt, V, _));
        }
        b.pointerType === "touch" ? tn.flushSync(() => {
          B();
        }) : H && F ? B() : (b.restTimeoutPending = !0, b.restTimeout.start(Y, B));
      }
    };
  }, [s, b, P, I, l, n, R]);
}
function Gn(t = []) {
  const e = t.map((c) => c?.reference), n = t.map((c) => c?.floating), o = t.map((c) => c?.item), r = t.map((c) => c?.trigger), s = v.useCallback(
    (c) => Ri(c, t, "reference"),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    e
  ), i = v.useCallback(
    (c) => Ri(c, t, "floating"),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    n
  ), a = v.useCallback(
    (c) => Ri(c, t, "item"),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    o
  ), l = v.useCallback(
    (c) => Ri(c, t, "trigger"),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    r
  );
  return v.useMemo(() => ({
    getReferenceProps: s,
    getFloatingProps: i,
    getItemProps: a,
    getTriggerProps: l
  }), [s, i, a, l]);
}
function Ri(t, e, n) {
  const o = /* @__PURE__ */ new Map(), r = n === "item", s = {};
  n === "floating" && (s.tabIndex = -1, s[dc] = "");
  for (const i in t)
    r && t && (i === Im || i === Mm) || (s[i] = t[i]);
  for (let i = 0; i < e.length; i += 1) {
    let a;
    const l = e[i]?.[n];
    typeof l == "function" ? a = t ? l(t) : null : a = l, a && up(s, a, r, o);
  }
  return up(s, t, r, o), s;
}
function up(t, e, n, o) {
  for (const r in e) {
    const s = e[r];
    n && (r === Im || r === Mm) || (r.startsWith("on") ? (o.has(r) || o.set(r, []), typeof s == "function" && (o.get(r)?.push(s), t[r] = (...i) => o.get(r)?.map((a) => a(...i)).find((a) => a !== void 0))) : t[r] = s);
  }
}
const Xw = "Escape";
function _a(t, e, n) {
  switch (t) {
    case "vertical":
      return e;
    case "horizontal":
      return n;
    default:
      return e || n;
  }
}
function Ei(t, e) {
  return _a(e, t === Wc || t === Fs, t === Oo || t === Do);
}
function Tl(t, e, n) {
  return _a(e, t === Fs, n ? t === Oo : t === Do) || t === "Enter" || t === " " || t === "";
}
function Zw(t, e, n) {
  return _a(e, n ? t === Oo : t === Do, t === Fs);
}
function Qw(t, e, n, o) {
  const r = n ? t === Do : t === Oo, s = t === Wc;
  return e === "both" || e === "horizontal" && o && o > 1 ? t === Xw : _a(e, r, s);
}
function pu(t, e) {
  const n = "rootStore" in t ? t.rootStore : t, o = n.useState("open"), r = n.useState("floatingElement"), s = n.useState("domReferenceElement"), i = n.context.dataRef, {
    listRef: a,
    activeIndex: l,
    onNavigate: c = () => {
    },
    enabled: u = !0,
    selectedIndex: d = null,
    allowEscape: f = !1,
    loopFocus: p = !1,
    nested: g = !1,
    rtl: m = !1,
    virtual: h = !1,
    focusItemOnOpen: b = "auto",
    focusItemOnHover: w = !0,
    openOnArrowKeyDown: y = !0,
    disabledIndices: C = void 0,
    orientation: R = "vertical",
    parentOrientation: S,
    cols: E = 1,
    id: P,
    resetOnPointerLeave: N = !0,
    externalTree: I
  } = e;
  process.env.NODE_ENV !== "production" && (f && (p || console.warn("`useListNavigation` looping must be enabled to allow escaping."), h || console.warn("`useListNavigation` must be virtual to allow escaping.")), R === "vertical" && E > 1 && console.warn("In grid list navigation mode (`cols` > 1), the `orientation` should", 'be either "horizontal" or "both".'));
  const M = ws(r), T = _t(M), k = ao(), D = Ho(I);
  xe(() => {
    i.current.orientation = R;
  }, [i, R]);
  const O = fc(s), V = v.useRef(b), _ = v.useRef(d ?? -1), A = v.useRef(null), F = v.useRef(!0), H = ge(($) => {
    c(_.current === -1 ? null : _.current, $);
  }), Y = v.useRef(H), B = v.useRef(!!r), U = v.useRef(o), q = v.useRef(!1), W = v.useRef(!1), K = v.useRef(null), te = _t(C), z = _t(o), Q = _t(d), ee = _t(N), ae = ge(() => {
    function $(ie) {
      h ? D?.events.emit("virtualfocus", ie) : K.current = Gi(ie, {
        sync: q.current,
        preventScroll: !0
      });
    }
    const Z = a.current[_.current], L = W.current;
    Z && $(Z), (q.current ? (ie) => ie() : requestAnimationFrame)(() => {
      const ie = a.current[_.current] || Z;
      if (!ie)
        return;
      Z || $(ie), // eslint-disable-next-line @typescript-eslint/no-use-before-define
      ue && (L || !F.current) && ie.scrollIntoView?.({
        block: "nearest",
        inline: "nearest"
      });
    });
  });
  xe(() => {
    u && (o && r ? (_.current = d ?? -1, V.current && d != null && (W.current = !0, H())) : B.current && (_.current = -1, Y.current()));
  }, [u, o, r, d, H]), xe(() => {
    if (u) {
      if (!o) {
        q.current = !1;
        return;
      }
      if (r)
        if (l == null) {
          if (q.current = !1, Q.current != null)
            return;
          if (B.current && (_.current = -1, ae()), (!U.current || !B.current) && V.current && (A.current != null || V.current === !0 && A.current == null)) {
            let $ = 0;
            const Z = () => {
              a.current[0] == null ? ($ < 2 && ($ ? requestAnimationFrame : queueMicrotask)(Z), $ += 1) : (_.current = A.current == null || Tl(A.current, R, m) || g ? Yi(a) : mc(a), A.current = null, H());
            };
            Z();
          }
        } else Ss(a.current, l) || (_.current = l, ae(), W.current = !1);
    }
  }, [u, o, r, l, Q, g, a, R, m, H, ae, te]), xe(() => {
    if (!u || r || !D || h || !B.current)
      return;
    const $ = D.nodesRef.current, Z = $.find((ie) => ie.id === k)?.context?.elements.floating, L = zt(Ke(r)), G = $.some((ie) => ie.context && De(ie.context.elements.floating, L));
    Z && !G && F.current && Z.focus({
      preventScroll: !0
    });
  }, [u, r, D, k, h]), xe(() => {
    Y.current = H, U.current = o, B.current = !!r;
  }), xe(() => {
    o || (A.current = null, V.current = b);
  }, [o, b]);
  const X = l != null, se = ge(($) => {
    if (!z.current)
      return;
    const Z = a.current.indexOf($.currentTarget);
    Z !== -1 && (_.current !== Z || l !== Z) && (_.current = Z, H($));
  }), ue = v.useMemo(() => ({
    onFocus(Z) {
      q.current = !0, se(Z);
    },
    onClick: ({
      currentTarget: Z
    }) => Z.focus({
      preventScroll: !0
    }),
    // Safari
    onMouseMove(Z) {
      q.current = !0, W.current = !1, w && se(Z);
    },
    onPointerLeave(Z) {
      if (!z.current || !F.current || Z.pointerType === "touch")
        return;
      q.current = !0;
      const L = Z.relatedTarget;
      if (!(!w || a.current.includes(L)) && ee.current && (K.current?.(), K.current = null, _.current = -1, H(Z), !h)) {
        const G = T.current, ie = zt(Ke(G));
        G && De(G, ie) && G.focus({
          preventScroll: !0
        });
      }
    }
  }), [se, z, T, w, a, H, ee, h]), re = v.useCallback(() => S ?? D?.nodesRef.current.find(($) => $.id === k)?.context?.dataRef?.current.orientation, [k, D, S]), ne = ge(($) => {
    if (F.current = !1, q.current = !0, $.which === 229 || !z.current && $.currentTarget === T.current)
      return;
    if (g && Qw($.key, R, m, E)) {
      Ei($.key, re()) || Ot($), n.setOpen(!1, Pe(Er, $.nativeEvent)), bt(s) && (h ? D?.events.emit("virtualfocus", s) : s.focus());
      return;
    }
    const Z = _.current, L = Yi(a, C), G = mc(a, C);
    if (O || ($.key === "Home" && (Ot($), _.current = L, H($)), $.key === "End" && (Ot($), _.current = G, H($))), E > 1) {
      const ie = Array.from({
        length: a.current.length
      }, () => ({
        width: 1,
        height: 1
      })), pe = _m(ie, E, !1), be = pe.findIndex((ke) => ke != null && !bo(a.current, ke, C)), Re = pe.reduce((ke, Se, Ie) => Se != null && !bo(a.current, Se, C) ? Ie : ke, -1), _e = pe[Dm(pe.map((ke) => ke != null ? a.current[ke] : null), {
        event: $,
        orientation: R,
        loopFocus: p,
        rtl: m,
        cols: E,
        // treat undefined (empty grid spaces) as disabled indices so we
        // don't end up in them
        disabledIndices: Am([...(typeof C != "function" ? C : null) || a.current.map((ke, Se) => bo(a.current, Se, C) ? Se : void 0), void 0], pe),
        minIndex: be,
        maxIndex: Re,
        prevIndex: Vm(
          _.current > G ? L : _.current,
          ie,
          pe,
          E,
          // use a corner matching the edge closest to the direction
          // we're moving in so we don't end up in the same item. Prefer
          // top/left over bottom/right.
          // eslint-disable-next-line no-nested-ternary
          $.key === Fs ? "bl" : $.key === (m ? Oo : Do) ? "tr" : "tl"
        ),
        stopEvent: !0
      })];
      if (_e != null && (_.current = _e, H($)), R === "both")
        return;
    }
    if (Ei($.key, R)) {
      if (Ot($), o && !h && zt($.currentTarget.ownerDocument) === $.currentTarget) {
        _.current = Tl($.key, R, m) ? L : G, H($);
        return;
      }
      Tl($.key, R, m) ? p ? Z >= G ? f && Z !== a.current.length ? _.current = -1 : (q.current = !1, _.current = L) : _.current = Jt(a.current, {
        startingIndex: Z,
        disabledIndices: C
      }) : _.current = Math.min(G, Jt(a.current, {
        startingIndex: Z,
        disabledIndices: C
      })) : p ? Z <= L ? f && Z !== -1 ? _.current = a.current.length : (q.current = !1, _.current = G) : _.current = Jt(a.current, {
        startingIndex: Z,
        decrement: !0,
        disabledIndices: C
      }) : _.current = Math.max(L, Jt(a.current, {
        startingIndex: Z,
        decrement: !0,
        disabledIndices: C
      })), Ss(a.current, _.current) && (_.current = -1), H($);
    }
  }), oe = v.useMemo(() => h && o && X && {
    "aria-activedescendant": `${P}-${l}`
  }, [h, o, X, P, l]), me = v.useMemo(() => ({
    "aria-orientation": R === "both" ? void 0 : R,
    ...O ? {} : oe,
    onKeyDown($) {
      if ($.key === "Tab" && $.shiftKey && o && !h) {
        const Z = gt($.nativeEvent);
        if (Z && !De(T.current, Z))
          return;
        Ot($), n.setOpen(!1, Pe(yo, $.nativeEvent)), bt(s) && s.focus();
        return;
      }
      ne($);
    },
    onPointerMove() {
      F.current = !0;
    }
  }), [oe, ne, T, R, O, n, o, h, s]), de = v.useMemo(() => {
    function $(L) {
      b === "auto" && xm(L.nativeEvent) && (V.current = !h);
    }
    function Z(L) {
      V.current = b, b === "auto" && wm(L.nativeEvent) && (V.current = !0);
    }
    return {
      onKeyDown(L) {
        const G = n.select("open");
        F.current = !1;
        const ie = L.key.startsWith("Arrow"), pe = Zw(L.key, re(), m), be = Ei(L.key, R), Re = (g ? pe : be) || L.key === "Enter" || L.key.trim() === "";
        if (h && G)
          return ne(L);
        if (!(!G && !y && ie)) {
          if (Re) {
            const _e = Ei(L.key, re());
            A.current = g && _e ? null : L.key;
          }
          if (g) {
            pe && (Ot(L), G ? (_.current = Yi(a, te.current), H(L)) : n.setOpen(!0, Pe(Er, L.nativeEvent, L.currentTarget)));
            return;
          }
          be && (Q.current != null && (_.current = Q.current), Ot(L), !G && y ? n.setOpen(!0, Pe(Er, L.nativeEvent, L.currentTarget)) : ne(L), G && H(L));
        }
      },
      onFocus(L) {
        n.select("open") && !h && (_.current = -1, H(L));
      },
      onPointerDown: Z,
      onPointerEnter: Z,
      onMouseDown: $,
      onClick: $
    };
  }, [ne, te, b, a, g, H, n, y, R, re, m, Q, h]), he = v.useMemo(() => ({
    ...oe,
    ...de
  }), [oe, de]);
  return v.useMemo(() => u ? {
    reference: he,
    floating: me,
    item: ue,
    trigger: de
  } : {}, [u, he, me, de, ue]);
}
const Jw = /* @__PURE__ */ new Map([["select", "listbox"], ["combobox", "listbox"], ["label", !1]]);
function gu(t, e = {}) {
  const n = "rootStore" in t ? t.rootStore : t, o = n.useState("open"), r = n.useState("floatingId"), s = n.useState("domReferenceElement"), i = n.useState("floatingElement"), {
    role: a = "dialog"
  } = e, l = wo(), c = s?.id || l, u = v.useMemo(() => ws(i)?.id || r, [i, r]), d = Jw.get(a) ?? a, p = ao() != null, g = v.useMemo(() => d === "tooltip" || a === "label" ? yt : {
    "aria-haspopup": d === "alertdialog" ? "dialog" : d,
    "aria-expanded": "false",
    ...d === "listbox" && {
      role: "combobox"
    },
    ...d === "menu" && p && {
      role: "menuitem"
    },
    ...a === "select" && {
      "aria-autocomplete": "none"
    },
    ...a === "combobox" && {
      "aria-autocomplete": "list"
    }
  }, [d, p, a]), m = v.useMemo(() => d === "tooltip" || a === "label" ? {
    [`aria-${a === "label" ? "labelledby" : "describedby"}`]: o ? u : void 0
  } : {
    ...g,
    "aria-expanded": o ? "true" : "false",
    "aria-controls": o ? u : void 0,
    ...d === "menu" && {
      id: c
    }
  }, [d, u, o, c, a, g]), h = v.useMemo(() => {
    const w = {
      id: u,
      ...d && {
        role: d
      }
    };
    return d === "tooltip" || a === "label" ? w : {
      ...w,
      ...d === "menu" && {
        "aria-labelledby": c
      }
    };
  }, [d, u, c, a]), b = v.useCallback(({
    active: w,
    selected: y
  }) => {
    const C = {
      role: "option",
      ...w && {
        id: `${u}-fui-option`
      }
    };
    switch (a) {
      case "select":
      case "combobox":
        return {
          ...C,
          "aria-selected": y
        };
    }
    return {};
  }, [u, a]);
  return v.useMemo(() => ({
    reference: m,
    floating: h,
    item: b,
    trigger: g
  }), [m, h, g, b]);
}
function mu(t, e) {
  const n = "rootStore" in t ? t.rootStore : t, o = n.context.dataRef, r = n.useState("open"), {
    listRef: s,
    elementsRef: i,
    activeIndex: a,
    onMatch: l,
    onTypingChange: c,
    enabled: u = !0,
    resetMs: d = 750,
    selectedIndex: f = null
  } = e, p = Vt(), g = v.useRef(""), m = v.useRef(f ?? a ?? -1), h = v.useRef(null);
  xe(() => {
    !r && f !== null || (p.clear(), h.current = null, g.current !== "" && (g.current = ""));
  }, [r, f, p]), xe(() => {
    r && g.current === "" && (m.current = f ?? a ?? -1);
  }, [r, f, a]);
  const b = ge((S) => {
    S ? o.current.typing || (o.current.typing = S, c?.(S)) : o.current.typing && (o.current.typing = S, c?.(S));
  }), w = ge((S) => {
    function E(O) {
      const V = i?.current[O];
      return !V || Ia(V);
    }
    function P(O, V, _ = 0) {
      if (O.length === 0)
        return -1;
      const A = (_ % O.length + O.length) % O.length, F = V.toLocaleLowerCase();
      for (let H = 0; H < O.length; H += 1) {
        const Y = (A + H) % O.length;
        if (!(!O[Y]?.toLocaleLowerCase().startsWith(F) || !E(Y)))
          return Y;
      }
      return -1;
    }
    const N = s.current;
    if (g.current.length > 0 && S.key === " " && (Ot(S), b(!0)), g.current.length > 0 && g.current[0] !== " " && P(N, g.current) === -1 && S.key !== " " && b(!1), N == null || // Character key.
    S.key.length !== 1 || // Modifier key.
    S.ctrlKey || S.metaKey || S.altKey)
      return;
    r && S.key !== " " && (Ot(S), b(!0));
    const I = g.current === "";
    I && (m.current = f ?? a ?? -1), N.every((O) => O ? O[0]?.toLocaleLowerCase() !== O[1]?.toLocaleLowerCase() : !0) && g.current === S.key && (g.current = "", m.current = h.current), g.current += S.key, p.start(d, () => {
      g.current = "", m.current = h.current, b(!1);
    });
    const k = ((I ? f ?? a ?? -1 : m.current) ?? 0) + 1, D = P(N, g.current, k);
    D !== -1 ? (l?.(D), h.current = D) : S.key !== " " && (g.current = "", b(!1));
  }), y = ge((S) => {
    const E = S.relatedTarget, P = n.select("domReferenceElement"), N = n.select("floatingElement"), I = De(P, E), M = De(N, E);
    I || M || (p.clear(), g.current = "", m.current = h.current, b(!1));
  }), C = v.useMemo(() => ({
    onKeyDown: w,
    onBlur: y
  }), [w, y]), R = v.useMemo(() => ({
    onKeyDown: w,
    onBlur: y
  }), [w, y]);
  return v.useMemo(() => u ? {
    reference: C,
    floating: R
  } : {}, [u, C, R]);
}
const dp = 0.1, eC = dp * dp, Ct = 0.5;
function Pi(t, e, n, o, r, s) {
  return o >= e != s >= e && t <= (r - n) * (e - o) / (s - o) + n;
}
function Ni(t, e, n, o, r, s, i, a, l, c) {
  let u = !1;
  return Pi(t, e, n, o, r, s) && (u = !u), Pi(t, e, r, s, i, a) && (u = !u), Pi(t, e, i, a, l, c) && (u = !u), Pi(t, e, l, c, n, o) && (u = !u), u;
}
function tC(t, e, n) {
  return t >= n.x && t <= n.x + n.width && e >= n.y && e <= n.y + n.height;
}
function Ii(t, e, n, o, r, s) {
  const i = Math.min(n, r), a = Math.max(n, r), l = Math.min(o, s), c = Math.max(o, s);
  return t >= i && t <= a && e >= l && e <= c;
}
function Gs(t = {}) {
  const {
    blockPointerEvents: e = !1
  } = t, n = new gn(), o = ({
    x: r,
    y: s,
    placement: i,
    elements: a,
    onClose: l,
    nodeId: c,
    tree: u
  }) => {
    const d = i?.split("-")[0];
    let f = !1, p = null, g = null, m = typeof performance < "u" ? performance.now() : 0;
    function h(w, y) {
      const C = performance.now(), R = C - m;
      if (p === null || g === null || R === 0)
        return p = w, g = y, m = C, !1;
      const S = w - p, E = y - g, P = S * S + E * E, N = R * R * eC;
      return p = w, g = y, m = C, P < N;
    }
    function b() {
      n.clear(), l();
    }
    return function(y) {
      n.clear();
      const C = a.domReference, R = a.floating;
      if (!C || !R || d == null || r == null || s == null)
        return;
      const {
        clientX: S,
        clientY: E
      } = y, P = gt(y), N = y.type === "mouseleave", I = De(R, P), M = De(C, P);
      if (I && (f = !0, !N))
        return;
      if (M && (f = !1, !N)) {
        f = !0;
        return;
      }
      if (N && lt(y.relatedTarget) && De(R, y.relatedTarget))
        return;
      function T() {
        return !!(u && oo(u.nodesRef.current, c).length > 0);
      }
      function k() {
        T() || b();
      }
      if (T())
        return;
      const D = C.getBoundingClientRect(), O = R.getBoundingClientRect(), V = r > O.right - O.width / 2, _ = s > O.bottom - O.height / 2, A = O.width > D.width, F = O.height > D.height, H = (A ? D : O).left, Y = (A ? D : O).right, B = (F ? D : O).top, U = (F ? D : O).bottom;
      if (d === "top" && s >= D.bottom - 1 || d === "bottom" && s <= D.top + 1 || d === "left" && r >= D.right - 1 || d === "right" && r <= D.left + 1) {
        k();
        return;
      }
      let q = !1;
      switch (d) {
        case "top":
          q = Ii(S, E, H, D.top + 1, Y, O.bottom - 1);
          break;
        case "bottom":
          q = Ii(S, E, H, O.top + 1, Y, D.bottom - 1);
          break;
        case "left":
          q = Ii(S, E, O.right - 1, U, D.left + 1, B);
          break;
        case "right":
          q = Ii(S, E, D.right - 1, U, O.left + 1, B);
          break;
      }
      if (q)
        return;
      if (f && !tC(S, E, D)) {
        k();
        return;
      }
      if (!N && h(S, E)) {
        k();
        return;
      }
      let W = !1;
      switch (d) {
        case "top": {
          const K = A ? Ct / 2 : Ct * 4, te = A || V ? r + K : r - K, z = A ? r - K : V ? r + K : r - K, Q = s + Ct + 1, ee = V || A ? O.bottom - Ct : O.top, ae = V ? A ? O.bottom - Ct : O.top : O.bottom - Ct;
          W = Ni(S, E, te, Q, z, Q, O.left, ee, O.right, ae);
          break;
        }
        case "bottom": {
          const K = A ? Ct / 2 : Ct * 4, te = A || V ? r + K : r - K, z = A ? r - K : V ? r + K : r - K, Q = s - Ct, ee = V || A ? O.top + Ct : O.bottom, ae = V ? A ? O.top + Ct : O.bottom : O.top + Ct;
          W = Ni(S, E, te, Q, z, Q, O.left, ee, O.right, ae);
          break;
        }
        case "left": {
          const K = F ? Ct / 2 : Ct * 4, te = F || _ ? s + K : s - K, z = F ? s - K : _ ? s + K : s - K, Q = r + Ct + 1, ee = _ || F ? O.right - Ct : O.left, ae = _ ? F ? O.right - Ct : O.left : O.right - Ct;
          W = Ni(S, E, ee, O.top, ae, O.bottom, Q, te, Q, z);
          break;
        }
        case "right": {
          const K = F ? Ct / 2 : Ct * 4, te = F || _ ? s + K : s - K, z = F ? s - K : _ ? s + K : s - K, Q = r - Ct, ee = _ || F ? O.left + Ct : O.right, ae = _ ? F ? O.left + Ct : O.right : O.left + Ct;
          W = Ni(S, E, Q, te, Q, z, ee, O.top, ae, O.bottom);
          break;
        }
      }
      W ? f || n.start(40, k) : k();
    };
  };
  return o.__options = {
    ...t,
    blockPointerEvents: e
  }, o;
}
const hu = /* @__PURE__ */ v.createContext(void 0);
process.env.NODE_ENV !== "production" && (hu.displayName = "PreviewCardRootContext");
function js(t) {
  const e = v.useContext(hu);
  if (e === void 0 && !t)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: PreviewCardRootContext is missing. PreviewCard parts must be placed within <PreviewCard.Root>." : Xe(50));
  return e;
}
const nC = 600, g1 = 300, oC = {
  ...Ws,
  instantType: ce((t) => t.instantType),
  hasViewport: ce((t) => t.hasViewport)
};
class bu extends ur {
  constructor(e) {
    super({
      ...rC(),
      ...e
    }, {
      popupRef: /* @__PURE__ */ v.createRef(),
      onOpenChange: void 0,
      onOpenChangeComplete: void 0,
      triggerElements: new dr(),
      closeDelayRef: {
        current: g1
      }
    }, oC);
  }
  setOpen = (e, n) => {
    const o = n.reason, r = o === Dt, s = e && o === Qo, i = !e && (o === Bn || o === ar);
    if (n.preventUnmountOnClose = () => {
      this.set("preventUnmountingOnClose", !0);
    }, this.context.onOpenChange?.(e, n), n.isCanceled)
      return;
    this.state.floatingRootContext.dispatchOpenChange(e, n);
    const a = () => {
      const l = {
        open: e
      };
      s ? l.instantType = "focus" : i ? l.instantType = "dismiss" : o === Dt && (l.instantType = void 0);
      const c = n.trigger?.id ?? null;
      (c || e) && (l.activeTriggerId = c, l.activeTriggerElement = n.trigger ?? null), this.update(l);
    };
    r ? tn.flushSync(a) : a();
  };
  static useStore(e, n) {
    const o = Pt(() => new bu(n)).current, r = e ?? o, s = Us({
      popupStore: r,
      onOpenChange: r.setOpen
    });
    return r.state.floatingRootContext = s, r;
  }
}
function rC() {
  return {
    ...Bs(),
    instantType: void 0,
    hasViewport: !1
  };
}
function fp(t) {
  const {
    open: e,
    defaultOpen: n = !1,
    onOpenChange: o,
    onOpenChangeComplete: r,
    actionsRef: s,
    handle: i,
    triggerId: a,
    defaultTriggerId: l = null,
    children: c
  } = t, u = bu.useStore(i?.store, {
    open: n,
    openProp: e,
    activeTriggerId: l,
    triggerIdProp: a
  });
  sr(() => {
    e === void 0 && u.state.open === !1 && n === !0 && u.update({
      open: !0,
      activeTriggerId: l
    });
  }), u.useControlledProp("openProp", e), u.useControlledProp("triggerIdProp", a), u.useContextCallback("onOpenChange", o), u.useContextCallback("onOpenChangeComplete", r);
  const d = u.useState("open"), f = u.select("floatingRootContext"), p = u.useState("activeTriggerId"), g = u.useState("payload");
  zs(u);
  const {
    forceUnmount: m
  } = Hs(d, u);
  xe(() => {
    d && p == null && u.set("payload", void 0);
  }, [u, p, d]);
  const h = v.useCallback(() => {
    u.setOpen(!1, Pe(As));
  }, [u]);
  v.useImperativeHandle(s, () => ({
    unmount: m,
    close: h
  }), [m, h]);
  const b = cr(f), {
    getReferenceProps: w,
    getTriggerProps: y,
    getFloatingProps: C
  } = Gn([b]), R = v.useMemo(() => w(), [w]), S = v.useMemo(() => y(), [y]), E = v.useMemo(() => C(), [C]);
  return u.useSyncedValues({
    activeTriggerProps: R,
    inactiveTriggerProps: S,
    popupProps: E
  }), /* @__PURE__ */ x(hu.Provider, {
    value: u,
    children: typeof c == "function" ? c({
      payload: g
    }) : c
  });
}
function sC(t) {
  return js(!0) ? /* @__PURE__ */ x(fp, {
    ...t
  }) : /* @__PURE__ */ x(nu, {
    children: /* @__PURE__ */ x(fp, {
      ...t
    })
  });
}
const vu = /* @__PURE__ */ v.createContext(void 0);
process.env.NODE_ENV !== "production" && (vu.displayName = "PreviewCardPortalContext");
function iC() {
  const t = v.useContext(vu);
  if (t === void 0)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: <PreviewCard.Portal> is missing." : Xe(48));
  return t;
}
const Va = /* @__PURE__ */ v.forwardRef(function(e, n) {
  const {
    children: o,
    container: r,
    className: s,
    render: i,
    style: a,
    ...l
  } = e, {
    portalNode: c,
    portalSubtree: u
  } = Zm({
    container: r,
    ref: n,
    componentProps: e,
    elementProps: l
  });
  return !u && !c ? null : /* @__PURE__ */ j(v.Fragment, {
    children: [u, c && /* @__PURE__ */ tn.createPortal(o, c)]
  });
});
process.env.NODE_ENV !== "production" && (Va.displayName = "FloatingPortalLite");
const m1 = /* @__PURE__ */ v.forwardRef(function(e, n) {
  const {
    keepMounted: o = !1,
    ...r
  } = e;
  return js().useState("mounted") || o ? /* @__PURE__ */ x(vu.Provider, {
    value: o,
    children: /* @__PURE__ */ x(Va, {
      ref: n,
      ...r
    })
  }) : null;
});
process.env.NODE_ENV !== "production" && (m1.displayName = "PreviewCardPortal");
let rn = (function(t) {
  return t.open = "data-open", t.closed = "data-closed", t[t.startingStyle = Wn.startingStyle] = "startingStyle", t[t.endingStyle = Wn.endingStyle] = "endingStyle", t.anchorHidden = "data-anchor-hidden", t.side = "data-side", t.align = "data-align", t;
})({}), ua = /* @__PURE__ */ (function(t) {
  return t.popupOpen = "data-popup-open", t.pressed = "data-pressed", t;
})({});
const aC = {
  [ua.popupOpen]: ""
}, lC = {
  [ua.popupOpen]: "",
  [ua.pressed]: ""
}, cC = {
  [rn.open]: ""
}, uC = {
  [rn.closed]: ""
}, dC = {
  [rn.anchorHidden]: ""
}, fr = {
  open(t) {
    return t ? aC : null;
  }
}, Es = {
  open(t) {
    return t ? lC : null;
  }
}, xn = {
  open(t) {
    return t ? cC : uC;
  },
  anchorHidden(t) {
    return t ? dC : null;
  }
};
function St(t) {
  return wo(t, "base-ui");
}
const h1 = /* @__PURE__ */ v.forwardRef(function(e, n) {
  const {
    render: o,
    className: r,
    delay: s,
    closeDelay: i,
    id: a,
    payload: l,
    handle: c,
    style: u,
    ...d
  } = e, f = js(!0), p = c?.store ?? f;
  if (!p)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: <PreviewCard.Trigger> must be either used within a <PreviewCard.Root> component or provided with a handle." : Xe(89));
  const g = St(a), m = p.useState("isTriggerActive", g), h = p.useState("isOpenedByTrigger", g), b = p.useState("floatingRootContext"), w = v.useRef(null), y = s ?? nC, C = i ?? g1, {
    registerTrigger: R,
    isMountedByThisTrigger: S
  } = $s(g, w, p, {
    payload: l
  });
  xe(() => {
    S && (p.context.closeDelayRef.current = C);
  }, [p, S, C]);
  const E = Ys(b, {
    mouseOnly: !0,
    move: !1,
    handleClose: Gs(),
    delay: () => ({
      open: y,
      close: C
    }),
    triggerElementRef: w,
    isActiveTrigger: m,
    isClosing: () => p.select("transitionStatus") === "ending"
  }), P = du(b, {
    delay: y
  }), N = {
    open: h
  }, I = p.useState("triggerProps", S);
  return Te("a", e, {
    state: N,
    ref: [n, R, w],
    props: [E, P.reference, I, {
      id: g
    }, d],
    stateAttributesMapping: fr
  });
});
process.env.NODE_ENV !== "production" && (h1.displayName = "PreviewCardTrigger");
const yu = /* @__PURE__ */ v.createContext(void 0);
process.env.NODE_ENV !== "production" && (yu.displayName = "PreviewCardPositionerContext");
function fC() {
  const t = v.useContext(yu);
  if (t === void 0)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: <PreviewCard.Popup> and <PreviewCard.Arrow> must be used within the <PreviewCard.Positioner> component" : Xe(49));
  return t;
}
const b1 = /* @__PURE__ */ v.createContext(void 0);
process.env.NODE_ENV !== "production" && (b1.displayName = "DirectionContext");
function Ks() {
  return v.useContext(b1)?.direction ?? "ltr";
}
const pC = (t) => ({
  name: "arrow",
  options: t,
  async fn(e) {
    const {
      x: n,
      y: o,
      placement: r,
      rects: s,
      platform: i,
      elements: a,
      middlewareData: l
    } = e, {
      element: c,
      padding: u = 0,
      offsetParent: d = "real"
    } = xo(t, e) || {};
    if (c == null)
      return {};
    const f = Om(u), p = {
      x: n,
      y: o
    }, g = Gc(r), m = Yc(g), h = await i.getDimensions(c), b = g === "y", w = b ? "top" : "left", y = b ? "bottom" : "right", C = b ? "clientHeight" : "clientWidth", R = s.reference[m] + s.reference[g] - p[g] - s.floating[m], S = p[g] - s.reference[g], E = d === "real" ? await i.getOffsetParent?.(c) : a.floating;
    let P = a.floating[C] || s.floating[m];
    (!P || !await i.isElement?.(E)) && (P = a.floating[C] || s.floating[m]);
    const N = R / 2 - S / 2, I = P / 2 - h[m] / 2 - 1, M = Math.min(f[w], I), T = Math.min(f[y], I), k = M, D = P - h[m] - T, O = P / 2 - h[m] / 2 + N, V = pc(k, O, D), _ = !l.arrow && zo(r) != null && O !== V && s.reference[m] / 2 - (O < k ? M : T) - h[m] / 2 < 0, A = _ ? O < k ? O - k : O - D : 0;
    return {
      [g]: p[g] + A,
      data: {
        [g]: V,
        centerOffset: O - V - A,
        ..._ && {
          alignmentOffset: A
        }
      },
      reset: _
    };
  }
}), gC = (t, e) => ({
  ...pC(t),
  options: [t, e]
}), mC = {
  name: "hide",
  async fn(t) {
    const {
      width: e,
      height: n,
      x: o,
      y: r
    } = t.rects.reference, s = e === 0 && n === 0 && o === 0 && r === 0;
    return {
      data: {
        referenceHidden: (await cw().fn(t)).data?.referenceHidden || s
      }
    };
  }
}, Ki = {
  sideX: "left",
  sideY: "top"
}, Aa = {
  name: "adaptiveOrigin",
  async fn(t) {
    const {
      x: e,
      y: n,
      rects: {
        floating: o
      },
      elements: {
        floating: r
      },
      platform: s,
      strategy: i,
      placement: a
    } = t, l = vt(r), c = l.getComputedStyle(r);
    if (!(c.transitionDuration !== "0s" && c.transitionDuration !== ""))
      return {
        x: e,
        y: n,
        data: Ki
      };
    const d = await s.getOffsetParent?.(r);
    let f = {
      width: 0,
      height: 0
    };
    if (i === "fixed" && l?.visualViewport)
      f = {
        width: l.visualViewport.width,
        height: l.visualViewport.height
      };
    else if (d === l) {
      const w = Ke(r);
      f = {
        width: w.documentElement.clientWidth,
        height: w.documentElement.clientHeight
      };
    } else await s.isElement?.(d) && (f = await s.getDimensions(d));
    const p = pn(a);
    let g = e, m = n;
    p === "left" && (g = f.width - (e + o.width)), p === "top" && (m = f.height - (n + o.height));
    const h = p === "left" ? "right" : Ki.sideX, b = p === "top" ? "bottom" : Ki.sideY;
    return {
      x: g,
      y: m,
      data: {
        sideX: h,
        sideY: b
      }
    };
  }
};
function v1(t, e, n) {
  const o = t === "inline-start" || t === "inline-end";
  return {
    top: "top",
    right: o ? n ? "inline-start" : "inline-end" : "right",
    bottom: "bottom",
    left: o ? n ? "inline-end" : "inline-start" : "left"
  }[e];
}
function pp(t, e, n) {
  const {
    rects: o,
    placement: r
  } = t;
  return {
    side: v1(e, pn(r), n),
    align: zo(r) || "center",
    anchor: {
      width: o.reference.width,
      height: o.reference.height
    },
    positioner: {
      width: o.floating.width,
      height: o.floating.height
    }
  };
}
function Hr(t) {
  const {
    // Public parameters
    anchor: e,
    positionMethod: n = "absolute",
    side: o = "bottom",
    sideOffset: r = 0,
    align: s = "center",
    alignOffset: i = 0,
    collisionBoundary: a,
    collisionPadding: l = 5,
    sticky: c = !1,
    arrowPadding: u = 5,
    disableAnchorTracking: d = !1,
    // Private parameters
    keepMounted: f = !1,
    floatingRootContext: p,
    mounted: g,
    collisionAvoidance: m,
    shiftCrossAxis: h = !1,
    nodeId: b,
    adaptiveOrigin: w,
    lazyFlip: y = !1,
    externalTree: C
  } = t, [R, S] = v.useState(null);
  !g && R !== null && S(null);
  const E = m.side || "flip", P = m.align || "flip", N = m.fallbackAxisSide || "end", I = typeof e == "function" ? e : void 0, M = ge(I), T = I ? M : e, k = _t(e), D = _t(g), V = Ks() === "rtl", _ = R || {
    top: "top",
    right: "right",
    bottom: "bottom",
    left: "left",
    "inline-end": V ? "left" : "right",
    "inline-start": V ? "right" : "left"
  }[o], A = s === "center" ? _ : `${_}-${s}`;
  let F = l;
  const H = 1, Y = o === "bottom" ? H : 0, B = o === "top" ? H : 0, U = o === "right" ? H : 0, q = o === "left" ? H : 0;
  typeof F == "number" ? F = {
    top: F + Y,
    right: F + q,
    bottom: F + B,
    left: F + U
  } : F && (F = {
    top: (F.top || 0) + Y,
    right: (F.right || 0) + q,
    bottom: (F.bottom || 0) + B,
    left: (F.left || 0) + U
  });
  const W = {
    boundary: a === "clipping-ancestors" ? "clippingAncestors" : a,
    padding: F
  }, K = v.useRef(null), te = _t(r), z = _t(i), ae = [rw(($e) => {
    const Ce = pp($e, o, V), Oe = typeof te.current == "function" ? te.current(Ce) : te.current, Ne = typeof z.current == "function" ? z.current(Ce) : z.current;
    return {
      mainAxis: Oe,
      crossAxis: Ne,
      alignmentAxis: Ne
    };
  }, [typeof r != "function" ? r : 0, typeof i != "function" ? i : 0, V, o])], X = P === "none" && E !== "shift", se = !X && (c || h || E === "shift"), ue = E === "none" ? null : aw({
    ...W,
    // Ensure the popup flips if it's been limited by its --available-height and it resizes.
    // Since the size() padding is smaller than the flip() padding, flip() will take precedence.
    padding: {
      top: F.top + H,
      right: F.right + H,
      bottom: F.bottom + H,
      left: F.left + H
    },
    mainAxis: !h && E === "flip",
    crossAxis: P === "flip" ? "alignment" : !1,
    fallbackAxisSideDirection: N
  }), re = X ? null : sw(($e) => {
    const Ce = Ke($e.elements.floating).documentElement;
    return {
      ...W,
      // Use the Layout Viewport to avoid shifting around when pinch-zooming
      // for context menus.
      rootBoundary: h ? {
        x: 0,
        y: 0,
        width: Ce.clientWidth,
        height: Ce.clientHeight
      } : void 0,
      mainAxis: P !== "none",
      crossAxis: se,
      limiter: c || h ? void 0 : iw((Oe) => {
        if (!K.current)
          return {};
        const {
          width: Ne,
          height: Be
        } = K.current.getBoundingClientRect(), ze = In(pn(Oe.placement)), Me = ze === "y" ? Ne : Be, Wt = ze === "y" ? F.left + F.right : F.top + F.bottom;
        return {
          offset: Me / 2 + Wt / 2
        };
      })
    };
  }, [W, c, h, F, P]);
  E === "shift" || P === "shift" || s === "center" ? ae.push(re, ue) : ae.push(ue, re), ae.push(lw({
    ...W,
    apply({
      elements: {
        floating: $e
      },
      availableWidth: Ce,
      availableHeight: Oe,
      rects: Ne
    }) {
      if (!D.current)
        return;
      const Be = $e.style;
      Be.setProperty("--available-width", `${Ce}px`), Be.setProperty("--available-height", `${Oe}px`);
      const ze = vt($e).devicePixelRatio || 1, {
        x: Me,
        y: Wt,
        width: ft,
        height: ve
      } = Ne.reference, we = (Math.round((Me + ft) * ze) - Math.round(Me * ze)) / ze, Ve = (Math.round((Wt + ve) * ze) - Math.round(Wt * ze)) / ze;
      Be.setProperty("--anchor-width", `${we}px`), Be.setProperty("--anchor-height", `${Ve}px`);
    }
  }), gC(() => ({
    // `transform-origin` calculations rely on an element existing. If the arrow hasn't been set,
    // we'll create a fake element.
    element: K.current || Ke(K.current).createElement("div"),
    padding: u,
    offsetParent: "floating"
  }), [u]), {
    name: "transformOrigin",
    fn($e) {
      const {
        elements: Ce,
        middlewareData: Oe,
        placement: Ne,
        rects: Be,
        y: ze
      } = $e, Me = pn(Ne), Wt = In(Me), ft = K.current, ve = Oe.arrow?.x || 0, we = Oe.arrow?.y || 0, Ve = ft?.clientWidth || 0, He = ft?.clientHeight || 0, ct = ve + Ve / 2, qe = we + He / 2, it = Math.abs(Oe.shift?.y || 0), Ue = Be.reference.height / 2, We = typeof r == "function" ? r(pp($e, o, V)) : r, Qe = it > We, nt = {
        top: `${ct}px calc(100% + ${We}px)`,
        bottom: `${ct}px ${-We}px`,
        left: `calc(100% + ${We}px) ${qe}px`,
        right: `${-We}px ${qe}px`
      }[Me], dt = `${ct}px ${Be.reference.y + Ue - ze}px`;
      return Ce.floating.style.setProperty("--transform-origin", se && Wt === "y" && Qe ? dt : nt), {};
    }
  }, mC, w), xe(() => {
    !g && p && p.update({
      referenceElement: null,
      floatingElement: null,
      domReferenceElement: null,
      positionReference: null
    });
  }, [g, p]);
  const ne = v.useMemo(() => ({
    elementResize: !d && typeof ResizeObserver < "u",
    layoutShift: !d && typeof IntersectionObserver < "u"
  }), [d]), {
    refs: oe,
    elements: me,
    x: de,
    y: he,
    middlewareData: $,
    update: Z,
    placement: L,
    context: G,
    isPositioned: ie,
    floatingStyles: pe
  } = Kw({
    rootContext: p,
    open: f ? g : void 0,
    placement: A,
    middleware: ae,
    strategy: n,
    whileElementsMounted: f ? void 0 : (...$e) => Jf(...$e, ne),
    nodeId: b,
    externalTree: C
  }), {
    sideX: be,
    sideY: Re
  } = $.adaptiveOrigin || Ki, _e = ie ? n : "fixed", ke = v.useMemo(() => {
    const $e = w ? {
      position: _e,
      [be]: de,
      [Re]: he
    } : {
      position: _e,
      ...pe
    };
    return ie || ($e.opacity = 0), $e;
  }, [w, _e, be, de, Re, he, pe, ie]), Se = v.useRef(null);
  xe(() => {
    if (!g)
      return;
    const $e = k.current, Ce = typeof $e == "function" ? $e() : $e, Ne = (gp(Ce) ? Ce.current : Ce) || null || null;
    Ne !== Se.current && (oe.setPositionReference(Ne), Se.current = Ne);
  }, [g, oe, T, k]), v.useEffect(() => {
    if (!g)
      return;
    const $e = k.current;
    typeof $e != "function" && gp($e) && $e.current !== Se.current && (oe.setPositionReference($e.current), Se.current = $e.current);
  }, [g, oe, T, k]), v.useEffect(() => {
    if (f && g && me.domReference && me.floating)
      return Jf(me.domReference, me.floating, Z, ne);
  }, [f, g, me, Z, ne]);
  const Ie = pn(L), Le = v1(o, Ie, V), Ze = zo(L) || "center", tt = !!$.hide?.referenceHidden;
  xe(() => {
    y && g && ie && S(Ie);
  }, [y, g, ie, Ie]);
  const ut = v.useMemo(() => ({
    position: "absolute",
    top: $.arrow?.y,
    left: $.arrow?.x
  }), [$.arrow]), at = $.arrow?.centerOffset !== 0;
  return v.useMemo(() => ({
    positionerStyles: ke,
    arrowStyles: ut,
    arrowRef: K,
    arrowUncentered: at,
    side: Le,
    align: Ze,
    physicalSide: Ie,
    anchorHidden: tt,
    refs: oe,
    context: G,
    isPositioned: ie,
    update: Z
  }), [ke, ut, K, at, Le, Ze, Ie, tt, oe, G, ie, Z]);
}
function gp(t) {
  return t != null && "current" in t;
}
function pr(t) {
  return t === "starting" ? ux : yt;
}
function Br(t, e, {
  styles: n,
  transitionStatus: o,
  props: r,
  refs: s,
  hidden: i,
  inert: a = !1
}) {
  const l = {
    ...n
  };
  return a && (l.pointerEvents = "none"), Te("div", t, {
    state: e,
    ref: s,
    props: [{
      role: "presentation",
      hidden: i,
      style: l
    }, pr(o), r],
    stateAttributesMapping: xn
  });
}
const y1 = /* @__PURE__ */ v.forwardRef(function(e, n) {
  const {
    render: o,
    className: r,
    anchor: s,
    positionMethod: i = "absolute",
    side: a = "bottom",
    align: l = "center",
    sideOffset: c = 0,
    alignOffset: u = 0,
    collisionBoundary: d = "clipping-ancestors",
    collisionPadding: f = 5,
    arrowPadding: p = 5,
    sticky: g = !1,
    disableAnchorTracking: m = !1,
    collisionAvoidance: h = Ma,
    style: b,
    ...w
  } = e, y = js(), C = iC(), R = Ta(), S = y.useState("open"), E = y.useState("mounted"), P = y.useState("floatingRootContext"), N = y.useState("instantType"), I = y.useState("transitionStatus"), M = y.useState("hasViewport"), T = Hr({
    anchor: s,
    floatingRootContext: P,
    positionMethod: i,
    mounted: E,
    side: a,
    sideOffset: c,
    align: l,
    alignOffset: u,
    arrowPadding: p,
    collisionBoundary: d,
    collisionPadding: f,
    sticky: g,
    disableAnchorTracking: m,
    keepMounted: C,
    nodeId: R,
    collisionAvoidance: h,
    adaptiveOrigin: M ? Aa : void 0
  }), k = {
    open: S,
    side: T.side,
    align: T.align,
    anchorHidden: T.anchorHidden,
    instant: N
  }, D = Br(e, k, {
    styles: T.positionerStyles,
    transitionStatus: I,
    props: w,
    refs: [n, y.useStateSetter("positionerElement")],
    hidden: !E,
    inert: !S
  });
  return /* @__PURE__ */ x(yu.Provider, {
    value: T,
    children: /* @__PURE__ */ x(tu, {
      id: R,
      children: D
    })
  });
});
process.env.NODE_ENV !== "production" && (y1.displayName = "PreviewCardPositioner");
const hC = {
  ...xn,
  ...Lt
}, x1 = /* @__PURE__ */ v.forwardRef(function(e, n) {
  const {
    className: o,
    render: r,
    style: s,
    ...i
  } = e, a = js(), {
    side: l,
    align: c
  } = fC(), u = a.useState("open"), d = a.useState("instantType"), f = a.useState("transitionStatus"), p = a.useState("popupProps"), g = a.useState("floatingRootContext");
  Bt({
    open: u,
    ref: a.context.popupRef,
    onComplete() {
      u && a.context.onOpenChangeComplete?.(!0);
    }
  });
  const m = ge(() => a.context.closeDelayRef.current);
  return Da(g, {
    closeDelay: m
  }), Te("div", e, {
    state: {
      open: u,
      side: l,
      align: c,
      instant: d,
      transitionStatus: f
    },
    ref: [n, a.context.popupRef, a.useStateSetter("popupElement")],
    props: [p, pr(f), i],
    stateAttributesMapping: hC
  });
});
process.env.NODE_ENV !== "production" && (x1.displayName = "PreviewCardPopup");
function gr(t) {
  return Lc(19) ? t : t ? "true" : void 0;
}
function bC(t) {
  const [e, n] = v.useState({
    current: t,
    previous: null
  });
  return t !== e.current && n({
    current: t,
    previous: e.current
  }), e.previous;
}
const vC = "z-[var(--z-overlay-popover,180)]", yC = le("rounded-(--radius-sm)", "border border-solid border-outline-subtle", "bg-surface-container-lowest", "text-text-default", "shadow-elevation-3", "font-(family-name:--font-family-body)", "origin-(--transform-origin)", "transition-[opacity,transform]", "duration-200", "ease-in-out", "will-change-[opacity,transform]", "[&[data-starting-style]]:scale-95", "[&[data-starting-style]]:opacity-0", "[&[data-ending-style]]:scale-95", "[&[data-ending-style]]:opacity-0");
function xC(t) {
  const e = J.c(6);
  let n, o;
  e[0] !== t ? ({
    children: n,
    ...o
  } = t, e[0] = t, e[1] = n, e[2] = o) : (n = e[1], o = e[2]);
  let r;
  return e[3] !== n || e[4] !== o ? (r = /* @__PURE__ */ x(sC, { ...o, children: n }), e[3] = n, e[4] = o, e[5] = r) : r = e[5], r;
}
function wC(t) {
  const e = J.c(8);
  let n, o, r;
  e[0] !== t ? ({
    render: o,
    delay: r,
    ...n
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r) : (n = e[1], o = e[2], r = e[3]);
  const s = r === void 0 ? 0 : r;
  let i;
  return e[4] !== s || e[5] !== n || e[6] !== o ? (i = /* @__PURE__ */ x(h1, { render: o, delay: s, ...n }), e[4] = s, e[5] = n, e[6] = o, e[7] = i) : i = e[7], i;
}
function CC(t) {
  const e = J.c(18);
  let n, o, r, s, i, a;
  e[0] !== t ? ({
    children: n,
    className: o,
    side: s,
    align: i,
    sideOffset: a,
    ...r
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r, e[4] = s, e[5] = i, e[6] = a) : (n = e[1], o = e[2], r = e[3], s = e[4], i = e[5], a = e[6]);
  const l = s === void 0 ? "bottom" : s, c = i === void 0 ? "center" : i, u = a === void 0 ? 8 : a;
  let d;
  e[7] !== o ? (d = le(yC, o), e[7] = o, e[8] = d) : d = e[8];
  let f;
  e[9] !== n || e[10] !== d ? (f = /* @__PURE__ */ x(x1, { className: d, children: n }), e[9] = n, e[10] = d, e[11] = f) : f = e[11];
  let p;
  return e[12] !== c || e[13] !== r || e[14] !== l || e[15] !== u || e[16] !== f ? (p = /* @__PURE__ */ x(m1, { children: /* @__PURE__ */ x(y1, { side: l, align: c, sideOffset: u, className: vC, ...r, children: f }) }), e[12] = c, e[13] = r, e[14] = l, e[15] = u, e[16] = f, e[17] = p) : p = e[17], p;
}
const SC = {
  operational: "bg-datavis-crit-green",
  warning: "bg-datavis-crit-yellow",
  critical: "bg-datavis-crit-red",
  inactive: "bg-surface-container-high"
}, RC = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"], EC = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
function PC(t) {
  if (t < 1 || t > 12)
    throw new RangeError(`AssetTimeline requires between 1 and 12 consecutive months. Received ${t}.`);
}
function NC(t) {
  const e = /* @__PURE__ */ new Date(), n = e.getMonth(), o = e.getFullYear();
  return Array.from({
    length: t
  }, (r, s) => {
    const i = t - s - 1, a = new Date(o, n - i, 1), l = a.getMonth(), c = a.getFullYear();
    return {
      shortLabel: RC[l],
      longLabel: `${EC[l]} ${c}`,
      key: `${c}-${l}`
    };
  });
}
function w1(t) {
  return t.events?.length ?? 0;
}
function IC(t) {
  const e = t.reduce((o, r) => (o[r.severity] += 1, o), {
    operational: 0,
    warning: 0,
    critical: 0,
    inactive: 0
  }), n = (o, r) => `${o} ${r} ${o === 1 ? "month" : "months"}`;
  return `Asset timeline: ${n(e.operational, "operational")}, ${n(e.warning, "warning")}, ${n(e.critical, "critical")}, ${n(e.inactive, "inactive")}.`;
}
function mp(t, e) {
  const n = w1(t), o = n === 1 ? "1 event" : `${n} events`;
  return n > 0 ? `${e.longLabel}: ${t.severity}, ${o}` : `${e.longLabel}: ${t.severity}, no events`;
}
function MC(t) {
  const e = J.c(3), {
    count: n
  } = t;
  let o;
  e[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (o = /* @__PURE__ */ x("svg", { "aria-hidden": "true", viewBox: "0 0 8 8", className: "size-(--spacing-8) fill-informative group-focus-visible/asset-timeline-month:fill-primary-on-primary", children: /* @__PURE__ */ x("path", { d: "M4 8C5.06087 8 6.07828 7.57857 6.82843 6.82843C7.57857 6.07828 8 5.06087 8 4C8 2.93913 7.57857 1.92172 6.82843 1.17157C6.07828 0.421427 5.06087 0 4 0C2.93913 0 1.92172 0.421427 1.17157 1.17157C0.421427 1.92172 0 2.93913 0 4C0 5.06087 0.421427 6.07828 1.17157 6.82843C1.92172 7.57857 2.93913 8 4 8ZM4 2.5C4.39782 2.5 4.77936 2.65804 5.06066 2.93934C5.34196 3.22064 5.5 3.60218 5.5 4C5.5 4.39782 5.34196 4.77936 5.06066 5.06066C4.77936 5.34196 4.39782 5.5 4 5.5C3.60218 5.5 3.22064 5.34196 2.93934 5.06066C2.65804 4.77936 2.5 4.39782 2.5 4C2.5 3.60218 2.65804 3.22064 2.93934 2.93934C3.22064 2.65804 3.60218 2.5 4 2.5Z" }) }), e[0] = o) : o = e[0];
  let r;
  return e[1] !== n ? (r = /* @__PURE__ */ j("span", { "data-slot": "asset-timeline-marker", className: "inline-flex h-(--spacing-20) min-w-(--spacing-32) items-center justify-center gap-(--spacing-6) rounded-(--radius-xs) border border-outline-subtle bg-surface-container-lowest px-(--spacing-6) font-(family-name:--font-family-label) font-(number:--font-weight-medium) text-(length:--font-size-label-small) leading-(--font-line-height-16) text-text-default group-hover/asset-timeline-month:bg-surface-container group-focus-visible/asset-timeline-month:bg-primary group-focus-visible/asset-timeline-month:text-primary-on-primary", children: [
    o,
    n
  ] }), e[1] = n, e[2] = r) : r = e[2], r;
}
function TC(t) {
  const e = J.c(43), {
    month: n,
    meta: o,
    monthIndex: r,
    renderHoverCard: s
  } = t, i = w1(n), a = i > 0, l = SC[n.severity];
  let c;
  e[0] !== l ? (c = le("block h-(--spacing-12) w-full", l), e[0] = l, e[1] = c) : c = e[1];
  let u;
  e[2] !== c ? (u = /* @__PURE__ */ x("span", { "aria-hidden": "true", "data-testid": "asset-timeline-fill", className: c }), e[2] = c, e[3] = u) : u = e[3];
  const d = u;
  let f;
  e[4] !== o.shortLabel ? (f = o.shortLabel.slice(0, 1), e[4] = o.shortLabel, e[5] = f) : f = e[5];
  let p;
  e[6] !== f ? (p = /* @__PURE__ */ x("span", { className: "@min-[48px]/asset-timeline-month:hidden", children: f }), e[6] = f, e[7] = p) : p = e[7];
  let g;
  e[8] !== o.shortLabel ? (g = /* @__PURE__ */ x("span", { className: "hidden @min-[48px]/asset-timeline-month:inline", children: o.shortLabel }), e[8] = o.shortLabel, e[9] = g) : g = e[9];
  let m;
  e[10] !== p || e[11] !== g ? (m = /* @__PURE__ */ j("span", { "aria-hidden": "true", className: "pt-(--spacing-4) font-(family-name:--font-family-title) font-(number:--font-weight-medium) text-(length:--font-size-title-inter-xsmall) leading-(--font-line-height-20) text-text-subtle", children: [
    p,
    g
  ] }), e[10] = p, e[11] = g, e[12] = m) : m = e[12];
  const h = m;
  let b;
  e[13] !== i ? (b = i > 0 && /* @__PURE__ */ x(MC, { count: i }), e[13] = i, e[14] = b) : b = e[14];
  let w;
  e[15] !== d || e[16] !== b ? (w = /* @__PURE__ */ j("span", { className: "flex w-full flex-col items-center gap-(--spacing-4)", children: [
    b,
    d
  ] }), e[15] = d, e[16] = b, e[17] = w) : w = e[17];
  const y = w;
  if (!a || !s || !n.events) {
    let N;
    e[18] !== o || e[19] !== n ? (N = mp(n, o), e[18] = o, e[19] = n, e[20] = N) : N = e[20];
    let I;
    return e[21] !== h || e[22] !== N || e[23] !== y ? (I = /* @__PURE__ */ j("div", { "data-testid": "asset-timeline-month", role: "img", "aria-label": N, className: "@container/asset-timeline-month flex w-full min-w-0 flex-col items-center text-center", children: [
      y,
      h
    ] }), e[21] = h, e[22] = N, e[23] = y, e[24] = I) : I = e[24], I;
  }
  let C;
  e[25] !== o || e[26] !== n ? (C = mp(n, o), e[25] = o, e[26] = n, e[27] = C) : C = e[27];
  let R;
  e[28] !== h || e[29] !== C || e[30] !== y ? (R = /* @__PURE__ */ x(wC, { delay: 0, closeDelay: 0, render: /* @__PURE__ */ j("button", { type: "button", "data-testid": "asset-timeline-month", "aria-label": C, className: "@container/asset-timeline-month group/asset-timeline-month flex w-full min-w-0 cursor-pointer flex-col items-center rounded-(--radius-xs) border-0 bg-transparent p-0 text-center outline-none", children: [
    y,
    h
  ] }) }), e[28] = h, e[29] = C, e[30] = y, e[31] = R) : R = e[31];
  let S;
  e[32] !== o.longLabel || e[33] !== o.shortLabel || e[34] !== n || e[35] !== r || e[36] !== s ? (S = s({
    month: n,
    monthIndex: r,
    monthLabel: o.shortLabel,
    monthLongLabel: o.longLabel
  }), e[32] = o.longLabel, e[33] = o.shortLabel, e[34] = n, e[35] = r, e[36] = s, e[37] = S) : S = e[37];
  let E;
  e[38] !== S ? (E = /* @__PURE__ */ x(CC, { className: "w-[280px] overflow-hidden", children: S }), e[38] = S, e[39] = E) : E = e[39];
  let P;
  return e[40] !== R || e[41] !== E ? (P = /* @__PURE__ */ j(xC, { children: [
    R,
    E
  ] }), e[40] = R, e[41] = E, e[42] = P) : P = e[42], P;
}
function rN(t) {
  const e = J.c(26);
  let n, o, r, s;
  e[0] !== t ? ({
    months: r,
    ariaLabel: n,
    className: o,
    ...s
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r, e[4] = s) : (n = e[1], o = e[2], r = e[3], s = e[4]), PC(r.length);
  const i = "renderHoverCard" in s ? s.renderHoverCard : void 0;
  let a;
  e[5] !== r.length ? (a = NC(r.length), e[5] = r.length, e[6] = a) : a = e[6];
  const l = a, c = `repeat(${r.length}, minmax(0, 1fr))`;
  let u;
  e[7] !== c ? (u = {
    gridTemplateColumns: c
  }, e[7] = c, e[8] = u) : u = e[8];
  const d = u;
  let f;
  e[9] !== n || e[10] !== r ? (f = n ?? IC(r), e[9] = n, e[10] = r, e[11] = f) : f = e[11];
  let p;
  e[12] !== o ? (p = le("grid w-full min-w-0 items-end gap-x-(--spacing-1)", o), e[12] = o, e[13] = p) : p = e[13];
  let g;
  if (e[14] !== l || e[15] !== r || e[16] !== i) {
    let h;
    e[18] !== l || e[19] !== i ? (h = (b, w) => /* @__PURE__ */ x(TC, { month: b, meta: l[w], monthIndex: w, renderHoverCard: i }, l[w].key), e[18] = l, e[19] = i, e[20] = h) : h = e[20], g = r.map(h), e[14] = l, e[15] = r, e[16] = i, e[17] = g;
  } else
    g = e[17];
  let m;
  return e[21] !== d || e[22] !== f || e[23] !== p || e[24] !== g ? (m = /* @__PURE__ */ x("section", { "data-testid": "asset-timeline", "aria-label": f, className: p, style: d, children: g }), e[21] = d, e[22] = f, e[23] = p, e[24] = g, e[25] = m) : m = e[25], m;
}
const xu = /* @__PURE__ */ v.createContext(void 0);
process.env.NODE_ENV !== "production" && (xu.displayName = "DialogRootContext");
function cn(t) {
  const e = v.useContext(xu);
  if (t === !1 && e === void 0)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: DialogRootContext is missing. Dialog parts must be placed within <Dialog.Root>." : Xe(27));
  return e;
}
const kC = {
  ...xn,
  ...Lt
}, Fa = /* @__PURE__ */ v.forwardRef(function(e, n) {
  const {
    render: o,
    className: r,
    style: s,
    forceRender: i = !1,
    ...a
  } = e, {
    store: l
  } = cn(), c = l.useState("open"), u = l.useState("nested"), d = l.useState("mounted"), f = l.useState("transitionStatus");
  return Te("div", e, {
    state: {
      open: c,
      transitionStatus: f
    },
    ref: [l.context.backdropRef, n],
    stateAttributesMapping: kC,
    props: [{
      role: "presentation",
      hidden: !d,
      style: {
        userSelect: "none",
        WebkitUserSelect: "none"
      }
    }, a],
    enabled: i || !u
  });
});
process.env.NODE_ENV !== "production" && (Fa.displayName = "DialogBackdrop");
const Ps = /* @__PURE__ */ v.forwardRef(function(e, n) {
  const {
    render: o,
    className: r,
    disabled: s = !1,
    nativeButton: i = !0,
    style: a,
    ...l
  } = e, {
    store: c
  } = cn(), u = c.useState("open");
  function d(m) {
    u && c.setOpen(!1, Pe(Rm, m.nativeEvent));
  }
  const {
    getButtonProps: f,
    buttonRef: p
  } = Ft({
    disabled: s,
    native: i
  });
  return Te("button", e, {
    state: {
      disabled: s
    },
    ref: [n, p],
    props: [{
      onClick: d
    }, l, f]
  });
});
process.env.NODE_ENV !== "production" && (Ps.displayName = "DialogClose");
const Ns = /* @__PURE__ */ v.forwardRef(function(e, n) {
  const {
    render: o,
    className: r,
    style: s,
    id: i,
    ...a
  } = e, {
    store: l
  } = cn(), c = St(i);
  return l.useSyncedValueWithCleanup("descriptionElementId", c), Te("p", e, {
    ref: n,
    props: [{
      id: c
    }, a]
  });
});
process.env.NODE_ENV !== "production" && (Ns.displayName = "DialogDescription");
let OC = /* @__PURE__ */ (function(t) {
  return t.nestedDialogs = "--nested-dialogs", t;
})({}), DC = (function(t) {
  return t[t.open = rn.open] = "open", t[t.closed = rn.closed] = "closed", t[t.startingStyle = rn.startingStyle] = "startingStyle", t[t.endingStyle = rn.endingStyle] = "endingStyle", t.nested = "data-nested", t.nestedDialogOpen = "data-nested-dialog-open", t;
})({});
const wu = /* @__PURE__ */ v.createContext(void 0);
process.env.NODE_ENV !== "production" && (wu.displayName = "DialogPortalContext");
function Cu() {
  const t = v.useContext(wu);
  if (t === void 0)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: <Dialog.Portal> is missing." : Xe(26));
  return t;
}
const Ir = "ArrowUp", Xo = "ArrowDown", Is = "ArrowLeft", Mr = "ArrowRight", qs = "Home", Xs = "End", C1 = /* @__PURE__ */ new Set([Is, Mr]), _C = /* @__PURE__ */ new Set([Is, Mr, qs, Xs]), S1 = /* @__PURE__ */ new Set([Ir, Xo]), VC = /* @__PURE__ */ new Set([Ir, Xo, qs, Xs]), R1 = /* @__PURE__ */ new Set([...C1, ...S1]), AC = /* @__PURE__ */ new Set([...R1, qs, Xs]), Zs = /* @__PURE__ */ new Set([Ir, Xo, Is, Mr, qs, Xs]), E1 = "Shift", FC = "Control", LC = "Alt", $C = "Meta", zC = /* @__PURE__ */ new Set([E1, FC, LC, $C]);
function HC(t) {
  return bt(t) && t.tagName === "INPUT";
}
function hp(t) {
  return !!(HC(t) && t.selectionStart != null || bt(t) && t.tagName === "TEXTAREA");
}
function bp(t, e, n, o) {
  if (!t || !e || !e.scrollTo)
    return;
  let r = t.scrollLeft, s = t.scrollTop;
  const i = t.clientWidth < t.scrollWidth, a = t.clientHeight < t.scrollHeight;
  if (i && o !== "vertical") {
    const l = vp(t, e, "left"), c = Mi(t), u = Mi(e);
    n === "ltr" && (l + e.offsetWidth + u.scrollMarginRight > t.scrollLeft + t.clientWidth - c.scrollPaddingRight ? r = l + e.offsetWidth + u.scrollMarginRight - t.clientWidth + c.scrollPaddingRight : l - u.scrollMarginLeft < t.scrollLeft + c.scrollPaddingLeft && (r = l - u.scrollMarginLeft - c.scrollPaddingLeft)), n === "rtl" && (l - u.scrollMarginRight < t.scrollLeft + c.scrollPaddingLeft ? r = l - u.scrollMarginLeft - c.scrollPaddingLeft : l + e.offsetWidth + u.scrollMarginRight > t.scrollLeft + t.clientWidth - c.scrollPaddingRight && (r = l + e.offsetWidth + u.scrollMarginRight - t.clientWidth + c.scrollPaddingRight));
  }
  if (a && o !== "horizontal") {
    const l = vp(t, e, "top"), c = Mi(t), u = Mi(e);
    l - u.scrollMarginTop < t.scrollTop + c.scrollPaddingTop ? s = l - u.scrollMarginTop - c.scrollPaddingTop : l + e.offsetHeight + u.scrollMarginBottom > t.scrollTop + t.clientHeight - c.scrollPaddingBottom && (s = l + e.offsetHeight + u.scrollMarginBottom - t.clientHeight + c.scrollPaddingBottom);
  }
  t.scrollTo({
    left: r,
    top: s,
    behavior: "auto"
  });
}
function vp(t, e, n) {
  const o = n === "left" ? "offsetLeft" : "offsetTop";
  let r = 0;
  for (; e.offsetParent && (r += e[o], e.offsetParent !== t); )
    e = e.offsetParent;
  return r;
}
function Mi(t) {
  const e = getComputedStyle(t);
  return {
    scrollMarginTop: parseFloat(e.scrollMarginTop) || 0,
    scrollMarginRight: parseFloat(e.scrollMarginRight) || 0,
    scrollMarginBottom: parseFloat(e.scrollMarginBottom) || 0,
    scrollMarginLeft: parseFloat(e.scrollMarginLeft) || 0,
    scrollPaddingTop: parseFloat(e.scrollPaddingTop) || 0,
    scrollPaddingRight: parseFloat(e.scrollPaddingRight) || 0,
    scrollPaddingBottom: parseFloat(e.scrollPaddingBottom) || 0,
    scrollPaddingLeft: parseFloat(e.scrollPaddingLeft) || 0
  };
}
const BC = {
  ...xn,
  ...Lt,
  nestedDialogOpen(t) {
    return t ? {
      [DC.nestedDialogOpen]: ""
    } : null;
  }
}, La = /* @__PURE__ */ v.forwardRef(function(e, n) {
  const {
    className: o,
    finalFocus: r,
    initialFocus: s,
    render: i,
    style: a,
    ...l
  } = e, {
    store: c
  } = cn(), u = c.useState("descriptionElementId"), d = c.useState("disablePointerDismissal"), f = c.useState("floatingRootContext"), p = c.useState("popupProps"), g = c.useState("modal"), m = c.useState("mounted"), h = c.useState("nested"), b = c.useState("nestedOpenDialogCount"), w = c.useState("open"), y = c.useState("openMethod"), C = c.useState("titleElementId"), R = c.useState("transitionStatus"), S = c.useState("role");
  Cu(), Bt({
    open: w,
    ref: c.context.popupRef,
    onComplete() {
      w && c.context.onOpenChangeComplete?.(!0);
    }
  });
  function E(T) {
    return T === "touch" ? c.context.popupRef.current : !0;
  }
  const P = s === void 0 ? E : s, N = b > 0, M = Te("div", e, {
    state: {
      open: w,
      nested: h,
      transitionStatus: R,
      nestedDialogOpen: N
    },
    props: [p, {
      "aria-labelledby": C ?? void 0,
      "aria-describedby": u ?? void 0,
      role: S,
      tabIndex: -1,
      hidden: !m,
      onKeyDown(T) {
        Zs.has(T.key) && T.stopPropagation();
      },
      style: {
        [OC.nestedDialogs]: b
      }
    }, l],
    ref: [n, c.context.popupRef, c.useStateSetter("popupElement")],
    stateAttributesMapping: BC
  });
  return /* @__PURE__ */ x(zr, {
    context: f,
    openInteractionType: y,
    disabled: !m,
    closeOnFocusOut: !d,
    initialFocus: P,
    returnFocus: r,
    modal: g !== !1,
    restoreFocus: "popup",
    children: M
  });
});
process.env.NODE_ENV !== "production" && (La.displayName = "DialogPopup");
const Wr = /* @__PURE__ */ v.forwardRef(function(e, n) {
  const {
    cutout: o,
    ...r
  } = e;
  let s;
  if (o) {
    const i = o.getBoundingClientRect();
    s = `polygon(0% 0%,100% 0%,100% 100%,0% 100%,0% 0%,${i.left}px ${i.top}px,${i.left}px ${i.bottom}px,${i.right}px ${i.bottom}px,${i.right}px ${i.top}px,${i.left}px ${i.top}px)`;
  }
  return /* @__PURE__ */ x("div", {
    ref: n,
    role: "presentation",
    "data-base-ui-inert": "",
    ...r,
    style: {
      position: "fixed",
      inset: 0,
      userSelect: "none",
      WebkitUserSelect: "none",
      clipPath: s
    }
  });
});
process.env.NODE_ENV !== "production" && (Wr.displayName = "InternalBackdrop");
const Qs = /* @__PURE__ */ v.forwardRef(function(e, n) {
  const {
    keepMounted: o = !1,
    ...r
  } = e, {
    store: s
  } = cn(), i = s.useState("mounted"), a = s.useState("modal"), l = s.useState("open");
  return i || o ? /* @__PURE__ */ x(wu.Provider, {
    value: o,
    children: /* @__PURE__ */ j($r, {
      ref: n,
      ...r,
      children: [i && a === !0 && /* @__PURE__ */ x(Wr, {
        ref: s.context.internalBackdropRef,
        inert: gr(!l)
      }), e.children]
    })
  }) : null;
});
process.env.NODE_ENV !== "production" && (Qs.displayName = "DialogPortal");
let yp = {}, xp = {}, wp = "";
function WC(t) {
  if (typeof document > "u")
    return !1;
  const e = Ke(t);
  return vt(e).innerWidth - e.documentElement.clientWidth > 0;
}
function UC(t) {
  if (!(typeof CSS < "u" && CSS.supports && CSS.supports("scrollbar-gutter", "stable")) || typeof document > "u")
    return !1;
  const n = Ke(t), o = n.documentElement, r = n.body, s = Lo(o) ? o : r, i = s.style.overflowY, a = o.style.scrollbarGutter;
  o.style.scrollbarGutter = "stable", s.style.overflowY = "scroll";
  const l = s.offsetWidth;
  s.style.overflowY = "hidden";
  const c = s.offsetWidth;
  return s.style.overflowY = i, o.style.scrollbarGutter = a, l === c;
}
function YC(t) {
  const e = Ke(t), n = e.documentElement, o = e.body, r = Lo(n) ? n : o, s = {
    overflowY: r.style.overflowY,
    overflowX: r.style.overflowX
  };
  return Object.assign(r.style, {
    overflowY: "hidden",
    overflowX: "hidden"
  }), () => {
    Object.assign(r.style, s);
  };
}
function GC(t) {
  const e = Ke(t), n = e.documentElement, o = e.body, r = vt(n);
  let s = 0, i = 0, a = !1;
  const l = Tt.create();
  if (Hc && (r.visualViewport?.scale ?? 1) !== 1)
    return () => {
    };
  function c() {
    const p = r.getComputedStyle(n), g = r.getComputedStyle(o), b = (p.scrollbarGutter || "").includes("both-edges") ? "stable both-edges" : "stable";
    s = n.scrollTop, i = n.scrollLeft, yp = {
      scrollbarGutter: n.style.scrollbarGutter,
      overflowY: n.style.overflowY,
      overflowX: n.style.overflowX
    }, wp = n.style.scrollBehavior, xp = {
      position: o.style.position,
      height: o.style.height,
      width: o.style.width,
      boxSizing: o.style.boxSizing,
      overflowY: o.style.overflowY,
      overflowX: o.style.overflowX,
      scrollBehavior: o.style.scrollBehavior
    };
    const w = n.scrollHeight > n.clientHeight, y = n.scrollWidth > n.clientWidth, C = p.overflowY === "scroll" || g.overflowY === "scroll", R = p.overflowX === "scroll" || g.overflowX === "scroll", S = Math.max(0, r.innerWidth - o.clientWidth), E = Math.max(0, r.innerHeight - o.clientHeight), P = parseFloat(g.marginTop) + parseFloat(g.marginBottom), N = parseFloat(g.marginLeft) + parseFloat(g.marginRight), I = Lo(n) ? n : o;
    if (a = UC(t), a) {
      n.style.scrollbarGutter = b, I.style.overflowY = "hidden", I.style.overflowX = "hidden";
      return;
    }
    Object.assign(n.style, {
      scrollbarGutter: b,
      overflowY: "hidden",
      overflowX: "hidden"
    }), (w || C) && (n.style.overflowY = "scroll"), (y || R) && (n.style.overflowX = "scroll"), Object.assign(o.style, {
      position: "relative",
      height: P || E ? `calc(100dvh - ${P + E}px)` : "100dvh",
      width: N || S ? `calc(100vw - ${N + S}px)` : "100vw",
      boxSizing: "border-box",
      overflow: "hidden",
      scrollBehavior: "unset"
    }), o.scrollTop = s, o.scrollLeft = i, n.setAttribute("data-base-ui-scroll-locked", ""), n.style.scrollBehavior = "unset";
  }
  function u() {
    Object.assign(n.style, yp), Object.assign(o.style, xp), a || (n.scrollTop = s, n.scrollLeft = i, n.removeAttribute("data-base-ui-scroll-locked"), n.style.scrollBehavior = wp);
  }
  function d() {
    u(), l.request(c);
  }
  c();
  const f = rt(r, "resize", d);
  return () => {
    l.cancel(), u(), typeof r.removeEventListener == "function" && f();
  };
}
class jC {
  lockCount = 0;
  restore = null;
  timeoutLock = gn.create();
  timeoutUnlock = gn.create();
  acquire(e) {
    return this.lockCount += 1, this.lockCount === 1 && this.restore === null && this.timeoutLock.start(0, () => this.lock(e)), this.release;
  }
  release = () => {
    this.lockCount -= 1, this.lockCount === 0 && this.restore && this.timeoutUnlock.start(0, this.unlock);
  };
  unlock = () => {
    this.lockCount === 0 && this.restore && (this.restore?.(), this.restore = null);
  };
  lock(e) {
    if (this.lockCount === 0 || this.restore !== null)
      return;
    const o = Ke(e).documentElement, r = vt(o).getComputedStyle(o).overflowY;
    if (r === "hidden" || r === "clip") {
      this.restore = ht;
      return;
    }
    const s = hm || !WC(e);
    this.restore = s ? YC(e) : GC(e);
  }
}
const KC = new jC();
function P1(t = !0, e = null) {
  xe(() => {
    if (t)
      return KC.acquire(e);
  }, [t, e]);
}
function qC(t) {
  const e = v.useRef(""), n = v.useCallback((r) => {
    r.defaultPrevented || (e.current = r.pointerType, t(r, r.pointerType));
  }, [t]);
  return {
    onClick: v.useCallback((r) => {
      if (r.detail === 0) {
        t(r, "keyboard");
        return;
      }
      "pointerType" in r ? t(r, r.pointerType) : t(r, e.current), e.current = "";
    }, [t]),
    onPointerDown: n
  };
}
function po(t, e) {
  const n = v.useRef(t), o = ge(e);
  xe(() => {
    n.current !== t && o(n.current);
  }, [t, o]), xe(() => {
    n.current = t;
  }, [t]);
}
function Js(t) {
  const [e, n] = v.useState(null), o = ge((i, a) => {
    t || n(a || // On iOS Safari, the hitslop around touch targets means tapping outside an element's
    // bounds does not fire `pointerdown` but does fire `mousedown`. The `interactionType`
    // will be "" in that case.
    (hm ? "touch" : ""));
  });
  po(t, (i) => {
    i && !t && n(null);
  });
  const {
    onClick: r,
    onPointerDown: s
  } = qC(o);
  return v.useMemo(() => ({
    openMethod: e,
    triggerProps: {
      onClick: r,
      onPointerDown: s
    }
  }), [e, r, s]);
}
function XC(t) {
  const {
    store: e,
    parentContext: n,
    actionsRef: o,
    isDrawer: r
  } = t, s = e.useState("open"), i = e.useState("disablePointerDismissal"), a = e.useState("modal"), l = e.useState("popupElement"), {
    openMethod: c,
    triggerProps: u
  } = Js(s);
  zs(e);
  const {
    forceUnmount: d
  } = Hs(s, e), f = v.useCallback(() => {
    e.setOpen(!1, Pe(As));
  }, [e]);
  v.useImperativeHandle(o, () => ({
    unmount: d,
    close: f
  }), [d, f]);
  const p = Us({
    popupStore: e,
    onOpenChange: e.setOpen,
    treatPopupAsFloatingElement: !0
  }), [g, m] = v.useState(0), [h, b] = v.useState(0), w = g === 0, y = gu(p), C = cr(p, {
    outsidePressEvent() {
      return e.context.internalBackdropRef.current || e.context.backdropRef.current ? "intentional" : {
        mouse: a === "trap-focus" ? "sloppy" : "intentional",
        touch: "sloppy"
      };
    },
    outsidePress(M) {
      if (!e.context.outsidePressEnabledRef.current || "button" in M && M.button !== 0 || "touches" in M && M.touches.length !== 1)
        return !1;
      const T = gt(M);
      if (w && !i) {
        const k = T;
        return a && (e.context.internalBackdropRef.current || e.context.backdropRef.current) ? e.context.internalBackdropRef.current === k || e.context.backdropRef.current === k || De(k, l) && !k?.hasAttribute("data-base-ui-portal") : !0;
      }
      return !1;
    },
    escapeKey: w
  });
  P1(s && a === !0, l);
  const {
    getReferenceProps: R,
    getFloatingProps: S,
    getTriggerProps: E
  } = Gn([y, C]);
  e.useContextCallback("onNestedDialogOpen", (M, T) => {
    m(M), b(T);
  }), e.useContextCallback("onNestedDialogClose", () => {
    m(0), b(0);
  }), v.useEffect(() => (n?.onNestedDialogOpen && s && n.onNestedDialogOpen(g + 1, h + (r ? 1 : 0)), n?.onNestedDialogClose && !s && n.onNestedDialogClose(), () => {
    n?.onNestedDialogClose && s && n.onNestedDialogClose();
  }), [r, s, g, h, n]);
  const P = v.useMemo(() => R(u), [R, u]), N = v.useMemo(() => E(u), [E, u]), I = v.useMemo(() => S(), [S]);
  e.useSyncedValues({
    openMethod: c,
    activeTriggerProps: P,
    inactiveTriggerProps: N,
    popupProps: I,
    floatingRootContext: p,
    nestedOpenDialogCount: g,
    nestedOpenDrawerCount: h
  });
}
const ZC = {
  ...Ws,
  modal: ce((t) => t.modal),
  nested: ce((t) => t.nested),
  nestedOpenDialogCount: ce((t) => t.nestedOpenDialogCount),
  nestedOpenDrawerCount: ce((t) => t.nestedOpenDrawerCount),
  disablePointerDismissal: ce((t) => t.disablePointerDismissal),
  openMethod: ce((t) => t.openMethod),
  descriptionElementId: ce((t) => t.descriptionElementId),
  titleElementId: ce((t) => t.titleElementId),
  viewportElement: ce((t) => t.viewportElement),
  role: ce((t) => t.role)
};
class Su extends ur {
  constructor(e) {
    super(QC(e), {
      popupRef: /* @__PURE__ */ v.createRef(),
      backdropRef: /* @__PURE__ */ v.createRef(),
      internalBackdropRef: /* @__PURE__ */ v.createRef(),
      outsidePressEnabledRef: {
        current: !0
      },
      triggerElements: new dr(),
      onOpenChange: void 0,
      onOpenChangeComplete: void 0
    }, ZC);
  }
  setOpen = (e, n) => {
    if (n.preventUnmountOnClose = () => {
      this.set("preventUnmountingOnClose", !0);
    }, !e && n.trigger == null && this.state.activeTriggerId != null && (n.trigger = this.state.activeTriggerElement ?? void 0), this.context.onOpenChange?.(e, n), n.isCanceled)
      return;
    this.state.floatingRootContext.dispatchOpenChange(e, n);
    const o = {
      open: e
    }, r = n.trigger?.id ?? null;
    (r || e) && (o.activeTriggerId = r, o.activeTriggerElement = n.trigger ?? null), this.update(o);
  };
  static useStore(e, n) {
    const o = Pt(() => new Su(n)).current;
    return e ?? o;
  }
}
function QC(t = {}) {
  return {
    ...Bs(),
    modal: !0,
    disablePointerDismissal: !1,
    popupElement: null,
    viewportElement: null,
    descriptionElementId: void 0,
    titleElementId: void 0,
    openMethod: null,
    nested: !1,
    nestedOpenDialogCount: 0,
    nestedOpenDrawerCount: 0,
    role: "dialog",
    ...t
  };
}
const da = /* @__PURE__ */ v.createContext(!1);
process.env.NODE_ENV !== "production" && (da.displayName = "IsDrawerContext");
function $a(t) {
  const {
    children: e,
    open: n,
    defaultOpen: o = !1,
    onOpenChange: r,
    onOpenChangeComplete: s,
    disablePointerDismissal: i = !1,
    modal: a = !0,
    actionsRef: l,
    handle: c,
    triggerId: u,
    defaultTriggerId: d = null
  } = t, f = cn(!0), p = v.useContext(da), g = !!f, m = Su.useStore(c?.store, {
    open: o,
    openProp: n,
    activeTriggerId: d,
    triggerIdProp: u,
    modal: a,
    disablePointerDismissal: i,
    nested: g
  });
  sr(() => {
    n === void 0 && m.state.open === !1 && o === !0 && m.update({
      open: !0,
      activeTriggerId: d
    });
  }), m.useControlledProp("openProp", n), m.useControlledProp("triggerIdProp", u), m.useSyncedValues({
    disablePointerDismissal: i,
    nested: g,
    modal: a
  }), m.useContextCallback("onOpenChange", r), m.useContextCallback("onOpenChangeComplete", s);
  const h = m.useState("payload");
  XC({
    store: m,
    actionsRef: l,
    parentContext: f?.store.context,
    isDrawer: p
  });
  const b = v.useMemo(() => ({
    store: m
  }), [m]);
  return /* @__PURE__ */ x(da.Provider, {
    value: !1,
    children: /* @__PURE__ */ x(xu.Provider, {
      value: b,
      children: typeof e == "function" ? e({
        payload: h
      }) : e
    })
  });
}
let Cp = (function(t) {
  return t[t.open = rn.open] = "open", t[t.closed = rn.closed] = "closed", t[t.startingStyle = rn.startingStyle] = "startingStyle", t[t.endingStyle = rn.endingStyle] = "endingStyle", t.nested = "data-nested", t.nestedDialogOpen = "data-nested-dialog-open", t;
})({});
const JC = {
  ...xn,
  ...Lt,
  nested(t) {
    return t ? {
      [Cp.nested]: ""
    } : null;
  },
  nestedDialogOpen(t) {
    return t ? {
      [Cp.nestedDialogOpen]: ""
    } : null;
  }
}, ei = /* @__PURE__ */ v.forwardRef(function(e, n) {
  const {
    className: o,
    render: r,
    children: s,
    style: i,
    ...a
  } = e, l = Cu(), {
    store: c
  } = cn(), u = c.useState("open"), d = c.useState("nested"), f = c.useState("transitionStatus"), p = c.useState("nestedOpenDialogCount"), g = c.useState("mounted"), m = p > 0;
  return Te("div", e, {
    enabled: l || g,
    state: {
      open: u,
      nested: d,
      transitionStatus: f,
      nestedDialogOpen: m
    },
    ref: [n, c.useStateSetter("viewportElement")],
    stateAttributesMapping: JC,
    props: [{
      role: "presentation",
      hidden: !g,
      style: {
        pointerEvents: u ? void 0 : "none"
      },
      children: s
    }, a]
  });
});
process.env.NODE_ENV !== "production" && (ei.displayName = "DialogViewport");
const Ms = /* @__PURE__ */ v.forwardRef(function(e, n) {
  const {
    render: o,
    className: r,
    style: s,
    id: i,
    ...a
  } = e, {
    store: l
  } = cn(), c = St(i);
  return l.useSyncedValueWithCleanup("titleElementId", c), Te("h2", e, {
    ref: n,
    props: [{
      id: c
    }, a]
  });
});
process.env.NODE_ENV !== "production" && (Ms.displayName = "DialogTitle");
const N1 = /* @__PURE__ */ v.forwardRef(function(e, n) {
  const {
    render: o,
    className: r,
    disabled: s = !1,
    nativeButton: i = !0,
    id: a,
    payload: l,
    handle: c,
    style: u,
    ...d
  } = e, f = cn(!0), p = c?.store ?? f?.store;
  if (!p)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: <Dialog.Trigger> must be used within <Dialog.Root> or provided with a handle." : Xe(79));
  const g = St(a), m = p.useState("floatingRootContext"), h = p.useState("isOpenedByTrigger", g), b = v.useRef(null), {
    registerTrigger: w,
    isMountedByThisTrigger: y
  } = $s(g, b, p, {
    payload: l
  }), {
    getButtonProps: C,
    buttonRef: R
  } = Ft({
    disabled: s,
    native: i
  }), S = lr(m, {
    enabled: m != null
  }), E = Gn([S]), P = {
    disabled: s,
    open: h
  }, N = p.useState("triggerProps", y);
  return Te("button", e, {
    state: P,
    ref: [R, n, w, b],
    props: [E.getReferenceProps(), N, {
      [qc]: "",
      id: g
    }, d, C],
    stateAttributesMapping: fr
  });
});
process.env.NODE_ENV !== "production" && (N1.displayName = "DialogTrigger");
const e3 = ye(["w-[min(calc(100vw_-_(var(--spacing-16)_*_2)),var(--modal-size))]", "max-w-(--modal-size)", "min-w-0", "max-h-[calc(100vh_-_var(--spacing-32))]", "flex flex-col", "overflow-hidden", "rounded-(--radius-sm)", "bg-surface-container-lowest", "shadow-elevation-5", "p-(--spacing-20)", "outline-none", "max-[599px]:min-h-[230px]", "max-[599px]:max-h-[min(680px,calc(100dvh_-_var(--spacing-16)))]", "max-[599px]:w-full", "max-[599px]:max-w-none", "max-[599px]:rounded-b-none", "max-[599px]:pb-[calc(var(--spacing-20)_+_env(safe-area-inset-bottom))]"], {
  variants: {
    size: {
      sm: "[--modal-size:320px]",
      md: "[--modal-size:600px]",
      lg: "[--modal-size:1100px]"
    }
  }
}), t3 = ye("shrink-0 mt-(--spacing-20) flex gap-(--spacing-16)", {
  variants: {
    size: {
      sm: ["h-auto", "flex-col-reverse", "items-stretch", "[&>*]:w-full"],
      md: "h-(--spacing-40) items-center justify-end",
      lg: "h-(--spacing-40) items-center justify-end"
    }
  }
}), n3 = ye(["font-(family-name:--font-family-title)", "text-(length:--font-size-title-lg)", "font-(number:--font-weight-medium)", "leading-(--font-line-height-28)", "text-text-default"]), o3 = ye(["text-(length:--font-size-body-medium)", "leading-(--font-line-height-20)", "text-text-subtext"]);
function Sp(t) {
  const e = J.c(34), {
    open: n,
    onOpenChange: o,
    title: r,
    description: s,
    dismissible: i,
    size: a,
    children: l,
    footer: c
  } = t, u = i === void 0 ? !0 : i, d = a ?? "md";
  let f;
  e[0] !== u || e[1] !== o ? (f = (M, T) => {
    if (!u && !M && (T.reason === "escape-key" || T.reason === "outside-press")) {
      T.cancel();
      return;
    }
    o(M);
  }, e[0] = u, e[1] = o, e[2] = f) : f = e[2];
  const p = f, g = !u;
  let m;
  e[3] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (m = /* @__PURE__ */ x(Fa, { className: "fixed inset-0 z-50 bg-surface-scrim" }), e[3] = m) : m = e[3];
  let h;
  e[4] !== d ? (h = le(e3({
    size: d
  })), e[4] = d, e[5] = h) : h = e[5];
  let b;
  e[6] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (b = le(n3()), e[6] = b) : b = e[6];
  let w;
  e[7] !== r ? (w = /* @__PURE__ */ x(Ms, { className: b, children: r }), e[7] = r, e[8] = w) : w = e[8];
  let y;
  e[9] !== u ? (y = u && /* @__PURE__ */ x(Ps, { render: /* @__PURE__ */ x(Kt, { icon: "x-close", "aria-label": "Close", variant: "ghost", size: "sm" }) }), e[9] = u, e[10] = y) : y = e[10];
  let C;
  e[11] !== w || e[12] !== y ? (C = /* @__PURE__ */ j("div", { className: "flex items-center justify-between", children: [
    w,
    y
  ] }), e[11] = w, e[12] = y, e[13] = C) : C = e[13];
  let R;
  e[14] !== s ? (R = s && /* @__PURE__ */ x(Ns, { className: le(o3()), children: s }), e[14] = s, e[15] = R) : R = e[15];
  let S;
  e[16] !== R || e[17] !== C ? (S = /* @__PURE__ */ j("div", { className: "shrink-0 flex flex-col gap-(--spacing-6)", children: [
    C,
    R
  ] }), e[16] = R, e[17] = C, e[18] = S) : S = e[18];
  let E;
  e[19] !== l ? (E = l && /* @__PURE__ */ x("div", { className: "min-h-0 mt-(--spacing-20) overflow-y-auto", children: l }), e[19] = l, e[20] = E) : E = e[20];
  let P;
  e[21] !== c || e[22] !== d ? (P = c && /* @__PURE__ */ x("div", { className: le(t3({
    size: d
  })), children: c }), e[21] = c, e[22] = d, e[23] = P) : P = e[23];
  let N;
  e[24] !== S || e[25] !== E || e[26] !== P || e[27] !== h ? (N = /* @__PURE__ */ j(Qs, { children: [
    m,
    /* @__PURE__ */ x(ei, { className: "fixed inset-0 z-50 flex items-center justify-center max-[599px]:items-end", children: /* @__PURE__ */ j(La, { "aria-modal": "true", className: h, children: [
      S,
      E,
      P
    ] }) })
  ] }), e[24] = S, e[25] = E, e[26] = P, e[27] = h, e[28] = N) : N = e[28];
  let I;
  return e[29] !== p || e[30] !== n || e[31] !== N || e[32] !== g ? (I = /* @__PURE__ */ x($a, { open: n, onOpenChange: p, modal: !0, disablePointerDismissal: g, children: N }), e[29] = p, e[30] = n, e[31] = N, e[32] = g, e[33] = I) : I = e[33], I;
}
const Cr = {
  complete: "complete",
  partial: "partial",
  failed: "failed",
  unknown: "unknown"
}, ds = {
  complete: "Complete",
  partial: "Partial",
  failed: "Failed",
  unknown: "Unknown"
}, r3 = {
  loadingReleaseInfo: "Loading release info...",
  copyRecord: "Copy record",
  openSsm: "Open SSM",
  openSsmAriaLabel: "Open SSM parameter",
  recordUnavailable: "Record unavailable",
  copyPrefix: "Copy",
  rows: {
    tag: "Tag",
    status: "Status",
    sha: "SHA",
    requestedRef: "Requested ref",
    deployedAt: "Deployed at",
    ssmParameter: "SSM parameter",
    selected: "Selected",
    deployed: "Deployed",
    failed: "Failed",
    terraform: "Terraform",
    api: "API",
    frontend: "Frontend"
  },
  links: {
    githubTag: "GitHub tag",
    githubCommit: "GitHub commit",
    workflowRun: "Workflow run"
  },
  status: ds,
  values: {
    unknown: "unknown",
    none: "none",
    notSelected: "not selected",
    deployed: "deployed"
  }
}, sN = {
  [Cr.complete]: {
    label: ds.complete,
    icon: "circle-check",
    iconTone: "positive"
  },
  [Cr.failed]: {
    label: ds.failed,
    icon: "circle-exclamation",
    iconTone: "negative"
  },
  [Cr.partial]: {
    label: ds.partial,
    icon: "warning",
    iconTone: "warning"
  },
  [Cr.unknown]: {
    label: ds.unknown,
    icon: "circle-info",
    iconTone: "neutral"
  }
};
function Rp(t, e = "unknown") {
  return t ? t.slice(0, 12) : e;
}
function s3(t) {
  return t ?? Cr.unknown;
}
function i3(t, e) {
  return e[t];
}
function a3(t, e) {
  if (!e)
    return "";
  const n = encodeURIComponent(encodeURIComponent(e));
  return `https://${t}.console.aws.amazon.com/systems-manager/parameters/${n}/description?region=${t}`;
}
function l3({
  appName: t,
  environment: e,
  recordParameterName: n,
  commitId: o,
  branchName: r,
  releaseTag: s
}) {
  return {
    app: t,
    environment: e,
    parameterName: n,
    status: Cr.unknown,
    sourceSha: o,
    requestedRef: r,
    releaseTag: s,
    selectedParts: [],
    deployedParts: [],
    failedParts: [],
    parts: {
      terraform: {
        selected: !1,
        result: "unknown",
        deployed: !1
      },
      api: {
        selected: !1,
        result: "unknown",
        deployed: !1
      },
      frontend: {
        selected: !1,
        result: "unknown",
        deployed: !1
      }
    }
  };
}
function kl(t, e) {
  return !t || t.length === 0 ? e : t.join(", ");
}
function c3(t, e) {
  if (!t)
    return e;
  const n = new Date(t);
  return Number.isNaN(n.getTime()) ? t : n.toLocaleString();
}
function Ol(t, e) {
  return t ? t.selected ? t.deployed ? e.deployed : t.result ?? e.unknown : e.notSelected : e.unknown;
}
function I1(t) {
  return Te(t.defaultTagName ?? "div", t, t);
}
const u3 = ye([
  // Font weight and line-height are set here; font size inherits from context.
  "font-(number:--font-weight-medium)",
  "leading-(--font-line-height-24)",
  "cursor-pointer",
  "select-none",
  "transition-colors",
  "duration-200",
  "ease-in-out",
  "outline-none",
  "rounded-(--radius-sm)",
  // Focus ring
  "focus-visible:ring-2",
  "focus-visible:ring-(--color-inline-link-focus-ring)",
  "focus-visible:ring-offset-(--spacing-4)",
  // Pressed/active background
  "active:bg-(--color-inline-link-pressed-bg)"
], {
  variants: {
    variant: {
      /**
       * Navigational: triggers a full context change (new page, route, or view).
       * Renders blue; underline appears on hover only.
       */
      navigational: ["text-(--color-inline-link)", "no-underline", "hover:underline", "underline-offset-4"],
      /**
       * Contextual: reveals information within the current context
       * (drawer, popover, inline expansion). Renders near-black; always underlined.
       */
      contextual: ["text-(--color-inline-link-contextual)", "underline", "underline-offset-4", "hover:text-(--color-inline-link-contextual-hover)"]
    },
    destructive: {
      true: ["text-(--color-text-destructive)", "hover:text-(--color-text-destructive)"]
    },
    disabled: {
      true: ["opacity-50", "pointer-events-none"]
    }
  },
  defaultVariants: {
    variant: "navigational"
  }
});
function Dl(t) {
  const e = J.c(23);
  let n, o, r, s, i, a, l, c, u;
  if (e[0] !== t) {
    const {
      destructive: p,
      disabled: g,
      children: m,
      ...h
    } = t;
    n = m, i = h;
    const b = p === void 0 ? !1 : p;
    r = g === void 0 ? !1 : g, s = "onClick" in t && t.onClick !== void 0 && !("href" in t && t.href !== void 0), o = u3({
      variant: s ? "contextual" : "navigational",
      destructive: b,
      disabled: r
    });
    const {
      render: w,
      href: y,
      target: C,
      rel: R,
      ...S
    } = s ? {} : i, E = C === "_blank" && !R ? "noopener noreferrer" : R;
    u = I1, a = "a", l = w, c = on(S, {
      ...y !== void 0 && {
        href: y
      },
      ...C !== void 0 && {
        target: C
      },
      ...E !== void 0 && {
        rel: E
      },
      ...r && {
        href: void 0,
        tabIndex: -1,
        onClick: d3
      },
      "aria-disabled": r || void 0,
      className: o,
      children: n
    }), e[0] = t, e[1] = n, e[2] = o, e[3] = r, e[4] = s, e[5] = i, e[6] = a, e[7] = l, e[8] = c, e[9] = u;
  } else
    n = e[1], o = e[2], r = e[3], s = e[4], i = e[5], a = e[6], l = e[7], c = e[8], u = e[9];
  let d;
  e[10] !== a || e[11] !== l || e[12] !== c ? (d = {
    defaultTagName: a,
    render: l,
    props: c
  }, e[10] = a, e[11] = l, e[12] = c, e[13] = d) : d = e[13];
  const f = u(d);
  if (s) {
    const p = i;
    let g, m;
    e[14] !== p ? ({
      onClick: m,
      ...g
    } = p, e[14] = p, e[15] = g, e[16] = m) : (g = e[15], m = e[16]);
    const h = g, b = r ? void 0 : m, w = r || void 0;
    let y;
    return e[17] !== n || e[18] !== o || e[19] !== h || e[20] !== b || e[21] !== w ? (y = /* @__PURE__ */ x("button", { ...h, type: "button", onClick: b, "aria-disabled": w, className: o, children: n }), e[17] = n, e[18] = o, e[19] = h, e[20] = b, e[21] = w, e[22] = y) : y = e[22], y;
  }
  return f;
}
function d3(t) {
  return t.preventDefault();
}
function f3(t) {
  const e = J.c(13), {
    display: n,
    labels: o
  } = t;
  let r;
  e[0] !== n.githubTagUrl || e[1] !== o ? (r = n.githubTagUrl ? /* @__PURE__ */ x(Dl, { href: n.githubTagUrl, target: "_blank", rel: "noreferrer", children: o.links.githubTag }) : null, e[0] = n.githubTagUrl, e[1] = o, e[2] = r) : r = e[2];
  let s;
  e[3] !== n.githubCommitUrl || e[4] !== o ? (s = n.githubCommitUrl ? /* @__PURE__ */ x(Dl, { href: n.githubCommitUrl, target: "_blank", rel: "noreferrer", children: o.links.githubCommit }) : null, e[3] = n.githubCommitUrl, e[4] = o, e[5] = s) : s = e[5];
  let i;
  e[6] !== n.record.workflowRunUrl || e[7] !== o ? (i = n.record.workflowRunUrl ? /* @__PURE__ */ x(Dl, { href: n.record.workflowRunUrl, target: "_blank", rel: "noreferrer", children: o.links.workflowRun }) : null, e[6] = n.record.workflowRunUrl, e[7] = o, e[8] = i) : i = e[8];
  let a;
  return e[9] !== r || e[10] !== s || e[11] !== i ? (a = /* @__PURE__ */ j("div", { className: "flex flex-wrap gap-(--spacing-12)", children: [
    r,
    s,
    i
  ] }), e[9] = r, e[10] = s, e[11] = i, e[12] = a) : a = e[12], a;
}
function Pn(t) {
  const e = J.c(17), {
    label: n,
    value: o,
    copyValue: r,
    copiedLabel: s,
    copyPrefix: i,
    onCopy: a,
    unknownValue: l,
    noneValue: c
  } = t, u = r ?? o, d = typeof navigator < "u" && !!navigator.clipboard?.writeText, f = !!(u && u !== l && u !== c), p = s === n;
  let g;
  e[0] !== n ? (g = /* @__PURE__ */ x("div", { className: "max-sm:col-span-2", children: /* @__PURE__ */ x(ys, { as: "div", size: "sm", tone: "subtle", children: n }) }), e[0] = n, e[1] = g) : g = e[1];
  const m = o || l;
  let h;
  e[2] !== m ? (h = /* @__PURE__ */ x("code", { className: "min-w-0 truncate rounded-(--radius-sm) bg-surface-container px-(--spacing-8) py-(--spacing-4) font-mono text-(length:--font-size-body-sm) leading-(--line-height-16) text-text-default", children: m }), e[2] = m, e[3] = h) : h = e[3];
  const b = p ? "check-mark" : "copy-regular", w = `${i} ${n}`, y = !f || !d;
  let C;
  e[4] !== n || e[5] !== a || e[6] !== u ? (C = () => {
    a(u, n);
  }, e[4] = n, e[5] = a, e[6] = u, e[7] = C) : C = e[7];
  let R;
  e[8] !== b || e[9] !== w || e[10] !== y || e[11] !== C ? (R = /* @__PURE__ */ x(Kt, { variant: "ghost", size: "sm", icon: b, "aria-label": w, disabled: y, onClick: C }), e[8] = b, e[9] = w, e[10] = y, e[11] = C, e[12] = R) : R = e[12];
  let S;
  return e[13] !== g || e[14] !== h || e[15] !== R ? (S = /* @__PURE__ */ j("div", { className: "grid grid-cols-[128px_minmax(0,1fr)_var(--spacing-32)] items-center gap-(--spacing-8) border-b border-outline-subtle py-(--spacing-8) last:border-b-0 max-sm:grid-cols-[1fr_var(--spacing-32)]", children: [
    g,
    h,
    R
  ] }), e[13] = g, e[14] = h, e[15] = R, e[16] = S) : S = e[16], S;
}
function p3(t) {
  const e = J.c(76), {
    display: n,
    copiedLabel: o,
    labels: r,
    onCopy: s
  } = t, i = r.rows.selected;
  let a;
  e[0] !== n.record.selectedParts || e[1] !== r.values.none ? (a = kl(n.record.selectedParts, r.values.none), e[0] = n.record.selectedParts, e[1] = r.values.none, e[2] = a) : a = e[2];
  let l;
  e[3] !== o || e[4] !== r.copyPrefix || e[5] !== r.rows.selected || e[6] !== r.values.none || e[7] !== r.values.unknown || e[8] !== s || e[9] !== a ? (l = /* @__PURE__ */ x(Pn, { label: i, value: a, copiedLabel: o, copyPrefix: r.copyPrefix, onCopy: s, unknownValue: r.values.unknown, noneValue: r.values.none }), e[3] = o, e[4] = r.copyPrefix, e[5] = r.rows.selected, e[6] = r.values.none, e[7] = r.values.unknown, e[8] = s, e[9] = a, e[10] = l) : l = e[10];
  const c = r.rows.deployed;
  let u;
  e[11] !== n.record.deployedParts || e[12] !== r.values.none ? (u = kl(n.record.deployedParts, r.values.none), e[11] = n.record.deployedParts, e[12] = r.values.none, e[13] = u) : u = e[13];
  let d;
  e[14] !== o || e[15] !== r.copyPrefix || e[16] !== r.rows.deployed || e[17] !== r.values.none || e[18] !== r.values.unknown || e[19] !== s || e[20] !== u ? (d = /* @__PURE__ */ x(Pn, { label: c, value: u, copiedLabel: o, copyPrefix: r.copyPrefix, onCopy: s, unknownValue: r.values.unknown, noneValue: r.values.none }), e[14] = o, e[15] = r.copyPrefix, e[16] = r.rows.deployed, e[17] = r.values.none, e[18] = r.values.unknown, e[19] = s, e[20] = u, e[21] = d) : d = e[21];
  const f = r.rows.failed;
  let p;
  e[22] !== n.record.failedParts || e[23] !== r.values.none ? (p = kl(n.record.failedParts, r.values.none), e[22] = n.record.failedParts, e[23] = r.values.none, e[24] = p) : p = e[24];
  let g;
  e[25] !== o || e[26] !== r.copyPrefix || e[27] !== r.rows.failed || e[28] !== r.values.none || e[29] !== r.values.unknown || e[30] !== s || e[31] !== p ? (g = /* @__PURE__ */ x(Pn, { label: f, value: p, copiedLabel: o, copyPrefix: r.copyPrefix, onCopy: s, unknownValue: r.values.unknown, noneValue: r.values.none }), e[25] = o, e[26] = r.copyPrefix, e[27] = r.rows.failed, e[28] = r.values.none, e[29] = r.values.unknown, e[30] = s, e[31] = p, e[32] = g) : g = e[32];
  const m = r.rows.terraform, h = n.record.parts?.terraform;
  let b;
  e[33] !== r.values || e[34] !== h ? (b = Ol(h, r.values), e[33] = r.values, e[34] = h, e[35] = b) : b = e[35];
  const w = n.record.parts?.terraform?.sha;
  let y;
  e[36] !== o || e[37] !== r.copyPrefix || e[38] !== r.rows.terraform || e[39] !== r.values.none || e[40] !== r.values.unknown || e[41] !== s || e[42] !== b || e[43] !== w ? (y = /* @__PURE__ */ x(Pn, { label: m, value: b, copyValue: w, copiedLabel: o, copyPrefix: r.copyPrefix, onCopy: s, unknownValue: r.values.unknown, noneValue: r.values.none }), e[36] = o, e[37] = r.copyPrefix, e[38] = r.rows.terraform, e[39] = r.values.none, e[40] = r.values.unknown, e[41] = s, e[42] = b, e[43] = w, e[44] = y) : y = e[44];
  const C = r.rows.api, R = n.record.parts?.api;
  let S;
  e[45] !== r.values || e[46] !== R ? (S = Ol(R, r.values), e[45] = r.values, e[46] = R, e[47] = S) : S = e[47];
  const E = n.record.parts?.api?.image ?? n.record.apiImage;
  let P;
  e[48] !== o || e[49] !== r.copyPrefix || e[50] !== r.rows.api || e[51] !== r.values.none || e[52] !== r.values.unknown || e[53] !== s || e[54] !== S || e[55] !== E ? (P = /* @__PURE__ */ x(Pn, { label: C, value: S, copyValue: E, copiedLabel: o, copyPrefix: r.copyPrefix, onCopy: s, unknownValue: r.values.unknown, noneValue: r.values.none }), e[48] = o, e[49] = r.copyPrefix, e[50] = r.rows.api, e[51] = r.values.none, e[52] = r.values.unknown, e[53] = s, e[54] = S, e[55] = E, e[56] = P) : P = e[56];
  const N = r.rows.frontend, I = n.record.parts?.frontend;
  let M;
  e[57] !== r.values || e[58] !== I ? (M = Ol(I, r.values), e[57] = r.values, e[58] = I, e[59] = M) : M = e[59];
  const T = n.record.parts?.frontend?.cloudfrontDistributionId ?? n.record.frontendCloudfrontDistributionId;
  let k;
  e[60] !== o || e[61] !== r.copyPrefix || e[62] !== r.rows.frontend || e[63] !== r.values.none || e[64] !== r.values.unknown || e[65] !== s || e[66] !== M || e[67] !== T ? (k = /* @__PURE__ */ x(Pn, { label: N, value: M, copyValue: T, copiedLabel: o, copyPrefix: r.copyPrefix, onCopy: s, unknownValue: r.values.unknown, noneValue: r.values.none }), e[60] = o, e[61] = r.copyPrefix, e[62] = r.rows.frontend, e[63] = r.values.none, e[64] = r.values.unknown, e[65] = s, e[66] = M, e[67] = T, e[68] = k) : k = e[68];
  let D;
  return e[69] !== y || e[70] !== P || e[71] !== k || e[72] !== l || e[73] !== d || e[74] !== g ? (D = /* @__PURE__ */ j("div", { className: "rounded-(--radius-sm) border border-outline-subtle bg-surface-container-lowest px-(--spacing-12)", children: [
    l,
    d,
    g,
    y,
    P,
    k
  ] }), e[69] = y, e[70] = P, e[71] = k, e[72] = l, e[73] = d, e[74] = g, e[75] = D) : D = e[75], D;
}
function g3(t) {
  const e = J.c(62), {
    display: n,
    copiedLabel: o,
    labels: r,
    onCopy: s
  } = t;
  let i;
  e[0] !== o || e[1] !== n.displayTag || e[2] !== r.copyPrefix || e[3] !== r.rows.tag || e[4] !== r.values.none || e[5] !== r.values.unknown || e[6] !== s ? (i = /* @__PURE__ */ x(Pn, { label: r.rows.tag, value: n.displayTag, copiedLabel: o, copyPrefix: r.copyPrefix, onCopy: s, unknownValue: r.values.unknown, noneValue: r.values.none }), e[0] = o, e[1] = n.displayTag, e[2] = r.copyPrefix, e[3] = r.rows.tag, e[4] = r.values.none, e[5] = r.values.unknown, e[6] = s, e[7] = i) : i = e[7];
  const a = r.rows.status;
  let l;
  e[8] !== n.status || e[9] !== r.status ? (l = i3(n.status, r.status), e[8] = n.status, e[9] = r.status, e[10] = l) : l = e[10];
  let c;
  e[11] !== o || e[12] !== r.copyPrefix || e[13] !== r.rows.status || e[14] !== r.values.none || e[15] !== r.values.unknown || e[16] !== s || e[17] !== l ? (c = /* @__PURE__ */ x(Pn, { label: a, value: l, copiedLabel: o, copyPrefix: r.copyPrefix, onCopy: s, unknownValue: r.values.unknown, noneValue: r.values.none }), e[11] = o, e[12] = r.copyPrefix, e[13] = r.rows.status, e[14] = r.values.none, e[15] = r.values.unknown, e[16] = s, e[17] = l, e[18] = c) : c = e[18];
  let u;
  e[19] !== o || e[20] !== n.shortSha || e[21] !== n.sourceSha || e[22] !== r.copyPrefix || e[23] !== r.rows.sha || e[24] !== r.values.none || e[25] !== r.values.unknown || e[26] !== s ? (u = /* @__PURE__ */ x(Pn, { label: r.rows.sha, value: n.shortSha, copyValue: n.sourceSha, copiedLabel: o, copyPrefix: r.copyPrefix, onCopy: s, unknownValue: r.values.unknown, noneValue: r.values.none }), e[19] = o, e[20] = n.shortSha, e[21] = n.sourceSha, e[22] = r.copyPrefix, e[23] = r.rows.sha, e[24] = r.values.none, e[25] = r.values.unknown, e[26] = s, e[27] = u) : u = e[27];
  const d = n.record.requestedRef ?? r.values.unknown;
  let f;
  e[28] !== o || e[29] !== r.copyPrefix || e[30] !== r.rows.requestedRef || e[31] !== r.values.none || e[32] !== r.values.unknown || e[33] !== s || e[34] !== d ? (f = /* @__PURE__ */ x(Pn, { label: r.rows.requestedRef, value: d, copiedLabel: o, copyPrefix: r.copyPrefix, onCopy: s, unknownValue: r.values.unknown, noneValue: r.values.none }), e[28] = o, e[29] = r.copyPrefix, e[30] = r.rows.requestedRef, e[31] = r.values.none, e[32] = r.values.unknown, e[33] = s, e[34] = d, e[35] = f) : f = e[35];
  const p = r.rows.deployedAt;
  let g;
  e[36] !== n.record.deployedAt || e[37] !== r.values.unknown ? (g = c3(n.record.deployedAt, r.values.unknown), e[36] = n.record.deployedAt, e[37] = r.values.unknown, e[38] = g) : g = e[38];
  let m;
  e[39] !== o || e[40] !== r.copyPrefix || e[41] !== r.rows.deployedAt || e[42] !== r.values.none || e[43] !== r.values.unknown || e[44] !== s || e[45] !== g ? (m = /* @__PURE__ */ x(Pn, { label: p, value: g, copiedLabel: o, copyPrefix: r.copyPrefix, onCopy: s, unknownValue: r.values.unknown, noneValue: r.values.none }), e[39] = o, e[40] = r.copyPrefix, e[41] = r.rows.deployedAt, e[42] = r.values.none, e[43] = r.values.unknown, e[44] = s, e[45] = g, e[46] = m) : m = e[46];
  let h;
  e[47] !== o || e[48] !== n.parameterName || e[49] !== r.copyPrefix || e[50] !== r.rows.ssmParameter || e[51] !== r.values.none || e[52] !== r.values.unknown || e[53] !== s ? (h = /* @__PURE__ */ x(Pn, { label: r.rows.ssmParameter, value: n.parameterName, copiedLabel: o, copyPrefix: r.copyPrefix, onCopy: s, unknownValue: r.values.unknown, noneValue: r.values.none }), e[47] = o, e[48] = n.parameterName, e[49] = r.copyPrefix, e[50] = r.rows.ssmParameter, e[51] = r.values.none, e[52] = r.values.unknown, e[53] = s, e[54] = h) : h = e[54];
  let b;
  return e[55] !== i || e[56] !== m || e[57] !== h || e[58] !== c || e[59] !== u || e[60] !== f ? (b = /* @__PURE__ */ j("div", { className: "rounded-(--radius-sm) border border-outline-subtle bg-surface-container-lowest px-(--spacing-12)", children: [
    i,
    c,
    u,
    f,
    m,
    h
  ] }), e[55] = i, e[56] = m, e[57] = h, e[58] = c, e[59] = u, e[60] = f, e[61] = b) : b = e[61], b;
}
function iN({
  open: t,
  onOpenChange: e,
  appName: n,
  appLabel: o = n,
  labels: r = r3,
  environment: s = "local",
  branchName: i = "local",
  commitId: a = "local",
  releaseTag: l = "",
  recordParameterName: c = `/assetwatch/deployments/${s}/${n}`,
  record: u,
  isRecordLoading: d = !1,
  isRecordUnavailable: f = !1,
  awsRegion: p = "us-east-2",
  repoFullName: g = "AssetWatch1/fullstack.assetwatch",
  modalTitle: m = `${o} Release Info`,
  modalDescription: h = `Current ${o} release information for this environment.`
}) {
  const [b, w] = Mt(null), y = typeof navigator < "u" && !!navigator.clipboard?.writeText;
  async function C(V, _) {
    !V || !y || (await navigator.clipboard.writeText(V), w(_), window.setTimeout(() => w(null), 1600));
  }
  if (d)
    return /* @__PURE__ */ x(Sp, { open: t, onOpenChange: e, title: m, description: h, children: /* @__PURE__ */ j(tr, { gap: 8, children: [
      /* @__PURE__ */ x($c, { size: "sm" }),
      /* @__PURE__ */ x(ys, { size: "sm", tone: "subtle", children: r.loadingReleaseInfo })
    ] }) });
  const R = u ?? l3({
    appName: n,
    environment: s,
    recordParameterName: c,
    commitId: a,
    branchName: i,
    releaseTag: l
  }), S = s3(R.status), E = R.releaseTag || l || `${R.environment ?? "local"}-${Rp(R.sourceSha, r.values.unknown)}`, P = R.sourceSha ?? a, N = Rp(P, r.values.unknown), I = R.parameterName || c || r.values.unknown, M = a3(p, I), T = JSON.stringify(R, null, 2), k = R.releaseTag ? `https://github.com/${g}/tree/${R.releaseTag}` : "", D = P && P !== "local" ? `https://github.com/${g}/commit/${P}` : "", O = {
    appLabel: o,
    environment: R.environment ?? s,
    status: S,
    displayTag: E,
    sourceSha: P,
    shortSha: N,
    parameterName: I,
    ssmConsoleUrl: M,
    recordJson: T,
    githubTagUrl: k,
    githubCommitUrl: D,
    record: R
  };
  return /* @__PURE__ */ x(Sp, { open: t, onOpenChange: e, title: m, description: h, footer: /* @__PURE__ */ j(tr, { gap: 8, children: [
    /* @__PURE__ */ x(Hn, { variant: "outline", size: "sm", icon: b === "record" ? "check-mark" : "copy-regular", disabled: !y, onClick: () => {
      C(O.recordJson, "record");
    }, children: r.copyRecord }),
    O.ssmConsoleUrl ? /* @__PURE__ */ x(Hn, { variant: "primary", size: "sm", icon: "arrow-up-right", render: /* @__PURE__ */ x("a", { href: O.ssmConsoleUrl, target: "_blank", rel: "noreferrer", "aria-label": r.openSsmAriaLabel, children: r.openSsm }), children: r.openSsm }) : null
  ] }), children: /* @__PURE__ */ j(vs, { gap: 16, children: [
    f ? /* @__PURE__ */ x(ys, { size: "sm", tone: "warning", children: r.recordUnavailable }) : null,
    /* @__PURE__ */ x(g3, { display: O, copiedLabel: b, labels: r, onCopy: C }),
    /* @__PURE__ */ x(p3, { display: O, copiedLabel: b, labels: r, onCopy: C }),
    /* @__PURE__ */ x(f3, { display: O, labels: r }),
    /* @__PURE__ */ x("pre", { className: "max-h-[220px] overflow-auto rounded-(--radius-sm) border border-outline-subtle bg-surface-container p-(--spacing-12) text-(length:--font-size-body-sm) leading-(--line-height-16) text-text-default", children: O.recordJson })
  ] }) });
}
const m3 = 4;
function os(t) {
  if (!t) return 0;
  const e = t.getBoundingClientRect().width;
  return e > 0 ? e : t.offsetWidth;
}
function h3(t) {
  const e = Number.parseFloat(getComputedStyle(t).columnGap);
  return Number.isFinite(e) ? e : m3;
}
function b3(t, e) {
  return t.reduce((o, r) => o + r, 0) + Math.max(0, t.length - 1) * e;
}
function Ep({
  itemWidths: t,
  reservedStartWidth: e,
  reservedEndWidth: n,
  overflowWidth: o
}) {
  return [...e > 0 ? [e] : [], ...t, ...o && o > 0 ? [o] : [], ...n > 0 ? [n] : []];
}
function Pp(t, e, n, o) {
  if (t.length === 0) return !0;
  if (o <= 1) return b3(t, n) <= e;
  let r = 1, s = 0;
  for (const i of t) {
    const a = s === 0 ? i : s + n + i;
    if (a <= e || s === 0) {
      s = a;
      continue;
    }
    if (r += 1, s = i, r > o) return !1;
  }
  return !0;
}
function M1({
  items: t,
  maxRows: e = 1,
  minVisibleItems: n = t.length > 0 ? 1 : 0
}) {
  const o = kt(null), r = kt(null), s = kt(null), i = kt(null), a = kt([]), l = kt({}), c = kt(() => {
  }), [u, d] = Mt(Number.POSITIVE_INFINITY), f = t.length === 0 ? 0 : Math.max(n, Math.min(u, t.length)), p = t.slice(0, f), g = t.length - p.length;
  return c.current = () => {
    const m = o.current;
    function h(E) {
      d((P) => P === E ? P : E);
    }
    if (!m || t.length <= n) {
      h(t.length);
      return;
    }
    const b = os(m), w = h3(m), y = os(s.current), C = os(i.current), R = t.map((E, P) => os(a.current[P])), S = Ep({
      itemWidths: R,
      reservedStartWidth: y,
      reservedEndWidth: C
    });
    if (Pp(S, b, w, e)) {
      h(t.length);
      return;
    }
    for (let E = t.length - 1; E >= n; E -= 1) {
      const P = t.length - E, N = os(l.current[P]), I = Ep({
        itemWidths: R.slice(0, E),
        reservedStartWidth: y,
        reservedEndWidth: C,
        overflowWidth: N
      });
      if (Pp(I, b, w, e)) {
        h(E);
        return;
      }
    }
    h(n);
  }, Zi(() => {
    c.current();
  }), Zi(() => {
    const m = o.current;
    if (typeof ResizeObserver > "u" || !m) return;
    const h = new ResizeObserver(() => {
      c.current();
    });
    return h.observe(m), r.current && h.observe(r.current), () => h.disconnect();
  }, []), {
    containerRef: o,
    measuringContainerRef: r,
    reservedStartRef: s,
    reservedEndRef: i,
    itemRefs: a,
    overflowRefs: l,
    visibleItems: p,
    overflowCount: g
  };
}
function sn({
  controlled: t,
  default: e,
  name: n,
  state: o = "value"
}) {
  const {
    current: r
  } = v.useRef(t !== void 0), [s, i] = v.useState(e), a = r ? t : s;
  if (process.env.NODE_ENV !== "production") {
    v.useEffect(() => {
      r !== (t !== void 0) && Vo([`A component is changing the ${r ? "" : "un"}controlled ${o} state of ${n} to be ${r ? "un" : ""}controlled.`, "Elements should not switch from uncontrolled to controlled (or vice versa).", `Decide between using a controlled or uncontrolled ${n} element for the lifetime of the component.`, "The nature of the state is determined during the first render. It's considered controlled if the value is not `undefined`.", "More info: https://fb.me/react-controlled-components"].join(`
`));
    }, [o, n, t]);
    const {
      current: c
    } = v.useRef(e);
    v.useEffect(() => {
      !r && Np(c) !== Np(e) && Vo([`A component is changing the default ${o} state of an uncontrolled ${n} after being initialized. To suppress this warning opt to use a controlled ${n}.`].join(`
`));
    }, [e]);
  }
  const l = v.useCallback((c) => {
    r || i(c);
  }, []);
  return [a, l];
}
function Np(t) {
  let e = 0;
  const n = /* @__PURE__ */ new WeakMap();
  try {
    return JSON.stringify(t, function(s, i) {
      if (!(s === "_owner" && this != null && typeof this == "object" && "$$typeof" in this)) {
        if (typeof i == "bigint")
          return `__bigint__:${i}`;
        if (i !== null && typeof i == "object") {
          const a = n.get(i);
          if (a !== void 0)
            return `__object__:${a}`;
          n.set(i, e), e += 1;
        }
        return i;
      }
    }) ?? `__top__:${typeof t}`;
  } catch {
    return "__unserializable__";
  }
}
function v3(t) {
  const {
    open: e,
    defaultOpen: n,
    onOpenChange: o,
    disabled: r
  } = t, s = e !== void 0, [i, a] = sn({
    controlled: e,
    default: n,
    name: "Collapsible",
    state: "open"
  }), {
    mounted: l,
    setMounted: c,
    transitionStatus: u
  } = Yn(i, !0, !0), [d, f] = v.useState(i), [{
    height: p,
    width: g
  }, m] = v.useState({
    height: void 0,
    width: void 0
  }), h = St(), [b, w] = v.useState(), y = b ?? h, [C, R] = v.useState(!1), [S, E] = v.useState(!1), P = v.useRef(null), N = v.useRef(null), I = v.useRef(null), M = v.useRef(null), T = Oa(M, !1), k = ge((D) => {
    const O = !i, V = Pe(Bn, D.nativeEvent);
    if (o(O, V), V.isCanceled)
      return;
    const _ = M.current;
    N.current === "css-animation" && _ != null && _.style.removeProperty("animation-name"), !C && !S && (N.current != null && N.current !== "css-animation" && !l && O && c(!0), N.current === "css-animation" && (!d && O && f(!0), !l && O && c(!0))), a(O), N.current === "none" && l && !O && c(!1);
  });
  return xe(() => {
    s && N.current === "none" && !i && c(!1);
  }, [s, i, e, c]), v.useMemo(() => ({
    abortControllerRef: P,
    animationTypeRef: N,
    disabled: r,
    handleTrigger: k,
    height: p,
    mounted: l,
    open: i,
    panelId: y,
    panelRef: M,
    runOnceAnimationsFinish: T,
    setDimensions: m,
    setHiddenUntilFound: R,
    setKeepMounted: E,
    setMounted: c,
    setOpen: a,
    setPanelIdState: w,
    setVisible: f,
    transitionDimensionRef: I,
    transitionStatus: u,
    visible: d,
    width: g
  }), [P, N, r, k, p, l, i, y, M, T, m, R, E, c, a, f, I, u, d, g]);
}
const Ru = /* @__PURE__ */ v.createContext(void 0);
process.env.NODE_ENV !== "production" && (Ru.displayName = "CollapsibleRootContext");
function T1() {
  const t = v.useContext(Ru);
  if (t === void 0)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: CollapsibleRootContext is missing. Collapsible parts must be placed within <Collapsible.Root>." : Xe(15));
  return t;
}
let ms = (function(t) {
  return t.open = "data-open", t.closed = "data-closed", t[t.startingStyle = Wn.startingStyle] = "startingStyle", t[t.endingStyle = Wn.endingStyle] = "endingStyle", t;
})({}), y3 = /* @__PURE__ */ (function(t) {
  return t.panelOpen = "data-panel-open", t;
})({});
const x3 = {
  [ms.open]: ""
}, w3 = {
  [ms.closed]: ""
}, C3 = {
  open(t) {
    return t ? {
      [y3.panelOpen]: ""
    } : null;
  }
}, S3 = {
  open(t) {
    return t ? x3 : w3;
  }
}, k1 = {
  ...S3,
  ...Lt
}, O1 = /* @__PURE__ */ v.forwardRef(function(e, n) {
  const {
    render: o,
    className: r,
    defaultOpen: s = !1,
    disabled: i = !1,
    onOpenChange: a,
    open: l,
    style: c,
    ...u
  } = e, d = ge(a), f = v3({
    open: l,
    defaultOpen: s,
    onOpenChange: d,
    disabled: i
  }), p = v.useMemo(() => ({
    open: f.open,
    disabled: f.disabled,
    transitionStatus: f.transitionStatus
  }), [f.open, f.disabled, f.transitionStatus]), g = v.useMemo(() => ({
    ...f,
    onOpenChange: d,
    state: p
  }), [f, d, p]), m = Te("div", e, {
    state: p,
    ref: n,
    props: u,
    stateAttributesMapping: k1
  });
  return /* @__PURE__ */ x(Ru.Provider, {
    value: g,
    children: m
  });
});
process.env.NODE_ENV !== "production" && (O1.displayName = "CollapsibleRoot");
const R3 = {
  ...C3,
  ...Lt
}, xc = /* @__PURE__ */ v.forwardRef(function(e, n) {
  const {
    panelId: o,
    open: r,
    handleTrigger: s,
    state: i,
    disabled: a
  } = T1(), {
    className: l,
    disabled: c = a,
    id: u,
    render: d,
    nativeButton: f = !0,
    style: p,
    ...g
  } = e, {
    getButtonProps: m,
    buttonRef: h
  } = Ft({
    disabled: c,
    focusableWhenDisabled: !0,
    native: f
  }), b = v.useMemo(() => ({
    "aria-controls": r ? o : void 0,
    "aria-expanded": r,
    onClick: s
  }), [o, r, s]);
  return Te("button", e, {
    state: i,
    ref: [n, h],
    props: [b, g, m],
    stateAttributesMapping: R3
  });
});
process.env.NODE_ENV !== "production" && (xc.displayName = "CollapsibleTrigger");
let E3 = /* @__PURE__ */ (function(t) {
  return t.disabled = "data-disabled", t.orientation = "data-orientation", t;
})({});
function P3(t) {
  const {
    abortControllerRef: e,
    animationTypeRef: n,
    externalRef: o,
    height: r,
    hiddenUntilFound: s,
    keepMounted: i,
    id: a,
    mounted: l,
    onOpenChange: c,
    open: u,
    panelRef: d,
    runOnceAnimationsFinish: f,
    setDimensions: p,
    setMounted: g,
    setOpen: m,
    setVisible: h,
    transitionDimensionRef: b,
    visible: w,
    width: y
  } = t, C = v.useRef(!1), R = v.useRef(null), S = v.useRef(u), E = v.useRef(u), P = Fr(), N = v.useMemo(() => n.current === "css-animation" ? !w : !u && !l, [u, l, w, n]), I = ge((T) => {
    if (!T)
      return;
    if (n.current == null || b.current == null) {
      const O = getComputedStyle(T), V = O.animationName !== "none" && O.animationName !== "", _ = O.transitionDuration !== "0s" && O.transitionDuration !== "";
      V && _ ? process.env.NODE_ENV !== "production" && Ea("CSS transitions and CSS animations both detected on Collapsible or Accordion panel.", "Only one of either animation type should be used.") : O.animationName === "none" && O.transitionDuration !== "0s" ? n.current = "css-transition" : O.animationName !== "none" && O.transitionDuration === "0s" ? n.current = "css-animation" : n.current = "none", T.getAttribute(E3.orientation) === "horizontal" || O.transitionProperty.indexOf("width") > -1 ? b.current = "width" : b.current = "height";
    }
    if (n.current !== "css-transition")
      return;
    (r === void 0 || y === void 0) && (p({
      height: T.scrollHeight,
      width: T.scrollWidth
    }), E.current && T.style.setProperty("transition-duration", "0s"));
    let k = -1, D = -1;
    return k = Tt.request(() => {
      E.current = !1, D = Tt.request(() => {
        setTimeout(() => {
          T.style.removeProperty("transition-duration");
        });
      });
    }), () => {
      Tt.cancel(k), Tt.cancel(D);
    };
  }), M = ln(o, d, I);
  return xe(() => {
    if (n.current !== "css-transition")
      return;
    const T = d.current;
    if (!T)
      return;
    let k = -1;
    if (e.current != null && (e.current.abort(), e.current = null), u) {
      const D = {
        "justify-content": T.style.justifyContent,
        "align-items": T.style.alignItems,
        "align-content": T.style.alignContent,
        "justify-items": T.style.justifyItems
      };
      Object.keys(D).forEach((O) => {
        T.style.setProperty(O, "initial", "important");
      }), !E.current && !i && T.setAttribute(ms.startingStyle, ""), p({
        height: T.scrollHeight,
        width: T.scrollWidth
      }), k = Tt.request(() => {
        Object.entries(D).forEach(([O, V]) => {
          V === "" ? T.style.removeProperty(O) : T.style.setProperty(O, V);
        });
      });
    } else {
      if (T.scrollHeight === 0 && T.scrollWidth === 0)
        return;
      p({
        height: T.scrollHeight,
        width: T.scrollWidth
      });
      const D = new AbortController();
      e.current = D;
      const O = D.signal;
      let V = null;
      const _ = ms.endingStyle;
      return V = new MutationObserver((A) => {
        A.some((H) => H.type === "attributes" && H.attributeName === _) && (V?.disconnect(), V = null, f(() => {
          p({
            height: 0,
            width: 0
          }), T.style.removeProperty("content-visibility"), g(!1), e.current === D && (e.current = null);
        }, O));
      }), V.observe(T, {
        attributes: !0,
        attributeFilter: [_]
      }), () => {
        V?.disconnect(), P.cancel(), e.current === D && (D.abort(), e.current = null);
      };
    }
    return () => {
      Tt.cancel(k);
    };
  }, [e, n, P, s, i, l, u, d, f, p, g]), xe(() => {
    if (n.current !== "css-animation")
      return;
    const T = d.current;
    T && (R.current = T.style.animationName || R.current, T.style.setProperty("animation-name", "none"), p({
      height: T.scrollHeight,
      width: T.scrollWidth
    }), !S.current && !C.current && T.style.removeProperty("animation-name"), u ? (e.current != null && (e.current.abort(), e.current = null), g(!0), h(!0)) : (e.current = new AbortController(), f(() => {
      g(!1), h(!1), e.current = null;
    }, e.current.signal)));
  }, [e, n, u, d, f, p, g, h, w]), Ar(() => {
    const T = Tt.request(() => {
      S.current = !1;
    });
    return () => Tt.cancel(T);
  }), xe(() => {
    if (!s)
      return;
    const T = d.current;
    if (!T)
      return;
    let k = -1, D = -1;
    return u && C.current && (T.style.transitionDuration = "0s", p({
      height: T.scrollHeight,
      width: T.scrollWidth
    }), k = Tt.request(() => {
      C.current = !1, D = Tt.request(() => {
        setTimeout(() => {
          T.style.removeProperty("transition-duration");
        });
      });
    })), () => {
      Tt.cancel(k), Tt.cancel(D);
    };
  }, [s, u, d, p]), xe(() => {
    const T = d.current;
    T && s && N && (T.setAttribute("hidden", "until-found"), n.current === "css-transition" && T.setAttribute(ms.startingStyle, ""));
  }, [s, N, n, d]), v.useEffect(function() {
    const k = d.current;
    if (!k)
      return;
    function D(O) {
      C.current = !0, m(!0), c(!0, Pe(Et, O));
    }
    return rt(k, "beforematch", D);
  }, [c, d, m]), v.useMemo(() => ({
    props: {
      hidden: N,
      id: a,
      ref: M
    }
  }), [N, a, M]);
}
let Ip = /* @__PURE__ */ (function(t) {
  return t.collapsiblePanelHeight = "--collapsible-panel-height", t.collapsiblePanelWidth = "--collapsible-panel-width", t;
})({});
const D1 = /* @__PURE__ */ v.forwardRef(function(e, n) {
  const {
    className: o,
    hiddenUntilFound: r,
    keepMounted: s,
    render: i,
    id: a,
    style: l,
    ...c
  } = e;
  process.env.NODE_ENV !== "production" && xe(() => {
    r && s === !1 && Ea("The `keepMounted={false}` prop on a Collapsible will be ignored when using `hiddenUntilFound` since it requires the Panel to remain mounted even when closed.");
  }, [r, s]);
  const {
    abortControllerRef: u,
    animationTypeRef: d,
    height: f,
    mounted: p,
    onOpenChange: g,
    open: m,
    panelId: h,
    panelRef: b,
    runOnceAnimationsFinish: w,
    setDimensions: y,
    setHiddenUntilFound: C,
    setKeepMounted: R,
    setMounted: S,
    setPanelIdState: E,
    setOpen: P,
    setVisible: N,
    state: I,
    transitionDimensionRef: M,
    visible: T,
    width: k,
    transitionStatus: D
  } = T1(), O = r ?? !1, V = s ?? !1;
  xe(() => {
    if (a)
      return E(a), () => {
        E(void 0);
      };
  }, [a, E]), xe(() => {
    C(O);
  }, [C, O]), xe(() => {
    R(V);
  }, [R, V]);
  const {
    props: _
  } = P3({
    abortControllerRef: u,
    animationTypeRef: d,
    externalRef: n,
    height: f,
    hiddenUntilFound: O,
    id: h,
    keepMounted: V,
    mounted: p,
    onOpenChange: g,
    open: m,
    panelRef: b,
    runOnceAnimationsFinish: w,
    setDimensions: y,
    setMounted: S,
    setOpen: P,
    setVisible: N,
    transitionDimensionRef: M,
    visible: T,
    width: k
  });
  Bt({
    open: m && D === "idle",
    ref: b,
    onComplete() {
      m && y({
        height: void 0,
        width: void 0
      });
    }
  });
  const A = v.useMemo(() => ({
    ...I,
    transitionStatus: D
  }), [I, D]), F = Te("div", e, {
    state: A,
    ref: [n, b],
    props: [_, {
      style: {
        [Ip.collapsiblePanelHeight]: f === void 0 ? "auto" : `${f}px`,
        [Ip.collapsiblePanelWidth]: k === void 0 ? "auto" : `${k}px`
      }
    }, c],
    stateAttributesMapping: k1
  });
  return V || O || p ? F : null;
});
process.env.NODE_ENV !== "production" && (D1.displayName = "CollapsiblePanel");
const N3 = ye(["group", "rounded-(--radius-sm)", "border border-outline-subtle", "bg-surface-container-lowest", "p-(--spacing-12)", "flex flex-col", "hover:bg-surface-container-low", "transition-colors duration-200 ease-in-out", "has-[:focus-visible]:[outline-width:var(--spacing-2)]", "has-[:focus-visible]:outline-solid", "has-[:focus-visible]:outline-tertiary-tertiary", "has-[:focus-visible]:[outline-offset:3px]", "data-[disabled]:opacity-50"]), I3 = ye(["w-full", "flex items-center gap-(--spacing-8)", "cursor-pointer", "min-h-(--spacing-24)", "text-left", "focus-visible:outline-none", "disabled:pointer-events-none", "disabled:cursor-default"]), M3 = ye(["group", "flex size-(--spacing-32) shrink-0 items-center justify-center", "rounded-(--radius-sm)", "cursor-pointer", "focus-visible:outline-none", "disabled:pointer-events-none", "disabled:cursor-default"]), T3 = ye(["w-full", "min-w-0", "overflow-hidden", "h-(--collapsible-panel-height)", "[&[data-starting-style]]:h-0", "[&[data-ending-style]]:h-0", "mt-(--spacing-12)", "[&[data-starting-style]]:mt-0", "[&[data-ending-style]]:mt-0", "transition-[height,margin-top] duration-150 ease-in-out", "motion-reduce:transition-none"]), k3 = ye(["w-full", "[overflow:clip]", "rounded-(--radius-sm)", "border-[0.5px] border-outline-subtle", "bg-surface-container-low", "p-(--spacing-8)", "flex flex-col gap-(--spacing-8)", "text-text-default"]);
function aN(t) {
  const e = J.c(58);
  let n, o, r, s, i, a, l, c, u, d, f, p;
  e[0] !== t ? ({
    open: l,
    defaultOpen: r,
    onOpenChange: a,
    title: f,
    startAccessory: u,
    titleAccessory: p,
    actions: n,
    summary: d,
    children: o,
    footer: i,
    disabled: s,
    ...c
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r, e[4] = s, e[5] = i, e[6] = a, e[7] = l, e[8] = c, e[9] = u, e[10] = d, e[11] = f, e[12] = p) : (n = e[1], o = e[2], r = e[3], s = e[4], i = e[5], a = e[6], l = e[7], c = e[8], u = e[9], d = e[10], f = e[11], p = e[12]);
  let g;
  e[13] !== a ? (g = a ? (F) => a(F) : void 0, e[13] = a, e[14] = g) : g = e[14];
  const m = s ? "" : void 0;
  let h;
  e[15] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (h = N3(), e[15] = h) : h = e[15];
  let b;
  e[16] !== u ? (b = u && /* @__PURE__ */ x("div", { className: "flex shrink-0 items-center", children: u }), e[16] = u, e[17] = b) : b = e[17];
  let w;
  e[18] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (w = I3(), e[18] = w) : w = e[18];
  let y;
  e[19] !== f ? (y = /* @__PURE__ */ x("h3", { className: "flex min-w-0 flex-1 m-0", children: /* @__PURE__ */ x(xc, { className: w, children: /* @__PURE__ */ x("span", { className: "min-w-0 flex-1 truncate font-(family-name:--font-family-title) text-(length:--font-size-title-md) font-medium leading-(--line-height-24) text-text-default", children: f }) }) }), e[19] = f, e[20] = y) : y = e[20];
  let C;
  e[21] !== p ? (C = p && /* @__PURE__ */ x("div", { className: "flex shrink-0 items-center", children: p }), e[21] = p, e[22] = C) : C = e[22];
  let R;
  e[23] !== y || e[24] !== C ? (R = /* @__PURE__ */ j("div", { className: "flex flex-1 min-w-0 items-center gap-(--spacing-8)", children: [
    y,
    C
  ] }), e[23] = y, e[24] = C, e[25] = R) : R = e[25];
  let S;
  e[26] !== n ? (S = n && /* @__PURE__ */ x("div", { className: "flex shrink-0 items-center", children: n }), e[26] = n, e[27] = S) : S = e[27];
  let E;
  e[28] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (E = M3(), e[28] = E) : E = e[28];
  let P;
  e[29] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (P = /* @__PURE__ */ x("span", { className: "flex group-data-[panel-open]:hidden", children: /* @__PURE__ */ x(Ye, { name: "chevron-down", size: "md", tone: "secondary" }) }), e[29] = P) : P = e[29];
  let N;
  e[30] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (N = /* @__PURE__ */ j(xc, { "aria-label": "Toggle accordion", "data-slot": "accordion-chevron-trigger", className: E, children: [
    P,
    /* @__PURE__ */ x("span", { className: "hidden group-data-[panel-open]:flex", children: /* @__PURE__ */ x(Ye, { name: "chevron-up", size: "md", tone: "secondary" }) })
  ] }), e[30] = N) : N = e[30];
  let I;
  e[31] !== b || e[32] !== R || e[33] !== S ? (I = /* @__PURE__ */ j("div", { className: "flex items-center gap-(--spacing-8) w-full", children: [
    b,
    R,
    S,
    N
  ] }), e[31] = b, e[32] = R, e[33] = S, e[34] = I) : I = e[34];
  let M;
  e[35] !== d ? (M = d && /* @__PURE__ */ x("div", { className: "w-full min-w-0", children: d }), e[35] = d, e[36] = M) : M = e[36];
  let T;
  e[37] !== I || e[38] !== M ? (T = /* @__PURE__ */ j("div", { className: "flex flex-col gap-(--spacing-8) w-full", children: [
    I,
    M
  ] }), e[37] = I, e[38] = M, e[39] = T) : T = e[39];
  let k;
  e[40] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (k = T3(), e[40] = k) : k = e[40];
  let D;
  e[41] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (D = k3(), e[41] = D) : D = e[41];
  let O;
  e[42] !== o ? (O = /* @__PURE__ */ x("div", { className: D, children: o }), e[42] = o, e[43] = O) : O = e[43];
  let V;
  e[44] !== i ? (V = i && /* @__PURE__ */ x("div", { className: "w-full", children: i }), e[44] = i, e[45] = V) : V = e[45];
  let _;
  e[46] !== O || e[47] !== V ? (_ = /* @__PURE__ */ x(D1, { className: k, children: /* @__PURE__ */ j("div", { className: "flex flex-col gap-(--spacing-8)", children: [
    O,
    V
  ] }) }), e[46] = O, e[47] = V, e[48] = _) : _ = e[48];
  let A;
  return e[49] !== r || e[50] !== s || e[51] !== l || e[52] !== c || e[53] !== g || e[54] !== T || e[55] !== m || e[56] !== _ ? (A = /* @__PURE__ */ j(O1, { ...c, open: l, defaultOpen: r, onOpenChange: g, disabled: s, "data-disabled": m, className: h, children: [
    T,
    _
  ] }), e[49] = r, e[50] = s, e[51] = l, e[52] = c, e[53] = g, e[54] = T, e[55] = m, e[56] = _, e[57] = A) : A = e[57], A;
}
const _1 = xa({
  activeId: void 0,
  orientation: "vertical",
  onActiveChange: void 0,
  startScrollLock: void 0,
  scrollRef: void 0
}), Mp = ye([
  // Layout
  "relative",
  "inline-flex",
  "items-center",
  "gap-(--spacing-4)",
  "px-(--spacing-6)",
  "rounded-(--radius-sm)",
  // Typography
  "font-(family-name:--font-family-label)",
  "text-(length:--font-size-label-large)",
  "leading-(--font-line-height-16)",
  "tracking-(--font-letter-spacing-default)",
  "whitespace-nowrap",
  "select-none",
  "outline-none",
  "cursor-pointer",
  // Transitions
  "transition-colors",
  "duration-200",
  "ease-in-out",
  // Default text color
  "text-informative",
  // Hover
  "hover:bg-surface-hover",
  // Pressed
  "active:bg-surface-pressed",
  // Focus ring
  "focus-visible:ring-2",
  "focus-visible:ring-button-focus-ring"
], {
  variants: {
    orientation: {
      // Vertical: fixed 26px height, no extra vertical padding
      vertical: ["h-[26px]"],
      // Horizontal: fixed 26px height, no extra vertical padding
      horizontal: ["h-[26px]"]
    },
    selected: {
      true: [],
      false: []
    },
    disabled: {
      true: ["opacity-50", "pointer-events-none", "cursor-default"]
    }
  },
  compoundVariants: [{
    orientation: "horizontal",
    selected: !0,
    className: "font-semibold"
  }]
}), O3 = ["flex", "items-center", "gap-(--spacing-16)", "h-[26px]", "w-full"].join(" "), Tp = ye(["shrink-0", "transition-colors", "duration-200", "ease-in-out"], {
  variants: {
    orientation: {
      vertical: ["shrink-0", "w-(--spacing-2)", "h-(--spacing-24)", "rounded-tr-(--radius-sm)", "rounded-br-(--radius-sm)"],
      horizontal: ["absolute", "bottom-0", "left-[14px]", "right-[14px]", "h-(--spacing-2)", "rounded-tl-(--radius-sm)", "rounded-tr-(--radius-sm)"]
    },
    selected: {
      true: "bg-informative",
      false: "bg-surface-container-highest"
    }
  }
});
function lN(t) {
  const e = J.c(53), {
    targetId: n,
    icon: o,
    disabled: r,
    children: s
  } = t, i = r === void 0 ? !1 : r, {
    activeId: a,
    orientation: l,
    onActiveChange: c,
    startScrollLock: u,
    scrollRef: d
  } = Jg(_1), f = a === n, p = !i && f;
  let g;
  e[0] !== i || e[1] !== c || e[2] !== d || e[3] !== u || e[4] !== n ? (g = function(N) {
    if (i) {
      N.preventDefault();
      return;
    }
    if (N.button !== 0 || N.metaKey || N.ctrlKey || N.shiftKey || N.altKey)
      return;
    N.preventDefault();
    const I = document.getElementById(n);
    if (I) {
      const M = window.matchMedia("(prefers-reduced-motion: reduce)").matches, T = M ? "instant" : "smooth", k = d?.current;
      M || u?.(), k ? k.scrollTo({
        top: I.offsetTop - k.offsetTop,
        behavior: T
      }) : I.scrollIntoView({
        behavior: T
      });
    }
    window.history.pushState(null, "", `#${n}`), c?.(n);
  }, e[0] = i, e[1] = c, e[2] = d, e[3] = u, e[4] = n, e[5] = g) : g = e[5];
  const m = g;
  if (l === "vertical") {
    const P = p || i && f;
    let N;
    e[6] !== l || e[7] !== P ? (N = Tp({
      orientation: l,
      selected: P
    }), e[6] = l, e[7] = P, e[8] = N) : N = e[8];
    const I = i && f ? "opacity-50" : "";
    let M;
    e[9] !== N || e[10] !== I ? (M = [N, I].filter(Boolean), e[9] = N, e[10] = I, e[11] = M) : M = e[11];
    const T = M.join(" ");
    let k;
    e[12] !== T ? (k = /* @__PURE__ */ x("span", { "aria-hidden": !0, className: T }), e[12] = T, e[13] = k) : k = e[13];
    const D = `#${n}`, O = p ? "true" : void 0, V = i ? "true" : void 0, _ = i ? -1 : void 0;
    let A;
    e[14] !== i || e[15] !== p || e[16] !== l ? (A = Mp({
      selected: p,
      disabled: i,
      orientation: l
    }), e[14] = i, e[15] = p, e[16] = l, e[17] = A) : A = e[17];
    let F;
    e[18] !== o ? (F = o && /* @__PURE__ */ x(Ye, { name: o, size: "xs", tone: "inherit", "aria-hidden": !0 }), e[18] = o, e[19] = F) : F = e[19];
    let H;
    e[20] !== s || e[21] !== m || e[22] !== O || e[23] !== V || e[24] !== _ || e[25] !== A || e[26] !== F || e[27] !== D ? (H = /* @__PURE__ */ j("a", { href: D, onClick: m, "aria-current": O, "aria-disabled": V, tabIndex: _, className: A, children: [
      F,
      s
    ] }), e[20] = s, e[21] = m, e[22] = O, e[23] = V, e[24] = _, e[25] = A, e[26] = F, e[27] = D, e[28] = H) : H = e[28];
    let Y;
    return e[29] !== H || e[30] !== k ? (Y = /* @__PURE__ */ j("div", { className: O3, children: [
      k,
      H
    ] }), e[29] = H, e[30] = k, e[31] = Y) : Y = e[31], Y;
  }
  const h = `#${n}`, b = p ? "true" : void 0, w = i ? "true" : void 0, y = i ? -1 : void 0;
  let C;
  e[32] !== i || e[33] !== p || e[34] !== l ? (C = Mp({
    selected: p,
    disabled: i,
    orientation: l
  }), e[32] = i, e[33] = p, e[34] = l, e[35] = C) : C = e[35];
  let R;
  e[36] !== o ? (R = o && /* @__PURE__ */ x(Ye, { name: o, size: "xs", tone: "inherit", "aria-hidden": !0 }), e[36] = o, e[37] = R) : R = e[37];
  let S;
  e[38] !== i || e[39] !== f || e[40] !== p || e[41] !== l ? (S = (p || i && f) && /* @__PURE__ */ x("span", { "aria-hidden": !0, className: [Tp({
    orientation: l,
    selected: !0
  }), i && f ? "opacity-50" : ""].filter(Boolean).join(" ") }), e[38] = i, e[39] = f, e[40] = p, e[41] = l, e[42] = S) : S = e[42];
  let E;
  return e[43] !== s || e[44] !== m || e[45] !== h || e[46] !== b || e[47] !== w || e[48] !== y || e[49] !== C || e[50] !== R || e[51] !== S ? (E = /* @__PURE__ */ j("a", { href: h, onClick: m, "aria-current": b, "aria-disabled": w, tabIndex: y, className: C, children: [
    R,
    s,
    S
  ] }), e[43] = s, e[44] = m, e[45] = h, e[46] = b, e[47] = w, e[48] = y, e[49] = C, e[50] = R, e[51] = S, e[52] = E) : E = e[52], E;
}
function cN(t) {
  const e = J.c(12), {
    orientation: n,
    activeId: o,
    onActiveChange: r,
    startScrollLock: s,
    scrollRef: i,
    children: a
  } = t, l = n === void 0 ? "vertical" : n;
  let c;
  e[0] !== o || e[1] !== r || e[2] !== l || e[3] !== i || e[4] !== s ? (c = {
    activeId: o,
    orientation: l,
    onActiveChange: r,
    startScrollLock: s,
    scrollRef: i
  }, e[0] = o, e[1] = r, e[2] = l, e[3] = i, e[4] = s, e[5] = c) : c = e[5];
  const u = l === "vertical" ? "flex flex-col items-start gap-(--spacing-8)" : "flex flex-row flex-wrap gap-(--spacing-8)";
  let d;
  e[6] !== a || e[7] !== u ? (d = /* @__PURE__ */ x("nav", { "aria-label": "On this page", className: u, children: a }), e[6] = a, e[7] = u, e[8] = d) : d = e[8];
  let f;
  return e[9] !== c || e[10] !== d ? (f = /* @__PURE__ */ x(_1, { value: c, children: d }), e[9] = c, e[10] = d, e[11] = f) : f = e[11], f;
}
const kp = 800;
function uN(t) {
  const e = kt(null), n = kt(!1), o = kt(null), r = kt(null), [s, i] = Mt(t[0]), a = t.join(","), l = kt(() => {
  });
  rr(() => {
    const u = e.current, d = a.split(",");
    function f() {
      o.current !== null && (i(o.current), o.current = null), n.current = !1, r.current !== null && (clearTimeout(r.current), r.current = null);
    }
    l.current = f;
    const p = new IntersectionObserver((m) => {
      for (const h of m)
        h.isIntersecting && (n.current ? (o.current = h.target.id, r.current !== null && clearTimeout(r.current), r.current = setTimeout(f, kp)) : i(h.target.id));
    }, {
      root: u,
      rootMargin: "0px 0px -80% 0px",
      threshold: 0
    });
    for (const m of d) {
      const h = document.getElementById(m);
      h && p.observe(h);
    }
    const g = u ?? document;
    return g.addEventListener("scrollend", f), () => {
      p.disconnect(), g.removeEventListener("scrollend", f), r.current !== null && clearTimeout(r.current);
    };
  }, [a]);
  const c = kt(() => {
    n.current = !0, r.current !== null && clearTimeout(r.current), r.current = setTimeout(() => l.current(), kp);
  }).current;
  return {
    scrollRef: e,
    activeId: s,
    onActiveChange: i,
    startScrollLock: c
  };
}
const Eu = /* @__PURE__ */ v.createContext(void 0);
process.env.NODE_ENV !== "production" && (Eu.displayName = "AvatarRootContext");
function V1() {
  const t = v.useContext(Eu);
  if (t === void 0)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: AvatarRootContext is missing. Avatar parts must be placed within <Avatar.Root>." : Xe(13));
  return t;
}
const Pu = {
  imageLoadingStatus: () => null
}, A1 = /* @__PURE__ */ v.forwardRef(function(e, n) {
  const {
    className: o,
    render: r,
    style: s,
    ...i
  } = e, [a, l] = v.useState("idle"), c = {
    imageLoadingStatus: a
  }, u = v.useMemo(() => ({
    imageLoadingStatus: a,
    setImageLoadingStatus: l
  }), [a, l]), d = Te("span", e, {
    state: c,
    ref: n,
    props: i,
    stateAttributesMapping: Pu
  });
  return /* @__PURE__ */ x(Eu.Provider, {
    value: u,
    children: d
  });
});
process.env.NODE_ENV !== "production" && (A1.displayName = "AvatarRoot");
function D3(t, {
  referrerPolicy: e,
  crossOrigin: n
}) {
  const [o, r] = v.useState("idle");
  return xe(() => {
    if (!t)
      return r("error"), ht;
    let s = !0;
    const i = new window.Image(), a = (l) => () => {
      s && r(l);
    };
    return r("loading"), i.onload = a("loaded"), i.onerror = a("error"), e && (i.referrerPolicy = e), i.crossOrigin = n ?? null, i.src = t, i.complete && r(i.naturalWidth > 0 ? "loaded" : "error"), () => {
      s = !1;
    };
  }, [t, n, e]), o;
}
const _3 = {
  ...Pu,
  ...Lt
}, F1 = /* @__PURE__ */ v.forwardRef(function(e, n) {
  const {
    className: o,
    render: r,
    onLoadingStatusChange: s,
    referrerPolicy: i,
    crossOrigin: a,
    style: l,
    ...c
  } = e, u = V1(), d = D3(e.src, {
    referrerPolicy: i,
    crossOrigin: a
  }), f = d === "loaded", {
    mounted: p,
    transitionStatus: g,
    setMounted: m
  } = Yn(f), h = v.useRef(null), b = ge((C) => {
    s?.(C), u.setImageLoadingStatus(C);
  });
  xe(() => {
    d !== "idle" && b(d);
  }, [d, b]);
  const w = {
    imageLoadingStatus: d,
    transitionStatus: g
  };
  Bt({
    open: f,
    ref: h,
    onComplete() {
      f || m(!1);
    }
  });
  const y = Te("img", e, {
    state: w,
    ref: [n, h],
    props: c,
    stateAttributesMapping: _3,
    enabled: p
  });
  return p ? y : null;
});
process.env.NODE_ENV !== "production" && (F1.displayName = "AvatarImage");
const L1 = /* @__PURE__ */ v.forwardRef(function(e, n) {
  const {
    className: o,
    render: r,
    delay: s,
    style: i,
    ...a
  } = e, {
    imageLoadingStatus: l
  } = V1(), [c, u] = v.useState(s === void 0), d = Vt();
  return v.useEffect(() => (s !== void 0 && d.start(s, () => u(!0)), d.clear), [d, s]), Te("span", e, {
    state: {
      imageLoadingStatus: l
    },
    ref: n,
    props: a,
    stateAttributesMapping: Pu,
    enabled: l !== "loaded" && c
  });
});
process.env.NODE_ENV !== "production" && (L1.displayName = "AvatarFallback");
const V3 = ye(["inline-flex", "shrink-0", "items-center", "justify-center", "overflow-hidden", "rounded-full", "font-(family-name:--font-family-label)", "font-(number:--font-weight-medium)", "select-none"], {
  variants: {
    size: {
      md: ["size-(--spacing-40)", "text-(length:--font-size-title-inter-medium)", "leading-(--font-line-height-24)"],
      xs: ["size-(--spacing-20)", "text-(length:--font-size-title-inter-xxsmall)", "leading-(--font-line-height-20)"]
    },
    variant: {
      internal: ["bg-surface-inverse-surface", "text-surface-inverse-on-surface"],
      external: ["bg-surface-container-highest", "text-surface-on-surface"]
    }
  }
});
function dN(t) {
  const e = J.c(29);
  let n, o, r, s, i, a;
  e[0] !== t ? ({
    initials: o,
    size: i,
    variant: a,
    src: s,
    "aria-label": n,
    ...r
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r, e[4] = s, e[5] = i, e[6] = a) : (n = e[1], o = e[2], r = e[3], s = e[4], i = e[5], a = e[6]);
  const l = i === void 0 ? "md" : i, c = l === "xs", u = !s && !c ? n : void 0, d = s && !c ? n : void 0, f = u ? "img" : void 0, p = c || void 0;
  let g;
  e[7] !== l || e[8] !== a ? (g = V3({
    size: l,
    variant: a
  }), e[7] = l, e[8] = a, e[9] = g) : g = e[9];
  let m;
  e[10] !== n || e[11] !== c || e[12] !== s ? (m = s ? /* @__PURE__ */ x(F1, { "data-slot": "avatar-image", src: s, alt: c ? "" : n ?? "", className: "h-full w-full object-cover" }) : null, e[10] = n, e[11] = c, e[12] = s, e[13] = m) : m = e[13];
  const h = d ? "img" : void 0;
  let b;
  e[14] !== o ? (b = /* @__PURE__ */ x("span", { "aria-hidden": "true", children: o }), e[14] = o, e[15] = b) : b = e[15];
  let w;
  e[16] !== d || e[17] !== h || e[18] !== b ? (w = /* @__PURE__ */ x(L1, { "data-slot": "avatar-fallback", role: h, "aria-label": d, children: b }), e[16] = d, e[17] = h, e[18] = b, e[19] = w) : w = e[19];
  let y;
  return e[20] !== r || e[21] !== u || e[22] !== f || e[23] !== p || e[24] !== g || e[25] !== m || e[26] !== w || e[27] !== a ? (y = /* @__PURE__ */ j(A1, { ...r, "data-slot": "avatar", "data-variant": a, role: f, "aria-label": u, "aria-hidden": p, className: g, children: [
    m,
    w
  ] }), e[20] = r, e[21] = u, e[22] = f, e[23] = p, e[24] = g, e[25] = m, e[26] = w, e[27] = a, e[28] = y) : y = e[28], y;
}
const A3 = ye(["inline-flex", "rounded-full"], {
  variants: {
    tone: {
      urgent: "bg-error",
      activity: "bg-primary",
      info: "bg-informative"
    },
    variant: {
      dot: "size-(--spacing-6)",
      pill: "items-center justify-center min-w-(--spacing-16) h-(--spacing-16) px-(--spacing-4) py-[3px]"
    }
  },
  defaultVariants: {
    tone: "urgent",
    variant: "dot"
  }
}), F3 = ye(["font-(family-name:--font-family-body)", "font-normal", "text-(length:--font-size-body-small)", "leading-[11px]", "text-center"], {
  variants: {
    tone: {
      urgent: "text-error-on-error",
      activity: "text-primary-on-primary",
      info: "text-text-inverse"
    }
  },
  defaultVariants: {
    tone: "urgent"
  }
});
function fN(t) {
  const e = J.c(28);
  let n, o, r, s, i, a, l;
  e[0] !== t ? ({
    tone: a,
    count: r,
    visible: l,
    "aria-hidden": n,
    "aria-label": o,
    style: i,
    ...s
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r, e[4] = s, e[5] = i, e[6] = a, e[7] = l) : (n = e[1], o = e[2], r = e[3], s = e[4], i = e[5], a = e[6], l = e[7]);
  const c = a === void 0 ? "urgent" : a, u = l === void 0 ? !0 : l, d = r === void 0;
  let f;
  e[8] !== r || e[9] !== d ? (f = d ? void 0 : String(r).slice(0, 3), e[8] = r, e[9] = d, e[10] = f) : f = e[10];
  const p = f, g = !u || !o || n === !0 || n === "true" ? !0 : void 0, m = d ? "dot" : "pill";
  let h;
  e[11] !== m || e[12] !== c ? (h = A3({
    tone: c,
    variant: m
  }), e[11] = m, e[12] = c, e[13] = h) : h = e[13];
  let b;
  e[14] !== i || e[15] !== u ? (b = u ? i : {
    ...i,
    visibility: "hidden"
  }, e[14] = i, e[15] = u, e[16] = b) : b = e[16];
  let w;
  e[17] !== p || e[18] !== d || e[19] !== c ? (w = !d && /* @__PURE__ */ x("span", { className: F3({
    tone: c
  }), children: p }), e[17] = p, e[18] = d, e[19] = c, e[20] = w) : w = e[20];
  let y;
  return e[21] !== o || e[22] !== g || e[23] !== s || e[24] !== h || e[25] !== b || e[26] !== w ? (y = /* @__PURE__ */ x("span", { ...s, role: "img", "aria-hidden": g, "aria-label": o, className: h, style: b, children: w }), e[21] = o, e[22] = g, e[23] = s, e[24] = h, e[25] = b, e[26] = w, e[27] = y) : y = e[27], y;
}
const L3 = ye(["flex", "w-full", "items-center", "justify-between", "px-(--spacing-24)", "py-(--spacing-16)", "rounded-(--radius-sm)", "relative", "after:absolute", "after:bottom-0", "after:left-0", "after:right-0", "after:h-px", "after:bg-outline-subtle"], {
  variants: {
    tone: {
      neutral: ["bg-surface-container-low", "text-surface-on-surface"],
      positive: ["bg-positive-container", "text-positive-on-container"],
      warning: ["bg-accessibility-warning-container", "text-warning-on-container"],
      negative: ["bg-negative-container", "text-negative-on-container"],
      informative: ["bg-informative-container", "text-informative-on-container"]
    }
  },
  defaultVariants: {
    tone: "neutral"
  }
});
function pN(t) {
  const e = J.c(35);
  let n, o, r, s, i, a, l;
  e[0] !== t ? ({
    icon: r,
    tone: a,
    title: l,
    description: o,
    action: n,
    onDismiss: s,
    ...i
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r, e[4] = s, e[5] = i, e[6] = a, e[7] = l) : (n = e[1], o = e[2], r = e[3], s = e[4], i = e[5], a = e[6], l = e[7]);
  const c = a === void 0 ? "neutral" : a, u = c === "negative", d = u ? "alert" : "status", f = u ? "assertive" : "polite";
  let p;
  e[8] !== c ? (p = le(L3({
    tone: c
  })), e[8] = c, e[9] = p) : p = e[9];
  let g;
  e[10] !== r ? (g = /* @__PURE__ */ x(Ye, { name: r, size: "md", tone: "inherit" }), e[10] = r, e[11] = g) : g = e[11];
  let m;
  e[12] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (m = {
    color: "inherit"
  }, e[12] = m) : m = e[12];
  let h;
  e[13] !== l ? (h = /* @__PURE__ */ x(Vr, { as: "span", size: "md", style: m, children: l }), e[13] = l, e[14] = h) : h = e[14];
  let b;
  e[15] !== o ? (b = o ? /* @__PURE__ */ x(ys, { as: "span", size: "md", style: {
    color: "inherit"
  }, children: o }) : null, e[15] = o, e[16] = b) : b = e[16];
  let w;
  e[17] !== h || e[18] !== b ? (w = /* @__PURE__ */ j("div", { className: "min-w-0 flex flex-col gap-(--spacing-8)", children: [
    h,
    b
  ] }), e[17] = h, e[18] = b, e[19] = w) : w = e[19];
  let y;
  e[20] !== g || e[21] !== w ? (y = /* @__PURE__ */ j("div", { className: "flex flex-1 items-start gap-(--spacing-8) min-w-0", children: [
    g,
    w
  ] }), e[20] = g, e[21] = w, e[22] = y) : y = e[22];
  let C;
  e[23] !== s ? (C = /* @__PURE__ */ x(Kt, { icon: "x-close", "aria-label": "Dismiss banner", variant: "ghost", size: "sm", onClick: s }), e[23] = s, e[24] = C) : C = e[24];
  let R;
  e[25] !== n || e[26] !== C ? (R = /* @__PURE__ */ j("div", { className: "flex shrink-0 items-start gap-(--spacing-8)", children: [
    n,
    C
  ] }), e[25] = n, e[26] = C, e[27] = R) : R = e[27];
  let S;
  return e[28] !== i || e[29] !== y || e[30] !== R || e[31] !== d || e[32] !== f || e[33] !== p ? (S = /* @__PURE__ */ j("div", { role: d, "aria-live": f, className: p, ...i, children: [
    y,
    R
  ] }), e[28] = i, e[29] = y, e[30] = R, e[31] = d, e[32] = f, e[33] = p, e[34] = S) : S = e[34], S;
}
function gN(t) {
  const e = J.c(2);
  let n;
  return e[0] !== t ? (n = /* @__PURE__ */ x("nav", { "aria-label": "Breadcrumb", "data-slot": "breadcrumb", ...t }), e[0] = t, e[1] = n) : n = e[1], n;
}
function mN(t) {
  const e = J.c(2);
  let n;
  return e[0] !== t ? (n = /* @__PURE__ */ x("ol", { "data-slot": "breadcrumb-list", className: "inline-flex flex-wrap items-center gap-(--spacing-8) text-(length:--font-size-body-md) leading-(--line-height-20)", ...t }), e[0] = t, e[1] = n) : n = e[1], n;
}
function hN(t) {
  const e = J.c(2);
  let n;
  return e[0] !== t ? (n = /* @__PURE__ */ x("li", { "data-slot": "breadcrumb-item", className: "inline-flex items-center", ...t }), e[0] = t, e[1] = n) : n = e[1], n;
}
function bN(t) {
  const e = J.c(10);
  let n, o, r, s;
  if (e[0] !== t) {
    const {
      render: a,
      ...l
    } = t;
    s = I1, n = "a", o = a;
    let c;
    e[5] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (c = ["text-breadcrumb-text-inactive", "font-(family-name:--font-family-body)", "font-(number:--font-weight-regular)", "no-underline", "whitespace-nowrap", "cursor-pointer", "transition-[color,text-decoration-color]", "hover:underline", "hover:[text-decoration-skip-ink:none]", "active:text-breadcrumb-text-inactive-pressed", "active:underline", "active:[text-decoration-skip-ink:none]", "active:[text-decoration-style:solid]", "outline-none", "focus-visible:[outline:var(--spacing-2)_solid_var(--color-breadcrumb-focus-ring)]", "focus-visible:outline-offset-[3px]", "rounded-(--radius-sm)"], e[5] = c) : c = e[5], r = on(l, {
      className: c.join(" ")
    }), e[0] = t, e[1] = n, e[2] = o, e[3] = r, e[4] = s;
  } else
    n = e[1], o = e[2], r = e[3], s = e[4];
  let i;
  return e[6] !== n || e[7] !== o || e[8] !== r ? (i = {
    defaultTagName: n,
    render: o,
    props: r
  }, e[6] = n, e[7] = o, e[8] = r, e[9] = i) : i = e[9], s(i);
}
function vN(t) {
  const e = J.c(2);
  let n;
  return e[0] !== t ? (n = /* @__PURE__ */ x("span", { "data-slot": "breadcrumb-page", "aria-current": "page", className: "text-breadcrumb-text-active font-family-body font-semibold whitespace-nowrap", ...t }), e[0] = t, e[1] = n) : n = e[1], n;
}
function yN(t) {
  const e = J.c(2);
  let n;
  return e[0] !== t ? (n = /* @__PURE__ */ x("li", { "data-slot": "breadcrumb-separator", "aria-hidden": "true", className: "text-breadcrumb-separator font-family-label font-medium shrink-0 select-none", ...t, children: "/" }), e[0] = t, e[1] = n) : n = e[1], n;
}
const $3 = 2, z3 = 32, H3 = 3;
function $1(t) {
  return t.clientWidth || t.getBoundingClientRect().width;
}
function B3(t) {
  return Math.max(t.scrollWidth, t.getBoundingClientRect().width);
}
function W3(t) {
  const e = z3 * $3;
  return Math.max(0, t - e);
}
function U3(t, e) {
  const n = $1(t), o = Array.from(e.children).filter((s) => s instanceof HTMLElement);
  if (n <= 0 || o.length === 0) return o.length;
  let r = 0;
  for (const s of o) {
    const i = s.offsetWidth || s.getBoundingClientRect().width;
    if (i <= 0) return o.length;
    if (s.offsetLeft + i > n) break;
    r += 1;
  }
  return Math.max(1, r);
}
function xN({
  children: t,
  ...e
}) {
  const n = v.useRef(null), o = v.useRef(null), r = v.useRef(null), s = v.useRef(() => {
  }), [i, a] = v.useState(!1), [l, c] = v.useState(0), [u, d] = v.useState(Number.POSITIVE_INFINITY), f = v.Children.toArray(t), p = f.length, g = p > 0 ? l % p : 0, m = f.map((y, C) => ({
    child: y,
    key: C
  })), h = i ? [...m.slice(g), ...m.slice(0, g)] : m;
  s.current = () => {
    const y = n.current, C = o.current, R = r.current;
    if (!y || !C || !R) return;
    const S = $1(y), E = B3(R), P = W3(S), N = E > S, I = p >= H3 && E > P, M = p > 1 && S > 0 && (N || I);
    a(M), d(M ? U3(C, R) : p), M || c(0);
  }, v.useLayoutEffect(() => {
    s.current();
  }), v.useLayoutEffect(() => {
    const y = n.current, C = o.current, R = r.current;
    if (!y || !C || !R || typeof ResizeObserver > "u")
      return;
    const S = new ResizeObserver(() => {
      s.current();
    });
    return S.observe(y), S.observe(C), S.observe(R), () => S.disconnect();
  }, []);
  const b = () => {
    p !== 0 && c((y) => (y + 1) % p);
  };
  return /* @__PURE__ */ j("div", { ...e, ref: n, "data-slot": "carousel", className: i ? "flex w-full items-center" : "flex w-full items-center gap-(--spacing-10)", children: [
    i && /* @__PURE__ */ x(Kt, { variant: "ghost", size: "sm", icon: "chevron-left", "aria-label": "Previous Images", onClick: () => {
      p !== 0 && c((y) => (y - 1 + p) % p);
    } }),
    /* @__PURE__ */ x("div", { ref: o, "data-slot": "carousel-viewport", className: i ? "min-w-0 flex-1 overflow-hidden" : "min-w-0 max-w-full overflow-hidden", children: /* @__PURE__ */ x("div", { ref: r, "data-slot": "carousel-track", className: "relative flex w-max items-center gap-(--spacing-10) p-(--spacing-4)", children: h.map(({
      child: y,
      key: C
    }, R) => {
      const S = i && R >= u;
      return /* @__PURE__ */ x("div", { "data-slot": "carousel-item", className: "shrink-0", inert: S ? !0 : void 0, "aria-hidden": S || void 0, children: y }, C);
    }) }) }),
    i && /* @__PURE__ */ x(Kt, { variant: "ghost", size: "sm", icon: "chevron-right", "aria-label": "Next Images", onClick: b })
  ] });
}
let Op = /* @__PURE__ */ (function(t) {
  return t.checked = "data-checked", t.unchecked = "data-unchecked", t.indeterminate = "data-indeterminate", t.disabled = "data-disabled", t.readonly = "data-readonly", t.required = "data-required", t.valid = "data-valid", t.invalid = "data-invalid", t.touched = "data-touched", t.dirty = "data-dirty", t.filled = "data-filled", t.focused = "data-focused", t;
})({}), Dp = /* @__PURE__ */ (function(t) {
  return t.disabled = "data-disabled", t.valid = "data-valid", t.invalid = "data-invalid", t.touched = "data-touched", t.dirty = "data-dirty", t.filled = "data-filled", t.focused = "data-focused", t;
})({});
const za = {
  badInput: !1,
  customError: !1,
  patternMismatch: !1,
  rangeOverflow: !1,
  rangeUnderflow: !1,
  stepMismatch: !1,
  tooLong: !1,
  tooShort: !1,
  typeMismatch: !1,
  valid: null,
  valueMissing: !1
}, Sr = {
  valid: null,
  touched: !1,
  dirty: !1,
  filled: !1,
  focused: !1
}, Y3 = {
  disabled: !1,
  ...Sr
}, jn = {
  valid(t) {
    return t === null ? null : t ? {
      [Dp.valid]: ""
    } : {
      [Dp.invalid]: ""
    };
  }
};
function G3(t) {
  return v.useMemo(() => ({
    checked(e) {
      return t.indeterminate ? {} : e ? {
        [Op.checked]: ""
      } : {
        [Op.unchecked]: ""
      };
    },
    ...jn
  }), [t.indeterminate]);
}
const Nu = /* @__PURE__ */ v.createContext({
  invalid: void 0,
  name: void 0,
  validityData: {
    state: za,
    errors: [],
    error: "",
    value: "",
    initialValue: null
  },
  setValidityData: ht,
  disabled: void 0,
  touched: Sr.touched,
  setTouched: ht,
  dirty: Sr.dirty,
  setDirty: ht,
  filled: Sr.filled,
  setFilled: ht,
  focused: Sr.focused,
  setFocused: ht,
  validate: () => null,
  validationMode: "onSubmit",
  validationDebounceTime: 0,
  shouldValidateOnChange: () => !1,
  state: Y3,
  markedDirtyRef: {
    current: !1
  },
  registerFieldControl: ht,
  validation: {
    getValidationProps: (t = yt) => t,
    getInputValidationProps: (t = yt) => t,
    inputRef: {
      current: null
    },
    commit: async () => {
    }
  }
});
process.env.NODE_ENV !== "production" && (Nu.displayName = "FieldRootContext");
function Xt(t = !0) {
  const e = v.useContext(Nu);
  if (e.setValidityData === ht && !t)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: FieldRootContext is missing. Field parts must be placed within <Field.Root>." : Xe(28));
  return e;
}
function Ur(t, e) {
  const {
    enabled: n = !0,
    getValue: o,
    id: r,
    value: s
  } = e, {
    registerFieldControl: i
  } = Xt(), a = v.useRef(null);
  a.current || (a.current = /* @__PURE__ */ Symbol()), xe(() => {
    const l = a.current;
    if (!(!l || !n))
      return i(l, {
        controlRef: t,
        getValue: o,
        id: r,
        value: s
      }), () => {
        i(l, void 0);
      };
  }, [t, n, o, r, i, s]);
}
const z1 = /* @__PURE__ */ v.createContext({
  disabled: !1
});
process.env.NODE_ENV !== "production" && (z1.displayName = "FieldItemContext");
function H1() {
  return v.useContext(z1);
}
const B1 = /* @__PURE__ */ v.createContext({
  formRef: {
    current: {
      fields: /* @__PURE__ */ new Map()
    }
  },
  errors: {},
  clearErrors: ht,
  validationMode: "onSubmit",
  submitAttemptedRef: {
    current: !1
  }
});
process.env.NODE_ENV !== "production" && (B1.displayName = "FormContext");
function Co() {
  return v.useContext(B1);
}
const Iu = /* @__PURE__ */ v.createContext({
  controlId: void 0,
  registerControlId: ht,
  labelId: void 0,
  setLabelId: ht,
  messageIds: [],
  setMessageIds: ht,
  getDescriptionProps: (t) => t
});
process.env.NODE_ENV !== "production" && (Iu.displayName = "LabelableContext");
function un() {
  return v.useContext(Iu);
}
function Mu(t, e, n, o = !0, r) {
  const [s, i] = v.useState(), a = St(r ? `${r}-label` : void 0), l = t ?? e ?? s;
  return xe(() => {
    const c = t || e || !o ? void 0 : j3(n.current, a);
    s !== c && i(c);
  }), l;
}
function j3(t, e) {
  const n = K3(t);
  if (n)
    return !n.id && e && (n.id = e), n.id || void 0;
}
function K3(t) {
  if (!t)
    return;
  const e = t.parentElement;
  if (e && e.tagName === "LABEL")
    return e;
  const n = t.id;
  if (n) {
    const r = t.nextElementSibling;
    if (r && r.htmlFor === n)
      return r;
  }
  const o = t.labels;
  return o && o[0];
}
const W1 = /* @__PURE__ */ v.createContext(void 0);
process.env.NODE_ENV !== "production" && (W1.displayName = "CheckboxGroupContext");
function q3(t = !0) {
  const e = v.useContext(W1);
  if (e === void 0 && !t)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: CheckboxGroupContext is missing. CheckboxGroup parts must be placed within <CheckboxGroup>." : Xe(3));
  return e;
}
const U1 = /* @__PURE__ */ v.createContext(void 0);
process.env.NODE_ENV !== "production" && (U1.displayName = "CheckboxRootContext");
const X3 = "data-parent", Y1 = /* @__PURE__ */ v.forwardRef(function(e, n) {
  const {
    checked: o,
    className: r,
    defaultChecked: s = !1,
    "aria-labelledby": i,
    disabled: a = !1,
    form: l,
    id: c,
    indeterminate: u = !1,
    inputRef: d,
    name: f,
    onCheckedChange: p,
    parent: g = !1,
    readOnly: m = !1,
    render: h,
    required: b = !1,
    uncheckedValue: w,
    value: y,
    nativeButton: C = !1,
    style: R,
    ...S
  } = e, {
    clearErrors: E
  } = Co(), {
    disabled: P,
    name: N,
    setDirty: I,
    setFilled: M,
    setFocused: T,
    setTouched: k,
    state: D,
    validationMode: O,
    validityData: V,
    shouldValidateOnChange: _,
    validation: A
  } = Xt(), F = H1(), {
    labelId: H,
    controlId: Y,
    registerControlId: B,
    getDescriptionProps: U
  } = un(), q = q3(), W = q?.parent, K = W && q.allValues, te = P || F.disabled || q?.disabled || a, z = N ?? f, Q = y ?? z, ee = St(), ae = St();
  let X = Y;
  K ? X = g ? ae : `${W.id}-${Q}` : c && (X = c);
  let se = {};
  K && (g ? se = q.parent.getParentProps() : Q && (se = q.parent.getChildProps(Q)));
  const ue = ge(p), {
    checked: re = o,
    indeterminate: ne = u,
    onCheckedChange: oe,
    ...me
  } = se, de = q?.value, he = q?.setValue, $ = q?.defaultValue, Z = v.useRef(null), L = Pt(() => /* @__PURE__ */ Symbol("checkbox-control")), G = v.useRef(!1), {
    getButtonProps: ie,
    buttonRef: pe
  } = Ft({
    disabled: te,
    native: C
  }), be = q?.validation ?? A, [Re, _e] = sn({
    controlled: Q && de && !g ? de.includes(Q) : re,
    default: Q && $ && !g ? $.includes(Q) : s,
    name: "Checkbox",
    state: "checked"
  });
  xe(() => {
    B !== ht && (G.current = !0, B(L.current, X));
  }, [X, q, B, g, L]), v.useEffect(() => {
    const Ce = L.current;
    return () => {
      !G.current || B === ht || (G.current = !1, B(Ce, void 0));
    };
  }, [B, L]), Ur(Z, {
    enabled: !q,
    id: ee,
    value: Re
  });
  const ke = v.useRef(null), Se = ln(d, ke, be.inputRef), Ie = Mu(i, H, ke, !C, X ?? void 0);
  xe(() => {
    ke.current && (ke.current.indeterminate = ne, Re && M(!0));
  }, [Re, ne, M]), po(Re, () => {
    q && !g || (E(z), M(Re), I(Re !== V.initialValue), _() ? be.commit(Re) : be.commit(Re, !0));
  });
  const Le = on(
    {
      checked: Re,
      disabled: te,
      form: l,
      // parent checkboxes unset `name` to be excluded from form submission
      name: g ? void 0 : z,
      // Set `id` to stop Chrome warning about an unassociated input.
      // When using a native button, the `id` is applied to the button instead.
      id: C ? void 0 : X ?? void 0,
      required: b,
      ref: Se,
      style: z ? Lr : $o,
      tabIndex: -1,
      type: "checkbox",
      "aria-hidden": !0,
      onChange(Ce) {
        if (Ce.nativeEvent.defaultPrevented)
          return;
        if (m) {
          Ce.preventDefault();
          return;
        }
        const Oe = Ce.currentTarget.checked, Ne = Pe(Et, Ce.nativeEvent);
        if (oe?.(Oe, Ne), ue(Oe, Ne), !Ne.isCanceled && (_e(Oe), Q && de && he && !g && !K)) {
          const Be = Oe ? [...de, Q] : de.filter((ze) => ze !== Q);
          he(Be, Ne);
        }
      },
      onFocus() {
        Z.current?.focus();
      }
    },
    // React <19 sets an empty value if `undefined` is passed explicitly
    // To avoid this, we only set the value if it's defined
    y !== void 0 ? {
      value: (q ? Re && y : y) || ""
    } : yt,
    U,
    q ? be.getValidationProps : be.getInputValidationProps
  ), Ze = K ? !!re : Re, tt = K && ne || u;
  v.useEffect(() => {
    if (!W || !Q)
      return;
    const Ce = W.disabledStatesRef.current;
    return Ce.set(Q, te), () => {
      Ce.delete(Q);
    };
  }, [W, te, Q]);
  const ut = v.useMemo(() => ({
    ...D,
    checked: Ze,
    disabled: te,
    readOnly: m,
    required: b,
    indeterminate: tt
  }), [D, Ze, te, m, b, tt]), at = G3(ut), $e = Te("span", e, {
    state: ut,
    ref: [pe, Z, n, q?.registerControlRef],
    props: [{
      id: C ? X ?? void 0 : ee,
      role: "checkbox",
      "aria-checked": ne ? "mixed" : Re,
      "aria-readonly": m || void 0,
      "aria-required": b || void 0,
      "aria-labelledby": Ie,
      [X3]: g ? "" : void 0,
      onFocus() {
        T(!0);
      },
      onBlur() {
        const Ce = ke.current;
        Ce && (k(!0), T(!1), O === "onBlur" && be.commit(q ? de : Ce.checked));
      },
      onClick(Ce) {
        m || te || (Ce.preventDefault(), ke.current?.dispatchEvent(new PointerEvent("click", {
          bubbles: !0,
          shiftKey: Ce.shiftKey,
          ctrlKey: Ce.ctrlKey,
          altKey: Ce.altKey,
          metaKey: Ce.metaKey
        })));
      }
    }, U, be.getValidationProps, S, me, ie],
    stateAttributesMapping: at
  });
  return /* @__PURE__ */ j(U1.Provider, {
    value: ut,
    children: [$e, !Re && !q && z && !g && w !== void 0 && /* @__PURE__ */ x("input", {
      type: "hidden",
      form: l,
      name: z,
      value: w
    }), /* @__PURE__ */ x("input", {
      ...Le,
      suppressHydrationWarning: !0
    })]
  });
});
process.env.NODE_ENV !== "production" && (Y1.displayName = "CheckboxRoot");
const fa = {
  sm: "rounded-[2px]",
  md: "rounded-(--radius-sm)"
}, _p = {
  sm: ["w-[calc(var(--icon-sm)*0.8)]", "h-[calc(var(--icon-sm)*0.8)]"],
  // Snap md to whole pixels to avoid SVG crossfade shimmer from 19.2px subpixel rasterization.
  md: ["w-[20px]", "h-[20px]"]
}, Z3 = ye([
  "relative",
  "shrink-0",
  "inline-flex",
  "items-center",
  "justify-center",
  "group/checkbox",
  // disabled
  "data-[disabled]:pointer-events-none",
  // focus
  "focus-visible:outline-none",
  "focus-visible:ring-[1px]",
  "focus-visible:ring-checkbox-focus-ring",
  "cursor-[inherit]",
  // touch target — before:inset per size to maintain WCAG 44×44px minimum
  "[@media(pointer:coarse)]:before:content-['']",
  "[@media(pointer:coarse)]:before:absolute"
], {
  variants: {
    size: {
      sm: ["w-(--icon-sm)", "h-(--icon-sm)", fa.sm, "[@media(pointer:coarse)]:before:inset-[-12px]"],
      md: ["w-(--icon-md)", "h-(--icon-md)", fa.md, "[@media(pointer:coarse)]:before:inset-[-10px]"]
    }
  },
  defaultVariants: {
    size: "sm"
  }
}), Q3 = ye(["absolute", "left-1/2", "top-1/2", "z-10", "inline-flex", "-translate-x-1/2", "-translate-y-1/2", "items-center", "justify-center", "overflow-hidden", "transition-[background-color]", "duration-200", "ease-in-out", "motion-reduce:transition-none", "group-data-[checked]/checkbox:bg-checkbox-filled-default-background", "group-data-[indeterminate]/checkbox:bg-checkbox-filled-default-background", "group-[[data-checked]:not([data-error]):not([data-disabled]):hover]/checkbox:bg-checkbox-filled-hover-background", "group-[[data-indeterminate]:not([data-error]):not([data-disabled]):hover]/checkbox:bg-checkbox-filled-hover-background", "group-[[data-checked]:not([data-error]):not([data-disabled]):active]/checkbox:bg-checkbox-filled-pressed-background", "group-[[data-indeterminate]:not([data-error]):not([data-disabled]):active]/checkbox:bg-checkbox-filled-pressed-background", "group-data-[error]/checkbox:bg-error", "group-data-[disabled]/checkbox:bg-checkbox-filled-disabled-background"], {
  variants: {
    size: {
      sm: [fa.sm, ..._p.sm],
      md: [fa.md, ..._p.md]
    }
  },
  defaultVariants: {
    size: "sm"
  }
}), J3 = ye(["absolute", "inset-0", "rounded-(--radius-sm)", "opacity-0", "group-[:not([data-checked]):not([data-indeterminate]):not([data-error]):not([data-disabled]):hover]/checkbox:opacity-100", "group-[:not([data-checked]):not([data-indeterminate]):not([data-error]):not([data-disabled]):hover]/checkbox:bg-checkbox-outline-hover-background", "transition-[background-color,opacity]", "duration-200", "ease-in-out", "motion-reduce:transition-none"], {
  variants: {
    size: {
      sm: ["w-(--icon-sm)", "h-(--icon-sm)"],
      md: ["w-(--icon-md)", "h-(--icon-md)"]
    }
  },
  defaultVariants: {
    size: "sm"
  }
}), e4 = ye(["absolute", "inset-0", "rounded-(--radius-sm)", "opacity-0", "group-[:not([data-checked]):not([data-indeterminate]):not([data-error]):not([data-disabled]):active]/checkbox:opacity-100", "group-[:not([data-checked]):not([data-indeterminate]):not([data-error]):not([data-disabled]):active]/checkbox:bg-checkbox-outline-pressed-background", "transition-[background-color,opacity]", "duration-200", "ease-in-out", "motion-reduce:transition-none"], {
  variants: {
    size: {
      sm: ["w-(--icon-sm)", "h-(--icon-sm)"],
      md: ["w-(--icon-md)", "h-(--icon-md)"]
    }
  },
  defaultVariants: {
    size: "sm"
  }
}), t4 = ye(["absolute", "inset-0", "h-full", "w-full", "text-checkbox-outline-default-border", "group-[:not([data-error]):not([data-disabled]):hover]/checkbox:text-checkbox-outline-hover-border", "group-[:not([data-error]):not([data-disabled]):active]/checkbox:text-checkbox-outline-pressed-border", "group-data-[error]/checkbox:text-error", "group-data-[disabled]/checkbox:text-checkbox-filled-disabled-background", "group-data-[checked]/checkbox:opacity-0", "group-data-[indeterminate]/checkbox:opacity-0", "transition-[color,opacity]", "duration-200", "ease-in-out", "motion-reduce:transition-none"]), n4 = ye(["absolute", "inset-0", "h-full", "w-full", "opacity-0", "text-primary-on-primary", "group-data-[checked]/checkbox:opacity-100", "group-data-[error]/checkbox:text-surface-container-lowest", "group-data-[disabled]/checkbox:text-surface-container-lowest", "transition-[color,opacity]", "duration-200", "ease-in-out", "motion-reduce:transition-none"]), o4 = ye(["absolute", "inset-0", "h-full", "w-full", "opacity-0", "text-primary-on-primary", "group-data-[indeterminate]/checkbox:opacity-100", "group-data-[error]/checkbox:text-surface-container-lowest", "group-data-[disabled]/checkbox:text-surface-container-lowest", "transition-[color,opacity]", "duration-200", "ease-in-out", "motion-reduce:transition-none"]);
function r4(t) {
  const e = J.c(3), {
    className: n
  } = t;
  let o;
  e[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (o = /* @__PURE__ */ x("path", { d: "M13.7143 1.14286C14.3464 1.14286 14.8571 1.65357 14.8571 2.28571V13.7143C14.8571 14.3464 14.3464 14.8571 13.7143 14.8571H2.28571C1.65357 14.8571 1.14286 14.3464 1.14286 13.7143V2.28571C1.14286 1.65357 1.65357 1.14286 2.28571 1.14286H13.7143ZM2.28571 0C1.025 0 0 1.025 0 2.28571V13.7143C0 14.975 1.025 16 2.28571 16H13.7143C14.975 16 16 14.975 16 13.7143V2.28571C16 1.025 14.975 0 13.7143 0H2.28571Z", fill: "currentColor", fillRule: "evenodd", clipRule: "evenodd" }), e[0] = o) : o = e[0];
  let r;
  return e[1] !== n ? (r = /* @__PURE__ */ x("svg", { viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", "aria-hidden": "true", focusable: "false", className: n, children: o }), e[1] = n, e[2] = r) : r = e[2], r;
}
function s4(t) {
  const e = J.c(3), {
    className: n
  } = t;
  let o;
  e[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (o = /* @__PURE__ */ x("path", { d: "M12.2143 4.06071C11.8321 3.78214 11.2964 3.86786 11.0179 4.25L6.75357 10.1143L4.89286 8.25357C4.55714 7.91786 4.01429 7.91786 3.68214 8.25357C3.35 8.58929 3.34643 9.13214 3.68214 9.46429L6.25357 12.0357C6.43214 12.2143 6.67857 12.3036 6.925 12.2857C7.17143 12.2679 7.40357 12.1393 7.55 11.9357L12.4036 5.25714C12.6821 4.875 12.5964 4.33929 12.2143 4.06071Z", fill: "currentColor" }), e[0] = o) : o = e[0];
  let r;
  return e[1] !== n ? (r = /* @__PURE__ */ x("svg", { viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", "aria-hidden": "true", focusable: "false", className: n, children: o }), e[1] = n, e[2] = r) : r = e[2], r;
}
function i4(t) {
  const e = J.c(3), {
    className: n
  } = t;
  let o;
  e[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (o = /* @__PURE__ */ x("path", { d: "M3 7V9H13V7H3Z", fill: "currentColor" }), e[0] = o) : o = e[0];
  let r;
  return e[1] !== n ? (r = /* @__PURE__ */ x("svg", { viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", "aria-hidden": "true", focusable: "false", className: n, children: o }), e[1] = n, e[2] = r) : r = e[2], r;
}
const Vp = ye(["text-text-default", "font-(family-name:--font-family-label)", "font-(number:--font-weight-medium)", "text-(length:--font-size-label-large)", "leading-(--font-line-height-20)", "tracking-(--font-letter-spacing-default)"]), a4 = ye(["text-text-subtext", "font-(family-name:--font-family-body)", "font-(number:--font-weight-regular)", "text-(length:--font-size-body-medium)", "leading-(--font-line-height-20)", "tracking-(--font-letter-spacing-default)"]), l4 = ye([], {
  variants: {
    size: {
      sm: [],
      md: []
    },
    labelLeft: {
      true: [],
      false: []
    }
  },
  compoundVariants: [{
    labelLeft: !1,
    size: "sm",
    className: "pl-[calc(var(--icon-sm)+var(--spacing-8))]"
  }, {
    labelLeft: !1,
    size: "md",
    className: "pl-[calc(var(--icon-md)+var(--spacing-8))]"
  }],
  defaultVariants: {
    size: "sm",
    labelLeft: !1
  }
});
function c4(t) {
  const e = J.c(69);
  let n, o, r, s, i, a, l, c;
  e[0] !== t ? ({
    error: r,
    label: i,
    description: n,
    labelLeft: a,
    size: c,
    indeterminate: s,
    disabled: o,
    ...l
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r, e[4] = s, e[5] = i, e[6] = a, e[7] = l, e[8] = c) : (n = e[1], o = e[2], r = e[3], s = e[4], i = e[5], a = e[6], l = e[7], c = e[8]);
  const u = bn();
  let d;
  e[9] !== n || e[10] !== u || e[11] !== l ? (d = [l["aria-describedby"], n ? `${u}-description` : void 0].filter(Boolean).join(" ") || void 0, e[9] = n, e[10] = u, e[11] = l, e[12] = d) : d = e[12];
  const f = d, p = o ? "cursor-not-allowed" : "cursor-pointer";
  let g;
  e[13] !== p ? (g = le("inline-flex flex-col gap-(--spacing-4)", p), e[13] = p, e[14] = g) : g = e[14];
  let m;
  e[15] !== o || e[16] !== u || e[17] !== i || e[18] !== a ? (m = a && i && /* @__PURE__ */ x("span", { id: `${u}-label`, className: le(Vp(), o && "opacity-50"), children: i }), e[15] = o, e[16] = u, e[17] = i, e[18] = a, e[19] = m) : m = e[19];
  const h = i ? void 0 : l["aria-label"], b = i ? `${u}-label` : void 0, w = r || void 0, y = r ? "" : void 0;
  let C;
  e[20] !== c ? (C = le(Z3({
    size: c
  })), e[20] = c, e[21] = C) : C = e[21];
  let R;
  e[22] !== c ? (R = le(J3({
    size: c
  })), e[22] = c, e[23] = R) : R = e[23];
  let S;
  e[24] !== R ? (S = /* @__PURE__ */ x("span", { className: R }), e[24] = R, e[25] = S) : S = e[25];
  let E;
  e[26] !== c ? (E = le(e4({
    size: c
  })), e[26] = c, e[27] = E) : E = e[27];
  let P;
  e[28] !== E ? (P = /* @__PURE__ */ x("span", { className: E }), e[28] = E, e[29] = P) : P = e[29];
  let N;
  e[30] !== c ? (N = le(Q3({
    size: c
  })), e[30] = c, e[31] = N) : N = e[31];
  let I;
  e[32] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (I = /* @__PURE__ */ x(r4, { className: le(t4()) }), e[32] = I) : I = e[32];
  let M;
  e[33] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (M = /* @__PURE__ */ x(s4, { className: le(n4()) }), e[33] = M) : M = e[33];
  let T;
  e[34] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (T = /* @__PURE__ */ x(i4, { className: le(o4()) }), e[34] = T) : T = e[34];
  let k;
  e[35] !== N ? (k = /* @__PURE__ */ j("span", { className: N, children: [
    I,
    M,
    T
  ] }), e[35] = N, e[36] = k) : k = e[36];
  let D;
  e[37] !== f || e[38] !== o || e[39] !== s || e[40] !== l || e[41] !== S || e[42] !== P || e[43] !== k || e[44] !== h || e[45] !== b || e[46] !== w || e[47] !== y || e[48] !== C ? (D = /* @__PURE__ */ j(Y1, { ...l, indeterminate: s, disabled: o, "aria-label": h, "aria-labelledby": b, "aria-describedby": f, "aria-invalid": w, "data-error": y, className: C, children: [
    S,
    P,
    k
  ] }), e[37] = f, e[38] = o, e[39] = s, e[40] = l, e[41] = S, e[42] = P, e[43] = k, e[44] = h, e[45] = b, e[46] = w, e[47] = y, e[48] = C, e[49] = D) : D = e[49];
  let O;
  e[50] !== o || e[51] !== u || e[52] !== i || e[53] !== a ? (O = !a && i && /* @__PURE__ */ x("span", { id: `${u}-label`, className: le(Vp(), o && "opacity-50"), children: i }), e[50] = o, e[51] = u, e[52] = i, e[53] = a, e[54] = O) : O = e[54];
  let V;
  e[55] !== D || e[56] !== O || e[57] !== m ? (V = /* @__PURE__ */ j("div", { className: "inline-flex items-center gap-(--spacing-8)", children: [
    m,
    D,
    O
  ] }), e[55] = D, e[56] = O, e[57] = m, e[58] = V) : V = e[58];
  let _;
  e[59] !== n || e[60] !== o || e[61] !== u || e[62] !== a || e[63] !== c ? (_ = n && /* @__PURE__ */ x("span", { id: `${u}-description`, className: le(a4(), o && "opacity-50", l4({
    size: c,
    labelLeft: a
  })), children: n }), e[59] = n, e[60] = o, e[61] = u, e[62] = a, e[63] = c, e[64] = _) : _ = e[64];
  let A;
  return e[65] !== V || e[66] !== _ || e[67] !== g ? (A = /* @__PURE__ */ j("label", { className: g, children: [
    V,
    _
  ] }), e[65] = V, e[66] = _, e[67] = g, e[68] = A) : A = e[68], A;
}
const G1 = /* @__PURE__ */ v.createContext({
  legendId: void 0,
  setLegendId: () => {
  },
  disabled: void 0
});
process.env.NODE_ENV !== "production" && (G1.displayName = "FieldsetRootContext");
function j1(t = !1) {
  const e = v.useContext(G1);
  if (!e && !t)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: FieldsetRootContext is missing. Fieldset parts must be placed within <Fieldset.Root>." : Xe(86));
  return e;
}
const K1 = function(e) {
  const n = St(), o = e.controlId === void 0 ? n : e.controlId, [r, s] = v.useState(o), [i, a] = v.useState(e.labelId), [l, c] = v.useState([]), u = Pt(() => /* @__PURE__ */ new Map()), {
    messageIds: d
  } = un(), f = ge((m, h) => {
    const b = u.current;
    if (h === void 0) {
      b.delete(m);
      return;
    }
    b.set(m, h), s((w) => {
      if (b.size === 0)
        return;
      let y;
      for (const C of b.values()) {
        if (w !== void 0 && C === w)
          return w;
        y === void 0 && (y = C);
      }
      return y;
    });
  }), p = v.useCallback((m) => on({
    "aria-describedby": d.concat(l).join(" ") || void 0
  }, m), [d, l]), g = v.useMemo(() => ({
    controlId: r,
    registerControlId: f,
    labelId: i,
    setLabelId: a,
    messageIds: l,
    setMessageIds: c,
    getDescriptionProps: p
  }), [r, f, i, a, l, c, p]);
  return /* @__PURE__ */ x(Iu.Provider, {
    value: g,
    children: e.children
  });
};
process.env.NODE_ENV !== "production" && (K1.displayName = "LabelableProvider");
function mr(t = {}) {
  const {
    id: e,
    implicit: n = !1,
    controlRef: o
  } = t, {
    controlId: r,
    registerControlId: s
  } = un(), i = St(e), a = n ? r : void 0, l = Pt(() => /* @__PURE__ */ Symbol("labelable-control")), c = v.useRef(!1), u = v.useRef(e != null), d = ge(() => {
    !c.current || s === ht || (c.current = !1, s(l.current, void 0));
  });
  return xe(() => {
    if (s === ht)
      return;
    let f;
    if (n) {
      const p = o?.current;
      lt(p) && p.closest("label") != null ? f = e ?? null : f = a ?? i;
    } else if (e != null)
      u.current = !0, f = e;
    else if (u.current)
      f = i;
    else {
      d();
      return;
    }
    if (f === void 0) {
      d();
      return;
    }
    c.current = !0, s(l.current, f);
  }, [e, o, a, s, n, i, l, d]), v.useEffect(() => d, [d]), r ?? i;
}
function u4(t, e) {
  const n = St(t);
  return xe(() => (e(n), () => {
    e(void 0);
  }), [n, e]), n;
}
function d4(t = {}) {
  const {
    id: e,
    fallbackControlId: n,
    native: o = !1,
    setLabelId: r,
    focusControl: s
  } = t, {
    controlId: i,
    setLabelId: a
  } = un(), l = ge((p) => {
    a(p), r?.(p);
  }), c = u4(e, l), u = i ?? n;
  function d(p) {
    if (s) {
      s(p, u);
      return;
    }
    if (!u)
      return;
    const g = Ke(p.currentTarget).getElementById(u);
    bt(g) && f4(g);
  }
  function f(p) {
    gt(p.nativeEvent)?.closest("button,input,select,textarea") || (!p.defaultPrevented && p.detail > 1 && p.preventDefault(), !o && d(p));
  }
  return o ? {
    id: c,
    htmlFor: u ?? void 0,
    onMouseDown: f
  } : {
    id: c,
    onClick: f,
    onPointerDown(p) {
      p.preventDefault();
    }
  };
}
function f4(t) {
  t.focus({
    // Available from Chrome 144+ (January 2026).
    // Safari and Firefox already support it.
    focusVisible: !0
  });
}
function pa(t, e) {
  return {
    ...t,
    state: {
      ...t.state,
      valid: !e && t.state.valid
    }
  };
}
const qi = Object.keys(za);
function p4(t) {
  if (!t || t.valid || !t.valueMissing)
    return !1;
  let e = !1;
  for (const n of qi)
    n !== "valid" && (n === "valueMissing" && (e = t[n]), t[n] && (e = !1));
  return e;
}
function g4(t) {
  const {
    formRef: e,
    clearErrors: n
  } = Co(), {
    setValidityData: o,
    validate: r,
    validityData: s,
    validationDebounceTime: i,
    invalid: a,
    markedDirtyRef: l,
    state: c,
    name: u,
    shouldValidateOnChange: d
  } = t, {
    controlId: f,
    getDescriptionProps: p
  } = un(), g = Vt(), m = v.useRef(null), h = ge(async (y, C = !1) => {
    const R = m.current;
    if (!R)
      return;
    if (C) {
      if (c.valid !== !1)
        return;
      const k = R.validity;
      if (!k.valueMissing) {
        const O = {
          value: y,
          state: {
            ...za,
            valid: !0
          },
          error: "",
          errors: [],
          initialValue: s.initialValue
        };
        if (R.setCustomValidity(""), f) {
          const V = e.current.fields.get(f);
          V && e.current.fields.set(f, {
            ...V,
            ...pa(O, !1)
            // invalid = false
          });
        }
        o(O);
        return;
      }
      const D = qi.reduce((O, V) => (O[V] = k[V], O), {});
      if (!D.valid && !p4(D))
        return;
    }
    function S(k) {
      const D = qi.reduce((V, _) => (V[_] = k.validity[_], V), {});
      let O = !1;
      for (const V of qi)
        if (V !== "valid") {
          if (V === "valueMissing" && D[V])
            O = !0;
          else if (D[V])
            return D;
        }
      return O && !l.current && (D.valid = !0, D.valueMissing = !1), D;
    }
    g.clear();
    let E = null, P = [];
    const N = S(R);
    let I;
    const M = d();
    if (R.validationMessage && !M)
      I = R.validationMessage, P = [R.validationMessage];
    else {
      const k = Array.from(e.current.fields.values()).reduce((O, V) => (V.name && (O[V.name] = V.getValue()), O), {}), D = r(y, k);
      typeof D == "object" && D !== null && "then" in D ? E = await D : E = D, E !== null ? (N.valid = !1, N.customError = !0, Array.isArray(E) ? (P = E, R.setCustomValidity(E.join(`
`))) : E && (P = [E], R.setCustomValidity(E))) : M && (R.setCustomValidity(""), N.customError = !1, R.validationMessage ? (I = R.validationMessage, P = [R.validationMessage]) : R.validity.valid && !N.valid && (N.valid = !0));
    }
    const T = {
      value: y,
      state: N,
      error: I ?? (Array.isArray(E) ? E[0] : E ?? ""),
      errors: P,
      initialValue: s.initialValue
    };
    if (f) {
      const k = e.current.fields.get(f);
      k && e.current.fields.set(f, {
        ...k,
        // Keep Form-level errors part of overall field validity for submit blocking/focus logic.
        ...pa(T, a)
      });
    }
    o(T);
  }), b = v.useCallback((y = {}) => on(p, c.valid === !1 ? {
    "aria-invalid": !0
  } : yt, y), [p, c.valid]), w = v.useCallback((y = {}) => on({
    onChange(C) {
      if (C.nativeEvent.defaultPrevented)
        return;
      if (n(u), !d()) {
        h(C.currentTarget.value, !0);
        return;
      }
      const R = C.currentTarget;
      if (R.value === "") {
        h(R.value);
        return;
      }
      g.clear(), i ? g.start(i, () => {
        h(R.value);
      }) : h(R.value);
    }
  }, b(y)), [b, n, u, g, h, i, d]);
  return v.useMemo(() => ({
    getValidationProps: b,
    getInputValidationProps: w,
    inputRef: m,
    commit: h
  }), [b, w, h]);
}
function m4(t) {
  const {
    commit: e,
    invalid: n,
    markedDirtyRef: o,
    name: r,
    setValidityData: s,
    validityData: i
  } = t, {
    formRef: a
  } = Co(), l = v.useRef(null), c = v.useRef(null), u = v.useRef(null), d = ge(() => {
    const h = c.current;
    if (h)
      return h.getValue ? h.getValue() : h.value;
  }), f = ge((h = !0) => {
    const b = c.current;
    if (!b)
      return;
    let w = b.value;
    w === void 0 && (w = d()), o.current = !0, h ? tn.flushSync(() => e(w)) : e(w);
  });
  function p() {
    const h = c.current;
    !h || !h.id || a.current.fields.set(h.id, {
      getValue: d,
      name: r,
      controlRef: h.controlRef ?? u,
      validityData: pa(i, n),
      validate: f
    });
  }
  function g(h = c.current?.id) {
    h && a.current.fields.delete(h);
  }
  function m() {
    const h = c.current;
    if (!h)
      return;
    let b = h.value;
    b === void 0 && (b = d()), i.initialValue === null && b !== null && s((w) => ({
      ...w,
      initialValue: b
    }));
  }
  return xe(() => {
    const h = c.current;
    !h || !h.id || a.current.fields.set(h.id, {
      getValue: d,
      name: r,
      controlRef: h.controlRef ?? u,
      validityData: pa(i, n),
      validate: f
    });
  }, [a, d, n, r, f, i]), xe(() => {
    const h = a.current.fields;
    return () => {
      const b = c.current?.id;
      b && h.delete(b);
    };
  }, [a]), ge((h, b) => {
    if (!b) {
      l.current === h && (l.current = null, g(), c.current = null);
      return;
    }
    const w = c.current?.id;
    l.current = h, c.current = b, w && w !== b.id && g(w), m(), p();
  });
}
const q1 = /* @__PURE__ */ v.forwardRef(function(e, n) {
  const {
    errors: o,
    validationMode: r,
    submitAttemptedRef: s
  } = Co(), {
    render: i,
    className: a,
    validate: l,
    validationDebounceTime: c = 0,
    validationMode: u = r,
    name: d,
    disabled: f = !1,
    invalid: p,
    dirty: g,
    touched: m,
    actionsRef: h,
    style: b,
    ...w
  } = e, {
    disabled: y
  } = j1(), C = ge(l || (() => null)), R = y || f, [S, E] = v.useState(!1), [P, N] = v.useState(!1), [I, M] = v.useState(!1), [T, k] = v.useState(!1), D = g ?? P, O = m ?? S, V = v.useRef(!1), _ = ge((ae) => {
    g === void 0 && (ae && (V.current = !0), N(ae));
  }), A = ge((ae) => {
    m === void 0 && E(ae);
  }), F = ge(() => u === "onChange" || u === "onSubmit" && s.current), H = !!d && Object.hasOwn(o, d) && o[d] !== void 0, Y = p === !0 || H, [B, U] = v.useState({
    state: za,
    error: "",
    errors: [],
    value: null,
    initialValue: null
  }), q = !Y && B.state.valid, W = v.useMemo(() => ({
    disabled: R,
    touched: O,
    dirty: D,
    valid: q,
    filled: I,
    focused: T
  }), [R, O, D, q, I, T]), K = g4({
    setValidityData: U,
    validate: C,
    validityData: B,
    validationDebounceTime: c,
    invalid: Y,
    markedDirtyRef: V,
    state: W,
    name: d,
    shouldValidateOnChange: F
  }), te = v.useCallback(() => {
    V.current = !0, K.commit(B.value);
  }, [K, B]), z = m4({
    commit: K.commit,
    invalid: Y,
    markedDirtyRef: V,
    name: d,
    setValidityData: U,
    validityData: B
  });
  v.useImperativeHandle(h, () => ({
    validate: te
  }), [te]);
  const Q = v.useMemo(() => ({
    invalid: Y,
    name: d,
    validityData: B,
    setValidityData: U,
    disabled: R,
    touched: O,
    setTouched: A,
    dirty: D,
    setDirty: _,
    filled: I,
    setFilled: M,
    focused: T,
    setFocused: k,
    validate: C,
    validationMode: u,
    validationDebounceTime: c,
    shouldValidateOnChange: F,
    state: W,
    markedDirtyRef: V,
    registerFieldControl: z,
    validation: K
  }), [Y, d, B, R, O, A, D, _, I, M, T, k, C, u, c, F, W, z, K]), ee = Te("div", e, {
    ref: n,
    state: W,
    props: w,
    stateAttributesMapping: jn
  });
  return /* @__PURE__ */ x(Nu.Provider, {
    value: Q,
    children: ee
  });
});
process.env.NODE_ENV !== "production" && (q1.displayName = "FieldRootInner");
const hr = /* @__PURE__ */ v.forwardRef(function(e, n) {
  return /* @__PURE__ */ x(K1, {
    children: /* @__PURE__ */ x(q1, {
      ...e,
      ref: n
    })
  });
});
process.env.NODE_ENV !== "production" && (hr.displayName = "FieldRoot");
const X1 = /* @__PURE__ */ v.forwardRef(function(e, n) {
  const {
    render: o,
    className: r,
    style: s,
    id: i,
    nativeLabel: a = !0,
    ...l
  } = e, c = Xt(!1), {
    labelId: u
  } = un(), d = v.useRef(null), f = d4({
    id: u ?? i,
    native: a
  });
  return process.env.NODE_ENV !== "production" && v.useEffect(() => {
    if (!d.current)
      return;
    const g = d.current.tagName === "LABEL";
    if (a) {
      if (!g) {
        const m = Jo.captureOwnerStack?.() || "";
        Vo(`<Field.Label> expected a <label> element because the \`nativeLabel\` prop is true. Rendering a non-<label> disables native label association, so \`htmlFor\` will not work. Use a real <label> in the \`render\` prop, or set \`nativeLabel\` to \`false\`.${m}`);
      }
    } else if (g) {
      const m = Jo.captureOwnerStack?.() || "";
      Vo(`<Field.Label> expected a non-<label> element because the \`nativeLabel\` prop is false. Rendering a <label> assumes native label behavior while Base UI treats it as non-native, which can cause unexpected pointer behavior. Use a non-<label> in the \`render\` prop, or set \`nativeLabel\` to \`true\`.${m}`);
    }
  }, [a]), Te("label", e, {
    ref: [n, d],
    state: c.state,
    props: [f, l],
    stateAttributesMapping: jn
  });
});
process.env.NODE_ENV !== "production" && (X1.displayName = "FieldLabel");
const h4 = {
  ...jn,
  ...Lt
}, br = /* @__PURE__ */ v.forwardRef(function(e, n) {
  const {
    render: o,
    id: r,
    className: s,
    match: i,
    style: a,
    ...l
  } = e, c = St(r), {
    validityData: u,
    state: d,
    name: f
  } = Xt(!1), {
    setMessageIds: p
  } = un(), {
    errors: g
  } = Co(), m = f ? g[f] : null, h = typeof i == "string";
  let b = !1;
  i === !0 ? b = !0 : h ? b = !!u.state[i] : b = !!m || u.state.valid === !1;
  const {
    mounted: w,
    transitionStatus: y,
    setMounted: C
  } = Yn(b);
  xe(() => {
    if (!(!b || !c))
      return p((O) => O.concat(c)), () => {
        p((O) => O.filter((V) => V !== c));
      };
  }, [b, c, p]);
  const R = v.useRef(null), [S, E] = v.useState(null), [P, N] = v.useState(null), I = u.errors.length > 1 ? /* @__PURE__ */ x("ul", {
    children: u.errors.map((O) => /* @__PURE__ */ x("li", {
      children: O
    }, O))
  }) : u.error, M = h ? I : m || I;
  let T = u.error;
  m != null ? T = Array.isArray(m) ? JSON.stringify(m) : m : u.errors.length > 1 && (T = JSON.stringify(u.errors)), b && T !== P && (N(T), E(M)), Bt({
    open: b,
    ref: R,
    onComplete() {
      b || C(!1);
    }
  });
  const k = {
    ...d,
    transitionStatus: y
  }, D = Te("div", e, {
    ref: [n, R],
    state: k,
    props: [{
      id: c,
      children: b ? M : S
    }, l],
    stateAttributesMapping: h4,
    enabled: w
  });
  return w ? D : null;
});
process.env.NODE_ENV !== "production" && (br.displayName = "FieldError");
const Yr = /* @__PURE__ */ v.forwardRef(function(e, n) {
  const {
    render: o,
    id: r,
    className: s,
    style: i,
    ...a
  } = e, l = St(r), c = Xt(!1), {
    setMessageIds: u
  } = un();
  return xe(() => {
    if (l)
      return u((f) => f.concat(l)), () => {
        u((f) => f.filter((p) => p !== l));
      };
  }, [l, u]), Te("p", e, {
    ref: n,
    state: c.state,
    props: [{
      id: l
    }, a],
    stateAttributesMapping: jn
  });
});
process.env.NODE_ENV !== "production" && (Yr.displayName = "FieldDescription");
const Tu = /* @__PURE__ */ v.forwardRef(function(e, n) {
  const {
    render: o,
    className: r,
    id: s,
    name: i,
    value: a,
    disabled: l = !1,
    onValueChange: c,
    defaultValue: u,
    autoFocus: d = !1,
    style: f,
    ...p
  } = e, {
    state: g,
    name: m,
    disabled: h,
    setTouched: b,
    setDirty: w,
    validityData: y,
    setFocused: C,
    setFilled: R,
    validationMode: S,
    validation: E
  } = Xt(), P = h || l, N = m ?? i, I = {
    ...g,
    disabled: P
  }, {
    labelId: M
  } = un(), T = mr({
    id: s
  });
  xe(() => {
    const F = a != null;
    E.inputRef.current?.value || F && a !== "" ? R(!0) : F && a === "" && R(!1);
  }, [E.inputRef, R, a]);
  const k = v.useRef(null);
  xe(() => {
    d && k.current === zt(Ke(k.current)) && C(!0);
  }, [d, C]);
  const [D] = sn({
    controlled: a,
    default: u,
    name: "FieldControl",
    state: "value"
  }), O = a !== void 0, V = O ? D : void 0, _ = ge(() => E.inputRef.current?.value);
  return Ur(E.inputRef, {
    id: T,
    value: V,
    getValue: _
  }), Te("input", e, {
    ref: [n, k],
    state: I,
    props: [{
      id: T,
      disabled: P,
      name: N,
      ref: E.inputRef,
      "aria-labelledby": M,
      autoFocus: d,
      ...O ? {
        value: V
      } : {
        defaultValue: u
      },
      onChange(F) {
        const H = F.currentTarget.value;
        c?.(H, Pe(Et, F.nativeEvent)), w(H !== y.initialValue), R(H !== "");
      },
      onFocus() {
        C(!0);
      },
      onBlur(F) {
        b(!0), C(!1), S === "onBlur" && E.commit(F.currentTarget.value);
      },
      onKeyDown(F) {
        F.currentTarget.tagName === "INPUT" && F.key === "Enter" && (b(!0), E.commit(F.currentTarget.value));
      }
    }, E.getInputValidationProps(), p],
    stateAttributesMapping: jn
  });
});
process.env.NODE_ENV !== "production" && (Tu.displayName = "FieldControl");
const ku = /* @__PURE__ */ v.createContext(void 0);
process.env.NODE_ENV !== "production" && (ku.displayName = "PopoverRootContext");
function ti(t) {
  const e = v.useContext(ku);
  if (e === void 0 && !t)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: PopoverRootContext is missing. Popover parts must be placed within <Popover.Root>." : Xe(47));
  return e;
}
function b4() {
  return {
    ...Bs(),
    disabled: !1,
    modal: !1,
    focusManagerModal: !1,
    instantType: void 0,
    openMethod: null,
    openChangeReason: null,
    titleElementId: void 0,
    descriptionElementId: void 0,
    stickIfOpen: !0,
    nested: !1,
    openOnHover: !1,
    closeDelay: 0,
    hasViewport: !1
  };
}
const v4 = {
  ...Ws,
  disabled: ce((t) => t.disabled),
  instantType: ce((t) => t.instantType),
  openMethod: ce((t) => t.openMethod),
  openChangeReason: ce((t) => t.openChangeReason),
  modal: ce((t) => t.modal),
  focusManagerModal: ce((t) => t.focusManagerModal),
  stickIfOpen: ce((t) => t.stickIfOpen),
  titleElementId: ce((t) => t.titleElementId),
  descriptionElementId: ce((t) => t.descriptionElementId),
  openOnHover: ce((t) => t.openOnHover),
  closeDelay: ce((t) => t.closeDelay),
  hasViewport: ce((t) => t.hasViewport)
};
class Ou extends ur {
  constructor(e) {
    const n = {
      ...b4(),
      ...e
    };
    n.open && e?.mounted === void 0 && (n.mounted = !0), super(n, {
      popupRef: /* @__PURE__ */ v.createRef(),
      backdropRef: /* @__PURE__ */ v.createRef(),
      internalBackdropRef: /* @__PURE__ */ v.createRef(),
      onOpenChange: void 0,
      onOpenChangeComplete: void 0,
      triggerFocusTargetRef: /* @__PURE__ */ v.createRef(),
      beforeContentFocusGuardRef: /* @__PURE__ */ v.createRef(),
      stickIfOpenTimeout: new gn(),
      triggerElements: new dr()
    }, v4);
  }
  setOpen = (e, n) => {
    const o = n.reason === Dt, r = n.reason === Bn && n.event.detail === 0, s = !e && (n.reason === ar || n.reason == null);
    if (n.preventUnmountOnClose = () => {
      this.set("preventUnmountingOnClose", !0);
    }, this.context.onOpenChange?.(e, n), n.isCanceled)
      return;
    this.state.floatingRootContext.dispatchOpenChange(e, n);
    const i = () => {
      const a = {
        open: e,
        openChangeReason: n.reason
      }, l = n.trigger?.id ?? null;
      (l || e) && (a.activeTriggerId = l, a.activeTriggerElement = n.trigger ?? null), this.update(a);
    };
    o ? (this.set("stickIfOpen", !0), this.context.stickIfOpenTimeout.start(Km, () => {
      this.set("stickIfOpen", !1);
    }), tn.flushSync(i)) : i(), r || s ? this.set("instantType", r ? "click" : "dismiss") : n.reason === yo ? this.set("instantType", "focus") : this.set("instantType", void 0);
  };
  static useStore(e, n) {
    const o = Pt(() => new Ou(n)).current, r = e ?? o;
    return Ar(o.disposeEffect), r;
  }
  disposeEffect = () => this.context.stickIfOpenTimeout.disposeEffect();
}
function Ap({
  props: t
}) {
  const {
    children: e,
    open: n,
    defaultOpen: o = !1,
    onOpenChange: r,
    onOpenChangeComplete: s,
    modal: i = !1,
    handle: a,
    triggerId: l,
    defaultTriggerId: c = null
  } = t, u = Ou.useStore(a?.store, {
    modal: i,
    open: o,
    openProp: n,
    activeTriggerId: c,
    triggerIdProp: l
  });
  sr(() => {
    n === void 0 && u.state.open === !1 && o === !0 && u.update({
      open: !0,
      activeTriggerId: c
    });
  }), u.useControlledProp("openProp", n), u.useControlledProp("triggerIdProp", l);
  const d = u.useState("open"), f = u.useState("payload");
  u.useContextCallback("onOpenChange", r), u.useContextCallback("onOpenChangeComplete", s);
  const {
    openMethod: p,
    triggerProps: g
  } = Js(d);
  zs(u);
  const {
    forceUnmount: m
  } = Hs(d, u, () => {
    u.update({
      stickIfOpen: !0,
      openChangeReason: null
    });
  });
  v.useEffect(() => {
    d || u.context.stickIfOpenTimeout.clear();
  }, [u, d]);
  const h = v.useCallback(() => {
    u.setOpen(!1, Pe(As));
  }, [u]);
  v.useImperativeHandle(t.actionsRef, () => ({
    unmount: m,
    close: h
  }), [m, h]);
  const b = Us({
    popupStore: u,
    onOpenChange: u.setOpen
  }), w = cr(b, {
    outsidePressEvent: {
      // Ensure `aria-hidden` on outside elements is removed immediately
      // on outside press when trapping focus.
      mouse: i === "trap-focus" ? "sloppy" : "intentional",
      touch: "sloppy"
    }
  }), y = gu(b), {
    getReferenceProps: C,
    getFloatingProps: R,
    getTriggerProps: S
  } = Gn([w, y]), E = v.useMemo(() => C(g), [C, g]), P = v.useMemo(() => S(g), [S, g]), N = v.useMemo(() => R(), [R]);
  u.useSyncedValues({
    modal: i,
    openMethod: p,
    activeTriggerProps: E,
    inactiveTriggerProps: P,
    popupProps: N,
    floatingRootContext: b,
    nested: ao() != null
  });
  const I = v.useMemo(() => ({
    store: u
  }), [u]);
  return /* @__PURE__ */ x(ku.Provider, {
    value: I,
    children: typeof e == "function" ? e({
      payload: f
    }) : e
  });
}
function Z1(t) {
  return ti(!0) ? /* @__PURE__ */ x(Ap, {
    props: t
  }) : /* @__PURE__ */ x(nu, {
    children: /* @__PURE__ */ x(Ap, {
      props: t
    })
  });
}
const y4 = 300;
function Q1(t, e) {
  const n = v.useRef(null), o = ge((s) => {
    tn.flushSync(() => {
      t.setOpen(!1, Pe(yo, s.nativeEvent, s.currentTarget));
    }), rx(n.current)?.focus();
  }), r = ge((s) => {
    const i = t.select("positionerElement");
    if (i && Pr(s, i))
      t.context.beforeContentFocusGuardRef.current?.focus();
    else {
      tn.flushSync(() => {
        t.setOpen(!1, Pe(yo, s.nativeEvent, s.currentTarget));
      });
      let a = ox(t.context.triggerFocusTargetRef.current || e.current);
      for (; a !== null && De(i, a); ) {
        const l = a;
        if (a = Kc(a), a === l)
          break;
      }
      a?.focus();
    }
  });
  return {
    preFocusGuardRef: n,
    handlePreFocusGuardFocus: o,
    handleFocusTargetFocus: r
  };
}
const Du = /* @__PURE__ */ v.forwardRef(function(e, n) {
  const {
    render: o,
    className: r,
    disabled: s = !1,
    nativeButton: i = !0,
    handle: a,
    payload: l,
    openOnHover: c = !1,
    delay: u = y4,
    closeDelay: d = 0,
    id: f,
    style: p,
    ...g
  } = e, m = ti(!0), h = a?.store ?? m?.store;
  if (!h)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: <Popover.Trigger> must be either used within a <Popover.Root> component or provided with a handle." : Xe(74));
  const b = St(f), w = h.useState("isTriggerActive", b), y = h.useState("floatingRootContext"), C = h.useState("isOpenedByTrigger", b), R = v.useRef(null), {
    registerTrigger: S,
    isMountedByThisTrigger: E
  } = $s(b, R, h, {
    payload: l,
    disabled: s,
    openOnHover: c,
    closeDelay: d
  }), P = h.useState("openChangeReason"), N = h.useState("stickIfOpen"), I = h.useState("openMethod"), M = h.useState("focusManagerModal"), T = Ys(y, {
    enabled: y != null && c && (I !== "touch" || P !== Bn),
    mouseOnly: !0,
    move: !1,
    handleClose: Gs(),
    restMs: u,
    delay: {
      close: d
    },
    triggerElementRef: R,
    isActiveTrigger: w,
    isClosing: () => h.select("transitionStatus") === "ending"
  }), k = lr(y, {
    enabled: y != null,
    stickIfOpen: N
  }), D = Gn([k]), O = h.useState("triggerProps", E), V = {
    disabled: s,
    open: C
  }, {
    getButtonProps: _,
    buttonRef: A
  } = Ft({
    disabled: s,
    native: i
  }), F = v.useMemo(() => ({
    open(q) {
      return q && P === Bn ? Es.open(q) : fr.open(q);
    }
  }), [P]), H = Te("button", e, {
    state: V,
    ref: [A, n, S, R],
    props: [D.getReferenceProps(), T, O, {
      [qc]: "",
      id: b
    }, g, _],
    stateAttributesMapping: F
  }), {
    preFocusGuardRef: Y,
    handlePreFocusGuardFocus: B,
    handleFocusTargetFocus: U
  } = Q1(h, R);
  return w && !M ? /* @__PURE__ */ j(v.Fragment, {
    children: [/* @__PURE__ */ x(Mn, {
      ref: Y,
      onFocus: B
    }), /* @__PURE__ */ x(v.Fragment, {
      children: H
    }, b), /* @__PURE__ */ x(Mn, {
      ref: h.context.triggerFocusTargetRef,
      onFocus: U
    })]
  }) : /* @__PURE__ */ x(v.Fragment, {
    children: H
  }, b);
});
process.env.NODE_ENV !== "production" && (Du.displayName = "PopoverTrigger");
const _u = /* @__PURE__ */ v.createContext(void 0);
process.env.NODE_ENV !== "production" && (_u.displayName = "PopoverPortalContext");
function x4() {
  const t = v.useContext(_u);
  if (t === void 0)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: <Popover.Portal> is missing." : Xe(45));
  return t;
}
const Vu = /* @__PURE__ */ v.forwardRef(function(e, n) {
  const {
    keepMounted: o = !1,
    ...r
  } = e, {
    store: s
  } = ti();
  return s.useState("mounted") || o ? /* @__PURE__ */ x(_u.Provider, {
    value: o,
    children: /* @__PURE__ */ x($r, {
      ref: n,
      ...r
    })
  }) : null;
});
process.env.NODE_ENV !== "production" && (Vu.displayName = "PopoverPortal");
const Au = /* @__PURE__ */ v.createContext(void 0);
process.env.NODE_ENV !== "production" && (Au.displayName = "PopoverPositionerContext");
function w4() {
  const t = v.useContext(Au);
  if (!t)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: PopoverPositionerContext is missing. PopoverPositioner parts must be placed within <Popover.Positioner>." : Xe(46));
  return t;
}
const C4 = 20;
function Ha(t, e, n, o) {
  const [r, s] = v.useState(!1);
  xe(() => {
    if (!t || !e || n == null) {
      s(!1);
      return;
    }
    const i = Ke(n).documentElement.clientWidth, a = n.offsetWidth;
    s(i > 0 && a > 0 && a >= i - C4);
  }, [t, e, n]), P1(t && (!e || r), o);
}
const Fu = /* @__PURE__ */ v.forwardRef(function(e, n) {
  const {
    render: o,
    className: r,
    anchor: s,
    positionMethod: i = "absolute",
    side: a = "bottom",
    align: l = "center",
    sideOffset: c = 0,
    alignOffset: u = 0,
    collisionBoundary: d = "clipping-ancestors",
    collisionPadding: f = 5,
    arrowPadding: p = 5,
    sticky: g = !1,
    disableAnchorTracking: m = !1,
    collisionAvoidance: h = Ma,
    style: b,
    ...w
  } = e, {
    store: y
  } = ti(), C = x4(), R = Ta(), S = y.useState("floatingRootContext"), E = y.useState("mounted"), P = y.useState("open"), N = y.useState("openChangeReason"), I = y.useState("activeTriggerElement"), M = y.useState("modal"), T = y.useState("openMethod"), k = y.useState("positionerElement"), D = y.useState("instantType"), O = y.useState("transitionStatus"), V = y.useState("hasViewport"), _ = v.useRef(null), A = Oa(k, !1, !1), F = Hr({
    anchor: s,
    floatingRootContext: S,
    positionMethod: i,
    mounted: E,
    side: a,
    sideOffset: c,
    align: l,
    alignOffset: u,
    arrowPadding: p,
    collisionBoundary: d,
    collisionPadding: f,
    sticky: g,
    disableAnchorTracking: m,
    keepMounted: C,
    nodeId: R,
    collisionAvoidance: h,
    adaptiveOrigin: V ? Aa : void 0
  }), H = S.useState("domReferenceElement");
  xe(() => {
    const q = H, W = _.current;
    if (q && (_.current = q), W && q && q !== W) {
      y.set("instantType", void 0);
      const K = new AbortController();
      return A(() => {
        y.set("instantType", "trigger-change");
      }, K.signal), () => {
        K.abort();
      };
    }
  }, [H, A, y]);
  const Y = {
    open: P,
    side: F.side,
    align: F.align,
    anchorHidden: F.anchorHidden,
    instant: D
  };
  Ha(P && M === !0 && N !== Dt, T === "touch", k, I);
  const B = v.useCallback((q) => {
    y.set("positionerElement", q);
  }, [y]), U = Br(e, Y, {
    styles: F.positionerStyles,
    transitionStatus: O,
    props: w,
    refs: [n, B],
    hidden: !E,
    inert: !P
  });
  return /* @__PURE__ */ j(Au.Provider, {
    value: F,
    children: [E && M === !0 && N !== Dt && /* @__PURE__ */ x(Wr, {
      ref: y.context.internalBackdropRef,
      inert: gr(!P),
      cutout: I
    }), /* @__PURE__ */ x(tu, {
      id: R,
      children: U
    })]
  });
});
process.env.NODE_ENV !== "production" && (Fu.displayName = "PopoverPositioner");
const J1 = /* @__PURE__ */ v.createContext(void 0);
process.env.NODE_ENV !== "production" && (J1.displayName = "ToolbarRootContext");
function Lu(t) {
  return v.useContext(J1);
}
const eh = /* @__PURE__ */ v.createContext(void 0);
process.env.NODE_ENV !== "production" && (eh.displayName = "ClosePartContext");
function S4() {
  const [t, e] = v.useState(0), n = ge(() => (e((r) => r + 1), () => {
    e((r) => Math.max(0, r - 1));
  }));
  return {
    context: v.useMemo(() => ({
      register: n
    }), [n]),
    hasClosePart: t > 0
  };
}
function R4(t) {
  const {
    value: e,
    children: n
  } = t;
  return /* @__PURE__ */ x(eh.Provider, {
    value: e,
    children: n
  });
}
const E4 = {
  ...xn,
  ...Lt
}, $u = /* @__PURE__ */ v.forwardRef(function(e, n) {
  const {
    className: o,
    render: r,
    initialFocus: s,
    finalFocus: i,
    style: a,
    ...l
  } = e, {
    store: c
  } = ti(), u = w4(), d = Lu() != null, {
    context: f,
    hasClosePart: p
  } = S4(), g = c.useState("open"), m = c.useState("openMethod"), h = c.useState("instantType"), b = c.useState("transitionStatus"), w = c.useState("popupProps"), y = c.useState("titleElementId"), C = c.useState("descriptionElementId"), R = c.useState("modal"), S = c.useState("mounted"), E = c.useState("openChangeReason"), P = c.useState("activeTriggerElement"), N = c.useState("floatingRootContext");
  Bt({
    open: g,
    ref: c.context.popupRef,
    onComplete() {
      g && c.context.onOpenChangeComplete?.(!0);
    }
  });
  const I = c.useState("disabled"), M = c.useState("openOnHover"), T = c.useState("closeDelay");
  Da(N, {
    enabled: M && !I,
    closeDelay: T
  });
  function k(F) {
    return F === "touch" ? c.context.popupRef.current : !0;
  }
  const D = s === void 0 ? k : s, O = {
    open: g,
    side: u.side,
    align: u.align,
    instant: h,
    transitionStatus: b
  }, V = R !== !1 && p;
  c.useSyncedValue("focusManagerModal", V);
  const _ = v.useCallback((F) => {
    c.set("popupElement", F);
  }, [c]), A = Te("div", e, {
    state: O,
    ref: [n, c.context.popupRef, _],
    props: [w, {
      "aria-labelledby": y,
      "aria-describedby": C,
      onKeyDown(F) {
        d && Zs.has(F.key) && F.stopPropagation();
      }
    }, pr(b), l],
    stateAttributesMapping: E4
  });
  return /* @__PURE__ */ x(zr, {
    context: N,
    openInteractionType: m,
    modal: V,
    disabled: !S || E === Dt,
    initialFocus: D,
    returnFocus: i,
    restoreFocus: "popup",
    previousFocusableElement: bt(P) ? P : void 0,
    nextFocusableElement: c.context.triggerFocusTargetRef,
    beforeContentFocusGuardRef: c.context.beforeContentFocusGuardRef,
    children: /* @__PURE__ */ x(R4, {
      value: f,
      children: A
    })
  });
});
process.env.NODE_ENV !== "production" && ($u.displayName = "PopoverPopup");
const zu = /* @__PURE__ */ v.createContext(null);
process.env.NODE_ENV !== "production" && (zu.displayName = "SelectRootContext");
const Hu = /* @__PURE__ */ v.createContext(null);
process.env.NODE_ENV !== "production" && (Hu.displayName = "SelectFloatingContext");
function So() {
  const t = v.useContext(zu);
  if (t === null)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: SelectRootContext is missing. Select parts must be placed within <Select.Root>." : Xe(60));
  return t;
}
function th() {
  const t = v.useContext(Hu);
  if (t === null)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: SelectFloatingContext is missing. Select parts must be placed within <Select.Root>." : Xe(61));
  return t;
}
const nh = (t, e) => Object.is(t, e);
function so(t, e, n) {
  return t == null || e == null ? Object.is(t, e) : n(t, e);
}
function oh(t, e, n) {
  return !t || t.length === 0 ? !1 : t.some((o) => o === void 0 ? !1 : so(e, o, n));
}
function vo(t, e, n) {
  return !t || t.length === 0 ? -1 : t.findIndex((o) => o === void 0 ? !1 : so(o, e, n));
}
function rh(t, e, n) {
  return t.filter((o) => !so(e, o, n));
}
function ga(t) {
  if (t == null)
    return "";
  if (typeof t == "string")
    return t;
  try {
    return JSON.stringify(t);
  } catch {
    return String(t);
  }
}
function Bu(t) {
  return t != null && t.length > 0 && typeof t[0] == "object" && t[0] != null && "items" in t[0];
}
function sh(t) {
  if (!Array.isArray(t))
    return t != null && "null" in t;
  const e = t;
  if (Bu(e)) {
    for (const n of e)
      for (const o of n.items)
        if (o && o.value == null && o.label != null)
          return !0;
    return !1;
  }
  for (const n of e)
    if (n && n.value == null && n.label != null)
      return !0;
  return !1;
}
function qt(t, e) {
  if (e && t != null)
    return e(t) ?? "";
  if (t && typeof t == "object") {
    if ("label" in t && t.label != null)
      return String(t.label);
    if ("value" in t)
      return String(t.value);
  }
  return ga(t);
}
function An(t, e) {
  return e && t != null ? e(t) ?? "" : t && typeof t == "object" && "value" in t && "label" in t ? ga(t.value) : ga(t);
}
function ih(t, e, n) {
  function o() {
    return qt(t, n);
  }
  if (n && t != null)
    return n(t);
  if (t && typeof t == "object" && "label" in t && t.label != null)
    return t.label;
  if (e && !Array.isArray(e))
    return e[t] ?? o();
  if (Array.isArray(e)) {
    const r = e, s = Bu(r) ? r.flatMap((i) => i.items) : r;
    if (t == null || typeof t != "object") {
      const i = s.find((a) => a.value === t);
      return i && i.label != null ? i.label : o();
    }
    if ("value" in t) {
      const i = s.find((a) => a && a.value === t.value);
      if (i && i.label != null)
        return i.label;
    }
  }
  return o();
}
function P4(t, e, n) {
  return t.reduce((o, r, s) => (s > 0 && o.push(", "), o.push(/* @__PURE__ */ x(v.Fragment, {
    children: ih(r, e, n)
  }, s)), o), []);
}
const st = {
  id: ce((t) => t.id),
  labelId: ce((t) => t.labelId),
  modal: ce((t) => t.modal),
  multiple: ce((t) => t.multiple),
  items: ce((t) => t.items),
  itemToStringLabel: ce((t) => t.itemToStringLabel),
  itemToStringValue: ce((t) => t.itemToStringValue),
  isItemEqualToValue: ce((t) => t.isItemEqualToValue),
  value: ce((t) => t.value),
  hasSelectedValue: ce((t) => {
    const {
      value: e,
      multiple: n,
      itemToStringValue: o
    } = t;
    return e == null ? !1 : n && Array.isArray(e) ? e.length > 0 : An(e, o) !== "";
  }),
  hasNullItemLabel: ce((t, e) => e ? sh(t.items) : !1),
  open: ce((t) => t.open),
  mounted: ce((t) => t.mounted),
  forceMount: ce((t) => t.forceMount),
  transitionStatus: ce((t) => t.transitionStatus),
  openMethod: ce((t) => t.openMethod),
  activeIndex: ce((t) => t.activeIndex),
  selectedIndex: ce((t) => t.selectedIndex),
  isActive: ce((t, e) => t.activeIndex === e),
  isSelected: ce((t, e, n) => {
    const o = t.isItemEqualToValue, r = t.value;
    return t.multiple ? Array.isArray(r) && r.some((s) => so(n, s, o)) : t.selectedIndex === e && t.selectedIndex !== null ? !0 : so(n, r, o);
  }),
  isSelectedByFocus: ce((t, e) => t.selectedIndex === e),
  popupProps: ce((t) => t.popupProps),
  triggerProps: ce((t) => t.triggerProps),
  triggerElement: ce((t) => t.triggerElement),
  positionerElement: ce((t) => t.positionerElement),
  listElement: ce((t) => t.listElement),
  scrollUpArrowVisible: ce((t) => t.scrollUpArrowVisible),
  scrollDownArrowVisible: ce((t) => t.scrollDownArrowVisible),
  hasScrollArrows: ce((t) => t.hasScrollArrows)
};
function $t(t, e = Number.MIN_SAFE_INTEGER, n = Number.MAX_SAFE_INTEGER) {
  return Math.max(e, Math.min(t, n));
}
const uo = 1;
function ah(t, e) {
  return Math.max(0, t - e);
}
function N4(t, e) {
  if (e <= 0)
    return 0;
  const n = $t(t, 0, e), o = n, r = e - n, s = o <= uo, i = r <= uo;
  return s && i ? o <= r ? 0 : e : s ? 0 : i ? e : n;
}
function lh(t) {
  const {
    id: e,
    value: n,
    defaultValue: o = null,
    onValueChange: r,
    open: s,
    defaultOpen: i = !1,
    onOpenChange: a,
    name: l,
    form: c,
    autoComplete: u,
    disabled: d = !1,
    readOnly: f = !1,
    required: p = !1,
    modal: g = !0,
    actionsRef: m,
    inputRef: h,
    onOpenChangeComplete: b,
    items: w,
    multiple: y = !1,
    itemToStringLabel: C,
    itemToStringValue: R,
    isItemEqualToValue: S = nh,
    highlightItemOnHover: E = !0,
    children: P
  } = t, {
    clearErrors: N
  } = Co(), {
    setDirty: I,
    setTouched: M,
    setFocused: T,
    shouldValidateOnChange: k,
    validityData: D,
    setFilled: O,
    name: V,
    disabled: _,
    validation: A,
    validationMode: F
  } = Xt(), H = mr({
    id: e
  }), Y = _ || d, B = V ?? l, [U, q] = sn({
    controlled: n,
    default: y ? o ?? Nn : o,
    name: "Select",
    state: "value"
  }), [W, K] = sn({
    controlled: s,
    default: i,
    name: "Select",
    state: "open"
  }), te = v.useRef([]), z = v.useRef([]), Q = v.useRef(null), ee = v.useRef(null), ae = v.useRef(0), X = v.useRef(null), se = v.useRef([]), ue = v.useRef(!1), re = v.useRef(!1), ne = v.useRef(null), oe = v.useRef({
    allowSelectedMouseUp: !1,
    allowUnselectedMouseUp: !1
  }), me = v.useRef(!1), {
    mounted: de,
    setMounted: he,
    transitionStatus: $
  } = Yn(W), {
    openMethod: Z,
    triggerProps: L
  } = Js(W), G = Pt(() => new lu({
    id: H,
    labelId: void 0,
    modal: g,
    multiple: y,
    itemToStringLabel: C,
    itemToStringValue: R,
    isItemEqualToValue: S,
    value: U,
    open: W,
    mounted: de,
    transitionStatus: $,
    items: w,
    forceMount: !1,
    openMethod: null,
    activeIndex: null,
    selectedIndex: null,
    popupProps: {},
    triggerProps: {},
    triggerElement: null,
    positionerElement: null,
    listElement: null,
    scrollUpArrowVisible: !1,
    scrollDownArrowVisible: !1,
    hasScrollArrows: !1
  })).current, ie = fe(G, st.activeIndex), pe = fe(G, st.selectedIndex), be = fe(G, st.triggerElement), Re = fe(G, st.positionerElement), _e = bC(Z), ke = Z ?? _e, Se = v.useMemo(() => y && Array.isArray(U) && U.length === 0 ? "" : An(U, R), [y, U, R]), Ie = v.useMemo(() => y && Array.isArray(U) ? U.map((Ue) => An(Ue, R)) : An(U, R), [y, U, R]), Le = _t(G.state.triggerElement), Ze = ge(() => Ie);
  Ur(Le, {
    id: H,
    value: U,
    getValue: Ze
  });
  const tt = v.useRef(U);
  xe(() => {
    U !== tt.current && G.set("forceMount", !0);
  }, [G, U]), xe(() => {
    O(y ? Array.isArray(U) && U.length > 0 : U != null);
  }, [y, U, O]), xe(function() {
    if (W)
      return;
    const We = se.current;
    if (y) {
      const nt = Array.isArray(U) ? U : [];
      if (nt.length === 0) {
        G.set("selectedIndex", null);
        return;
      }
      const dt = nt[nt.length - 1], pt = vo(We, dt, S);
      G.set("selectedIndex", pt === -1 ? null : pt);
      return;
    }
    const Qe = vo(We, U, S);
    G.set("selectedIndex", Qe === -1 ? null : Qe);
  }, [y, W, U, se, S, G]), po(U, () => {
    N(B), I(U !== D.initialValue), k() ? A.commit(U) : A.commit(U, !0);
  });
  const ut = ge((Ue, We) => {
    if (a?.(Ue, We), !We.isCanceled && (K(Ue), !Ue && (We.reason === yo || We.reason === Vs) && (M(!0), T(!1), F === "onBlur" && A.commit(U)), !Ue && G.state.activeIndex !== null)) {
      const Qe = te.current[G.state.activeIndex];
      queueMicrotask(() => {
        Qe?.setAttribute("tabindex", "-1");
      });
    }
  }), at = ge(() => {
    he(!1), G.update({
      activeIndex: null,
      openMethod: null
    }), b?.(!1);
  });
  Bt({
    enabled: !m,
    open: W,
    ref: Q,
    onComplete() {
      W || at();
    }
  }), v.useImperativeHandle(m, () => ({
    unmount: at
  }), [at]);
  const $e = ge((Ue, We) => {
    r?.(Ue, We), !We.isCanceled && q(Ue);
  }), Ce = ge(() => {
    const Ue = G.state.listElement || Q.current;
    if (!Ue)
      return;
    const We = ah(Ue.scrollHeight, Ue.clientHeight), Qe = N4(Ue.scrollTop, We), nt = Qe > 0, dt = Qe < We;
    G.state.scrollUpArrowVisible !== nt && G.set("scrollUpArrowVisible", nt), G.state.scrollDownArrowVisible !== dt && G.set("scrollDownArrowVisible", dt);
  }), Oe = uu({
    open: W,
    onOpenChange: ut,
    elements: {
      reference: be,
      floating: Re
    }
  }), Ne = lr(Oe, {
    enabled: !f && !Y,
    event: "mousedown"
  }), Be = cr(Oe, {
    bubbles: !1
  }), ze = pu(Oe, {
    enabled: !f && !Y,
    listRef: te,
    activeIndex: ie,
    selectedIndex: pe,
    disabledIndices: Nn,
    onNavigate(Ue) {
      Ue === null && !W || G.set("activeIndex", Ue);
    },
    focusItemOnHover: E
  }), Me = mu(Oe, {
    enabled: !f && !Y && (W || !y),
    listRef: z,
    activeIndex: ie,
    selectedIndex: pe,
    onMatch(Ue) {
      W ? G.set("activeIndex", Ue) : $e(se.current[Ue], Pe("none"));
    },
    onTypingChange(Ue) {
      ue.current = Ue;
    }
  }), {
    getReferenceProps: Wt,
    getFloatingProps: ft,
    getItemProps: ve
  } = Gn([Ne, Be, ze, Me]), we = v.useMemo(() => on(Wt(), L, H ? {
    id: H
  } : yt), [Wt, L, H]);
  sr(() => {
    G.update({
      popupProps: ft(),
      triggerProps: we
    });
  }), xe(() => {
    G.update({
      id: H,
      modal: g,
      multiple: y,
      value: U,
      open: W,
      mounted: de,
      transitionStatus: $,
      popupProps: ft(),
      triggerProps: we,
      items: w,
      itemToStringLabel: C,
      itemToStringValue: R,
      isItemEqualToValue: S,
      openMethod: ke
    });
  }, [G, H, g, y, U, W, de, $, ft, we, w, C, R, S, ke]);
  const Ve = v.useMemo(() => ({
    store: G,
    name: B,
    required: p,
    disabled: Y,
    readOnly: f,
    multiple: y,
    highlightItemOnHover: E,
    setValue: $e,
    setOpen: ut,
    listRef: te,
    popupRef: Q,
    scrollHandlerRef: ee,
    handleScrollArrowVisibility: Ce,
    scrollArrowsMountedCountRef: ae,
    getItemProps: ve,
    events: Oe.context.events,
    valueRef: X,
    valuesRef: se,
    labelsRef: z,
    typingRef: ue,
    selectionRef: oe,
    selectedItemTextRef: ne,
    validation: A,
    onOpenChangeComplete: b,
    keyboardActiveRef: re,
    alignItemWithTriggerActiveRef: me,
    initialValueRef: tt
  }), [G, B, p, Y, f, y, E, $e, ut, ve, Oe.context.events, A, b, Ce]), He = ln(h, A.inputRef), ct = y && Array.isArray(U) && U.length > 0, qe = y ? void 0 : B, it = v.useMemo(() => !y || !Array.isArray(U) || !B ? null : U.map((Ue) => {
    const We = An(Ue, R);
    return /* @__PURE__ */ x("input", {
      type: "hidden",
      form: c,
      name: B,
      value: We
    }, We);
  }), [y, U, c, B, R]);
  return /* @__PURE__ */ x(zu.Provider, {
    value: Ve,
    children: /* @__PURE__ */ j(Hu.Provider, {
      value: Oe,
      children: [P, /* @__PURE__ */ x("input", {
        ...A.getInputValidationProps({
          onFocus() {
            G.state.triggerElement?.focus({
              // Supported in Chrome from 144 (January 2026)
              focusVisible: !0
            });
          },
          // Handle browser autofill.
          onChange(Ue) {
            if (Ue.nativeEvent.defaultPrevented)
              return;
            const We = Ue.currentTarget.value, Qe = Pe(Et, Ue.nativeEvent);
            function nt() {
              if (y)
                return;
              const dt = se.current.find((pt) => An(pt, R).toLowerCase() === We.toLowerCase() || qt(pt, C).toLowerCase() === We.toLowerCase());
              dt != null && (I(dt !== D.initialValue), $e(dt, Qe), k() && A.commit(dt));
            }
            G.set("forceMount", !0), queueMicrotask(nt);
          }
        }),
        id: H && qe == null ? `${H}-hidden-input` : void 0,
        form: c,
        name: qe,
        autoComplete: u,
        value: Se,
        disabled: Y,
        required: p && !ct,
        readOnly: f,
        ref: He,
        style: B ? Lr : $o,
        tabIndex: -1,
        "aria-hidden": !0,
        suppressHydrationWarning: !0
      }), it]
    })
  });
}
function Wu(t, e) {
  return t ?? e;
}
function Uu(t) {
  const e = t.getBoundingClientRect();
  if (process.env.NODE_ENV !== "production")
    return e;
  const n = vt(t), o = n.getComputedStyle(t, "::before"), r = n.getComputedStyle(t, "::after");
  if (!(o.content !== "none" || r.content !== "none"))
    return e;
  const i = parseFloat(o.width) || 0, a = parseFloat(o.height) || 0, l = parseFloat(r.width) || 0, c = parseFloat(r.height) || 0, u = Math.max(e.width, i, l), d = Math.max(e.height, a, c), f = u - e.width, p = d - e.height;
  return {
    left: e.left - f / 2,
    right: e.right + f / 2,
    top: e.top - p / 2,
    bottom: e.bottom + p / 2
  };
}
const Ti = 2, I4 = 400, Fp = 200, M4 = {
  ...Es,
  ...jn,
  value: () => null
}, Yu = /* @__PURE__ */ v.forwardRef(function(e, n) {
  const {
    render: o,
    className: r,
    id: s,
    disabled: i = !1,
    nativeButton: a = !0,
    style: l,
    ...c
  } = e, {
    setTouched: u,
    setFocused: d,
    validationMode: f,
    state: p,
    disabled: g
  } = Xt(), {
    labelId: m
  } = un(), {
    store: h,
    setOpen: b,
    selectionRef: w,
    validation: y,
    readOnly: C,
    required: R,
    alignItemWithTriggerActiveRef: S,
    disabled: E,
    keyboardActiveRef: P
  } = So(), N = g || E || i, I = fe(h, st.open), M = fe(h, st.value), T = fe(h, st.triggerProps), k = fe(h, st.positionerElement), D = fe(h, st.listElement), O = fe(h, st.id), V = fe(h, st.labelId), _ = fe(h, st.hasSelectedValue), A = !_ && I, F = fe(h, st.hasNullItemLabel, A), H = s ?? O, Y = Wu(m, V);
  mr({
    id: H
  });
  const B = _t(k), U = v.useRef(null), {
    getButtonProps: q,
    buttonRef: W
  } = Ft({
    disabled: N,
    native: a
  }), K = ge((re) => {
    h.set("triggerElement", re);
  }), te = ln(n, U, W, K), z = Vt(), Q = Vt(), ee = Vt(), ae = Vt();
  v.useEffect(() => {
    if (I)
      return !(_ || F) ? ee.start(I4, () => {
        w.current.allowUnselectedMouseUp = !0, w.current.allowSelectedMouseUp = !0;
      }) : ae.start(Fp, () => {
        w.current.allowUnselectedMouseUp = !0, ee.start(Fp, () => {
          w.current.allowSelectedMouseUp = !0;
        });
      }), () => {
        ee.clear(), ae.clear();
      };
    w.current = {
      allowSelectedMouseUp: !1,
      allowUnselectedMouseUp: !1
    }, Q.clear();
  }, [I, _, F, w, Q, ee, ae]);
  const X = v.useMemo(() => D?.id ?? ws(k)?.id, [D, k]), se = on(T, {
    id: H,
    role: "combobox",
    "aria-expanded": I ? "true" : "false",
    "aria-haspopup": "listbox",
    "aria-controls": I ? X : void 0,
    "aria-labelledby": Y,
    "aria-readonly": C || void 0,
    "aria-required": R || void 0,
    tabIndex: N ? -1 : 0,
    ref: te,
    onFocus(re) {
      d(!0), I && S.current && b(!1, Pe(Et, re.nativeEvent)), z.start(0, () => {
        h.set("forceMount", !0);
      });
    },
    onBlur(re) {
      De(k, re.relatedTarget) || (u(!0), d(!1), f === "onBlur" && y.commit(M));
    },
    onPointerMove() {
      P.current = !1;
    },
    onKeyDown() {
      P.current = !0;
    },
    onMouseDown(re) {
      if (I)
        return;
      const ne = Ke(re.currentTarget);
      function oe(me) {
        if (!U.current)
          return;
        const de = me.target;
        if (De(U.current, de) || De(B.current, de) || de === U.current)
          return;
        const he = Uu(U.current);
        me.clientX >= he.left - Ti && me.clientX <= he.right + Ti && me.clientY >= he.top - Ti && me.clientY <= he.bottom + Ti || b(!1, Pe(Pm, me));
      }
      Q.start(0, () => {
        ne.addEventListener("mouseup", oe, {
          once: !0
        });
      });
    }
  }, y.getValidationProps, c, q);
  se.role = "combobox";
  const ue = {
    ...p,
    open: I,
    disabled: N,
    value: M,
    readOnly: C,
    placeholder: !_
  };
  return Te("button", e, {
    ref: [n, U],
    state: ue,
    stateAttributesMapping: M4,
    props: se
  });
});
process.env.NODE_ENV !== "production" && (Yu.displayName = "SelectTrigger");
const T4 = {
  value: () => null
}, Gu = /* @__PURE__ */ v.forwardRef(function(e, n) {
  const {
    className: o,
    render: r,
    children: s,
    placeholder: i,
    style: a,
    ...l
  } = e, {
    store: c,
    valueRef: u
  } = So(), d = fe(c, st.value), f = fe(c, st.items), p = fe(c, st.itemToStringLabel), g = fe(c, st.hasSelectedValue), m = !g && i != null && s == null, h = fe(c, st.hasNullItemLabel, m), b = {
    value: d,
    placeholder: !g
  };
  let w = null;
  return typeof s == "function" ? w = s(d) : s != null ? w = s : !g && i != null && !h ? w = i : Array.isArray(d) ? w = P4(d, f, p) : w = ih(d, f, p), Te("span", e, {
    state: b,
    ref: [n, u],
    props: [{
      children: w
    }, l],
    stateAttributesMapping: T4
  });
});
process.env.NODE_ENV !== "production" && (Gu.displayName = "SelectValue");
const ju = /* @__PURE__ */ v.forwardRef(function(e, n) {
  const {
    className: o,
    render: r,
    style: s,
    ...i
  } = e, {
    store: a
  } = So(), c = {
    open: fe(a, st.open)
  };
  return Te("span", e, {
    state: c,
    ref: n,
    props: [{
      "aria-hidden": !0,
      children: "▼"
    }, i],
    stateAttributesMapping: fr
  });
});
process.env.NODE_ENV !== "production" && (ju.displayName = "SelectIcon");
const ch = /* @__PURE__ */ v.createContext(void 0);
process.env.NODE_ENV !== "production" && (ch.displayName = "SelectPortalContext");
const uh = /* @__PURE__ */ v.forwardRef(function(e, n) {
  const {
    store: o
  } = So(), r = fe(o, st.mounted), s = fe(o, st.forceMount);
  return r || s ? /* @__PURE__ */ x(ch.Provider, {
    value: !0,
    children: /* @__PURE__ */ x($r, {
      ref: n,
      ...e
    })
  }) : null;
});
process.env.NODE_ENV !== "production" && (uh.displayName = "SelectPortal");
const Ku = /* @__PURE__ */ v.createContext({
  register: () => {
  },
  unregister: () => {
  },
  subscribeMapChange: () => () => {
  },
  elementsRef: {
    current: []
  },
  nextIndexRef: {
    current: 0
  }
});
process.env.NODE_ENV !== "production" && (Ku.displayName = "CompositeListContext");
function k4() {
  return v.useContext(Ku);
}
function Gr(t) {
  const {
    children: e,
    elementsRef: n,
    labelsRef: o,
    onMapChange: r
  } = t, s = ge(r), i = v.useRef(0), a = Pt(D4).current, l = Pt(O4).current, [c, u] = v.useState(0), d = v.useRef(c), f = ge((b, w) => {
    l.set(b, w ?? null), d.current += 1, u(d.current);
  }), p = ge((b) => {
    l.delete(b), d.current += 1, u(d.current);
  }), g = v.useMemo(() => {
    const b = /* @__PURE__ */ new Map();
    return Array.from(l.keys()).filter((y) => y.isConnected).sort(_4).forEach((y, C) => {
      const R = l.get(y) ?? {};
      b.set(y, {
        ...R,
        index: C
      });
    }), b;
  }, [l, c]);
  xe(() => {
    if (typeof MutationObserver != "function" || g.size === 0)
      return;
    const b = new MutationObserver((w) => {
      const y = /* @__PURE__ */ new Set(), C = (R) => y.has(R) ? y.delete(R) : y.add(R);
      w.forEach((R) => {
        R.removedNodes.forEach(C), R.addedNodes.forEach(C);
      }), y.size === 0 && (d.current += 1, u(d.current));
    });
    return g.forEach((w, y) => {
      y.parentElement && b.observe(y.parentElement, {
        childList: !0
      });
    }), () => {
      b.disconnect();
    };
  }, [g]), xe(() => {
    d.current === c && (n.current.length !== g.size && (n.current.length = g.size), o && o.current.length !== g.size && (o.current.length = g.size), i.current = g.size), s(g);
  }, [s, g, n, o, c]), xe(() => () => {
    n.current = [];
  }, [n]), xe(() => () => {
    o && (o.current = []);
  }, [o]);
  const m = ge((b) => (a.add(b), () => {
    a.delete(b);
  }));
  xe(() => {
    a.forEach((b) => b(g));
  }, [a, g]);
  const h = v.useMemo(() => ({
    register: f,
    unregister: p,
    subscribeMapChange: m,
    elementsRef: n,
    labelsRef: o,
    nextIndexRef: i
  }), [f, p, m, n, o, i]);
  return /* @__PURE__ */ x(Ku.Provider, {
    value: h,
    children: e
  });
}
function O4() {
  return /* @__PURE__ */ new Map();
}
function D4() {
  return /* @__PURE__ */ new Set();
}
function _4(t, e) {
  const n = t.compareDocumentPosition(e);
  return n & Node.DOCUMENT_POSITION_FOLLOWING || n & Node.DOCUMENT_POSITION_CONTAINED_BY ? -1 : n & Node.DOCUMENT_POSITION_PRECEDING || n & Node.DOCUMENT_POSITION_CONTAINS ? 1 : 0;
}
const qu = /* @__PURE__ */ v.createContext(void 0);
process.env.NODE_ENV !== "production" && (qu.displayName = "SelectPositionerContext");
function dh() {
  const t = v.useContext(qu);
  if (!t)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: SelectPositionerContext is missing. SelectPositioner parts must be placed within <Select.Positioner>." : Xe(59));
  return t;
}
function ma(t, e) {
  t && Object.assign(t.style, e);
}
const fh = {
  position: "relative",
  maxHeight: "100%",
  overflowX: "hidden",
  overflowY: "auto"
}, V4 = {
  position: "fixed"
}, ph = /* @__PURE__ */ v.forwardRef(function(e, n) {
  const {
    anchor: o,
    positionMethod: r = "absolute",
    className: s,
    render: i,
    side: a = "bottom",
    align: l = "center",
    sideOffset: c = 0,
    alignOffset: u = 0,
    collisionBoundary: d = "clipping-ancestors",
    collisionPadding: f,
    arrowPadding: p = 5,
    sticky: g = !1,
    disableAnchorTracking: m,
    alignItemWithTrigger: h = !0,
    collisionAvoidance: b = Xc,
    style: w,
    ...y
  } = e, {
    store: C,
    listRef: R,
    labelsRef: S,
    alignItemWithTriggerActiveRef: E,
    selectedItemTextRef: P,
    valuesRef: N,
    initialValueRef: I,
    popupRef: M,
    setValue: T
  } = So(), k = th(), D = fe(C, st.open), O = fe(C, st.mounted), V = fe(C, st.modal), _ = fe(C, st.value), A = fe(C, st.openMethod), F = fe(C, st.positionerElement), H = fe(C, st.triggerElement), Y = fe(C, st.isItemEqualToValue), B = fe(C, st.transitionStatus), U = v.useRef(null), q = v.useRef(null), [W, K] = v.useState(h), te = O && W && A !== "touch";
  !O && W !== h && K(h), xe(() => {
    O || (st.scrollUpArrowVisible(C.state) && C.set("scrollUpArrowVisible", !1), st.scrollDownArrowVisible(C.state) && C.set("scrollDownArrowVisible", !1));
  }, [C, O]), v.useImperativeHandle(E, () => te), Ha((te || V) && D, A === "touch", F, H);
  const z = Hr({
    anchor: o,
    floatingRootContext: k,
    positionMethod: r,
    mounted: O,
    side: a,
    sideOffset: c,
    align: l,
    alignOffset: u,
    arrowPadding: p,
    collisionBoundary: d,
    collisionPadding: f,
    sticky: g,
    disableAnchorTracking: m ?? te,
    collisionAvoidance: b,
    keepMounted: !0
  }), Q = te ? "none" : z.side, ee = te ? V4 : z.positionerStyles, ae = {
    open: D,
    side: Q,
    align: z.align,
    anchorHidden: z.anchorHidden
  }, X = ge((oe) => {
    C.set("positionerElement", oe);
  }), se = Br(e, ae, {
    styles: ee,
    transitionStatus: B,
    props: y,
    refs: [n, X],
    hidden: !O,
    inert: !D
  }), ue = v.useRef(0), re = ge((oe) => {
    if (oe.size === 0 && ue.current === 0 || N.current.length === 0)
      return;
    const me = ue.current;
    if (ue.current = oe.size, oe.size === me)
      return;
    const de = Pe(Et);
    if (me !== 0 && !C.state.multiple && _ !== null && vo(N.current, _, Y) === -1) {
      const $ = I.current, L = $ != null && vo(N.current, $, Y) !== -1 ? $ : null;
      T(L, de), L === null && (C.set("selectedIndex", null), P.current = null);
    }
    if (me !== 0 && C.state.multiple && Array.isArray(_)) {
      const he = (Z) => vo(N.current, Z, Y) !== -1, $ = _.filter((Z) => he(Z));
      ($.length !== _.length || $.some((Z) => !oh(_, Z, Y))) && (T($, de), $.length === 0 && (C.set("selectedIndex", null), P.current = null));
    }
    if (D && te) {
      C.update({
        scrollUpArrowVisible: !1,
        scrollDownArrowVisible: !1
      });
      const he = {
        height: ""
      };
      ma(F, he), ma(M.current, he);
    }
  }), ne = v.useMemo(() => ({
    ...z,
    side: Q,
    alignItemWithTriggerActive: te,
    setControlledAlignItemWithTrigger: K,
    scrollUpArrowRef: U,
    scrollDownArrowRef: q
  }), [z, Q, te, K]);
  return /* @__PURE__ */ x(Gr, {
    elementsRef: R,
    labelsRef: S,
    onMapChange: re,
    children: /* @__PURE__ */ j(qu.Provider, {
      value: ne,
      children: [O && V && /* @__PURE__ */ x(Wr, {
        inert: gr(!D),
        cutout: H
      }), se]
    })
  });
});
process.env.NODE_ENV !== "production" && (ph.displayName = "SelectPositioner");
const ki = "base-ui-disable-scrollbar", ha = {
  className: ki,
  getElement(t) {
    return /* @__PURE__ */ x("style", {
      nonce: t,
      href: ki,
      precedence: "base-ui:low",
      children: `.${ki}{scrollbar-width:none}.${ki}::-webkit-scrollbar{display:none}`
    });
  }
};
process.env.NODE_ENV !== "production" && (ha.getElement.displayName = "styleDisableScrollbar.getElement");
const gh = /* @__PURE__ */ v.createContext(void 0);
process.env.NODE_ENV !== "production" && (gh.displayName = "CSPContext");
const A4 = {
  disableStyleElements: !1
};
function F4() {
  return v.useContext(gh) ?? A4;
}
const L4 = {
  ...xn,
  ...Lt
}, mh = /* @__PURE__ */ v.forwardRef(function(e, n) {
  const {
    render: o,
    className: r,
    style: s,
    finalFocus: i,
    ...a
  } = e, {
    store: l,
    popupRef: c,
    onOpenChangeComplete: u,
    setOpen: d,
    valueRef: f,
    selectedItemTextRef: p,
    keyboardActiveRef: g,
    multiple: m,
    handleScrollArrowVisibility: h,
    scrollHandlerRef: b,
    listRef: w,
    highlightItemOnHover: y
  } = So(), {
    side: C,
    align: R,
    alignItemWithTriggerActive: S,
    isPositioned: E,
    setControlledAlignItemWithTrigger: P,
    scrollDownArrowRef: N,
    scrollUpArrowRef: I
  } = dh(), M = Lu() != null, T = th(), k = Ks(), {
    nonce: D,
    disableStyleElements: O
  } = F4(), V = fe(l, st.id), _ = fe(l, st.open), A = fe(l, st.mounted), F = fe(l, st.popupProps), H = fe(l, st.transitionStatus), Y = fe(l, st.triggerElement), B = fe(l, st.positionerElement), U = fe(l, st.listElement), q = v.useRef(!1), W = v.useRef(!1), K = v.useRef({}), te = Fr(), z = ge((X) => {
    if (!B || !c.current || !W.current)
      return;
    if (q.current || !S) {
      h();
      return;
    }
    const se = B.style.top === "0px", ue = B.style.bottom === "0px";
    if (!se && !ue) {
      h();
      return;
    }
    const re = $p(B), ne = fs(B.getBoundingClientRect().height, "y", re), oe = Ke(B), me = getComputedStyle(B), de = parseFloat(me.marginTop), he = parseFloat(me.marginBottom), $ = Lp(getComputedStyle(c.current)), Z = Math.min(oe.documentElement.clientHeight - de - he, $), L = X.scrollTop, G = Oi(X);
    let ie = 0, pe = null, be = !1, Re = !1;
    const _e = (Le) => {
      B.style.height = `${Le}px`;
    }, ke = (Le, Ze) => {
      const tt = $t(Le, 0, Z - ne);
      tt > 0 && _e(ne + tt), X.scrollTop = Ze, Z - (ne + tt) <= uo && (q.current = !0), h();
    }, Se = se ? G - L : L, Ie = Math.min(ne + Se, Z);
    if (ie = Ie, Se <= uo) {
      ke(Se, se ? G : 0);
      return;
    }
    if (Z - Ie > uo)
      se ? Re = !0 : pe = 0;
    else if (be = !0, ue && L < G) {
      const Le = ne + Se - Z;
      pe = L - (Se - Le);
    }
    if (ie = Math.ceil(ie), ie !== 0 && _e(ie), Re || pe != null) {
      const Le = Oi(X), Ze = Re ? Le : $t(pe, 0, Le);
      Math.abs(X.scrollTop - Ze) > uo && (X.scrollTop = Ze);
    }
    (be || ie >= Z - uo) && (q.current = !0), h();
  });
  v.useImperativeHandle(b, () => z, [z]), Bt({
    open: _,
    ref: c,
    onComplete() {
      _ && u?.(!0);
    }
  });
  const Q = {
    open: _,
    transitionStatus: H,
    side: C,
    align: R
  };
  xe(() => {
    !B || !c.current || Object.keys(K.current).length || (K.current = {
      top: B.style.top || "0",
      left: B.style.left || "0",
      right: B.style.right,
      height: B.style.height,
      bottom: B.style.bottom,
      minHeight: B.style.minHeight,
      maxHeight: B.style.maxHeight,
      marginTop: B.style.marginTop,
      marginBottom: B.style.marginBottom
    });
  }, [c, B]), xe(() => {
    _ || S || (W.current = !1, q.current = !1, ma(B, K.current));
  }, [_, S, B, c]), xe(() => {
    const X = c.current;
    if (!_ || !Y || !B || !X || S && !E || l.state.transitionStatus === "ending")
      return;
    if (!S) {
      W.current = !0, te.request(h), X.style.removeProperty("--transform-origin");
      return;
    }
    const se = $4(X);
    X.style.removeProperty("--transform-origin");
    try {
      const ue = p.current, re = f.current, ne = getComputedStyle(B), oe = getComputedStyle(X), me = Ke(Y), de = vt(B), he = $p(Y), $ = Di(Y.getBoundingClientRect(), he), Z = Di(B.getBoundingClientRect(), he), L = $.height, G = U || X, ie = G.scrollHeight, pe = parseFloat(oe.borderBottomWidth), be = parseFloat(ne.marginTop) || 10, Re = parseFloat(ne.marginBottom) || 10, _e = parseFloat(ne.minHeight) || 100, ke = Lp(oe), Se = 5, Ie = 5, Le = 20, Ze = me.documentElement.clientHeight - be - Re, tt = me.documentElement.clientWidth, ut = Ze - $.bottom + L;
      let at, $e = k === "rtl" ? $.right - Z.width : $.left, Ce = 0;
      if (ue && re) {
        const He = Di(re.getBoundingClientRect(), he);
        at = Di(ue.getBoundingClientRect(), he), $e = Z.left + (k === "rtl" ? He.right - at.right : He.left - at.left);
        const ct = He.top - $.top + He.height / 2;
        Ce = at.top - Z.top + at.height / 2 - ct;
      }
      const Oe = ut + Ce + Re + pe;
      let Ne = Math.min(Ze, Oe);
      const Be = Ze - be - Re, ze = Oe - Ne, Me = tt - Ie;
      B.style.left = `${$t($e, Se, Me - Z.width)}px`, B.style.height = `${Ne}px`, B.style.maxHeight = "auto", B.style.marginTop = `${be}px`, B.style.marginBottom = `${Re}px`, X.style.height = "100%";
      const Wt = Oi(G), ft = ze >= Wt - uo;
      ft && (Ne = Math.min(Ze, Z.height) - (ze - Wt));
      const ve = $.top < Le || $.bottom > Ze - Le || Math.ceil(Ne) + uo < Math.min(ie, _e), we = (de.visualViewport?.scale ?? 1) !== 1 && Hc;
      if (ve || we) {
        W.current = !0, ma(B, K.current), P(!1);
        return;
      }
      const Ve = Math.max(_e, Ne);
      if (ft) {
        const He = Math.max(0, Ze - Oe);
        B.style.top = Z.height >= Be ? "0" : `${He}px`, B.style.height = `${Ne}px`, G.scrollTop = Oi(G);
      } else
        B.style.bottom = "0", G.scrollTop = ze;
      if (at) {
        const He = Z.top, ct = Z.height, qe = at.top + at.height / 2, it = ct > 0 ? (qe - He) / ct * 100 : 50, Ue = $t(it, 0, 100);
        X.style.setProperty("--transform-origin", `50% ${Ue}%`);
      }
      (Ve === Ze || Ne >= ke) && (q.current = !0), h(), y && l.state.selectedIndex === null && l.state.activeIndex === null && w.current[0] != null && l.set("activeIndex", 0), W.current = !0;
    } finally {
      se();
    }
  }, [l, _, B, Y, f, p, c, h, S, P, te, N, I, U, w, y, k, E]), v.useEffect(() => {
    if (!S || !B || !_)
      return;
    const X = vt(B);
    function se(ue) {
      d(!1, Pe(Ay, ue));
    }
    return rt(X, "resize", se);
  }, [d, S, B, _]);
  const ee = {
    ...U ? {
      role: "presentation",
      "aria-orientation": void 0
    } : {
      role: "listbox",
      "aria-multiselectable": m || void 0,
      id: `${V}-list`
    },
    onKeyDown(X) {
      g.current = !0, M && Zs.has(X.key) && X.stopPropagation();
    },
    onMouseMove() {
      g.current = !1;
    },
    onScroll(X) {
      U || z(X.currentTarget);
    },
    ...S && {
      style: U ? {
        height: "100%"
      } : fh
    }
  }, ae = Te("div", e, {
    ref: [n, c],
    state: Q,
    stateAttributesMapping: L4,
    props: [F, ee, pr(H), {
      className: !U && S ? ha.className : void 0
    }, a]
  });
  return /* @__PURE__ */ j(v.Fragment, {
    children: [!O && ha.getElement(D), /* @__PURE__ */ x(zr, {
      context: T,
      modal: !1,
      disabled: !A,
      returnFocus: i,
      restoreFocus: !0,
      children: ae
    })]
  });
});
process.env.NODE_ENV !== "production" && (mh.displayName = "SelectPopup");
function Lp(t) {
  const e = t.maxHeight || "";
  return e.endsWith("px") && parseFloat(e) || 1 / 0;
}
function Oi(t) {
  return ah(t.scrollHeight, t.clientHeight);
}
function $p(t) {
  return s1.getScale(t);
}
function fs(t, e, n) {
  return t / n[e];
}
function Di(t, e) {
  return Cs({
    x: fs(t.x, "x", e),
    y: fs(t.y, "y", e),
    width: fs(t.width, "x", e),
    height: fs(t.height, "y", e)
  });
}
const zp = [["transform", "none"], ["scale", "1"], ["translate", "0 0"]];
function $4(t) {
  const {
    style: e
  } = t, n = {};
  for (const [o, r] of zp)
    n[o] = e.getPropertyValue(o), e.setProperty(o, r, "important");
  return () => {
    for (const [o] of zp) {
      const r = n[o];
      r ? e.setProperty(o, r) : e.removeProperty(o);
    }
  };
}
const hh = /* @__PURE__ */ v.forwardRef(function(e, n) {
  const {
    className: o,
    render: r,
    style: s,
    ...i
  } = e, {
    store: a,
    scrollHandlerRef: l
  } = So(), {
    alignItemWithTriggerActive: c
  } = dh(), u = fe(a, st.hasScrollArrows), d = fe(a, st.openMethod), f = fe(a, st.multiple), g = {
    id: `${fe(a, st.id)}-list`,
    role: "listbox",
    "aria-multiselectable": f || void 0,
    onScroll(h) {
      l.current?.(h.currentTarget);
    },
    ...c && {
      style: fh
    },
    className: u && d !== "touch" ? ha.className : void 0
  }, m = ge((h) => {
    a.set("listElement", h);
  });
  return Te("div", e, {
    ref: [n, m],
    props: [g, i]
  });
});
process.env.NODE_ENV !== "production" && (hh.displayName = "SelectList");
let Xu = /* @__PURE__ */ (function(t) {
  return t[t.None = 0] = "None", t[t.GuessFromOrder = 1] = "GuessFromOrder", t;
})({});
function Ro(t = {}) {
  const {
    label: e,
    metadata: n,
    textRef: o,
    indexGuessBehavior: r,
    index: s
  } = t, {
    register: i,
    unregister: a,
    subscribeMapChange: l,
    elementsRef: c,
    labelsRef: u,
    nextIndexRef: d
  } = k4(), f = v.useRef(-1), [p, g] = v.useState(s ?? (r === Xu.GuessFromOrder ? () => {
    if (f.current === -1) {
      const b = d.current;
      d.current += 1, f.current = b;
    }
    return f.current;
  } : -1)), m = v.useRef(null), h = v.useCallback((b) => {
    if (m.current = b, p !== -1 && b !== null && (c.current[p] = b, u)) {
      const w = e !== void 0;
      u.current[p] = w ? e : o?.current?.textContent ?? b.textContent;
    }
  }, [p, c, u, e, o]);
  return xe(() => {
    if (s != null)
      return;
    const b = m.current;
    if (b)
      return i(b, n), () => {
        a(b);
      };
  }, [s, i, a, n]), xe(() => {
    if (s == null)
      return l((b) => {
        const w = m.current ? b.get(m.current)?.index : null;
        w != null && g(w);
      });
  }, [s, l, g]), v.useMemo(() => ({
    ref: h,
    index: p
  }), [p, h]);
}
const Zu = /* @__PURE__ */ v.createContext(void 0);
process.env.NODE_ENV !== "production" && (Zu.displayName = "SelectItemContext");
function Qu() {
  const t = v.useContext(Zu);
  if (!t)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: SelectItemContext is missing. SelectItem parts must be placed within <Select.Item>." : Xe(57));
  return t;
}
const bh = /* @__PURE__ */ v.memo(/* @__PURE__ */ v.forwardRef(function(e, n) {
  const {
    render: o,
    className: r,
    value: s = null,
    label: i,
    disabled: a = !1,
    nativeButton: l = !1,
    style: c,
    ...u
  } = e, d = v.useRef(null), f = Ro({
    label: i,
    textRef: d,
    indexGuessBehavior: Xu.GuessFromOrder
  }), {
    store: p,
    getItemProps: g,
    setOpen: m,
    setValue: h,
    selectionRef: b,
    typingRef: w,
    valuesRef: y,
    multiple: C,
    selectedItemTextRef: R
  } = So(), S = fe(p, st.isActive, f.index), E = fe(p, st.isSelected, f.index, s), P = fe(p, st.isSelectedByFocus, f.index), N = fe(p, st.isItemEqualToValue), I = f.index, M = I !== -1, T = v.useRef(null), k = _t(I);
  xe(() => {
    if (!M)
      return;
    const W = y.current;
    return W[I] = s, () => {
      delete W[I];
    };
  }, [M, I, s, y]), xe(() => {
    if (!M)
      return;
    const W = p.state.value;
    let K = W;
    C && Array.isArray(W) && W.length > 0 && (K = W[W.length - 1]), K !== void 0 && so(s, K, N) && (p.set("selectedIndex", I), d.current && (R.current = d.current));
  }, [M, I, C, N, p, s, R]);
  const D = {
    disabled: a,
    selected: E,
    highlighted: S
  }, O = g({
    active: S,
    selected: E
  });
  O.id = void 0;
  const V = v.useRef(null), _ = v.useRef("mouse"), A = v.useRef(!1), {
    getButtonProps: F,
    buttonRef: H
  } = Ft({
    disabled: a,
    focusableWhenDisabled: !0,
    native: l,
    composite: !0
  });
  function Y(W) {
    const K = p.state.value;
    if (C) {
      const te = Array.isArray(K) ? K : [], z = E ? rh(te, s, N) : [...te, s];
      h(z, Pe(ko, W));
    } else
      h(s, Pe(ko, W)), m(!1, Pe(ko, W));
  }
  const B = {
    role: "option",
    "aria-selected": E,
    tabIndex: S ? 0 : -1,
    onTouchStart() {
      b.current = {
        allowSelectedMouseUp: !1,
        allowUnselectedMouseUp: !1
      };
    },
    onKeyDown(W) {
      V.current = W.key, p.set("activeIndex", I), W.key === " " && w.current && W.preventDefault();
    },
    onClick(W) {
      A.current = !1, !(W.type === "keydown" && V.current === null) && (a || W.type === "keydown" && V.current === " " && w.current || _.current !== "touch" && !S || (V.current = null, Y(W.nativeEvent)));
    },
    onPointerEnter(W) {
      _.current = W.pointerType;
    },
    onPointerDown(W) {
      _.current = W.pointerType, A.current = !0;
    },
    onMouseUp() {
      if (a)
        return;
      if (A.current) {
        A.current = !1;
        return;
      }
      const W = !b.current.allowSelectedMouseUp && E, K = !b.current.allowUnselectedMouseUp && !E;
      W || K || _.current !== "touch" && !S || T.current?.click();
    }
  }, U = Te("div", e, {
    ref: [H, n, f.ref, T],
    state: D,
    props: [O, B, u, F]
  }), q = v.useMemo(() => ({
    selected: E,
    indexRef: k,
    textRef: d,
    selectedByFocus: P,
    hasRegistered: M
  }), [E, k, d, P, M]);
  return /* @__PURE__ */ x(Zu.Provider, {
    value: q,
    children: U
  });
}));
process.env.NODE_ENV !== "production" && (bh.displayName = "SelectItem");
const vh = /* @__PURE__ */ v.forwardRef(function(e, n) {
  const o = e.keepMounted ?? !1, {
    selected: r
  } = Qu();
  return o || r ? /* @__PURE__ */ x(yh, {
    ...e,
    ref: n
  }) : null;
});
process.env.NODE_ENV !== "production" && (vh.displayName = "SelectItemIndicator");
const yh = /* @__PURE__ */ v.memo(/* @__PURE__ */ v.forwardRef((t, e) => {
  const {
    render: n,
    className: o,
    style: r,
    keepMounted: s,
    ...i
  } = t, {
    selected: a
  } = Qu(), l = v.useRef(null), {
    transitionStatus: c,
    setMounted: u
  } = Yn(a), f = Te("span", t, {
    ref: [e, l],
    state: {
      selected: a,
      transitionStatus: c
    },
    props: [{
      "aria-hidden": !0,
      children: "✔️"
    }, i],
    stateAttributesMapping: Lt
  });
  return Bt({
    open: a,
    ref: l,
    onComplete() {
      a || u(!1);
    }
  }), f;
}));
process.env.NODE_ENV !== "production" && (yh.displayName = "Inner");
const xh = /* @__PURE__ */ v.memo(/* @__PURE__ */ v.forwardRef(function(e, n) {
  const {
    indexRef: o,
    textRef: r,
    selectedByFocus: s,
    hasRegistered: i
  } = Qu(), {
    selectedItemTextRef: a
  } = So(), {
    className: l,
    render: c,
    style: u,
    ...d
  } = e, f = v.useCallback((g) => {
    if (!g || !i)
      return;
    const m = a.current === null || !a.current.isConnected;
    (s || m && o.current === 0) && (a.current = g);
  }, [a, o, s, i]);
  return Te("div", e, {
    ref: [f, n, r],
    props: d
  });
}));
process.env.NODE_ENV !== "production" && (xh.displayName = "SelectItemText");
function z4(t, e, n = "long") {
  return new Intl.DateTimeFormat("en-US", {
    // Enforces engine to render the time. Without the option JavaScriptCore omits it.
    hour: "numeric",
    timeZone: t,
    timeZoneName: n
  }).format(e).split(/\s/g).slice(2).join(" ");
}
const H4 = {}, ps = {};
function Zo(t, e) {
  try {
    const o = (H4[t] ||= new Intl.DateTimeFormat("en-US", {
      timeZone: t,
      timeZoneName: "longOffset"
    }).format)(e).split("GMT")[1];
    return o in ps ? ps[o] : Hp(o, o.split(":"));
  } catch {
    if (t in ps) return ps[t];
    const n = t?.match(B4);
    return n ? Hp(t, n.slice(1)) : NaN;
  }
}
const B4 = /([+-]\d\d):?(\d\d)?/;
function Hp(t, e) {
  const n = +(e[0] || 0), o = +(e[1] || 0), r = +(e[2] || 0) / 60;
  return ps[t] = n * 60 + o > 0 ? n * 60 + o + r : n * 60 - o - r;
}
class eo extends Date {
  //#region static
  constructor(...e) {
    super(), e.length > 1 && typeof e[e.length - 1] == "string" && (this.timeZone = e.pop()), this.internal = /* @__PURE__ */ new Date(), isNaN(Zo(this.timeZone, this)) ? this.setTime(NaN) : e.length ? typeof e[0] == "number" && (e.length === 1 || e.length === 2 && typeof e[1] != "number") ? this.setTime(e[0]) : typeof e[0] == "string" ? this.setTime(+new Date(e[0])) : e[0] instanceof Date ? this.setTime(+e[0]) : (this.setTime(+new Date(...e)), wh(this), wc(this)) : this.setTime(Date.now());
  }
  static tz(e, ...n) {
    return n.length ? new eo(...n, e) : new eo(Date.now(), e);
  }
  //#endregion
  //#region time zone
  withTimeZone(e) {
    return new eo(+this, e);
  }
  getTimezoneOffset() {
    const e = -Zo(this.timeZone, this);
    return e > 0 ? Math.floor(e) : Math.ceil(e);
  }
  //#endregion
  //#region time
  setTime(e) {
    return Date.prototype.setTime.apply(this, arguments), wc(this), +this;
  }
  //#endregion
  //#region date-fns integration
  [/* @__PURE__ */ Symbol.for("constructDateFrom")](e) {
    return new eo(+new Date(e), this.timeZone);
  }
  //#endregion
}
const Bp = /^(get|set)(?!UTC)/;
Object.getOwnPropertyNames(Date.prototype).forEach((t) => {
  if (!Bp.test(t)) return;
  const e = t.replace(Bp, "$1UTC");
  eo.prototype[e] && (t.startsWith("get") ? eo.prototype[t] = function() {
    return this.internal[e]();
  } : (eo.prototype[t] = function() {
    return Date.prototype[e].apply(this.internal, arguments), W4(this), +this;
  }, eo.prototype[e] = function() {
    return Date.prototype[e].apply(this, arguments), wc(this), +this;
  }));
});
function wc(t) {
  t.internal.setTime(+t), t.internal.setUTCSeconds(t.internal.getUTCSeconds() - Math.round(-Zo(t.timeZone, t) * 60));
}
function W4(t) {
  Date.prototype.setFullYear.call(t, t.internal.getUTCFullYear(), t.internal.getUTCMonth(), t.internal.getUTCDate()), Date.prototype.setHours.call(t, t.internal.getUTCHours(), t.internal.getUTCMinutes(), t.internal.getUTCSeconds(), t.internal.getUTCMilliseconds()), wh(t);
}
function wh(t) {
  const e = Zo(t.timeZone, t), n = e > 0 ? Math.floor(e) : Math.ceil(e), o = /* @__PURE__ */ new Date(+t);
  o.setUTCHours(o.getUTCHours() - 1);
  const r = -(/* @__PURE__ */ new Date(+t)).getTimezoneOffset(), s = -(/* @__PURE__ */ new Date(+o)).getTimezoneOffset(), i = r - s, a = Date.prototype.getHours.apply(t) !== t.internal.getUTCHours();
  i && a && t.internal.setUTCMinutes(t.internal.getUTCMinutes() + i);
  const l = r - n;
  l && Date.prototype.setUTCMinutes.call(t, Date.prototype.getUTCMinutes.call(t) + l);
  const c = /* @__PURE__ */ new Date(+t);
  c.setUTCSeconds(0);
  const u = r > 0 ? c.getSeconds() : (c.getSeconds() - 60) % 60, d = Math.round(-(Zo(t.timeZone, t) * 60)) % 60;
  (d || u) && (t.internal.setUTCSeconds(t.internal.getUTCSeconds() + d), Date.prototype.setUTCSeconds.call(t, Date.prototype.getUTCSeconds.call(t) + d + u));
  const f = Zo(t.timeZone, t), p = f > 0 ? Math.floor(f) : Math.ceil(f), m = -(/* @__PURE__ */ new Date(+t)).getTimezoneOffset() - p, h = p !== n, b = m - l;
  if (h && b) {
    Date.prototype.setUTCMinutes.call(t, Date.prototype.getUTCMinutes.call(t) + b);
    const w = Zo(t.timeZone, t), y = w > 0 ? Math.floor(w) : Math.ceil(w), C = p - y;
    C && (t.internal.setUTCMinutes(t.internal.getUTCMinutes() + C), Date.prototype.setUTCMinutes.call(t, Date.prototype.getUTCMinutes.call(t) + C));
  }
}
class en extends eo {
  //#region static
  static tz(e, ...n) {
    return n.length ? new en(...n, e) : new en(Date.now(), e);
  }
  //#endregion
  //#region representation
  toISOString() {
    const [e, n, o] = this.tzComponents(), r = `${e}${n}:${o}`;
    return this.internal.toISOString().slice(0, -1) + r;
  }
  toString() {
    return `${this.toDateString()} ${this.toTimeString()}`;
  }
  toDateString() {
    const [e, n, o, r] = this.internal.toUTCString().split(" ");
    return `${e?.slice(0, -1)} ${o} ${n} ${r}`;
  }
  toTimeString() {
    const e = this.internal.toUTCString().split(" ")[4], [n, o, r] = this.tzComponents();
    return `${e} GMT${n}${o}${r} (${z4(this.timeZone, this)})`;
  }
  toLocaleString(e, n) {
    return Date.prototype.toLocaleString.call(this, e, {
      ...n,
      timeZone: n?.timeZone || this.timeZone
    });
  }
  toLocaleDateString(e, n) {
    return Date.prototype.toLocaleDateString.call(this, e, {
      ...n,
      timeZone: n?.timeZone || this.timeZone
    });
  }
  toLocaleTimeString(e, n) {
    return Date.prototype.toLocaleTimeString.call(this, e, {
      ...n,
      timeZone: n?.timeZone || this.timeZone
    });
  }
  //#endregion
  //#region private
  tzComponents() {
    const e = this.getTimezoneOffset(), n = e > 0 ? "-" : "+", o = String(Math.floor(Math.abs(e) / 60)).padStart(2, "0"), r = String(Math.abs(e) % 60).padStart(2, "0");
    return [n, o, r];
  }
  //#endregion
  withTimeZone(e) {
    return new en(+this, e);
  }
  //#region date-fns integration
  [/* @__PURE__ */ Symbol.for("constructDateFrom")](e) {
    return new en(+new Date(e), this.timeZone);
  }
  //#endregion
}
const Ch = 6048e5, U4 = 864e5, Wp = /* @__PURE__ */ Symbol.for("constructDateFrom");
function Ht(t, e) {
  return typeof t == "function" ? t(e) : t && typeof t == "object" && Wp in t ? t[Wp](e) : t instanceof Date ? new t.constructor(e) : new Date(e);
}
function Rt(t, e) {
  return Ht(e || t, t);
}
function Sh(t, e, n) {
  const o = Rt(t, n?.in);
  return isNaN(e) ? Ht(t, NaN) : (e && o.setDate(o.getDate() + e), o);
}
function Rh(t, e, n) {
  const o = Rt(t, n?.in);
  if (isNaN(e)) return Ht(t, NaN);
  if (!e)
    return o;
  const r = o.getDate(), s = Ht(t, o.getTime());
  s.setMonth(o.getMonth() + e + 1, 0);
  const i = s.getDate();
  return r >= i ? s : (o.setFullYear(
    s.getFullYear(),
    s.getMonth(),
    r
  ), o);
}
let Y4 = {};
function ni() {
  return Y4;
}
function _r(t, e) {
  const n = ni(), o = e?.weekStartsOn ?? e?.locale?.options?.weekStartsOn ?? n.weekStartsOn ?? n.locale?.options?.weekStartsOn ?? 0, r = Rt(t, e?.in), s = r.getDay(), i = (s < o ? 7 : 0) + s - o;
  return r.setDate(r.getDate() - i), r.setHours(0, 0, 0, 0), r;
}
function Ts(t, e) {
  return _r(t, { ...e, weekStartsOn: 1 });
}
function Eh(t, e) {
  const n = Rt(t, e?.in), o = n.getFullYear(), r = Ht(n, 0);
  r.setFullYear(o + 1, 0, 4), r.setHours(0, 0, 0, 0);
  const s = Ts(r), i = Ht(n, 0);
  i.setFullYear(o, 0, 4), i.setHours(0, 0, 0, 0);
  const a = Ts(i);
  return n.getTime() >= s.getTime() ? o + 1 : n.getTime() >= a.getTime() ? o : o - 1;
}
function Up(t) {
  const e = Rt(t), n = new Date(
    Date.UTC(
      e.getFullYear(),
      e.getMonth(),
      e.getDate(),
      e.getHours(),
      e.getMinutes(),
      e.getSeconds(),
      e.getMilliseconds()
    )
  );
  return n.setUTCFullYear(e.getFullYear()), +t - +n;
}
function jr(t, ...e) {
  const n = Ht.bind(
    null,
    e.find((o) => typeof o == "object")
  );
  return e.map(n);
}
function ks(t, e) {
  const n = Rt(t, e?.in);
  return n.setHours(0, 0, 0, 0), n;
}
function Ju(t, e, n) {
  const [o, r] = jr(
    n?.in,
    t,
    e
  ), s = ks(o), i = ks(r), a = +s - Up(s), l = +i - Up(i);
  return Math.round((a - l) / U4);
}
function G4(t, e) {
  const n = Eh(t, e), o = Ht(t, 0);
  return o.setFullYear(n, 0, 4), o.setHours(0, 0, 0, 0), Ts(o);
}
function j4(t, e, n) {
  return Sh(t, e * 7, n);
}
function K4(t, e, n) {
  return Rh(t, e * 12, n);
}
function q4(t, e) {
  let n, o = e?.in;
  return t.forEach((r) => {
    !o && typeof r == "object" && (o = Ht.bind(null, r));
    const s = Rt(r, o);
    (!n || n < s || isNaN(+s)) && (n = s);
  }), Ht(o, n || NaN);
}
function X4(t, e) {
  let n, o = e?.in;
  return t.forEach((r) => {
    !o && typeof r == "object" && (o = Ht.bind(null, r));
    const s = Rt(r, o);
    (!n || n > s || isNaN(+s)) && (n = s);
  }), Ht(o, n || NaN);
}
function Z4(t, e, n) {
  const [o, r] = jr(
    n?.in,
    t,
    e
  );
  return +ks(o) == +ks(r);
}
function Ph(t) {
  return t instanceof Date || typeof t == "object" && Object.prototype.toString.call(t) === "[object Date]";
}
function Q4(t) {
  return !(!Ph(t) && typeof t != "number" || isNaN(+Rt(t)));
}
function Nh(t, e, n) {
  const [o, r] = jr(
    n?.in,
    t,
    e
  ), s = o.getFullYear() - r.getFullYear(), i = o.getMonth() - r.getMonth();
  return s * 12 + i;
}
function J4(t, e) {
  const n = Rt(t, e?.in), o = n.getMonth();
  return n.setFullYear(n.getFullYear(), o + 1, 0), n.setHours(23, 59, 59, 999), n;
}
function Ih(t, e) {
  const [n, o] = jr(t, e.start, e.end);
  return { start: n, end: o };
}
function eS(t, e) {
  const { start: n, end: o } = Ih(e?.in, t);
  let r = +n > +o;
  const s = r ? +n : +o, i = r ? o : n;
  i.setHours(0, 0, 0, 0), i.setDate(1);
  let a = 1;
  const l = [];
  for (; +i <= s; )
    l.push(Ht(n, i)), i.setMonth(i.getMonth() + a);
  return r ? l.reverse() : l;
}
function tS(t, e) {
  const n = Rt(t, e?.in);
  return n.setDate(1), n.setHours(0, 0, 0, 0), n;
}
function nS(t, e) {
  const n = Rt(t, e?.in), o = n.getFullYear();
  return n.setFullYear(o + 1, 0, 0), n.setHours(23, 59, 59, 999), n;
}
function Mh(t, e) {
  const n = Rt(t, e?.in);
  return n.setFullYear(n.getFullYear(), 0, 1), n.setHours(0, 0, 0, 0), n;
}
function oS(t, e) {
  const { start: n, end: o } = Ih(e?.in, t);
  let r = +n > +o;
  const s = r ? +n : +o, i = r ? o : n;
  i.setHours(0, 0, 0, 0), i.setMonth(0, 1);
  let a = 1;
  const l = [];
  for (; +i <= s; )
    l.push(Ht(n, i)), i.setFullYear(i.getFullYear() + a);
  return r ? l.reverse() : l;
}
function Th(t, e) {
  const n = ni(), o = e?.weekStartsOn ?? e?.locale?.options?.weekStartsOn ?? n.weekStartsOn ?? n.locale?.options?.weekStartsOn ?? 0, r = Rt(t, e?.in), s = r.getDay(), i = (s < o ? -7 : 0) + 6 - (s - o);
  return r.setDate(r.getDate() + i), r.setHours(23, 59, 59, 999), r;
}
function rS(t, e) {
  return Th(t, { ...e, weekStartsOn: 1 });
}
const sS = {
  lessThanXSeconds: {
    one: "less than a second",
    other: "less than {{count}} seconds"
  },
  xSeconds: {
    one: "1 second",
    other: "{{count}} seconds"
  },
  halfAMinute: "half a minute",
  lessThanXMinutes: {
    one: "less than a minute",
    other: "less than {{count}} minutes"
  },
  xMinutes: {
    one: "1 minute",
    other: "{{count}} minutes"
  },
  aboutXHours: {
    one: "about 1 hour",
    other: "about {{count}} hours"
  },
  xHours: {
    one: "1 hour",
    other: "{{count}} hours"
  },
  xDays: {
    one: "1 day",
    other: "{{count}} days"
  },
  aboutXWeeks: {
    one: "about 1 week",
    other: "about {{count}} weeks"
  },
  xWeeks: {
    one: "1 week",
    other: "{{count}} weeks"
  },
  aboutXMonths: {
    one: "about 1 month",
    other: "about {{count}} months"
  },
  xMonths: {
    one: "1 month",
    other: "{{count}} months"
  },
  aboutXYears: {
    one: "about 1 year",
    other: "about {{count}} years"
  },
  xYears: {
    one: "1 year",
    other: "{{count}} years"
  },
  overXYears: {
    one: "over 1 year",
    other: "over {{count}} years"
  },
  almostXYears: {
    one: "almost 1 year",
    other: "almost {{count}} years"
  }
}, iS = (t, e, n) => {
  let o;
  const r = sS[t];
  return typeof r == "string" ? o = r : e === 1 ? o = r.one : o = r.other.replace("{{count}}", e.toString()), n?.addSuffix ? n.comparison && n.comparison > 0 ? "in " + o : o + " ago" : o;
};
function _l(t) {
  return (e = {}) => {
    const n = e.width ? String(e.width) : t.defaultWidth;
    return t.formats[n] || t.formats[t.defaultWidth];
  };
}
const aS = {
  full: "EEEE, MMMM do, y",
  long: "MMMM do, y",
  medium: "MMM d, y",
  short: "MM/dd/yyyy"
}, lS = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a"
}, cS = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, uS = {
  date: _l({
    formats: aS,
    defaultWidth: "full"
  }),
  time: _l({
    formats: lS,
    defaultWidth: "full"
  }),
  dateTime: _l({
    formats: cS,
    defaultWidth: "full"
  })
}, dS = {
  lastWeek: "'last' eeee 'at' p",
  yesterday: "'yesterday at' p",
  today: "'today at' p",
  tomorrow: "'tomorrow at' p",
  nextWeek: "eeee 'at' p",
  other: "P"
}, fS = (t, e, n, o) => dS[t];
function rs(t) {
  return (e, n) => {
    const o = n?.context ? String(n.context) : "standalone";
    let r;
    if (o === "formatting" && t.formattingValues) {
      const i = t.defaultFormattingWidth || t.defaultWidth, a = n?.width ? String(n.width) : i;
      r = t.formattingValues[a] || t.formattingValues[i];
    } else {
      const i = t.defaultWidth, a = n?.width ? String(n.width) : t.defaultWidth;
      r = t.values[a] || t.values[i];
    }
    const s = t.argumentCallback ? t.argumentCallback(e) : e;
    return r[s];
  };
}
const pS = {
  narrow: ["B", "A"],
  abbreviated: ["BC", "AD"],
  wide: ["Before Christ", "Anno Domini"]
}, gS = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1st quarter", "2nd quarter", "3rd quarter", "4th quarter"]
}, mS = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
  ],
  wide: [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December"
  ]
}, hS = {
  narrow: ["S", "M", "T", "W", "T", "F", "S"],
  short: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
  abbreviated: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  wide: [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday"
  ]
}, bS = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  }
}, vS = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  }
}, yS = (t, e) => {
  const n = Number(t), o = n % 100;
  if (o > 20 || o < 10)
    switch (o % 10) {
      case 1:
        return n + "st";
      case 2:
        return n + "nd";
      case 3:
        return n + "rd";
    }
  return n + "th";
}, xS = {
  ordinalNumber: yS,
  era: rs({
    values: pS,
    defaultWidth: "wide"
  }),
  quarter: rs({
    values: gS,
    defaultWidth: "wide",
    argumentCallback: (t) => t - 1
  }),
  month: rs({
    values: mS,
    defaultWidth: "wide"
  }),
  day: rs({
    values: hS,
    defaultWidth: "wide"
  }),
  dayPeriod: rs({
    values: bS,
    defaultWidth: "wide",
    formattingValues: vS,
    defaultFormattingWidth: "wide"
  })
};
function ss(t) {
  return (e, n = {}) => {
    const o = n.width, r = o && t.matchPatterns[o] || t.matchPatterns[t.defaultMatchWidth], s = e.match(r);
    if (!s)
      return null;
    const i = s[0], a = o && t.parsePatterns[o] || t.parsePatterns[t.defaultParseWidth], l = Array.isArray(a) ? CS(a, (d) => d.test(i)) : (
      // [TODO] -- I challenge you to fix the type
      wS(a, (d) => d.test(i))
    );
    let c;
    c = t.valueCallback ? t.valueCallback(l) : l, c = n.valueCallback ? (
      // [TODO] -- I challenge you to fix the type
      n.valueCallback(c)
    ) : c;
    const u = e.slice(i.length);
    return { value: c, rest: u };
  };
}
function wS(t, e) {
  for (const n in t)
    if (Object.prototype.hasOwnProperty.call(t, n) && e(t[n]))
      return n;
}
function CS(t, e) {
  for (let n = 0; n < t.length; n++)
    if (e(t[n]))
      return n;
}
function SS(t) {
  return (e, n = {}) => {
    const o = e.match(t.matchPattern);
    if (!o) return null;
    const r = o[0], s = e.match(t.parsePattern);
    if (!s) return null;
    let i = t.valueCallback ? t.valueCallback(s[0]) : s[0];
    i = n.valueCallback ? n.valueCallback(i) : i;
    const a = e.slice(r.length);
    return { value: i, rest: a };
  };
}
const RS = /^(\d+)(th|st|nd|rd)?/i, ES = /\d+/i, PS = {
  narrow: /^(b|a)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(before christ|before common era|anno domini|common era)/i
}, NS = {
  any: [/^b/i, /^(a|c)/i]
}, IS = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](th|st|nd|rd)? quarter/i
}, MS = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, TS = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
}, kS = {
  narrow: [
    /^j/i,
    /^f/i,
    /^m/i,
    /^a/i,
    /^m/i,
    /^j/i,
    /^j/i,
    /^a/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ],
  any: [
    /^ja/i,
    /^f/i,
    /^mar/i,
    /^ap/i,
    /^may/i,
    /^jun/i,
    /^jul/i,
    /^au/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ]
}, OS = {
  narrow: /^[smtwf]/i,
  short: /^(su|mo|tu|we|th|fr|sa)/i,
  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
}, DS = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
}, _S = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
}, VS = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i
  }
}, AS = {
  ordinalNumber: SS({
    matchPattern: RS,
    parsePattern: ES,
    valueCallback: (t) => parseInt(t, 10)
  }),
  era: ss({
    matchPatterns: PS,
    defaultMatchWidth: "wide",
    parsePatterns: NS,
    defaultParseWidth: "any"
  }),
  quarter: ss({
    matchPatterns: IS,
    defaultMatchWidth: "wide",
    parsePatterns: MS,
    defaultParseWidth: "any",
    valueCallback: (t) => t + 1
  }),
  month: ss({
    matchPatterns: TS,
    defaultMatchWidth: "wide",
    parsePatterns: kS,
    defaultParseWidth: "any"
  }),
  day: ss({
    matchPatterns: OS,
    defaultMatchWidth: "wide",
    parsePatterns: DS,
    defaultParseWidth: "any"
  }),
  dayPeriod: ss({
    matchPatterns: _S,
    defaultMatchWidth: "any",
    parsePatterns: VS,
    defaultParseWidth: "any"
  })
}, xr = {
  code: "en-US",
  formatDistance: iS,
  formatLong: uS,
  formatRelative: fS,
  localize: xS,
  match: AS,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
};
function FS(t, e) {
  const n = Rt(t, e?.in);
  return Ju(n, Mh(n)) + 1;
}
function ed(t, e) {
  const n = Rt(t, e?.in), o = +Ts(n) - +G4(n);
  return Math.round(o / Ch) + 1;
}
function kh(t, e) {
  const n = Rt(t, e?.in), o = n.getFullYear(), r = ni(), s = e?.firstWeekContainsDate ?? e?.locale?.options?.firstWeekContainsDate ?? r.firstWeekContainsDate ?? r.locale?.options?.firstWeekContainsDate ?? 1, i = Ht(e?.in || t, 0);
  i.setFullYear(o + 1, 0, s), i.setHours(0, 0, 0, 0);
  const a = _r(i, e), l = Ht(e?.in || t, 0);
  l.setFullYear(o, 0, s), l.setHours(0, 0, 0, 0);
  const c = _r(l, e);
  return +n >= +a ? o + 1 : +n >= +c ? o : o - 1;
}
function LS(t, e) {
  const n = ni(), o = e?.firstWeekContainsDate ?? e?.locale?.options?.firstWeekContainsDate ?? n.firstWeekContainsDate ?? n.locale?.options?.firstWeekContainsDate ?? 1, r = kh(t, e), s = Ht(e?.in || t, 0);
  return s.setFullYear(r, 0, o), s.setHours(0, 0, 0, 0), _r(s, e);
}
function td(t, e) {
  const n = Rt(t, e?.in), o = +_r(n, e) - +LS(n, e);
  return Math.round(o / Ch) + 1;
}
function xt(t, e) {
  const n = t < 0 ? "-" : "", o = Math.abs(t).toString().padStart(e, "0");
  return n + o;
}
const Po = {
  // Year
  y(t, e) {
    const n = t.getFullYear(), o = n > 0 ? n : 1 - n;
    return xt(e === "yy" ? o % 100 : o, e.length);
  },
  // Month
  M(t, e) {
    const n = t.getMonth();
    return e === "M" ? String(n + 1) : xt(n + 1, 2);
  },
  // Day of the month
  d(t, e) {
    return xt(t.getDate(), e.length);
  },
  // AM or PM
  a(t, e) {
    const n = t.getHours() / 12 >= 1 ? "pm" : "am";
    switch (e) {
      case "a":
      case "aa":
        return n.toUpperCase();
      case "aaa":
        return n;
      case "aaaaa":
        return n[0];
      default:
        return n === "am" ? "a.m." : "p.m.";
    }
  },
  // Hour [1-12]
  h(t, e) {
    return xt(t.getHours() % 12 || 12, e.length);
  },
  // Hour [0-23]
  H(t, e) {
    return xt(t.getHours(), e.length);
  },
  // Minute
  m(t, e) {
    return xt(t.getMinutes(), e.length);
  },
  // Second
  s(t, e) {
    return xt(t.getSeconds(), e.length);
  },
  // Fraction of second
  S(t, e) {
    const n = e.length, o = t.getMilliseconds(), r = Math.trunc(
      o * Math.pow(10, n - 3)
    );
    return xt(r, e.length);
  }
}, vr = {
  midnight: "midnight",
  noon: "noon",
  morning: "morning",
  afternoon: "afternoon",
  evening: "evening",
  night: "night"
}, Yp = {
  // Era
  G: function(t, e, n) {
    const o = t.getFullYear() > 0 ? 1 : 0;
    switch (e) {
      // AD, BC
      case "G":
      case "GG":
      case "GGG":
        return n.era(o, { width: "abbreviated" });
      // A, B
      case "GGGGG":
        return n.era(o, { width: "narrow" });
      default:
        return n.era(o, { width: "wide" });
    }
  },
  // Year
  y: function(t, e, n) {
    if (e === "yo") {
      const o = t.getFullYear(), r = o > 0 ? o : 1 - o;
      return n.ordinalNumber(r, { unit: "year" });
    }
    return Po.y(t, e);
  },
  // Local week-numbering year
  Y: function(t, e, n, o) {
    const r = kh(t, o), s = r > 0 ? r : 1 - r;
    if (e === "YY") {
      const i = s % 100;
      return xt(i, 2);
    }
    return e === "Yo" ? n.ordinalNumber(s, { unit: "year" }) : xt(s, e.length);
  },
  // ISO week-numbering year
  R: function(t, e) {
    const n = Eh(t);
    return xt(n, e.length);
  },
  // Extended year. This is a single number designating the year of this calendar system.
  // The main difference between `y` and `u` localizers are B.C. years:
  // | Year | `y` | `u` |
  // |------|-----|-----|
  // | AC 1 |   1 |   1 |
  // | BC 1 |   1 |   0 |
  // | BC 2 |   2 |  -1 |
  // Also `yy` always returns the last two digits of a year,
  // while `uu` pads single digit years to 2 characters and returns other years unchanged.
  u: function(t, e) {
    const n = t.getFullYear();
    return xt(n, e.length);
  },
  // Quarter
  Q: function(t, e, n) {
    const o = Math.ceil((t.getMonth() + 1) / 3);
    switch (e) {
      // 1, 2, 3, 4
      case "Q":
        return String(o);
      // 01, 02, 03, 04
      case "QQ":
        return xt(o, 2);
      // 1st, 2nd, 3rd, 4th
      case "Qo":
        return n.ordinalNumber(o, { unit: "quarter" });
      // Q1, Q2, Q3, Q4
      case "QQQ":
        return n.quarter(o, {
          width: "abbreviated",
          context: "formatting"
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)
      case "QQQQQ":
        return n.quarter(o, {
          width: "narrow",
          context: "formatting"
        });
      default:
        return n.quarter(o, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone quarter
  q: function(t, e, n) {
    const o = Math.ceil((t.getMonth() + 1) / 3);
    switch (e) {
      // 1, 2, 3, 4
      case "q":
        return String(o);
      // 01, 02, 03, 04
      case "qq":
        return xt(o, 2);
      // 1st, 2nd, 3rd, 4th
      case "qo":
        return n.ordinalNumber(o, { unit: "quarter" });
      // Q1, Q2, Q3, Q4
      case "qqq":
        return n.quarter(o, {
          width: "abbreviated",
          context: "standalone"
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)
      case "qqqqq":
        return n.quarter(o, {
          width: "narrow",
          context: "standalone"
        });
      default:
        return n.quarter(o, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // Month
  M: function(t, e, n) {
    const o = t.getMonth();
    switch (e) {
      case "M":
      case "MM":
        return Po.M(t, e);
      // 1st, 2nd, ..., 12th
      case "Mo":
        return n.ordinalNumber(o + 1, { unit: "month" });
      // Jan, Feb, ..., Dec
      case "MMM":
        return n.month(o, {
          width: "abbreviated",
          context: "formatting"
        });
      // J, F, ..., D
      case "MMMMM":
        return n.month(o, {
          width: "narrow",
          context: "formatting"
        });
      default:
        return n.month(o, { width: "wide", context: "formatting" });
    }
  },
  // Stand-alone month
  L: function(t, e, n) {
    const o = t.getMonth();
    switch (e) {
      // 1, 2, ..., 12
      case "L":
        return String(o + 1);
      // 01, 02, ..., 12
      case "LL":
        return xt(o + 1, 2);
      // 1st, 2nd, ..., 12th
      case "Lo":
        return n.ordinalNumber(o + 1, { unit: "month" });
      // Jan, Feb, ..., Dec
      case "LLL":
        return n.month(o, {
          width: "abbreviated",
          context: "standalone"
        });
      // J, F, ..., D
      case "LLLLL":
        return n.month(o, {
          width: "narrow",
          context: "standalone"
        });
      default:
        return n.month(o, { width: "wide", context: "standalone" });
    }
  },
  // Local week of year
  w: function(t, e, n, o) {
    const r = td(t, o);
    return e === "wo" ? n.ordinalNumber(r, { unit: "week" }) : xt(r, e.length);
  },
  // ISO week of year
  I: function(t, e, n) {
    const o = ed(t);
    return e === "Io" ? n.ordinalNumber(o, { unit: "week" }) : xt(o, e.length);
  },
  // Day of the month
  d: function(t, e, n) {
    return e === "do" ? n.ordinalNumber(t.getDate(), { unit: "date" }) : Po.d(t, e);
  },
  // Day of year
  D: function(t, e, n) {
    const o = FS(t);
    return e === "Do" ? n.ordinalNumber(o, { unit: "dayOfYear" }) : xt(o, e.length);
  },
  // Day of week
  E: function(t, e, n) {
    const o = t.getDay();
    switch (e) {
      // Tue
      case "E":
      case "EE":
      case "EEE":
        return n.day(o, {
          width: "abbreviated",
          context: "formatting"
        });
      // T
      case "EEEEE":
        return n.day(o, {
          width: "narrow",
          context: "formatting"
        });
      // Tu
      case "EEEEEE":
        return n.day(o, {
          width: "short",
          context: "formatting"
        });
      default:
        return n.day(o, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Local day of week
  e: function(t, e, n, o) {
    const r = t.getDay(), s = (r - o.weekStartsOn + 8) % 7 || 7;
    switch (e) {
      // Numerical value (Nth day of week with current locale or weekStartsOn)
      case "e":
        return String(s);
      // Padded numerical value
      case "ee":
        return xt(s, 2);
      // 1st, 2nd, ..., 7th
      case "eo":
        return n.ordinalNumber(s, { unit: "day" });
      case "eee":
        return n.day(r, {
          width: "abbreviated",
          context: "formatting"
        });
      // T
      case "eeeee":
        return n.day(r, {
          width: "narrow",
          context: "formatting"
        });
      // Tu
      case "eeeeee":
        return n.day(r, {
          width: "short",
          context: "formatting"
        });
      default:
        return n.day(r, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone local day of week
  c: function(t, e, n, o) {
    const r = t.getDay(), s = (r - o.weekStartsOn + 8) % 7 || 7;
    switch (e) {
      // Numerical value (same as in `e`)
      case "c":
        return String(s);
      // Padded numerical value
      case "cc":
        return xt(s, e.length);
      // 1st, 2nd, ..., 7th
      case "co":
        return n.ordinalNumber(s, { unit: "day" });
      case "ccc":
        return n.day(r, {
          width: "abbreviated",
          context: "standalone"
        });
      // T
      case "ccccc":
        return n.day(r, {
          width: "narrow",
          context: "standalone"
        });
      // Tu
      case "cccccc":
        return n.day(r, {
          width: "short",
          context: "standalone"
        });
      default:
        return n.day(r, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // ISO day of week
  i: function(t, e, n) {
    const o = t.getDay(), r = o === 0 ? 7 : o;
    switch (e) {
      // 2
      case "i":
        return String(r);
      // 02
      case "ii":
        return xt(r, e.length);
      // 2nd
      case "io":
        return n.ordinalNumber(r, { unit: "day" });
      // Tue
      case "iii":
        return n.day(o, {
          width: "abbreviated",
          context: "formatting"
        });
      // T
      case "iiiii":
        return n.day(o, {
          width: "narrow",
          context: "formatting"
        });
      // Tu
      case "iiiiii":
        return n.day(o, {
          width: "short",
          context: "formatting"
        });
      default:
        return n.day(o, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM or PM
  a: function(t, e, n) {
    const r = t.getHours() / 12 >= 1 ? "pm" : "am";
    switch (e) {
      case "a":
      case "aa":
        return n.dayPeriod(r, {
          width: "abbreviated",
          context: "formatting"
        });
      case "aaa":
        return n.dayPeriod(r, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "aaaaa":
        return n.dayPeriod(r, {
          width: "narrow",
          context: "formatting"
        });
      default:
        return n.dayPeriod(r, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM, PM, midnight, noon
  b: function(t, e, n) {
    const o = t.getHours();
    let r;
    switch (o === 12 ? r = vr.noon : o === 0 ? r = vr.midnight : r = o / 12 >= 1 ? "pm" : "am", e) {
      case "b":
      case "bb":
        return n.dayPeriod(r, {
          width: "abbreviated",
          context: "formatting"
        });
      case "bbb":
        return n.dayPeriod(r, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "bbbbb":
        return n.dayPeriod(r, {
          width: "narrow",
          context: "formatting"
        });
      default:
        return n.dayPeriod(r, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // in the morning, in the afternoon, in the evening, at night
  B: function(t, e, n) {
    const o = t.getHours();
    let r;
    switch (o >= 17 ? r = vr.evening : o >= 12 ? r = vr.afternoon : o >= 4 ? r = vr.morning : r = vr.night, e) {
      case "B":
      case "BB":
      case "BBB":
        return n.dayPeriod(r, {
          width: "abbreviated",
          context: "formatting"
        });
      case "BBBBB":
        return n.dayPeriod(r, {
          width: "narrow",
          context: "formatting"
        });
      default:
        return n.dayPeriod(r, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Hour [1-12]
  h: function(t, e, n) {
    if (e === "ho") {
      let o = t.getHours() % 12;
      return o === 0 && (o = 12), n.ordinalNumber(o, { unit: "hour" });
    }
    return Po.h(t, e);
  },
  // Hour [0-23]
  H: function(t, e, n) {
    return e === "Ho" ? n.ordinalNumber(t.getHours(), { unit: "hour" }) : Po.H(t, e);
  },
  // Hour [0-11]
  K: function(t, e, n) {
    const o = t.getHours() % 12;
    return e === "Ko" ? n.ordinalNumber(o, { unit: "hour" }) : xt(o, e.length);
  },
  // Hour [1-24]
  k: function(t, e, n) {
    let o = t.getHours();
    return o === 0 && (o = 24), e === "ko" ? n.ordinalNumber(o, { unit: "hour" }) : xt(o, e.length);
  },
  // Minute
  m: function(t, e, n) {
    return e === "mo" ? n.ordinalNumber(t.getMinutes(), { unit: "minute" }) : Po.m(t, e);
  },
  // Second
  s: function(t, e, n) {
    return e === "so" ? n.ordinalNumber(t.getSeconds(), { unit: "second" }) : Po.s(t, e);
  },
  // Fraction of second
  S: function(t, e) {
    return Po.S(t, e);
  },
  // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
  X: function(t, e, n) {
    const o = t.getTimezoneOffset();
    if (o === 0)
      return "Z";
    switch (e) {
      // Hours and optional minutes
      case "X":
        return jp(o);
      // Hours, minutes and optional seconds without `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `XX`
      case "XXXX":
      case "XX":
        return Ko(o);
      // Hours and minutes with `:` delimiter
      default:
        return Ko(o, ":");
    }
  },
  // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
  x: function(t, e, n) {
    const o = t.getTimezoneOffset();
    switch (e) {
      // Hours and optional minutes
      case "x":
        return jp(o);
      // Hours, minutes and optional seconds without `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `xx`
      case "xxxx":
      case "xx":
        return Ko(o);
      // Hours and minutes with `:` delimiter
      default:
        return Ko(o, ":");
    }
  },
  // Timezone (GMT)
  O: function(t, e, n) {
    const o = t.getTimezoneOffset();
    switch (e) {
      // Short
      case "O":
      case "OO":
      case "OOO":
        return "GMT" + Gp(o, ":");
      default:
        return "GMT" + Ko(o, ":");
    }
  },
  // Timezone (specific non-location)
  z: function(t, e, n) {
    const o = t.getTimezoneOffset();
    switch (e) {
      // Short
      case "z":
      case "zz":
      case "zzz":
        return "GMT" + Gp(o, ":");
      default:
        return "GMT" + Ko(o, ":");
    }
  },
  // Seconds timestamp
  t: function(t, e, n) {
    const o = Math.trunc(+t / 1e3);
    return xt(o, e.length);
  },
  // Milliseconds timestamp
  T: function(t, e, n) {
    return xt(+t, e.length);
  }
};
function Gp(t, e = "") {
  const n = t > 0 ? "-" : "+", o = Math.abs(t), r = Math.trunc(o / 60), s = o % 60;
  return s === 0 ? n + String(r) : n + String(r) + e + xt(s, 2);
}
function jp(t, e) {
  return t % 60 === 0 ? (t > 0 ? "-" : "+") + xt(Math.abs(t) / 60, 2) : Ko(t, e);
}
function Ko(t, e = "") {
  const n = t > 0 ? "-" : "+", o = Math.abs(t), r = xt(Math.trunc(o / 60), 2), s = xt(o % 60, 2);
  return n + r + e + s;
}
const Kp = (t, e) => {
  switch (t) {
    case "P":
      return e.date({ width: "short" });
    case "PP":
      return e.date({ width: "medium" });
    case "PPP":
      return e.date({ width: "long" });
    default:
      return e.date({ width: "full" });
  }
}, Oh = (t, e) => {
  switch (t) {
    case "p":
      return e.time({ width: "short" });
    case "pp":
      return e.time({ width: "medium" });
    case "ppp":
      return e.time({ width: "long" });
    default:
      return e.time({ width: "full" });
  }
}, $S = (t, e) => {
  const n = t.match(/(P+)(p+)?/) || [], o = n[1], r = n[2];
  if (!r)
    return Kp(t, e);
  let s;
  switch (o) {
    case "P":
      s = e.dateTime({ width: "short" });
      break;
    case "PP":
      s = e.dateTime({ width: "medium" });
      break;
    case "PPP":
      s = e.dateTime({ width: "long" });
      break;
    default:
      s = e.dateTime({ width: "full" });
      break;
  }
  return s.replace("{{date}}", Kp(o, e)).replace("{{time}}", Oh(r, e));
}, zS = {
  p: Oh,
  P: $S
}, HS = /^D+$/, BS = /^Y+$/, WS = ["D", "DD", "YY", "YYYY"];
function US(t) {
  return HS.test(t);
}
function YS(t) {
  return BS.test(t);
}
function GS(t, e, n) {
  const o = jS(t, e, n);
  if (console.warn(o), WS.includes(t)) throw new RangeError(o);
}
function jS(t, e, n) {
  const o = t[0] === "Y" ? "years" : "days of the month";
  return `Use \`${t.toLowerCase()}\` instead of \`${t}\` (in \`${e}\`) for formatting ${o} to the input \`${n}\`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md`;
}
const KS = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, qS = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, XS = /^'([^]*?)'?$/, ZS = /''/g, QS = /[a-zA-Z]/;
function gs(t, e, n) {
  const o = ni(), r = n?.locale ?? o.locale ?? xr, s = n?.firstWeekContainsDate ?? n?.locale?.options?.firstWeekContainsDate ?? o.firstWeekContainsDate ?? o.locale?.options?.firstWeekContainsDate ?? 1, i = n?.weekStartsOn ?? n?.locale?.options?.weekStartsOn ?? o.weekStartsOn ?? o.locale?.options?.weekStartsOn ?? 0, a = Rt(t, n?.in);
  if (!Q4(a))
    throw new RangeError("Invalid time value");
  let l = e.match(qS).map((u) => {
    const d = u[0];
    if (d === "p" || d === "P") {
      const f = zS[d];
      return f(u, r.formatLong);
    }
    return u;
  }).join("").match(KS).map((u) => {
    if (u === "''")
      return { isToken: !1, value: "'" };
    const d = u[0];
    if (d === "'")
      return { isToken: !1, value: JS(u) };
    if (Yp[d])
      return { isToken: !0, value: u };
    if (d.match(QS))
      throw new RangeError(
        "Format string contains an unescaped latin alphabet character `" + d + "`"
      );
    return { isToken: !1, value: u };
  });
  r.localize.preprocessor && (l = r.localize.preprocessor(a, l));
  const c = {
    firstWeekContainsDate: s,
    weekStartsOn: i,
    locale: r
  };
  return l.map((u) => {
    if (!u.isToken) return u.value;
    const d = u.value;
    (!n?.useAdditionalWeekYearTokens && YS(d) || !n?.useAdditionalDayOfYearTokens && US(d)) && GS(d, e, String(t));
    const f = Yp[d[0]];
    return f(a, d, r.localize, c);
  }).join("");
}
function JS(t) {
  const e = t.match(XS);
  return e ? e[1].replace(ZS, "'") : t;
}
function e5(t, e) {
  const n = Rt(t, e?.in), o = n.getFullYear(), r = n.getMonth(), s = Ht(n, 0);
  return s.setFullYear(o, r + 1, 0), s.setHours(0, 0, 0, 0), s.getDate();
}
function t5(t, e) {
  return Rt(t, e?.in).getMonth();
}
function n5(t, e) {
  return Rt(t, e?.in).getFullYear();
}
function o5(t, e) {
  return +Rt(t) > +Rt(e);
}
function r5(t, e) {
  return +Rt(t) < +Rt(e);
}
function s5(t, e, n) {
  const [o, r] = jr(
    n?.in,
    t,
    e
  );
  return o.getFullYear() === r.getFullYear() && o.getMonth() === r.getMonth();
}
function i5(t, e, n) {
  const [o, r] = jr(
    n?.in,
    t,
    e
  );
  return o.getFullYear() === r.getFullYear();
}
function a5(t, e, n) {
  const o = Rt(t, n?.in), r = o.getFullYear(), s = o.getDate(), i = Ht(t, 0);
  i.setFullYear(r, e, 15), i.setHours(0, 0, 0, 0);
  const a = e5(i);
  return o.setMonth(e, Math.min(s, a)), o;
}
function l5(t, e, n) {
  const o = Rt(t, n?.in);
  return isNaN(+o) ? Ht(t, NaN) : (o.setFullYear(e), o);
}
const qp = 5, c5 = 4;
function u5(t, e) {
  const n = e.startOfMonth(t), o = n.getDay() > 0 ? n.getDay() : 7, r = e.addDays(t, -o + 1), s = e.addDays(r, qp * 7 - 1);
  return e.getMonth(t) === e.getMonth(s) ? qp : c5;
}
function Dh(t, e) {
  const n = e.startOfMonth(t), o = n.getDay();
  return o === 1 ? n : o === 0 ? e.addDays(n, -6) : e.addDays(n, -1 * (o - 1));
}
function d5(t, e) {
  const n = Dh(t, e), o = u5(t, e);
  return e.addDays(n, o * 7 - 1);
}
const _h = {
  ...xr,
  labels: {
    labelDayButton: (t, e, n, o) => {
      let r;
      o && typeof o.format == "function" ? r = o.format.bind(o) : r = (i, a) => gs(i, a, { locale: xr, ...n });
      let s = r(t, "PPPP");
      return e.today && (s = `Today, ${s}`), e.selected && (s = `${s}, selected`), s;
    },
    labelMonthDropdown: "Choose the Month",
    labelNext: "Go to the Next Month",
    labelPrevious: "Go to the Previous Month",
    labelWeekNumber: (t) => `Week ${t}`,
    labelYearDropdown: "Choose the Year",
    labelGrid: (t, e, n) => {
      let o;
      return n && typeof n.format == "function" ? o = n.format.bind(n) : o = (r, s) => gs(r, s, { locale: xr, ...e }), o(t, "LLLL yyyy");
    },
    labelGridcell: (t, e, n, o) => {
      let r;
      o && typeof o.format == "function" ? r = o.format.bind(o) : r = (i, a) => gs(i, a, { locale: xr, ...n });
      let s = r(t, "PPPP");
      return e?.today && (s = `Today, ${s}`), s;
    },
    labelNav: "Navigation bar",
    labelWeekNumberHeader: "Week Number",
    labelWeekday: (t, e, n) => {
      let o;
      return n && typeof n.format == "function" ? o = n.format.bind(n) : o = (r, s) => gs(r, s, { locale: xr, ...e }), o(t, "cccc");
    }
  }
};
class vn {
  /**
   * Creates an instance of `DateLib`.
   *
   * @param options Configuration options for the date library.
   * @param overrides Custom overrides for the date library functions.
   */
  constructor(e, n) {
    this.Date = Date, this.today = () => this.overrides?.today ? this.overrides.today() : this.options.timeZone ? en.tz(this.options.timeZone) : new this.Date(), this.newDate = (o, r, s) => this.overrides?.newDate ? this.overrides.newDate(o, r, s) : this.options.timeZone ? new en(o, r, s, this.options.timeZone) : new Date(o, r, s), this.addDays = (o, r) => this.overrides?.addDays ? this.overrides.addDays(o, r) : Sh(o, r), this.addMonths = (o, r) => this.overrides?.addMonths ? this.overrides.addMonths(o, r) : Rh(o, r), this.addWeeks = (o, r) => this.overrides?.addWeeks ? this.overrides.addWeeks(o, r) : j4(o, r), this.addYears = (o, r) => this.overrides?.addYears ? this.overrides.addYears(o, r) : K4(o, r), this.differenceInCalendarDays = (o, r) => this.overrides?.differenceInCalendarDays ? this.overrides.differenceInCalendarDays(o, r) : Ju(o, r), this.differenceInCalendarMonths = (o, r) => this.overrides?.differenceInCalendarMonths ? this.overrides.differenceInCalendarMonths(o, r) : Nh(o, r), this.eachMonthOfInterval = (o) => this.overrides?.eachMonthOfInterval ? this.overrides.eachMonthOfInterval(o) : eS(o), this.eachYearOfInterval = (o) => {
      const r = this.overrides?.eachYearOfInterval ? this.overrides.eachYearOfInterval(o) : oS(o), s = new Set(r.map((a) => this.getYear(a)));
      if (s.size === r.length)
        return r;
      const i = [];
      return s.forEach((a) => {
        i.push(new Date(a, 0, 1));
      }), i;
    }, this.endOfBroadcastWeek = (o) => this.overrides?.endOfBroadcastWeek ? this.overrides.endOfBroadcastWeek(o) : d5(o, this), this.endOfISOWeek = (o) => this.overrides?.endOfISOWeek ? this.overrides.endOfISOWeek(o) : rS(o), this.endOfMonth = (o) => this.overrides?.endOfMonth ? this.overrides.endOfMonth(o) : J4(o), this.endOfWeek = (o, r) => this.overrides?.endOfWeek ? this.overrides.endOfWeek(o, r) : Th(o, this.options), this.endOfYear = (o) => this.overrides?.endOfYear ? this.overrides.endOfYear(o) : nS(o), this.format = (o, r, s) => {
      const i = this.overrides?.format ? this.overrides.format(o, r, this.options) : gs(o, r, this.options);
      return this.options.numerals && this.options.numerals !== "latn" ? this.replaceDigits(i) : i;
    }, this.getISOWeek = (o) => this.overrides?.getISOWeek ? this.overrides.getISOWeek(o) : ed(o), this.getMonth = (o, r) => this.overrides?.getMonth ? this.overrides.getMonth(o, this.options) : t5(o, this.options), this.getYear = (o, r) => this.overrides?.getYear ? this.overrides.getYear(o, this.options) : n5(o, this.options), this.getWeek = (o, r) => this.overrides?.getWeek ? this.overrides.getWeek(o, this.options) : td(o, this.options), this.isAfter = (o, r) => this.overrides?.isAfter ? this.overrides.isAfter(o, r) : o5(o, r), this.isBefore = (o, r) => this.overrides?.isBefore ? this.overrides.isBefore(o, r) : r5(o, r), this.isDate = (o) => this.overrides?.isDate ? this.overrides.isDate(o) : Ph(o), this.isSameDay = (o, r) => this.overrides?.isSameDay ? this.overrides.isSameDay(o, r) : Z4(o, r), this.isSameMonth = (o, r) => this.overrides?.isSameMonth ? this.overrides.isSameMonth(o, r) : s5(o, r), this.isSameYear = (o, r) => this.overrides?.isSameYear ? this.overrides.isSameYear(o, r) : i5(o, r), this.max = (o) => this.overrides?.max ? this.overrides.max(o) : q4(o), this.min = (o) => this.overrides?.min ? this.overrides.min(o) : X4(o), this.setMonth = (o, r) => this.overrides?.setMonth ? this.overrides.setMonth(o, r) : a5(o, r), this.setYear = (o, r) => this.overrides?.setYear ? this.overrides.setYear(o, r) : l5(o, r), this.startOfBroadcastWeek = (o, r) => this.overrides?.startOfBroadcastWeek ? this.overrides.startOfBroadcastWeek(o, this) : Dh(o, this), this.startOfDay = (o) => this.overrides?.startOfDay ? this.overrides.startOfDay(o) : ks(o), this.startOfISOWeek = (o) => this.overrides?.startOfISOWeek ? this.overrides.startOfISOWeek(o) : Ts(o), this.startOfMonth = (o) => this.overrides?.startOfMonth ? this.overrides.startOfMonth(o) : tS(o), this.startOfWeek = (o, r) => this.overrides?.startOfWeek ? this.overrides.startOfWeek(o, this.options) : _r(o, this.options), this.startOfYear = (o) => this.overrides?.startOfYear ? this.overrides.startOfYear(o) : Mh(o), this.options = { locale: _h, ...e }, this.overrides = n;
  }
  /**
   * Generates a mapping of Arabic digits (0-9) to the target numbering system
   * digits.
   *
   * @since 9.5.0
   * @returns A record mapping Arabic digits to the target numerals.
   */
  getDigitMap() {
    const { numerals: e = "latn" } = this.options, n = new Intl.NumberFormat("en-US", {
      numberingSystem: e
    }), o = {};
    for (let r = 0; r < 10; r++)
      o[r.toString()] = n.format(r);
    return o;
  }
  /**
   * Replaces Arabic digits in a string with the target numbering system digits.
   *
   * @since 9.5.0
   * @param input The string containing Arabic digits.
   * @returns The string with digits replaced.
   */
  replaceDigits(e) {
    const n = this.getDigitMap();
    return e.replace(/\d/g, (o) => n[o] || o);
  }
  /**
   * Formats a number using the configured numbering system.
   *
   * @since 9.5.0
   * @param value The number to format.
   * @returns The formatted number as a string.
   */
  formatNumber(e) {
    return this.replaceDigits(e.toString());
  }
  /**
   * Returns the preferred ordering for month and year labels for the current
   * locale.
   */
  getMonthYearOrder() {
    const e = this.options.locale?.code;
    return e && vn.yearFirstLocales.has(e) ? "year-first" : "month-first";
  }
  /**
   * Formats the month/year pair respecting locale conventions.
   *
   * @since 9.11.0
   */
  formatMonthYear(e) {
    const { locale: n, timeZone: o, numerals: r } = this.options, s = n?.code;
    if (s && vn.yearFirstLocales.has(s))
      try {
        return new Intl.DateTimeFormat(s, {
          month: "long",
          year: "numeric",
          timeZone: o,
          numberingSystem: r
        }).format(e);
      } catch {
      }
    const i = this.getMonthYearOrder() === "year-first" ? "y LLLL" : "LLLL y";
    return this.format(e, i);
  }
}
vn.yearFirstLocales = /* @__PURE__ */ new Set([
  "eu",
  "hu",
  "ja",
  "ja-Hira",
  "ja-JP",
  "ko",
  "ko-KR",
  "lt",
  "lt-LT",
  "lv",
  "lv-LV",
  "mn",
  "mn-MN",
  "zh",
  "zh-CN",
  "zh-HK",
  "zh-TW"
]);
const lo = new vn();
class Vh {
  constructor(e, n, o = lo) {
    this.date = e, this.displayMonth = n, this.outside = !!(n && !o.isSameMonth(e, n)), this.dateLib = o, this.isoDate = o.format(e, "yyyy-MM-dd"), this.displayMonthId = o.format(n, "yyyy-MM"), this.dateMonthId = o.format(e, "yyyy-MM");
  }
  /**
   * Checks if this day is equal to another `CalendarDay`, considering both the
   * date and the displayed month.
   *
   * @param day The `CalendarDay` to compare with.
   * @returns `true` if the days are equal, otherwise `false`.
   */
  isEqualTo(e) {
    return this.dateLib.isSameDay(e.date, this.date) && this.dateLib.isSameMonth(e.displayMonth, this.displayMonth);
  }
}
class f5 {
  constructor(e, n) {
    this.date = e, this.weeks = n;
  }
}
class p5 {
  constructor(e, n) {
    this.days = n, this.weekNumber = e;
  }
}
function g5(t) {
  return Ae.createElement("button", { ...t });
}
function m5(t) {
  return Ae.createElement("span", { ...t });
}
function h5(t) {
  const { size: e = 24, orientation: n = "left", className: o } = t;
  return (
    // biome-ignore lint/a11y/noSvgWithoutTitle: handled by the parent component
    Ae.createElement(
      "svg",
      { className: o, width: e, height: e, viewBox: "0 0 24 24" },
      n === "up" && Ae.createElement("polygon", { points: "6.77 17 12.5 11.43 18.24 17 20 15.28 12.5 8 5 15.28" }),
      n === "down" && Ae.createElement("polygon", { points: "6.77 8 12.5 13.57 18.24 8 20 9.72 12.5 17 5 9.72" }),
      n === "left" && Ae.createElement("polygon", { points: "16 18.112 9.81111111 12 16 5.87733333 14.0888889 4 6 12 14.0888889 20" }),
      n === "right" && Ae.createElement("polygon", { points: "8 18.112 14.18888889 12 8 5.87733333 9.91111111 4 18 12 9.91111111 20" })
    )
  );
}
function b5(t) {
  const { day: e, modifiers: n, ...o } = t;
  return Ae.createElement("td", { ...o });
}
function v5(t) {
  const { day: e, modifiers: n, ...o } = t, r = Ae.useRef(null);
  return Ae.useEffect(() => {
    n.focused && r.current?.focus();
  }, [n.focused]), Ae.createElement("button", { ref: r, ...o });
}
var je;
(function(t) {
  t.Root = "root", t.Chevron = "chevron", t.Day = "day", t.DayButton = "day_button", t.CaptionLabel = "caption_label", t.Dropdowns = "dropdowns", t.Dropdown = "dropdown", t.DropdownRoot = "dropdown_root", t.Footer = "footer", t.MonthGrid = "month_grid", t.MonthCaption = "month_caption", t.MonthsDropdown = "months_dropdown", t.Month = "month", t.Months = "months", t.Nav = "nav", t.NextMonthButton = "button_next", t.PreviousMonthButton = "button_previous", t.Week = "week", t.Weeks = "weeks", t.Weekday = "weekday", t.Weekdays = "weekdays", t.WeekNumber = "week_number", t.WeekNumberHeader = "week_number_header", t.YearsDropdown = "years_dropdown";
})(je || (je = {}));
var It;
(function(t) {
  t.disabled = "disabled", t.hidden = "hidden", t.outside = "outside", t.focused = "focused", t.today = "today";
})(It || (It = {}));
var Ln;
(function(t) {
  t.range_end = "range_end", t.range_middle = "range_middle", t.range_start = "range_start", t.selected = "selected";
})(Ln || (Ln = {}));
var mn;
(function(t) {
  t.weeks_before_enter = "weeks_before_enter", t.weeks_before_exit = "weeks_before_exit", t.weeks_after_enter = "weeks_after_enter", t.weeks_after_exit = "weeks_after_exit", t.caption_after_enter = "caption_after_enter", t.caption_after_exit = "caption_after_exit", t.caption_before_enter = "caption_before_enter", t.caption_before_exit = "caption_before_exit";
})(mn || (mn = {}));
function y5(t) {
  const { options: e, className: n, components: o, classNames: r, ...s } = t, i = [r[je.Dropdown], n].join(" "), a = e?.find(({ value: l }) => l === s.value);
  return Ae.createElement(
    "span",
    { "data-disabled": s.disabled, className: r[je.DropdownRoot] },
    Ae.createElement(o.Select, { className: i, ...s }, e?.map(({ value: l, label: c, disabled: u }) => Ae.createElement(o.Option, { key: l, value: l, disabled: u }, c))),
    Ae.createElement(
      "span",
      { className: r[je.CaptionLabel], "aria-hidden": !0 },
      a?.label,
      Ae.createElement(o.Chevron, { orientation: "down", size: 18, className: r[je.Chevron] })
    )
  );
}
function x5(t) {
  return Ae.createElement("div", { ...t });
}
function w5(t) {
  return Ae.createElement("div", { ...t });
}
function C5(t) {
  const { calendarMonth: e, displayIndex: n, ...o } = t;
  return Ae.createElement("div", { ...o }, t.children);
}
function S5(t) {
  const { calendarMonth: e, displayIndex: n, ...o } = t;
  return Ae.createElement("div", { ...o });
}
function R5(t) {
  return Ae.createElement("table", { ...t });
}
function E5(t) {
  return Ae.createElement("div", { ...t });
}
const Ah = xa(void 0);
function Kr() {
  const t = em(Ah);
  if (t === void 0)
    throw new Error("useDayPicker() must be used within a custom component.");
  return t;
}
function P5(t) {
  const { components: e } = Kr();
  return Ae.createElement(e.Dropdown, { ...t });
}
function N5(t) {
  const { onPreviousClick: e, onNextClick: n, previousMonth: o, nextMonth: r, ...s } = t, { components: i, classNames: a, labels: { labelPrevious: l, labelNext: c } } = Kr(), u = Rn((f) => {
    r && n?.(f);
  }, [r, n]), d = Rn((f) => {
    o && e?.(f);
  }, [o, e]);
  return Ae.createElement(
    "nav",
    { ...s },
    Ae.createElement(
      i.PreviousMonthButton,
      { type: "button", className: a[je.PreviousMonthButton], tabIndex: o ? void 0 : -1, "aria-disabled": o ? void 0 : !0, "aria-label": l(o), onClick: d },
      Ae.createElement(i.Chevron, { disabled: o ? void 0 : !0, className: a[je.Chevron], orientation: "left" })
    ),
    Ae.createElement(
      i.NextMonthButton,
      { type: "button", className: a[je.NextMonthButton], tabIndex: r ? void 0 : -1, "aria-disabled": r ? void 0 : !0, "aria-label": c(r), onClick: u },
      Ae.createElement(i.Chevron, { disabled: r ? void 0 : !0, orientation: "right", className: a[je.Chevron] })
    )
  );
}
function I5(t) {
  const { components: e } = Kr();
  return Ae.createElement(e.Button, { ...t });
}
function M5(t) {
  return Ae.createElement("option", { ...t });
}
function T5(t) {
  const { components: e } = Kr();
  return Ae.createElement(e.Button, { ...t });
}
function k5(t) {
  const { rootRef: e, ...n } = t;
  return Ae.createElement("div", { ...n, ref: e });
}
function O5(t) {
  return Ae.createElement("select", { ...t });
}
function D5(t) {
  const { week: e, ...n } = t;
  return Ae.createElement("tr", { ...n });
}
function _5(t) {
  return Ae.createElement("th", { ...t });
}
function V5(t) {
  return Ae.createElement(
    "thead",
    { "aria-hidden": !0 },
    Ae.createElement("tr", { ...t })
  );
}
function A5(t) {
  const { week: e, ...n } = t;
  return Ae.createElement("th", { ...n });
}
function F5(t) {
  return Ae.createElement("th", { ...t });
}
function L5(t) {
  return Ae.createElement("tbody", { ...t });
}
function $5(t) {
  const { components: e } = Kr();
  return Ae.createElement(e.Dropdown, { ...t });
}
const z5 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Button: g5,
  CaptionLabel: m5,
  Chevron: h5,
  Day: b5,
  DayButton: v5,
  Dropdown: y5,
  DropdownNav: x5,
  Footer: w5,
  Month: C5,
  MonthCaption: S5,
  MonthGrid: R5,
  Months: E5,
  MonthsDropdown: P5,
  Nav: N5,
  NextMonthButton: I5,
  Option: M5,
  PreviousMonthButton: T5,
  Root: k5,
  Select: O5,
  Week: D5,
  WeekNumber: A5,
  WeekNumberHeader: F5,
  Weekday: _5,
  Weekdays: V5,
  Weeks: L5,
  YearsDropdown: $5
}, Symbol.toStringTag, { value: "Module" }));
function go(t, e, n = !1, o = lo) {
  let { from: r, to: s } = t;
  const { differenceInCalendarDays: i, isSameDay: a } = o;
  return r && s ? (i(s, r) < 0 && ([r, s] = [s, r]), i(e, r) >= (n ? 1 : 0) && i(s, e) >= (n ? 1 : 0)) : !n && s ? a(s, e) : !n && r ? a(r, e) : !1;
}
function nd(t) {
  return !!(t && typeof t == "object" && "before" in t && "after" in t);
}
function Ba(t) {
  return !!(t && typeof t == "object" && "from" in t);
}
function od(t) {
  return !!(t && typeof t == "object" && "after" in t);
}
function rd(t) {
  return !!(t && typeof t == "object" && "before" in t);
}
function Fh(t) {
  return !!(t && typeof t == "object" && "dayOfWeek" in t);
}
function Lh(t, e) {
  return Array.isArray(t) && t.every(e.isDate);
}
function mo(t, e, n = lo) {
  const o = Array.isArray(e) ? e : [e], { isSameDay: r, differenceInCalendarDays: s, isAfter: i } = n;
  return o.some((a) => {
    if (typeof a == "boolean")
      return a;
    if (n.isDate(a))
      return r(t, a);
    if (Lh(a, n))
      return a.some((l) => r(t, l));
    if (Ba(a))
      return go(a, t, !1, n);
    if (Fh(a))
      return Array.isArray(a.dayOfWeek) ? a.dayOfWeek.includes(t.getDay()) : a.dayOfWeek === t.getDay();
    if (nd(a)) {
      const l = s(a.before, t), c = s(a.after, t), u = l > 0, d = c < 0;
      return i(a.before, a.after) ? d && u : u || d;
    }
    return od(a) ? s(t, a.after) > 0 : rd(a) ? s(a.before, t) > 0 : typeof a == "function" ? a(t) : !1;
  });
}
function H5(t, e, n, o, r) {
  const { disabled: s, hidden: i, modifiers: a, showOutsideDays: l, broadcastCalendar: c, today: u = r.today() } = e, { isSameDay: d, isSameMonth: f, startOfMonth: p, isBefore: g, endOfMonth: m, isAfter: h } = r, b = n && p(n), w = o && m(o), y = {
    [It.focused]: [],
    [It.outside]: [],
    [It.disabled]: [],
    [It.hidden]: [],
    [It.today]: []
  }, C = {};
  for (const R of t) {
    const { date: S, displayMonth: E } = R, P = !!(E && !f(S, E)), N = !!(b && g(S, b)), I = !!(w && h(S, w)), M = !!(s && mo(S, s, r)), T = !!(i && mo(S, i, r)) || N || I || // Broadcast calendar will show outside days as default
    !c && !l && P || c && l === !1 && P, k = d(S, u);
    P && y.outside.push(R), M && y.disabled.push(R), T && y.hidden.push(R), k && y.today.push(R), a && Object.keys(a).forEach((D) => {
      const O = a?.[D];
      O && mo(S, O, r) && (C[D] ? C[D].push(R) : C[D] = [R]);
    });
  }
  return (R) => {
    const S = {
      [It.focused]: !1,
      [It.disabled]: !1,
      [It.hidden]: !1,
      [It.outside]: !1,
      [It.today]: !1
    }, E = {};
    for (const P in y) {
      const N = y[P];
      S[P] = N.some((I) => I === R);
    }
    for (const P in C)
      E[P] = C[P].some((N) => N === R);
    return {
      ...S,
      // custom modifiers should override all the previous ones
      ...E
    };
  };
}
function B5(t, e, n = {}) {
  return Object.entries(t).filter(([, r]) => r === !0).reduce((r, [s]) => (n[s] ? r.push(n[s]) : e[It[s]] ? r.push(e[It[s]]) : e[Ln[s]] && r.push(e[Ln[s]]), r), [e[je.Day]]);
}
function W5(t) {
  return {
    ...z5,
    ...t
  };
}
function U5(t) {
  const e = {
    "data-mode": t.mode ?? void 0,
    "data-required": "required" in t ? t.required : void 0,
    "data-multiple-months": t.numberOfMonths && t.numberOfMonths > 1 || void 0,
    "data-week-numbers": t.showWeekNumber || void 0,
    "data-broadcast-calendar": t.broadcastCalendar || void 0,
    "data-nav-layout": t.navLayout || void 0
  };
  return Object.entries(t).forEach(([n, o]) => {
    n.startsWith("data-") && (e[n] = o);
  }), e;
}
function Y5() {
  const t = {};
  for (const e in je)
    t[je[e]] = `rdp-${je[e]}`;
  for (const e in It)
    t[It[e]] = `rdp-${It[e]}`;
  for (const e in Ln)
    t[Ln[e]] = `rdp-${Ln[e]}`;
  for (const e in mn)
    t[mn[e]] = `rdp-${mn[e]}`;
  return t;
}
function $h(t, e, n) {
  return (n ?? new vn(e)).formatMonthYear(t);
}
const G5 = $h;
function j5(t, e, n) {
  return (n ?? new vn(e)).format(t, "d");
}
function K5(t, e = lo) {
  return e.format(t, "LLLL");
}
function q5(t, e, n) {
  return (n ?? new vn(e)).format(t, "cccccc");
}
function X5(t, e = lo) {
  return t < 10 ? e.formatNumber(`0${t.toLocaleString()}`) : e.formatNumber(`${t.toLocaleString()}`);
}
function Z5() {
  return "";
}
function zh(t, e = lo) {
  return e.format(t, "yyyy");
}
const Q5 = zh, J5 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  formatCaption: $h,
  formatDay: j5,
  formatMonthCaption: G5,
  formatMonthDropdown: K5,
  formatWeekNumber: X5,
  formatWeekNumberHeader: Z5,
  formatWeekdayName: q5,
  formatYearCaption: Q5,
  formatYearDropdown: zh
}, Symbol.toStringTag, { value: "Module" }));
function e8(t) {
  return t?.formatMonthCaption && !t.formatCaption && (t.formatCaption = t.formatMonthCaption), t?.formatYearCaption && !t.formatYearDropdown && (t.formatYearDropdown = t.formatYearCaption), {
    ...J5,
    ...t
  };
}
function sd(t, e, n, o) {
  let r = (o ?? new vn(n)).format(t, "PPPP");
  return e.today && (r = `Today, ${r}`), e.selected && (r = `${r}, selected`), r;
}
const t8 = sd;
function id(t, e, n) {
  return (n ?? new vn(e)).formatMonthYear(t);
}
const n8 = id;
function Hh(t, e, n, o) {
  let r = (o ?? new vn(n)).format(t, "PPPP");
  return e?.today && (r = `Today, ${r}`), r;
}
function Bh(t) {
  return "Choose the Month";
}
function Wh() {
  return "";
}
const o8 = "Go to the Next Month";
function Uh(t, e) {
  return o8;
}
function Yh(t) {
  return "Go to the Previous Month";
}
function Gh(t, e, n) {
  return (n ?? new vn(e)).format(t, "cccc");
}
function jh(t, e) {
  return `Week ${t}`;
}
function Kh(t) {
  return "Week Number";
}
function qh(t) {
  return "Choose the Year";
}
const r8 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  labelCaption: n8,
  labelDay: t8,
  labelDayButton: sd,
  labelGrid: id,
  labelGridcell: Hh,
  labelMonthDropdown: Bh,
  labelNav: Wh,
  labelNext: Uh,
  labelPrevious: Yh,
  labelWeekNumber: jh,
  labelWeekNumberHeader: Kh,
  labelWeekday: Gh,
  labelYearDropdown: qh
}, Symbol.toStringTag, { value: "Module" })), Vn = (t, e, n) => e || (n ? typeof n == "function" ? n : (...o) => n : t);
function s8(t, e) {
  const n = e.locale?.labels ?? {};
  return {
    ...r8,
    ...t ?? {},
    labelDayButton: Vn(sd, t?.labelDayButton, n.labelDayButton),
    labelMonthDropdown: Vn(Bh, t?.labelMonthDropdown, n.labelMonthDropdown),
    labelNext: Vn(Uh, t?.labelNext, n.labelNext),
    labelPrevious: Vn(Yh, t?.labelPrevious, n.labelPrevious),
    labelWeekNumber: Vn(jh, t?.labelWeekNumber, n.labelWeekNumber),
    labelYearDropdown: Vn(qh, t?.labelYearDropdown, n.labelYearDropdown),
    labelGrid: Vn(id, t?.labelGrid, n.labelGrid),
    labelGridcell: Vn(Hh, t?.labelGridcell, n.labelGridcell),
    labelNav: Vn(Wh, t?.labelNav, n.labelNav),
    labelWeekNumberHeader: Vn(Kh, t?.labelWeekNumberHeader, n.labelWeekNumberHeader),
    labelWeekday: Vn(Gh, t?.labelWeekday, n.labelWeekday)
  };
}
function i8(t, e, n, o, r) {
  const { startOfMonth: s, startOfYear: i, endOfYear: a, eachMonthOfInterval: l, getMonth: c } = r;
  return l({
    start: i(t),
    end: a(t)
  }).map((f) => {
    const p = o.formatMonthDropdown(f, r), g = c(f), m = e && f < s(e) || n && f > s(n) || !1;
    return { value: g, label: p, disabled: m };
  });
}
function a8(t, e = {}, n = {}) {
  let o = { ...e?.[je.Day] };
  return Object.entries(t).filter(([, r]) => r === !0).forEach(([r]) => {
    o = {
      ...o,
      ...n?.[r]
    };
  }), o;
}
function l8(t, e, n, o) {
  const r = o ?? t.today(), s = n ? t.startOfBroadcastWeek(r, t) : e ? t.startOfISOWeek(r) : t.startOfWeek(r), i = [];
  for (let a = 0; a < 7; a++) {
    const l = t.addDays(s, a);
    i.push(l);
  }
  return i;
}
function c8(t, e, n, o, r = !1) {
  if (!t || !e)
    return;
  const { startOfYear: s, endOfYear: i, eachYearOfInterval: a, getYear: l } = o, c = s(t), u = i(e), d = a({ start: c, end: u });
  return r && d.reverse(), d.map((f) => {
    const p = n.formatYearDropdown(f, o);
    return {
      value: l(f),
      label: p,
      disabled: !1
    };
  });
}
function u8(t, e = {}) {
  const { weekStartsOn: n, locale: o } = e, r = n ?? o?.options?.weekStartsOn ?? 0, s = (a) => {
    const l = typeof a == "number" || typeof a == "string" ? new Date(a) : a;
    return new en(l.getFullYear(), l.getMonth(), l.getDate(), 12, 0, 0, t);
  }, i = (a) => {
    const l = s(a);
    return new Date(l.getFullYear(), l.getMonth(), l.getDate(), 0, 0, 0, 0);
  };
  return {
    today: () => s(en.tz(t)),
    newDate: (a, l, c) => new en(a, l, c, 12, 0, 0, t),
    startOfDay: (a) => s(a),
    startOfWeek: (a, l) => {
      const c = s(a), u = l?.weekStartsOn ?? r, d = (c.getDay() - u + 7) % 7;
      return c.setDate(c.getDate() - d), c;
    },
    startOfISOWeek: (a) => {
      const l = s(a), c = (l.getDay() - 1 + 7) % 7;
      return l.setDate(l.getDate() - c), l;
    },
    startOfMonth: (a) => {
      const l = s(a);
      return l.setDate(1), l;
    },
    startOfYear: (a) => {
      const l = s(a);
      return l.setMonth(0, 1), l;
    },
    endOfWeek: (a, l) => {
      const c = s(a), f = (((l?.weekStartsOn ?? r) + 6) % 7 - c.getDay() + 7) % 7;
      return c.setDate(c.getDate() + f), c;
    },
    endOfISOWeek: (a) => {
      const l = s(a), c = (7 - l.getDay()) % 7;
      return l.setDate(l.getDate() + c), l;
    },
    endOfMonth: (a) => {
      const l = s(a);
      return l.setMonth(l.getMonth() + 1, 0), l;
    },
    endOfYear: (a) => {
      const l = s(a);
      return l.setMonth(11, 31), l;
    },
    eachMonthOfInterval: (a) => {
      const l = s(a.start), c = s(a.end), u = [], d = new en(l.getFullYear(), l.getMonth(), 1, 12, 0, 0, t), f = c.getFullYear() * 12 + c.getMonth();
      for (; d.getFullYear() * 12 + d.getMonth() <= f; )
        u.push(new en(d, t)), d.setMonth(d.getMonth() + 1, 1);
      return u;
    },
    // Normalize to noon once before arithmetic (avoid DST/midnight edge cases),
    // mutate the same TZDate, and return it.
    addDays: (a, l) => {
      const c = s(a);
      return c.setDate(c.getDate() + l), c;
    },
    addWeeks: (a, l) => {
      const c = s(a);
      return c.setDate(c.getDate() + l * 7), c;
    },
    addMonths: (a, l) => {
      const c = s(a);
      return c.setMonth(c.getMonth() + l), c;
    },
    addYears: (a, l) => {
      const c = s(a);
      return c.setFullYear(c.getFullYear() + l), c;
    },
    eachYearOfInterval: (a) => {
      const l = s(a.start), c = s(a.end), u = [], d = new en(l.getFullYear(), 0, 1, 12, 0, 0, t);
      for (; d.getFullYear() <= c.getFullYear(); )
        u.push(new en(d, t)), d.setFullYear(d.getFullYear() + 1, 0, 1);
      return u;
    },
    getWeek: (a, l) => {
      const c = i(a);
      return td(c, {
        weekStartsOn: l?.weekStartsOn ?? r,
        firstWeekContainsDate: l?.firstWeekContainsDate ?? o?.options?.firstWeekContainsDate ?? 1
      });
    },
    getISOWeek: (a) => {
      const l = i(a);
      return ed(l);
    },
    differenceInCalendarDays: (a, l) => {
      const c = i(a), u = i(l);
      return Ju(c, u);
    },
    differenceInCalendarMonths: (a, l) => {
      const c = i(a), u = i(l);
      return Nh(c, u);
    }
  };
}
const oi = (t) => t instanceof HTMLElement ? t : null, Vl = (t) => [
  ...t.querySelectorAll("[data-animated-month]") ?? []
], d8 = (t) => oi(t.querySelector("[data-animated-month]")), Al = (t) => oi(t.querySelector("[data-animated-caption]")), Fl = (t) => oi(t.querySelector("[data-animated-weeks]")), f8 = (t) => oi(t.querySelector("[data-animated-nav]")), p8 = (t) => oi(t.querySelector("[data-animated-weekdays]"));
function g8(t, e, { classNames: n, months: o, focused: r, dateLib: s }) {
  const i = kt(null), a = kt(o), l = kt(!1);
  Zi(() => {
    const c = a.current;
    if (a.current = o, !e || !t.current || // safety check because the ref can be set to anything by consumers
    !(t.current instanceof HTMLElement) || // validation required for the animation to work as expected
    o.length === 0 || c.length === 0 || o.length !== c.length)
      return;
    const u = s.isSameMonth(o[0].date, c[0].date), d = s.isAfter(o[0].date, c[0].date), f = d ? n[mn.caption_after_enter] : n[mn.caption_before_enter], p = d ? n[mn.weeks_after_enter] : n[mn.weeks_before_enter], g = i.current, m = t.current.cloneNode(!0);
    if (m instanceof HTMLElement ? (Vl(m).forEach((y) => {
      if (!(y instanceof HTMLElement))
        return;
      const C = d8(y);
      C && y.contains(C) && y.removeChild(C);
      const R = Al(y);
      R && R.classList.remove(f);
      const S = Fl(y);
      S && S.classList.remove(p);
    }), i.current = m) : i.current = null, l.current || u || // skip animation if a day is focused because it can cause issues to the animation and is better for a11y
    r)
      return;
    const h = g instanceof HTMLElement ? Vl(g) : [], b = Vl(t.current);
    if (b?.every((w) => w instanceof HTMLElement) && h && h.every((w) => w instanceof HTMLElement)) {
      l.current = !0, t.current.style.isolation = "isolate";
      const w = f8(t.current);
      w && (w.style.zIndex = "1"), b.forEach((y, C) => {
        const R = h[C];
        if (!R)
          return;
        y.style.position = "relative", y.style.overflow = "hidden";
        const S = Al(y);
        S && S.classList.add(f);
        const E = Fl(y);
        E && E.classList.add(p);
        const P = () => {
          l.current = !1, t.current && (t.current.style.isolation = ""), w && (w.style.zIndex = ""), S && S.classList.remove(f), E && E.classList.remove(p), y.style.position = "", y.style.overflow = "", y.contains(R) && y.removeChild(R);
        };
        R.style.pointerEvents = "none", R.style.position = "absolute", R.style.overflow = "hidden", R.setAttribute("aria-hidden", "true");
        const N = p8(R);
        N && (N.style.opacity = "0");
        const I = Al(R);
        I && (I.classList.add(d ? n[mn.caption_before_exit] : n[mn.caption_after_exit]), I.addEventListener("animationend", P));
        const M = Fl(R);
        M && M.classList.add(d ? n[mn.weeks_before_exit] : n[mn.weeks_after_exit]), y.insertBefore(R, y.firstChild);
      });
    }
  });
}
function m8(t, e, n, o) {
  const r = t[0], s = t[t.length - 1], { ISOWeek: i, fixedWeeks: a, broadcastCalendar: l } = n ?? {}, { addDays: c, differenceInCalendarDays: u, differenceInCalendarMonths: d, endOfBroadcastWeek: f, endOfISOWeek: p, endOfMonth: g, endOfWeek: m, isAfter: h, startOfBroadcastWeek: b, startOfISOWeek: w, startOfWeek: y } = o, C = l ? b(r, o) : i ? w(r) : y(r), R = l ? f(s) : i ? p(g(s)) : m(g(s)), S = e && (l ? f(e) : i ? p(e) : m(e)), E = S && h(R, S) ? S : R, P = u(E, C), N = d(s, r) + 1, I = [];
  for (let k = 0; k <= P; k++) {
    const D = c(C, k);
    I.push(D);
  }
  const T = (l ? 35 : 42) * N;
  if (a && I.length < T) {
    const k = T - I.length;
    for (let D = 0; D < k; D++) {
      const O = c(I[I.length - 1], 1);
      I.push(O);
    }
  }
  return I;
}
function h8(t) {
  const e = [];
  return t.reduce((n, o) => {
    const r = o.weeks.reduce((s, i) => s.concat(i.days.slice()), e.slice());
    return n.concat(r.slice());
  }, e.slice());
}
function b8(t, e, n, o) {
  const { numberOfMonths: r = 1 } = n, s = [];
  for (let i = 0; i < r; i++) {
    const a = o.addMonths(t, i);
    if (e && a > e)
      break;
    s.push(a);
  }
  return s;
}
function Xp(t, e, n, o) {
  const { month: r, defaultMonth: s, today: i = o.today(), numberOfMonths: a = 1 } = t;
  let l = r || s || i;
  const { differenceInCalendarMonths: c, addMonths: u, startOfMonth: d } = o;
  if (n && c(n, l) < a - 1) {
    const f = -1 * (a - 1);
    l = u(n, f);
  }
  return e && c(l, e) < 0 && (l = e), d(l);
}
function v8(t, e, n, o) {
  const { addDays: r, endOfBroadcastWeek: s, endOfISOWeek: i, endOfMonth: a, endOfWeek: l, getISOWeek: c, getWeek: u, startOfBroadcastWeek: d, startOfISOWeek: f, startOfWeek: p } = o, g = t.reduce((m, h) => {
    const b = n.broadcastCalendar ? d(h, o) : n.ISOWeek ? f(h) : p(h), w = n.broadcastCalendar ? s(h) : n.ISOWeek ? i(a(h)) : l(a(h)), y = e.filter((E) => E >= b && E <= w), C = n.broadcastCalendar ? 35 : 42;
    if (n.fixedWeeks && y.length < C) {
      const E = e.filter((P) => {
        const N = C - y.length;
        return P > w && P <= r(w, N);
      });
      y.push(...E);
    }
    const R = y.reduce((E, P) => {
      const N = n.ISOWeek ? c(P) : u(P), I = E.find((T) => T.weekNumber === N), M = new Vh(P, h, o);
      return I ? I.days.push(M) : E.push(new p5(N, [M])), E;
    }, []), S = new f5(h, R);
    return m.push(S), m;
  }, []);
  return n.reverseMonths ? g.reverse() : g;
}
function y8(t, e) {
  let { startMonth: n, endMonth: o } = t;
  const { startOfYear: r, startOfDay: s, startOfMonth: i, endOfMonth: a, addYears: l, endOfYear: c, newDate: u, today: d } = e, { fromYear: f, toYear: p, fromMonth: g, toMonth: m } = t;
  !n && g && (n = g), !n && f && (n = e.newDate(f, 0, 1)), !o && m && (o = m), !o && p && (o = u(p, 11, 31));
  const h = t.captionLayout === "dropdown" || t.captionLayout === "dropdown-years";
  return n ? n = i(n) : f ? n = u(f, 0, 1) : !n && h && (n = r(l(t.today ?? d(), -100))), o ? o = a(o) : p ? o = u(p, 11, 31) : !o && h && (o = c(t.today ?? d())), [
    n && s(n),
    o && s(o)
  ];
}
function x8(t, e, n, o) {
  if (n.disableNavigation)
    return;
  const { pagedNavigation: r, numberOfMonths: s = 1 } = n, { startOfMonth: i, addMonths: a, differenceInCalendarMonths: l } = o, c = r ? s : 1, u = i(t);
  if (!e)
    return a(u, c);
  if (!(l(e, t) < s))
    return a(u, c);
}
function w8(t, e, n, o) {
  if (n.disableNavigation)
    return;
  const { pagedNavigation: r, numberOfMonths: s } = n, { startOfMonth: i, addMonths: a, differenceInCalendarMonths: l } = o, c = r ? s ?? 1 : 1, u = i(t);
  if (!e)
    return a(u, -c);
  if (!(l(u, e) <= 0))
    return a(u, -c);
}
function C8(t) {
  const e = [];
  return t.reduce((n, o) => n.concat(o.weeks.slice()), e.slice());
}
function Wa(t, e) {
  const [n, o] = Mt(t);
  return [e === void 0 ? n : e, o];
}
function S8(t, e) {
  const [n, o] = y8(t, e), { startOfMonth: r, endOfMonth: s } = e, i = Xp(t, n, o, e), [a, l] = Wa(
    i,
    // initialMonth is always computed from props.month if provided
    t.month ? i : void 0
  );
  rr(() => {
    const C = Xp(t, n, o, e);
    l(C);
  }, [t.timeZone]);
  const { months: c, weeks: u, days: d, previousMonth: f, nextMonth: p } = Wi(() => {
    const C = b8(a, o, { numberOfMonths: t.numberOfMonths }, e), R = m8(C, t.endMonth ? s(t.endMonth) : void 0, {
      ISOWeek: t.ISOWeek,
      fixedWeeks: t.fixedWeeks,
      broadcastCalendar: t.broadcastCalendar
    }, e), S = v8(C, R, {
      broadcastCalendar: t.broadcastCalendar,
      fixedWeeks: t.fixedWeeks,
      ISOWeek: t.ISOWeek,
      reverseMonths: t.reverseMonths
    }, e), E = C8(S), P = h8(S), N = w8(a, n, t, e), I = x8(a, o, t, e);
    return {
      months: S,
      weeks: E,
      days: P,
      previousMonth: N,
      nextMonth: I
    };
  }, [
    e,
    a.getTime(),
    o?.getTime(),
    n?.getTime(),
    t.disableNavigation,
    t.broadcastCalendar,
    t.endMonth?.getTime(),
    t.fixedWeeks,
    t.ISOWeek,
    t.numberOfMonths,
    t.pagedNavigation,
    t.reverseMonths
  ]), { disableNavigation: g, onMonthChange: m } = t, h = (C) => u.some((R) => R.days.some((S) => S.isEqualTo(C))), b = (C) => {
    if (g)
      return;
    let R = r(C);
    n && R < r(n) && (R = r(n)), o && R > r(o) && (R = r(o)), l(R), m?.(R);
  };
  return {
    months: c,
    weeks: u,
    days: d,
    navStart: n,
    navEnd: o,
    previousMonth: f,
    nextMonth: p,
    goToMonth: b,
    goToDay: (C) => {
      h(C) || b(C.date);
    }
  };
}
var Jn;
(function(t) {
  t[t.Today = 0] = "Today", t[t.Selected = 1] = "Selected", t[t.LastFocused = 2] = "LastFocused", t[t.FocusedModifier = 3] = "FocusedModifier";
})(Jn || (Jn = {}));
function Zp(t) {
  return !t[It.disabled] && !t[It.hidden] && !t[It.outside];
}
function R8(t, e, n, o) {
  let r, s = -1;
  for (const i of t) {
    const a = e(i);
    Zp(a) && (a[It.focused] && s < Jn.FocusedModifier ? (r = i, s = Jn.FocusedModifier) : o?.isEqualTo(i) && s < Jn.LastFocused ? (r = i, s = Jn.LastFocused) : n(i.date) && s < Jn.Selected ? (r = i, s = Jn.Selected) : a[It.today] && s < Jn.Today && (r = i, s = Jn.Today));
  }
  return r || (r = t.find((i) => Zp(e(i)))), r;
}
function E8(t, e, n, o, r, s, i) {
  const { ISOWeek: a, broadcastCalendar: l } = s, { addDays: c, addMonths: u, addWeeks: d, addYears: f, endOfBroadcastWeek: p, endOfISOWeek: g, endOfWeek: m, max: h, min: b, startOfBroadcastWeek: w, startOfISOWeek: y, startOfWeek: C } = i;
  let S = {
    day: c,
    week: d,
    month: u,
    year: f,
    startOfWeek: (E) => l ? w(E, i) : a ? y(E) : C(E),
    endOfWeek: (E) => l ? p(E) : a ? g(E) : m(E)
  }[t](n, e === "after" ? 1 : -1);
  return e === "before" && o ? S = h([o, S]) : e === "after" && r && (S = b([r, S])), S;
}
function Xh(t, e, n, o, r, s, i, a = 0) {
  if (a > 365)
    return;
  const l = E8(t, e, n.date, o, r, s, i), c = !!(s.disabled && mo(l, s.disabled, i)), u = !!(s.hidden && mo(l, s.hidden, i)), d = l, f = new Vh(l, d, i);
  return !c && !u ? f : Xh(t, e, f, o, r, s, i, a + 1);
}
function P8(t, e, n, o, r) {
  const { autoFocus: s } = t, [i, a] = Mt(), l = R8(e.days, n, o || (() => !1), i), [c, u] = Mt(s ? l : void 0);
  return {
    isFocusTarget: (m) => !!l?.isEqualTo(m),
    setFocused: u,
    focused: c,
    blur: () => {
      a(c), u(void 0);
    },
    moveFocus: (m, h) => {
      if (!c)
        return;
      const b = Xh(m, h, c, e.navStart, e.navEnd, t, r);
      b && (t.disableNavigation && !e.days.some((y) => y.isEqualTo(b)) || (e.goToDay(b), u(b)));
    }
  };
}
function N8(t, e) {
  const { selected: n, required: o, onSelect: r } = t, [s, i] = Wa(n, r ? n : void 0), a = r ? n : s, { isSameDay: l } = e, c = (p) => a?.some((g) => l(g, p)) ?? !1, { min: u, max: d } = t;
  return {
    selected: a,
    select: (p, g, m) => {
      let h = [...a ?? []];
      if (c(p)) {
        if (a?.length === u || o && a?.length === 1)
          return;
        h = a?.filter((b) => !l(b, p));
      } else
        a?.length === d ? h = [p] : h = [...h, p];
      return r || i(h), r?.(h, p, g, m), h;
    },
    isSelected: c
  };
}
function I8(t, e, n = 0, o = 0, r = !1, s = lo) {
  const { from: i, to: a } = e || {}, { isSameDay: l, isAfter: c, isBefore: u } = s;
  let d;
  if (!i && !a)
    d = { from: t, to: n > 0 ? void 0 : t };
  else if (i && !a)
    l(i, t) ? n === 0 ? d = { from: i, to: t } : r ? d = { from: i, to: void 0 } : d = void 0 : u(t, i) ? d = { from: t, to: i } : d = { from: i, to: t };
  else if (i && a)
    if (l(i, t) && l(a, t))
      r ? d = { from: i, to: a } : d = void 0;
    else if (l(i, t))
      d = { from: i, to: n > 0 ? void 0 : t };
    else if (l(a, t))
      d = { from: t, to: n > 0 ? void 0 : t };
    else if (u(t, i))
      d = { from: t, to: a };
    else if (c(t, i))
      d = { from: i, to: t };
    else if (c(t, a))
      d = { from: i, to: t };
    else
      throw new Error("Invalid range");
  if (d?.from && d?.to) {
    const f = s.differenceInCalendarDays(d.to, d.from);
    o > 0 && f > o ? d = { from: t, to: void 0 } : n > 1 && f < n && (d = { from: t, to: void 0 });
  }
  return d;
}
function M8(t, e, n = lo) {
  const o = Array.isArray(e) ? e : [e];
  let r = t.from;
  const s = n.differenceInCalendarDays(t.to, t.from), i = Math.min(s, 6);
  for (let a = 0; a <= i; a++) {
    if (o.includes(r.getDay()))
      return !0;
    r = n.addDays(r, 1);
  }
  return !1;
}
function Qp(t, e, n = lo) {
  return go(t, e.from, !1, n) || go(t, e.to, !1, n) || go(e, t.from, !1, n) || go(e, t.to, !1, n);
}
function T8(t, e, n = lo) {
  const o = Array.isArray(e) ? e : [e];
  if (o.filter((a) => typeof a != "function").some((a) => typeof a == "boolean" ? a : n.isDate(a) ? go(t, a, !1, n) : Lh(a, n) ? a.some((l) => go(t, l, !1, n)) : Ba(a) ? a.from && a.to ? Qp(t, { from: a.from, to: a.to }, n) : !1 : Fh(a) ? M8(t, a.dayOfWeek, n) : nd(a) ? n.isAfter(a.before, a.after) ? Qp(t, {
    from: n.addDays(a.after, 1),
    to: n.addDays(a.before, -1)
  }, n) : mo(t.from, a, n) || mo(t.to, a, n) : od(a) || rd(a) ? mo(t.from, a, n) || mo(t.to, a, n) : !1))
    return !0;
  const i = o.filter((a) => typeof a == "function");
  if (i.length) {
    let a = t.from;
    const l = n.differenceInCalendarDays(t.to, t.from);
    for (let c = 0; c <= l; c++) {
      if (i.some((u) => u(a)))
        return !0;
      a = n.addDays(a, 1);
    }
  }
  return !1;
}
function k8(t, e) {
  const { disabled: n, excludeDisabled: o, resetOnSelect: r, selected: s, required: i, onSelect: a } = t, [l, c] = Wa(s, a ? s : void 0), u = a ? s : l;
  return {
    selected: u,
    select: (p, g, m) => {
      const { min: h, max: b } = t;
      let w;
      if (p) {
        const y = u?.from, C = u?.to, R = !!y && !!C, S = !!y && !!C && e.isSameDay(y, C) && e.isSameDay(p, y);
        r && (R || !u?.from) ? !i && S ? w = void 0 : w = { from: p, to: void 0 } : w = I8(p, u, h, b, i, e);
      }
      return o && n && w?.from && w.to && T8({ from: w.from, to: w.to }, n, e) && (w.from = p, w.to = void 0), a || c(w), a?.(w, p, g, m), w;
    },
    isSelected: (p) => u && go(u, p, !1, e)
  };
}
function O8(t, e) {
  const { selected: n, required: o, onSelect: r } = t, [s, i] = Wa(n, r ? n : void 0), a = r ? n : s, { isSameDay: l } = e;
  return {
    selected: a,
    select: (d, f, p) => {
      let g = d;
      return !o && a && a && l(d, a) && (g = void 0), r || i(g), r?.(g, d, f, p), g;
    },
    isSelected: (d) => a ? l(a, d) : !1
  };
}
function D8(t, e) {
  const n = O8(t, e), o = N8(t, e), r = k8(t, e);
  switch (t.mode) {
    case "single":
      return n;
    case "multiple":
      return o;
    case "range":
      return r;
    default:
      return;
  }
}
function En(t, e) {
  return t instanceof en && t.timeZone === e ? t : new en(t, e);
}
function yr(t, e, n) {
  return En(t, e);
}
function Jp(t, e, n) {
  return typeof t == "boolean" || typeof t == "function" ? t : t instanceof Date ? yr(t, e) : Array.isArray(t) ? t.map((o) => o instanceof Date ? yr(o, e) : o) : Ba(t) ? {
    ...t,
    from: t.from ? En(t.from, e) : t.from,
    to: t.to ? En(t.to, e) : t.to
  } : nd(t) ? {
    before: yr(t.before, e),
    after: yr(t.after, e)
  } : od(t) ? {
    after: yr(t.after, e)
  } : rd(t) ? {
    before: yr(t.before, e)
  } : t;
}
function Ll(t, e, n) {
  return t && (Array.isArray(t) ? t.map((o) => Jp(o, e)) : Jp(t, e));
}
function _8(t) {
  let e = t;
  const n = e.timeZone;
  if (n && (e = {
    ...t,
    timeZone: n
  }, e.today && (e.today = En(e.today, n)), e.month && (e.month = En(e.month, n)), e.defaultMonth && (e.defaultMonth = En(e.defaultMonth, n)), e.startMonth && (e.startMonth = En(e.startMonth, n)), e.endMonth && (e.endMonth = En(e.endMonth, n)), e.mode === "single" && e.selected ? e.selected = En(e.selected, n) : e.mode === "multiple" && e.selected ? e.selected = e.selected?.map((Ce) => En(Ce, n)) : e.mode === "range" && e.selected && (e.selected = {
    from: e.selected.from ? En(e.selected.from, n) : e.selected.from,
    to: e.selected.to ? En(e.selected.to, n) : e.selected.to
  }), e.disabled !== void 0 && (e.disabled = Ll(e.disabled, n)), e.hidden !== void 0 && (e.hidden = Ll(e.hidden, n)), e.modifiers)) {
    const Ce = {};
    Object.keys(e.modifiers).forEach((Oe) => {
      Ce[Oe] = Ll(e.modifiers?.[Oe], n);
    }), e.modifiers = Ce;
  }
  const { components: o, formatters: r, labels: s, dateLib: i, locale: a, classNames: l } = Wi(() => {
    const Ce = { ..._h, ...e.locale }, Oe = e.broadcastCalendar ? 1 : e.weekStartsOn, Ne = e.noonSafe && e.timeZone ? u8(e.timeZone, {
      weekStartsOn: Oe,
      locale: Ce
    }) : void 0, Be = e.dateLib && Ne ? { ...Ne, ...e.dateLib } : e.dateLib ?? Ne, ze = new vn({
      locale: Ce,
      weekStartsOn: Oe,
      firstWeekContainsDate: e.firstWeekContainsDate,
      useAdditionalWeekYearTokens: e.useAdditionalWeekYearTokens,
      useAdditionalDayOfYearTokens: e.useAdditionalDayOfYearTokens,
      timeZone: e.timeZone,
      numerals: e.numerals
    }, Be);
    return {
      dateLib: ze,
      components: W5(e.components),
      formatters: e8(e.formatters),
      labels: s8(e.labels, ze.options),
      locale: Ce,
      classNames: { ...Y5(), ...e.classNames }
    };
  }, [
    e.locale,
    e.broadcastCalendar,
    e.weekStartsOn,
    e.firstWeekContainsDate,
    e.useAdditionalWeekYearTokens,
    e.useAdditionalDayOfYearTokens,
    e.timeZone,
    e.numerals,
    e.dateLib,
    e.noonSafe,
    e.components,
    e.formatters,
    e.labels,
    e.classNames
  ]);
  e.today || (e = { ...e, today: i.today() });
  const { captionLayout: c, mode: u, navLayout: d, numberOfMonths: f = 1, onDayBlur: p, onDayClick: g, onDayFocus: m, onDayKeyDown: h, onDayMouseEnter: b, onDayMouseLeave: w, onNextClick: y, onPrevClick: C, showWeekNumber: R, styles: S } = e, { formatCaption: E, formatDay: P, formatMonthDropdown: N, formatWeekNumber: I, formatWeekNumberHeader: M, formatWeekdayName: T, formatYearDropdown: k } = r, D = S8(e, i), { days: O, months: V, navStart: _, navEnd: A, previousMonth: F, nextMonth: H, goToMonth: Y } = D, B = H5(O, e, _, A, i), { isSelected: U, select: q, selected: W } = D8(e, i) ?? {}, { blur: K, focused: te, isFocusTarget: z, moveFocus: Q, setFocused: ee } = P8(e, D, B, U ?? (() => !1), i), { labelDayButton: ae, labelGridcell: X, labelGrid: se, labelMonthDropdown: ue, labelNav: re, labelPrevious: ne, labelNext: oe, labelWeekday: me, labelWeekNumber: de, labelWeekNumberHeader: he, labelYearDropdown: $ } = s, Z = Wi(() => l8(i, e.ISOWeek, e.broadcastCalendar, e.today), [i, e.ISOWeek, e.broadcastCalendar, e.today]), L = u !== void 0 || g !== void 0, G = Rn(() => {
    F && (Y(F), C?.(F));
  }, [F, Y, C]), ie = Rn(() => {
    H && (Y(H), y?.(H));
  }, [Y, H, y]), pe = Rn((Ce, Oe) => (Ne) => {
    Ne.preventDefault(), Ne.stopPropagation(), ee(Ce), !Oe.disabled && (q?.(Ce.date, Oe, Ne), g?.(Ce.date, Oe, Ne));
  }, [q, g, ee]), be = Rn((Ce, Oe) => (Ne) => {
    ee(Ce), m?.(Ce.date, Oe, Ne);
  }, [m, ee]), Re = Rn((Ce, Oe) => (Ne) => {
    K(), p?.(Ce.date, Oe, Ne);
  }, [K, p]), _e = Rn((Ce, Oe) => (Ne) => {
    const Be = {
      ArrowLeft: [
        Ne.shiftKey ? "month" : "day",
        e.dir === "rtl" ? "after" : "before"
      ],
      ArrowRight: [
        Ne.shiftKey ? "month" : "day",
        e.dir === "rtl" ? "before" : "after"
      ],
      ArrowDown: [Ne.shiftKey ? "year" : "week", "after"],
      ArrowUp: [Ne.shiftKey ? "year" : "week", "before"],
      PageUp: [Ne.shiftKey ? "year" : "month", "before"],
      PageDown: [Ne.shiftKey ? "year" : "month", "after"],
      Home: ["startOfWeek", "before"],
      End: ["endOfWeek", "after"]
    };
    if (Be[Ne.key]) {
      Ne.preventDefault(), Ne.stopPropagation();
      const [ze, Me] = Be[Ne.key];
      Q(ze, Me);
    }
    h?.(Ce.date, Oe, Ne);
  }, [Q, h, e.dir]), ke = Rn((Ce, Oe) => (Ne) => {
    b?.(Ce.date, Oe, Ne);
  }, [b]), Se = Rn((Ce, Oe) => (Ne) => {
    w?.(Ce.date, Oe, Ne);
  }, [w]), Ie = Rn((Ce) => (Oe) => {
    const Ne = Number(Oe.target.value), Be = i.setMonth(i.startOfMonth(Ce), Ne);
    Y(Be);
  }, [i, Y]), Le = Rn((Ce) => (Oe) => {
    const Ne = Number(Oe.target.value), Be = i.setYear(i.startOfMonth(Ce), Ne);
    Y(Be);
  }, [i, Y]), { className: Ze, style: tt } = Wi(() => ({
    className: [l[je.Root], e.className].filter(Boolean).join(" "),
    style: { ...S?.[je.Root], ...e.style }
  }), [l, e.className, e.style, S]), ut = U5(e), at = kt(null);
  g8(at, !!e.animate, {
    classNames: l,
    months: V,
    focused: te,
    dateLib: i
  });
  const $e = {
    dayPickerProps: e,
    selected: W,
    select: q,
    isSelected: U,
    months: V,
    nextMonth: H,
    previousMonth: F,
    goToMonth: Y,
    getModifiers: B,
    components: o,
    classNames: l,
    styles: S,
    labels: s,
    formatters: r
  };
  return Ae.createElement(
    Ah.Provider,
    { value: $e },
    Ae.createElement(
      o.Root,
      { rootRef: e.animate ? at : void 0, className: Ze, style: tt, dir: e.dir, id: e.id, lang: e.lang ?? a.code, nonce: e.nonce, title: e.title, role: e.role, "aria-label": e["aria-label"], "aria-labelledby": e["aria-labelledby"], ...ut },
      Ae.createElement(
        o.Months,
        { className: l[je.Months], style: S?.[je.Months] },
        !e.hideNavigation && !d && Ae.createElement(o.Nav, { "data-animated-nav": e.animate ? "true" : void 0, className: l[je.Nav], style: S?.[je.Nav], "aria-label": re(), onPreviousClick: G, onNextClick: ie, previousMonth: F, nextMonth: H }),
        V.map((Ce, Oe) => Ae.createElement(
          o.Month,
          {
            "data-animated-month": e.animate ? "true" : void 0,
            className: l[je.Month],
            style: S?.[je.Month],
            // biome-ignore lint/suspicious/noArrayIndexKey: breaks animation
            key: Oe,
            displayIndex: Oe,
            calendarMonth: Ce
          },
          d === "around" && !e.hideNavigation && Oe === 0 && Ae.createElement(
            o.PreviousMonthButton,
            { type: "button", className: l[je.PreviousMonthButton], tabIndex: F ? void 0 : -1, "aria-disabled": F ? void 0 : !0, "aria-label": ne(F), onClick: G, "data-animated-button": e.animate ? "true" : void 0 },
            Ae.createElement(o.Chevron, { disabled: F ? void 0 : !0, className: l[je.Chevron], orientation: e.dir === "rtl" ? "right" : "left" })
          ),
          Ae.createElement(o.MonthCaption, { "data-animated-caption": e.animate ? "true" : void 0, className: l[je.MonthCaption], style: S?.[je.MonthCaption], calendarMonth: Ce, displayIndex: Oe }, c?.startsWith("dropdown") ? Ae.createElement(
            o.DropdownNav,
            { className: l[je.Dropdowns], style: S?.[je.Dropdowns] },
            (() => {
              const Ne = c === "dropdown" || c === "dropdown-months" ? Ae.createElement(o.MonthsDropdown, { key: "month", className: l[je.MonthsDropdown], "aria-label": ue(), classNames: l, components: o, disabled: !!e.disableNavigation, onChange: Ie(Ce.date), options: i8(Ce.date, _, A, r, i), style: S?.[je.Dropdown], value: i.getMonth(Ce.date) }) : Ae.createElement("span", { key: "month" }, N(Ce.date, i)), Be = c === "dropdown" || c === "dropdown-years" ? Ae.createElement(o.YearsDropdown, { key: "year", className: l[je.YearsDropdown], "aria-label": $(i.options), classNames: l, components: o, disabled: !!e.disableNavigation, onChange: Le(Ce.date), options: c8(_, A, r, i, !!e.reverseYears), style: S?.[je.Dropdown], value: i.getYear(Ce.date) }) : Ae.createElement("span", { key: "year" }, k(Ce.date, i));
              return i.getMonthYearOrder() === "year-first" ? [Be, Ne] : [Ne, Be];
            })(),
            Ae.createElement("span", { role: "status", "aria-live": "polite", style: {
              border: 0,
              clip: "rect(0 0 0 0)",
              height: "1px",
              margin: "-1px",
              overflow: "hidden",
              padding: 0,
              position: "absolute",
              width: "1px",
              whiteSpace: "nowrap",
              wordWrap: "normal"
            } }, E(Ce.date, i.options, i))
          ) : Ae.createElement(o.CaptionLabel, { className: l[je.CaptionLabel], role: "status", "aria-live": "polite" }, E(Ce.date, i.options, i))),
          d === "around" && !e.hideNavigation && Oe === f - 1 && Ae.createElement(
            o.NextMonthButton,
            { type: "button", className: l[je.NextMonthButton], tabIndex: H ? void 0 : -1, "aria-disabled": H ? void 0 : !0, "aria-label": oe(H), onClick: ie, "data-animated-button": e.animate ? "true" : void 0 },
            Ae.createElement(o.Chevron, { disabled: H ? void 0 : !0, className: l[je.Chevron], orientation: e.dir === "rtl" ? "left" : "right" })
          ),
          Oe === f - 1 && d === "after" && !e.hideNavigation && Ae.createElement(o.Nav, { "data-animated-nav": e.animate ? "true" : void 0, className: l[je.Nav], style: S?.[je.Nav], "aria-label": re(), onPreviousClick: G, onNextClick: ie, previousMonth: F, nextMonth: H }),
          Ae.createElement(
            o.MonthGrid,
            { role: "grid", "aria-multiselectable": u === "multiple" || u === "range", "aria-label": se(Ce.date, i.options, i) || void 0, className: l[je.MonthGrid], style: S?.[je.MonthGrid] },
            !e.hideWeekdays && Ae.createElement(
              o.Weekdays,
              { "data-animated-weekdays": e.animate ? "true" : void 0, className: l[je.Weekdays], style: S?.[je.Weekdays] },
              R && Ae.createElement(o.WeekNumberHeader, { "aria-label": he(i.options), className: l[je.WeekNumberHeader], style: S?.[je.WeekNumberHeader], scope: "col" }, M()),
              Z.map((Ne) => Ae.createElement(o.Weekday, { "aria-label": me(Ne, i.options, i), className: l[je.Weekday], key: String(Ne), style: S?.[je.Weekday], scope: "col" }, T(Ne, i.options, i)))
            ),
            Ae.createElement(o.Weeks, { "data-animated-weeks": e.animate ? "true" : void 0, className: l[je.Weeks], style: S?.[je.Weeks] }, Ce.weeks.map((Ne) => Ae.createElement(
              o.Week,
              { className: l[je.Week], key: Ne.weekNumber, style: S?.[je.Week], week: Ne },
              R && Ae.createElement(o.WeekNumber, { week: Ne, style: S?.[je.WeekNumber], "aria-label": de(Ne.weekNumber, {
                locale: a
              }), className: l[je.WeekNumber], scope: "row", role: "rowheader" }, I(Ne.weekNumber, i)),
              Ne.days.map((Be) => {
                const { date: ze } = Be, Me = B(Be);
                if (Me[It.focused] = !Me.hidden && !!te?.isEqualTo(Be), Me[Ln.selected] = U?.(ze) || Me.selected, Ba(W)) {
                  const { from: we, to: Ve } = W;
                  Me[Ln.range_start] = !!(we && Ve && i.isSameDay(ze, we)), Me[Ln.range_end] = !!(we && Ve && i.isSameDay(ze, Ve)), Me[Ln.range_middle] = go(W, ze, !0, i);
                }
                const Wt = a8(Me, S, e.modifiersStyles), ft = B5(Me, l, e.modifiersClassNames), ve = !L && !Me.hidden ? X(ze, Me, i.options, i) : void 0;
                return Ae.createElement(o.Day, { key: `${Be.isoDate}_${Be.displayMonthId}`, day: Be, modifiers: Me, className: ft.join(" "), style: Wt, role: "gridcell", "aria-selected": Me.selected || void 0, "aria-label": ve, "data-day": Be.isoDate, "data-month": Be.outside ? Be.dateMonthId : void 0, "data-selected": Me.selected || void 0, "data-disabled": Me.disabled || void 0, "data-hidden": Me.hidden || void 0, "data-outside": Be.outside || void 0, "data-focused": Me.focused || void 0, "data-today": Me.today || void 0 }, !Me.hidden && L ? Ae.createElement(o.DayButton, { className: l[je.DayButton], style: S?.[je.DayButton], type: "button", day: Be, modifiers: Me, disabled: !Me.focused && Me.disabled || void 0, "aria-disabled": Me.focused && Me.disabled || void 0, tabIndex: z(Be) ? 0 : -1, "aria-label": ae(ze, Me, i.options, i), onClick: pe(Be, Me), onBlur: Re(Be, Me), onFocus: be(Be, Me), onKeyDown: _e(Be, Me), onMouseEnter: ke(Be, Me), onMouseLeave: Se(Be, Me) }, P(ze, i.options, i)) : !Me.hidden && P(Be.date, i.options, i));
              })
            )))
          )
        ))
      ),
      e.footer && Ae.createElement(o.Footer, { className: l[je.Footer], style: S?.[je.Footer], role: "status", "aria-live": "polite" }, e.footer)
    )
  );
}
function V8() {
  const t = J.c(1);
  let e;
  return t[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (e = /* @__PURE__ */ x("svg", { viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", "aria-hidden": "true", focusable: "false", className: "w-full h-full", children: /* @__PURE__ */ x("path", { d: "M12.2143 4.06071C11.8321 3.78214 11.2964 3.86786 11.0179 4.25L6.75357 10.1143L4.89286 8.25357C4.55714 7.91786 4.01429 7.91786 3.68214 8.25357C3.35 8.58929 3.34643 9.13214 3.68214 9.46429L6.25357 12.0357C6.43214 12.2143 6.67857 12.3036 6.925 12.2857C7.17143 12.2679 7.40357 12.1393 7.55 11.9357L12.4036 5.25714C12.6821 4.875 12.5964 4.33929 12.2143 4.06071Z", fill: "currentColor" }) }), t[0] = e) : e = t[0], e;
}
const A8 = ye(["rounded-(--radius-sm)", "border", "border-solid", "border-menu-default-outline", "bg-menu-default-background", "shadow-elevation-3", "p-(--spacing-4)", "flex", "flex-col", "max-h-[min(20rem,calc(100vh-2rem))]", "overflow-y-auto", "overscroll-contain", "outline-none", "data-[starting-style]:opacity-0", "data-[starting-style]:scale-95", "data-[ending-style]:opacity-0", "data-[ending-style]:scale-95", "transition-[opacity,transform]", "duration-100", "ease-in-out"], {
  variants: {
    size: {
      sm: "w-[180px]",
      md: "w-[296px]",
      lg: "w-[400px]",
      anchor: "w-[var(--anchor-width)]",
      trigger: "w-[max(180px,var(--anchor-width))] max-w-[calc(100vw-var(--spacing-16))]",
      auto: "w-auto"
    }
  },
  defaultVariants: {
    size: "md"
  }
}), F8 = ye(["flex", "h-[36px]", "w-full", "items-center", "gap-(--spacing-8)", "rounded-(--radius-sm)", "px-(--spacing-12)", "py-(--spacing-8)", "font-(family-name:--font-family-body)", "text-(length:--font-size-body-medium)", "font-(number:--font-weight-regular)", "leading-(--font-line-height-20)", "tracking-(--font-letter-spacing-default)", "text-menu-text-default", "cursor-pointer", "select-none", "outline-none", "transition-colors", "duration-200", "ease-in-out", "hover:bg-menu-item-hover", "active:bg-menu-item-pressed", "data-[highlighted]:bg-menu-item-hover", "data-[selected]:bg-menu-item-selected", "data-[checked]:bg-menu-item-selected", "[&[data-highlighted]:active]:bg-menu-item-pressed", "[&[data-selected]:active]:bg-menu-item-pressed", "[&[data-checked]:active]:bg-menu-item-pressed", "focus-visible:ring-2", "focus-visible:ring-inset", "focus-visible:ring-menu-focus-ring", "data-[disabled]:pointer-events-none", "data-[disabled]:cursor-default", "data-[disabled]:opacity-50", "data-[disabled]:hover:bg-transparent"], {
  variants: {
    tone: {
      default: "",
      destructive: ["text-menu-text-destructive", "[&_svg]:text-menu-icon-destructive"]
    }
  },
  defaultVariants: {
    tone: "default"
  }
}), L8 = le("flex", "h-(--spacing-24)", "w-full", "items-center", "rounded-(--radius-sm)", "px-(--spacing-12)", "py-(--spacing-4)", "font-(family-name:--font-family-label)", "text-(length:--font-size-label-small)", "font-(number:--font-weight-medium)", "leading-(--font-line-height-16)", "tracking-(--font-letter-spacing-default)", "text-menu-text-subtle", "select-none", "data-[disabled]:text-menu-text-disabled-sub");
function Ua({
  size: t,
  className: e
}) {
  return le(A8({
    size: t
  }), e);
}
function ba(t) {
  const e = J.c(19), {
    children: n,
    leadingIcon: o,
    endSection: r,
    checked: s,
    checkbox: i,
    submenu: a
  } = t;
  let l;
  e[0] !== i || e[1] !== s ? (l = i && /* @__PURE__ */ x($8, { checked: s }), e[0] = i, e[1] = s, e[2] = l) : l = e[2];
  let c;
  e[3] !== o ? (c = o && /* @__PURE__ */ x("span", { className: "inline-flex shrink-0 text-menu-icon-default", children: /* @__PURE__ */ x(Ye, { name: o, size: "xs", tone: "inherit" }) }), e[3] = o, e[4] = c) : c = e[4];
  let u;
  e[5] !== n ? (u = /* @__PURE__ */ x("span", { className: "min-w-0 flex-1 truncate", children: n }), e[5] = n, e[6] = u) : u = e[6];
  let d;
  e[7] !== i || e[8] !== s ? (d = s && !i && /* @__PURE__ */ x("span", { className: "inline-flex shrink-0 text-menu-icon-secondary", children: /* @__PURE__ */ x(Ye, { name: "check-mark", size: "xs", tone: "inherit" }) }), e[7] = i, e[8] = s, e[9] = d) : d = e[9];
  let f;
  e[10] !== r || e[11] !== a ? (f = a ? /* @__PURE__ */ x("span", { "aria-hidden": "true", className: "inline-flex shrink-0 text-menu-icon-default", children: /* @__PURE__ */ x(Ye, { name: "chevron-right", size: "xs", tone: "inherit" }) }) : r && /* @__PURE__ */ x("span", { className: "inline-flex shrink-0 items-center gap-(--spacing-4)", children: r }), e[10] = r, e[11] = a, e[12] = f) : f = e[12];
  let p;
  return e[13] !== l || e[14] !== c || e[15] !== u || e[16] !== d || e[17] !== f ? (p = /* @__PURE__ */ j(_o, { children: [
    l,
    c,
    u,
    d,
    f
  ] }), e[13] = l, e[14] = c, e[15] = u, e[16] = d, e[17] = f, e[18] = p) : p = e[18], p;
}
function $8(t) {
  const e = J.c(7), {
    checked: n
  } = t, o = n ? "" : void 0, r = n ? "" : void 0;
  let s;
  e[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (s = le("inline-flex", "h-(--icon-xs)", "w-(--icon-xs)", "items-center", "justify-center", "rounded-(--radius-sm)", "border-[1.5px]", "border-checkbox-outline-default-border", "bg-surface-container-lowest", "text-transparent", "transition-colors", "duration-200", "ease-in-out", "data-[checked]:border-transparent", "data-[checked]:bg-checkbox-filled-default-background", "data-[checked]:text-surface-container-lowest", "[[data-disabled]_&]:border-transparent", "[[data-disabled]_&]:bg-checkbox-filled-disabled-background", "[[data-disabled]_&]:text-surface-container-lowest"), e[0] = s) : s = e[0];
  let i;
  e[1] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (i = /* @__PURE__ */ x("span", { className: "h-[calc(var(--icon-xs)*0.8)] w-[calc(var(--icon-xs)*0.8)]", children: /* @__PURE__ */ x(V8, {}) }), e[1] = i) : i = e[1];
  let a;
  e[2] !== r ? (a = /* @__PURE__ */ x("span", { "data-checked": r, className: s, children: i }), e[2] = r, e[3] = a) : a = e[3];
  let l;
  return e[4] !== o || e[5] !== a ? (l = /* @__PURE__ */ x("span", { "aria-hidden": "true", "data-checked": o, className: "inline-flex h-(--icon-sm) w-(--icon-sm) shrink-0 items-center justify-center", children: a }), e[4] = o, e[5] = a, e[6] = l) : l = e[6], l;
}
function or({
  tone: t,
  className: e
}) {
  return le(F8({
    tone: t
  }), e);
}
function Zh(t) {
  const e = J.c(13), {
    children: n,
    positionerClassName: o,
    popupClassName: r,
    listClassName: s
  } = t;
  let i;
  e[0] !== r ? (i = Ua({
    size: "auto",
    className: r
  }), e[0] = r, e[1] = i) : i = e[1];
  let a;
  e[2] !== s ? (a = le("flex flex-col", s), e[2] = s, e[3] = a) : a = e[3];
  let l;
  e[4] !== n || e[5] !== a ? (l = /* @__PURE__ */ x(hh, { className: a, children: n }), e[4] = n, e[5] = a, e[6] = l) : l = e[6];
  let c;
  e[7] !== i || e[8] !== l ? (c = /* @__PURE__ */ x(mh, { className: i, children: l }), e[7] = i, e[8] = l, e[9] = c) : c = e[9];
  let u;
  return e[10] !== o || e[11] !== c ? (u = /* @__PURE__ */ x(uh, { children: /* @__PURE__ */ x(ph, { sideOffset: 4, alignItemWithTrigger: !1, className: o, children: c }) }), e[10] = o, e[11] = c, e[12] = u) : u = e[12], u;
}
function Qh(t) {
  const e = J.c(11), {
    value: n,
    disabled: o,
    icon: r,
    children: s
  } = t;
  let i;
  e[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (i = or({}), e[0] = i) : i = e[0];
  let a;
  e[1] !== r ? (a = r && /* @__PURE__ */ x("span", { className: "shrink-0 text-menu-icon-default inline-flex", children: /* @__PURE__ */ x(Ye, { name: r, size: "xs", tone: "inherit" }) }), e[1] = r, e[2] = a) : a = e[2];
  let l;
  e[3] !== s ? (l = /* @__PURE__ */ x(xh, { className: "flex-1 min-w-0", children: s }), e[3] = s, e[4] = l) : l = e[4];
  let c;
  e[5] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (c = /* @__PURE__ */ x(vh, { className: "inline-flex shrink-0 text-menu-icon-secondary", children: /* @__PURE__ */ x(Ye, { name: "check-mark", size: "xs", tone: "inherit" }) }), e[5] = c) : c = e[5];
  let u;
  return e[6] !== o || e[7] !== a || e[8] !== l || e[9] !== n ? (u = /* @__PURE__ */ j(bh, { value: n, disabled: o, className: i, children: [
    a,
    l,
    c
  ] }), e[6] = o, e[7] = a, e[8] = l, e[9] = n, e[10] = u) : u = e[10], u;
}
function Jh(t) {
  const e = J.c(2), {
    size: n
  } = t, o = n === void 0 ? "xs" : n;
  let r;
  return e[0] !== o ? (r = /* @__PURE__ */ x("span", { className: "transition-transform duration-200 [[data-popup-open]_&]:rotate-180 inline-flex", children: /* @__PURE__ */ x(Ye, { name: "chevron-down", size: o, tone: "inherit" }) }), e[0] = o, e[1] = r) : r = e[1], r;
}
function z8(t) {
  const e = J.c(26), {
    value: n,
    onChange: o,
    options: r,
    disabled: s,
    "aria-label": i
  } = t;
  let a;
  e[0] !== r || e[1] !== n ? (a = r?.find((R) => R.value === Number(n)), e[0] = r, e[1] = n, e[2] = a) : a = e[2];
  const l = a;
  let c;
  e[3] !== o ? (c = function(S) {
    S !== null && o?.({
      target: {
        value: String(S)
      },
      currentTarget: {
        value: String(S)
      }
    });
  }, e[3] = o, e[4] = c) : c = e[4];
  const u = c, d = l?.value ?? null;
  let f;
  e[5] !== r ? (f = r ?? [], e[5] = r, e[6] = f) : f = e[6];
  let p;
  e[7] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (p = le("flex items-center gap-(--spacing-2)", "cursor-pointer rounded-(--radius-xs) outline-none", "focus-visible:ring-2 focus-visible:ring-offset-1", "focus-visible:ring-offset-surface", "focus-visible:ring-button-focus-ring", "data-[disabled]:cursor-not-allowed data-[disabled]:opacity-50"), e[7] = p) : p = e[7];
  const g = l?.label ?? "";
  let m;
  e[8] !== g ? (m = /* @__PURE__ */ x(Gu, { className: "text-(length:--font-size-title-inter-medium) font-(number:--font-weight-medium) leading-(--font-line-height-24) text-text-default select-none", children: g }), e[8] = g, e[9] = m) : m = e[9];
  let h;
  e[10] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (h = /* @__PURE__ */ x(ju, { className: "text-icon-main", children: /* @__PURE__ */ x(Jh, { size: "sm" }) }), e[10] = h) : h = e[10];
  let b;
  e[11] !== i || e[12] !== s || e[13] !== m ? (b = /* @__PURE__ */ j(Yu, { disabled: s, "aria-label": i, className: p, children: [
    m,
    h
  ] }), e[11] = i, e[12] = s, e[13] = m, e[14] = b) : b = e[14];
  let w;
  e[15] !== r ? (w = r?.map(H8), e[15] = r, e[16] = w) : w = e[16];
  let y;
  e[17] !== w ? (y = /* @__PURE__ */ x(Zh, { listClassName: "max-h-[368px] overflow-y-auto", children: w }), e[17] = w, e[18] = y) : y = e[18];
  let C;
  return e[19] !== s || e[20] !== u || e[21] !== y || e[22] !== d || e[23] !== f || e[24] !== b ? (C = /* @__PURE__ */ j(lh, { value: d, onValueChange: u, disabled: s, items: f, children: [
    b,
    y
  ] }), e[19] = s, e[20] = u, e[21] = y, e[22] = d, e[23] = f, e[24] = b, e[25] = C) : C = e[25], C;
}
function H8(t) {
  return /* @__PURE__ */ x(Qh, { value: t.value, disabled: t.disabled, children: t.label }, t.value);
}
function B8(t) {
  const e = J.c(18), {
    children: n
  } = t, {
    goToMonth: o,
    nextMonth: r,
    previousMonth: s,
    dayPickerProps: i
  } = Kr(), a = i.disabled === !0, l = a || !s;
  let c;
  e[0] !== o || e[1] !== s ? (c = () => s && o(s), e[0] = o, e[1] = s, e[2] = c) : c = e[2];
  let u;
  e[3] !== l || e[4] !== c ? (u = /* @__PURE__ */ x(Kt, { icon: "chevron-left", variant: "ghost", size: "md", "aria-label": "Previous month", disabled: l, onClick: c }), e[3] = l, e[4] = c, e[5] = u) : u = e[5];
  let d;
  e[6] !== n ? (d = /* @__PURE__ */ x("div", { className: "flex items-center gap-[26px]", children: n }), e[6] = n, e[7] = d) : d = e[7];
  const f = a || !r;
  let p;
  e[8] !== o || e[9] !== r ? (p = () => r && o(r), e[8] = o, e[9] = r, e[10] = p) : p = e[10];
  let g;
  e[11] !== f || e[12] !== p ? (g = /* @__PURE__ */ x(Kt, { icon: "chevron-right", variant: "ghost", size: "md", "aria-label": "Next month", disabled: f, onClick: p }), e[11] = f, e[12] = p, e[13] = g) : g = e[13];
  let m;
  return e[14] !== u || e[15] !== d || e[16] !== g ? (m = /* @__PURE__ */ j("div", { className: "flex items-center justify-between pt-(--spacing-8) px-(--spacing-12)", children: [
    u,
    d,
    g
  ] }), e[14] = u, e[15] = d, e[16] = g, e[17] = m) : m = e[17], m;
}
function W8(t) {
  const e = J.c(12), {
    value: n,
    onValueChange: o,
    disabled: r
  } = t, s = r === void 0 ? !1 : r, i = n ?? void 0, a = n ?? void 0;
  let l;
  e[0] !== o ? (l = (m) => o(m ?? null), e[0] = o, e[1] = l) : l = e[1];
  let c, u;
  e[2] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (c = new Date(2e3, 0), u = new Date(2099, 11), e[2] = c, e[3] = u) : (c = e[2], u = e[3]);
  let d, f, p;
  e[4] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (d = {
    formatMonthDropdown: U8
  }, f = {
    root: "w-[328px] bg-surface rounded-(--radius-sm) shadow-elevation-3 flex flex-col gap-(--spacing-4)",
    months: "flex flex-col",
    month: "flex flex-col gap-(--spacing-4)",
    month_caption: "",
    nav: "hidden",
    dropdowns: "flex items-center gap-[26px]",
    dropdown_root: "",
    dropdown: "",
    caption_label: "",
    month_grid: "w-full border-collapse",
    weeks: "flex flex-col gap-(--spacing-8) px-(--spacing-2) pb-(--spacing-16)",
    week: "flex gap-[11px] items-center justify-center",
    weekdays: "flex gap-[11px] items-center justify-center px-(--spacing-2) pt-(--spacing-8) pb-(--spacing-12) border-t border-outline-subtle",
    weekday: "size-(--font-line-height-36) flex items-center justify-center font-(family-name:--font-family-label) text-(length:--font-size-label-medium) font-(number:--font-weight-semibold) text-text-subtle",
    day: "size-(--font-line-height-36) flex items-center justify-center rounded-full text-(length:--font-size-body-medium) leading-(--font-line-height-20) text-text-default cursor-pointer transition-colors duration-200 ease-in-out [&:not([data-selected])]:hover:bg-surface-hover [&:not([data-selected])]:active:bg-surface-pressed",
    day_button: "size-full flex items-center justify-center outline-none rounded-full focus-visible:ring-2 focus-visible:ring-offset-1 focus-visible:ring-offset-surface focus-visible:ring-button-focus-ring",
    selected: "bg-primary [&>button]:text-primary-on-primary",
    today: "font-(number:--font-weight-semibold)",
    outside: "text-text-subtle",
    disabled: "text-text-disabled pointer-events-none opacity-50",
    hidden: "invisible"
  }, p = {
    MonthCaption: B8,
    Dropdown: z8
  }, e[4] = d, e[5] = f, e[6] = p) : (d = e[4], f = e[5], p = e[6]);
  let g;
  return e[7] !== s || e[8] !== i || e[9] !== a || e[10] !== l ? (g = /* @__PURE__ */ x(_8, { mode: "single", selected: i, defaultMonth: a, onSelect: l, disabled: s, captionLayout: "dropdown", startMonth: c, endMonth: u, showOutsideDays: !0, formatters: d, classNames: f, components: p }), e[7] = s, e[8] = i, e[9] = a, e[10] = l, e[11] = g) : g = e[11], g;
}
function U8(t) {
  return t.toLocaleString("en-US", {
    month: "short"
  });
}
const ad = /* @__PURE__ */ v.createContext(void 0);
process.env.NODE_ENV !== "production" && (ad.displayName = "TooltipRootContext");
function ri(t) {
  const e = v.useContext(ad);
  if (e === void 0 && !t)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: TooltipRootContext is missing. Tooltip parts must be placed within <Tooltip.Root>." : Xe(72));
  return e;
}
const Y8 = {
  ...Ws,
  disabled: ce((t) => t.disabled),
  instantType: ce((t) => t.instantType),
  isInstantPhase: ce((t) => t.isInstantPhase),
  trackCursorAxis: ce((t) => t.trackCursorAxis),
  disableHoverablePopup: ce((t) => t.disableHoverablePopup),
  lastOpenChangeReason: ce((t) => t.openChangeReason),
  closeOnClick: ce((t) => t.closeOnClick),
  closeDelay: ce((t) => t.closeDelay),
  hasViewport: ce((t) => t.hasViewport)
};
class ld extends ur {
  constructor(e) {
    super({
      ...G8(),
      ...e
    }, {
      popupRef: /* @__PURE__ */ v.createRef(),
      onOpenChange: void 0,
      onOpenChangeComplete: void 0,
      triggerElements: new dr()
    }, Y8);
  }
  setOpen = (e, n) => {
    const o = n.reason, r = o === Dt, s = e && o === Qo, i = !e && (o === Bn || o === ar);
    if (n.preventUnmountOnClose = () => {
      this.set("preventUnmountingOnClose", !0);
    }, this.context.onOpenChange?.(e, n), n.isCanceled)
      return;
    this.state.floatingRootContext.dispatchOpenChange(e, n);
    const a = () => {
      const l = {
        open: e,
        openChangeReason: o
      };
      s ? l.instantType = "focus" : i ? l.instantType = "dismiss" : o === Dt && (l.instantType = void 0);
      const c = n.trigger?.id ?? null;
      (c || e) && (l.activeTriggerId = c, l.activeTriggerElement = n.trigger ?? null), this.update(l);
    };
    r ? tn.flushSync(a) : a();
  };
  static useStore(e, n) {
    const o = Pt(() => new ld(n)).current, r = e ?? o, s = Us({
      popupStore: r,
      onOpenChange: r.setOpen
    });
    return r.state.floatingRootContext = s, r;
  }
}
function G8() {
  return {
    ...Bs(),
    disabled: !1,
    instantType: void 0,
    isInstantPhase: !1,
    trackCursorAxis: "none",
    disableHoverablePopup: !1,
    openChangeReason: null,
    closeOnClick: !0,
    closeDelay: 0,
    hasViewport: !1
  };
}
const cd = au(function(e) {
  const {
    disabled: n = !1,
    defaultOpen: o = !1,
    open: r,
    disableHoverablePopup: s = !1,
    trackCursorAxis: i = "none",
    actionsRef: a,
    onOpenChange: l,
    onOpenChangeComplete: c,
    handle: u,
    triggerId: d,
    defaultTriggerId: f = null,
    children: p
  } = e, g = ld.useStore(u?.store, {
    open: o,
    openProp: r,
    activeTriggerId: f,
    triggerIdProp: d
  });
  sr(() => {
    r === void 0 && g.state.open === !1 && o === !0 && g.update({
      open: !0,
      activeTriggerId: f
    });
  }), g.useControlledProp("openProp", r), g.useControlledProp("triggerIdProp", d), g.useContextCallback("onOpenChange", l), g.useContextCallback("onOpenChangeComplete", c);
  const m = g.useState("open"), h = !n && m, b = g.useState("activeTriggerId"), w = g.useState("payload");
  g.useSyncedValues({
    trackCursorAxis: i,
    disableHoverablePopup: s
  }), xe(() => {
    m && n && g.setOpen(!1, Pe(Vy));
  }, [m, n, g]), g.useSyncedValue("disabled", n), zs(g);
  const {
    forceUnmount: y,
    transitionStatus: C
  } = Hs(h, g), R = g.select("floatingRootContext"), S = g.useState("isInstantPhase"), E = g.useState("instantType"), P = g.useState("lastOpenChangeReason"), N = v.useRef(null);
  xe(() => {
    C === "ending" && P === Et || C !== "ending" && S ? (E !== "delay" && (N.current = E), g.set("instantType", "delay")) : N.current !== null && (g.set("instantType", N.current), N.current = null);
  }, [C, S, P, E, g]), xe(() => {
    h && b == null && g.set("payload", void 0);
  }, [g, b, h]);
  const I = v.useCallback(() => {
    g.setOpen(!1, Pe(As));
  }, [g]);
  v.useImperativeHandle(a, () => ({
    unmount: y,
    close: I
  }), [y, I]);
  const M = cr(R, {
    enabled: !n,
    referencePress: () => g.select("closeOnClick")
  }), T = xx(R, {
    enabled: !n && i !== "none",
    axis: i === "none" ? void 0 : i
  }), {
    getReferenceProps: k,
    getFloatingProps: D,
    getTriggerProps: O
  } = Gn([M, T]), V = v.useMemo(() => k(), [k]), _ = v.useMemo(() => O(), [O]), A = v.useMemo(() => D(), [D]);
  return g.useSyncedValues({
    activeTriggerProps: V,
    inactiveTriggerProps: _,
    popupProps: A
  }), /* @__PURE__ */ x(ad.Provider, {
    value: g,
    children: typeof p == "function" ? p({
      payload: w
    }) : p
  });
});
process.env.NODE_ENV !== "production" && (cd.displayName = "TooltipRoot");
const ud = /* @__PURE__ */ v.createContext(void 0);
process.env.NODE_ENV !== "production" && (ud.displayName = "TooltipProviderContext");
function j8() {
  return v.useContext(ud);
}
let K8 = (function(t) {
  return t[t.popupOpen = ua.popupOpen] = "popupOpen", t.triggerDisabled = "data-trigger-disabled", t;
})({});
const q8 = 600, dd = u1(function(e, n) {
  const {
    className: o,
    render: r,
    handle: s,
    payload: i,
    disabled: a,
    delay: l,
    closeOnClick: c = !0,
    closeDelay: u,
    id: d,
    style: f,
    ...p
  } = e, g = ri(!0), m = s?.store ?? g;
  if (!m)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: <Tooltip.Trigger> must be either used within a <Tooltip.Root> component or provided with a handle." : Xe(82));
  const h = St(d), b = m.useState("isTriggerActive", h), w = m.useState("isOpenedByTrigger", h), y = m.useState("floatingRootContext"), C = v.useRef(null), R = l ?? q8, S = u ?? 0, {
    registerTrigger: E,
    isMountedByThisTrigger: P
  } = $s(h, C, m, {
    payload: i,
    closeOnClick: c,
    closeDelay: S
  }), N = j8(), {
    delayRef: I,
    isInstantPhase: M,
    hasProvider: T
  } = Ly(y, {
    open: w
  });
  m.useSyncedValue("isInstantPhase", M);
  const k = m.useState("disabled"), D = a ?? k, O = m.useState("trackCursorAxis"), V = m.useState("disableHoverablePopup"), _ = Ys(y, {
    enabled: !D,
    mouseOnly: !0,
    move: !1,
    handleClose: !V && O !== "both" ? Gs() : null,
    restMs() {
      const B = N?.delay, U = typeof I.current == "object" ? I.current.open : void 0;
      let q = R;
      return T && (U !== 0 ? q = l ?? B ?? R : q = 0), q;
    },
    delay() {
      const B = typeof I.current == "object" ? I.current.close : void 0;
      let U = S;
      return u == null && T && (U = B), {
        close: U
      };
    },
    triggerElementRef: C,
    isActiveTrigger: b,
    isClosing: () => m.select("transitionStatus") === "ending"
  }), A = du(y, {
    enabled: !D
  }).reference, F = {
    open: w
  }, H = m.useState("triggerProps", P);
  return Te("button", e, {
    state: F,
    ref: [n, E, C],
    props: [_, A, H, {
      onPointerDown() {
        m.set("closeOnClick", c);
      },
      id: h,
      [K8.triggerDisabled]: D ? "" : void 0
    }, p],
    stateAttributesMapping: fr
  });
});
process.env.NODE_ENV !== "production" && (dd.displayName = "TooltipTrigger");
const fd = /* @__PURE__ */ v.createContext(void 0);
process.env.NODE_ENV !== "production" && (fd.displayName = "TooltipPortalContext");
function X8() {
  const t = v.useContext(fd);
  if (t === void 0)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: <Tooltip.Portal> is missing." : Xe(70));
  return t;
}
const pd = /* @__PURE__ */ v.forwardRef(function(e, n) {
  const {
    keepMounted: o = !1,
    ...r
  } = e;
  return ri().useState("mounted") || o ? /* @__PURE__ */ x(fd.Provider, {
    value: o,
    children: /* @__PURE__ */ x(Va, {
      ref: n,
      ...r
    })
  }) : null;
});
process.env.NODE_ENV !== "production" && (pd.displayName = "TooltipPortal");
const gd = /* @__PURE__ */ v.createContext(void 0);
process.env.NODE_ENV !== "production" && (gd.displayName = "TooltipPositionerContext");
function eb() {
  const t = v.useContext(gd);
  if (t === void 0)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: TooltipPositionerContext is missing. TooltipPositioner parts must be placed within <Tooltip.Positioner>." : Xe(71));
  return t;
}
const md = /* @__PURE__ */ v.forwardRef(function(e, n) {
  const {
    render: o,
    className: r,
    anchor: s,
    positionMethod: i = "absolute",
    side: a = "top",
    align: l = "center",
    sideOffset: c = 0,
    alignOffset: u = 0,
    collisionBoundary: d = "clipping-ancestors",
    collisionPadding: f = 5,
    arrowPadding: p = 5,
    sticky: g = !1,
    disableAnchorTracking: m = !1,
    collisionAvoidance: h = Ma,
    style: b,
    ...w
  } = e, y = ri(), C = X8(), R = y.useState("open"), S = y.useState("mounted"), E = y.useState("trackCursorAxis"), P = y.useState("disableHoverablePopup"), N = y.useState("floatingRootContext"), I = y.useState("instantType"), M = y.useState("transitionStatus"), T = y.useState("hasViewport"), k = Hr({
    anchor: s,
    positionMethod: i,
    floatingRootContext: N,
    mounted: S,
    side: a,
    sideOffset: c,
    align: l,
    alignOffset: u,
    collisionBoundary: d,
    collisionPadding: f,
    sticky: g,
    arrowPadding: p,
    disableAnchorTracking: m,
    keepMounted: C,
    collisionAvoidance: h,
    adaptiveOrigin: T ? Aa : void 0
  }), D = v.useMemo(() => ({
    open: R,
    side: k.side,
    align: k.align,
    anchorHidden: k.anchorHidden,
    instant: E !== "none" ? "tracking-cursor" : I
  }), [R, k.side, k.align, k.anchorHidden, E, I]), O = Br(e, D, {
    styles: k.positionerStyles,
    transitionStatus: M,
    props: w,
    refs: [n, y.useStateSetter("positionerElement")],
    hidden: !S,
    inert: !R || E === "both" || P
  });
  return /* @__PURE__ */ x(gd.Provider, {
    value: k,
    children: O
  });
});
process.env.NODE_ENV !== "production" && (md.displayName = "TooltipPositioner");
const Z8 = {
  ...xn,
  ...Lt
}, hd = /* @__PURE__ */ v.forwardRef(function(e, n) {
  const {
    className: o,
    render: r,
    style: s,
    ...i
  } = e, a = ri(), {
    side: l,
    align: c
  } = eb(), u = a.useState("open"), d = a.useState("instantType"), f = a.useState("transitionStatus"), p = a.useState("popupProps"), g = a.useState("floatingRootContext");
  Bt({
    open: u,
    ref: a.context.popupRef,
    onComplete() {
      u && a.context.onOpenChangeComplete?.(!0);
    }
  });
  const m = a.useState("disabled"), h = a.useState("closeDelay");
  return Da(g, {
    enabled: !m,
    closeDelay: h
  }), Te("div", e, {
    state: {
      open: u,
      side: l,
      align: c,
      instant: d,
      transitionStatus: f
    },
    ref: [n, a.context.popupRef, a.useStateSetter("popupElement")],
    props: [p, pr(f), i],
    stateAttributesMapping: Z8
  });
});
process.env.NODE_ENV !== "production" && (hd.displayName = "TooltipPopup");
const bd = /* @__PURE__ */ v.forwardRef(function(e, n) {
  const {
    className: o,
    render: r,
    style: s,
    ...i
  } = e, a = ri(), l = a.useState("open"), c = a.useState("instantType"), {
    arrowRef: u,
    side: d,
    align: f,
    arrowUncentered: p,
    arrowStyles: g
  } = eb();
  return Te("div", e, {
    state: {
      open: l,
      side: d,
      align: f,
      uncentered: p,
      instant: c
    },
    ref: [n, u],
    props: [{
      style: g,
      "aria-hidden": !0
    }, i],
    stateAttributesMapping: xn
  });
});
process.env.NODE_ENV !== "production" && (bd.displayName = "TooltipArrow");
const tb = function(e) {
  const {
    delay: n,
    closeDelay: o,
    timeout: r = 400
  } = e, s = v.useMemo(() => ({
    delay: n,
    closeDelay: o
  }), [n, o]), i = v.useMemo(() => ({
    open: n,
    close: o
  }), [n, o]);
  return /* @__PURE__ */ x(ud.Provider, {
    value: s,
    children: /* @__PURE__ */ x(Fy, {
      delay: i,
      timeoutMs: r,
      children: e.children
    })
  });
};
process.env.NODE_ENV !== "production" && (tb.displayName = "TooltipProvider");
const nb = "z-[var(--z-overlay-tooltip,200)]", ob = 5, rb = 9, sb = le("max-w-[240px]", "rounded-(--radius-sm)", "px-(--spacing-12) py-(--spacing-8)", "bg-surface-inverse-surface", "text-text-inverse", "shadow-elevation-2", "font-(family-name:--font-family-body)", "transition-opacity duration-150 ease-in-out", "[&[data-starting-style]]:opacity-0", "[&[data-ending-style]]:opacity-0"), ib = le("text-(length:--font-size-label-small)", "leading-(--font-line-height-16)"), ab = le("text-(length:--font-size-label-xs)", "font-(number:--font-weight-regular)", "leading-(--font-line-height-16)", "mt-(--spacing-4)"), lb = le("bg-surface-inverse-surface", "[&[data-side=top]]:h-(--spacing-6) [&[data-side=top]]:w-(--spacing-12)", "[&[data-side=bottom]]:h-(--spacing-6) [&[data-side=bottom]]:w-(--spacing-12)", "[&[data-side=left]]:h-(--spacing-12) [&[data-side=left]]:w-(--spacing-6)", "[&[data-side=right]]:h-(--spacing-12) [&[data-side=right]]:w-(--spacing-6)", "[&[data-side=top]]:-bottom-(--spacing-4) [&[data-side=top]]:[clip-path:polygon(50%_100%,0%_0%,100%_0%)]", "[&[data-side=bottom]]:-top-(--spacing-4) [&[data-side=bottom]]:[clip-path:polygon(50%_0%,0%_100%,100%_100%)]", "[&[data-side=left]]:-right-(--spacing-4) [&[data-side=left]]:[clip-path:polygon(100%_50%,0%_0%,0%_100%)]", "[&[data-side=right]]:-left-(--spacing-4) [&[data-side=right]]:[clip-path:polygon(0%_50%,100%_0%,100%_100%)]");
function Q8(t) {
  const e = J.c(43);
  let n, o, r, s, i, a, l, c, u;
  e[0] !== t ? ({
    label: o,
    description: n,
    icon: s,
    size: i,
    side: a,
    align: l,
    disabled: c,
    showArrow: u,
    ...r
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r, e[4] = s, e[5] = i, e[6] = a, e[7] = l, e[8] = c, e[9] = u) : (n = e[1], o = e[2], r = e[3], s = e[4], i = e[5], a = e[6], l = e[7], c = e[8], u = e[9]);
  const d = s === void 0 ? "circle-info" : s, f = i === void 0 ? "sm" : i, p = a === void 0 ? "top" : a, g = l === void 0 ? "center" : l, m = c === void 0 ? !1 : c, h = u === void 0 ? !0 : u, b = m ? -1 : 0, w = m && "opacity-40 pointer-events-none";
  let y;
  e[10] !== w ? (y = le("inline-flex items-center justify-center", "cursor-default transition-colors duration-200", "rounded-(--radius-sm)", "text-icon-main", "hover:text-primary", "focus-visible:text-primary", "focus-visible:outline-none focus-visible:ring-2", "focus-visible:ring-button-focus-ring", "focus-visible:ring-offset-1", "focus-visible:ring-offset-surface", w), e[10] = w, e[11] = y) : y = e[11];
  let C;
  e[12] !== d || e[13] !== f ? (C = /* @__PURE__ */ x(Ye, { name: d, size: f, tone: "inherit" }), e[12] = d, e[13] = f, e[14] = C) : C = e[14];
  let R;
  e[15] !== o || e[16] !== r || e[17] !== C || e[18] !== b || e[19] !== y ? (R = /* @__PURE__ */ x(dd, { render: /* @__PURE__ */ x("span", { role: "img", tabIndex: b, "aria-label": o, ...r, className: y, children: C }) }), e[15] = o, e[16] = r, e[17] = C, e[18] = b, e[19] = y, e[20] = R) : R = e[20];
  const S = h ? rb : ob;
  let E;
  e[21] !== h ? (E = h && /* @__PURE__ */ x(bd, { "data-slot": "tooltip-arrow", className: lb }), e[21] = h, e[22] = E) : E = e[22];
  const P = n ? "font-(number:--font-weight-semibold)" : "font-(number:--font-weight-regular)";
  let N;
  e[23] !== P ? (N = le(ib, P), e[23] = P, e[24] = N) : N = e[24];
  let I;
  e[25] !== o || e[26] !== N ? (I = /* @__PURE__ */ x("p", { className: N, children: o }), e[25] = o, e[26] = N, e[27] = I) : I = e[27];
  let M;
  e[28] !== n ? (M = n && /* @__PURE__ */ x("p", { className: ab, children: n }), e[28] = n, e[29] = M) : M = e[29];
  let T;
  e[30] !== E || e[31] !== I || e[32] !== M ? (T = /* @__PURE__ */ j(hd, { className: sb, children: [
    E,
    I,
    M
  ] }), e[30] = E, e[31] = I, e[32] = M, e[33] = T) : T = e[33];
  let k;
  e[34] !== g || e[35] !== p || e[36] !== S || e[37] !== T ? (k = /* @__PURE__ */ x(pd, { children: /* @__PURE__ */ x(md, { side: p, align: g, sideOffset: S, className: nb, children: T }) }), e[34] = g, e[35] = p, e[36] = S, e[37] = T, e[38] = k) : k = e[38];
  let D;
  return e[39] !== m || e[40] !== R || e[41] !== k ? (D = /* @__PURE__ */ j(cd, { disabled: m, children: [
    R,
    k
  ] }), e[39] = m, e[40] = R, e[41] = k, e[42] = D) : D = e[42], D;
}
function qr(t) {
  const e = J.c(11), {
    htmlFor: n,
    label: o,
    required: r,
    tooltip: s
  } = t;
  let i;
  e[0] !== r ? (i = r && /* @__PURE__ */ x("span", { "aria-hidden": "true", className: "text-input-required", children: "*" }), e[0] = r, e[1] = i) : i = e[1];
  let a;
  e[2] !== n || e[3] !== o || e[4] !== i ? (a = /* @__PURE__ */ j(X1, { htmlFor: n, className: "flex items-center gap-(--spacing-2) text-(length:--font-size-body-medium) leading-(--font-line-height-20) font-(number:--font-weight-semibold) text-input-text-default", children: [
    o,
    i
  ] }), e[2] = n, e[3] = o, e[4] = i, e[5] = a) : a = e[5];
  let l;
  e[6] !== s ? (l = s && /* @__PURE__ */ x(Q8, { label: s, size: "xs" }), e[6] = s, e[7] = l) : l = e[7];
  let c;
  return e[8] !== a || e[9] !== l ? (c = /* @__PURE__ */ j("div", { className: "flex items-center justify-between mb-(--spacing-4)", children: [
    a,
    l
  ] }), e[8] = a, e[9] = l, e[10] = c) : c = e[10], c;
}
const J8 = /^(\d{2})\/(\d{2})\/(\d{4})$/;
function eg(t) {
  const e = t.match(J8);
  if (!e) return null;
  const [, n, o, r] = e, s = new Date(Number(r), Number(n) - 1, Number(o));
  return s.getFullYear() !== Number(r) || s.getMonth() !== Number(n) - 1 || s.getDate() !== Number(o) ? null : s;
}
function $l(t) {
  const e = String(t.getMonth() + 1).padStart(2, "0"), n = String(t.getDate()).padStart(2, "0"), o = t.getFullYear();
  return `${e}/${n}/${o}`;
}
const e6 = ye(["flex", "items-center", "justify-between", "gap-(--spacing-4)", "w-[176px]", "rounded-(--radius-sm)", "border", "border-solid", "border-input-default-outline", "bg-input-default-background", "px-(--spacing-10)", "transition-colors", "duration-200", "ease-in-out", "cursor-text", "[&:not(:focus-within)]:hover:bg-input-hover-background", "[&:not(:focus-within)]:hover:border-input-hover-outline", "active:border-input-pressed-outline", "focus-within:border-input-active-outline"], {
  variants: {
    size: {
      sm: ["h-(--spacing-32)", "py-(--spacing-6)"],
      md: ["h-(--spacing-40)", "py-(--spacing-10)"]
    },
    hasError: {
      true: ["border-input-error-outline", "[&:not(:focus-within)]:hover:border-input-error-outline"],
      false: []
    }
  },
  defaultVariants: {
    size: "md",
    hasError: !1
  }
});
function wN(t) {
  const e = J.c(70), {
    value: n,
    onValueChange: o,
    label: r,
    size: s,
    required: i,
    description: a,
    tooltip: l,
    error: c,
    disabled: u
  } = t, d = s === void 0 ? "md" : s, f = u === void 0 ? !1 : u, [p, g] = Mt(!1);
  let m;
  e[0] !== n ? (m = n ? $l(n) : "", e[0] = n, e[1] = m) : m = e[1];
  const [h, b] = Mt(m), w = kt(null), y = kt(null), C = bn(), R = bn(), S = !!c;
  let E, P;
  e[2] !== n ? (E = () => {
    b((ne) => {
      const oe = eg(ne);
      return (n === null ? ne === "" : oe !== null && oe.getFullYear() === n.getFullYear() && oe.getMonth() === n.getMonth() && oe.getDate() === n.getDate()) ? ne : n ? $l(n) : "";
    });
  }, P = [n], e[2] = n, e[3] = E, e[4] = P) : (E = e[3], P = e[4]), rr(E, P);
  let N;
  e[5] !== o ? (N = function(oe) {
    const me = oe.target.value;
    b(me);
    const de = eg(me);
    de ? o(de) : me === "" && o(null);
  }, e[5] = o, e[6] = N) : N = e[6];
  const I = N;
  let M;
  e[7] !== o ? (M = function(oe) {
    o(oe), b(oe ? $l(oe) : ""), g(!1);
  }, e[7] = o, e[8] = M) : M = e[8];
  const T = M;
  let k;
  e[9] !== o ? (k = function() {
    o(null), b(""), g(!1), y.current?.focus();
  }, e[9] = o, e[10] = k) : k = e[10];
  const D = k, O = h, V = f && "pointer-events-none";
  let _;
  e[11] !== V ? (_ = le("flex flex-col w-fit", V), e[11] = V, e[12] = _) : _ = e[12];
  let A;
  e[13] !== C || e[14] !== r || e[15] !== i || e[16] !== l ? (A = r && /* @__PURE__ */ x(qr, { htmlFor: C, label: r, required: i, tooltip: l }), e[13] = C, e[14] = r, e[15] = i, e[16] = l, e[17] = A) : A = e[17];
  let F;
  e[18] !== f || e[19] !== S || e[20] !== d ? (F = le(e6({
    size: d,
    hasError: S
  }), f && "opacity-50"), e[18] = f, e[19] = S, e[20] = d, e[21] = F) : F = e[21];
  const H = i || void 0, Y = S || void 0, B = a || c ? R : void 0, U = S && "text-input-error-text";
  let q;
  e[22] !== U ? (q = le("flex-1 min-w-0 outline-none bg-transparent", "text-(length:--font-size-body-medium)", "leading-(--font-line-height-20)", "text-input-text-default", "placeholder:text-text-subtle", U), e[22] = U, e[23] = q) : q = e[23];
  let W;
  e[24] !== f || e[25] !== O || e[26] !== I || e[27] !== C || e[28] !== i || e[29] !== H || e[30] !== Y || e[31] !== B || e[32] !== q ? (W = /* @__PURE__ */ x("input", { id: C, ref: y, type: "text", value: O, onChange: I, placeholder: "MM/DD/YYYY", disabled: f, required: i, "aria-required": H, "aria-invalid": Y, "aria-describedby": B, className: q }), e[24] = f, e[25] = O, e[26] = I, e[27] = C, e[28] = i, e[29] = H, e[30] = Y, e[31] = B, e[32] = q, e[33] = W) : W = e[33];
  let K;
  e[34] !== f || e[35] !== D || e[36] !== n ? (K = n !== null && !f && /* @__PURE__ */ x("button", { type: "button", "aria-label": "Clear date", className: "flex items-center justify-center size-(--spacing-16) rounded-(--radius-xs) text-icon-secondary outline-none focus-visible:ring-2 focus-visible:ring-button-focus-ring", onMouseDown: t6, onClick: D, children: /* @__PURE__ */ x(Ye, { name: "x-close", size: "xs", tone: "inherit" }) }), e[34] = f, e[35] = D, e[36] = n, e[37] = K) : K = e[37];
  let te;
  e[38] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (te = /* @__PURE__ */ x(Ye, { name: "calendar", size: "xs", tone: "inherit" }), e[38] = te) : te = e[38];
  let z;
  e[39] !== f ? (z = /* @__PURE__ */ x(Du, { render: /* @__PURE__ */ x("button", { type: "button", "aria-label": "Open calendar", disabled: f, className: "flex items-center justify-center size-(--spacing-16) rounded-(--radius-xs) text-icon-main hover:text-icon-main disabled:opacity-50 outline-none focus-visible:ring-2 focus-visible:ring-button-focus-ring", children: te }) }), e[39] = f, e[40] = z) : z = e[40];
  let Q;
  e[41] !== K || e[42] !== z ? (Q = /* @__PURE__ */ j("div", { className: "flex shrink-0 items-center gap-(--spacing-6)", children: [
    K,
    z
  ] }), e[41] = K, e[42] = z, e[43] = Q) : Q = e[43];
  let ee;
  e[44] !== F || e[45] !== W || e[46] !== Q ? (ee = /* @__PURE__ */ j("div", { ref: w, className: F, children: [
    W,
    Q
  ] }), e[44] = F, e[45] = W, e[46] = Q, e[47] = ee) : ee = e[47];
  let ae;
  e[48] !== f || e[49] !== T || e[50] !== n ? (ae = /* @__PURE__ */ x(Vu, { children: /* @__PURE__ */ x(Fu, { anchor: w, side: "bottom", align: "start", sideOffset: 4, children: /* @__PURE__ */ x($u, { children: /* @__PURE__ */ x(W8, { value: n, onValueChange: T, disabled: f }) }) }) }), e[48] = f, e[49] = T, e[50] = n, e[51] = ae) : ae = e[51];
  let X;
  e[52] !== p || e[53] !== ee || e[54] !== ae ? (X = /* @__PURE__ */ j(Z1, { open: p, onOpenChange: g, modal: !1, children: [
    ee,
    ae
  ] }), e[52] = p, e[53] = ee, e[54] = ae, e[55] = X) : X = e[55];
  let se;
  e[56] !== a || e[57] !== R || e[58] !== c || e[59] !== S ? (se = S ? /* @__PURE__ */ x(br, { match: !0, id: R, className: "text-(length:--font-size-label-small) leading-(--font-line-height-16) text-input-error-text", children: c }) : a ? /* @__PURE__ */ x(Yr, { id: R, className: "text-(length:--font-size-label-small) leading-(--font-line-height-16) text-input-text-supporting", children: a }) : null, e[56] = a, e[57] = R, e[58] = c, e[59] = S, e[60] = se) : se = e[60];
  let ue;
  e[61] !== se ? (ue = /* @__PURE__ */ x("div", { "data-testid": "date-picker-subtext-row", className: "min-h-(--spacing-20) mt-(--spacing-4)", children: se }), e[61] = se, e[62] = ue) : ue = e[62];
  let re;
  return e[63] !== f || e[64] !== S || e[65] !== _ || e[66] !== A || e[67] !== X || e[68] !== ue ? (re = /* @__PURE__ */ j(hr, { invalid: S, disabled: f, className: _, children: [
    A,
    X,
    ue
  ] }), e[63] = f, e[64] = S, e[65] = _, e[66] = A, e[67] = X, e[68] = ue, e[69] = re) : re = e[69], re;
}
function t6(t) {
  return t.preventDefault();
}
const n6 = {
  default: "border-outline-subtle",
  high: "border-outline opacity-60"
}, o6 = {
  horizontal: {
    "full-width": "",
    inset: "pl-(--spacing-16)",
    "middle-inset": "px-(--spacing-16)"
  },
  vertical: {
    "full-width": "",
    inset: "pt-(--spacing-16)",
    "middle-inset": "py-(--spacing-16)"
  }
}, tg = ye(["text-text-subtext", "font-(family-name:--font-family-body)", "font-(number:--font-weight-medium)", "leading-(--font-line-height-20)", "tracking-(--font-letter-spacing-default)", "whitespace-nowrap"]);
function Ya(t) {
  const e = J.c(52);
  let n, o, r, s, i, a;
  e[0] !== t ? ({
    orientation: s,
    variant: i,
    subheader: r,
    centeredText: n,
    emphasis: a,
    ...o
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r, e[4] = s, e[5] = i, e[6] = a) : (n = e[1], o = e[2], r = e[3], s = e[4], i = e[5], a = e[6]);
  const l = s === void 0 ? "horizontal" : s, c = i === void 0 ? "full-width" : i, u = a === void 0 ? "default" : a, d = l === "vertical", f = n6[u], p = d ? "border-l" : "border-t", g = o6[l][c];
  if (!d && n) {
    let C;
    e[7] !== f || e[8] !== p ? (C = le("grow", p, f), e[7] = f, e[8] = p, e[9] = C) : C = e[9];
    let R;
    e[10] !== C ? (R = /* @__PURE__ */ x("hr", { "aria-orientation": "horizontal", className: C }), e[10] = C, e[11] = R) : R = e[11];
    let S;
    e[12] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (S = le(tg(), "shrink-0", "text-(length:--font-size-body-small)"), e[12] = S) : S = e[12];
    let E;
    e[13] !== n || e[14] !== S ? (E = /* @__PURE__ */ x("span", { className: S, children: n }), e[13] = n, e[14] = S, e[15] = E) : E = e[15];
    let P;
    e[16] !== f || e[17] !== p ? (P = le("grow", p, f), e[16] = f, e[17] = p, e[18] = P) : P = e[18];
    let N;
    e[19] !== P ? (N = /* @__PURE__ */ x("hr", { "aria-orientation": "horizontal", className: P }), e[19] = P, e[20] = N) : N = e[20];
    let I;
    return e[21] !== o || e[22] !== R || e[23] !== E || e[24] !== N ? (I = /* @__PURE__ */ j("div", { ...o, className: "flex items-center gap-(--spacing-6)", children: [
      R,
      E,
      N
    ] }), e[21] = o, e[22] = R, e[23] = E, e[24] = N, e[25] = I) : I = e[25], I;
  }
  if (!d && r) {
    let C;
    e[26] !== f || e[27] !== p ? (C = le("w-full", p, f), e[26] = f, e[27] = p, e[28] = C) : C = e[28];
    let R;
    e[29] !== C ? (R = /* @__PURE__ */ x("hr", { "aria-orientation": "horizontal", className: C }), e[29] = C, e[30] = R) : R = e[30];
    let S;
    e[31] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (S = le(tg(), "shrink-0", "text-(length:--font-size-body-medium)"), e[31] = S) : S = e[31];
    let E;
    e[32] !== r || e[33] !== S ? (E = /* @__PURE__ */ x("span", { className: S, children: r }), e[32] = r, e[33] = S, e[34] = E) : E = e[34];
    let P;
    return e[35] !== o || e[36] !== R || e[37] !== E ? (P = /* @__PURE__ */ j("div", { ...o, className: "flex flex-col gap-(--spacing-4) px-(--spacing-16)", children: [
      R,
      E
    ] }), e[35] = o, e[36] = R, e[37] = E, e[38] = P) : P = e[38], P;
  }
  const m = d ? "flex-col" : "flex-row";
  let h;
  e[39] !== g || e[40] !== m ? (h = le("flex", m, g), e[39] = g, e[40] = m, e[41] = h) : h = e[41];
  let b;
  e[42] !== f || e[43] !== p ? (b = le("grow", p, f), e[42] = f, e[43] = p, e[44] = b) : b = e[44];
  let w;
  e[45] !== l || e[46] !== b ? (w = /* @__PURE__ */ x("hr", { "aria-orientation": l, className: b }), e[45] = l, e[46] = b, e[47] = w) : w = e[47];
  let y;
  return e[48] !== o || e[49] !== h || e[50] !== w ? (y = /* @__PURE__ */ x("div", { ...o, className: h, children: w }), e[48] = o, e[49] = h, e[50] = w, e[51] = y) : y = e[51], y;
}
const _i = 8, ng = 20, r6 = 16, s6 = 20;
function cb(t) {
  return {
    offsetX: t ? t.offsetLeft : r6,
    offsetY: t ? t.offsetTop : s6,
    width: t?.offsetWidth || ng,
    height: t?.offsetHeight || ng
  };
}
function i6(t, e) {
  const n = -e.offsetX, o = -e.offsetY, r = window.innerWidth - e.offsetX - e.width, s = window.innerHeight - e.offsetY - e.height;
  return {
    x: Math.max(n, Math.min(t.x, r)),
    y: Math.max(o, Math.min(t.y, s))
  };
}
function a6(t) {
  const e = J.c(24), {
    dragHandleRef: n,
    position: o,
    onPositionChange: r,
    disabled: s
  } = t, i = s === void 0 ? !1 : s, a = v.useRef(!1), [l, c] = v.useState(!1);
  let u;
  e[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (u = {
    pointerX: 0,
    pointerY: 0,
    elementX: 0,
    elementY: 0
  }, e[0] = u) : u = e[0];
  const d = v.useRef(u);
  let f;
  e[1] !== n ? (f = (M) => i6(M, cb(n.current)), e[1] = n, e[2] = f) : f = e[2];
  const p = f;
  let g;
  e[3] !== i || e[4] !== o ? (g = (M) => {
    i || M.pointerType === "mouse" && M.button !== 0 || (M.currentTarget.setPointerCapture?.(M.pointerId), a.current = !0, c(!0), d.current = {
      pointerX: M.clientX,
      pointerY: M.clientY,
      elementX: o.x,
      elementY: o.y
    });
  }, e[3] = i, e[4] = o, e[5] = g) : g = e[5];
  const m = g;
  let h;
  e[6] !== p || e[7] !== r ? (h = (M) => {
    if (!a.current)
      return;
    const T = M.clientX - d.current.pointerX, k = M.clientY - d.current.pointerY;
    r(p({
      x: d.current.elementX + T,
      y: d.current.elementY + k
    }));
  }, e[6] = p, e[7] = r, e[8] = h) : h = e[8];
  const b = h;
  let w;
  e[9] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (w = () => a.current ? (a.current = !1, c(!1), !0) : !1, e[9] = w) : w = e[9];
  const y = w;
  let C;
  e[10] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (C = (M) => {
    y() && M.currentTarget.releasePointerCapture?.(M.pointerId);
  }, e[10] = C) : C = e[10];
  const R = C;
  let S;
  e[11] !== p || e[12] !== i || e[13] !== r || e[14] !== o ? (S = (M) => {
    if (i || M.target !== M.currentTarget)
      return;
    let T = 0, k = 0;
    if (M.key === "ArrowLeft")
      T = -_i;
    else if (M.key === "ArrowRight")
      T = _i;
    else if (M.key === "ArrowUp")
      k = -_i;
    else if (M.key === "ArrowDown")
      k = _i;
    else
      return;
    M.preventDefault(), r(p({
      x: o.x + T,
      y: o.y + k
    }));
  }, e[11] = p, e[12] = i, e[13] = r, e[14] = o, e[15] = S) : S = e[15];
  const E = S;
  let P;
  e[16] !== E || e[17] !== m || e[18] !== b ? (P = {
    onPointerDown: m,
    onPointerMove: b,
    onPointerUp: R,
    onPointerCancel: y,
    onLostPointerCapture: y,
    onKeyDown: E,
    tabIndex: 0,
    "aria-label": "Drag to reposition",
    "data-slot": "dialog-drag-handle"
  }, e[16] = E, e[17] = m, e[18] = b, e[19] = P) : P = e[19];
  const N = P;
  let I;
  return e[20] !== n || e[21] !== l || e[22] !== N ? (I = {
    dragHandleRef: n,
    isDragging: l,
    dragHandleProps: N
  }, e[20] = n, e[21] = l, e[22] = N, e[23] = I) : I = e[23], I;
}
const og = 550, rg = 400, l6 = 16, c6 = ye(["fixed", "inset-0", "z-50"], {
  variants: {
    expanded: {
      true: ["pointer-events-none", "flex", "items-center", "justify-center", "p-(--spacing-16)"],
      false: "pointer-events-none"
    }
  }
}), u6 = ye(["flex", "flex-col", "overflow-hidden", "rounded-(--radius-sm)", "bg-surface-container-lowest", "shadow-elevation-5"], {
  variants: {
    expanded: {
      true: ["pointer-events-auto", "w-[min(1263px,calc(100vw_-_var(--spacing-32)))]", "max-h-[min(1136px,calc(100vh_-_var(--spacing-32)))]", "outline-none"],
      false: ["pointer-events-auto", "fixed", "z-50", "h-[min(400px,100vh)]", "w-[min(550px,100vw)]"]
    }
  }
}), d6 = ye(["shrink-0", "bg-surface-container-lowest", "px-(--spacing-24)", "py-(--spacing-16)", "shadow-elevation-1"]), f6 = ye(["flex", "shrink-0", "flex-col", "gap-(--spacing-6)", "p-(--spacing-16)"]), sg = ye(["font-(family-name:--font-family-title)", "text-(length:--font-size-title-lg)", "font-(number:--font-weight-bold)", "leading-(--font-line-height-28)", "text-text-default"]), ig = ye(["text-(length:--font-size-body-medium)", "leading-(--font-line-height-20)", "text-text-subtext"]), p6 = ye(["mt-(--spacing-4)", "flex", "size-(--spacing-20)", "shrink-0", "items-center", "justify-center", "rounded-(--radius-sm)", "border-0", "bg-transparent", "p-0", "select-none", "outline-none", "focus-visible:ring-2", "focus-visible:ring-button-focus-ring", "focus-visible:ring-offset-1", "focus-visible:ring-offset-surface"]), g6 = ye(["min-h-0", "flex-1"], {
  variants: {
    expanded: {
      true: "flex",
      false: ["overflow-y-auto", "p-(--spacing-16)"]
    }
  }
}), m6 = ye([], {
  variants: {
    expanded: {
      true: ["min-w-0", "flex-1", "overflow-y-auto", "p-(--spacing-16)"],
      false: "contents"
    }
  }
}), ag = ye(["flex", "min-h-(--spacing-40)", "shrink-0", "items-center", "gap-(--spacing-16)", "px-(--spacing-16)", "pb-(--spacing-16)"]);
function ub() {
  return typeof window > "u" ? {
    width: og,
    height: rg
  } : {
    width: Math.min(og, window.innerWidth),
    height: Math.min(rg, window.innerHeight)
  };
}
function Vi(t, e = ub()) {
  return typeof window > "u" ? t : {
    x: Math.max(0, Math.min(t.x, window.innerWidth - e.width)),
    y: Math.max(0, Math.min(t.y, window.innerHeight - e.height))
  };
}
function lg(t, e) {
  if (typeof window > "u") return t;
  const n = cb(e);
  return {
    x: Math.max(-n.offsetX, Math.min(t.x, window.innerWidth - n.offsetX - n.width)),
    y: Math.max(-n.offsetY, Math.min(t.y, window.innerHeight - n.offsetY - n.height))
  };
}
function h6(t) {
  if (typeof window > "u") return {
    x: 0,
    y: 0
  };
  const {
    innerWidth: e,
    innerHeight: n
  } = window, o = ub(), r = Math.min(l6, e, n), s = e - o.width - r, i = n - o.height - r;
  switch (t) {
    case "top-start":
      return Vi({
        x: r,
        y: r
      }, o);
    case "top-end":
      return Vi({
        x: s,
        y: r
      }, o);
    case "bottom-start":
      return Vi({
        x: r,
        y: i
      }, o);
    case "bottom-end":
      return Vi({
        x: s,
        y: i
      }, o);
  }
}
function CN({
  open: t,
  onOpenChange: e,
  expanded: n = !1,
  onExpandedChange: o,
  initialPlacement: r = "bottom-end",
  position: s,
  onPositionChange: i,
  heading: a,
  description: l,
  headerAccessory: c,
  expandedAside: u,
  children: d,
  floatingFooter: f,
  expandedFooter: p
}) {
  const g = !!n, m = s !== void 0, [h, b] = v.useState(() => h6(r)), w = s ?? h, y = v.useRef(null), C = (N) => {
    m || b(N), i?.(N);
  }, R = t && !g ? lg(w, y.current) : w, {
    isDragging: S,
    dragHandleProps: E
  } = a6({
    dragHandleRef: y,
    position: R,
    onPositionChange: C,
    disabled: g
  });
  return v.useEffect(() => {
    if (!t || g || typeof window > "u") return;
    const N = () => {
      const I = lg({
        x: w.x,
        y: w.y
      }, y.current);
      (I.x !== w.x || I.y !== w.y) && (m || b(I), i?.(I));
    };
    return N(), window.addEventListener("resize", N), () => window.removeEventListener("resize", N);
  }, [w.x, w.y, m, g, i, t]), /* @__PURE__ */ x($a, { open: t, onOpenChange: (N, I) => {
    const M = I?.reason === "outside-press" || I?.reason === "focus-out";
    if (!g && !N && M) {
      I.cancel();
      return;
    }
    e(N);
  }, modal: g, disablePointerDismissal: !g, children: /* @__PURE__ */ j(Qs, { children: [
    g && /* @__PURE__ */ x(Fa, { "data-slot": "dialog-scrim", className: "fixed inset-0 z-50 bg-surface-scrim" }),
    /* @__PURE__ */ x(ei, { className: le(c6({
      expanded: g
    })), children: /* @__PURE__ */ j(La, { "aria-modal": g ? "true" : void 0, "data-slot": g ? "dialog-expanded" : "dialog", initialFocus: g ? void 0 : () => y.current, className: le(u6({
      expanded: g
    })), style: g ? void 0 : {
      left: R.x,
      top: R.y
    }, children: [
      g ? /* @__PURE__ */ j("div", { "data-slot": "dialog-expanded-header", className: le(d6()), children: [
        /* @__PURE__ */ j("div", { className: "flex items-center justify-between", children: [
          /* @__PURE__ */ j("div", { className: "flex min-w-0 flex-1 items-center gap-(--spacing-16)", children: [
            /* @__PURE__ */ x(Ms, { className: le(sg(), "whitespace-nowrap"), children: a }),
            c && /* @__PURE__ */ x("div", { className: "flex min-w-0 items-center gap-(--spacing-16)", children: c })
          ] }),
          /* @__PURE__ */ j("div", { className: "flex shrink-0 items-center gap-(--spacing-16)", children: [
            o && /* @__PURE__ */ x(Kt, { variant: "ghost", size: "sm", icon: "expand-regular", "aria-label": "Collapse", onClick: () => o(!1) }),
            /* @__PURE__ */ x(Ps, { render: /* @__PURE__ */ x(Kt, { variant: "ghost", size: "sm", icon: "x-close", "aria-label": "Close" }) })
          ] })
        ] }),
        l && /* @__PURE__ */ x(Ns, { className: le(ig(), "mt-(--spacing-6)"), children: l })
      ] }) : /* @__PURE__ */ x("div", { className: le(f6()), children: /* @__PURE__ */ j("div", { className: "flex items-start justify-between gap-(--spacing-6)", children: [
        /* @__PURE__ */ j("div", { className: "flex min-w-0 flex-1 gap-(--spacing-8)", children: [
          /* @__PURE__ */ x("button", { type: "button", ref: y, ...E, className: le(p6(), S ? "cursor-grabbing" : "cursor-grab"), children: /* @__PURE__ */ x(Ye, { name: "drag", size: "sm", tone: "secondary" }) }),
          /* @__PURE__ */ j("div", { className: "min-w-0 flex-1", children: [
            /* @__PURE__ */ j("div", { className: "flex items-center gap-(--spacing-8)", children: [
              /* @__PURE__ */ x(Ms, { className: le(sg(), "min-w-0"), children: a }),
              c && /* @__PURE__ */ x("span", { className: "shrink-0", children: c })
            ] }),
            l && /* @__PURE__ */ x(Ns, { className: le(ig(), "mt-(--spacing-4)"), children: l })
          ] })
        ] }),
        /* @__PURE__ */ j("div", { className: "flex shrink-0 items-center gap-(--spacing-4)", children: [
          o && /* @__PURE__ */ x(Kt, { variant: "ghost", size: "sm", icon: "expand-regular", "aria-label": "Expand", onClick: () => o(!0) }),
          /* @__PURE__ */ x(Ps, { render: /* @__PURE__ */ x(Kt, { variant: "ghost", size: "sm", icon: "x-close", "aria-label": "Close" }) })
        ] })
      ] }) }),
      /* @__PURE__ */ j("div", { className: le(g6({
        expanded: g
      })), children: [
        g && u && /* @__PURE__ */ j(_o, { children: [
          /* @__PURE__ */ x("div", { className: "min-w-0 basis-1/2 overflow-y-auto p-(--spacing-16)", children: u }),
          /* @__PURE__ */ x(Ya, { orientation: "vertical" })
        ] }),
        /* @__PURE__ */ x("div", { className: le(m6({
          expanded: g
        })), children: d }, "body")
      ] }),
      g ? p && /* @__PURE__ */ x("div", { className: le(ag()), children: p }) : f && /* @__PURE__ */ x("div", { className: le(ag()), children: f })
    ] }) })
  ] }) });
}
let jt = /* @__PURE__ */ (function(t) {
  return t.nestedDrawers = "--nested-drawers", t.height = "--drawer-height", t.frontmostHeight = "--drawer-frontmost-height", t.swipeMovementX = "--drawer-swipe-movement-x", t.swipeMovementY = "--drawer-swipe-movement-y", t.snapPointOffset = "--drawer-snap-point-offset", t.swipeStrength = "--drawer-swipe-strength", t;
})({}), ho = /* @__PURE__ */ (function(t) {
  return t.swipeProgress = "--drawer-swipe-progress", t;
})({});
const b6 = {
  ...xn,
  ...Lt
}, db = /* @__PURE__ */ v.forwardRef(function(e, n) {
  const {
    render: o,
    className: r,
    style: s,
    forceRender: i = !1,
    ...a
  } = e, {
    store: l
  } = cn(), c = l.useState("open"), u = l.useState("nested"), d = l.useState("mounted"), f = l.useState("transitionStatus");
  return Te("div", e, {
    state: {
      open: c,
      transitionStatus: f
    },
    ref: [l.context.backdropRef, n],
    stateAttributesMapping: b6,
    props: [{
      role: "presentation",
      hidden: !d,
      style: {
        pointerEvents: c ? void 0 : "none",
        userSelect: "none",
        WebkitUserSelect: "none",
        [ho.swipeProgress]: "0",
        [jt.swipeStrength]: "1"
      }
    }, a],
    enabled: i || !u
  });
});
process.env.NODE_ENV !== "production" && (db.displayName = "DrawerBackdrop");
const fb = Ps, pb = "data-drawer-content", gb = /* @__PURE__ */ v.forwardRef(function(e, n) {
  const {
    render: o,
    className: r,
    style: s,
    ...i
  } = e;
  return cn(), Te("div", e, {
    ref: n,
    props: [{
      [pb]: ""
    }, i]
  });
});
process.env.NODE_ENV !== "production" && (gb.displayName = "DrawerContent");
const v6 = Ns, mb = /* @__PURE__ */ v.createContext(void 0);
process.env.NODE_ENV !== "production" && (mb.displayName = "DrawerProviderContext");
function hb(t) {
  return v.useContext(mb);
}
let Fn = (function(t) {
  return t[t.open = rn.open] = "open", t[t.closed = rn.closed] = "closed", t[t.startingStyle = rn.startingStyle] = "startingStyle", t[t.endingStyle = rn.endingStyle] = "endingStyle", t.expanded = "data-expanded", t.nestedDrawerOpen = "data-nested-drawer-open", t.nestedDrawerSwiping = "data-nested-drawer-swiping", t.swipeDismiss = "data-swipe-dismiss", t.swipeDirection = "data-swipe-direction", t.swiping = "data-swiping", t;
})({});
const vd = /* @__PURE__ */ v.createContext(void 0);
process.env.NODE_ENV !== "production" && (vd.displayName = "DrawerRootContext");
function Ga(t) {
  const e = v.useContext(vd);
  if (t === !1 && e === void 0)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: DrawerRootContext is missing. Drawer parts must be placed within <Drawer.Root>." : Xe(90));
  return e;
}
function cg(t, e, n) {
  if (!Number.isFinite(e) || e <= 0)
    return null;
  if (typeof t == "number")
    return Number.isFinite(t) ? t <= 1 ? $t(t, 0, 1) * e : t : null;
  const o = t.trim();
  if (o.endsWith("px")) {
    const r = Number.parseFloat(o);
    return Number.isFinite(r) ? r : null;
  }
  if (o.endsWith("rem")) {
    const r = Number.parseFloat(o);
    return Number.isFinite(r) ? r * n : null;
  }
  return null;
}
function y6(t, e) {
  let n = null, o = 1 / 0;
  for (const r of e) {
    const s = Math.abs(r.height - t);
    s < o && (o = s, n = r);
  }
  return n;
}
function bb() {
  const {
    store: t
  } = cn(), {
    snapPoints: e,
    activeSnapPoint: n,
    setActiveSnapPoint: o,
    popupHeight: r
  } = Ga(), s = t.useState("viewportElement"), [i, a] = v.useState(0), [l, c] = v.useState(16), u = ge(() => {
    const g = Ke(s).documentElement;
    s && a(s.offsetHeight), s || a(g.clientHeight);
    const m = parseFloat(getComputedStyle(g).fontSize);
    Number.isFinite(m) && c(m);
  });
  xe(() => {
    if (u(), !s || typeof ResizeObserver != "function")
      return;
    const p = new ResizeObserver(u);
    return p.observe(s), () => {
      p.disconnect();
    };
  }, [u, s]);
  const d = v.useMemo(() => {
    if (!e || e.length === 0 || i <= 0 || r <= 0)
      return [];
    const p = Math.min(r, i);
    if (!Number.isFinite(p) || p <= 0)
      return [];
    const g = e.map((b) => {
      const w = cg(b, i, l);
      if (w === null || !Number.isFinite(w))
        return null;
      const y = $t(w, 0, p);
      return {
        value: b,
        height: y,
        offset: Math.max(0, r - y)
      };
    }).filter((b) => !!b);
    if (g.length <= 1)
      return g;
    const m = [], h = [];
    for (let b = g.length - 1; b >= 0; b -= 1) {
      const w = g[b];
      h.some((C) => Math.abs(C - w.height) <= 1) || (h.push(w.height), m.push(w));
    }
    return m.reverse(), m;
  }, [r, l, e, i]), f = v.useMemo(() => {
    if (n === void 0)
      return d[0];
    if (n === null)
      return;
    const p = d.find((b) => Object.is(b.value, n));
    if (p)
      return p;
    const g = Math.min(r, i), m = cg(n, i, l);
    if (m === null || !Number.isFinite(m))
      return;
    const h = $t(m, 0, g);
    return y6(h, d) ?? void 0;
  }, [n, r, d, l, i]);
  return {
    snapPoints: e,
    activeSnapPoint: n,
    setActiveSnapPoint: o,
    popupHeight: r,
    viewportHeight: i,
    resolvedSnapPoints: d,
    activeSnapPointOffset: f?.offset ?? null
  };
}
const yd = /* @__PURE__ */ v.createContext(null);
process.env.NODE_ENV !== "production" && (yd.displayName = "DrawerViewportContext");
function x6(t) {
  return v.useContext(yd);
}
let ug = !1;
function w6() {
  ug || (typeof CSS < "u" && "registerProperty" in CSS && ([jt.swipeMovementX, jt.swipeMovementY, jt.snapPointOffset].forEach((t) => {
    try {
      CSS.registerProperty({
        name: t,
        syntax: "<length>",
        inherits: !1,
        initialValue: "0px"
      });
    } catch {
    }
  }), [{
    name: ho.swipeProgress,
    initialValue: "0"
  }, {
    name: jt.swipeStrength,
    initialValue: "1"
  }].forEach(({
    name: t,
    initialValue: e
  }) => {
    try {
      CSS.registerProperty({
        name: t,
        syntax: "<number>",
        inherits: !1,
        initialValue: e
      });
    } catch {
    }
  })), ug = !0);
}
const C6 = {
  ...xn,
  ...Lt,
  expanded(t) {
    return t ? {
      [Fn.expanded]: ""
    } : null;
  },
  nestedDrawerOpen(t) {
    return t ? {
      [Fn.nestedDrawerOpen]: ""
    } : null;
  },
  nestedDrawerSwiping(t) {
    return t ? {
      [Fn.nestedDrawerSwiping]: ""
    } : null;
  },
  swipeDirection(t) {
    return t ? {
      [Fn.swipeDirection]: t
    } : null;
  },
  swiping(t) {
    return t ? {
      [Fn.swiping]: ""
    } : null;
  }
}, vb = /* @__PURE__ */ v.forwardRef(function(e, n) {
  const {
    className: o,
    finalFocus: r,
    initialFocus: s,
    render: i,
    style: a,
    ...l
  } = e, {
    store: c
  } = cn(), {
    swipeDirection: u,
    frontmostHeight: d,
    hasNestedDrawer: f,
    nestedSwiping: p,
    nestedSwipeProgressStore: g,
    onPopupHeightChange: m,
    notifyParentFrontmostHeight: h,
    notifyParentHasNestedDrawer: b
  } = Ga(), w = c.useState("descriptionElementId"), y = c.useState("disablePointerDismissal"), C = c.useState("floatingRootContext"), R = c.useState("popupProps"), S = c.useState("modal"), E = c.useState("mounted"), P = c.useState("nested"), N = c.useState("nestedOpenDrawerCount"), I = c.useState("transitionStatus"), M = c.useState("open"), T = c.useState("openMethod"), k = c.useState("titleElementId"), D = c.useState("role"), O = N > 0, V = x6(), _ = V?.swiping ?? !1, A = V?.swipeStrength ?? null, {
    snapPoints: F,
    activeSnapPoint: H,
    activeSnapPointOffset: Y
  } = bb();
  Cu();
  const [B, U] = v.useState(0), q = v.useRef(0);
  process.env.NODE_ENV !== "production" && v.useEffect(() => {
    if (V)
      return;
    const ue = Jo.captureOwnerStack?.() || "";
    Vo(`<Drawer.Popup> expected to be rendered within <Drawer.Viewport>. Omitting the viewport disables drawer swipe handling and touch scroll locking. Wrap <Drawer.Popup> in <Drawer.Viewport>.${ue}`);
  }, [V]);
  const W = ge(() => {
    const ue = c.context.popupRef.current;
    if (!ue)
      return;
    const re = ue.offsetHeight;
    if (q.current > 0 && d > q.current && re > q.current)
      return;
    if (q.current > 0 && f) {
      const me = q.current;
      U(me), m(me);
      return;
    }
    const oe = re;
    oe !== q.current && (q.current = oe, U(oe), m(oe));
  });
  xe(() => {
    if (!E) {
      q.current = 0, U(0), m(0);
      return;
    }
    const ue = c.context.popupRef.current;
    if (!ue || (w6(), W(), typeof ResizeObserver != "function"))
      return;
    const re = new ResizeObserver(W);
    return re.observe(ue), () => {
      re.disconnect();
    };
  }, [W, E, O, m, c.context.popupRef]), xe(() => {
    const ue = c.context.popupRef, re = () => {
      const oe = ue.current;
      if (!oe)
        return;
      const me = g.getSnapshot();
      me > 0 ? oe.style.setProperty(ho.swipeProgress, `${me}`) : oe.style.setProperty(ho.swipeProgress, "0");
    };
    re();
    const ne = g.subscribe(re);
    return () => {
      ne();
      const oe = ue.current;
      oe && oe.style.setProperty(ho.swipeProgress, "0");
    };
  }, [g, c.context.popupRef]), v.useEffect(() => {
    if (M)
      return h?.(d), () => {
        h?.(0);
      };
  }, [d, M, h]), v.useEffect(() => b ? (b(M || I === "ending"), () => {
    b(!1);
  }) : void 0, [b, M, I]), Bt({
    open: M,
    ref: c.context.popupRef,
    onComplete() {
      M && c.context.onOpenChangeComplete?.(!0);
    }
  });
  const K = s === void 0 ? c.context.popupRef : s, te = {
    open: M,
    nested: P,
    transitionStatus: I,
    expanded: H === 1,
    nestedDrawerOpen: O,
    nestedDrawerSwiping: p,
    swipeDirection: u,
    swiping: _
  };
  let z;
  B && !(!f && I !== "ending") && (z = `${B}px`);
  const ee = F && F.length > 0 && (u === "down" || u === "up");
  let ae = null;
  ee && Y !== null && (ae = u === "up" ? -Y : Y);
  let X = V ? V.getDragStyles() : yt;
  if (ee && u === "down") {
    const ue = Y ?? 0, re = Number.parseFloat(String(X[jt.swipeMovementY] ?? 0)), ne = Number.isFinite(re) ? ue + re : ue, oe = ne < 0;
    if (_ && oe && Number.isFinite(re)) {
      const me = Math.abs(ne), he = -Math.sqrt(me) - ue;
      X = {
        ...X,
        transform: void 0,
        [jt.swipeMovementY]: `${he}px`
      };
    } else
      X = {
        ...X,
        transform: void 0
      };
  }
  const se = Te("div", e, {
    state: te,
    props: [R, {
      "aria-labelledby": k,
      "aria-describedby": w,
      role: D,
      tabIndex: -1,
      hidden: !E,
      onKeyDown(ue) {
        Zs.has(ue.key) && ue.stopPropagation();
      },
      style: {
        ...X,
        [ho.swipeProgress]: "0",
        [jt.nestedDrawers]: N,
        [jt.height]: z,
        [jt.snapPointOffset]: typeof ae == "number" ? `${ae}px` : "0px",
        [jt.frontmostHeight]: d ? `${d}px` : void 0,
        [jt.swipeStrength]: typeof A == "number" && Number.isFinite(A) && A > 0 ? `${A}` : "1"
      }
    }, l],
    ref: [n, c.context.popupRef, c.useStateSetter("popupElement")],
    stateAttributesMapping: C6
  });
  return /* @__PURE__ */ x(zr, {
    context: C,
    openInteractionType: T,
    disabled: !E,
    closeOnFocusOut: !y,
    initialFocus: K,
    returnFocus: r,
    modal: S !== !1,
    restoreFocus: "popup",
    children: se
  });
});
process.env.NODE_ENV !== "production" && (vb.displayName = "DrawerPopup");
const S6 = Qs;
var dg, fg;
function R6(t) {
  const {
    children: e,
    open: n,
    defaultOpen: o = !1,
    onOpenChange: r,
    onOpenChangeComplete: s,
    disablePointerDismissal: i = !1,
    modal: a = !0,
    actionsRef: l,
    handle: c,
    triggerId: u,
    defaultTriggerId: d = null,
    swipeDirection: f = "down",
    snapToSequentialPoints: p = !1,
    snapPoints: g,
    snapPoint: m,
    defaultSnapPoint: h,
    onSnapPointChange: b
  } = t, w = ge(b), y = Ga(!0), C = y?.onNestedSwipeProgressChange, R = y?.onNestedFrontmostHeightChange, S = y?.onNestedSwipingChange, E = y?.onNestedDrawerPresenceChange, [P, N] = v.useState(0), [I, M] = v.useState(0), [T, k] = v.useState(!1), [D, O] = v.useState(!1), [V] = v.useState(E6), _ = h !== void 0 ? h : g?.[0] ?? null, A = m !== void 0, [F, H] = sn({
    controlled: m,
    default: _,
    name: "Drawer",
    state: "snapPoint"
  }), Y = v.useRef(!1), B = ge((X, se) => {
    const ue = se ?? Pe(Et);
    w?.(X, ue), !ue.isCanceled && H(X);
  }), U = v.useMemo(() => A || !g || g.length === 0 ? F : F === null || !g.some((X) => Object.is(X, F)) ? _ : F, [F, A, _, g]), q = ge((X) => {
    N(X), !Y.current && X > 0 && M(X);
  }), W = ge((X) => {
    if (X > 0) {
      Y.current = !0, M(X);
      return;
    }
    Y.current = !1, P > 0 && M(P);
  }), K = ge((X) => {
    k(X);
  }), te = ge((X) => {
    V.set(X), C?.(X);
  }), z = ge((X) => {
    O(X), S?.(X);
  }), Q = ge((X, se) => {
    r?.(X, se), !se.isCanceled && !X && g && g.length > 0 && B(_, Pe(se.reason, se.event, se.trigger));
  }), ee = v.useMemo(() => ({
    swipeDirection: f,
    snapToSequentialPoints: p,
    snapPoints: g,
    activeSnapPoint: U,
    setActiveSnapPoint: B,
    frontmostHeight: I,
    popupHeight: P,
    hasNestedDrawer: T,
    nestedSwiping: D,
    nestedSwipeProgressStore: V,
    onNestedDrawerPresenceChange: K,
    onPopupHeightChange: q,
    onNestedFrontmostHeightChange: W,
    onNestedSwipingChange: z,
    onNestedSwipeProgressChange: te,
    notifyParentFrontmostHeight: R,
    notifyParentSwipingChange: S,
    notifyParentSwipeProgressChange: C,
    notifyParentHasNestedDrawer: E
  }), [U, I, T, D, V, E, C, S, R, K, W, te, z, q, P, B, g, p, f]), ae = typeof e == "function" ? (X) => /* @__PURE__ */ j(v.Fragment, {
    children: [dg || (dg = /* @__PURE__ */ x(pg, {})), e(X)]
  }) : /* @__PURE__ */ j(v.Fragment, {
    children: [fg || (fg = /* @__PURE__ */ x(pg, {})), e]
  });
  return /* @__PURE__ */ x(vd.Provider, {
    value: ee,
    children: /* @__PURE__ */ x(da.Provider, {
      value: !0,
      children: /* @__PURE__ */ x($a, {
        open: n,
        defaultOpen: o,
        onOpenChange: Q,
        onOpenChangeComplete: s,
        disablePointerDismissal: i,
        modal: a,
        actionsRef: l,
        handle: c,
        triggerId: u,
        defaultTriggerId: d,
        children: ae
      })
    })
  });
}
function E6() {
  let t = 0;
  const e = /* @__PURE__ */ new Set();
  return {
    getSnapshot: () => t,
    set(n) {
      const o = Number.isFinite(n) ? n : 0;
      o !== t && (t = o, e.forEach((r) => {
        r();
      }));
    },
    subscribe(n) {
      return e.add(n), () => {
        e.delete(n);
      };
    }
  };
}
function pg() {
  const t = wo(), e = hb(), n = cn(!1), o = n.store.useState("open"), r = n.store.useState("nestedOpenDialogCount"), s = n.store.useState("popupElement"), i = r === 0;
  return v.useEffect(() => {
    if (!(!e || t == null))
      return () => {
        e.removeDrawer(t);
      };
  }, [t, e]), v.useEffect(() => {
    t != null && e?.setDrawerOpen(t, o);
  }, [t, o, e]), v.useEffect(() => {
    if (!o || !i || !xs)
      return;
    const l = vt(s).CloseWatcher;
    if (!l)
      return;
    function c(f) {
      n.store.select("open") && n.store.setOpen(!1, Pe(Dy, f));
    }
    const u = new l(), d = rt(u, "close", c);
    return () => {
      d(), u.destroy();
    };
  }, [n.store, i, o, s]), null;
}
function Cc(t, e) {
  const n = an(t);
  if (e === "vertical") {
    const r = n.overflowY;
    return (r === "auto" || r === "scroll") && t.scrollHeight > t.clientHeight;
  }
  const o = n.overflowX;
  return (o === "auto" || o === "scroll") && t.scrollWidth > t.clientWidth;
}
function P6(t, e, n) {
  let o = t;
  for (; o && o !== e; ) {
    for (const r of n)
      if (Cc(o, r))
        return !0;
    o = o.parentElement;
  }
  return !1;
}
function Rr(t, e, n = "vertical") {
  let o = bt(t) ? t : null;
  for (; o && o !== e; ) {
    if (Cc(o, n))
      return o;
    o = o.parentElement;
  }
  return Cc(e, n) ? e : null;
}
function Xi(t, e, n) {
  return typeof t?.elementFromPoint == "function" ? t.elementFromPoint(e, n) : null;
}
const N6 = 40, I6 = 10, M6 = 1, T6 = 50, gg = 16, k6 = 80, O6 = 'button,a,input,select,textarea,label,[role="button"]';
function zl(t, e, n) {
  switch (t) {
    case "up":
      return -n;
    case "down":
      return n;
    case "left":
      return -e;
    case "right":
      return e;
    default:
      return 0;
  }
}
function D6(t) {
  const n = vt(t).getComputedStyle(t).transform;
  let o = 0, r = 0, s = 1;
  if (n && n !== "none") {
    const i = n.match(/matrix(?:3d)?\(([^)]+)\)/);
    if (i) {
      const a = i[1].split(", ").map(parseFloat);
      a.length === 6 ? (o = a[4], r = a[5], s = Math.sqrt(a[0] * a[0] + a[1] * a[1])) : a.length === 16 && (o = a[12], r = a[13], s = a[0]);
    }
  }
  return {
    x: o,
    y: r,
    scale: s
  };
}
function Ai(t) {
  return Number.isFinite(t) && t > 0 ? t : null;
}
function _6(t) {
  return t % 2 === 1;
}
function Hl(t, e, n) {
  const o = t[n];
  if (typeof o == "function")
    try {
      o.call(t, e);
    } catch (r) {
      if (r && typeof r == "object" && "name" in r && r.name === "NotFoundError")
        return;
      throw r;
    }
}
function V6(t) {
  const {
    enabled: e,
    directions: n,
    elementRef: o,
    movementCssVars: r,
    canStart: s,
    ignoreSelectorWhenTouch: i = !0,
    ignoreScrollableAncestors: a = !1,
    swipeThreshold: l,
    onDismiss: c,
    onProgress: u,
    onCancel: d,
    onSwipeStart: f,
    onRelease: p,
    onSwipingChange: g,
    trackDrag: m = !0
  } = t, h = O6, b = n.length === 1 ? n[0] : void 0, w = Math.max(0, typeof l == "number" ? l : N6), y = n.includes("left"), C = n.includes("right"), R = n.includes("up"), S = n.includes("down"), E = y || C, P = R || S, N = v.useMemo(() => {
    const ve = [];
    return P && ve.push("vertical"), E && ve.push("horizontal"), ve;
  }, [E, P]), [I, M] = v.useState(void 0), [T, k] = v.useState(!1), [D, O] = v.useState(!1), [V, _] = v.useState(!1), [A, F] = v.useState({
    x: 0,
    y: 0
  }), [H, Y] = v.useState({
    x: 0,
    y: 0,
    scale: 1
  }), [B, U] = v.useState(null), q = v.useRef({
    x: 0,
    y: 0
  }), W = v.useRef({
    x: 0,
    y: 0
  }), K = v.useRef(null), te = v.useRef({
    x: 0,
    y: 0,
    scale: 1
  }), z = v.useRef(void 0), Q = v.useRef(0), ee = v.useRef(!1), ae = v.useRef({
    x: 0,
    y: 0
  }), X = v.useRef(!1), se = v.useRef(!1), ue = v.useRef(null), re = v.useRef(!1), ne = v.useRef(!1), oe = v.useRef({
    width: 0,
    height: 0
  }), me = v.useRef(0), de = v.useRef(w), he = v.useRef(null), $ = v.useRef(null), Z = v.useRef({
    x: 0,
    y: 0
  }), L = v.useRef(null), G = v.useRef(!1), ie = ge((ve) => {
    G.current !== ve && (G.current = ve, k(ve), g?.(ve));
  });
  function pe(ve) {
    if (!ve)
      return;
    if (typeof l != "function") {
      de.current = w;
      return;
    }
    const we = o.current;
    if (!we)
      return;
    const Ve = l({
      element: we,
      direction: ve
    });
    de.current = Math.max(0, Ve);
  }
  const be = ge((ve, we) => {
    const Ve = Number.isFinite(ve) ? $t(ve, 0, 1) : 0, He = Ve !== me.current;
    let ct = !1;
    if (we) {
      const qe = L.current;
      ct = !qe || qe.deltaX !== we.deltaX || qe.deltaY !== we.deltaY || qe.direction !== we.direction;
    }
    !He && !ct || (me.current = Ve, we ? L.current = we : He && (L.current = null), u?.(Ve, we));
  });
  function Re(ve, we) {
    if (we === null)
      return;
    const Ve = $.current;
    if (Ve && we > Ve.time) {
      const He = Math.max(we - Ve.time, gg);
      Z.current = {
        x: (ve.x - Ve.x) / He,
        y: (ve.y - Ve.y) / He
      };
    }
    $.current = {
      x: ve.x,
      y: ve.y,
      time: we
    };
  }
  const _e = v.useCallback(() => {
    M(void 0), ie(!1), O(!1), _(!1), F({
      x: 0,
      y: 0
    }), Y({
      x: 0,
      y: 0,
      scale: 1
    }), U(null), be(0), de.current = w, q.current = {
      x: 0,
      y: 0
    }, W.current = {
      x: 0,
      y: 0
    }, te.current = {
      x: 0,
      y: 0,
      scale: 1
    }, z.current = void 0, Q.current = 0, ee.current = !1, ae.current = {
      x: 0,
      y: 0
    }, X.current = !1, K.current = null, se.current = !1, ue.current = null, re.current = !1, ne.current = !1, oe.current = {
      width: 0,
      height: 0
    }, he.current = null, $.current = null, Z.current = {
      x: 0,
      y: 0
    }, L.current = null;
  }, [ie, w, be]);
  v.useEffect(() => {
    typeof l != "function" && (de.current = w);
  }, [w, l]);
  function ke(ve) {
    if ("touches" in ve) {
      const we = ve.touches[0];
      return we ? {
        x: we.clientX,
        y: we.clientY
      } : null;
    }
    return {
      x: ve.clientX,
      y: ve.clientY
    };
  }
  function Se(ve) {
    return "touches" in ve ? !0 : ve.pointerType === "touch";
  }
  function Ie(ve, we) {
    const Ve = Ke(o.current);
    return Xi(Ve, ve.x, ve.y) ?? gt(we);
  }
  function Le(ve, we) {
    return E && !P ? Rr(ve, we, "horizontal") : P && !E ? Rr(ve, we, "vertical") : Rr(ve, we, "vertical") ?? Rr(ve, we, "horizontal");
  }
  function Ze(ve, we, Ve) {
    re.current = !1;
    const He = Se(ve), ct = Ie(we, ve.nativeEvent), it = Ke(o.current).body, Ue = He && it ? Le(ct, it) : null, We = Ve?.ignoreScrollableTarget ?? !1;
    if (Ue && !We || (re.current = !!(Ue && We), (ct ? ct.closest(h) : !1) && (!He || i)))
      return !1;
    const nt = o.current;
    if (a && nt && ct && N.length > 0 && !(Ve?.ignoreScrollableAncestors ?? !1) && P6(ct, nt, N))
      return !1;
    if (ee.current = !1, z.current = void 0, Q.current = 0, q.current = we, he.current = Ai(ve.timeStamp), ae.current = we, K.current = we, nt) {
      oe.current = {
        width: nt.offsetWidth,
        height: nt.offsetHeight
      }, pe(b);
      const dt = D6(nt);
      te.current = dt, W.current = {
        x: dt.x,
        y: dt.y
      }, Y(dt), F({
        x: dt.x,
        y: dt.y
      }), Re({
        x: dt.x,
        y: dt.y
      }, he.current), "touches" in ve || Hl(nt, ve.pointerId, "setPointerCapture");
    }
    return f?.(ve.nativeEvent), ie(!0), O(!1), U(null), X.current = !0, be(0), !0;
  }
  function tt() {
    ut(), re.current = !1, K.current = null;
  }
  function ut() {
    se.current = !1, ue.current = null;
  }
  function at(ve) {
    if (tt(), !G.current)
      return;
    ie(!1), O(!1), U(null);
    const we = m ? H : te.current;
    W.current = {
      x: we.x,
      y: we.y
    }, F({
      x: we.x,
      y: we.y
    }), M(void 0), ne.current = !1;
    const Ve = o.current;
    Ve && Hl(Ve, ve.pointerId, "releasePointerCapture"), be(0, {
      deltaX: 0,
      deltaY: 0,
      direction: void 0
    }), d?.(ve.nativeEvent);
  }
  function $e(ve, we) {
    const Ve = (it) => it >= 0 ? it ** 0.5 : -(Math.abs(it) ** 0.5), He = (it, Ue, We) => !Ue && it < 0 || !We && it > 0 ? Ve(it) : it, ct = E ? He(ve, y, C) : Ve(ve), qe = P ? He(we, R, S) : Ve(we);
    return {
      x: ct,
      y: qe
    };
  }
  function Ce(ve, we, Ve) {
    const He = Math.abs(we), ct = Math.abs(Ve);
    if (P && Ve !== 0 && (!E || ct >= He)) {
      const Ue = Math.max(0, ve.scrollHeight - ve.clientHeight), We = ve.scrollTop <= 0, Qe = ve.scrollTop >= Ue, nt = Ve > 0, dt = Ve < 0;
      return nt && We && S || dt && Qe && R;
    }
    if (E && we !== 0 && (!P || He > ct)) {
      const Ue = Math.max(0, ve.scrollWidth - ve.clientWidth), We = ve.scrollLeft <= 0, Qe = ve.scrollLeft >= Ue, nt = we > 0, dt = we < 0;
      return nt && We && C || dt && Qe && y;
    }
    return null;
  }
  const Oe = ge((ve) => {
    if (!e || ve.defaultPrevented || ve.nativeEvent.defaultPrevented || !("touches" in ve) && ve.button !== 0)
      return;
    const we = ke(ve);
    !we || (se.current = !0, ue.current = we, re.current = !1, ne.current = !1, !(s ? s(we, {
      nativeEvent: ve.nativeEvent,
      direction: b
    }) : !0)) || Ze(ve, we) && ut();
  });
  function Ne(ve, we, Ve) {
    if (!e || !G.current)
      return;
    const He = gt(ve.nativeEvent);
    if (Se(ve) && !re.current) {
      const Yt = ve.currentTarget;
      if (Le(He, Yt))
        return;
    }
    if ("touches" in ve || ve.preventDefault(), X.current) {
      q.current = we;
      const Yt = Ai(ve.timeStamp);
      Yt !== null && (he.current = Yt), X.current = !1;
    }
    const ct = we.x, qe = we.y, it = Ve.x, Ue = Ve.y;
    (Ue < 0 && qe > ae.current.y || Ue > 0 && qe < ae.current.y) && (ae.current = {
      x: ae.current.x,
      y: qe
    }), (it < 0 && ct > ae.current.x || it > 0 && ct < ae.current.x) && (ae.current = {
      x: ct,
      y: ae.current.y
    });
    const We = ct - q.current.x, Qe = qe - q.current.y, nt = qe - ae.current.y, dt = ct - ae.current.x;
    if (!D && Math.sqrt(We * We + Qe * Qe) >= M6 && (O(!0), B === null && E && P)) {
      const kn = Math.abs(We), Qr = Math.abs(Qe);
      U(kn > Qr ? "horizontal" : "vertical");
    }
    let pt;
    if (!z.current)
      B === "vertical" ? Qe > 0 ? pt = "down" : Qe < 0 && (pt = "up") : B === "horizontal" ? We > 0 ? pt = "right" : We < 0 && (pt = "left") : Math.abs(We) >= Math.abs(Qe) ? pt = We > 0 ? "right" : "left" : pt = Qe > 0 ? "down" : "up", pt && (pt === "left" && y || pt === "right" && C || pt === "up" && R || pt === "down" && S) && (z.current = pt, Q.current = zl(pt, We, Qe), M(pt), pe(pt));
    else {
      const Yt = z.current, kn = zl(Yt, dt, nt);
      kn > de.current ? (ee.current = !1, M(Yt)) : !(y && C) && !(R && S) && Q.current - kn >= I6 && (ee.current = !0);
    }
    const Nt = $e(We, Qe);
    let ot = te.current.x, At = te.current.y;
    B === "horizontal" ? E && (ot += Nt.x) : (B === "vertical" || E && (ot += Nt.x), P && (At += Nt.y)), W.current = {
      x: ot,
      y: At
    }, m && F({
      x: ot,
      y: At
    }), Re({
      x: ot,
      y: At
    }, Ai(ve.timeStamp));
    const qn = ot - te.current.x, dn = At - te.current.y, Tn = z.current, Cn = b ?? z.current;
    if (!Cn) {
      be(0, {
        deltaX: qn,
        deltaY: dn,
        direction: Tn
      });
      return;
    }
    const Sn = Cn === "left" || Cn === "right" ? oe.current.width : oe.current.height, Zt = te.current.scale || 1;
    if (Sn <= 0 || Zt <= 0) {
      be(0, {
        deltaX: qn,
        deltaY: dn,
        direction: Tn
      });
      return;
    }
    const Xn = zl(Cn, ot - te.current.x, At - te.current.y);
    if (Xn <= 0) {
      be(0, {
        deltaX: qn,
        deltaY: dn,
        direction: Tn
      });
      return;
    }
    be(Xn / (Sn * Zt), {
      deltaX: qn,
      deltaY: dn,
      direction: Tn
    });
  }
  const Be = ge((ve) => {
    const we = ke(ve);
    if (!we)
      return;
    if (!("touches" in ve)) {
      const ct = _6(ve.buttons);
      ct && (ne.current = !0);
      const qe = ve.buttons === 0 && ne.current;
      if (ve.buttons !== 0 && !ct || qe) {
        at(ve);
        return;
      }
    }
    if (!T && se.current) {
      if (!Se(ve) && (ve.defaultPrevented || ve.nativeEvent.defaultPrevented)) {
        tt();
        return;
      }
      if (s ? s(we, {
        nativeEvent: ve.nativeEvent,
        direction: b
      }) : !0) {
        const qe = ue.current;
        let it = !1;
        if (Se(ve)) {
          const We = o.current;
          if (qe && We) {
            const Qe = Ie(we, ve.nativeEvent), dt = Ke(We).body, pt = dt ? Le(Qe, dt) : null;
            if (pt && (De(We, pt) || De(pt, We))) {
              const Nt = we.x - qe.x, ot = we.y - qe.y, At = Ce(pt, Nt, ot);
              if (At === !1)
                return;
              At === !0 && (it = !0);
            }
          }
        }
        Ze(ve, we, {
          ignoreScrollableTarget: it,
          ignoreScrollableAncestors: it
        }) && (qe && it ? (ut(), q.current = qe, ae.current = qe, K.current = qe, X.current = !1) : (ut(), re.current = !1));
      }
    }
    const Ve = K.current, He = Ve === null ? {
      x: 0,
      y: 0
    } : {
      x: we.x - Ve.x,
      y: we.y - Ve.y
    };
    K.current = we, Ne(ve, we, He);
  }), ze = ge((ve) => {
    if (!e)
      return;
    const we = W.current, Ve = te.current, He = we.x - Ve.x, ct = we.y - Ve.y, qe = {
      deltaX: He,
      deltaY: ct,
      direction: I ?? z.current
    };
    if (!G.current) {
      tt(), be(0, qe);
      return;
    }
    ie(!1), O(!1), U(null), tt(), ne.current = !1;
    const it = o.current;
    it && ("touches" in ve || Hl(it, ve.pointerId, "releasePointerCapture"));
    const Ue = He, We = ct, Qe = he.current, nt = Ai(ve.timeStamp), dt = Qe !== null && nt !== null && nt > Qe ? nt - Qe : 0, pt = dt > 0 ? Math.max(dt, T6) : 0, Nt = pt > 0 ? Ue / pt : 0, ot = pt > 0 ? We / pt : 0;
    let At = Z.current.x, qn = Z.current.y;
    const dn = $.current;
    if (dn && nt !== null && nt >= dn.time) {
      const Xn = nt - dn.time;
      if (Xn <= k6) {
        const Yt = Math.max(Xn, gg), kn = we.x - dn.x, Qr = we.y - dn.y, fn = kn / Yt, On = Qr / Yt;
        fn !== 0 && (At = fn), On !== 0 && (qn = On);
      } else
        At = 0, qn = 0;
    }
    const Tn = p?.({
      event: ve.nativeEvent,
      direction: I ?? z.current,
      deltaX: Ue,
      deltaY: We,
      velocityX: Nt,
      velocityY: ot,
      releaseVelocityX: At,
      releaseVelocityY: qn
    }), Cn = typeof Tn == "boolean";
    if (ee.current && !Cn) {
      W.current = {
        x: Ve.x,
        y: Ve.y
      }, F({
        x: Ve.x,
        y: Ve.y
      }), M(void 0), be(0, qe);
      return;
    }
    let Sn = !1, Zt;
    if (Cn)
      Sn = Tn, Zt = I ?? z.current ?? b;
    else
      for (const Xn of n) {
        switch (Xn) {
          case "right":
            Ue > de.current && (Sn = !0, Zt = "right");
            break;
          case "left":
            Ue < -de.current && (Sn = !0, Zt = "left");
            break;
          case "down":
            We > de.current && (Sn = !0, Zt = "down");
            break;
          case "up":
            We < -de.current && (Sn = !0, Zt = "up");
            break;
        }
        if (Sn)
          break;
      }
    Sn && Zt ? (M(Zt), _(!0), c?.(ve.nativeEvent, {
      direction: Zt
    })) : (W.current = {
      x: Ve.x,
      y: Ve.y
    }, F({
      x: Ve.x,
      y: Ve.y
    }), M(void 0), be(0, qe));
  }), Me = v.useCallback(() => {
    const ve = m ? A : W.current, we = m ? H : te.current;
    if (!T && ve.x === we.x && ve.y === we.y && !V)
      return {
        [r.x]: "0px",
        [r.y]: "0px"
      };
    const Ve = ve.x - we.x, He = ve.y - we.y;
    return {
      transition: T ? "none" : void 0,
      // While swiping, freeze the element at its current visual transform so it doesn't snap to the
      // end position.
      transform: T ? `translateX(${ve.x}px) translateY(${ve.y}px) scale(${we.scale})` : void 0,
      [r.x]: `${Ve}px`,
      [r.y]: `${He}px`
    };
  }, [V, A, H, T, r, m]), Wt = v.useCallback(() => e ? {
    onPointerDown: Oe,
    onPointerMove: Be,
    onPointerUp: ze,
    onPointerCancel: ze
  } : {}, [e, ze, Be, Oe]), ft = v.useCallback(() => e ? {
    onTouchStart: Oe,
    onTouchMove: Be,
    onTouchEnd: ze,
    onTouchCancel: ze
  } : {}, [e, ze, Be, Oe]);
  return {
    swiping: T,
    swipeDirection: I,
    dragDismissed: V,
    getPointerProps: Wt,
    getTouchProps: ft,
    getDragStyles: Me,
    reset: _e
  };
}
const A6 = Ms, F6 = N1, Sc = 10, mg = 0.5, hg = 0.5, L6 = 300, bg = 4, vg = 0.2, $6 = 4, Bl = 80, yg = 360, Wl = 0.1, xg = 1, z6 = `[${pb}]`, yb = /* @__PURE__ */ v.forwardRef(function(e, n) {
  const {
    className: o,
    render: r,
    style: s,
    children: i,
    ...a
  } = e, {
    store: l
  } = cn(), {
    swipeDirection: c,
    notifyParentSwipingChange: u,
    notifyParentSwipeProgressChange: d,
    frontmostHeight: f,
    snapToSequentialPoints: p
  } = Ga(), m = hb()?.visualStateStore, h = l.useState("open"), b = l.useState("mounted"), w = l.useState("nested"), y = l.useState("nestedOpenDrawerCount"), C = l.useState("viewportElement"), R = l.useState("popupElement"), S = y > 0, E = c === "left" || c === "right" ? "horizontal" : "vertical", P = E === "vertical", N = P ? "horizontal" : "vertical", {
    snapPoints: I,
    resolvedSnapPoints: M,
    activeSnapPoint: T,
    activeSnapPointOffset: k,
    setActiveSnapPoint: D,
    popupHeight: O
  } = bb(), [V, _] = v.useState(null), A = v.useRef(void 0), F = v.useRef(null), H = Fr(), Y = v.useRef(!1), B = v.useRef(""), U = v.useRef(!1), q = v.useRef(!1), W = v.useRef(null), K = v.useMemo(() => {
    if (!I || I.length < 2 || c !== "down" && c !== "up" || M.length < 2)
      return null;
    const $ = M.map((pe) => pe.offset).filter((pe) => Number.isFinite(pe)).sort((pe, be) => pe - be);
    if ($.length < 2)
      return null;
    const Z = $[0], L = $[1], G = $[$.length - 1];
    let ie = L - Z;
    if (!Number.isFinite(ie) || ie <= 0) {
      const pe = G - Z;
      if (!Number.isFinite(pe) || pe <= 0)
        return null;
      ie = pe;
    }
    return {
      minOffset: Z,
      range: ie
    };
  }, [M, I, c]), te = v.useMemo(() => !K || k === null ? null : $t((k - K.minOffset) / K.range, 0, 1), [k, K]), z = v.useMemo(() => I && I.length > 0 && (c === "down" || c === "up") ? c === "down" ? ["down", "up"] : ["up", "down"] : [c], [I, c]), Q = ge(($) => {
    wg(l.context.popupRef.current, l.context.backdropRef.current, $);
  }), ee = ge(() => {
    Q(!1), l.context.popupRef.current?.removeAttribute(Wn.endingStyle), _(null);
  }), ae = ge(() => {
    Y.current && (Y.current = !1, u?.(!1));
  }), X = ge(({
    resolvedProgress: $,
    shouldTrackProgress: Z,
    notifyParent: L
  }) => {
    const G = h && !w && Z, ie = G ? $ : 0, pe = h && Z ? $ : 0;
    L && d && (d(pe), pe <= 0 && ae()), m?.set({
      swipeProgress: ie,
      frontmostHeight: ie > 0 ? f : 0
    });
    const be = l.context.backdropRef.current;
    if (be) {
      if (!G || ie <= 0) {
        be.style.setProperty(ho.swipeProgress, "0"), be.style.removeProperty(jt.height);
        return;
      }
      be.style.setProperty(ho.swipeProgress, `${ie}`), f > 0 ? be.style.setProperty(jt.height, `${f}px`) : be.style.removeProperty(jt.height);
    }
  });
  function se({
    direction: $,
    deltaX: Z,
    deltaY: L,
    velocityX: G,
    velocityY: ie,
    releaseVelocityX: pe,
    releaseVelocityY: be
  }) {
    if (!$)
      return null;
    const Re = l.context.popupRef.current;
    if (!Re)
      return null;
    const _e = $ === "left" || $ === "right" ? Re.offsetWidth : Re.offsetHeight;
    if (!Number.isFinite(_e) || _e <= 0)
      return null;
    const ke = $ === "left" || $ === "right" ? Z : L, Se = I && I.length > 0 ? k ?? 0 : 0;
    let Ie = 0;
    $ === "down" ? Ie = Se : $ === "up" && (Ie = -Se);
    const Le = Ie + ke, Ze = $ === "left" || $ === "up" ? -Le : Le, tt = Math.max(0, _e - Ze);
    if (!Number.isFinite(tt) || tt <= 0)
      return null;
    const ut = $ === "left" || $ === "right" ? pe : be, at = $ === "left" || $ === "right" ? G : ie, $e = Math.abs(ut) > 0 && Number.isFinite(ut) ? ut : at, Ce = $ === "left" || $ === "up" ? -$e : $e;
    if (!Number.isFinite(Ce) || Ce <= vg)
      return null;
    const Oe = $t(Ce, vg, $6), Ne = $t(tt / Oe, Bl, yg);
    if (!Number.isFinite(Ne))
      return null;
    const Be = (Ne - Bl) / (yg - Bl), ze = $t(Wl + Be * (xg - Wl), Wl, xg);
    return !Number.isFinite(ze) || ze <= 0 ? null : ze;
  }
  function ue($) {
    if (Y.current || !$)
      return;
    const Z = $.direction ?? c, L = Z === "left" || Z === "right" ? $.deltaX : $.deltaY;
    !Number.isFinite(L) || Math.abs(L) < Sc || (Y.current = !0, u?.(!0));
  }
  const re = V6({
    enabled: b && !S,
    directions: z,
    elementRef: l.context.popupRef,
    ignoreSelectorWhenTouch: !1,
    ignoreScrollableAncestors: !0,
    movementCssVars: {
      x: jt.swipeMovementX,
      y: jt.swipeMovementY
    },
    onSwipeStart($) {
      if ("touches" in $ || "pointerType" in $ && $.pointerType === "touch")
        return;
      const Z = l.context.popupRef.current;
      if (!Z)
        return;
      const G = Ke(Z).getSelection?.();
      if (!G || G.isCollapsed)
        return;
      const ie = lt(G.anchorNode) ? G.anchorNode : G.anchorNode?.parentElement, pe = lt(G.focusNode) ? G.focusNode : G.focusNode?.parentElement;
      !De(Z, ie) && !De(Z, pe) || G.removeAllRanges();
    },
    onSwipingChange($) {
      Cg(l.context.backdropRef.current, $), !$ && !d && ae();
    },
    swipeThreshold({
      element: $,
      direction: Z
    }) {
      return Sg($, Z);
    },
    canStart($, Z) {
      const L = l.context.popupRef.current;
      if (!L)
        return !1;
      const G = L.ownerDocument, ie = Xi(G, $.x, $.y);
      if (!ie || !De(L, ie))
        return !1;
      const pe = Z.nativeEvent;
      return !(("touches" in pe || "pointerType" in pe && pe.pointerType === "touch") && Eg(G, L) || pe.type === "touchstart" && Ul(ie));
    },
    onProgress($, Z) {
      ue(Z);
      const L = Z?.direction ?? re.swipeDirection, G = L === void 0 || L === c, ie = !!(I && I.length > 0), be = ie && (c === "down" || c === "up") || !ie || c === "left" || c === "right" || G;
      let Re = $;
      if (K && O > 0) {
        if (Z && Number.isFinite(Z.deltaY)) {
          const _e = k ?? K.minOffset, ke = $t(_e + Z.deltaY, 0, O);
          Re = $t((ke - K.minOffset) / K.range, 0, 1);
        } else if (te !== null)
          Re = te;
        else if (L === "down" || L === "up") {
          const _e = $ * O, ke = k ?? K.minOffset, Se = L === "down" ? ke + _e : ke - _e;
          Re = $t((Se - K.minOffset) / K.range, 0, 1);
        }
      }
      X({
        resolvedProgress: Re,
        shouldTrackProgress: be,
        notifyParent: !0
      });
    },
    onRelease({
      event: $,
      deltaX: Z,
      deltaY: L,
      direction: G,
      velocityX: ie,
      velocityY: pe,
      releaseVelocityX: be,
      releaseVelocityY: Re
    }) {
      const _e = {
        deltaX: Z,
        deltaY: L,
        velocityX: ie,
        velocityY: pe,
        releaseVelocityX: be,
        releaseVelocityY: Re
      };
      function ke(ft) {
        const ve = l.context.popupRef.current;
        ve && (ae(), Q(!0), ve.style.removeProperty("transition"), ve.setAttribute(Wn.endingStyle, ""), tn.flushSync(() => {
          _(se({
            direction: ft,
            ..._e
          }));
        }));
      }
      if (!I || I.length === 0) {
        if (!G) {
          ee();
          return;
        }
        const ft = l.context.popupRef.current;
        if (!ft) {
          ee();
          return;
        }
        const ve = Sg(ft, G), we = G === "left" || G === "right" ? Z : L;
        if (!Number.isFinite(we)) {
          ee();
          return;
        }
        const Ve = G === "left" || G === "up" ? -we : we;
        if (Ve <= 0)
          return ee(), !1;
        const He = G === "left" || G === "right" ? ie : pe;
        if ((G === "left" || G === "up" ? -He : He) >= mg && Ve > 0)
          return ke(G), !0;
        const qe = Ve > ve;
        return qe ? ke(G) : ee(), qe;
      }
      if (c !== "down" && c !== "up") {
        ee();
        return;
      }
      if (!O || M.length === 0) {
        ee();
        return;
      }
      const Se = c === "down" ? L : -L;
      if (!Number.isFinite(Se)) {
        ee();
        return;
      }
      const Ie = Math.sign(Se), Le = c === "down" ? Re : -Re, Ze = c === "down" ? pe : -pe;
      let tt = Number.isFinite(Le) ? Le : Ze;
      if (Ie !== 0 && Math.abs(Se) >= Sc && Number.isFinite(tt)) {
        const ft = Math.sign(tt);
        ft !== 0 && ft !== Ie && (tt = Ze);
      }
      const ut = k ?? 0, at = $t(ut + Se, 0, O), $e = Number.isFinite(tt) && Math.abs(tt) >= hg ? $t(tt, -bg, bg) * L6 : 0, Ce = p ? at : $t(at + $e, 0, O), Oe = Pe(mi, $), Ne = () => (A.current = T, D?.(null, Oe), ke(c), !0);
      if (p) {
        const ft = [...M].sort((Qe, nt) => Qe.offset - nt.offset);
        if (ft.length === 0)
          return ee(), !1;
        let ve = 0, we = Math.abs(ut - ft[0].offset);
        for (let Qe = 1; Qe < ft.length; Qe += 1) {
          const nt = Math.abs(ut - ft[Qe].offset);
          nt < we && (we = nt, ve = Qe);
        }
        let Ve = ft[0];
        we = Math.abs(Ce - Ve.offset);
        for (const Qe of ft) {
          const nt = Math.abs(Ce - Qe.offset);
          nt < we && (we = nt, Ve = Qe);
        }
        const He = Math.sign(tt), ct = Ie !== 0 && He !== 0 && He === Ie && Math.abs(tt) >= hg;
        let qe = Ce;
        if (ct) {
          const Qe = $t(ve + Ie, 0, ft.length - 1);
          if (Qe !== ve) {
            const nt = ft[Qe];
            (Ie > 0 ? Ce < nt.offset : Ce > nt.offset) && (Ve = nt, qe = nt.offset);
          } else if (Ie > 0)
            return Ne();
        }
        const Ue = Math.abs(qe - O), We = Math.abs(qe - Ve.offset);
        return Ue < We ? Ne() : (D?.(Ve.value, Oe), ee(), !1);
      }
      if (tt >= mg && Se > 0)
        return Ne();
      let Be = M[0], ze = Math.abs(Ce - Be.offset);
      for (const ft of M) {
        const ve = Math.abs(Ce - ft.offset);
        ve < ze && (ze = ve, Be = ft);
      }
      return Math.abs(Ce - O) < ze ? Ne() : (D?.(Be.value, Oe), ee(), !1);
    },
    onDismiss($) {
      m?.set({
        swipeProgress: 0,
        frontmostHeight: 0
      });
      const Z = l.context.backdropRef.current;
      Z && (Z.style.setProperty(ho.swipeProgress, "0"), Z.style.removeProperty(jt.height));
      const L = Pe(mi, $);
      if (l.setOpen(!1, L), L.isCanceled) {
        const G = A.current;
        G !== void 0 && D?.(G, Pe(mi, $)), A.current = void 0, F.current?.(), ee();
        return;
      }
      if (l.select("open")) {
        const G = $;
        H.request(() => {
          if (l.select("open")) {
            const ie = A.current;
            ie !== void 0 && D?.(ie, Pe(mi, G)), A.current = void 0, ee(), F.current?.();
          } else
            A.current = void 0;
        });
        return;
      }
      A.current = void 0, Q(!0);
    }
  }), ne = re.getPointerProps(), oe = re.getTouchProps(), me = re.reset;
  F.current = me, v.useEffect(() => {
    const $ = C ?? R;
    if (!$)
      return;
    const Z = $, L = Ke(Z), G = vt(L);
    function ie(pe) {
      if (q.current)
        return;
      const be = W.current, Re = pe.touches[0];
      if (!Re || !be)
        return;
      const _e = P ? Re.clientY - be.lastY : Re.clientX - be.lastX;
      if (xb(pe, G)) {
        be.allowSwipe = !1, Yo(be, Re);
        return;
      }
      if (pe.touches.length === 2) {
        Yo(be, Re);
        return;
      }
      if (Eg(L, Z) || !h || !b || S) {
        Yo(be, Re);
        return;
      }
      if (U6(be, Re, P)) {
        Yo(be, Re);
        return;
      }
      const Se = be.scrollTarget;
      if (!Se || Se === L.documentElement || Se === L.body) {
        pe.cancelable && pe.preventDefault(), Yo(be, Re);
        return;
      }
      if (!Y6(Se, E)) {
        pe.cancelable && pe.preventDefault(), Yo(be, Re);
        return;
      }
      const Le = _e;
      if (Le !== 0) {
        const Ze = j6(Se, E, c, Le);
        be.allowSwipe ? pe.cancelable && pe.preventDefault() : pe.cancelable && Ze ? (be.allowSwipe = !0, pe.preventDefault()) : be.allowSwipe = !1;
      }
      Yo(be, Re);
    }
    return rt(L, "touchmove", ie, {
      passive: !1,
      capture: !0
    });
  }, [b, S, h, R, P, E, c, C]), v.useEffect(() => {
    if (!K || re.swiping)
      return;
    X({
      resolvedProgress: !h || w ? 0 : te ?? 0,
      shouldTrackProgress: !0,
      notifyParent: !1
    });
  }, [X, f, w, d, h, te, K, re.swiping, l, m]), v.useEffect(() => {
    if (d)
      return h || d(0), () => {
        d(0);
      };
  }, [d, h]), v.useEffect(() => {
    h && (me(), ee());
  }, [ee, h, me]), v.useEffect(() => () => {
    m?.set({
      swipeProgress: 0,
      frontmostHeight: 0
    }), Cg(l.context.backdropRef.current, !1), ae();
  }, [ae, l, m]);
  const de = v.useMemo(() => ({
    swiping: re.swiping,
    getDragStyles: re.getDragStyles,
    swipeStrength: V ?? null,
    setSwipeDismissed($) {
      wg(l.context.popupRef.current, l.context.backdropRef.current, $);
    }
  }), [l, re.getDragStyles, re.swiping, V]);
  function he() {
    q.current = !1, W.current = null, B.current = "", U.current = !1;
  }
  return /* @__PURE__ */ x(ei, {
    ref: n,
    className: o,
    render: r,
    ...on(a, {
      onPointerDown($) {
        if (B.current = $.pointerType, U.current = $.pointerType === "pen", !h || !b || S)
          return;
        const Z = Ke($.currentTarget), L = Xi(Z, $.clientX, $.clientY);
        Ul(L) || H6(L) || $.pointerType !== "touch" && ne.onPointerDown?.($);
      },
      onPointerMove($) {
        $.pointerType !== "touch" && ne.onPointerMove?.($);
      },
      onPointerUp($) {
        B.current === $.pointerType && (B.current = ""), $.pointerType !== "touch" && ne.onPointerUp?.($);
      },
      onPointerCancel($) {
        B.current === $.pointerType && (B.current = ""), $.pointerType !== "touch" && ne.onPointerCancel?.($);
      },
      onTouchStart($) {
        if (B.current === "pen" && U.current) {
          U.current = !1, q.current = !1, W.current = null;
          return;
        }
        if (!h || !b || S) {
          q.current = !1, W.current = null;
          return;
        }
        const L = $.touches[0];
        if (!L)
          return;
        if (Pg($)) {
          q.current = !1, W.current = null;
          return;
        }
        const G = Ke($.currentTarget), ie = Xi(G, L.clientX, L.clientY);
        if (q.current = Ul(ie), q.current) {
          W.current = null;
          return;
        }
        const pe = C ?? R, be = gt($.nativeEvent), Re = lt(be) ? be : null;
        if (pe && Re && !De(pe, Re)) {
          q.current = !0, W.current = null;
          return;
        }
        let _e = null, ke = !1;
        pe && Re && (_e = Rr(Re, pe, E), ke = Rr(Re, pe, N) != null);
        let Se = null;
        _e && (Se = G6(_e, E, c) ? null : !1), W.current = {
          startX: L.clientX,
          startY: L.clientY,
          lastX: L.clientX,
          lastY: L.clientY,
          scrollTarget: _e,
          hasCrossAxisScrollableContent: ke,
          allowSwipe: Se,
          preserveNativeCrossAxisScroll: !1
        }, oe.onTouchStart?.($);
      },
      onTouchMove($) {
        if (q.current || Pg($))
          return;
        const Z = W.current;
        Z?.preserveNativeCrossAxisScroll || Z?.allowSwipe === !1 || Z?.scrollTarget != null && !Z.allowSwipe || oe.onTouchMove?.($);
      },
      onTouchEnd($) {
        he(), oe.onTouchEnd?.($);
      },
      onTouchCancel($) {
        he(), oe.onTouchCancel?.($);
      },
      // Drawer popups use drawer-specific nested state attributes.
      // Suppress DialogViewport's generic nested dialog attribute.
      "data-nested-dialog-open": void 0
    }),
    children: /* @__PURE__ */ x(yd.Provider, {
      value: de,
      children: i
    })
  });
});
process.env.NODE_ENV !== "production" && (yb.displayName = "DrawerViewport");
function wg(t, e, n) {
  if (n) {
    t?.setAttribute(Fn.swipeDismiss, ""), e?.setAttribute(Fn.swipeDismiss, "");
    return;
  }
  t?.removeAttribute(Fn.swipeDismiss), e?.removeAttribute(Fn.swipeDismiss);
}
function Cg(t, e) {
  if (t) {
    if (e) {
      t.setAttribute(Fn.swiping, "");
      return;
    }
    t.removeAttribute(Fn.swiping);
  }
}
function Ul(t) {
  return !!t?.closest(qm);
}
function H6(t) {
  return !!t?.closest(z6);
}
function Sg(t, e) {
  const n = e === "left" || e === "right" ? t.offsetWidth : t.offsetHeight;
  return Math.max(n * 0.5, Sc);
}
function Rg(t, e) {
  return t instanceof e.HTMLInputElement && t.type === "range";
}
function B6(t) {
  return lt(t) ? t.tagName === "INPUT" || t.tagName === "TEXTAREA" : !1;
}
function W6(t, e) {
  const n = lt(t.anchorNode) ? t.anchorNode : t.anchorNode?.parentElement, o = lt(t.focusNode) ? t.focusNode : t.focusNode?.parentElement;
  return t.containsNode(e, !0) || De(e, n) || De(e, o);
}
function Eg(t, e) {
  const n = zt(t);
  if (!!(n && De(e, n)) && B6(n)) {
    const {
      selectionStart: s,
      selectionEnd: i
    } = n;
    if (s != null && i != null && s < i)
      return !0;
  }
  const r = t.getSelection?.();
  return !r || r.isCollapsed ? !1 : W6(r, e);
}
function xb(t, e) {
  const n = t.composedPath();
  return n ? n.some((o) => Rg(o, e)) : Rg(gt(t), e);
}
function Pg(t) {
  return xb(t.nativeEvent, vt(t.currentTarget));
}
function Yo(t, e) {
  t.lastX = e.clientX, t.lastY = e.clientY;
}
function U6(t, e, n) {
  if (t.preserveNativeCrossAxisScroll)
    return !0;
  if (t.allowSwipe === !0 || !t.hasCrossAxisScrollableContent)
    return !1;
  const o = n ? e.clientY - t.startY : e.clientX - t.startX, r = n ? e.clientX - t.startX : e.clientY - t.startY, s = Math.abs(o), i = Math.abs(r);
  return i < 6 || i <= s + 2 ? !1 : (t.preserveNativeCrossAxisScroll = !0, !0);
}
function Y6(t, e) {
  return e === "vertical" ? t.scrollHeight > t.clientHeight : t.scrollWidth > t.clientWidth;
}
function wb(t, e) {
  if (e === "vertical") {
    const o = Math.max(0, t.scrollHeight - t.clientHeight);
    return {
      offset: t.scrollTop,
      max: o
    };
  }
  const n = Math.max(0, t.scrollWidth - t.clientWidth);
  return {
    offset: t.scrollLeft,
    max: n
  };
}
function G6(t, e, n) {
  const {
    offset: o,
    max: r
  } = wb(t, e), s = Cb(n, e);
  return s === null ? !1 : s ? o <= 0 : o >= r;
}
function j6(t, e, n, o) {
  const {
    offset: r,
    max: s
  } = wb(t, e), i = Cb(n, e);
  return i === null || !(i ? o > 0 : o < 0) ? !1 : i ? r <= 0 : r >= s;
}
function Cb(t, e) {
  return e === "vertical" ? t === "down" ? !0 : t === "up" ? !1 : null : t === "right" ? !0 : t === "left" ? !1 : null;
}
function K6(t, e) {
  const n = typeof window < "u" && typeof window.matchMedia < "u";
  t = t.replace(/^@media( ?)/m, "");
  const {
    defaultMatches: o = !1,
    matchMedia: r = n ? window.matchMedia : null,
    ssrMatchMedia: s = null,
    noSsr: i = !1
  } = e, a = v.useCallback(() => o, [o]), l = v.useMemo(() => {
    if (i && r)
      return () => r(t).matches;
    if (s !== null) {
      const {
        matches: f
      } = s(t);
      return () => f;
    }
    return a;
  }, [a, t, s, i, r]), [c, u] = v.useMemo(() => {
    if (r === null)
      return [a, () => () => {
      }];
    const f = r(t);
    return [() => f.matches, (p) => rt(f, "change", p)];
  }, [a, r, t]), d = iu.useSyncExternalStore(u, c, l);
  return process.env.NODE_ENV !== "production" && v.useDebugValue({
    query: t,
    match: d
  }), d;
}
const q6 = ye(["fixed", "inset-0", "z-50", "bg-surface-scrim", "transition-opacity", "duration-200", "data-ending-style:opacity-0", "data-starting-style:opacity-0"]), X6 = ye(["fixed", "inset-0", "z-50", "flex", "justify-end", "pointer-events-none", "max-[904px]:items-end", "max-[904px]:justify-center"]), Z6 = ye(["pointer-events-auto", "flex", "h-dvh", "max-h-dvh", "min-w-0", "flex-col", "overflow-hidden", "border", "border-outline-subtle", "bg-surface", "text-text-default", "shadow-elevation-4", "outline-none", "transition-transform", "duration-200", "ease-out", "data-ending-style:translate-x-full", "data-starting-style:translate-x-full", "max-[904px]:h-auto", "max-[904px]:min-h-[230px]", "max-[904px]:max-h-[min(680px,calc(100dvh_-_var(--spacing-16)))]", "max-[904px]:w-full", "max-[904px]:rounded-t-(--radius-sm)", "max-[904px]:data-ending-style:translate-x-0", "max-[904px]:data-ending-style:translate-y-full", "max-[904px]:data-starting-style:translate-x-0", "max-[904px]:data-starting-style:translate-y-full"], {
  variants: {
    size: {
      default: ["[--drawer-size:640px]", "w-[min(100vw,var(--drawer-size))]"],
      small: ["[--drawer-size:560px]", "w-[min(100vw,var(--drawer-size))]"]
    }
  },
  defaultVariants: {
    size: "default"
  }
}), Q6 = ye(["flex", "min-h-0", "flex-1", "flex-col", "gap-(--spacing-16)", "overflow-hidden", "bg-surface", "pt-(--spacing-10)"]), J6 = ye(["flex", "shrink-0", "items-start", "justify-between", "gap-(--spacing-2)", "bg-surface", "mx-(--spacing-10)", "p-(--spacing-8)"]), e9 = ye(["flex", "min-w-0", "flex-1", "items-start", "gap-(--spacing-8)"]), t9 = ye(["flex", "min-w-0", "flex-1", "flex-col", "gap-(--spacing-4)"]), n9 = ye(["font-(family-name:--font-family-title)", "text-(length:--font-size-title-lg)", "font-(number:--font-weight-medium)", "leading-(--font-line-height-28)", "text-text-default"]), o9 = ye(["text-(length:--font-size-body-medium)", "leading-(--font-line-height-20)", "text-text-subtext"]), r9 = ye(["min-h-0", "flex-1", "overflow-y-auto", "px-(--spacing-20)", "max-[904px]:pb-[env(safe-area-inset-bottom)]"]), s9 = ye(["flex", "flex-col"], {
  variants: {
    gap: {
      none: "gap-0",
      md: "gap-(--spacing-20)"
    }
  },
  defaultVariants: {
    gap: "md"
  }
}), i9 = ye(["flex", "min-h-(--spacing-80)", "shrink-0", "items-center", "justify-end", "gap-(--spacing-10)", "border-t", "border-outline-subtle", "bg-surface", "px-(--spacing-20)", "py-(--spacing-16)", "max-[904px]:pb-[calc(var(--spacing-16)_+_env(safe-area-inset-bottom))]"]);
function SN(t) {
  const e = J.c(8);
  let n, o;
  e[0] !== t ? ({
    children: n,
    ...o
  } = t, e[0] = t, e[1] = n, e[2] = o) : (n = e[1], o = e[2]);
  let r;
  e[3] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (r = {
    defaultMatches: !1
  }, e[3] = r) : r = e[3];
  const i = K6("(max-width: 904px)", r) ? "down" : "right";
  let a;
  return e[4] !== n || e[5] !== o || e[6] !== i ? (a = /* @__PURE__ */ x(R6, { modal: !0, swipeDirection: i, ...o, children: n }), e[4] = n, e[5] = o, e[6] = i, e[7] = a) : a = e[7], a;
}
function RN(t) {
  const e = J.c(2);
  let n;
  return e[0] !== t ? (n = /* @__PURE__ */ x(F6, { ...t }), e[0] = t, e[1] = n) : n = e[1], n;
}
function EN(t) {
  const e = J.c(2);
  let n;
  return e[0] !== t ? (n = /* @__PURE__ */ x(fb, { ...t }), e[0] = t, e[1] = n) : n = e[1], n;
}
function PN(t) {
  const e = J.c(17);
  let n, o, r, s;
  e[0] !== t ? ({
    children: n,
    size: r,
    initialFocus: s,
    ...o
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r, e[4] = s) : (n = e[1], o = e[2], r = e[3], s = e[4]);
  const i = s === void 0 ? !0 : s;
  let a;
  e[5] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (a = /* @__PURE__ */ x(db, { className: le(q6()) }), e[5] = a) : a = e[5];
  let l;
  e[6] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (l = le(X6()), e[6] = l) : l = e[6];
  let c;
  e[7] !== r ? (c = le(Z6({
    size: r
  })), e[7] = r, e[8] = c) : c = e[8];
  let u;
  e[9] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (u = le(Q6()), e[9] = u) : u = e[9];
  let d;
  e[10] !== n ? (d = /* @__PURE__ */ x(gb, { className: u, children: n }), e[10] = n, e[11] = d) : d = e[11];
  let f;
  return e[12] !== i || e[13] !== o || e[14] !== c || e[15] !== d ? (f = /* @__PURE__ */ j(S6, { children: [
    a,
    /* @__PURE__ */ x(yb, { className: l, children: /* @__PURE__ */ x(vb, { "aria-modal": "true", initialFocus: i, className: c, ...o, children: d }) })
  ] }), e[12] = i, e[13] = o, e[14] = c, e[15] = d, e[16] = f) : f = e[16], f;
}
function NN(t) {
  const e = J.c(36);
  let n, o, r, s, i, a, l;
  e[0] !== t ? ({
    title: l,
    subtitle: i,
    leadingIcon: r,
    accessory: n,
    actions: o,
    closeLabel: a,
    ...s
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r, e[4] = s, e[5] = i, e[6] = a, e[7] = l) : (n = e[1], o = e[2], r = e[3], s = e[4], i = e[5], a = e[6], l = e[7]);
  const c = a === void 0 ? "Close drawer" : a;
  let u;
  e[8] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (u = le(J6()), e[8] = u) : u = e[8];
  let d;
  e[9] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (d = le(e9()), e[9] = d) : d = e[9];
  let f;
  e[10] !== r ? (f = r && /* @__PURE__ */ x("span", { className: "mt-(--spacing-4) inline-flex shrink-0 text-icon-main", children: /* @__PURE__ */ x(Ye, { name: r, size: "sm", tone: "inherit" }) }), e[10] = r, e[11] = f) : f = e[11];
  let p;
  e[12] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (p = le(t9()), e[12] = p) : p = e[12];
  let g;
  e[13] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (g = le(n9()), e[13] = g) : g = e[13];
  let m;
  e[14] !== l ? (m = /* @__PURE__ */ x(A6, { className: g, children: l }), e[14] = l, e[15] = m) : m = e[15];
  let h;
  e[16] !== n || e[17] !== m ? (h = /* @__PURE__ */ j("div", { className: "flex min-w-0 flex-wrap items-center gap-(--spacing-8)", children: [
    m,
    n
  ] }), e[16] = n, e[17] = m, e[18] = h) : h = e[18];
  let b;
  e[19] !== i ? (b = i && /* @__PURE__ */ x(v6, { className: le(o9()), children: i }), e[19] = i, e[20] = b) : b = e[20];
  let w;
  e[21] !== h || e[22] !== b ? (w = /* @__PURE__ */ j("div", { className: p, children: [
    h,
    b
  ] }), e[21] = h, e[22] = b, e[23] = w) : w = e[23];
  let y;
  e[24] !== w || e[25] !== f ? (y = /* @__PURE__ */ j("div", { className: d, children: [
    f,
    w
  ] }), e[24] = w, e[25] = f, e[26] = y) : y = e[26];
  let C;
  e[27] !== c ? (C = /* @__PURE__ */ x(fb, { render: /* @__PURE__ */ x(Kt, { icon: "x-close", "aria-label": c, variant: "ghost", size: "md" }) }), e[27] = c, e[28] = C) : C = e[28];
  let R;
  e[29] !== o || e[30] !== C ? (R = /* @__PURE__ */ j("div", { className: "flex shrink-0 items-center gap-(--spacing-8)", children: [
    o,
    C
  ] }), e[29] = o, e[30] = C, e[31] = R) : R = e[31];
  let S;
  return e[32] !== s || e[33] !== y || e[34] !== R ? (S = /* @__PURE__ */ j("div", { className: u, ...s, children: [
    y,
    R
  ] }), e[32] = s, e[33] = y, e[34] = R, e[35] = S) : S = e[35], S;
}
function IN(t) {
  const e = J.c(13);
  let n, o, r;
  e[0] !== t ? ({
    children: n,
    gap: o,
    ...r
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r) : (n = e[1], o = e[2], r = e[3]);
  let s;
  e[4] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (s = le(r9()), e[4] = s) : s = e[4];
  let i;
  e[5] !== o ? (i = le(s9({
    gap: o
  })), e[5] = o, e[6] = i) : i = e[6];
  let a;
  e[7] !== n || e[8] !== i ? (a = /* @__PURE__ */ x("div", { className: i, children: n }), e[7] = n, e[8] = i, e[9] = a) : a = e[9];
  let l;
  return e[10] !== r || e[11] !== a ? (l = /* @__PURE__ */ x("div", { className: s, ...r, children: a }), e[10] = r, e[11] = a, e[12] = l) : l = e[12], l;
}
function MN(t) {
  const e = J.c(7);
  let n, o;
  e[0] !== t ? ({
    children: n,
    ...o
  } = t, e[0] = t, e[1] = n, e[2] = o) : (n = e[1], o = e[2]);
  let r;
  e[3] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (r = le(i9()), e[3] = r) : r = e[3];
  let s;
  return e[4] !== n || e[5] !== o ? (s = /* @__PURE__ */ x("div", { className: r, ...o, children: n }), e[4] = n, e[5] = o, e[6] = s) : s = e[6], s;
}
const xd = /* @__PURE__ */ v.createContext(void 0);
process.env.NODE_ENV !== "production" && (xd.displayName = "MenuPositionerContext");
function si(t) {
  const e = v.useContext(xd);
  if (e === void 0 && !t)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: MenuPositionerContext is missing. MenuPositioner parts must be placed within <Menu.Positioner>." : Xe(33));
  return e;
}
const wd = /* @__PURE__ */ v.createContext(void 0);
process.env.NODE_ENV !== "production" && (wd.displayName = "MenuRootContext");
function Kn(t) {
  const e = v.useContext(wd);
  if (e === void 0 && !t)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: MenuRootContext is missing. Menu parts must be placed within <Menu.Root>." : Xe(36));
  return e;
}
const Sb = /* @__PURE__ */ v.createContext(void 0);
process.env.NODE_ENV !== "production" && (Sb.displayName = "ContextMenuRootContext");
function ja(t = !0) {
  const e = v.useContext(Sb);
  if (e === void 0 && !t)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: ContextMenuRootContext is missing. ContextMenu parts must be placed within <ContextMenu.Root>." : Xe(25));
  return e;
}
const Rb = /* @__PURE__ */ v.createContext(void 0);
process.env.NODE_ENV !== "production" && (Rb.displayName = "MenuCheckboxItemContext");
function a9(t) {
  const {
    closeOnClick: e,
    highlighted: n,
    id: o,
    nodeId: r,
    store: s,
    typingRef: i,
    itemRef: a,
    itemMetadata: l
  } = t, {
    events: c
  } = s.useState("floatingTreeRoot"), u = ja(!0), d = u !== void 0;
  return v.useMemo(() => ({
    id: o,
    role: "menuitem",
    tabIndex: n ? 0 : -1,
    onKeyDown(f) {
      f.key === " " && i?.current && f.preventDefault();
    },
    onMouseMove(f) {
      r && c.emit("itemhover", {
        nodeId: r,
        target: f.currentTarget
      });
    },
    onClick(f) {
      e && c.emit("close", {
        domEvent: f,
        reason: ko
      });
    },
    onMouseUp(f) {
      if (u) {
        const p = u.initialCursorPointRef.current;
        if (u.initialCursorPointRef.current = null, d && p && Math.abs(f.clientX - p.x) <= 1 && Math.abs(f.clientY - p.y) <= 1 || d && !vm && f.button === 2)
          return;
      }
      a.current && s.context.allowMouseUpTriggerRef.current && (!d || f.button === 2) && (!l || l.type === "regular-item") && a.current.click();
    }
  }), [e, n, o, c, r, s, i, a, u, d, l]);
}
const Cd = {
  type: "regular-item"
};
function Ka(t) {
  const {
    closeOnClick: e,
    disabled: n = !1,
    highlighted: o,
    id: r,
    store: s,
    typingRef: i = s.context.typingRef,
    nativeButton: a,
    itemMetadata: l,
    nodeId: c
  } = t, u = v.useRef(null), {
    getButtonProps: d,
    buttonRef: f
  } = Ft({
    disabled: n,
    focusableWhenDisabled: !0,
    native: a,
    composite: !0
  }), p = a9({
    closeOnClick: e,
    highlighted: o,
    id: r,
    nodeId: c,
    store: s,
    typingRef: i,
    itemRef: u,
    itemMetadata: l
  }), g = v.useCallback((h) => on(p, {
    onMouseEnter() {
      l.type === "submenu-trigger" && l.setActive();
    }
  }, h, d), [p, d, l]), m = ln(u, f);
  return v.useMemo(() => ({
    getItemProps: g,
    itemRef: m
  }), [g, m]);
}
let Ng = /* @__PURE__ */ (function(t) {
  return t.checked = "data-checked", t.unchecked = "data-unchecked", t.disabled = "data-disabled", t.highlighted = "data-highlighted", t;
})({});
const Sd = {
  checked(t) {
    return t ? {
      [Ng.checked]: ""
    } : {
      [Ng.unchecked]: ""
    };
  },
  ...Lt
}, Eb = /* @__PURE__ */ v.forwardRef(function(e, n) {
  const {
    render: o,
    className: r,
    id: s,
    label: i,
    nativeButton: a = !1,
    disabled: l = !1,
    closeOnClick: c = !1,
    checked: u,
    defaultChecked: d,
    onCheckedChange: f,
    style: p,
    ...g
  } = e, m = Ro({
    label: i
  }), h = si(!0), b = St(s), {
    store: w
  } = Kn(), y = w.useState("isActive", m.index), C = w.useState("itemProps"), [R, S] = sn({
    controlled: u,
    default: d ?? !1,
    name: "MenuCheckboxItem",
    state: "checked"
  }), {
    getItemProps: E,
    itemRef: P
  } = Ka({
    closeOnClick: c,
    disabled: l,
    highlighted: y,
    id: b,
    store: w,
    nativeButton: a,
    nodeId: h?.context.nodeId,
    itemMetadata: Cd
  }), N = v.useMemo(() => ({
    disabled: l,
    highlighted: y,
    checked: R
  }), [l, y, R]), I = ge((T) => {
    const k = {
      ...Pe(ko, T.nativeEvent),
      preventUnmountOnClose: () => {
      }
    };
    f?.(!R, k), !k.isCanceled && S((D) => !D);
  }), M = Te("div", e, {
    state: N,
    stateAttributesMapping: Sd,
    props: [C, {
      role: "menuitemcheckbox",
      "aria-checked": R,
      onClick: I
    }, g, E],
    ref: [P, n, m.ref]
  });
  return /* @__PURE__ */ x(Rb.Provider, {
    value: N,
    children: M
  });
});
process.env.NODE_ENV !== "production" && (Eb.displayName = "MenuCheckboxItem");
const Pb = /* @__PURE__ */ v.forwardRef(function(e, n) {
  const {
    render: o,
    className: r,
    id: s,
    label: i,
    nativeButton: a = !1,
    disabled: l = !1,
    closeOnClick: c = !0,
    style: u,
    ...d
  } = e, f = Ro({
    label: i
  }), p = si(!0), g = St(s), {
    store: m
  } = Kn(), h = m.useState("isActive", f.index), b = m.useState("itemProps"), {
    getItemProps: w,
    itemRef: y
  } = Ka({
    closeOnClick: c,
    disabled: l,
    highlighted: h,
    id: g,
    store: m,
    nativeButton: a,
    nodeId: p?.context.nodeId,
    itemMetadata: Cd
  });
  return Te("div", e, {
    state: {
      disabled: l,
      highlighted: h
    },
    props: [b, d, w],
    ref: [y, n, f.ref]
  });
});
process.env.NODE_ENV !== "production" && (Pb.displayName = "MenuItem");
const l9 = {
  ...xn,
  ...Lt
}, Nb = /* @__PURE__ */ v.forwardRef(function(e, n) {
  const {
    render: o,
    className: r,
    style: s,
    finalFocus: i,
    ...a
  } = e, {
    store: l
  } = Kn(), {
    side: c,
    align: u
  } = si(), d = Lu() != null, f = l.useState("open"), p = l.useState("transitionStatus"), g = l.useState("popupProps"), m = l.useState("mounted"), h = l.useState("instantType"), b = l.useState("activeTriggerElement"), w = l.useState("parent"), y = l.useState("lastOpenChangeReason"), C = l.useState("rootId"), R = l.useState("floatingRootContext"), S = l.useState("floatingTreeRoot"), E = l.useState("closeDelay"), P = l.useState("activeTriggerElement"), N = w.type === "context-menu";
  Bt({
    open: f,
    ref: l.context.popupRef,
    onComplete() {
      f && l.context.onOpenChangeComplete?.(!0);
    }
  }), v.useEffect(() => {
    function V(_) {
      l.setOpen(!1, Pe(_.reason, _.domEvent));
    }
    return S.events.on("close", V), () => {
      S.events.off("close", V);
    };
  }, [S.events, l]);
  const I = l.useState("hoverEnabled"), M = l.useState("disabled");
  Da(R, {
    enabled: I && !M && !N && w.type !== "menubar",
    closeDelay: E
  });
  const T = {
    transitionStatus: p,
    side: c,
    align: u,
    open: f,
    nested: w.type === "menu",
    instant: h
  }, k = v.useCallback((V) => {
    l.set("popupElement", V);
  }, [l]), D = Te("div", e, {
    state: T,
    ref: [n, l.context.popupRef, k],
    stateAttributesMapping: l9,
    props: [g, {
      onKeyDown(V) {
        d && Zs.has(V.key) && V.stopPropagation();
      }
    }, pr(p), a, {
      "data-rootownerid": C
    }]
  });
  let O = w.type === void 0 || N;
  return (b || w.type === "menubar" && y !== Vs) && (O = !0), /* @__PURE__ */ x(zr, {
    context: R,
    modal: N,
    disabled: !m,
    returnFocus: i === void 0 ? O : i,
    initialFocus: w.type !== "menu",
    restoreFocus: !0,
    externalTree: w.type !== "menubar" ? S : void 0,
    previousFocusableElement: P,
    nextFocusableElement: w.type === void 0 ? l.context.triggerFocusTargetRef : void 0,
    beforeContentFocusGuardRef: w.type === void 0 ? l.context.beforeContentFocusGuardRef : void 0,
    children: D
  });
});
process.env.NODE_ENV !== "production" && (Nb.displayName = "MenuPopup");
const Rd = /* @__PURE__ */ v.createContext(void 0);
process.env.NODE_ENV !== "production" && (Rd.displayName = "MenuPortalContext");
function c9() {
  const t = v.useContext(Rd);
  if (t === void 0)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: <Menu.Portal> is missing." : Xe(32));
  return t;
}
const Ib = /* @__PURE__ */ v.forwardRef(function(e, n) {
  const {
    keepMounted: o = !1,
    ...r
  } = e, {
    store: s
  } = Kn();
  return s.useState("mounted") || o ? /* @__PURE__ */ x(Rd.Provider, {
    value: o,
    children: /* @__PURE__ */ x($r, {
      ref: n,
      ...r
    })
  }) : null;
});
process.env.NODE_ENV !== "production" && (Ib.displayName = "MenuPortal");
const Mb = /* @__PURE__ */ v.forwardRef(function(e, n) {
  const {
    anchor: o,
    positionMethod: r = "absolute",
    className: s,
    render: i,
    side: a,
    align: l,
    sideOffset: c = 0,
    alignOffset: u = 0,
    collisionBoundary: d = "clipping-ancestors",
    collisionPadding: f = 5,
    arrowPadding: p = 5,
    sticky: g = !1,
    disableAnchorTracking: m = !1,
    collisionAvoidance: h = Xc,
    style: b,
    ...w
  } = e, {
    store: y
  } = Kn(), C = c9(), R = ja(!0), S = y.useState("parent"), E = y.useState("floatingRootContext"), P = y.useState("floatingTreeRoot"), N = y.useState("mounted"), I = y.useState("open"), M = y.useState("modal"), T = y.useState("openMethod"), k = y.useState("activeTriggerElement"), D = y.useState("transitionStatus"), O = y.useState("positionerElement"), V = y.useState("instantType"), _ = y.useState("hasViewport"), A = y.useState("lastOpenChangeReason"), F = y.useState("floatingNodeId"), H = y.useState("floatingParentNodeId"), Y = E.useState("domReferenceElement"), B = v.useRef(null), U = Oa(O, !1, !1);
  let q = o, W = c, K = u, te = l, z = h;
  S.type === "context-menu" && (q = o ?? S.context?.anchor, te = te ?? "start", !a && te !== "center" && (K = e.alignOffset ?? 2, W = e.sideOffset ?? -5));
  let Q = a, ee = te;
  S.type === "menu" ? (Q = Q ?? "inline-end", ee = ee ?? "start", z = e.collisionAvoidance ?? Ma) : S.type === "menubar" && (Q = Q ?? "bottom", ee = ee ?? "start");
  const ae = S.type === "context-menu", X = Hr({
    anchor: q,
    floatingRootContext: E,
    positionMethod: R ? "fixed" : r,
    mounted: N,
    side: Q,
    sideOffset: W,
    align: ee,
    alignOffset: K,
    arrowPadding: ae ? 0 : p,
    collisionBoundary: d,
    collisionPadding: f,
    sticky: g,
    nodeId: F,
    keepMounted: C,
    disableAnchorTracking: m,
    collisionAvoidance: z,
    shiftCrossAxis: ae && !("side" in z && z.side === "flip"),
    externalTree: P,
    adaptiveOrigin: _ ? Aa : void 0
  });
  v.useEffect(() => {
    function he($) {
      $.open && ($.parentNodeId === F && y.set("hoverEnabled", !1), $.nodeId !== F && $.parentNodeId === y.select("floatingParentNodeId") && y.setOpen(!1, Pe(us)));
    }
    return P.events.on("menuopenchange", he), () => {
      P.events.off("menuopenchange", he);
    };
  }, [y, P.events, F]), v.useEffect(() => {
    if (y.select("floatingParentNodeId") == null)
      return;
    function he($) {
      if ($.open || $.nodeId !== y.select("floatingParentNodeId"))
        return;
      const Z = $.reason ?? us;
      y.setOpen(!1, Pe(Z));
    }
    return P.events.on("menuopenchange", he), () => {
      P.events.off("menuopenchange", he);
    };
  }, [P.events, y]);
  const se = Vt();
  v.useEffect(() => {
    I || se.clear();
  }, [I, se]), v.useEffect(() => {
    function he($) {
      if (!(!I || $.nodeId !== y.select("floatingParentNodeId")))
        if ($.target && k && k !== $.target) {
          const Z = y.select("closeDelay");
          Z > 0 ? se.isStarted() || se.start(Z, () => {
            y.setOpen(!1, Pe(us));
          }) : y.setOpen(!1, Pe(us));
        } else
          se.clear();
    }
    return P.events.on("itemhover", he), () => {
      P.events.off("itemhover", he);
    };
  }, [P.events, I, k, y, se]), v.useEffect(() => {
    const he = {
      open: I,
      nodeId: F,
      parentNodeId: H,
      reason: y.select("lastOpenChangeReason")
    };
    P.events.emit("menuopenchange", he);
  }, [P.events, I, y, F, H]), xe(() => {
    const he = Y, $ = B.current;
    if (he && (B.current = he), $ && he && he !== $) {
      y.set("instantType", void 0);
      const Z = new AbortController();
      return U(() => {
        y.set("instantType", "trigger-change");
      }, Z.signal), () => {
        Z.abort();
      };
    }
  }, [Y, U, y]);
  const ue = {
    open: I,
    side: X.side,
    align: X.align,
    anchorHidden: X.anchorHidden,
    nested: S.type === "menu",
    instant: V
  }, re = S.type === "menubar" && S.context.modal;
  Ha(I && (re || M && A !== Dt), T === "touch", O, k);
  const oe = Br(e, ue, {
    styles: X.positionerStyles,
    transitionStatus: D,
    props: w,
    refs: [n, y.useStateSetter("positionerElement")],
    hidden: !N,
    inert: !I
  }), me = N && S.type !== "menu" && (S.type !== "menubar" && M && A !== Dt || S.type === "menubar" && S.context.modal);
  let de = null;
  return S.type === "menubar" ? de = S.context.contentElement : S.type === void 0 && (de = k), /* @__PURE__ */ j(xd.Provider, {
    value: X,
    children: [me && /* @__PURE__ */ x(Wr, {
      ref: S.type === "context-menu" || S.type === "nested-context-menu" ? S.context.internalBackdropRef : null,
      inert: gr(!I),
      cutout: de
    }), /* @__PURE__ */ x(tu, {
      id: F,
      children: /* @__PURE__ */ x(Gr, {
        elementsRef: y.context.itemDomElements,
        labelsRef: y.context.itemLabels,
        children: oe
      })
    })]
  });
});
process.env.NODE_ENV !== "production" && (Mb.displayName = "MenuPositioner");
const Ed = /* @__PURE__ */ v.createContext(void 0);
process.env.NODE_ENV !== "production" && (Ed.displayName = "MenuRadioGroupContext");
function u9() {
  const t = v.useContext(Ed);
  if (t === void 0)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: MenuRadioGroupContext is missing. MenuRadioGroup parts must be placed within <Menu.RadioGroup>." : Xe(34));
  return t;
}
const Tb = /* @__PURE__ */ v.memo(/* @__PURE__ */ v.forwardRef(function(e, n) {
  const {
    render: o,
    className: r,
    value: s,
    defaultValue: i,
    onValueChange: a,
    disabled: l = !1,
    style: c,
    ...u
  } = e, [d, f] = sn({
    controlled: s,
    default: i,
    name: "MenuRadioGroup"
  }), p = ge(a), g = ge((w, y) => {
    p?.(w, y), !y.isCanceled && f(w);
  }), h = Te("div", e, {
    state: {
      disabled: l
    },
    ref: n,
    props: {
      role: "group",
      "aria-disabled": l || void 0,
      ...u
    }
  }), b = v.useMemo(() => ({
    value: d,
    setValue: g,
    disabled: l
  }), [d, g, l]);
  return /* @__PURE__ */ x(Ed.Provider, {
    value: b,
    children: h
  });
}));
process.env.NODE_ENV !== "production" && (Tb.displayName = "MenuRadioGroup");
const Pd = /* @__PURE__ */ v.createContext(void 0);
process.env.NODE_ENV !== "production" && (Pd.displayName = "MenuRadioItemContext");
function d9() {
  const t = v.useContext(Pd);
  if (t === void 0)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: MenuRadioItemContext is missing. MenuRadioItem parts must be placed within <Menu.RadioItem>." : Xe(35));
  return t;
}
const kb = /* @__PURE__ */ v.forwardRef(function(e, n) {
  const {
    render: o,
    className: r,
    id: s,
    label: i,
    nativeButton: a = !1,
    disabled: l = !1,
    closeOnClick: c = !1,
    value: u,
    style: d,
    ...f
  } = e, p = Ro({
    label: i
  }), g = si(!0), m = St(s), {
    store: h
  } = Kn(), b = h.useState("isActive", p.index), w = h.useState("itemProps"), {
    value: y,
    setValue: C,
    disabled: R
  } = u9(), S = R || l, E = y === u, {
    getItemProps: P,
    itemRef: N
  } = Ka({
    closeOnClick: c,
    disabled: S,
    highlighted: b,
    id: m,
    store: h,
    nativeButton: a,
    nodeId: g?.context.nodeId,
    itemMetadata: Cd
  }), I = v.useMemo(() => ({
    disabled: S,
    highlighted: b,
    checked: E
  }), [S, b, E]), M = ge((k) => {
    const D = {
      ...Pe(ko, k.nativeEvent),
      preventUnmountOnClose: () => {
      }
    };
    C(u, D);
  }), T = Te("div", e, {
    state: I,
    stateAttributesMapping: Sd,
    props: [w, {
      role: "menuitemradio",
      "aria-checked": E,
      onClick: M
    }, f, P],
    ref: [N, n, p.ref]
  });
  return /* @__PURE__ */ x(Pd.Provider, {
    value: I,
    children: T
  });
});
process.env.NODE_ENV !== "production" && (kb.displayName = "MenuRadioItem");
const Ob = /* @__PURE__ */ v.forwardRef(function(e, n) {
  const {
    render: o,
    className: r,
    style: s,
    keepMounted: i = !1,
    ...a
  } = e, l = d9(), c = v.useRef(null), {
    transitionStatus: u,
    setMounted: d
  } = Yn(l.checked);
  Bt({
    open: l.checked,
    ref: c,
    onComplete() {
      l.checked || d(!1);
    }
  });
  const f = {
    checked: l.checked,
    disabled: l.disabled,
    highlighted: l.highlighted,
    transitionStatus: u
  };
  return Te("span", e, {
    state: f,
    stateAttributesMapping: Sd,
    ref: [n, c],
    props: {
      "aria-hidden": !0,
      ...a
    },
    enabled: i || l.checked
  });
});
process.env.NODE_ENV !== "production" && (Ob.displayName = "MenuRadioItemIndicator");
const Db = /* @__PURE__ */ v.createContext(null);
process.env.NODE_ENV !== "production" && (Db.displayName = "MenubarContext");
function _b(t) {
  return v.useContext(Db);
}
const f9 = {
  ...Ws,
  disabled: ce((t) => t.parent.type === "menubar" && t.parent.context.disabled || t.disabled),
  modal: ce((t) => (t.parent.type === void 0 || t.parent.type === "context-menu") && (t.modal ?? !0)),
  openMethod: ce((t) => t.openMethod),
  allowMouseEnter: ce((t) => t.allowMouseEnter),
  stickIfOpen: ce((t) => t.stickIfOpen),
  parent: ce((t) => t.parent),
  rootId: ce((t) => t.parent.type === "menu" ? t.parent.store.select("rootId") : t.parent.type !== void 0 ? t.parent.context.rootId : t.rootId),
  activeIndex: ce((t) => t.activeIndex),
  isActive: ce((t, e) => t.activeIndex === e),
  hoverEnabled: ce((t) => t.hoverEnabled),
  instantType: ce((t) => t.instantType),
  lastOpenChangeReason: ce((t) => t.openChangeReason),
  floatingTreeRoot: ce((t) => t.parent.type === "menu" ? t.parent.store.select("floatingTreeRoot") : t.floatingTreeRoot),
  floatingNodeId: ce((t) => t.floatingNodeId),
  floatingParentNodeId: ce((t) => t.floatingParentNodeId),
  itemProps: ce((t) => t.itemProps),
  closeDelay: ce((t) => t.closeDelay),
  hasViewport: ce((t) => t.hasViewport),
  keyboardEventRelay: ce((t) => {
    if (t.keyboardEventRelay)
      return t.keyboardEventRelay;
    if (t.parent.type === "menu")
      return t.parent.store.select("keyboardEventRelay");
  })
};
class Nd extends ur {
  constructor(e) {
    super({
      ...p9(),
      ...e
    }, {
      positionerRef: /* @__PURE__ */ v.createRef(),
      popupRef: /* @__PURE__ */ v.createRef(),
      typingRef: {
        current: !1
      },
      itemDomElements: {
        current: []
      },
      itemLabels: {
        current: []
      },
      allowMouseUpTriggerRef: {
        current: !1
      },
      triggerFocusTargetRef: /* @__PURE__ */ v.createRef(),
      beforeContentFocusGuardRef: /* @__PURE__ */ v.createRef(),
      onOpenChangeComplete: void 0,
      triggerElements: new dr()
    }, f9), this.unsubscribeParentListener = this.observe("parent", (n) => {
      if (this.unsubscribeParentListener?.(), n.type === "menu") {
        let o = n.store.select("rootId"), r = n.store.select("floatingTreeRoot"), s = n.store.select("keyboardEventRelay");
        this.unsubscribeParentListener = n.store.subscribe(() => {
          const i = n.store.select("rootId"), a = n.store.select("floatingTreeRoot"), l = n.store.select("keyboardEventRelay");
          o === i && r === a && s === l || (o = i, r = a, s = l, this.notifyAll());
        }), this.context.allowMouseUpTriggerRef = n.store.context.allowMouseUpTriggerRef;
        return;
      }
      n.type !== void 0 && (this.context.allowMouseUpTriggerRef = n.context.allowMouseUpTriggerRef), this.unsubscribeParentListener = null;
    });
  }
  setOpen(e, n) {
    this.state.floatingRootContext.context.events.emit("setOpen", {
      open: e,
      eventDetails: n
    });
  }
  static useStore(e, n) {
    const o = Pt(() => new Nd(n)).current;
    return e ?? o;
  }
  unsubscribeParentListener = null;
}
function p9() {
  return {
    ...Bs(),
    disabled: !1,
    modal: !0,
    openMethod: null,
    allowMouseEnter: !1,
    stickIfOpen: !0,
    parent: {
      type: void 0
    },
    rootId: void 0,
    activeIndex: null,
    hoverEnabled: !0,
    instantType: void 0,
    openChangeReason: null,
    floatingTreeRoot: new Qc(),
    floatingNodeId: void 0,
    floatingParentNodeId: null,
    itemProps: yt,
    keyboardEventRelay: void 0,
    closeDelay: 0,
    hasViewport: !1
  };
}
const Id = /* @__PURE__ */ v.createContext(void 0);
process.env.NODE_ENV !== "production" && (Id.displayName = "MenuSubmenuRootContext");
function Vb() {
  return v.useContext(Id);
}
const Xr = au(function(e) {
  const {
    children: n,
    open: o,
    onOpenChange: r,
    onOpenChangeComplete: s,
    defaultOpen: i = !1,
    disabled: a = !1,
    modal: l,
    loopFocus: c = !0,
    orientation: u = "vertical",
    actionsRef: d,
    closeParentOnEsc: f = !1,
    handle: p,
    triggerId: g,
    defaultTriggerId: m = null,
    highlightItemOnHover: h = !0
  } = e, b = ja(!0), w = Kn(!0), y = _b(!0), C = Vb(), R = v.useMemo(() => C && w ? {
    type: "menu",
    store: w.store
  } : y ? {
    type: "menubar",
    context: y
  } : b && !w ? {
    type: "context-menu",
    context: b
  } : {
    type: void 0
  }, [b, w, y, C]), S = Nd.useStore(p?.store, {
    open: i,
    openProp: o,
    activeTriggerId: m,
    triggerIdProp: g,
    parent: R
  });
  sr(() => {
    o === void 0 && S.state.open === !1 && i === !0 && S.update({
      open: !0,
      activeTriggerId: m
    });
  }), S.useControlledProp("openProp", o), S.useControlledProp("triggerIdProp", g), S.useContextCallback("onOpenChangeComplete", s);
  const E = S.useState("floatingTreeRoot"), P = Ta(E), N = ao();
  xe(() => {
    b && !w ? S.update({
      parent: {
        type: "context-menu",
        context: b
      },
      floatingNodeId: P,
      floatingParentNodeId: N
    }) : w && S.update({
      floatingNodeId: P,
      floatingParentNodeId: N
    });
  }, [b, w, P, N, S]);
  const I = S.useState("open"), M = S.useState("activeTriggerElement"), T = S.useState("positionerElement"), k = S.useState("hoverEnabled"), D = S.useState("disabled"), O = S.useState("lastOpenChangeReason"), V = S.useState("parent"), _ = S.useState("activeIndex"), A = S.useState("payload"), F = S.useState("floatingParentNodeId"), H = v.useRef(null), Y = F != null;
  process.env.NODE_ENV !== "production" && V.type !== void 0 && l !== void 0 && console.warn("Base UI: The `modal` prop is not supported on nested menus. It will be ignored.");
  const {
    openMethod: B,
    triggerProps: U
  } = Js(I);
  S.useSyncedValues({
    disabled: a,
    modal: V.type === void 0 ? l : void 0,
    openMethod: B,
    rootId: wo()
  }), zs(S);
  const {
    forceUnmount: q
  } = Hs(I, S, () => {
    S.update({
      allowMouseEnter: !1,
      stickIfOpen: !0
    });
  }), W = v.useRef(V.type !== "context-menu"), K = Vt();
  v.useEffect(() => {
    if (I || (H.current = null), V.type === "context-menu") {
      if (!I) {
        K.clear(), W.current = !1;
        return;
      }
      K.start(500, () => {
        W.current = !0;
      });
    }
  }, [K, I, V.type]), xe(() => {
    !I && !k && S.set("hoverEnabled", !0);
  }, [I, k, S]);
  const te = v.useRef(!0), z = Vt(), Q = ge((Se, Ie) => {
    const Le = Ie.reason;
    if (I === Se && Ie.trigger === M && O === Le || (Ie.preventUnmountOnClose = () => {
      S.set("preventUnmountingOnClose", !0);
    }, !Se && Ie.trigger == null && (Ie.trigger = M ?? void 0), r?.(Se, Ie), Ie.isCanceled))
      return;
    S.state.floatingRootContext.dispatchOpenChange(Se, Ie);
    const Ze = Ie.event;
    if (Se === !1 && Ze?.type === "click" && Ze.pointerType === "touch" && !te.current)
      return;
    if (!Se && _ !== null) {
      const Ce = S.context.itemDomElements.current[_];
      queueMicrotask(() => {
        Ce?.setAttribute("tabindex", "-1");
      });
    }
    Se && Le === Qo ? (te.current = !1, z.start(300, () => {
      te.current = !0;
    })) : (te.current = !0, z.clear());
    const tt = (Le === Bn || Le === ko) && Ze.detail === 0 && Ze?.isTrusted, ut = !Se && (Le === ar || Le == null), at = {
      open: Se,
      openChangeReason: Le
    };
    H.current = Ie.event ?? null;
    const $e = Ie.trigger?.id ?? null;
    ($e || Se) && (at.activeTriggerId = $e, at.activeTriggerElement = Ie.trigger ?? null), S.update(at), V.type === "menubar" && (Le === Qo || Le === yo || Le === Dt || Le === Er || Le === us) ? S.set("instantType", "group") : tt || ut ? S.set("instantType", tt ? "click" : "dismiss") : S.set("instantType", void 0);
  }), ee = v.useCallback(() => {
    S.setOpen(!1, Pe(As));
  }, [S]);
  v.useImperativeHandle(d, () => ({
    unmount: q,
    close: ee
  }), [q, ee]);
  let ae;
  V.type === "context-menu" && (ae = V.context), v.useImperativeHandle(ae?.positionerRef, () => T, [T]), v.useImperativeHandle(ae?.actionsRef, () => ({
    setOpen: Q
  }), [Q]);
  const X = Us({
    popupStore: S,
    onOpenChange: Q
  }), se = X.context.events;
  v.useEffect(() => {
    const Se = ({
      open: Ie,
      eventDetails: Le
    }) => Q(Ie, Le);
    return se.on("setOpen", Se), () => {
      se?.off("setOpen", Se);
    };
  }, [se, Q]);
  const ue = cr(X, {
    enabled: !D,
    bubbles: {
      escapeKey: f && V.type === "menu"
    },
    outsidePress() {
      return V.type !== "context-menu" || H.current?.type === "contextmenu" ? !0 : W.current;
    },
    externalTree: Y ? E : void 0
  }), re = gu(X, {
    role: "menu"
  }), ne = Ks(), oe = v.useCallback((Se) => {
    S.select("activeIndex") !== Se && S.set("activeIndex", Se);
  }, [S]), me = pu(X, {
    enabled: !D,
    listRef: S.context.itemDomElements,
    activeIndex: _,
    nested: V.type !== void 0,
    loopFocus: c,
    orientation: u,
    parentOrientation: V.type === "menubar" ? V.context.orientation : void 0,
    rtl: ne === "rtl",
    disabledIndices: Nn,
    onNavigate: oe,
    openOnArrowKeyDown: V.type !== "context-menu",
    externalTree: Y ? E : void 0,
    focusItemOnHover: h
  }), de = v.useCallback((Se) => {
    S.context.typingRef.current = Se;
  }, [S]), he = mu(X, {
    listRef: S.context.itemLabels,
    elementsRef: S.context.itemDomElements,
    activeIndex: _,
    resetMs: cx,
    onMatch: (Se) => {
      I && Se !== _ && S.set("activeIndex", Se);
    },
    onTypingChange: de
  }), {
    getReferenceProps: $,
    getFloatingProps: Z,
    getItemProps: L,
    getTriggerProps: G
  } = Gn([ue, re, me, he]), ie = v.useMemo(() => {
    const Se = on($(), {
      onMouseMove() {
        S.set("allowMouseEnter", !0);
      }
    }, U);
    return delete Se.role, Se;
  }, [$, S, U]), pe = v.useMemo(() => {
    const Se = G();
    if (!Se)
      return Se;
    const Ie = on(Se, U);
    return delete Ie.role, delete Ie["aria-controls"], Ie;
  }, [G, U]), be = v.useMemo(() => Z({
    onMouseMove() {
      S.set("allowMouseEnter", !0), V.type === "menu" && S.set("hoverEnabled", !1);
    },
    onClick() {
      S.select("hoverEnabled") && S.set("hoverEnabled", !1);
    },
    onKeyDown(Se) {
      const Ie = S.select("keyboardEventRelay");
      Ie && !Se.isPropagationStopped() && Ie(Se);
    }
  }), [Z, V.type, S]), Re = v.useMemo(() => L(), [L]);
  S.useSyncedValues({
    floatingRootContext: X,
    activeTriggerProps: ie,
    inactiveTriggerProps: pe,
    popupProps: be,
    itemProps: Re
  });
  const _e = v.useMemo(() => ({
    store: S,
    parent: R
  }), [S, R]), ke = /* @__PURE__ */ x(wd.Provider, {
    value: _e,
    children: typeof n == "function" ? n({
      payload: A
    }) : n
  });
  return V.type === void 0 || V.type === "context-menu" ? /* @__PURE__ */ x(nu, {
    externalTree: E,
    children: ke
  }) : ke;
});
process.env.NODE_ENV !== "production" && (Xr.displayName = "MenuRoot");
function g9(t) {
  const e = Kn().store, n = v.useMemo(() => ({
    parentMenu: e
  }), [e]);
  return /* @__PURE__ */ x(Id.Provider, {
    value: n,
    children: /* @__PURE__ */ x(Xr, {
      ...t
    })
  });
}
function Ab(t = {}) {
  const {
    highlightItemOnHover: e,
    highlightedIndex: n,
    onHighlightedIndexChange: o
  } = Fc(), {
    ref: r,
    index: s
  } = Ro(t), i = n === s, a = v.useRef(null), l = ln(r, a);
  return {
    compositeProps: v.useMemo(() => ({
      tabIndex: i ? 0 : -1,
      onFocus() {
        o(s);
      },
      onMouseMove() {
        const u = a.current;
        if (!e || !u)
          return;
        const d = u.hasAttribute("disabled") || u.ariaDisabled === "true";
        !i && !d && u.focus();
      }
    }), [i, o, s, e]),
    compositeRef: l,
    index: s
  };
}
function Md(t) {
  const {
    render: e,
    className: n,
    style: o,
    state: r = yt,
    props: s = Nn,
    refs: i = Nn,
    metadata: a,
    stateAttributesMapping: l,
    tag: c = "div",
    ...u
  } = t, {
    compositeProps: d,
    compositeRef: f
  } = Ab({
    metadata: a
  });
  return Te(c, t, {
    state: r,
    ref: [...i, f],
    props: [d, ...s, u],
    stateAttributesMapping: l
  });
}
function Fb(t) {
  if (bt(t) && t.hasAttribute("data-rootownerid"))
    return t.getAttribute("data-rootownerid") ?? void 0;
  if (!to(t))
    return Fb(ro(t));
}
function m9(t) {
  const {
    enabled: e = !0,
    mouseDownAction: n,
    open: o
  } = t, r = v.useRef(!1);
  return v.useMemo(() => e ? {
    onMouseDown: (s) => {
      (n === "open" && !o || n === "close" && o) && (r.current = !0, Ke(s.currentTarget).addEventListener("click", () => {
        r.current = !1;
      }, {
        once: !0
      }));
    },
    onClick: (s) => {
      r.current && (r.current = !1, s.preventBaseUIHandler());
    }
  } : yt, [e, n, o]);
}
const Fi = 2, Lb = u1(function(e, n) {
  const {
    render: o,
    className: r,
    disabled: s = !1,
    nativeButton: i = !0,
    id: a,
    openOnHover: l,
    delay: c = 100,
    closeDelay: u = 0,
    handle: d,
    payload: f,
    style: p,
    ...g
  } = e, m = Kn(!0), h = d?.store ?? m?.store;
  if (!h)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: <Menu.Trigger> must be either used within a <Menu.Root> component or provided with a handle." : Xe(85));
  const b = St(a), w = h.useState("isTriggerActive", b), y = h.useState("floatingRootContext"), C = h.useState("isOpenedByTrigger", b), R = v.useRef(null), S = b9(), E = Fc(!0), P = Ho(), N = v.useMemo(() => P ?? new Qc(), [P]), I = Ta(N), M = ao(), {
    registerTrigger: T,
    isMountedByThisTrigger: k
  } = $s(b, R, h, {
    payload: f,
    closeDelay: u,
    parent: S,
    floatingTreeRoot: N,
    floatingNodeId: I,
    floatingParentNodeId: M,
    keyboardEventRelay: E?.relayKeyboardEvent
  }), D = S.type === "menubar", O = h.useState("disabled"), V = s || O || D && S.context.disabled, {
    getButtonProps: _,
    buttonRef: A
  } = Ft({
    disabled: V,
    native: i
  });
  v.useEffect(() => {
    !C && S.type === void 0 && (h.context.allowMouseUpTriggerRef.current = !1);
  }, [h, C, S.type]);
  const F = v.useRef(null), H = Vt(), Y = ge((me) => {
    if (!F.current)
      return;
    H.clear(), h.context.allowMouseUpTriggerRef.current = !1;
    const de = me.target;
    if (De(F.current, de) || De(h.select("positionerElement"), de) || de === F.current || de != null && Fb(de) === h.select("rootId"))
      return;
    const he = Uu(F.current);
    me.clientX >= he.left - Fi && me.clientX <= he.right + Fi && me.clientY >= he.top - Fi && me.clientY <= he.bottom + Fi || N.events.emit("close", {
      domEvent: me,
      reason: Pm
    });
  });
  v.useEffect(() => {
    C && h.select("lastOpenChangeReason") === Dt && Ke(F.current).addEventListener("mouseup", Y, {
      once: !0
    });
  }, [C, Y, h]);
  const B = D && S.context.hasSubmenuOpen, q = Ys(y, {
    enabled: (l ?? B) && !V && S.type !== "context-menu" && (!D || B && !k),
    handleClose: Gs({
      blockPointerEvents: !D
    }),
    mouseOnly: !0,
    move: !1,
    restMs: S.type === void 0 ? c : void 0,
    delay: {
      close: u
    },
    triggerElementRef: R,
    externalTree: N,
    isActiveTrigger: w,
    isClosing: () => h.select("transitionStatus") === "ending"
  }), W = h9(C, h.select("lastOpenChangeReason")), K = lr(y, {
    enabled: !V && S.type !== "context-menu",
    event: C && D ? "click" : "mousedown",
    toggle: !0,
    ignoreMouse: !1,
    stickIfOpen: S.type === void 0 ? W : !1
  }), te = du(y, {
    enabled: !V && B
  }), z = m9({
    open: C,
    enabled: D,
    mouseDownAction: "open"
  }), Q = Gn([K, te]), ee = {
    disabled: V,
    open: C
  }, ae = h.useState("triggerProps", k), X = [F, n, A, T, R], se = [Q.getReferenceProps(), q ?? yt, ae, {
    "aria-haspopup": "menu",
    id: b,
    onMouseDown: (me) => {
      if (h.select("open"))
        return;
      H.start(200, () => {
        h.context.allowMouseUpTriggerRef.current = !0;
      }), Ke(me.currentTarget).addEventListener("mouseup", Y, {
        once: !0
      });
    }
  }, D ? {
    role: "menuitem"
  } : {}, z, g, _], {
    preFocusGuardRef: ue,
    handlePreFocusGuardFocus: re,
    handleFocusTargetFocus: ne
  } = Q1(h, R), oe = Te("button", e, {
    enabled: !D,
    stateAttributesMapping: Es,
    state: ee,
    ref: X,
    props: se
  });
  return D ? /* @__PURE__ */ x(Md, {
    tag: "button",
    render: o,
    className: r,
    style: p,
    state: ee,
    refs: X,
    props: se,
    stateAttributesMapping: Es
  }) : C ? /* @__PURE__ */ j(v.Fragment, {
    children: [/* @__PURE__ */ x(Mn, {
      ref: ue,
      onFocus: re
    }, `${b}-pre-focus-guard`), /* @__PURE__ */ x(v.Fragment, {
      children: oe
    }, b), /* @__PURE__ */ x(Mn, {
      ref: h.context.triggerFocusTargetRef,
      onFocus: ne
    }, `${b}-post-focus-guard`)]
  }) : /* @__PURE__ */ x(v.Fragment, {
    children: oe
  }, b);
});
process.env.NODE_ENV !== "production" && (Lb.displayName = "MenuTrigger");
function h9(t, e) {
  const n = Vt(), [o, r] = v.useState(!1);
  return xe(() => {
    t && e === "trigger-hover" ? (r(!0), n.start(Km, () => {
      r(!1);
    })) : t || (n.clear(), r(!1));
  }, [t, e, n]), o;
}
function b9() {
  const t = ja(!0), e = Kn(!0), n = _b();
  return v.useMemo(() => n ? {
    type: "menubar",
    context: n
  } : t && !e ? {
    type: "context-menu",
    context: t
  } : {
    type: void 0
  }, [t, e, n]);
}
function $b(t) {
  return t == null || t.hasAttribute("disabled") || t.getAttribute("aria-disabled") === "true";
}
const zb = /* @__PURE__ */ v.forwardRef(function(e, n) {
  const {
    render: o,
    className: r,
    label: s,
    id: i,
    nativeButton: a = !1,
    openOnHover: l = !0,
    delay: c = 100,
    closeDelay: u = 0,
    disabled: d = !1,
    style: f,
    ...p
  } = e, g = Ro(), m = si(), {
    store: h
  } = Kn(), b = St(i), w = h.useState("open"), y = h.useState("floatingRootContext"), C = h.useState("floatingTreeRoot"), R = d1(b, h), S = v.useCallback((K) => {
    const te = R(K);
    return K !== null && h.select("open") && h.select("activeTriggerId") == null && h.update({
      activeTriggerId: b,
      activeTriggerElement: K,
      closeDelay: u
    }), te;
  }, [R, u, h, b]), E = v.useRef(null), P = v.useCallback((K) => {
    E.current = K, h.set("activeTriggerElement", K);
  }, [h]);
  process.env.NODE_ENV !== "production" && xe(() => {
    const K = E.current;
    if (K && $b(K) && !d) {
      const te = Jo.captureOwnerStack?.() || "";
      Ea(`A disabled element was detected on <Menu.SubmenuTrigger>. To properly disable the trigger, use the \`disabled\` prop on the component instead of setting it on the rendered element.${te}`);
    }
  });
  const N = Vb();
  if (!N?.parentMenu)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: <Menu.SubmenuTrigger> must be placed in <Menu.SubmenuRoot>." : Xe(37));
  h.useSyncedValue("closeDelay", u);
  const I = N.parentMenu, M = I.useState("itemProps"), T = I.useState("isActive", g.index), k = v.useMemo(() => ({
    type: "submenu-trigger",
    setActive() {
      I.set("activeIndex", g.index);
    }
  }), [I, g.index]), D = h.useState("disabled"), O = d || D, {
    getItemProps: V,
    itemRef: _
  } = Ka({
    closeOnClick: !1,
    disabled: O,
    highlighted: T,
    id: b,
    store: h,
    typingRef: I.context.typingRef,
    nativeButton: a,
    itemMetadata: k,
    nodeId: m?.context.nodeId
  }), A = h.useState("hoverEnabled"), F = I.useState("allowMouseEnter"), H = Ys(y, {
    enabled: A && l && !O,
    handleClose: Gs({
      blockPointerEvents: !0
    }),
    mouseOnly: !0,
    move: !0,
    restMs: c,
    delay: F ? {
      open: c,
      close: u
    } : 0,
    triggerElementRef: E,
    externalTree: C,
    isClosing: () => h.select("transitionStatus") === "ending"
  }), Y = lr(y, {
    enabled: !O,
    event: "mousedown",
    toggle: !l,
    ignoreMouse: l,
    stickIfOpen: !1
  }), B = Gn([Y]), U = h.useState("triggerProps", !0);
  return delete U.id, Te("div", e, {
    state: {
      disabled: O,
      highlighted: T,
      open: w
    },
    stateAttributesMapping: fr,
    props: [B.getReferenceProps(), H, U, M, {
      tabIndex: w || T ? 0 : -1,
      onBlur() {
        T && I.set("activeIndex", null);
      }
    }, p, V],
    ref: [n, g.ref, _, S, P]
  });
});
process.env.NODE_ENV !== "production" && (zb.displayName = "MenuSubmenuTrigger");
const Td = /* @__PURE__ */ v.createContext(void 0);
process.env.NODE_ENV !== "production" && (Td.displayName = "TabsRootContext");
function kd() {
  const t = v.useContext(Td);
  if (t === void 0)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: TabsRootContext is missing. Tabs parts must be placed within <Tabs.Root>." : Xe(64));
  return t;
}
let v9 = /* @__PURE__ */ (function(t) {
  return t.activationDirection = "data-activation-direction", t.orientation = "data-orientation", t;
})({});
const Od = {
  tabActivationDirection: (t) => ({
    [v9.activationDirection]: t
  })
}, Dd = /* @__PURE__ */ v.forwardRef(function(e, n) {
  const {
    className: o,
    defaultValue: r = 0,
    onValueChange: s,
    orientation: i = "horizontal",
    render: a,
    value: l,
    style: c,
    ...u
  } = e, d = Object.hasOwn(e, "defaultValue"), f = v.useRef([]), [p, g] = v.useState(() => /* @__PURE__ */ new Map()), [m, h] = sn({
    controlled: l,
    default: r,
    name: "Tabs",
    state: "value"
  }), b = l !== void 0, [w, y] = v.useState(() => /* @__PURE__ */ new Map()), C = v.useCallback((U) => {
    if (U === void 0)
      return null;
    for (const [q, W] of w.entries())
      if (W != null && U === (W.value ?? W.index))
        return q;
    return null;
  }, [w]), [R, S] = v.useState(() => ({
    previousValue: m,
    tabActivationDirection: "none"
  })), {
    previousValue: E,
    tabActivationDirection: P
  } = R;
  let N = P, I = !1;
  E !== m && (N = Ig(E, m, i, w), I = E != null && m != null && C(m) == null);
  const M = I ? E : m, T = E !== M || P !== N;
  xe(() => {
    T && S({
      previousValue: M,
      tabActivationDirection: N
    });
  }, [M, T, N]);
  const k = ge((U, q) => {
    const W = Ig(m, U, i, w);
    q.activationDirection = W, s?.(U, q), !q.isCanceled && h(U);
  }), D = ge((U, q) => {
    g((W) => {
      if (W.get(U) === q)
        return W;
      const K = new Map(W);
      return K.set(U, q), K;
    });
  }), O = ge((U, q) => {
    g((W) => {
      if (!W.has(U) || W.get(U) !== q)
        return W;
      const K = new Map(W);
      return K.delete(U), K;
    });
  }), V = v.useCallback((U) => p.get(U), [p]), _ = v.useCallback((U) => {
    for (const q of w.values())
      if (U === q?.value)
        return q?.id;
  }, [w]), A = v.useMemo(() => ({
    getTabElementBySelectedValue: C,
    getTabIdByPanelValue: _,
    getTabPanelIdByValue: V,
    onValueChange: k,
    orientation: i,
    registerMountedTabPanel: D,
    setTabMap: y,
    unregisterMountedTabPanel: O,
    tabActivationDirection: N,
    value: m
  }), [C, _, V, k, i, D, y, O, N, m]), F = v.useMemo(() => {
    for (const U of w.values())
      if (U != null && U.value === m)
        return U;
  }, [w, m]), H = v.useMemo(() => {
    for (const U of w.values())
      if (U != null && !U.disabled)
        return U.value;
  }, [w]);
  xe(() => {
    if (b || w.size === 0)
      return;
    const U = F?.disabled, q = F == null && m !== null;
    if (d && U && m === r || !U && !q)
      return;
    const K = H ?? null;
    m !== K && (h(K), S((te) => te.tabActivationDirection === "none" ? te : {
      ...te,
      tabActivationDirection: "none"
    }));
  }, [r, H, d, b, F, h, w, m]);
  const B = Te("div", e, {
    state: {
      orientation: i,
      tabActivationDirection: N
    },
    ref: n,
    props: u,
    stateAttributesMapping: Od
  });
  return /* @__PURE__ */ x(Td.Provider, {
    value: A,
    children: /* @__PURE__ */ x(Gr, {
      elementsRef: f,
      children: B
    })
  });
});
process.env.NODE_ENV !== "production" && (Dd.displayName = "TabsRoot");
function Ig(t, e, n, o) {
  if (t == null || e == null)
    return "none";
  let r = null, s = null;
  for (const [l, c] of o.entries()) {
    if (c == null)
      continue;
    const u = c.value ?? c.index;
    if (t === u && (r = l), e === u && (s = l), r != null && s != null)
      break;
  }
  if (r == null || s == null)
    return r !== s && (typeof t == "number" || typeof t == "string") && typeof t == typeof e ? n === "horizontal" ? e > t ? "right" : "left" : e > t ? "down" : "up" : "none";
  const i = r.getBoundingClientRect(), a = s.getBoundingClientRect();
  if (n === "horizontal") {
    if (a.left < i.left)
      return "left";
    if (a.left > i.left)
      return "right";
  } else {
    if (a.top < i.top)
      return "up";
    if (a.top > i.top)
      return "down";
  }
  return "none";
}
const _d = "data-composite-item-active", Vd = /* @__PURE__ */ v.createContext(void 0);
process.env.NODE_ENV !== "production" && (Vd.displayName = "TabsListContext");
function y9() {
  const t = v.useContext(Vd);
  if (t === void 0)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: TabsListContext is missing. TabsList parts must be placed within <Tabs.List>." : Xe(65));
  return t;
}
const Ad = /* @__PURE__ */ v.forwardRef(function(e, n) {
  const {
    className: o,
    disabled: r = !1,
    render: s,
    value: i,
    id: a,
    nativeButton: l = !0,
    style: c,
    ...u
  } = e, {
    value: d,
    getTabPanelIdByValue: f,
    orientation: p
  } = kd(), {
    activateOnFocus: g,
    highlightedTabIndex: m,
    onTabActivation: h,
    registerTabResizeObserverElement: b,
    setHighlightedTabIndex: w,
    tabsListElement: y
  } = y9(), C = St(a), R = v.useMemo(() => ({
    disabled: r,
    id: C,
    value: i
  }), [r, C, i]), {
    compositeProps: S,
    compositeRef: E,
    index: P
    // hook is used instead of the CompositeItem component
    // because the index is needed for Tab internals
  } = Ab({
    metadata: R
  }), N = i === d, I = v.useRef(!1), M = v.useRef(null);
  v.useEffect(() => {
    const B = M.current;
    if (B)
      return b(B);
  }, [b]), xe(() => {
    if (I.current) {
      I.current = !1;
      return;
    }
    if (!(N && P > -1 && m !== P))
      return;
    const B = y;
    if (B != null) {
      const U = zt(Ke(B));
      if (U && De(B, U))
        return;
    }
    r || w(P);
  }, [N, P, m, w, r, y]);
  const {
    getButtonProps: T,
    buttonRef: k
  } = Ft({
    disabled: r,
    native: l,
    focusableWhenDisabled: !0
  }), D = f(i), O = v.useRef(!1), V = v.useRef(!1);
  function _(B) {
    N || r || h(i, Pe(Et, B.nativeEvent, void 0, {
      activationDirection: "none"
    }));
  }
  function A(B) {
    N || (P > -1 && !r && w(P), !r && g && (!O.current || // keyboard or touch focus
    O.current && V.current) && h(i, Pe(Et, B.nativeEvent, void 0, {
      activationDirection: "none"
    })));
  }
  function F(B) {
    if (N || r)
      return;
    O.current = !0;
    function U() {
      O.current = !1, V.current = !1;
    }
    (!B.button || B.button === 0) && (V.current = !0, Ke(B.currentTarget).addEventListener("pointerup", U, {
      once: !0
    }));
  }
  return Te("button", e, {
    state: {
      disabled: r,
      active: N,
      orientation: p
    },
    ref: [n, k, E, M],
    props: [S, {
      role: "tab",
      "aria-controls": D,
      "aria-selected": N,
      id: C,
      onClick: _,
      onFocus: A,
      onPointerDown: F,
      [_d]: N ? "" : void 0,
      onKeyDownCapture() {
        I.current = !0;
      }
    }, u, T]
  });
});
process.env.NODE_ENV !== "production" && (Ad.displayName = "TabsTab");
let x9 = (function(t) {
  return t.index = "data-index", t.activationDirection = "data-activation-direction", t.orientation = "data-orientation", t.hidden = "data-hidden", t[t.startingStyle = Wn.startingStyle] = "startingStyle", t[t.endingStyle = Wn.endingStyle] = "endingStyle", t;
})({});
const w9 = {
  ...Od,
  ...Lt
}, Hb = /* @__PURE__ */ v.forwardRef(function(e, n) {
  const {
    className: o,
    value: r,
    render: s,
    keepMounted: i = !1,
    style: a,
    ...l
  } = e, {
    value: c,
    getTabIdByPanelValue: u,
    orientation: d,
    tabActivationDirection: f,
    registerMountedTabPanel: p,
    unregisterMountedTabPanel: g
  } = kd(), m = St(), h = v.useMemo(() => ({
    id: m,
    value: r
  }), [m, r]), {
    ref: b,
    index: w
  } = Ro({
    metadata: h
  }), y = r === c, {
    mounted: C,
    transitionStatus: R,
    setMounted: S
  } = Yn(y), E = !C, P = u(r), N = {
    hidden: E,
    orientation: d,
    tabActivationDirection: f,
    transitionStatus: R
  }, I = v.useRef(null), M = Te("div", e, {
    state: N,
    ref: [n, b, I],
    props: [{
      "aria-labelledby": P,
      hidden: E,
      id: m,
      role: "tabpanel",
      tabIndex: y ? 0 : -1,
      inert: gr(!y),
      [x9.index]: w
    }, l],
    stateAttributesMapping: w9
  });
  return Bt({
    open: y,
    ref: I,
    onComplete() {
      y || S(!1);
    }
  }), xe(() => {
    if (!(E && !i) && m != null)
      return p(r, m), () => {
        g(r, m);
      };
  }, [E, i, r, m, p, g]), i || C ? M : null;
});
process.env.NODE_ENV !== "production" && (Hb.displayName = "TabsPanel");
const C9 = [];
function S9(t) {
  const {
    itemSizes: e,
    cols: n = 1,
    loopFocus: o = !0,
    onLoop: r,
    dense: s = !1,
    orientation: i = "both",
    direction: a,
    highlightedIndex: l,
    onHighlightedIndexChange: c,
    rootRef: u,
    enableHomeAndEndKeys: d = !1,
    stopEventPropagation: f = !1,
    disabledIndices: p,
    modifierKeys: g = C9
  } = t, [m, h] = v.useState(0), b = n > 1, w = v.useRef(null), y = ln(w, u), C = v.useRef([]), R = v.useRef(!1), S = l ?? m, E = ge((M, T = !1) => {
    if ((c ?? h)(M), T) {
      const k = C.current[M];
      bp(w.current, k, a, i);
    }
  }), P = ge((M) => {
    if (M.size === 0 || R.current)
      return;
    R.current = !0;
    const T = Array.from(M.keys()), k = T.find((O) => O?.hasAttribute(_d)) ?? null, D = k ? T.indexOf(k) : -1;
    D !== -1 && E(D), bp(w.current, k, a, i);
  }), N = ge((M, T, k) => r ? r?.(M, T, k, C) : k), I = v.useMemo(() => ({
    "aria-orientation": i === "both" ? void 0 : i,
    ref: y,
    onFocus(M) {
      const T = w.current, k = gt(M.nativeEvent);
      !T || k == null || !hp(k) || k.setSelectionRange(0, k.value.length ?? 0);
    },
    onKeyDown(M) {
      const T = d ? AC : R1;
      if (!T.has(M.key) || R9(M, g) || !w.current)
        return;
      const D = a === "rtl", O = D ? Is : Mr, V = {
        horizontal: O,
        vertical: Xo,
        both: O
      }[i], _ = D ? Mr : Is, A = {
        horizontal: _,
        vertical: Ir,
        both: _
      }[i], F = gt(M.nativeEvent);
      if (F != null && hp(F) && !$b(F)) {
        const K = F.selectionStart, te = F.selectionEnd, z = F.value ?? "";
        if (K == null || M.shiftKey || K !== te || M.key !== A && K < z.length || M.key !== V && K > 0)
          return;
      }
      let H = S;
      const Y = Yi(C, p), B = mc(C, p);
      if (b) {
        const K = e || Array.from({
          length: C.current.length
        }, () => ({
          width: 1,
          height: 1
        })), te = _m(K, n, s), z = te.findIndex((ee) => ee != null && !bo(C.current, ee, p)), Q = te.reduce((ee, ae, X) => ae != null && !bo(C.current, ae, p) ? X : ee, -1);
        H = te[Dm(te.map((ee) => ee != null ? C.current[ee] : null), {
          event: M,
          orientation: i,
          loopFocus: o,
          onLoop: N,
          cols: n,
          // treat undefined (empty grid spaces) as disabled indices so we
          // don't end up in them
          disabledIndices: Am([...p || C.current.map((ee, ae) => bo(C.current, ae) ? ae : void 0), void 0], te),
          minIndex: z,
          maxIndex: Q,
          prevIndex: Vm(
            S > B ? Y : S,
            K,
            te,
            n,
            // use a corner matching the edge closest to the direction we're
            // moving in so we don't end up in the same item. Prefer
            // top/left over bottom/right.
            // eslint-disable-next-line no-nested-ternary
            M.key === Xo ? "bl" : M.key === Mr ? "tr" : "tl"
          ),
          rtl: D
        })];
      }
      const U = {
        horizontal: [O],
        vertical: [Xo],
        both: [O, Xo]
      }[i], q = {
        horizontal: [_],
        vertical: [Ir],
        both: [_, Ir]
      }[i], W = b ? T : {
        horizontal: d ? _C : C1,
        vertical: d ? VC : S1,
        both: T
      }[i];
      d && (M.key === qs ? H = Y : M.key === Xs && (H = B)), H === S && (U.includes(M.key) || q.includes(M.key)) && (o && H === B && U.includes(M.key) ? (H = Y, r && (H = r(M, S, H, C))) : o && H === Y && q.includes(M.key) ? (H = B, r && (H = r(M, S, H, C))) : H = Jt(C.current, {
        startingIndex: H,
        decrement: q.includes(M.key),
        disabledIndices: p
      })), H !== S && !Ss(C.current, H) && (f && M.stopPropagation(), W.has(M.key) && M.preventDefault(), E(H, !0), queueMicrotask(() => {
        C.current[H]?.focus();
      }));
    }
  }), [n, s, a, p, C, d, S, b, e, o, r, N, y, g, E, i, f]);
  return v.useMemo(() => ({
    props: I,
    highlightedIndex: S,
    onHighlightedIndexChange: E,
    elementsRef: C,
    disabledIndices: p,
    onMapChange: P,
    relayKeyboardEvent: I.onKeyDown
  }), [I, S, E, C, p, P]);
}
function R9(t, e) {
  for (const n of zC.values())
    if (!e.includes(n) && t.getModifierState(n))
      return !0;
  return !1;
}
function Bb(t) {
  const {
    render: e,
    className: n,
    style: o,
    refs: r = Nn,
    props: s = Nn,
    state: i = yt,
    stateAttributesMapping: a,
    highlightedIndex: l,
    onHighlightedIndexChange: c,
    orientation: u,
    dense: d,
    itemSizes: f,
    loopFocus: p,
    onLoop: g,
    cols: m,
    enableHomeAndEndKeys: h,
    onMapChange: b,
    stopEventPropagation: w = !0,
    rootRef: y,
    disabledIndices: C,
    modifierKeys: R,
    highlightItemOnHover: S = !1,
    tag: E = "div",
    ...P
  } = t, N = Ks(), {
    props: I,
    highlightedIndex: M,
    onHighlightedIndexChange: T,
    elementsRef: k,
    onMapChange: D,
    relayKeyboardEvent: O
  } = S9({
    itemSizes: f,
    cols: m,
    loopFocus: p,
    onLoop: g,
    dense: d,
    orientation: u,
    highlightedIndex: l,
    onHighlightedIndexChange: c,
    rootRef: y,
    stopEventPropagation: w,
    enableHomeAndEndKeys: h,
    direction: N,
    disabledIndices: C,
    modifierKeys: R
  }), V = Te(E, t, {
    state: i,
    ref: r,
    props: [I, ...s, P],
    stateAttributesMapping: a
  }), _ = v.useMemo(() => ({
    highlightedIndex: M,
    onHighlightedIndexChange: T,
    highlightItemOnHover: S,
    relayKeyboardEvent: O
  }), [M, T, S, O]);
  return /* @__PURE__ */ x(Ac.Provider, {
    value: _,
    children: /* @__PURE__ */ x(Gr, {
      elementsRef: k,
      onMapChange: (A) => {
        b?.(A), D(A);
      },
      children: V
    })
  });
}
const Fd = /* @__PURE__ */ v.forwardRef(function(e, n) {
  const {
    activateOnFocus: o = !1,
    className: r,
    loopFocus: s = !0,
    render: i,
    style: a,
    ...l
  } = e, {
    onValueChange: c,
    orientation: u,
    value: d,
    setTabMap: f,
    tabActivationDirection: p
  } = kd(), [g, m] = v.useState(0), [h, b] = v.useState(null), w = v.useRef(/* @__PURE__ */ new Set()), y = v.useRef(/* @__PURE__ */ new Set()), C = v.useRef(null), R = ge(() => {
    w.current.forEach((T) => {
      T();
    });
  });
  v.useEffect(() => {
    if (typeof ResizeObserver > "u")
      return;
    const T = new ResizeObserver(() => {
      w.current.size && R();
    });
    return C.current = T, h && T.observe(h), y.current.forEach((k) => {
      T.observe(k);
    }), () => {
      T.disconnect(), C.current = null;
    };
  }, [h, R]);
  const S = ge((T) => (w.current.add(T), () => {
    w.current.delete(T);
  })), E = ge((T) => (y.current.add(T), C.current?.observe(T), () => {
    y.current.delete(T), C.current?.unobserve(T);
  })), P = ge((T, k) => {
    T !== d && c(T, k);
  }), N = {
    orientation: u,
    tabActivationDirection: p
  }, I = {
    "aria-orientation": u === "vertical" ? "vertical" : void 0,
    role: "tablist"
  }, M = v.useMemo(() => ({
    activateOnFocus: o,
    highlightedTabIndex: g,
    registerIndicatorUpdateListener: S,
    registerTabResizeObserverElement: E,
    onTabActivation: P,
    setHighlightedTabIndex: m,
    tabsListElement: h
  }), [o, g, S, E, P, m, h]);
  return /* @__PURE__ */ x(Vd.Provider, {
    value: M,
    children: /* @__PURE__ */ x(Bb, {
      render: i,
      className: r,
      style: a,
      state: N,
      refs: [n, b],
      props: [I, l],
      stateAttributesMapping: Od,
      highlightedIndex: g,
      enableHomeAndEndKeys: !0,
      loopFocus: s,
      orientation: u,
      onHighlightedIndexChange: m,
      onMapChange: f,
      disabledIndices: Nn
    })
  });
});
process.env.NODE_ENV !== "production" && (Fd.displayName = "TabsList");
const E9 = 13;
function P9(t) {
  const e = J.c(2);
  let n;
  return e[0] !== t ? (n = /* @__PURE__ */ x(Xr, { ...t }), e[0] = t, e[1] = n) : n = e[1], n;
}
function Tr(t) {
  const e = J.c(2);
  let n;
  return e[0] !== t ? (n = /* @__PURE__ */ x(Lb, { ...t }), e[0] = t, e[1] = n) : n = e[1], n;
}
function ii(t) {
  const e = J.c(24);
  let n, o, r, s, i, a, l, c, u;
  e[0] !== t ? ({
    children: n,
    side: a,
    align: l,
    sideOffset: c,
    alignOffset: u,
    size: i,
    className: o,
    positionerClassName: r,
    ...s
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r, e[4] = s, e[5] = i, e[6] = a, e[7] = l, e[8] = c, e[9] = u) : (n = e[1], o = e[2], r = e[3], s = e[4], i = e[5], a = e[6], l = e[7], c = e[8], u = e[9]);
  const d = a === void 0 ? "bottom" : a, f = l === void 0 ? "start" : l, p = c === void 0 ? 4 : c, g = u === void 0 ? 0 : u;
  let m;
  e[10] !== o || e[11] !== i ? (m = Ua({
    size: i,
    className: o
  }), e[10] = o, e[11] = i, e[12] = m) : m = e[12];
  let h;
  e[13] !== n || e[14] !== s || e[15] !== m ? (h = /* @__PURE__ */ x(Nb, { className: m, ...s, children: n }), e[13] = n, e[14] = s, e[15] = m, e[16] = h) : h = e[16];
  let b;
  return e[17] !== f || e[18] !== g || e[19] !== r || e[20] !== d || e[21] !== p || e[22] !== h ? (b = /* @__PURE__ */ x(Ib, { children: /* @__PURE__ */ x(Mb, { side: d, align: f, sideOffset: p, alignOffset: g, className: r, children: h }) }), e[17] = f, e[18] = g, e[19] = r, e[20] = d, e[21] = p, e[22] = h, e[23] = b) : b = e[23], b;
}
function Wb(t) {
  const e = J.c(36);
  let n, o, r, s, i, a, l;
  if (e[0] !== t ? ({
    children: n,
    leadingIcon: s,
    endSection: r,
    submenu: a,
    tone: l,
    className: o,
    ...i
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r, e[4] = s, e[5] = i, e[6] = a, e[7] = l) : (n = e[1], o = e[2], r = e[3], s = e[4], i = e[5], a = e[6], l = e[7]), a != null) {
    let f;
    if (e[8] !== i) {
      const {
        closeOnClick: w,
        ...y
      } = i;
      f = y, e[8] = i, e[9] = f;
    } else
      f = e[9];
    let p;
    e[10] !== o || e[11] !== l ? (p = or({
      tone: l,
      className: o
    }), e[10] = o, e[11] = l, e[12] = p) : p = e[12];
    let g;
    e[13] !== n || e[14] !== s ? (g = /* @__PURE__ */ x(ba, { leadingIcon: s, submenu: !0, children: n }), e[13] = n, e[14] = s, e[15] = g) : g = e[15];
    let m;
    e[16] !== p || e[17] !== g || e[18] !== f ? (m = /* @__PURE__ */ x(zb, { className: p, ...f, children: g }), e[16] = p, e[17] = g, e[18] = f, e[19] = m) : m = e[19];
    let h;
    e[20] !== a ? (h = /* @__PURE__ */ x(ii, { side: "right", align: "start", sideOffset: E9, alignOffset: -4, size: "sm", children: a }), e[20] = a, e[21] = h) : h = e[21];
    let b;
    return e[22] !== m || e[23] !== h ? (b = /* @__PURE__ */ j(g9, { children: [
      m,
      h
    ] }), e[22] = m, e[23] = h, e[24] = b) : b = e[24], b;
  }
  let c;
  e[25] !== o || e[26] !== l ? (c = or({
    tone: l,
    className: o
  }), e[25] = o, e[26] = l, e[27] = c) : c = e[27];
  let u;
  e[28] !== n || e[29] !== r || e[30] !== s ? (u = /* @__PURE__ */ x(ba, { leadingIcon: s, endSection: r, children: n }), e[28] = n, e[29] = r, e[30] = s, e[31] = u) : u = e[31];
  let d;
  return e[32] !== i || e[33] !== c || e[34] !== u ? (d = /* @__PURE__ */ x(Pb, { className: c, ...i, children: u }), e[32] = i, e[33] = c, e[34] = u, e[35] = d) : d = e[35], d;
}
function Ub(t) {
  const e = J.c(6);
  let n, o;
  e[0] !== t ? ({
    children: n,
    ...o
  } = t, e[0] = t, e[1] = n, e[2] = o) : (n = e[1], o = e[2]);
  let r;
  return e[3] !== n || e[4] !== o ? (r = /* @__PURE__ */ x(Tb, { ...o, children: n }), e[3] = n, e[4] = o, e[5] = r) : r = e[5], r;
}
function Yb(t) {
  const e = J.c(21);
  let n, o, r, s, i;
  e[0] !== t ? ({
    children: n,
    leadingIcon: s,
    endSection: r,
    className: o,
    ...i
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r, e[4] = s, e[5] = i) : (n = e[1], o = e[2], r = e[3], s = e[4], i = e[5]);
  let a;
  e[6] !== o ? (a = or({
    className: o
  }), e[6] = o, e[7] = a) : a = e[7];
  let l;
  e[8] !== s ? (l = s && /* @__PURE__ */ x("span", { className: "inline-flex shrink-0 text-menu-icon-default", children: /* @__PURE__ */ x(Ye, { name: s, size: "xs", tone: "inherit" }) }), e[8] = s, e[9] = l) : l = e[9];
  let c;
  e[10] !== n ? (c = /* @__PURE__ */ x("span", { className: "min-w-0 flex-1 truncate", children: n }), e[10] = n, e[11] = c) : c = e[11];
  let u;
  e[12] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (u = /* @__PURE__ */ x(Ob, { className: "inline-flex shrink-0 text-menu-icon-secondary", children: /* @__PURE__ */ x(Ye, { name: "check-mark", size: "xs", tone: "inherit" }) }), e[12] = u) : u = e[12];
  let d;
  e[13] !== r ? (d = r && /* @__PURE__ */ x("span", { className: "inline-flex shrink-0 items-center gap-(--spacing-4)", children: r }), e[13] = r, e[14] = d) : d = e[14];
  let f;
  return e[15] !== i || e[16] !== a || e[17] !== l || e[18] !== c || e[19] !== d ? (f = /* @__PURE__ */ j(kb, { className: a, ...i, children: [
    l,
    c,
    u,
    d
  ] }), e[15] = i, e[16] = a, e[17] = l, e[18] = c, e[19] = d, e[20] = f) : f = e[20], f;
}
function N9(t) {
  const e = J.c(19);
  let n, o, r, s, i, a;
  e[0] !== t ? ({
    children: o,
    leadingIcon: i,
    endSection: s,
    checked: n,
    className: r,
    ...a
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r, e[4] = s, e[5] = i, e[6] = a) : (n = e[1], o = e[2], r = e[3], s = e[4], i = e[5], a = e[6]);
  let l;
  e[7] !== r ? (l = or({
    className: r
  }), e[7] = r, e[8] = l) : l = e[8];
  let c;
  e[9] !== n || e[10] !== o || e[11] !== s || e[12] !== i ? (c = /* @__PURE__ */ x(ba, { leadingIcon: i, endSection: s, checked: n, checkbox: !0, children: o }), e[9] = n, e[10] = o, e[11] = s, e[12] = i, e[13] = c) : c = e[13];
  let u;
  return e[14] !== n || e[15] !== a || e[16] !== l || e[17] !== c ? (u = /* @__PURE__ */ x(Eb, { checked: n, className: l, ...a, children: c }), e[14] = n, e[15] = a, e[16] = l, e[17] = c, e[18] = u) : u = e[18], u;
}
function I9(t) {
  const e = J.c(13);
  let n, o, r, s;
  e[0] !== t ? ({
    children: n,
    disabled: r,
    className: o,
    ...s
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r, e[4] = s) : (n = e[1], o = e[2], r = e[3], s = e[4]);
  const i = r ? "" : void 0, a = r || void 0;
  let l;
  e[5] !== o ? (l = le(L8, o), e[5] = o, e[6] = l) : l = e[6];
  let c;
  return e[7] !== n || e[8] !== s || e[9] !== i || e[10] !== a || e[11] !== l ? (c = /* @__PURE__ */ x("div", { role: "presentation", "data-disabled": i, "aria-disabled": a, className: l, ...s, children: n }), e[7] = n, e[8] = s, e[9] = i, e[10] = a, e[11] = l, e[12] = c) : c = e[12], c;
}
function ai() {
  const t = J.c(10), [e, n] = v.useState(!1);
  let o, r;
  t[0] !== e ? (o = () => {
    if (!e)
      return;
    const u = function() {
      n(!1);
    };
    return document.addEventListener("mouseup", u), document.addEventListener("dragend", u), window.addEventListener("blur", u), () => {
      document.removeEventListener("mouseup", u), document.removeEventListener("dragend", u), window.removeEventListener("blur", u);
    };
  }, r = [e], t[0] = e, t[1] = o, t[2] = r) : (o = t[1], r = t[2]), v.useEffect(o, r);
  const s = e ? "" : void 0;
  let i, a;
  t[3] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (i = (u) => {
    u.defaultPrevented || u.button !== 0 || n(!0);
  }, a = () => n(!1), t[3] = i, t[4] = a) : (i = t[3], a = t[4]);
  let l;
  t[5] !== s ? (l = {
    "data-mouse-down": s,
    onMouseDown: i,
    onMouseUp: a
  }, t[5] = s, t[6] = l) : l = t[6];
  let c;
  return t[7] !== e || t[8] !== l ? (c = {
    mouseDown: e,
    triggerMouseDownProps: l
  }, t[7] = e, t[8] = l, t[9] = c) : c = t[9], c;
}
function M9(t) {
  const e = J.c(8), {
    value: n,
    defaultValue: o,
    onChange: r
  } = t;
  let s;
  e[0] !== o ? (s = o ?? [], e[0] = o, e[1] = s) : s = e[1];
  const [i, a] = Mt(s), l = n !== void 0, c = l ? n : i;
  let u;
  e[2] !== l || e[3] !== r ? (u = function(g) {
    l || a(g), r?.(g);
  }, e[2] = l, e[3] = r, e[4] = u) : u = e[4];
  const d = u;
  let f;
  return e[5] !== c || e[6] !== d ? (f = [c, d], e[5] = c, e[6] = d, e[7] = f) : f = e[7], f;
}
function Gb(t) {
  const e = J.c(6), {
    value: n,
    defaultValue: o,
    onChange: r
  } = t, [s, i] = Mt(o ?? null), a = n !== void 0, l = a ? n : s;
  let c;
  e[0] !== a || e[1] !== r ? (c = function(p) {
    a || i(p), r?.(p);
  }, e[0] = a, e[1] = r, e[2] = c) : c = e[2];
  const u = c;
  let d;
  return e[3] !== l || e[4] !== u ? (d = [l, u], e[3] = l, e[4] = u, e[5] = d) : d = e[5], d;
}
const T9 = ye(["inline-flex", "h-(--spacing-32)", "items-center", "justify-center", "gap-(--spacing-8)", "rounded-(--radius-sm)", "border", "border-solid", "border-button-outline-default-border", "bg-button-outline-default-background", "px-(--spacing-12)", "font-(family-name:--font-family-label)", "text-(length:--font-size-body-medium)", "font-(number:--font-weight-medium)", "leading-(--font-line-height-20)", "text-button-outline-default-text", "outline-none", "transition-colors", "duration-200", "ease-in-out", "cursor-pointer", "select-none", "hover:border-button-outline-hover-border", "hover:bg-button-outline-hover-background", "active:border-button-outline-pressed-border", "active:bg-button-outline-pressed-background", "data-[mouse-down]:border-button-outline-pressed-border", "data-[mouse-down]:bg-button-outline-pressed-background", "focus-visible:ring-2", "focus-visible:ring-offset-[3px]", "focus-visible:ring-offset-surface", "focus-visible:ring-button-focus-ring", "disabled:pointer-events-none", "disabled:cursor-not-allowed", "disabled:opacity-40", "[&_svg]:pointer-events-none", "[&_svg]:shrink-0"], {
  variants: {
    fullWidth: {
      true: "w-full",
      false: ""
    }
  },
  defaultVariants: {
    fullWidth: !1
  }
});
function qa(t) {
  const e = J.c(31);
  let n, o, r, s, i, a, l, c, u;
  e[0] !== t ? ({
    children: n,
    leadingIcon: r,
    trailingIcon: u,
    showChevron: i,
    open: a,
    mouseDown: l,
    fullWidth: c,
    className: o,
    ...s
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r, e[4] = s, e[5] = i, e[6] = a, e[7] = l, e[8] = c, e[9] = u) : (n = e[1], o = e[2], r = e[3], s = e[4], i = e[5], a = e[6], l = e[7], c = e[8], u = e[9]);
  const d = i === void 0 ? !1 : i, f = a === void 0 ? !1 : a, p = l === void 0 ? !1 : l, g = c === void 0 ? !1 : c;
  let m;
  e[10] !== o || e[11] !== g ? (m = le(T9({
    fullWidth: g
  }), o), e[10] = o, e[11] = g, e[12] = m) : m = e[12];
  const h = p ? "" : void 0, b = d ? f : s["aria-expanded"];
  let w;
  e[13] !== r ? (w = r && /* @__PURE__ */ x(Ye, { name: r, size: "xs", tone: "inherit" }), e[13] = r, e[14] = w) : w = e[14];
  let y;
  e[15] !== n ? (y = /* @__PURE__ */ x("span", { className: "min-w-0 truncate", children: n }), e[15] = n, e[16] = y) : y = e[16];
  let C;
  e[17] !== u ? (C = u && /* @__PURE__ */ x(Ye, { name: u, size: "xs", tone: "inherit" }), e[17] = u, e[18] = C) : C = e[18];
  let R;
  e[19] !== f || e[20] !== d ? (R = d && /* @__PURE__ */ x("span", { "data-open": f ? "" : void 0, className: "inline-flex transition-transform duration-200 data-[open]:rotate-180", children: /* @__PURE__ */ x(Ye, { name: "chevron-down", size: "xs", tone: "inherit" }) }), e[19] = f, e[20] = d, e[21] = R) : R = e[21];
  let S;
  return e[22] !== s || e[23] !== C || e[24] !== R || e[25] !== m || e[26] !== h || e[27] !== b || e[28] !== w || e[29] !== y ? (S = /* @__PURE__ */ j(Un, { className: m, ...s, "data-mouse-down": h, "aria-expanded": b, children: [
    w,
    y,
    C,
    R
  ] }), e[22] = s, e[23] = C, e[24] = R, e[25] = m, e[26] = h, e[27] = b, e[28] = w, e[29] = y, e[30] = S) : S = e[30], S;
}
function TN(t) {
  const e = J.c(40), {
    children: n,
    title: o,
    triggerLabel: r,
    align: s,
    open: i,
    defaultOpen: a,
    onOpenChange: l,
    onApply: c,
    onClearAll: u,
    disabled: d
  } = t, f = o === void 0 ? "Filters" : o, p = s === void 0 ? "start" : s, [g, m] = Mt(a ?? !1), {
    mouseDown: h,
    triggerMouseDownProps: b
  } = ai(), w = i !== void 0, y = w ? i : g;
  let C;
  e[0] !== w || e[1] !== l ? (C = function(H) {
    w || m(H), l?.(H);
  }, e[0] = w, e[1] = l, e[2] = C) : C = e[2];
  const R = C;
  let S;
  e[3] !== R ? (S = function() {
    R(!1);
  }, e[3] = R, e[4] = S) : S = e[4];
  const E = S;
  let P;
  e[5] !== d || e[6] !== h || e[7] !== f || e[8] !== r || e[9] !== b ? (P = /* @__PURE__ */ x(Du, { render: r !== void 0 ? /* @__PURE__ */ x(qa, { trailingIcon: "filter", disabled: d, mouseDown: h, ...b, children: r }) : /* @__PURE__ */ x(Kt, { variant: "outline", size: "sm", icon: "filter", "aria-label": f, disabled: d, ...b }) }), e[5] = d, e[6] = h, e[7] = f, e[8] = r, e[9] = b, e[10] = P) : P = e[10];
  let N;
  e[11] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (N = le("flex", "w-[500px]", "max-w-[calc(100vw-var(--spacing-32))]", "max-h-[calc(100vh-var(--spacing-32))]", "flex-col", "gap-(--spacing-20)", "overflow-y-auto", "rounded-(--radius-sm)", "border", "border-solid", "border-outline-subtle", "bg-surface", "p-(--spacing-20)", "shadow-elevation-3", "outline-none"), e[11] = N) : N = e[11];
  let I;
  e[12] !== f ? (I = /* @__PURE__ */ x("h2", { className: "font-(family-name:--font-family-title) text-(length:--font-size-title-lg) font-(number:--font-weight-bold) leading-(--font-line-height-28) text-text-default", children: f }), e[12] = f, e[13] = I) : I = e[13];
  let M;
  e[14] !== u ? (M = u && /* @__PURE__ */ x(Hn, { variant: "ghost", size: "sm", onClick: u, children: "Clear All" }), e[14] = u, e[15] = M) : M = e[15];
  let T;
  e[16] !== I || e[17] !== M ? (T = /* @__PURE__ */ j("div", { className: "flex items-center justify-between gap-(--spacing-16)", children: [
    I,
    M
  ] }), e[16] = I, e[17] = M, e[18] = T) : T = e[18];
  let k;
  e[19] !== n || e[20] !== E ? (k = typeof n == "function" ? n({
    close: E
  }) : n, e[19] = n, e[20] = E, e[21] = k) : k = e[21];
  let D;
  e[22] !== k ? (D = /* @__PURE__ */ x("div", { className: "flex flex-col gap-(--spacing-16)", children: k }), e[22] = k, e[23] = D) : D = e[23];
  let O;
  e[24] !== E || e[25] !== c ? (O = /* @__PURE__ */ x("div", { className: "flex justify-end", children: /* @__PURE__ */ x(Hn, { size: "sm", onClick: () => {
    c?.(), E();
  }, children: "Apply filters" }) }), e[24] = E, e[25] = c, e[26] = O) : O = e[26];
  let V;
  e[27] !== D || e[28] !== O || e[29] !== T || e[30] !== f ? (V = /* @__PURE__ */ j($u, { role: "dialog", "aria-label": f, className: N, children: [
    T,
    D,
    O
  ] }), e[27] = D, e[28] = O, e[29] = T, e[30] = f, e[31] = V) : V = e[31];
  let _;
  e[32] !== p || e[33] !== V ? (_ = /* @__PURE__ */ x(Vu, { children: /* @__PURE__ */ x(Fu, { side: "bottom", align: p, sideOffset: 4, children: V }) }), e[32] = p, e[33] = V, e[34] = _) : _ = e[34];
  let A;
  return e[35] !== y || e[36] !== R || e[37] !== _ || e[38] !== P ? (A = /* @__PURE__ */ j(Z1, { open: y, onOpenChange: R, modal: !1, children: [
    P,
    _
  ] }), e[35] = y, e[36] = R, e[37] = _, e[38] = P, e[39] = A) : A = e[39], A;
}
function kN(t) {
  const e = J.c(27), {
    label: n,
    options: o,
    value: r,
    defaultValue: s,
    onChange: i,
    align: a,
    disabled: l
  } = t, c = a === void 0 ? "start" : a;
  let u;
  e[0] !== s || e[1] !== i || e[2] !== r ? (u = {
    value: r,
    defaultValue: s,
    onChange: i
  }, e[0] = s, e[1] = i, e[2] = r, e[3] = u) : u = e[3];
  const [d, f] = M9(u), [p, g] = Mt(!1), {
    mouseDown: m,
    triggerMouseDownProps: h
  } = ai();
  let b;
  e[4] !== d || e[5] !== f ? (b = function(P, N) {
    f(N ? [...d, P] : d.filter((I) => I !== P));
  }, e[4] = d, e[5] = f, e[6] = b) : b = e[6];
  const w = b;
  let y;
  e[7] !== l || e[8] !== n || e[9] !== m || e[10] !== p || e[11] !== h ? (y = /* @__PURE__ */ x(Tr, { render: /* @__PURE__ */ x(qa, { showChevron: !0, open: p, disabled: l, mouseDown: m, ...h, children: n }) }), e[7] = l, e[8] = n, e[9] = m, e[10] = p, e[11] = h, e[12] = y) : y = e[12];
  let C;
  if (e[13] !== w || e[14] !== o || e[15] !== d) {
    let E;
    e[17] !== w || e[18] !== d ? (E = (P) => /* @__PURE__ */ x(N9, { checked: d.includes(P.value), disabled: P.disabled, closeOnClick: !1, onCheckedChange: (N) => {
      w(P.value, N);
    }, children: P.label }, P.value), e[17] = w, e[18] = d, e[19] = E) : E = e[19], C = o.map(E), e[13] = w, e[14] = o, e[15] = d, e[16] = C;
  } else
    C = e[16];
  let R;
  e[20] !== c || e[21] !== C ? (R = /* @__PURE__ */ x(ii, { size: "trigger", align: c, children: C }), e[20] = c, e[21] = C, e[22] = R) : R = e[22];
  let S;
  return e[23] !== p || e[24] !== y || e[25] !== R ? (S = /* @__PURE__ */ j(Xr, { open: p, onOpenChange: g, children: [
    y,
    R
  ] }), e[23] = p, e[24] = y, e[25] = R, e[26] = S) : S = e[26], S;
}
function ON(t) {
  const e = J.c(29), {
    options: n,
    value: o,
    defaultValue: r,
    onChange: s,
    placeholder: i,
    align: a,
    disabled: l
  } = t, c = i === void 0 ? "Date Range" : i, u = a === void 0 ? "start" : a;
  let d;
  e[0] !== r || e[1] !== s || e[2] !== o ? (d = {
    value: o,
    defaultValue: r,
    onChange: s
  }, e[0] = r, e[1] = s, e[2] = o, e[3] = d) : d = e[3];
  const [f, p] = Gb(d), [g, m] = Mt(!1), {
    mouseDown: h,
    triggerMouseDownProps: b
  } = ai();
  let w;
  e[4] !== n || e[5] !== c || e[6] !== f ? (w = n.find((M) => M.value === f)?.label ?? c, e[4] = n, e[5] = c, e[6] = f, e[7] = w) : w = e[7];
  const y = w;
  let C;
  e[8] !== l || e[9] !== h || e[10] !== g || e[11] !== y || e[12] !== b ? (C = /* @__PURE__ */ x(Tr, { render: /* @__PURE__ */ x(qa, { leadingIcon: "calendar", showChevron: !0, open: g, mouseDown: h, disabled: l, ...b, children: y }) }), e[8] = l, e[9] = h, e[10] = g, e[11] = y, e[12] = b, e[13] = C) : C = e[13];
  const R = f ?? "";
  let S;
  e[14] !== p ? (S = (M) => {
    p(M), m(!1);
  }, e[14] = p, e[15] = S) : S = e[15];
  let E;
  e[16] !== n ? (E = n.map(k9), e[16] = n, e[17] = E) : E = e[17];
  let P;
  e[18] !== R || e[19] !== S || e[20] !== E ? (P = /* @__PURE__ */ x(Ub, { value: R, onValueChange: S, children: E }), e[18] = R, e[19] = S, e[20] = E, e[21] = P) : P = e[21];
  let N;
  e[22] !== u || e[23] !== P ? (N = /* @__PURE__ */ x(ii, { size: "trigger", align: u, children: P }), e[22] = u, e[23] = P, e[24] = N) : N = e[24];
  let I;
  return e[25] !== g || e[26] !== N || e[27] !== C ? (I = /* @__PURE__ */ j(Xr, { open: g, onOpenChange: m, children: [
    C,
    N
  ] }), e[25] = g, e[26] = N, e[27] = C, e[28] = I) : I = e[28], I;
}
function k9(t) {
  return /* @__PURE__ */ x(Yb, { value: t.value, disabled: t.disabled, children: t.label }, t.value);
}
function DN(t) {
  const e = J.c(33), {
    prefix: n,
    options: o,
    value: r,
    defaultValue: s,
    onChange: i,
    align: a,
    disabled: l
  } = t, c = a === void 0 ? "start" : a;
  let u;
  e[0] !== s || e[1] !== i || e[2] !== r ? (u = {
    value: r,
    defaultValue: s,
    onChange: i
  }, e[0] = s, e[1] = i, e[2] = r, e[3] = u) : u = e[3];
  const [d, f] = Gb(u), [p, g] = Mt(!1), {
    mouseDown: m,
    triggerMouseDownProps: h
  } = ai();
  let b;
  e[4] !== o || e[5] !== d ? (b = o.find((T) => T.value === d)?.label ?? "", e[4] = o, e[5] = d, e[6] = b) : b = e[6];
  const w = b;
  let y;
  e[7] !== n ? (y = /* @__PURE__ */ x("span", { className: "text-text-subtle", children: n }), e[7] = n, e[8] = y) : y = e[8];
  let C;
  e[9] !== w ? (C = w && /* @__PURE__ */ j(_o, { children: [
    " ",
    /* @__PURE__ */ x("span", { children: w })
  ] }), e[9] = w, e[10] = C) : C = e[10];
  let R;
  e[11] !== l || e[12] !== m || e[13] !== p || e[14] !== y || e[15] !== C || e[16] !== h ? (R = /* @__PURE__ */ x(Tr, { render: /* @__PURE__ */ j(qa, { showChevron: !0, open: p, disabled: l, mouseDown: m, ...h, children: [
    y,
    C
  ] }) }), e[11] = l, e[12] = m, e[13] = p, e[14] = y, e[15] = C, e[16] = h, e[17] = R) : R = e[17];
  const S = d ?? "";
  let E;
  e[18] !== f ? (E = (T) => {
    f(T), g(!1);
  }, e[18] = f, e[19] = E) : E = e[19];
  let P;
  e[20] !== o ? (P = o.map(O9), e[20] = o, e[21] = P) : P = e[21];
  let N;
  e[22] !== S || e[23] !== E || e[24] !== P ? (N = /* @__PURE__ */ x(Ub, { value: S, onValueChange: E, children: P }), e[22] = S, e[23] = E, e[24] = P, e[25] = N) : N = e[25];
  let I;
  e[26] !== c || e[27] !== N ? (I = /* @__PURE__ */ x(ii, { size: "trigger", align: c, children: N }), e[26] = c, e[27] = N, e[28] = I) : I = e[28];
  let M;
  return e[29] !== p || e[30] !== I || e[31] !== R ? (M = /* @__PURE__ */ j(Xr, { open: p, onOpenChange: g, children: [
    R,
    I
  ] }), e[29] = p, e[30] = I, e[31] = R, e[32] = M) : M = e[32], M;
}
function O9(t) {
  return /* @__PURE__ */ x(Yb, { value: t.value, disabled: t.disabled, children: t.label }, t.value);
}
function _N(t) {
  const e = J.c(13), {
    filters: n,
    onRemove: o,
    onClearAll: r,
    label: s
  } = t, i = s === void 0 ? "Filters:" : s;
  if (n.length === 0)
    return null;
  let a;
  e[0] !== i ? (a = /* @__PURE__ */ x("span", { className: "font-(family-name:--font-family-label) text-(length:--font-size-label-medium) font-(number:--font-weight-semibold) leading-(--font-line-height-16) text-text-subtle", children: i }), e[0] = i, e[1] = a) : a = e[1];
  let l;
  if (e[2] !== n || e[3] !== o) {
    let d;
    e[5] !== o ? (d = (f) => /* @__PURE__ */ x(Fv, { label: f.label, removeAriaLabel: f.removeAriaLabel, onClose: () => o(f.id) }, f.id), e[5] = o, e[6] = d) : d = e[6], l = n.map(d), e[2] = n, e[3] = o, e[4] = l;
  } else
    l = e[4];
  let c;
  e[7] !== r ? (c = /* @__PURE__ */ x(Hn, { variant: "ghost", size: "sm", onClick: r, children: "Clear All" }), e[7] = r, e[8] = c) : c = e[8];
  let u;
  return e[9] !== a || e[10] !== l || e[11] !== c ? (u = /* @__PURE__ */ j("div", { "aria-live": "polite", className: "flex flex-wrap items-center gap-(--spacing-8)", children: [
    a,
    l,
    c
  ] }), e[9] = a, e[10] = l, e[11] = c, e[12] = u) : u = e[12], u;
}
function VN(t) {
  const e = J.c(13), {
    items: n,
    value: o,
    defaultValue: r,
    onValueChange: s,
    "aria-label": i
  } = t, a = i === void 0 ? "Filter views" : i;
  let l;
  e[0] !== s ? (l = (p) => s?.(p), e[0] = s, e[1] = l) : l = e[1];
  let c;
  e[2] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (c = le("inline-flex", "flex-wrap", "max-w-full", "items-center", "gap-[2px]", "rounded-(--radius-sm)", "border", "border-solid", "border-outline-subtle", "bg-surface-container-high", "p-[2px]", "max-[599px]:gap-(--spacing-4)", "max-[599px]:p-(--spacing-4)"), e[2] = c) : c = e[2];
  let u;
  e[3] !== n ? (u = n.map(D9), e[3] = n, e[4] = u) : u = e[4];
  let d;
  e[5] !== a || e[6] !== u ? (d = /* @__PURE__ */ x(Fd, { "aria-label": a, className: c, children: u }), e[5] = a, e[6] = u, e[7] = d) : d = e[7];
  let f;
  return e[8] !== r || e[9] !== l || e[10] !== d || e[11] !== o ? (f = /* @__PURE__ */ x(Dd, { value: o, defaultValue: r, onValueChange: l, children: d }), e[8] = r, e[9] = l, e[10] = d, e[11] = o, e[12] = f) : f = e[12], f;
}
function D9(t) {
  return /* @__PURE__ */ j(Ad, { value: t.value, disabled: t.disabled, "aria-label": t.count === void 0 ? t.label : `${t.label} ${t.count}`, className: le("relative", "group", "inline-flex", "h-[28px]", "min-w-0", "items-center", "justify-center", "gap-(--spacing-6)", "rounded-(--radius-xs)", "px-(--spacing-10)", "font-(family-name:--font-family-label)", "text-(length:--font-size-body-medium)", "font-(number:--font-weight-medium)", "leading-(--font-line-height-20)", "text-text-subtle", "outline-none", "transition-[background-color,box-shadow]", "duration-200", "ease-in-out", "cursor-pointer", "select-none", "focus-visible:[outline:2px_solid_hsl(var(--button-focus-ring))]", "focus-visible:[outline-offset:2px]", "data-[active]:bg-surface-container-lowest", "data-[active]:text-text-default", "data-[active]:shadow-elevation-1", "data-[disabled]:pointer-events-none", "data-[disabled]:cursor-default", "data-[disabled]:opacity-50", "max-[599px]:before:absolute", "max-[599px]:before:left-0", "max-[599px]:before:top-1/2", "max-[599px]:before:h-[44px]", "max-[599px]:before:min-w-[44px]", "max-[599px]:before:w-full", "max-[599px]:before:-translate-y-1/2", "max-[599px]:before:content-['']"), children: [
    /* @__PURE__ */ x("span", { className: "truncate", children: t.label }),
    t.count !== void 0 && /* @__PURE__ */ x("span", { className: "text-text-disabled group-data-[active]:text-text-subtle", children: t.count })
  ] }, t.value);
}
const Mg = le("border", "border-outline-subtle", "rounded-(--radius-sm)", "flex", "flex-col");
function AN(t) {
  const e = J.c(24);
  let n, o, r;
  e[0] !== t ? ({
    as: r,
    children: n,
    ...o
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r) : (n = e[1], o = e[2], r = e[3]);
  const s = r === void 0 ? "form" : r;
  let i, a, l, c;
  if (e[4] !== n) {
    const h = v.Children.toArray(n);
    i = h.find(jb);
    const b = h.filter(_9);
    c = "overflow-hidden p-(--spacing-20)", a = "flex flex-col gap-(--spacing-20) w-full", l = v.Children.map(b, (w, y) => /* @__PURE__ */ j(_o, { children: [
      w,
      y < b.length - 1 && /* @__PURE__ */ x(Ya, { variant: "middle-inset" })
    ] })), e[4] = n, e[5] = i, e[6] = a, e[7] = l, e[8] = c;
  } else
    i = e[5], a = e[6], l = e[7], c = e[8];
  let u;
  e[9] !== a || e[10] !== l ? (u = /* @__PURE__ */ x("div", { className: a, children: l }), e[9] = a, e[10] = l, e[11] = u) : u = e[11];
  let d;
  e[12] !== c || e[13] !== u ? (d = /* @__PURE__ */ x("div", { className: c, children: u }), e[12] = c, e[13] = u, e[14] = d) : d = e[14];
  let f;
  e[15] !== i || e[16] !== d ? (f = /* @__PURE__ */ j(_o, { children: [
    d,
    i
  ] }), e[15] = i, e[16] = d, e[17] = f) : f = e[17];
  const p = f;
  if (s === "div") {
    const h = o;
    let b;
    return e[18] !== p || e[19] !== h ? (b = /* @__PURE__ */ x("div", { className: Mg, ...h, children: p }), e[18] = p, e[19] = h, e[20] = b) : b = e[20], b;
  }
  const g = o;
  let m;
  return e[21] !== p || e[22] !== g ? (m = /* @__PURE__ */ x("form", { className: Mg, ...g, children: p }), e[21] = p, e[22] = g, e[23] = m) : m = e[23], m;
}
function _9(t) {
  return !jb(t);
}
function jb(t) {
  return v.isValidElement(t) && t.type === L9;
}
const V9 = ye(["font-(family-name:--font-family-title)", "font-(number:--font-weight-medium)", "text-text-default", "tracking-(--font-letter-spacing-default)", "shrink-0"], {
  variants: {
    variant: {
      main: ["text-(length:--font-size-title-xl)", "leading-(--font-line-height-28)"],
      subsection: ["text-(length:--font-size-title-md)", "leading-(--font-line-height-24)"]
    }
  }
}), A9 = ye(["font-(family-name:--font-family-body)", "font-(number:--font-weight-medium)", "text-text-subtext", "text-(length:--font-size-body-medium)", "leading-(--font-line-height-20)", "tracking-(--font-letter-spacing-default)"]);
function FN(t) {
  const e = J.c(30), {
    variant: n,
    title: o,
    description: r,
    titleAccessory: s,
    actions: i,
    children: a
  } = t, l = n === "main" ? "h2" : "h3", c = v.useId(), u = r != null, d = u ? `${c}-description` : void 0;
  let f;
  e[0] !== o ? (f = /* @__PURE__ */ x("legend", { className: "sr-only", children: o }), e[0] = o, e[1] = f) : f = e[1];
  let p;
  e[2] !== n ? (p = V9({
    variant: n
  }), e[2] = n, e[3] = p) : p = e[3];
  let g;
  e[4] !== l || e[5] !== p || e[6] !== o ? (g = /* @__PURE__ */ x(l, { className: p, children: o }), e[4] = l, e[5] = p, e[6] = o, e[7] = g) : g = e[7];
  const m = s != null && s;
  let h;
  e[8] !== g || e[9] !== m ? (h = /* @__PURE__ */ j("div", { className: "flex items-center gap-(--spacing-6)", children: [
    g,
    m
  ] }), e[8] = g, e[9] = m, e[10] = h) : h = e[10];
  let b;
  e[11] !== r || e[12] !== u || e[13] !== c ? (b = u && /* @__PURE__ */ x("p", { id: `${c}-description`, className: le(A9(), "mt-(--spacing-6)"), children: r }), e[11] = r, e[12] = u, e[13] = c, e[14] = b) : b = e[14];
  let w;
  e[15] !== h || e[16] !== b ? (w = /* @__PURE__ */ j("div", { className: "flex-1 min-w-0", children: [
    h,
    b
  ] }), e[15] = h, e[16] = b, e[17] = w) : w = e[17];
  let y;
  e[18] !== i ? (y = i != null && /* @__PURE__ */ x("div", { className: "shrink-0", children: i }), e[18] = i, e[19] = y) : y = e[19];
  let C;
  e[20] !== w || e[21] !== y ? (C = /* @__PURE__ */ j("div", { className: "flex items-start gap-(--spacing-12)", children: [
    w,
    y
  ] }), e[20] = w, e[21] = y, e[22] = C) : C = e[22];
  let R;
  e[23] !== a ? (R = a != null && /* @__PURE__ */ x("div", { className: "mt-(--spacing-16) flex flex-col", children: a }), e[23] = a, e[24] = R) : R = e[24];
  let S;
  return e[25] !== d || e[26] !== C || e[27] !== R || e[28] !== f ? (S = /* @__PURE__ */ j("fieldset", { "aria-describedby": d, className: "border-0 p-0 m-0 min-w-0", children: [
    f,
    C,
    R
  ] }), e[25] = d, e[26] = C, e[27] = R, e[28] = f, e[29] = S) : S = e[29], S;
}
const F9 = le("font-(family-name:--font-family-label)", "font-(number:--font-weight-semibold)", "leading-(--font-line-height-20)", "text-text-default", "text-(length:--font-size-label-lg)", "tracking-(--font-letter-spacing-default)", "whitespace-nowrap", "shrink-0");
function LN(t) {
  const e = J.c(10), {
    columns: n
  } = t, [o, r] = n, s = n.length === 2 ? "justify-between" : "justify-center";
  let i;
  e[0] !== s ? (i = le("flex w-[212px] items-start p-0", s), e[0] = s, e[1] = i) : i = e[1];
  let a;
  e[2] !== o ? (a = /* @__PURE__ */ x(Tg, { column: o }), e[2] = o, e[3] = a) : a = e[3];
  let l;
  e[4] !== r ? (l = r != null && /* @__PURE__ */ x(Tg, { column: r }), e[4] = r, e[5] = l) : l = e[5];
  let c;
  return e[6] !== i || e[7] !== a || e[8] !== l ? (c = /* @__PURE__ */ j("div", { className: i, children: [
    a,
    l
  ] }), e[6] = i, e[7] = a, e[8] = l, e[9] = c) : c = e[9], c;
}
function Tg(t) {
  const e = J.c(7), {
    column: n
  } = t;
  let o;
  e[0] !== n.icon ? (o = n.icon != null && /* @__PURE__ */ x(Ye, { name: n.icon, size: "sm", "aria-hidden": !0 }), e[0] = n.icon, e[1] = o) : o = e[1];
  let r;
  e[2] !== n.label ? (r = /* @__PURE__ */ x("span", { className: F9, children: n.label }), e[2] = n.label, e[3] = r) : r = e[3];
  let s;
  return e[4] !== o || e[5] !== r ? (s = /* @__PURE__ */ j("div", { className: "flex flex-1 items-center justify-end gap-(--spacing-8) min-w-0 overflow-hidden", children: [
    o,
    r
  ] }), e[4] = o, e[5] = r, e[6] = s) : s = e[6], s;
}
function L9(t) {
  const e = J.c(18);
  let n, o, r;
  e[0] !== t ? ({
    leading: o,
    actions: n,
    ...r
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r) : (n = e[1], o = e[2], r = e[3]);
  let s;
  e[4] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (s = /* @__PURE__ */ x("div", { "aria-hidden": "true", className: "pointer-events-none h-[58px] w-full shrink-0 bg-gradient-to-b from-surface-0 to-surface mb-[-12px]" }), e[4] = s) : s = e[4];
  const i = o != null && n != null ? "sm:justify-between" : n != null ? "sm:justify-end" : "sm:justify-start";
  let a;
  e[5] !== i ? (a = le("flex flex-col items-stretch gap-(--spacing-16) overflow-hidden border-t border-outline-subtle bg-surface p-(--spacing-16) shrink-0 rounded-b-(--radius-sm) sm:flex-row sm:items-center", i), e[5] = i, e[6] = a) : a = e[6];
  let l;
  e[7] !== o ? (l = o != null && /* @__PURE__ */ x("div", { className: "min-w-0 w-full sm:flex-1", children: o }), e[7] = o, e[8] = l) : l = e[8];
  let c;
  e[9] !== n ? (c = n != null && /* @__PURE__ */ x("div", { className: "flex flex-wrap items-center justify-end gap-(--spacing-16) self-end sm:flex-nowrap sm:self-auto sm:shrink-0", children: n }), e[9] = n, e[10] = c) : c = e[10];
  let u;
  e[11] !== a || e[12] !== l || e[13] !== c ? (u = /* @__PURE__ */ j("div", { className: a, children: [
    l,
    c
  ] }), e[11] = a, e[12] = l, e[13] = c, e[14] = u) : u = e[14];
  let d;
  return e[15] !== r || e[16] !== u ? (d = /* @__PURE__ */ j("footer", { role: "none", className: "sticky bottom-0 flex flex-col", ...r, children: [
    s,
    u
  ] }), e[15] = r, e[16] = u, e[17] = d) : d = e[17], d;
}
const Kb = /* @__PURE__ */ v.forwardRef(function(e, n) {
  return /* @__PURE__ */ x(Tu, {
    ref: n,
    ...e
  });
});
process.env.NODE_ENV !== "production" && (Kb.displayName = "Input");
const $9 = ye(["flex", "items-center", "gap-(--spacing-4)", "w-full", "rounded-(--radius-sm)", "border", "border-solid", "border-input-default-outline", "bg-input-default-background", "text-input-text-default", "transition-colors", "duration-200", "ease-in-out", "[&:not(:focus-within)]:hover:bg-input-hover-background", "[&:not(:focus-within)]:hover:border-input-hover-outline", "active:border-input-pressed-outline", "focus-within:border-input-active-outline", "[&_svg]:pointer-events-none", "[&_svg]:shrink-0"], {
  variants: {
    size: {
      sm: ["h-(--spacing-32)", "px-(--spacing-10)", "py-(--spacing-6)"],
      md: ["h-(--spacing-40)", "px-(--spacing-10)", "py-(--spacing-10)"]
    }
  },
  defaultVariants: {
    size: "md"
  }
});
function $N(t) {
  const e = J.c(49);
  let n, o, r, s, i, a, l, c, u, d, f, p;
  e[0] !== t ? ({
    size: c,
    label: s,
    leadingIcon: i,
    trailingIcon: f,
    unit: p,
    description: n,
    error: r,
    tooltip: d,
    reserveSubtextSpace: u,
    required: l,
    disabled: o,
    ...a
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r, e[4] = s, e[5] = i, e[6] = a, e[7] = l, e[8] = c, e[9] = u, e[10] = d, e[11] = f, e[12] = p) : (n = e[1], o = e[2], r = e[3], s = e[4], i = e[5], a = e[6], l = e[7], c = e[8], u = e[9], d = e[10], f = e[11], p = e[12]);
  const g = c === void 0 ? "md" : c, m = u === void 0 ? !0 : u, h = !!r, b = i ? void 0 : f;
  let w;
  e[13] !== s || e[14] !== l || e[15] !== d ? (w = s && /* @__PURE__ */ x(qr, { label: s, required: l, tooltip: d }), e[13] = s, e[14] = l, e[15] = d, e[16] = w) : w = e[16];
  let y;
  e[17] !== o || e[18] !== h || e[19] !== g ? (y = le($9({
    size: g
  }), o && "opacity-50", h && ["border-input-error-outline", "[&:not(:focus-within)]:hover:border-input-error-outline"]), e[17] = o, e[18] = h, e[19] = g, e[20] = y) : y = e[20];
  let C;
  e[21] !== i ? (C = i && /* @__PURE__ */ x(Ye, { name: i, size: "sm", tone: "inherit" }), e[21] = i, e[22] = C) : C = e[22];
  const R = l || void 0, S = h && "text-input-error-text";
  let E;
  e[23] !== S ? (E = le("flex-1", "min-w-0", "outline-none", "text-(length:--font-size-body-medium)", "text-input-text-default", "leading-(--font-line-height-20)", "placeholder:text-text-subtle", S), e[23] = S, e[24] = E) : E = e[24];
  let P;
  e[25] !== a || e[26] !== l || e[27] !== R || e[28] !== E ? (P = /* @__PURE__ */ x(Kb, { required: l, "aria-required": R, className: E, ...a }), e[25] = a, e[26] = l, e[27] = R, e[28] = E, e[29] = P) : P = e[29];
  let N;
  e[30] !== b || e[31] !== p ? (N = p ? /* @__PURE__ */ j("div", { className: "flex items-center gap-(--spacing-6) shrink-0", children: [
    /* @__PURE__ */ x("span", { "aria-hidden": "true", className: "text-input-default-outline select-none", children: "|" }),
    /* @__PURE__ */ x("span", { className: "text-(length:--font-size-body-medium) text-input-text-supporting whitespace-nowrap", children: p })
  ] }) : b ? /* @__PURE__ */ x(Ye, { name: b, size: "sm", tone: "inherit" }) : null, e[30] = b, e[31] = p, e[32] = N) : N = e[32];
  let I;
  e[33] !== N || e[34] !== y || e[35] !== C || e[36] !== P ? (I = /* @__PURE__ */ j("div", { className: y, children: [
    C,
    P,
    N
  ] }), e[33] = N, e[34] = y, e[35] = C, e[36] = P, e[37] = I) : I = e[37];
  let M;
  e[38] !== n || e[39] !== r || e[40] !== h || e[41] !== m ? (M = (m || h || n) && /* @__PURE__ */ x("div", { "data-testid": "input-subtext-row", className: le("mt-(--spacing-4)", m && "min-h-(--spacing-20)"), children: h ? /* @__PURE__ */ x(br, { match: !0, className: "text-(length:--font-size-label-small) leading-(--font-line-height-16) text-input-error-text", children: r }) : n ? /* @__PURE__ */ x(Yr, { className: "text-(length:--font-size-label-small) leading-(--font-line-height-16) text-input-text-supporting", children: n }) : null }), e[38] = n, e[39] = r, e[40] = h, e[41] = m, e[42] = M) : M = e[42];
  let T;
  return e[43] !== o || e[44] !== h || e[45] !== I || e[46] !== M || e[47] !== w ? (T = /* @__PURE__ */ j(hr, { invalid: h, disabled: o, className: "flex flex-col w-full", children: [
    w,
    I,
    M
  ] }), e[43] = o, e[44] = h, e[45] = I, e[46] = M, e[47] = w, e[48] = T) : T = e[48], T;
}
function z9(t) {
  const e = J.c(7);
  let n, o;
  e[0] !== t ? ({
    children: n,
    ...o
  } = t, e[0] = t, e[1] = n, e[2] = o) : (n = e[1], o = e[2]);
  let r;
  e[3] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (r = le("inline-flex", "items-center", "justify-center", "gap-(--spacing-4)", "rounded-(--radius-sm)", "border-[0.5px]", "border-solid", "border-menu-hotkey-outline", "bg-menu-hotkey-background", "px-(--spacing-6)", "py-(--spacing-4)", "font-(family-name:--font-family-body)", "text-(length:--font-size-label-medium)", "font-(number:--font-weight-regular)", "leading-(--font-line-height-16)", "tracking-(--font-letter-spacing-default)", "text-surface-on-surface-variant", "whitespace-nowrap", "not-italic", "select-none"), e[3] = r) : r = e[3];
  let s;
  return e[4] !== n || e[5] !== o ? (s = /* @__PURE__ */ x("kbd", { "data-slot": "kbd", className: r, ...o, children: n }), e[4] = n, e[5] = o, e[6] = s) : s = e[6], s;
}
const H9 = le("group relative flex min-h-[140px] w-full flex-col items-stretch justify-center overflow-hidden", "min-w-0 flex-1", "border-0 border-b border-solid border-b-outline-subtle", "bg-surface", "p-(--spacing-16)", "text-left", "transition-colors duration-200 ease-in-out", "after:pointer-events-none after:absolute after:inset-y-0 after:right-0 after:w-(--spacing-4)", "after:bg-primary after:opacity-0 after:transition-opacity after:duration-200 after:ease-in-out after:content-['']", "data-[state=active]:bg-primary/8 data-[state=active]:after:opacity-100", "cursor-pointer", "hover:bg-surface-hover", "active:bg-surface-pressed", "focus-visible:z-10 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-button-focus-ring", "disabled:pointer-events-none disabled:opacity-50");
function zN(t) {
  const e = J.c(9);
  let n, o, r;
  e[0] !== t ? ({
    active: r,
    children: n,
    ...o
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r) : (n = e[1], o = e[2], r = e[3]);
  const s = r === void 0 ? !1 : r, i = s ? "active" : "default";
  let a;
  return e[4] !== s || e[5] !== n || e[6] !== o || e[7] !== i ? (a = /* @__PURE__ */ x(Un, { type: "button", "data-slot": "list-card", "data-state": i, "aria-pressed": s, className: H9, ...o, children: n }), e[4] = s, e[5] = n, e[6] = o, e[7] = i, e[8] = a) : a = e[8], a;
}
const B9 = {
  default: {
    width: 44,
    height: 23.21
  },
  compact: {
    width: 24.16,
    height: 12.74
  }
};
function HN(t) {
  const e = J.c(17);
  let n, o, r, s, i;
  e[0] !== t ? ({
    size: i,
    style: s,
    "aria-label": o,
    "aria-hidden": n,
    ...r
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r, e[4] = s, e[5] = i) : (n = e[1], o = e[2], r = e[3], s = e[4], i = e[5]);
  const a = i === void 0 ? "default" : i, l = !o, c = B9[a], u = n ?? (l ? !0 : void 0), d = l ? void 0 : "img";
  let f;
  e[6] !== s ? (f = {
    flexShrink: 0,
    ...s
  }, e[6] = s, e[7] = f) : f = e[7];
  let p;
  e[8] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (p = /* @__PURE__ */ x("path", { d: "M10.3174 20.54C9.85932 21.349 9.19472 22.0221 8.3916 22.4902C7.58855 22.9583 6.67561 23.2051 5.74609 23.2051H0L4.35254 15.5615H13.1367L10.3174 20.54ZM26.4014 23.2051H20.6514C19.7228 23.2052 18.8103 22.9593 18.0078 22.4922C17.2054 22.0251 16.5415 21.3532 16.083 20.5459L10.2764 10.3164C9.8266 9.52465 9.59036 8.62933 9.59082 7.71875C9.59128 6.80816 9.82872 5.91337 10.2793 5.12207L13.1934 0L26.4014 23.2051ZM39.6104 23.2021H33.8613C32.9331 23.2021 32.021 22.9562 31.2188 22.4893C30.4164 22.0221 29.7514 21.3504 29.293 20.543L23.4863 10.3135C23.0366 9.52227 22.7998 8.62785 22.7998 7.71777C22.7998 6.8077 23.0366 5.91328 23.4863 5.12207L26.4014 0L39.6104 23.2021ZM44 7.71973L39.6084 15.4395L36.6934 10.3174C36.243 9.52576 36.0068 8.63047 36.0068 7.71973C36.0068 6.80898 36.243 5.91369 36.6934 5.12207L39.6084 0L44 7.71973Z", className: "fill-primary" }), e[8] = p) : p = e[8];
  let g;
  return e[9] !== o || e[10] !== c.height || e[11] !== c.width || e[12] !== r || e[13] !== u || e[14] !== d || e[15] !== f ? (g = /* @__PURE__ */ x("svg", { ...r, width: c.width, height: c.height, viewBox: "0 0 44 23.21", fill: "none", xmlns: "http://www.w3.org/2000/svg", "aria-hidden": u, "aria-label": o, role: d, style: f, children: p }), e[9] = o, e[10] = c.height, e[11] = c.width, e[12] = r, e[13] = u, e[14] = d, e[15] = f, e[16] = g) : g = e[16], g;
}
function va(t) {
  const e = J.c(24), {
    children: n,
    label: o,
    description: r,
    side: s,
    align: i,
    disabled: a,
    showArrow: l
  } = t, c = s === void 0 ? "top" : s, u = i === void 0 ? "center" : i, d = a === void 0 ? !1 : a, f = l === void 0 ? !0 : l;
  let p;
  e[0] !== n ? (p = /* @__PURE__ */ x(dd, { render: n }), e[0] = n, e[1] = p) : p = e[1];
  const g = f ? rb : ob;
  let m;
  e[2] !== f ? (m = f && /* @__PURE__ */ x(bd, { "data-slot": "tooltip-arrow", className: lb }), e[2] = f, e[3] = m) : m = e[3];
  const h = r ? "font-(number:--font-weight-semibold)" : "font-(number:--font-weight-regular)";
  let b;
  e[4] !== h ? (b = le(ib, h), e[4] = h, e[5] = b) : b = e[5];
  let w;
  e[6] !== o || e[7] !== b ? (w = /* @__PURE__ */ x("p", { className: b, children: o }), e[6] = o, e[7] = b, e[8] = w) : w = e[8];
  let y;
  e[9] !== r ? (y = r && /* @__PURE__ */ x("p", { className: ab, children: r }), e[9] = r, e[10] = y) : y = e[10];
  let C;
  e[11] !== w || e[12] !== y || e[13] !== m ? (C = /* @__PURE__ */ j(hd, { className: sb, children: [
    m,
    w,
    y
  ] }), e[11] = w, e[12] = y, e[13] = m, e[14] = C) : C = e[14];
  let R;
  e[15] !== u || e[16] !== c || e[17] !== C || e[18] !== g ? (R = /* @__PURE__ */ x(pd, { children: /* @__PURE__ */ x(md, { side: c, align: u, sideOffset: g, className: nb, children: C }) }), e[15] = u, e[16] = c, e[17] = C, e[18] = g, e[19] = R) : R = e[19];
  let S;
  return e[20] !== d || e[21] !== R || e[22] !== p ? (S = /* @__PURE__ */ j(cd, { disabled: d, children: [
    p,
    R
  ] }), e[20] = d, e[21] = R, e[22] = p, e[23] = S) : S = e[23], S;
}
function BN(t) {
  const e = J.c(17), {
    align: n,
    disabled: o,
    items: r,
    size: s,
    tooltip: i,
    variant: a,
    ...l
  } = t, c = n === void 0 ? "end" : n, u = o === void 0 ? !1 : o, d = s === void 0 ? "md" : s, f = a === void 0 ? "default" : a, [p, g] = v.useState(!1), {
    triggerMouseDownProps: m
  } = ai();
  let h;
  e[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (h = function(M) {
    g(M);
  }, e[0] = h) : h = e[0];
  const b = h, w = Y9({
    disabled: u,
    isOpen: p,
    props: l,
    size: d,
    tooltip: i,
    triggerMouseDownProps: m,
    variant: f
  }), y = f === "combo" && "gap-(--spacing-4)";
  let C;
  e[1] !== y ? (C = le("inline-flex items-center", y), e[1] = y, e[2] = C) : C = e[2];
  let R;
  e[3] !== C || e[4] !== w ? (R = /* @__PURE__ */ x("div", { className: C, children: w }), e[3] = C, e[4] = w, e[5] = R) : R = e[5];
  const S = R;
  let E;
  e[6] !== r ? (E = r.map(W9), e[6] = r, e[7] = E) : E = e[7];
  let P;
  e[8] !== c || e[9] !== E ? (P = /* @__PURE__ */ x(ii, { align: c, sideOffset: 5, size: "trigger", children: E }), e[8] = c, e[9] = E, e[10] = P) : P = e[10];
  let N;
  return e[11] !== u || e[12] !== b || e[13] !== p || e[14] !== P || e[15] !== S ? (N = /* @__PURE__ */ j(P9, { open: p, onOpenChange: b, disabled: u, modal: !1, children: [
    S,
    P
  ] }), e[11] = u, e[12] = b, e[13] = p, e[14] = P, e[15] = S, e[16] = N) : N = e[16], N;
}
function W9(t) {
  return t.type === "subheader" ? /* @__PURE__ */ x(I9, { disabled: t.disabled, children: t.label }, t.id) : U9(t);
}
function kg(t) {
  return /* @__PURE__ */ x(Wb, { disabled: t.disabled, endSection: t.endSection, leadingIcon: t.leadingIcon, onClick: t.onSelect, tone: t.tone, children: t.label }, t.id);
}
function U9(t) {
  return t.submenuItems ? /* @__PURE__ */ x(Wb, { disabled: t.disabled, leadingIcon: t.leadingIcon, tone: t.tone, submenu: t.submenuItems.map(kg), children: t.label }, t.id) : kg(t);
}
function Y9({
  disabled: t,
  isOpen: e,
  props: n,
  size: o,
  tooltip: r,
  triggerMouseDownProps: s,
  variant: i
}) {
  const a = o === "lg" ? "md" : o, l = o === "lg" ? {
    width: 44,
    height: 44
  } : void 0;
  if (i === "combo") {
    const {
      buttonVariant: p = "outline",
      label: g,
      onPrimaryAction: m
    } = n, h = /* @__PURE__ */ x(Tr, { render: /* @__PURE__ */ x(Kt, { "aria-label": `${g} menu`, disabled: t, icon: e ? "chevron-up" : "chevron-down", size: a, style: l, variant: p, ...s }) });
    return /* @__PURE__ */ j(_o, { children: [
      /* @__PURE__ */ x(Hn, { disabled: t, onClick: m, size: o, variant: p, children: g }),
      r ? /* @__PURE__ */ x(va, { label: r, side: "top", align: "end", showArrow: !0, children: /* @__PURE__ */ x("span", { className: "inline-flex", children: h }) }) : h
    ] });
  }
  if (i === "overflow") {
    const {
      "aria-label": p
    } = n, g = /* @__PURE__ */ x(Tr, { render: /* @__PURE__ */ x(Kt, { "aria-label": p, disabled: t, icon: "ellipsis-dots", size: a, style: l, variant: "outline", ...s }) });
    return r ? /* @__PURE__ */ x(va, { label: r, side: "top", align: "end", showArrow: !0, children: /* @__PURE__ */ x("span", { className: "inline-flex", children: g }) }) : g;
  }
  const {
    "aria-label": c,
    label: u
  } = n, d = {};
  c && (d["aria-label"] = c);
  const f = /* @__PURE__ */ x(Tr, { render: /* @__PURE__ */ x(Hn, { ...d, disabled: t, icon: e ? "chevron-up" : "chevron-down", size: o, variant: "outline", ...s, children: u }) });
  return r ? G9(f, r) : f;
}
function G9(t, e) {
  return /* @__PURE__ */ x(va, { label: e, side: "top", align: "end", showArrow: !0, children: t });
}
const Ld = /* @__PURE__ */ v.createContext(void 0);
process.env.NODE_ENV !== "production" && (Ld.displayName = "ComboboxRootContext");
const $d = /* @__PURE__ */ v.createContext(void 0);
process.env.NODE_ENV !== "production" && ($d.displayName = "ComboboxFloatingContext");
const zd = /* @__PURE__ */ v.createContext(void 0);
process.env.NODE_ENV !== "production" && (zd.displayName = "ComboboxDerivedItemsContext");
const Hd = /* @__PURE__ */ v.createContext("");
process.env.NODE_ENV !== "production" && (Hd.displayName = "ComboboxInputValueContext");
function wn() {
  const t = v.useContext(Ld);
  if (!t)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: ComboboxRootContext is missing. Combobox parts must be placed within <Combobox.Root>." : Xe(22));
  return t;
}
function Xa() {
  const t = v.useContext($d);
  if (!t)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: ComboboxFloatingContext is missing. Combobox parts must be placed within <Combobox.Root>." : Xe(23));
  return t;
}
function Bo() {
  const t = v.useContext(zd);
  if (!t)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: ComboboxItemsContext is missing. Combobox parts must be placed within <Combobox.Root>." : Xe(24));
  return t;
}
function Bd() {
  return v.useContext(Hd);
}
const Ee = {
  id: ce((t) => t.id),
  labelId: ce((t) => t.labelId),
  items: ce((t) => t.items),
  selectedValue: ce((t) => t.selectedValue),
  hasSelectionChips: ce((t) => {
    const e = t.selectedValue;
    return Array.isArray(e) && e.length > 0;
  }),
  hasSelectedValue: ce((t) => {
    const {
      selectedValue: e,
      selectionMode: n
    } = t;
    return e == null ? !1 : n === "multiple" && Array.isArray(e) ? e.length > 0 : !0;
  }),
  hasNullItemLabel: ce((t, e) => e ? sh(t.items) : !1),
  open: ce((t) => t.open),
  mounted: ce((t) => t.mounted),
  forceMounted: ce((t) => t.forceMounted),
  inline: ce((t) => t.inline),
  activeIndex: ce((t) => t.activeIndex),
  selectedIndex: ce((t) => t.selectedIndex),
  isActive: ce((t, e) => t.activeIndex === e),
  isSelected: ce((t, e) => {
    const n = t.isItemEqualToValue, o = t.selectedValue;
    return Array.isArray(o) ? o.some((r) => so(e, r, n)) : so(e, o, n);
  }),
  transitionStatus: ce((t) => t.transitionStatus),
  popupProps: ce((t) => t.popupProps),
  inputProps: ce((t) => t.inputProps),
  triggerProps: ce((t) => t.triggerProps),
  getItemProps: ce((t) => t.getItemProps),
  positionerElement: ce((t) => t.positionerElement),
  listElement: ce((t) => t.listElement),
  triggerElement: ce((t) => t.triggerElement),
  inputElement: ce((t) => t.inputElement),
  inputGroupElement: ce((t) => t.inputGroupElement),
  popupSide: ce((t) => t.popupSide),
  openMethod: ce((t) => t.openMethod),
  inputInsidePopup: ce((t) => t.inputInsidePopup),
  selectionMode: ce((t) => t.selectionMode),
  name: ce((t) => t.name),
  form: ce((t) => t.form),
  disabled: ce((t) => t.disabled),
  readOnly: ce((t) => t.readOnly),
  required: ce((t) => t.required),
  grid: ce((t) => t.grid),
  virtualized: ce((t) => t.virtualized),
  itemToStringLabel: ce((t) => t.itemToStringLabel),
  isItemEqualToValue: ce((t) => t.isItemEqualToValue),
  modal: ce((t) => t.modal),
  autoHighlight: ce((t) => t.autoHighlight),
  submitOnItemClick: ce((t) => t.submitOnItemClick)
};
function j9(t, e) {
  return (n, o) => {
    if (n == null)
      return !1;
    const r = qt(n, e);
    return t.contains(r, o);
  };
}
function K9(t, e, n) {
  return (o, r) => {
    if (o == null)
      return !1;
    if (!r)
      return !0;
    const s = qt(o, e), i = n != null ? qt(n, e) : "";
    return i && t.contains(i, r) && i.length === r.length ? !0 : t.contains(s, r);
  };
}
const Og = /* @__PURE__ */ new Map();
function q9(t = {}) {
  const e = {
    usage: "search",
    sensitivity: "base",
    ignorePunctuation: !0,
    ...t
  }, n = `${qb(t.locale)}|${JSON.stringify(e)}`, o = Og.get(n);
  if (o)
    return o;
  const r = new Intl.Collator(t.locale, e), s = {
    contains(i, a, l) {
      if (!a)
        return !0;
      const c = qt(i, l);
      for (let u = 0; u <= c.length - a.length; u += 1)
        if (r.compare(c.slice(u, u + a.length), a) === 0)
          return !0;
      return !1;
    },
    startsWith(i, a, l) {
      if (!a)
        return !0;
      const c = qt(i, l);
      return r.compare(c.slice(0, a.length), a) === 0;
    },
    endsWith(i, a, l) {
      if (!a)
        return !0;
      const c = qt(i, l), u = a.length;
      return c.length >= u && r.compare(c.slice(c.length - u), a) === 0;
    }
  };
  return Og.set(n, s), s;
}
function qb(t) {
  return Array.isArray(t) ? t.map((e) => qb(e)).join(",") : t == null ? "" : String(t);
}
const Xb = q9, Zb = /* @__PURE__ */ Symbol("none"), Go = {
  value: Zb,
  index: -1
};
function Qb(t) {
  const {
    id: e,
    onOpenChangeComplete: n,
    defaultSelectedValue: o = null,
    selectedValue: r,
    onSelectedValueChange: s,
    defaultInputValue: i,
    inputValue: a,
    open: l,
    defaultOpen: c = !1,
    selectionMode: u = "none",
    onItemHighlighted: d,
    name: f,
    form: p,
    disabled: g = !1,
    readOnly: m = !1,
    required: h = !1,
    inputRef: b,
    grid: w = !1,
    items: y,
    filteredItems: C,
    filter: R,
    openOnInputClick: S = !0,
    autoHighlight: E = !1,
    keepHighlight: P = !1,
    highlightItemOnHover: N = !0,
    loopFocus: I = !0,
    itemToStringLabel: M,
    itemToStringValue: T,
    isItemEqualToValue: k = nh,
    virtualized: D = !1,
    inline: O = !1,
    fillInputOnItemPress: V = !0,
    modal: _ = !1,
    limit: A = -1,
    autoComplete: F = "list",
    formAutoComplete: H,
    locale: Y,
    submitOnItemClick: B = !1
  } = t, {
    clearErrors: U
  } = Co(), {
    setDirty: q,
    validityData: W,
    shouldValidateOnChange: K,
    setFilled: te,
    name: z,
    disabled: Q,
    setTouched: ee,
    setFocused: ae,
    validationMode: X,
    validation: se
  } = Xt(), ue = mr({
    id: e
  }), re = Xb({
    locale: Y
  }), [ne, oe] = v.useState(!1), [me, de] = v.useState(null), he = v.useRef([]), $ = v.useRef([]), Z = v.useRef(null), L = v.useRef(null), G = v.useRef(null), ie = v.useRef(null), pe = v.useRef(null), be = v.useRef(!0), Re = v.useRef(!1), _e = v.useRef(null), ke = v.useRef(null), Se = v.useRef(null), Ie = v.useRef(Go), Le = v.useRef(null), Ze = v.useRef([]), tt = v.useRef([]), ut = Q || g, at = z ?? f, $e = u === "multiple", Ce = u === "single", Oe = a !== void 0 || i !== void 0, Ne = y !== void 0, Be = C !== void 0;
  let ze;
  E === "always" ? ze = "always" : ze = E ? "input-change" : !1;
  const [Me, Wt] = sn({
    controlled: r,
    default: $e ? o ?? Nn : o,
    name: "Combobox",
    state: "selectedValue"
  }), ft = v.useMemo(() => R === null ? () => !0 : R !== void 0 ? R : Ce && !ne ? K9(re, M, Me) : j9(re, M), [R, Ce, Me, ne, re, M]), ve = Pt(() => Oe ? i ?? "" : Ce ? qt(Me, M) : "").current, [we, Ve] = sn({
    controlled: a,
    default: ve,
    name: "Combobox",
    state: "inputValue"
  }), [He, ct] = sn({
    controlled: l,
    default: c,
    name: "Combobox",
    state: "open"
  }), qe = Bu(y), it = me ?? (we === "" ? "" : String(we).trim()), Ue = Ce ? qt(Me, M) : "", We = Ce && !ne && it !== "" && Ue !== "" && Ue.length === it.length && re.contains(Ue, it), Qe = We ? "" : it, nt = Ne && Be && We, dt = v.useMemo(() => y ? qe ? y.flatMap((Fe) => Fe.items) : y : Nn, [y, qe]), pt = v.useMemo(() => {
    if (C && !nt)
      return C;
    if (!y)
      return Nn;
    if (qe) {
      const Ge = y, mt = [];
      let wt = 0;
      for (const Gt of Ge) {
        if (A > -1 && wt >= A)
          break;
        const Ut = Qe === "" ? Gt.items : Gt.items.filter((fi) => ft(fi, Qe, M));
        if (Ut.length === 0)
          continue;
        const Wo = A > -1 ? A - wt : 1 / 0, Eo = Ut.slice(0, Wo);
        if (Eo.length > 0) {
          const fi = {
            ...Gt,
            items: Eo
          };
          mt.push(fi), wt += Eo.length;
        }
      }
      return mt;
    }
    if (Qe === "")
      return A > -1 ? dt.slice(0, A) : (
        // The cast here is done as `flatItems` is readonly.
        // valuesRef.current, a mutable ref, can be set to `flatFilteredItems`, which may
        // reference this exact readonly value, creating a mutation risk.
        // However, <Combobox.Item> can never mutate this value as the mutating effect
        // bails early when `items` is provided, and this is only ever returned
        // when `items` is provided due to the early return at the top of this hook.
        dt
      );
    const Fe = [];
    for (const Ge of dt) {
      if (A > -1 && Fe.length >= A)
        break;
      ft(Ge, Qe, M) && Fe.push(Ge);
    }
    return Fe;
  }, [C, nt, y, qe, Qe, A, ft, M, dt]), Nt = v.useMemo(() => qe ? pt.flatMap((Ge) => Ge.items) : pt, [pt, qe]), ot = Pt(() => new lu({
    id: ue,
    labelId: void 0,
    selectedValue: Me,
    open: He,
    filter: ft,
    query: it,
    items: y,
    selectionMode: u,
    listRef: he,
    labelsRef: $,
    popupRef: Z,
    emptyRef: pe,
    inputRef: L,
    startDismissRef: G,
    endDismissRef: ie,
    keyboardActiveRef: be,
    chipsContainerRef: _e,
    clearRef: ke,
    valuesRef: Ze,
    allValuesRef: tt,
    selectionEventRef: Se,
    name: at,
    form: p,
    disabled: ut,
    readOnly: m,
    required: h,
    grid: w,
    isGrouped: qe,
    virtualized: D,
    openOnInputClick: S,
    itemToStringLabel: M,
    isItemEqualToValue: k,
    modal: _,
    autoHighlight: ze,
    submitOnItemClick: B,
    hasInputValue: Oe,
    mounted: !1,
    forceMounted: !1,
    transitionStatus: "idle",
    inline: O,
    activeIndex: null,
    selectedIndex: null,
    popupProps: {},
    inputProps: {},
    triggerProps: {},
    positionerElement: null,
    listElement: null,
    triggerElement: null,
    inputElement: null,
    inputGroupElement: null,
    popupSide: null,
    openMethod: null,
    inputInsidePopup: !0,
    onOpenChangeComplete: n || ht,
    // Placeholder callbacks replaced on first render
    setOpen: ht,
    setInputValue: ht,
    setSelectedValue: ht,
    setIndices: ht,
    onItemHighlighted: ht,
    handleSelection: ht,
    getItemProps: () => yt,
    forceMount: ht,
    requestSubmit: ht
  })).current, At = u === "none" ? we : Me, qn = v.useMemo(() => u === "none" ? At : Array.isArray(Me) ? Me.map((Fe) => An(Fe, T)) : An(Me, T), [At, T, u, Me]), dn = ge(d), Tn = ge(n), Cn = fe(ot, Ee.activeIndex), Sn = fe(ot, Ee.selectedIndex), Zt = fe(ot, Ee.positionerElement), Xn = fe(ot, Ee.listElement), Yt = fe(ot, Ee.triggerElement), kn = fe(ot, Ee.inputElement), Qr = fe(ot, Ee.inputGroupElement), fn = fe(ot, Ee.inline), On = fe(ot, Ee.inputInsidePopup), K2 = _t(Yt), {
    mounted: wf,
    setMounted: q2,
    transitionStatus: nl
  } = Yn(He), {
    openMethod: Cf,
    triggerProps: ol
  } = Js(He), X2 = ge(() => qn);
  Ur(On ? K2 : L, {
    id: ue,
    value: At,
    getValue: X2
  });
  const ci = ge(() => {
    y ? $.current = Nt.map((Fe) => qt(Fe, M)) : ot.set("forceMounted", !0);
  }), Z2 = v.useRef(Me);
  xe(() => {
    Me !== Z2.current && ci();
  }, [ci, Me]);
  const Dn = ge((Fe) => {
    ot.update(Fe);
    const Ge = Fe.type || "none";
    if (Fe.activeIndex !== void 0)
      if (Fe.activeIndex === null)
        Ie.current !== Go && (Ie.current = Go, dn(void 0, ts(Ge, void 0, {
          index: -1
        })));
      else {
        const mt = Ze.current[Fe.activeIndex];
        Ie.current = {
          value: mt,
          index: Fe.activeIndex
        }, dn(mt, ts(Ge, void 0, {
          index: Fe.activeIndex
        }));
      }
  }), Zn = ge((Fe, Ge) => {
    if (Re.current = Ge.reason === Io, t.onInputValueChange?.(Fe, Ge), !Ge.isCanceled) {
      if (Ge.reason === wr) {
        const mt = Ge.event, wt = mt.inputType;
        if (mt.type === "compositionend" || wt != null && wt !== "" && wt !== "insertReplacementText") {
          const Ut = Fe.trim() !== "";
          Ut && oe(!0), Le.current = {
            hasQuery: Ut
          }, Ut && ze && ot.state.activeIndex == null && ot.set("activeIndex", 0);
        }
      }
      Ve(Fe);
    }
  }), Jr = ge((Fe, Ge) => {
    if (He !== Fe && (Ge.reason === "escape-key" && Ne && Nt.length === 0 && !ot.state.emptyRef.current && Ge.allowPropagation(), t.onOpenChange?.(Fe, Ge), !Ge.isCanceled && (!Fe && ne && (Ce ? (fn || de(it), it === "" && oe(!1)) : $e && (fn || On ? Dn({
      activeIndex: null
    }) : de(it), Zn("", Pe(Io, Ge.event)))), ct(Fe), !Fe && On && (Ge.reason === yo || Ge.reason === Vs) && (ee(!0), ae(!1), X === "onBlur")))) {
      const mt = u === "none" ? we : Me;
      se.commit(mt);
    }
  }), ui = ge((Fe, Ge) => {
    if (s?.(Fe, Ge), Ge.isCanceled)
      return;
    Wt(Fe), (u === "none" && Z.current && V || Ce && !ot.state.inputInsidePopup) && Zn(qt(Fe, M), Pe(Ge.reason, Ge.event)), Ce && Fe != null && Ge.reason !== wr && ne && !fn && de(it);
  }), Q2 = ge((Fe, Ge) => {
    let mt = Ge;
    if (mt === void 0) {
      if (Cn === null)
        return;
      mt = Ze.current[Cn];
    }
    const wt = gt(Fe), Gt = Se.current ?? Fe;
    Se.current = null;
    const Ut = Pe(ko, Gt), Wo = wt?.closest("a")?.getAttribute("href");
    if (Wo) {
      Wo.startsWith("#") && Jr(!1, Ut);
      return;
    }
    if ($e) {
      const Eo = Array.isArray(Me) ? Me : [], u0 = oh(Eo, mt, ot.state.isItemEqualToValue) ? rh(Eo, mt, ot.state.isItemEqualToValue) : [...Eo, mt];
      if (ui(u0, Ut), !(L.current ? L.current.value.trim() !== "" : !1))
        return;
      ot.state.inputInsidePopup ? Zn("", Pe(Io, Ut.event)) : Jr(!1, Ut);
    } else
      ui(mt, Ut), Jr(!1, Ut);
  }), rl = ge(() => {
    if (!ot.state.submitOnItemClick)
      return;
    const Fe = se.inputRef.current?.form ?? ot.state.inputElement?.form;
    Fe && typeof Fe.requestSubmit == "function" && Fe.requestSubmit();
  }), sl = ge(() => {
    if (q2(!1), Tn?.(!1), oe(!1), de(null), Dn(u === "none" ? {
      activeIndex: null,
      selectedIndex: null
    } : {
      activeIndex: null
    }), $e && L.current && L.current.value !== "" && !Re.current && Zn("", Pe(Io)), Ce)
      if (ot.state.inputInsidePopup)
        L.current && L.current.value !== "" && Zn("", Pe(Io));
      else {
        const Fe = qt(Me, M);
        L.current && L.current.value !== Fe && Zn(Fe, Pe(Fe === "" ? Io : Et));
      }
  }), J2 = v.useMemo(() => fn && Zt ? {
    current: Zt.closest('[role="dialog"]')
  } : Z, [fn, Zt]);
  Bt({
    enabled: !t.actionsRef,
    open: He,
    ref: J2,
    onComplete() {
      He || sl();
    }
  }), v.useImperativeHandle(t.actionsRef, () => ({
    unmount: sl
  }), [sl]), xe(function() {
    if (He || u === "none")
      return;
    const Ge = y ? dt : tt.current;
    if ($e) {
      const mt = Array.isArray(Me) ? Me : [], wt = mt[mt.length - 1], Gt = vo(Ge, wt, k);
      Dn({
        selectedIndex: Gt === -1 ? null : Gt
      });
    } else {
      const mt = vo(Ge, Me, k);
      Dn({
        selectedIndex: mt === -1 ? null : mt
      });
    }
  }, [He, Me, y, u, dt, $e, k, Dn]), xe(() => {
    y && (Ze.current = Nt, he.current.length = Nt.length);
  }, [y, Nt]), xe(() => {
    const Fe = Le.current;
    if (Fe && (Fe.hasQuery ? ze && ot.set("activeIndex", 0) : ze === "always" && ot.set("activeIndex", 0), Le.current = null), !He && !fn)
      return;
    const mt = Ne || Be ? Nt : Ze.current, wt = ot.state.activeIndex;
    if (wt == null) {
      if (ze === "always" && mt.length > 0) {
        ot.set("activeIndex", 0);
        return;
      }
      Ie.current !== Go && (Ie.current = Go, ot.state.onItemHighlighted(void 0, ts(Et, void 0, {
        index: -1
      })));
      return;
    }
    if (wt >= mt.length) {
      Ie.current !== Go && (Ie.current = Go, ot.state.onItemHighlighted(void 0, ts(Et, void 0, {
        index: -1
      }))), ot.set("activeIndex", null);
      return;
    }
    const Gt = mt[wt], Ut = Ie.current.value, Wo = Ut !== Zb && so(Gt, Ut, ot.state.isItemEqualToValue);
    (Ie.current.index !== wt || !Wo) && (Ie.current = {
      value: Gt,
      index: wt
    }, ot.state.onItemHighlighted(Gt, ts(Et, void 0, {
      index: wt
    })));
  }, [Cn, ze, Be, Ne, Nt, fn, He, ot]), xe(() => {
    if (u === "none") {
      te(String(we) !== "");
      return;
    }
    te($e ? Array.isArray(Me) && Me.length > 0 : Me != null);
  }, [te, u, we, Me, $e]), v.useEffect(() => {
    Ne && ze && Nt.length === 0 && Dn({
      activeIndex: null
    });
  }, [Ne, ze, Nt.length, Dn]), po(it, () => {
    !He || it === "" || it === String(ve) || oe(!0);
  }), po(Me, () => {
    if (u !== "none" && (U(at), q(Me !== W.initialValue), K() ? se.commit(Me) : se.commit(Me, !0), Ce && !Oe && !On)) {
      const Fe = qt(Me, M);
      we !== Fe && Zn(Fe, Pe(Et));
    }
  }), po(we, () => {
    u === "none" && (U(at), q(we !== W.initialValue), K() ? se.commit(we) : se.commit(we, !0));
  }), po(y, () => {
    if (!Ce || Oe || On || ne)
      return;
    const Fe = qt(Me, M);
    we !== Fe && Zn(Fe, Pe(Et));
  });
  const di = uu({
    open: fn ? !0 : He,
    onOpenChange: Jr,
    elements: {
      reference: On ? Yt : kn,
      floating: Zt
    }
  });
  let il, al;
  fn || (il = w ? "grid" : "listbox", al = He ? "true" : "false");
  const e0 = v.useMemo(() => {
    const Fe = kn?.tagName === "INPUT", Ge = kn == null || Fe, mt = Ge || He, wt = Ge ? {
      autoComplete: "off",
      spellCheck: "false",
      autoCorrect: "off",
      autoCapitalize: "none"
    } : {};
    return mt && (wt.role = "combobox", wt["aria-expanded"] = al, wt["aria-haspopup"] = il, wt["aria-controls"] = He ? Xn?.id : void 0, wt["aria-autocomplete"] = F), {
      reference: wt,
      floating: {
        role: "presentation"
      }
    };
  }, [kn, He, al, il, Xn?.id, F]), t0 = lr(di, {
    enabled: !m && !ut && S,
    event: "mousedown-only",
    toggle: !1,
    // Apply a small delay for touch to let mobile viewport/keyboard positioning settle.
    // This avoids top-bottom flip flickers if the preferred position is "top" when first tapping.
    touchOpenDelay: On ? 0 : 100,
    reason: Em
  }), n0 = cr(di, {
    enabled: !m && !ut && !fn,
    outsidePressEvent: {
      mouse: "sloppy",
      // The visual viewport (affected by the mobile software keyboard) can be
      // somewhat small. The user may want to scroll the screen to see more of
      // the popup.
      touch: "intentional"
    },
    // Without a popup, let the Escape key bubble the event up to other popups' handlers.
    bubbles: fn ? !0 : void 0,
    outsidePress(Fe) {
      const Ge = gt(Fe);
      return !De(Yt, Ge) && !De(ke.current, Ge) && !De(_e.current, Ge) && !De(Qr, Ge);
    }
  }), o0 = pu(di, {
    enabled: !m && !ut,
    id: ue,
    listRef: he,
    activeIndex: Cn,
    selectedIndex: Sn,
    virtual: !0,
    loopFocus: I,
    allowEscape: I && !ze,
    focusItemOnOpen: ne || u === "none" && !ze ? !1 : "auto",
    focusItemOnHover: N,
    resetOnPointerLeave: !P,
    // `cols` > 1 enables grid navigation.
    // Since <Combobox.Row> infers column sizes (and is required when building a grid),
    // it works correctly even with a value of `2`.
    // Floating UI tests don't require `role="row"` wrappers, so retains the number API.
    cols: w ? 2 : 1,
    orientation: w ? "horizontal" : void 0,
    disabledIndices: Nn,
    onNavigate(Fe, Ge) {
      !Ge && !He || nl === "ending" || Dn(Ge ? {
        activeIndex: Fe,
        type: be.current ? "keyboard" : "pointer"
      } : {
        activeIndex: Fe
      });
    }
  }), {
    getReferenceProps: ll,
    getFloatingProps: cl,
    getItemProps: ul
  } = Gn([e0, t0, n0, o0]);
  sr(() => {
    ot.update({
      inline: O,
      popupProps: cl(),
      inputProps: ll(),
      triggerProps: ol,
      getItemProps: ul,
      setOpen: Jr,
      setInputValue: Zn,
      setSelectedValue: ui,
      setIndices: Dn,
      onItemHighlighted: dn,
      handleSelection: Q2,
      forceMount: ci,
      requestSubmit: rl
    });
  }), xe(() => {
    ot.update({
      id: ue,
      selectedValue: Me,
      open: He,
      mounted: wf,
      transitionStatus: nl,
      items: y,
      inline: O,
      popupProps: cl(),
      inputProps: ll(),
      triggerProps: ol,
      openMethod: Cf,
      getItemProps: ul,
      selectionMode: u,
      name: at,
      form: p,
      disabled: ut,
      readOnly: m,
      required: h,
      grid: w,
      isGrouped: qe,
      virtualized: D,
      onOpenChangeComplete: Tn,
      openOnInputClick: S,
      itemToStringLabel: M,
      modal: _,
      autoHighlight: ze,
      isItemEqualToValue: k,
      submitOnItemClick: B,
      hasInputValue: Oe,
      requestSubmit: rl
    });
  }, [ot, ue, Me, He, wf, nl, y, cl, ll, ul, Cf, ol, u, at, ut, m, h, se, w, qe, D, Tn, S, M, _, k, B, Oe, O, rl, ze, p]);
  const r0 = ln(b, se.inputRef), s0 = v.useMemo(() => ({
    query: it,
    hasItems: Ne,
    filteredItems: pt,
    flatFilteredItems: Nt
  }), [it, Ne, pt, Nt]), i0 = v.useMemo(() => Array.isArray(At) ? "" : An(At, T), [At, T]), a0 = $e && Array.isArray(Me) && Me.length > 0, dl = $e || u === "none" ? void 0 : at, l0 = v.useMemo(() => !$e || !Array.isArray(Me) || !at ? null : Me.map((Fe) => {
    const Ge = An(Fe, T);
    return /* @__PURE__ */ x("input", {
      type: "hidden",
      form: p,
      name: at,
      value: Ge
    }, Ge);
  }), [$e, Me, p, at, T]), c0 = /* @__PURE__ */ j(v.Fragment, {
    children: [t.children, /* @__PURE__ */ x("input", {
      ...se.getInputValidationProps({
        // Move focus when the hidden input is focused.
        onFocus() {
          if (On) {
            Yt?.focus();
            return;
          }
          (L.current || Yt)?.focus();
        },
        // Handle browser autofill.
        onChange(Fe) {
          if (Fe.nativeEvent.defaultPrevented)
            return;
          const Ge = Fe.currentTarget.value, mt = Pe(Et, Fe.nativeEvent);
          function wt() {
            if ($e)
              return;
            if (u === "none") {
              q(Ge !== W.initialValue), Zn(Ge, mt), K() && se.commit(Ge);
              return;
            }
            const Gt = Ze.current.find((Ut) => An(Ut, T).toLowerCase() === Ge.toLowerCase() || qt(Ut, M).toLowerCase() === Ge.toLowerCase());
            Gt != null && (q(Gt !== W.initialValue), ui?.(Gt, mt), K() && se.commit(Gt));
          }
          y ? wt() : (ci(), queueMicrotask(wt));
        }
      }),
      id: ue && dl == null ? `${ue}-hidden-input` : void 0,
      form: p,
      name: dl,
      autoComplete: H,
      disabled: ut,
      required: h && !a0,
      readOnly: m,
      value: i0,
      ref: r0,
      style: dl ? Lr : $o,
      tabIndex: -1,
      "aria-hidden": !0,
      suppressHydrationWarning: !0
    }), l0]
  });
  return /* @__PURE__ */ x(Ld.Provider, {
    value: ot,
    children: /* @__PURE__ */ x($d.Provider, {
      value: di,
      children: /* @__PURE__ */ x(zd.Provider, {
        value: s0,
        children: /* @__PURE__ */ x(Hd.Provider, {
          value: we,
          children: c0
        })
      })
    })
  });
}
function Jb(t) {
  const {
    multiple: e = !1,
    defaultValue: n,
    value: o,
    onValueChange: r,
    autoComplete: s,
    ...i
  } = t;
  return /* @__PURE__ */ x(Qb, {
    ...i,
    selectionMode: e ? "multiple" : "single",
    selectedValue: o,
    defaultSelectedValue: n,
    onSelectedValueChange: r,
    formAutoComplete: s
  });
}
const Wd = {
  ...Es,
  ...jn,
  popupSide: (t) => t ? {
    "data-popup-side": t
  } : null,
  listEmpty: (t) => t ? {
    "data-list-empty": ""
  } : null
}, Ud = /* @__PURE__ */ v.createContext(void 0);
process.env.NODE_ENV !== "production" && (Ud.displayName = "ComboboxChipsContext");
function e2() {
  return v.useContext(Ud);
}
const Yd = /* @__PURE__ */ v.createContext(void 0);
process.env.NODE_ENV !== "production" && (Yd.displayName = "ComboboxPositionerContext");
function Gd(t) {
  const e = v.useContext(Yd);
  if (e === void 0 && !t)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: <Combobox.Popup> and <Combobox.Arrow> must be used within the <Combobox.Positioner> component" : Xe(21));
  return e;
}
const jd = /* @__PURE__ */ v.forwardRef(function(e, n) {
  const o = wn(), {
    buttonRef: r,
    getButtonProps: s
  } = Ft({
    native: !1
  }), i = ln(n, r), a = ge((c) => {
    o.state.setOpen(!1, Pe(Rm, c.nativeEvent, c.currentTarget));
  }), l = s({
    onClick: a
  });
  return /* @__PURE__ */ x("span", {
    ref: i,
    ...l,
    "aria-label": "Dismiss",
    tabIndex: void 0,
    style: Lr
  });
});
process.env.NODE_ENV !== "production" && (jd.displayName = "ComboboxInternalDismissButton");
const Kd = /* @__PURE__ */ v.forwardRef(function(e, n) {
  const {
    render: o,
    className: r,
    disabled: s = !1,
    id: i,
    style: a,
    ...l
  } = e, {
    state: c,
    disabled: u,
    setTouched: d,
    setFocused: f,
    validationMode: p,
    validation: g
  } = Xt(), {
    labelId: m
  } = un(), h = e2(), w = !!Gd(!0), y = wn(), {
    filteredItems: C
  } = Bo(), R = Bd(), S = Ks(), E = fe(y, Ee.required), P = fe(y, Ee.disabled), N = fe(y, Ee.readOnly), I = fe(y, Ee.name), M = fe(y, Ee.form), T = fe(y, Ee.selectionMode), k = fe(y, Ee.autoHighlight), D = fe(y, Ee.inputProps), O = fe(y, Ee.triggerProps), V = fe(y, Ee.open), _ = fe(y, Ee.mounted), A = fe(y, Ee.selectedValue), F = fe(y, Ee.popupSide), H = fe(y, Ee.positionerElement), Y = fe(y, Ee.id), B = fe(y, Ee.inline), U = fe(y, Ee.modal), q = !!k, W = _ && H ? F : null, K = u || P || s, te = C.length === 0, z = w || B, Q = !z || U, ee = St(i ?? (z ? void 0 : Y)), ae = Wu(m, void 0), X = w ? Sr : c, [se, ue] = v.useState(null), re = v.useRef(!1), ne = v.useRef(null), oe = v.useRef(!1), me = ge((L) => {
    const G = w || y.state.inline;
    G && !y.state.hasInputValue && y.state.setInputValue("", Pe(Et)), y.update({
      inputElement: L,
      inputInsidePopup: G
    });
  }), de = w || !g ? l : g.getValidationProps(l), he = {
    ...X,
    open: V,
    disabled: K,
    readOnly: N,
    popupSide: W,
    listEmpty: te
  };
  function $(L) {
    if (!h)
      return;
    let G;
    const {
      highlightedChipIndex: ie
    } = h, pe = h.chipsRef.current.length;
    if (ie !== void 0) {
      if (L.key === "ArrowLeft")
        L.preventDefault(), ie > 0 ? G = ie - 1 : G = void 0;
      else if (L.key === "ArrowRight")
        L.preventDefault(), ie < pe - 1 ? G = ie + 1 : G = void 0;
      else if (L.key === "Backspace" || L.key === "Delete") {
        L.preventDefault();
        const be = ie >= A.length - 1 ? A.length - 2 : ie;
        G = be >= 0 ? be : void 0, y.state.setIndices({
          activeIndex: null,
          selectedIndex: null,
          type: "keyboard"
        });
      }
      return G;
    }
    return L.key === "ArrowLeft" && (L.currentTarget.selectionStart ?? 0) === 0 && A.length > 0 ? (L.preventDefault(), G = pe > 0 ? pe - 1 : void 0) : L.key === "Backspace" && L.currentTarget.value === "" && A.length > 0 && (y.state.setIndices({
      activeIndex: null,
      selectedIndex: null,
      type: "keyboard"
    }), L.preventDefault()), G;
  }
  const Z = Te("input", e, {
    state: he,
    ref: [n, y.state.inputRef, me],
    props: [D, O, {
      type: "text",
      value: e.value ?? se ?? R,
      "aria-readonly": N || void 0,
      "aria-required": E || void 0,
      "aria-labelledby": ae,
      disabled: K,
      readOnly: N,
      required: T === "none" ? E : void 0,
      form: M,
      ...T === "none" && I && {
        name: I
      },
      id: ee,
      onFocus() {
        if (f(!0), !B || !oe.current)
          return;
        oe.current = !1;
        const L = ne.current;
        L == null || // `valuesRef` can be sparse, so guard against restoring a removed slot.
        !Object.hasOwn(y.state.valuesRef.current, L) || y.state.setIndices({
          activeIndex: L
        });
      },
      onBlur() {
        d(!0), f(!1);
        const L = y.state.activeIndex;
        if (B && L !== null && k !== "always" && (ne.current = L, oe.current = !0, y.state.setIndices({
          activeIndex: null
        })), p === "onBlur") {
          const G = T === "none" ? R : A;
          g.commit(G);
        }
      },
      onCompositionStart(L) {
        xs || (re.current = !0, ue(L.currentTarget.value));
      },
      onCompositionEnd(L) {
        re.current = !1;
        const G = L.currentTarget.value;
        ue(null), y.state.setInputValue(G, Pe(wr, L.nativeEvent));
      },
      onChange(L) {
        const G = L.nativeEvent.inputType, ie = !G || G === "insertReplacementText", pe = re.current || !ie;
        if (re.current) {
          const ke = L.currentTarget.value;
          ue(ke), ke === "" && !y.state.openOnInputClick && !y.state.inputInsidePopup && y.state.setOpen(!1, Pe(Io, L.nativeEvent));
          const Se = ke.trim(), Ie = q && Se !== "";
          !N && !K && Se && pe && (y.state.setOpen(!0, Pe(wr, L.nativeEvent)), q || y.state.setIndices({
            activeIndex: null,
            selectedIndex: null,
            type: y.state.keyboardActiveRef.current ? "keyboard" : "pointer"
          })), V && y.state.activeIndex !== null && !Ie && y.state.setIndices({
            activeIndex: null,
            selectedIndex: null,
            type: y.state.keyboardActiveRef.current ? "keyboard" : "pointer"
          });
          return;
        }
        y.state.setInputValue(L.currentTarget.value, Pe(wr, L.nativeEvent));
        const be = L.currentTarget.value === "", Re = Pe(Io, L.nativeEvent);
        be && !y.state.inputInsidePopup && (T === "single" && y.state.setSelectedValue(null, Re), y.state.openOnInputClick || y.state.setOpen(!1, Re));
        const _e = L.currentTarget.value.trim();
        !N && !K && _e && pe && (y.state.setOpen(!0, Pe(wr, L.nativeEvent)), q || y.state.setIndices({
          activeIndex: null,
          selectedIndex: null,
          type: y.state.keyboardActiveRef.current ? "keyboard" : "pointer"
        })), V && y.state.activeIndex !== null && !q && y.state.setIndices({
          activeIndex: null,
          selectedIndex: null,
          type: y.state.keyboardActiveRef.current ? "keyboard" : "pointer"
        });
      },
      onKeyDown(L) {
        if (K || N || L.ctrlKey || L.shiftKey || L.altKey || L.metaKey)
          return;
        y.state.keyboardActiveRef.current = !0;
        const G = L.currentTarget, ie = G.scrollWidth - G.clientWidth, pe = S === "rtl";
        if (L.key === "Home") {
          Ot(L);
          const _e = Tf && pe ? G.value.length : 0;
          G.setSelectionRange(_e, _e), G.scrollLeft = 0;
          return;
        }
        if (L.key === "End") {
          Ot(L);
          const _e = Tf && pe ? 0 : G.value.length;
          G.setSelectionRange(_e, _e), G.scrollLeft = pe ? -ie : ie;
          return;
        }
        if (!_ && L.key === "Escape") {
          const _e = T === "multiple" && Array.isArray(A) ? A.length === 0 : A === null, ke = Pe(ar, L.nativeEvent), Se = T === "multiple" ? [] : null;
          y.state.setInputValue("", ke), y.state.setSelectedValue(Se, ke), !_e && !y.state.inline && !ke.isPropagationAllowed && L.stopPropagation();
          return;
        }
        if (h && L.key === "Backspace" && G.value === "" && h.highlightedChipIndex === void 0 && Array.isArray(A) && A.length > 0) {
          const _e = h.chipsRef.current.length, ke = _e > 0 ? _e - 1 : A.length - 1, Se = A.filter((Ie, Le) => Le !== ke);
          y.state.setIndices({
            activeIndex: null,
            selectedIndex: null,
            type: y.state.keyboardActiveRef.current ? "keyboard" : "pointer"
          }), y.state.setSelectedValue(Se, Pe(Et, L.nativeEvent));
          return;
        }
        const be = h?.highlightedChipIndex !== void 0, Re = $(L);
        if (h?.setHighlightedChipIndex(Re), Re !== void 0 ? h?.chipsRef.current[Re]?.focus() : be && y.state.inputRef.current?.focus(), L.which !== 229 && L.key === "Enter" && V) {
          const _e = y.state.activeIndex, ke = L.nativeEvent;
          if (_e === null) {
            if (B)
              return;
            y.state.setOpen(!1, Pe(Et, ke));
            return;
          }
          Ot(L);
          const Se = y.state.listRef.current[_e];
          Se && (y.state.selectionEventRef.current = ke, Se.click(), y.state.selectionEventRef.current = null);
        }
      },
      onPointerMove() {
        y.state.keyboardActiveRef.current = !1;
      },
      onPointerDown() {
        y.state.keyboardActiveRef.current = !1;
      }
    }, de],
    stateAttributesMapping: Wd
  });
  return /* @__PURE__ */ j(v.Fragment, {
    children: [V && Q && /* @__PURE__ */ x(jd, {
      ref: y.state.startDismissRef
    }), Z]
  });
});
process.env.NODE_ENV !== "production" && (Kd.displayName = "ComboboxInput");
function t2(t, e, n, o, r) {
  if (t.baseUIHandlerPrevented || o)
    return;
  const s = gt(t.nativeEvent), i = lt(s) ? s : null;
  i !== t.currentTarget && (r?.(i) || km(i)) || (t.preventDefault(), !n && (e.state.inputRef.current?.focus(), e.state.openOnInputClick && e.state.setOpen(!0, Pe(Em, t.nativeEvent))));
}
const qd = /* @__PURE__ */ v.forwardRef(function(e, n) {
  const {
    render: o,
    className: r,
    style: s,
    ...i
  } = e, {
    state: a
  } = Xt(), l = wn(), {
    filteredItems: c
  } = Bo(), u = fe(l, Ee.open), d = fe(l, Ee.mounted), f = fe(l, Ee.popupSide), p = fe(l, Ee.positionerElement), g = fe(l, Ee.disabled), m = fe(l, Ee.readOnly), h = fe(l, Ee.hasSelectedValue), b = fe(l, Ee.selectionMode), w = d && p ? f : null, y = g, C = c.length === 0, S = {
    ...a,
    open: u,
    disabled: y,
    readOnly: m,
    popupSide: w,
    listEmpty: C,
    placeholder: b === "none" ? !1 : !h
  }, E = ge((P) => {
    l.set("inputGroupElement", P);
  });
  return Te("div", e, {
    ref: [n, E],
    props: [{
      role: "group",
      onMouseDown(P) {
        t2(P, l, y, m, (N) => De(l.state.chipsContainerRef.current, N));
      }
    }, i],
    state: S,
    stateAttributesMapping: Wd
  });
});
process.env.NODE_ENV !== "production" && (qd.displayName = "ComboboxInputGroup");
const Li = 2, Xd = /* @__PURE__ */ v.forwardRef(function(e, n) {
  const {
    render: o,
    className: r,
    nativeButton: s = !0,
    disabled: i = !1,
    id: a,
    style: l,
    ...c
  } = e, {
    state: u,
    disabled: d,
    setTouched: f,
    setFocused: p,
    validationMode: g,
    validation: m
  } = Xt(), {
    labelId: h
  } = un(), b = wn(), {
    filteredItems: w
  } = Bo(), y = fe(b, Ee.selectionMode), C = fe(b, Ee.disabled), R = fe(b, Ee.readOnly), S = fe(b, Ee.required), E = fe(b, Ee.mounted), P = fe(b, Ee.popupSide), N = fe(b, Ee.positionerElement), I = fe(b, Ee.listElement), M = fe(b, Ee.triggerProps), T = fe(b, Ee.triggerElement), k = fe(b, Ee.inputInsidePopup), D = fe(b, Ee.id), O = fe(b, Ee.labelId), V = fe(b, Ee.open), _ = fe(b, Ee.selectedValue), A = fe(b, Ee.activeIndex), F = fe(b, Ee.selectedIndex), H = fe(b, Ee.hasSelectedValue), Y = Xa(), B = Bd(), U = Vt(), q = d || C || i, W = w.length === 0, K = E && N ? P : null;
  mr({
    id: k ? a : void 0
  });
  const te = k ? a ?? D : a, z = Wu(h, O), Q = v.useRef("");
  function ee(de) {
    Q.current = de.pointerType;
  }
  const ae = Y.useState("domReferenceElement");
  v.useEffect(() => {
    k && T && T !== ae && Y.set("domReferenceElement", T);
  }, [T, ae, Y, k]);
  const {
    reference: X
  } = mu(Y, {
    enabled: !V && !R && !C && y === "single",
    listRef: b.state.labelsRef,
    activeIndex: A,
    selectedIndex: F,
    onMatch(de) {
      const he = b.state.valuesRef.current[de];
      he !== void 0 && b.state.setSelectedValue(he, Pe("none"));
    }
  }), {
    reference: se
  } = lr(Y, {
    enabled: !R && !C,
    event: "mousedown"
  }), {
    buttonRef: ue,
    getButtonProps: re
  } = Ft({
    native: s,
    disabled: q
  }), ne = {
    ...u,
    open: V,
    disabled: q,
    popupSide: K,
    listEmpty: W,
    placeholder: y === "none" ? !1 : !H
  }, oe = ge((de) => {
    b.set("triggerElement", de);
  });
  return Te("button", e, {
    ref: [n, ue, oe],
    state: ne,
    props: [M, se, X, {
      id: te,
      tabIndex: k ? 0 : -1,
      role: k ? "combobox" : void 0,
      "aria-expanded": V ? "true" : "false",
      "aria-haspopup": k ? "dialog" : "listbox",
      "aria-controls": V ? I?.id : void 0,
      "aria-required": k && S || void 0,
      "aria-labelledby": z,
      onPointerDown: ee,
      onPointerEnter: ee,
      onFocus() {
        p(!0), !(q || R) && U.start(0, b.state.forceMount);
      },
      onBlur(de) {
        if (!De(N, de.relatedTarget) && (f(!0), p(!1), g === "onBlur")) {
          const he = y === "none" ? B : _;
          m.commit(he);
        }
      },
      onMouseDown(de) {
        if (q || R || (k || Y.set("domReferenceElement", de.currentTarget), b.state.forceMount(), Q.current !== "touch" && (b.state.inputRef.current?.focus(), k || de.preventDefault()), V))
          return;
        const he = Ke(de.currentTarget);
        function $(Z) {
          if (!T)
            return;
          const L = gt(Z), G = b.state.positionerElement, ie = b.state.listElement;
          if (De(T, L) || De(G, L) || De(ie, L) || L === T)
            return;
          const pe = Uu(T), be = Z.clientX >= pe.left - Li && Z.clientX <= pe.right + Li, Re = Z.clientY >= pe.top - Li && Z.clientY <= pe.bottom + Li;
          be && Re || b.state.setOpen(!1, Pe("cancel-open", Z));
        }
        k && he.addEventListener("mouseup", $, {
          once: !0
        });
      },
      onKeyDown(de) {
        q || R || (de.key === "ArrowDown" || de.key === "ArrowUp") && (Ot(de), b.state.setOpen(!0, Pe(Er, de.nativeEvent)), b.state.inputRef.current?.focus());
      }
    }, m ? m.getValidationProps(c) : c, re],
    stateAttributesMapping: Wd
  });
});
process.env.NODE_ENV !== "production" && (Xd.displayName = "ComboboxTrigger");
const Zd = /* @__PURE__ */ v.createContext(null);
process.env.NODE_ENV !== "production" && (Zd.displayName = "GroupCollectionContext");
function X9() {
  return v.useContext(Zd);
}
function Z9(t) {
  const {
    children: e,
    items: n
  } = t, o = v.useMemo(() => ({
    items: n
  }), [n]);
  return /* @__PURE__ */ x(Zd.Provider, {
    value: o,
    children: e
  });
}
function n2(t) {
  const {
    children: e
  } = t, {
    filteredItems: n
  } = Bo(), o = X9(), r = o ? o.items : n;
  return r ? /* @__PURE__ */ x(v.Fragment, {
    children: r.map(e)
  }) : null;
}
const Za = /* @__PURE__ */ v.forwardRef(function(e, n) {
  var o;
  const {
    render: r,
    className: s,
    style: i,
    children: a,
    ...l
  } = e, c = wn(), u = Xa(), d = !!Gd(!0), {
    filteredItems: f,
    hasItems: p
  } = Bo(), g = fe(c, Ee.selectionMode), m = fe(c, Ee.grid), h = fe(c, Ee.popupProps), b = fe(c, Ee.virtualized), w = g === "multiple", y = f.length === 0, C = ge((I) => {
    c.set("positionerElement", I);
  }), R = ge((I) => {
    c.set("listElement", I);
  }), S = v.useMemo(() => typeof a == "function" ? o || (o = /* @__PURE__ */ x(n2, {
    children: a
  })) : a, [a]), E = {
    empty: y
  }, P = u.useState("floatingId"), N = Te("div", e, {
    state: E,
    ref: [n, R, d ? null : C],
    props: [h, {
      children: S,
      tabIndex: -1,
      id: P,
      role: m ? "grid" : "listbox",
      "aria-multiselectable": w ? "true" : void 0,
      onKeyDown(I) {
        if (!(c.state.disabled || c.state.readOnly) && I.key === "Enter") {
          const M = c.state.activeIndex;
          if (M == null)
            return;
          Ot(I);
          const T = I.nativeEvent, k = c.state.listRef.current[M];
          k && (c.state.selectionEventRef.current = T, k.click(), c.state.selectionEventRef.current = null);
        }
      },
      onKeyDownCapture() {
        c.state.keyboardActiveRef.current = !0;
      },
      onPointerMoveCapture() {
        c.state.keyboardActiveRef.current = !1;
      }
    }, l]
  });
  return b ? N : /* @__PURE__ */ x(Gr, {
    elementsRef: c.state.listRef,
    labelsRef: p ? void 0 : c.state.labelsRef,
    children: N
  });
});
process.env.NODE_ENV !== "production" && (Za.displayName = "ComboboxList");
const Qd = /* @__PURE__ */ v.createContext(void 0);
process.env.NODE_ENV !== "production" && (Qd.displayName = "ComboboxPortalContext");
function Q9() {
  const t = v.useContext(Qd);
  if (t === void 0)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: <Combobox.Portal> is missing." : Xe(20));
  return t;
}
const Jd = /* @__PURE__ */ v.forwardRef(function(e, n) {
  const {
    keepMounted: o = !1,
    ...r
  } = e, s = wn(), i = fe(s, Ee.mounted), a = fe(s, Ee.forceMounted);
  return i || o || a ? /* @__PURE__ */ x(Qd.Provider, {
    value: o,
    children: /* @__PURE__ */ x($r, {
      ref: n,
      ...r
    })
  }) : null;
});
process.env.NODE_ENV !== "production" && (Jd.displayName = "ComboboxPortal");
const ef = /* @__PURE__ */ v.forwardRef(function(e, n) {
  const {
    render: o,
    className: r,
    anchor: s,
    positionMethod: i = "absolute",
    side: a = "bottom",
    align: l = "center",
    sideOffset: c = 0,
    alignOffset: u = 0,
    collisionBoundary: d = "clipping-ancestors",
    collisionPadding: f = 5,
    arrowPadding: p = 5,
    sticky: g = !1,
    disableAnchorTracking: m = !1,
    collisionAvoidance: h = Xc,
    style: b,
    ...w
  } = e, y = wn(), {
    filteredItems: C
  } = Bo(), R = Xa(), S = Q9(), E = fe(y, Ee.modal), P = fe(y, Ee.open), N = fe(y, Ee.mounted), I = fe(y, Ee.openMethod), M = fe(y, Ee.positionerElement), T = fe(y, Ee.triggerElement), k = fe(y, Ee.inputElement), D = fe(y, Ee.inputGroupElement), O = fe(y, Ee.inputInsidePopup), V = fe(y, Ee.transitionStatus), _ = C.length === 0, F = Hr({
    anchor: s ?? (O ? T : D ?? k),
    floatingRootContext: R,
    positionMethod: i,
    mounted: N,
    side: a,
    sideOffset: c,
    align: l,
    alignOffset: u,
    arrowPadding: p,
    collisionBoundary: d,
    collisionPadding: f,
    sticky: g,
    disableAnchorTracking: m,
    keepMounted: S,
    collisionAvoidance: h,
    lazyFlip: !0
  });
  Ha(P && E, I === "touch", M, T);
  const H = {
    open: P,
    side: F.side,
    align: F.align,
    anchorHidden: F.anchorHidden,
    empty: _
  };
  xe(() => {
    y.set("popupSide", F.side);
  }, [y, F.side]);
  const Y = ge((U) => {
    y.set("positionerElement", U);
  }), B = Br(e, H, {
    styles: F.positionerStyles,
    transitionStatus: V,
    props: w,
    refs: [n, Y],
    hidden: !N,
    inert: !P
  });
  return /* @__PURE__ */ j(Yd.Provider, {
    value: F,
    children: [N && E && /* @__PURE__ */ x(Wr, {
      inert: gr(!P),
      cutout: D ?? k ?? T
    }), B]
  });
});
process.env.NODE_ENV !== "production" && (ef.displayName = "ComboboxPositioner");
const J9 = {
  ...xn,
  ...Lt
}, tf = /* @__PURE__ */ v.forwardRef(function(e, n) {
  const {
    render: o,
    className: r,
    style: s,
    initialFocus: i,
    finalFocus: a,
    ...l
  } = e, c = wn(), u = Gd(), d = Xa(), {
    filteredItems: f
  } = Bo(), p = fe(c, Ee.mounted), g = fe(c, Ee.open), m = fe(c, Ee.openMethod), h = fe(c, Ee.transitionStatus), b = fe(c, Ee.inputInsidePopup), w = fe(c, Ee.inputElement), y = fe(c, Ee.modal), C = f.length === 0;
  Bt({
    open: g,
    ref: c.state.popupRef,
    onComplete() {
      g && c.state.onOpenChangeComplete(!0);
    }
  });
  const R = {
    open: g,
    side: u.side,
    align: u.align,
    anchorHidden: u.anchorHidden,
    transitionStatus: h,
    empty: C
  }, S = Te("div", e, {
    state: R,
    ref: [n, c.state.popupRef],
    props: [{
      role: b ? "dialog" : "presentation",
      tabIndex: -1,
      onFocus(M) {
        const T = gt(M.nativeEvent);
        m !== "touch" && (De(c.state.listElement, T) || T === M.currentTarget) && c.state.inputRef.current?.focus();
      }
    }, pr(h), l],
    stateAttributesMapping: J9
  }), P = i === void 0 ? b ? (M) => M === "touch" ? c.state.popupRef.current : w : !1 : i;
  let N;
  a != null ? N = a : N = b ? void 0 : !1;
  const I = !b || y;
  return /* @__PURE__ */ x(zr, {
    context: d,
    disabled: !p,
    modal: I,
    openInteractionType: m,
    initialFocus: P,
    returnFocus: N,
    getInsideElements: () => [c.state.startDismissRef.current, c.state.endDismissRef.current],
    children: /* @__PURE__ */ j(v.Fragment, {
      children: [S, I && /* @__PURE__ */ x(jd, {
        ref: c.state.endDismissRef
      })]
    })
  });
});
process.env.NODE_ENV !== "production" && (tf.displayName = "ComboboxPopup");
const nf = /* @__PURE__ */ v.createContext(void 0);
process.env.NODE_ENV !== "production" && (nf.displayName = "ComboboxGroupContext");
function eR() {
  const t = v.useContext(nf);
  if (t === void 0)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: ComboboxGroupContext is missing. ComboboxGroup parts must be placed within <Combobox.Group>." : Xe(18));
  return t;
}
const o2 = /* @__PURE__ */ v.forwardRef(function(e, n) {
  const {
    render: o,
    className: r,
    style: s,
    items: i,
    ...a
  } = e, [l, c] = v.useState(), u = v.useMemo(() => ({
    labelId: l,
    setLabelId: c,
    items: i
  }), [l, c, i]), d = Te("div", e, {
    ref: n,
    props: [{
      role: "group",
      "aria-labelledby": l
    }, a]
  }), f = /* @__PURE__ */ x(nf.Provider, {
    value: u,
    children: d
  });
  return i ? /* @__PURE__ */ x(Z9, {
    items: i,
    children: f
  }) : f;
});
process.env.NODE_ENV !== "production" && (o2.displayName = "ComboboxGroup");
const r2 = /* @__PURE__ */ v.forwardRef(function(e, n) {
  const {
    render: o,
    className: r,
    style: s,
    id: i,
    ...a
  } = e, {
    setLabelId: l
  } = eR(), c = St(i);
  return xe(() => (l(c), () => {
    l(void 0);
  }), [c, l]), Te("div", e, {
    ref: n,
    props: [{
      id: c
    }, a]
  });
});
process.env.NODE_ENV !== "production" && (r2.displayName = "ComboboxGroupLabel");
const s2 = /* @__PURE__ */ v.createContext(void 0);
process.env.NODE_ENV !== "production" && (s2.displayName = "ComboboxItemContext");
const of = /* @__PURE__ */ v.createContext(!1);
process.env.NODE_ENV !== "production" && (of.displayName = "ComboboxRowContext");
function tR() {
  return v.useContext(of);
}
const Qa = /* @__PURE__ */ v.memo(/* @__PURE__ */ v.forwardRef(function(e, n) {
  const {
    render: o,
    className: r,
    value: s = null,
    index: i,
    disabled: a = !1,
    nativeButton: l = !1,
    style: c,
    ...u
  } = e, d = v.useRef(!1), f = v.useRef(null), p = Ro({
    index: i,
    textRef: f,
    indexGuessBehavior: Xu.GuessFromOrder
  }), g = wn(), m = tR(), {
    flatFilteredItems: h,
    hasItems: b
  } = Bo(), w = fe(g, Ee.open), y = fe(g, Ee.selectionMode), C = fe(g, Ee.readOnly), R = fe(g, Ee.virtualized), S = fe(g, Ee.isItemEqualToValue), E = y !== "none", P = i ?? (R ? vo(h, s, S) : p.index), N = p.index !== -1, I = fe(g, Ee.id), M = fe(g, Ee.isActive, P), T = fe(g, Ee.isSelected, s), k = fe(g, Ee.getItemProps), D = v.useRef(null), O = I != null && N ? `${I}-${P}` : void 0, V = T && E;
  xe(() => {
    if (!(N && (R || i != null)))
      return;
    const K = g.state.listRef.current;
    return K[P] = D.current, () => {
      delete K[P];
    };
  }, [N, R, P, i, g]), xe(() => {
    if (!N || b)
      return;
    const W = g.state.valuesRef.current;
    return W[P] = s, y !== "none" && g.state.allValuesRef.current.push(s), () => {
      delete W[P];
    };
  }, [N, b, P, s, g, y]), xe(() => {
    if (!w) {
      d.current = !1;
      return;
    }
    if (!N || b)
      return;
    const W = g.state.selectedValue, K = Array.isArray(W) ? W[W.length - 1] : W;
    so(s, K, S) && g.set("selectedIndex", P);
  }, [N, b, w, g, P, s, S]);
  const _ = {
    disabled: a,
    selected: V,
    highlighted: M
  }, A = k({
    active: M,
    selected: V
  });
  A.id = void 0, A.onFocus = void 0;
  const {
    getButtonProps: F,
    buttonRef: H
  } = Ft({
    disabled: a,
    focusableWhenDisabled: !0,
    native: l,
    composite: !0
  });
  function Y(W) {
    function K() {
      g.state.handleSelection(W, s);
    }
    g.state.submitOnItemClick ? (tn.flushSync(K), g.state.requestSubmit()) : K();
  }
  const B = {
    id: O,
    role: m ? "gridcell" : "option",
    "aria-selected": E ? V : void 0,
    // Focusable items steal focus from the input upon mouseup.
    // Warn if the user renders a natively focusable element like `<button>`,
    // as it should be a `<div>` instead.
    tabIndex: void 0,
    onPointerDownCapture(W) {
      d.current = !0, W.preventDefault();
    },
    onMouseDown(W) {
      W.preventDefault();
    },
    onClick(W) {
      a || C || Y(W.nativeEvent);
    },
    onMouseUp(W) {
      const K = d.current;
      d.current = !1, !(a || C || W.button !== 0 || K || !M) && Y(W.nativeEvent);
    }
  }, U = Te("div", e, {
    ref: [H, n, p.ref, D],
    state: _,
    props: [A, B, u, F]
  }), q = v.useMemo(() => ({
    selected: V,
    textRef: f
  }), [V, f]);
  return /* @__PURE__ */ x(s2.Provider, {
    value: q,
    children: U
  });
}));
process.env.NODE_ENV !== "production" && (Qa.displayName = "ComboboxItem");
const i2 = /* @__PURE__ */ v.forwardRef(function(e, n) {
  const {
    render: o,
    className: r,
    style: s,
    ...i
  } = e, a = wn(), l = fe(a, Ee.open), c = fe(a, Ee.hasSelectionChips), [u, d] = v.useState(void 0);
  l && u !== void 0 && d(void 0);
  const f = v.useRef([]), p = Te("div", e, {
    ref: [n, a.state.chipsContainerRef],
    // NVDA enters browse mode instead of staying in focus mode when navigating with
    // arrow keys inside a container unless it has a toolbar role.
    props: [c ? {
      role: "toolbar"
    } : yt, {
      onMouseDown(m) {
        t2(m, a, a.state.disabled, a.state.readOnly);
      }
    }, i]
  }), g = v.useMemo(() => ({
    highlightedChipIndex: u,
    setHighlightedChipIndex: d,
    chipsRef: f
  }), [u, d, f]);
  return /* @__PURE__ */ x(Ud.Provider, {
    value: g,
    children: /* @__PURE__ */ x(Gr, {
      elementsRef: f,
      children: p
    })
  });
});
process.env.NODE_ENV !== "production" && (i2.displayName = "ComboboxChips");
const rf = /* @__PURE__ */ v.createContext(void 0);
process.env.NODE_ENV !== "production" && (rf.displayName = "ComboboxChipContext");
function nR() {
  const t = v.useContext(rf);
  if (!t)
    throw new Error(process.env.NODE_ENV !== "production" ? "useComboboxChipContext must be used within a ComboboxChip" : Xe(17));
  return t;
}
const a2 = /* @__PURE__ */ v.forwardRef(function(e, n) {
  const {
    render: o,
    className: r,
    style: s,
    ...i
  } = e, a = wn(), {
    setHighlightedChipIndex: l,
    chipsRef: c
  } = e2(), u = fe(a, Ee.disabled), d = fe(a, Ee.readOnly), f = fe(a, Ee.selectedValue), {
    ref: p,
    index: g
  } = Ro();
  function m(y) {
    let C = g;
    if (y.key === "ArrowLeft")
      y.preventDefault(), g > 0 ? C = g - 1 : C = void 0;
    else if (y.key === "ArrowRight")
      y.preventDefault(), g < c.current.length - 1 ? C = g + 1 : C = void 0;
    else if (y.key === "Backspace" || y.key === "Delete") {
      const R = g >= f.length - 1 ? f.length - 2 : g;
      C = R >= 0 ? R : void 0, Ot(y), a.state.setIndices({
        activeIndex: null,
        selectedIndex: null,
        type: "keyboard"
      }), a.state.setSelectedValue(f.filter((S, E) => E !== g), Pe(Et, y.nativeEvent));
    } else y.key === "Enter" || y.key === " " ? (Ot(y), C = void 0) : y.key === "ArrowDown" || y.key === "ArrowUp" ? (Ot(y), a.state.setOpen(!0, Pe(Er, y.nativeEvent)), C = void 0) : (
      // Check for printable characters (letters, numbers, symbols)
      y.key.length === 1 && !y.ctrlKey && !y.metaKey && !y.altKey && (C = void 0)
    );
    return C;
  }
  const b = Te("div", e, {
    ref: [n, p],
    state: {
      disabled: u
    },
    props: [{
      tabIndex: -1,
      "aria-disabled": u || void 0,
      "aria-readonly": d || void 0,
      onKeyDown(y) {
        if (u || d)
          return;
        const C = m(y);
        tn.flushSync(() => {
          l(C);
        }), C === void 0 ? a.state.inputRef.current?.focus() : c.current[C]?.focus();
      }
    }, i]
  }), w = v.useMemo(() => ({
    index: g
  }), [g]);
  return /* @__PURE__ */ x(rf.Provider, {
    value: w,
    children: b
  });
});
process.env.NODE_ENV !== "production" && (a2.displayName = "ComboboxChip");
const l2 = /* @__PURE__ */ v.forwardRef(function(e, n) {
  const {
    render: o,
    className: r,
    disabled: s = !1,
    nativeButton: i = !0,
    style: a,
    ...l
  } = e, c = wn(), {
    index: u
  } = nR(), d = fe(c, Ee.disabled), f = fe(c, Ee.readOnly), p = fe(c, Ee.selectedValue), g = fe(c, Ee.isItemEqualToValue), m = d || s, {
    buttonRef: h,
    getButtonProps: b
  } = Ft({
    native: i,
    disabled: m || f,
    focusableWhenDisabled: !0
  }), w = {
    disabled: m
  };
  function y(S) {
    const E = c.state.activeIndex;
    if (E == null)
      return;
    const P = vo(c.state.valuesRef.current, S, g);
    P !== -1 && E === P && c.state.setIndices({
      activeIndex: null,
      type: c.state.keyboardActiveRef.current ? "keyboard" : "pointer"
    });
  }
  function C(S) {
    const E = Pe(Oy, S.nativeEvent), P = p[u];
    return y(P), c.state.setSelectedValue(p.filter((N, I) => I !== u), E), c.state.inputRef.current?.focus(), E;
  }
  return Te("button", e, {
    ref: [n, h],
    state: w,
    props: [{
      tabIndex: -1,
      onMouseDown(S) {
        S.preventDefault();
      },
      onClick(S) {
        if (m || f)
          return;
        C(S).isPropagationAllowed || S.stopPropagation();
      },
      onKeyDown(S) {
        m || f || (S.key === "Enter" || S.key === " ") && (C(S).isPropagationAllowed || Ot(S));
      }
    }, l, b]
  });
});
process.env.NODE_ENV !== "production" && (l2.displayName = "ComboboxChipRemove");
const c2 = /* @__PURE__ */ v.forwardRef(function(e, n) {
  const {
    render: o,
    className: r,
    style: s,
    ...i
  } = e, a = Te("div", e, {
    ref: n,
    props: [{
      role: "row"
    }, i]
  });
  return /* @__PURE__ */ x(of.Provider, {
    value: !0,
    children: a
  });
});
process.env.NODE_ENV !== "production" && (c2.displayName = "ComboboxRow");
const oR = {
  ...Lt,
  ...fr
}, sf = /* @__PURE__ */ v.forwardRef(function(e, n) {
  const {
    render: o,
    className: r,
    disabled: s = !1,
    nativeButton: i = !0,
    keepMounted: a = !1,
    style: l,
    ...c
  } = e, {
    disabled: u
  } = Xt(), d = wn(), f = fe(d, Ee.selectionMode), p = fe(d, Ee.disabled), g = fe(d, Ee.readOnly), m = fe(d, Ee.open), h = fe(d, Ee.selectedValue), b = fe(d, Ee.hasSelectionChips), w = Bd();
  let y = !1;
  f === "none" ? y = w !== "" : f === "single" ? y = h != null : y = b;
  const C = u || p || s, {
    buttonRef: R,
    getButtonProps: S
  } = Ft({
    native: i,
    disabled: C
  }), {
    mounted: E,
    transitionStatus: P,
    setMounted: N
  } = Yn(y), I = {
    disabled: C,
    open: m,
    transitionStatus: P
  };
  Bt({
    open: y,
    ref: d.state.clearRef,
    onComplete() {
      y || N(!1);
    }
  });
  const M = Te("button", e, {
    state: I,
    ref: [n, R, d.state.clearRef],
    props: [{
      tabIndex: -1,
      children: "x",
      // Avoid stealing focus from the input.
      onMouseDown(k) {
        k.preventDefault();
      },
      onClick(k) {
        if (C || g)
          return;
        const D = d.state.keyboardActiveRef;
        d.state.setInputValue("", Pe(Of, k.nativeEvent)), f !== "none" ? (d.state.setSelectedValue(Array.isArray(h) ? [] : null, Pe(Of, k.nativeEvent)), d.state.setIndices({
          activeIndex: null,
          selectedIndex: null,
          type: D.current ? "keyboard" : "pointer"
        })) : d.state.setIndices({
          activeIndex: null,
          type: D.current ? "keyboard" : "pointer"
        }), d.state.inputRef.current?.focus();
      }
    }, c, S],
    stateAttributesMapping: oR
  });
  return a || E ? M : null;
});
process.env.NODE_ENV !== "production" && (sf.displayName = "ComboboxClear");
const rR = ye([
  "flex",
  "items-center",
  "gap-(--spacing-4)",
  "w-full",
  "rounded-(--radius-sm)",
  "border",
  "border-solid",
  "border-input-default-outline",
  "bg-input-default-background",
  "text-input-text-default",
  "transition-colors",
  "duration-200",
  "ease-in-out",
  "outline-none",
  "cursor-pointer",
  "[&_svg]:shrink-0",
  // Hover (only when not open)
  "[&:not([data-popup-open])]:hover:bg-input-hover-background",
  "[&:not([data-popup-open])]:hover:border-input-hover-outline",
  // Active/open
  "data-[popup-open]:border-input-active-outline",
  // Pressed
  "active:border-input-pressed-outline",
  // Focus ring (keyboard)
  "focus-visible:ring-2",
  "focus-visible:ring-input-focus-ring",
  "focus-visible:ring-offset-1"
], {
  variants: {
    size: {
      sm: ["h-(--spacing-32)", "px-(--spacing-10)", "py-(--spacing-6)"],
      md: ["h-(--spacing-40)", "px-(--spacing-10)", "py-(--spacing-10)"]
    }
  },
  defaultVariants: {
    size: "md"
  }
}), Dg = ["inline-flex", "items-center", "gap-(--spacing-4)", "h-(--spacing-24)", "bg-chip-neutral-container", "text-chip-neutral-label", "rounded-(--radius-sm)", "px-(--spacing-6)", "font-(family-name:--font-family-label)", "text-(length:--font-size-label-medium)", "leading-(--font-line-height-16)", "font-(number:--font-weight-medium)", "whitespace-nowrap", "overflow-hidden", "max-w-full"];
function _g(t, e) {
  return t.find((n) => n.value === e)?.label ?? e;
}
function WN(t) {
  const e = J.c(81), {
    options: n,
    value: o,
    onChange: r,
    defaultValue: s,
    placeholder: i,
    size: a,
    label: l,
    tooltip: c,
    required: u,
    description: d,
    error: f,
    disabled: p,
    name: g,
    reserveSubtextSpace: m
  } = t, h = a === void 0 ? "md" : a, b = m === void 0 ? !0 : m, w = !!f, C = b || w || !!d, R = o !== void 0;
  let S;
  e[0] !== s ? (S = s ?? [], e[0] = s, e[1] = S) : S = e[1];
  const [E, P] = Mt(S), N = R ? o : E;
  let I;
  e[2] !== N ? (I = {
    items: N
  }, e[2] = N, e[3] = I) : I = e[3];
  const {
    containerRef: M,
    measuringContainerRef: T,
    itemRefs: k,
    overflowRefs: D,
    visibleItems: O,
    overflowCount: V
  } = M1(I);
  let _;
  e[4] !== R || e[5] !== r ? (_ = function(me) {
    R || P(me), r?.(me);
  }, e[4] = R, e[5] = r, e[6] = _) : _ = e[6];
  const A = _;
  let F;
  e[7] !== l || e[8] !== u || e[9] !== c ? (F = l && /* @__PURE__ */ x(qr, { label: l, required: u, tooltip: c }), e[7] = l, e[8] = u, e[9] = c, e[10] = F) : F = e[10];
  let H;
  e[11] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (H = /* @__PURE__ */ x("div", {}), e[11] = H) : H = e[11];
  let Y;
  e[12] !== p || e[13] !== w || e[14] !== h ? (Y = le(rR({
    size: h
  }), p ? "opacity-50 cursor-not-allowed" : "cursor-pointer", w && ["border-input-error-outline", "[&:not([data-popup-open])]:hover:border-input-error-outline"]), e[12] = p, e[13] = w, e[14] = h, e[15] = Y) : Y = e[15];
  const B = u || void 0;
  let U;
  e[16] !== N.length || e[17] !== p || e[18] !== n || e[19] !== V || e[20] !== i || e[21] !== O ? (U = N.length === 0 ? /* @__PURE__ */ x("span", { className: "flex-1 min-w-0 text-left text-(length:--font-size-body-medium) leading-(--font-line-height-20) text-input-text-placeholder truncate", children: i }) : /* @__PURE__ */ j(_o, { children: [
    O.map((oe) => /* @__PURE__ */ j(a2, { className: le(Dg), children: [
      /* @__PURE__ */ x("span", { className: "min-w-0 flex-1 truncate", children: _g(n, oe) }),
      !p && /* @__PURE__ */ x(l2, { className: "inline-flex shrink-0 cursor-pointer items-center text-icon-secondary rounded-(--radius-xs) focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-1 focus-visible:ring-offset-surface focus-visible:ring-button-focus-ring", "aria-label": "Remove", onMouseDown: iR, children: /* @__PURE__ */ x(Ye, { name: "x-close", size: "xs", tone: "inherit" }) })
    ] }, oe)),
    V > 0 && /* @__PURE__ */ x(er, { label: `+${V}`, tone: "neutral" })
  ] }), e[16] = N.length, e[17] = p, e[18] = n, e[19] = V, e[20] = i, e[21] = O, e[22] = U) : U = e[22];
  let q;
  e[23] !== M || e[24] !== U ? (q = /* @__PURE__ */ x(i2, { ref: M, "data-multi-select-chips": "", className: "flex flex-1 min-w-0 items-center gap-(--spacing-4) cursor-[inherit]", children: U }), e[23] = M, e[24] = U, e[25] = q) : q = e[25];
  let W;
  e[26] !== p ? (W = !p && /* @__PURE__ */ x(sf, { className: "shrink-0 inline-flex items-center text-icon-secondary", "aria-label": "Clear all", onMouseDown: sR, children: /* @__PURE__ */ x(Ye, { name: "x-close", size: "xs", tone: "inherit" }) }), e[26] = p, e[27] = W) : W = e[27];
  let K;
  e[28] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (K = /* @__PURE__ */ x("span", { className: "shrink-0 text-input-text-default inline-flex transition-transform duration-200 [[data-popup-open]_&]:rotate-180 pointer-events-none", children: /* @__PURE__ */ x(Ye, { name: "chevron-down", size: "xs", tone: "inherit" }) }), e[28] = K) : K = e[28];
  let te;
  e[29] !== q || e[30] !== W || e[31] !== Y || e[32] !== B ? (te = /* @__PURE__ */ j(Xd, { render: H, nativeButton: !1, className: Y, "aria-required": B, children: [
    q,
    W,
    K
  ] }), e[29] = q, e[30] = W, e[31] = Y, e[32] = B, e[33] = te) : te = e[33];
  let z;
  e[34] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (z = Ua({
    size: "auto"
  }), e[34] = z) : z = e[34];
  let Q;
  if (e[35] !== N || e[36] !== n) {
    let oe;
    e[38] !== N ? (oe = (me) => {
      const de = N.includes(me.value);
      return /* @__PURE__ */ x(Qa, { value: me.value, disabled: me.disabled, className: or({}), children: /* @__PURE__ */ x(ba, { checked: de, checkbox: !0, children: me.label }) }, me.value);
    }, e[38] = N, e[39] = oe) : oe = e[39], Q = n.map(oe), e[35] = N, e[36] = n, e[37] = Q;
  } else
    Q = e[37];
  let ee;
  e[40] !== Q ? (ee = /* @__PURE__ */ x(Jd, { children: /* @__PURE__ */ x(ef, { sideOffset: 4, className: "w-(--anchor-width)", children: /* @__PURE__ */ x(tf, { className: z, children: /* @__PURE__ */ x(Za, { className: "flex flex-col outline-none", children: Q }) }) }) }), e[40] = Q, e[41] = ee) : ee = e[41];
  let ae;
  if (e[42] !== k || e[43] !== N || e[44] !== p || e[45] !== n) {
    let oe;
    e[47] !== k || e[48] !== p || e[49] !== n ? (oe = (me, de) => /* @__PURE__ */ x("span", { ref: (he) => {
      k.current[de] = he;
    }, "data-label": _g(n, me), "data-multi-select-measure": "chip", "data-multi-select-measure-index": de, className: le(Dg, "max-w-none before:content-[attr(data-label)]"), children: !p && /* @__PURE__ */ x("span", { className: "inline-flex shrink-0 items-center text-icon-secondary", children: /* @__PURE__ */ x(Ye, { name: "x-close", size: "xs", tone: "inherit" }) }) }, `chip-measure-${me}`), e[47] = k, e[48] = p, e[49] = n, e[50] = oe) : oe = e[50], ae = N.map(oe), e[42] = k, e[43] = N, e[44] = p, e[45] = n, e[46] = ae;
  } else
    ae = e[46];
  let X;
  if (e[51] !== N || e[52] !== D) {
    let oe;
    e[54] !== D ? (oe = (me, de) => {
      const he = de + 1;
      return /* @__PURE__ */ x("span", { ref: ($) => {
        D.current[he] = $;
      }, "data-label": `+${he}`, "data-multi-select-measure": "overflow", "data-multi-select-measure-count": he, className: "inline-flex items-center justify-center max-w-none gap-(--spacing-4) h-(--spacing-24) rounded-(--radius-sm) overflow-hidden font-(family-name:--font-family-label) text-(length:--font-size-label-medium) leading-(--font-line-height-16) font-(--font-weight-medium) whitespace-nowrap bg-chip-neutral-container text-chip-neutral-label px-(--spacing-6) py-(--spacing-4) before:content-[attr(data-label)]" }, `overflow-measure-${he}`);
    }, e[54] = D, e[55] = oe) : oe = e[55], X = N.slice(1).map(oe), e[51] = N, e[52] = D, e[53] = X;
  } else
    X = e[53];
  let se;
  e[56] !== T || e[57] !== ae || e[58] !== X ? (se = /* @__PURE__ */ x("div", { "aria-hidden": "true", className: "pointer-events-none invisible absolute left-0 top-0 h-0 overflow-hidden", children: /* @__PURE__ */ j("div", { ref: T, className: "inline-flex w-max items-center gap-(--spacing-4)", children: [
    ae,
    X
  ] }) }), e[56] = T, e[57] = ae, e[58] = X, e[59] = se) : se = e[59];
  let ue;
  e[60] !== N || e[61] !== p || e[62] !== A || e[63] !== g || e[64] !== u || e[65] !== te || e[66] !== ee || e[67] !== se ? (ue = /* @__PURE__ */ j(Jb, { multiple: !0, value: N, onValueChange: A, disabled: p, required: u, name: g, children: [
    te,
    ee,
    se
  ] }), e[60] = N, e[61] = p, e[62] = A, e[63] = g, e[64] = u, e[65] = te, e[66] = ee, e[67] = se, e[68] = ue) : ue = e[68];
  let re;
  e[69] !== d || e[70] !== f || e[71] !== w || e[72] !== b || e[73] !== C ? (re = C && /* @__PURE__ */ x("div", { "data-testid": "multi-select-subtext-row", className: le("mt-(--spacing-4)", b && "min-h-(--spacing-20)"), children: w ? /* @__PURE__ */ x(br, { match: !0, className: "text-(length:--font-size-label-small) leading-(--font-line-height-16) text-input-error-text", children: f }) : d ? /* @__PURE__ */ x(Yr, { className: "text-(length:--font-size-label-small) leading-(--font-line-height-16) text-input-text-supporting", children: d }) : null }), e[69] = d, e[70] = f, e[71] = w, e[72] = b, e[73] = C, e[74] = re) : re = e[74];
  let ne;
  return e[75] !== p || e[76] !== w || e[77] !== ue || e[78] !== re || e[79] !== F ? (ne = /* @__PURE__ */ j(hr, { invalid: w, disabled: p, className: "relative flex flex-col w-full", children: [
    F,
    ue,
    re
  ] }), e[75] = p, e[76] = w, e[77] = ue, e[78] = re, e[79] = F, e[80] = ne) : ne = e[80], ne;
}
function sR(t) {
  return t.stopPropagation();
}
function iR(t) {
  return t.stopPropagation();
}
const aR = ye([
  "flex",
  "items-center",
  "justify-between",
  "gap-(--spacing-4)",
  "w-full",
  "rounded-(--radius-sm)",
  "border",
  "border-solid",
  "border-input-default-outline",
  "bg-input-default-background",
  "text-input-text-default",
  "transition-colors",
  "duration-200",
  "ease-in-out",
  "outline-none",
  "cursor-pointer",
  "data-[disabled]:cursor-not-allowed",
  "[&_svg]:pointer-events-none",
  "[&_svg]:shrink-0",
  // Hover (only when not open)
  "[&:not([data-popup-open])]:hover:bg-input-hover-background",
  "[&:not([data-popup-open])]:hover:border-input-hover-outline",
  // Active/open
  "data-[popup-open]:border-input-active-outline",
  // Pressed
  "active:border-input-pressed-outline",
  // Focus ring (keyboard)
  "focus-visible:ring-2",
  "focus-visible:ring-input-focus-ring",
  "focus-visible:ring-offset-1"
], {
  variants: {
    size: {
      sm: ["h-(--spacing-32)", "px-(--spacing-10)", "py-(--spacing-6)"],
      md: ["h-(--spacing-40)", "px-(--spacing-10)", "py-(--spacing-10)"]
    }
  },
  defaultVariants: {
    size: "md"
  }
});
function lR(t) {
  const e = J.c(47), {
    id: n,
    options: o,
    value: r,
    onChange: s,
    defaultValue: i,
    placeholder: a,
    size: l,
    label: c,
    tooltip: u,
    required: d,
    description: f,
    error: p,
    disabled: g,
    reserveSubtextSpace: m,
    name: h,
    "data-testid": b
  } = t, w = l === void 0 ? "md" : l, y = m === void 0 ? !0 : m, C = !!p, S = y || C || !!f, E = r !== void 0, [P, N] = Mt(i ?? null), I = E ? r : P;
  let M;
  e[0] !== I || e[1] !== E || e[2] !== s || e[3] !== d ? (M = function(W, K) {
    const z = K.reason === "item-press" && !d && I !== null && W === I ? null : W;
    s?.(z, K), !E && !K.isCanceled && N(z);
  }, e[0] = I, e[1] = E, e[2] = s, e[3] = d, e[4] = M) : M = e[4];
  const T = M;
  let k;
  e[5] !== c || e[6] !== d || e[7] !== u ? (k = c && /* @__PURE__ */ x(qr, { label: c, required: d, tooltip: u }), e[5] = c, e[6] = d, e[7] = u, e[8] = k) : k = e[8];
  let D;
  e[9] !== g || e[10] !== C || e[11] !== w ? (D = le(aR({
    size: w
  }), g && "opacity-50", C && ["border-input-error-outline", "[&:not([data-popup-open])]:hover:border-input-error-outline"]), e[9] = g, e[10] = C, e[11] = w, e[12] = D) : D = e[12];
  const O = d || void 0;
  let V;
  e[13] !== a ? (V = /* @__PURE__ */ x(Gu, { placeholder: a, className: "flex-1 min-w-0 text-left text-(length:--font-size-body-medium) leading-(--font-line-height-20) truncate data-[placeholder]:text-input-text-placeholder" }), e[13] = a, e[14] = V) : V = e[14];
  let _;
  e[15] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (_ = /* @__PURE__ */ x(ju, { className: "shrink-0 text-input-text-default", children: /* @__PURE__ */ x(Jh, {}) }), e[15] = _) : _ = e[15];
  let A;
  e[16] !== b || e[17] !== n || e[18] !== D || e[19] !== O || e[20] !== V ? (A = /* @__PURE__ */ j(Yu, { id: n, "data-testid": b, className: D, "aria-required": O, children: [
    V,
    _
  ] }), e[16] = b, e[17] = n, e[18] = D, e[19] = O, e[20] = V, e[21] = A) : A = e[21];
  let F;
  e[22] !== o ? (F = o.map(cR), e[22] = o, e[23] = F) : F = e[23];
  let H;
  e[24] !== F ? (H = /* @__PURE__ */ x(Zh, { positionerClassName: "w-(--anchor-width)", children: F }), e[24] = F, e[25] = H) : H = e[25];
  let Y;
  e[26] !== I || e[27] !== g || e[28] !== T || e[29] !== h || e[30] !== o || e[31] !== d || e[32] !== H || e[33] !== A ? (Y = /* @__PURE__ */ j(lh, { value: I, onValueChange: T, disabled: g, required: d, name: h, items: o, children: [
    A,
    H
  ] }), e[26] = I, e[27] = g, e[28] = T, e[29] = h, e[30] = o, e[31] = d, e[32] = H, e[33] = A, e[34] = Y) : Y = e[34];
  let B;
  e[35] !== f || e[36] !== p || e[37] !== C || e[38] !== y || e[39] !== S ? (B = S && /* @__PURE__ */ x("div", { "data-testid": "select-subtext-row", className: le("mt-(--spacing-4)", y && "min-h-(--spacing-20)"), children: C ? /* @__PURE__ */ x(br, { match: !0, className: "text-(length:--font-size-label-small) leading-(--font-line-height-16) text-input-error-text", children: p }) : f ? /* @__PURE__ */ x(Yr, { className: "text-(length:--font-size-label-small) leading-(--font-line-height-16) text-input-text-supporting", children: f }) : null }), e[35] = f, e[36] = p, e[37] = C, e[38] = y, e[39] = S, e[40] = B) : B = e[40];
  let U;
  return e[41] !== g || e[42] !== C || e[43] !== Y || e[44] !== B || e[45] !== k ? (U = /* @__PURE__ */ j(hr, { invalid: C, disabled: g, className: "flex flex-col w-full", children: [
    k,
    Y,
    B
  ] }), e[41] = g, e[42] = C, e[43] = Y, e[44] = B, e[45] = k, e[46] = U) : U = e[46], U;
}
function cR(t) {
  return /* @__PURE__ */ x(Qh, { value: t.value, disabled: t.disabled, icon: t.icon, children: t.label }, t.value);
}
const uR = [10, 25, 50, 100];
function Ao(t, e) {
  return Number.isFinite(t) && t > 0 ? Math.floor(t) : e;
}
function Zr(t, e) {
  const n = Ao(e, 1), o = Ao(t, 1);
  return Math.min(Math.max(o, 1), n);
}
function u2(t, e) {
  const n = Ao(e, 1), o = Zr(t, n);
  return n === 1 ? "none" : o === 1 ? "right" : o === n ? "left" : "both";
}
function dR(t, e) {
  const n = Ao(e, 1), o = Zr(t, n);
  return n <= 4 ? Array.from({
    length: n
  }, (r, s) => ({
    type: "page",
    page: s + 1
  })) : o <= 3 ? [{
    type: "page",
    page: 1
  }, {
    type: "page",
    page: 2
  }, {
    type: "page",
    page: 3
  }, {
    type: "ellipsis",
    key: "end-ellipsis"
  }, {
    type: "page",
    page: n
  }] : o >= n - 2 ? [{
    type: "page",
    page: 1
  }, {
    type: "ellipsis",
    key: "start-ellipsis"
  }, {
    type: "page",
    page: n - 2
  }, {
    type: "page",
    page: n - 1
  }, {
    type: "page",
    page: n
  }] : [{
    type: "page",
    page: 1
  }, {
    type: "ellipsis",
    key: "start-ellipsis"
  }, {
    type: "page",
    page: o - 1
  }, {
    type: "page",
    page: o
  }, {
    type: "page",
    page: o + 1
  }, {
    type: "ellipsis",
    key: "end-ellipsis"
  }, {
    type: "page",
    page: n
  }];
}
function fR({
  currentPage: t,
  rowsPerPage: e,
  totalItems: n,
  totalPages: o
}) {
  const r = Math.max(0, Math.floor(n));
  if (r === 0)
    return "0 - 0 of 0";
  const s = Ao(e, r), i = Zr(t, o), a = (i - 1) * s + 1, l = Math.min(i * s, r);
  return `${a} - ${l} of ${r}`;
}
function pR(t, e) {
  return e ? `Page ${t}, current page` : `Go to page ${t}`;
}
function ya(t) {
  const e = J.c(11), {
    direction: n,
    disabled: o,
    mobile: r,
    onClick: s
  } = t, i = r === void 0 ? !1 : r, a = n === "previous", l = a ? "Previous page" : "Next page", c = i ? "size-[44px]" : "size-(--spacing-32)", u = o ? "cursor-default text-icon-disabled" : "cursor-pointer text-surface-on-surface hover:bg-surface-hover active:bg-surface-pressed";
  let d;
  e[0] !== c || e[1] !== u ? (d = le("inline-flex shrink-0 items-center justify-center rounded-(--radius-sm) border-0 bg-transparent p-0 outline-none transition-colors duration-200 ease-in-out", "focus-visible:ring-2 focus-visible:ring-button-focus-ring focus-visible:ring-offset-1 focus-visible:ring-offset-surface", c, u), e[0] = c, e[1] = u, e[2] = d) : d = e[2];
  const f = a ? "chevron-left" : "chevron-right";
  let p;
  e[3] !== f ? (p = /* @__PURE__ */ x(Ye, { name: f, size: "xs", tone: "inherit" }), e[3] = f, e[4] = p) : p = e[4];
  let g;
  return e[5] !== o || e[6] !== s || e[7] !== l || e[8] !== d || e[9] !== p ? (g = /* @__PURE__ */ x("button", { type: "button", "aria-label": l, disabled: o, onClick: s, className: d, children: p }), e[5] = o, e[6] = s, e[7] = l, e[8] = d, e[9] = p, e[10] = g) : g = e[10], g;
}
function Vg(t) {
  const e = J.c(26), {
    currentPage: n,
    totalPages: o,
    onPageChange: r,
    showPageIndicator: s
  } = t, i = s === void 0 ? !1 : s;
  let a, l, c;
  e[0] !== n || e[1] !== o ? (l = Ao(o, 1), a = Zr(n, l), c = u2(a, l), e[0] = n, e[1] = o, e[2] = a, e[3] = l, e[4] = c) : (a = e[2], l = e[3], c = e[4]);
  const u = c, d = u === "both" || u === "left", f = u === "both" || u === "right", p = !d;
  let g;
  e[5] !== r || e[6] !== a ? (g = () => r(a - 1), e[5] = r, e[6] = a, e[7] = g) : g = e[7];
  let m;
  e[8] !== p || e[9] !== g ? (m = /* @__PURE__ */ x(ya, { direction: "previous", disabled: p, onClick: g }), e[8] = p, e[9] = g, e[10] = m) : m = e[10];
  let h;
  e[11] !== r || e[12] !== a || e[13] !== l || e[14] !== i ? (h = i && /* @__PURE__ */ x(gR, { currentPage: a, totalPages: l, onPageChange: r }), e[11] = r, e[12] = a, e[13] = l, e[14] = i, e[15] = h) : h = e[15];
  const b = !f;
  let w;
  e[16] !== r || e[17] !== a ? (w = () => r(a + 1), e[16] = r, e[17] = a, e[18] = w) : w = e[18];
  let y;
  e[19] !== b || e[20] !== w ? (y = /* @__PURE__ */ x(ya, { direction: "next", disabled: b, onClick: w }), e[19] = b, e[20] = w, e[21] = y) : y = e[21];
  let C;
  return e[22] !== m || e[23] !== h || e[24] !== y ? (C = /* @__PURE__ */ j("div", { className: "flex items-center justify-center gap-(--spacing-12)", children: [
    m,
    h,
    y
  ] }), e[22] = m, e[23] = h, e[24] = y, e[25] = C) : C = e[25], C;
}
function gR(t) {
  const e = J.c(9), {
    currentPage: n,
    totalPages: o,
    onPageChange: r
  } = t;
  let s;
  if (e[0] !== n || e[1] !== r || e[2] !== o) {
    let a;
    e[4] !== n || e[5] !== r ? (a = (l) => {
      if (l.type === "ellipsis")
        return /* @__PURE__ */ x(mR, {}, l.key);
      const c = l.page === n;
      return /* @__PURE__ */ x("button", { type: "button", "aria-label": pR(l.page, c), "aria-current": c ? "page" : void 0, onClick: () => r(l.page), className: le("inline-flex min-w-(--spacing-20) items-center justify-center rounded-(--radius-sm) px-(--spacing-6) py-(--spacing-2)", "font-(family-name:--font-family-label) text-(length:--font-size-label-medium) font-(number:--font-weight-semibold) leading-(--font-line-height-16)", "outline-none focus-visible:ring-2 focus-visible:ring-button-focus-ring focus-visible:ring-offset-1 focus-visible:ring-offset-surface", c ? "bg-primary text-primary-on-primary" : "cursor-pointer text-text-subtle hover:bg-surface-hover active:bg-surface-pressed"), children: l.page }, l.page);
    }, e[4] = n, e[5] = r, e[6] = a) : a = e[6], s = dR(n, o).map(a), e[0] = n, e[1] = r, e[2] = o, e[3] = s;
  } else
    s = e[3];
  let i;
  return e[7] !== s ? (i = /* @__PURE__ */ x("div", { className: "flex items-center justify-center gap-(--spacing-10)", children: s }), e[7] = s, e[8] = i) : i = e[8], i;
}
function mR() {
  const t = J.c(1);
  let e;
  return t[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (e = /* @__PURE__ */ x("span", { className: "select-none whitespace-nowrap font-(family-name:--font-family-label) text-(length:--font-size-label-large) font-(number:--font-weight-semibold) leading-(--font-line-height-20) text-text-default", children: "..." }), t[0] = e) : e = t[0], e;
}
function hR(t) {
  const e = J.c(16), {
    selectId: n,
    rowsPerPage: o,
    rowsPerPageOptions: r,
    disabled: s,
    onRowsPerPageChange: i,
    onPageChange: a
  } = t, l = s === void 0 ? !1 : s;
  let c;
  e[0] !== n ? (c = /* @__PURE__ */ x("label", { htmlFor: n, className: "whitespace-nowrap font-(family-name:--font-family-label) text-(length:--font-size-label-medium) font-(number:--font-weight-semibold) leading-(--font-line-height-16) text-text-subtext", children: "Rows per page" }), e[0] = n, e[1] = c) : c = e[1];
  const u = String(o);
  let d;
  e[2] !== r ? (d = r.map(bR), e[2] = r, e[3] = d) : d = e[3];
  let f;
  e[4] !== a || e[5] !== i ? (f = (m) => {
    m != null && (i(Number(m)), a(1));
  }, e[4] = a, e[5] = i, e[6] = f) : f = e[6];
  let p;
  e[7] !== l || e[8] !== n || e[9] !== u || e[10] !== d || e[11] !== f ? (p = /* @__PURE__ */ x("div", { className: "h-(--spacing-32) w-(--spacing-80) shrink-0", children: /* @__PURE__ */ x(lR, { id: n, size: "sm", value: u, disabled: l, reserveSubtextSpace: !1, options: d, onChange: f }) }), e[7] = l, e[8] = n, e[9] = u, e[10] = d, e[11] = f, e[12] = p) : p = e[12];
  let g;
  return e[13] !== c || e[14] !== p ? (g = /* @__PURE__ */ j("div", { className: "flex h-(--spacing-40) w-[188px] shrink-0 items-center justify-between gap-(--spacing-12)", children: [
    c,
    p
  ] }), e[13] = c, e[14] = p, e[15] = g) : g = e[15], g;
}
function bR(t) {
  return {
    value: String(t),
    label: String(t)
  };
}
function vR(t) {
  const e = J.c(22), {
    rangeLabel: n,
    currentPage: o,
    totalPages: r,
    onPageChange: s
  } = t;
  let i, a;
  if (e[0] !== o || e[1] !== r) {
    const y = Ao(r, 1);
    i = Zr(o, y), a = u2(i, y), e[0] = o, e[1] = r, e[2] = i, e[3] = a;
  } else
    i = e[2], a = e[3];
  const l = a, c = l === "both" || l === "left", u = l === "both" || l === "right", d = !c;
  let f;
  e[4] !== s || e[5] !== i ? (f = () => s(i - 1), e[4] = s, e[5] = i, e[6] = f) : f = e[6];
  let p;
  e[7] !== d || e[8] !== f ? (p = /* @__PURE__ */ x(ya, { direction: "previous", mobile: !0, disabled: d, onClick: f }), e[7] = d, e[8] = f, e[9] = p) : p = e[9];
  let g;
  e[10] !== n ? (g = /* @__PURE__ */ x("span", { className: "min-w-0 truncate px-(--spacing-12) text-center font-(family-name:--font-family-label) text-(length:--font-size-label-medium) font-(number:--font-weight-semibold) leading-(--font-line-height-16) text-text-subtext", children: n }), e[10] = n, e[11] = g) : g = e[11];
  const m = !u;
  let h;
  e[12] !== s || e[13] !== i ? (h = () => s(i + 1), e[12] = s, e[13] = i, e[14] = h) : h = e[14];
  let b;
  e[15] !== m || e[16] !== h ? (b = /* @__PURE__ */ x(ya, { direction: "next", mobile: !0, disabled: m, onClick: h }), e[15] = m, e[16] = h, e[17] = b) : b = e[17];
  let w;
  return e[18] !== p || e[19] !== g || e[20] !== b ? (w = /* @__PURE__ */ j("div", { className: "flex h-[44px] w-full items-center justify-between px-(--spacing-16) sm:hidden", children: [
    p,
    g,
    b
  ] }), e[18] = p, e[19] = g, e[20] = b, e[21] = w) : w = e[21], w;
}
function yR(t) {
  const e = J.c(28), {
    currentPage: n,
    totalPages: o,
    totalItems: r,
    rowsPerPage: s,
    onPageChange: i
  } = t, a = bn();
  let l, c, u, d;
  e[0] !== n || e[1] !== s || e[2] !== r || e[3] !== o ? (u = Ao(o, 1), c = Zr(n, u), l = r <= 0, d = fR({
    currentPage: c,
    rowsPerPage: s,
    totalItems: r,
    totalPages: u
  }), e[0] = n, e[1] = s, e[2] = r, e[3] = o, e[4] = l, e[5] = c, e[6] = u, e[7] = d) : (l = e[4], c = e[5], u = e[6], d = e[7]);
  const f = d;
  let p;
  e[8] !== i || e[9] !== f || e[10] !== c || e[11] !== u ? (p = /* @__PURE__ */ x(vR, { rangeLabel: f, currentPage: c, totalPages: u, onPageChange: i }), e[8] = i, e[9] = f, e[10] = c, e[11] = u, e[12] = p) : p = e[12];
  let g;
  e[13] !== i || e[14] !== t.contextLabel || e[15] !== t.onRowsPerPageChange || e[16] !== t.rowsPerPageOptions || e[17] !== t.variant || e[18] !== f || e[19] !== s || e[20] !== l || e[21] !== a || e[22] !== c || e[23] !== u ? (g = t.variant === "simplified" ? /* @__PURE__ */ j("div", { className: "hidden h-[56px] w-full items-center justify-between px-(--spacing-24) sm:flex", children: [
    /* @__PURE__ */ x("span", { className: "min-w-0 flex-1 truncate font-(family-name:--font-family-label) text-(length:--font-size-label-large) font-(number:--font-weight-semibold) leading-(--font-line-height-20) text-text-subtext", children: t.contextLabel }),
    /* @__PURE__ */ x("div", { className: "flex flex-1 justify-center", children: /* @__PURE__ */ x(Vg, { currentPage: c, totalPages: u, onPageChange: i, showPageIndicator: !0 }) }),
    /* @__PURE__ */ x("div", { className: "h-(--spacing-40) flex-1" })
  ] }) : /* @__PURE__ */ j("div", { className: "hidden h-[56px] w-full items-center justify-between px-(--spacing-24) sm:flex", children: [
    /* @__PURE__ */ x("span", { className: "min-w-0 flex-1 truncate font-(family-name:--font-family-label) text-(length:--font-size-label-large) font-(number:--font-weight-semibold) leading-(--font-line-height-20) text-text-subtext", children: f }),
    /* @__PURE__ */ x("div", { className: "flex flex-1 justify-center", children: /* @__PURE__ */ x(Vg, { currentPage: c, totalPages: u, onPageChange: i, showPageIndicator: !0 }) }),
    /* @__PURE__ */ x("div", { className: "flex flex-1 justify-end", children: /* @__PURE__ */ x(hR, { selectId: a, rowsPerPage: s, rowsPerPageOptions: t.rowsPerPageOptions ?? uR, disabled: l, onRowsPerPageChange: t.onRowsPerPageChange, onPageChange: i }) })
  ] }), e[13] = i, e[14] = t.contextLabel, e[15] = t.onRowsPerPageChange, e[16] = t.rowsPerPageOptions, e[17] = t.variant, e[18] = f, e[19] = s, e[20] = l, e[21] = a, e[22] = c, e[23] = u, e[24] = g) : g = e[24];
  let m;
  return e[25] !== p || e[26] !== g ? (m = /* @__PURE__ */ j("nav", { "aria-label": "Table pagination", className: "w-full", children: [
    p,
    g
  ] }), e[25] = p, e[26] = g, e[27] = m) : m = e[27], m;
}
const Ag = /* @__PURE__ */ new Map();
function xR(t, e) {
  const n = JSON.stringify({
    locale: t,
    options: e
  }), o = Ag.get(n);
  if (o)
    return o;
  const r = new Intl.NumberFormat(t, e);
  return Ag.set(n, r), r;
}
function Fg(t, e, n) {
  return t == null ? "" : xR(e, n).format(t);
}
function wR(t, e, n) {
  return t == null ? "" : n ? Fg(t, e, n) : Fg(t / 100, e, {
    style: "percent"
  });
}
const af = /* @__PURE__ */ v.createContext(void 0);
process.env.NODE_ENV !== "production" && (af.displayName = "ProgressRootContext");
function d2() {
  const t = v.useContext(af);
  if (t === void 0)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: ProgressRootContext is missing. Progress parts must be placed within <Progress.Root>." : Xe(51));
  return t;
}
let Yl = /* @__PURE__ */ (function(t) {
  return t.complete = "data-complete", t.indeterminate = "data-indeterminate", t.progressing = "data-progressing", t;
})({});
const lf = {
  status(t) {
    return t === "progressing" ? {
      [Yl.progressing]: ""
    } : t === "complete" ? {
      [Yl.complete]: ""
    } : t === "indeterminate" ? {
      [Yl.indeterminate]: ""
    } : null;
  }
};
function CR(t, e) {
  return e == null ? "indeterminate progress" : t || `${e}%`;
}
const cf = /* @__PURE__ */ v.forwardRef(function(e, n) {
  const {
    format: o,
    getAriaValueText: r = CR,
    locale: s,
    max: i = 100,
    min: a = 0,
    value: l,
    render: c,
    className: u,
    children: d,
    style: f,
    ...p
  } = e, [g, m] = v.useState(), h = _t(o);
  let b = "indeterminate";
  Number.isFinite(l) && (b = l === i ? "complete" : "progressing");
  const w = wR(l, s, h.current), y = v.useMemo(() => ({
    status: b
  }), [b]), C = {
    "aria-labelledby": g,
    "aria-valuemax": i,
    "aria-valuemin": a,
    "aria-valuenow": l ?? void 0,
    "aria-valuetext": r(w, l),
    role: "progressbar",
    children: /* @__PURE__ */ j(v.Fragment, {
      children: [d, /* @__PURE__ */ x("span", {
        role: "presentation",
        style: $o,
        children: "x"
      })]
    })
  }, R = v.useMemo(() => ({
    formattedValue: w,
    max: i,
    min: a,
    setLabelId: m,
    state: y,
    status: b,
    value: l
  }), [w, i, a, m, y, b, l]), S = Te("div", e, {
    state: y,
    ref: n,
    props: [C, p],
    stateAttributesMapping: lf
  });
  return /* @__PURE__ */ x(af.Provider, {
    value: R,
    children: S
  });
});
process.env.NODE_ENV !== "production" && (cf.displayName = "ProgressRoot");
const f2 = /* @__PURE__ */ v.forwardRef(function(e, n) {
  const {
    render: o,
    className: r,
    style: s,
    ...i
  } = e, {
    state: a
  } = d2();
  return Te("div", e, {
    state: a,
    ref: n,
    props: i,
    stateAttributesMapping: lf
  });
});
process.env.NODE_ENV !== "production" && (f2.displayName = "ProgressTrack");
function SR(t, e, n) {
  return (t - e) * 100 / (n - e);
}
const p2 = /* @__PURE__ */ v.forwardRef(function(e, n) {
  const {
    render: o,
    className: r,
    style: s,
    ...i
  } = e, {
    max: a,
    min: l,
    value: c,
    state: u
  } = d2(), d = Number.isFinite(c) && c !== null ? SR(c, l, a) : null, f = v.useCallback(() => d == null ? {} : {
    insetInlineStart: 0,
    height: "inherit",
    width: `${d}%`
  }, [d]);
  return Te("div", e, {
    state: u,
    ref: n,
    props: [{
      style: f()
    }, i],
    stateAttributesMapping: lf
  });
});
process.env.NODE_ENV !== "production" && (p2.displayName = "ProgressIndicator");
const RR = {
  sm: "2px",
  md: "4px",
  lg: "8px"
}, ER = {
  brand: "bg-primary",
  positive: "bg-datavis-crit-green",
  warning: "bg-datavis-crit-yellow",
  negative: "bg-datavis-crit-red"
};
function UN(t) {
  const e = J.c(22);
  let n, o, r, s, i, a;
  e[0] !== t ? ({
    value: a,
    size: s,
    tone: i,
    "aria-label": n,
    "aria-labelledby": o,
    ...r
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r, e[4] = s, e[5] = i, e[6] = a) : (n = e[1], o = e[2], r = e[3], s = e[4], i = e[5], a = e[6]);
  const l = s === void 0 ? "md" : s, c = i === void 0 ? "brand" : i;
  let u;
  e[7] !== a ? (u = Number.isFinite(a) ? Math.min(100, Math.max(0, a)) : 0, e[7] = a, e[8] = u) : u = e[8];
  const d = u, f = RR[l];
  let p;
  e[9] !== f ? (p = {
    height: f
  }, e[9] = f, e[10] = p) : p = e[10];
  const g = `absolute ${ER[c]}`;
  let m;
  e[11] !== g ? (m = /* @__PURE__ */ x(p2, { className: g }), e[11] = g, e[12] = m) : m = e[12];
  let h;
  e[13] !== p || e[14] !== m ? (h = /* @__PURE__ */ x(f2, { className: "relative w-full overflow-hidden bg-[hsl(var(--surface-inverse-surface)/0.2)]", style: p, children: m }), e[13] = p, e[14] = m, e[15] = h) : h = e[15];
  let b;
  return e[16] !== n || e[17] !== o || e[18] !== d || e[19] !== r || e[20] !== h ? (b = /* @__PURE__ */ x(cf, { ...r, value: d, "aria-label": n, "aria-labelledby": o, children: h }), e[16] = n, e[17] = o, e[18] = d, e[19] = r, e[20] = h, e[21] = b) : b = e[21], b;
}
const PR = {
  sm: {
    diameter: 16,
    stroke: 3
  },
  md: {
    diameter: 36,
    stroke: 5
  },
  lg: {
    diameter: 56,
    stroke: 7
  }
}, NR = {
  brand: "stroke-primary",
  positive: "stroke-datavis-crit-green",
  warning: "stroke-datavis-crit-yellow",
  negative: "stroke-datavis-crit-red"
};
function YN(t) {
  const e = J.c(40);
  let n, o, r, s, i, a, l;
  e[0] !== t ? ({
    value: l,
    size: i,
    tone: a,
    "aria-label": n,
    "aria-labelledby": o,
    style: s,
    ...r
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r, e[4] = s, e[5] = i, e[6] = a, e[7] = l) : (n = e[1], o = e[2], r = e[3], s = e[4], i = e[5], a = e[6], l = e[7]);
  const c = i === void 0 ? "md" : i, u = a === void 0 ? "brand" : a;
  let d;
  e[8] !== l ? (d = Number.isFinite(l) ? Math.min(100, Math.max(0, l)) : 0, e[8] = l, e[9] = d) : d = e[9];
  const f = d, {
    diameter: p,
    stroke: g
  } = PR[c], m = (p - g) / 2, h = 2 * Math.PI * m, b = h * (1 - f / 100), w = p / 2;
  let y;
  e[10] !== p ? (y = {
    display: "inline-flex",
    width: p,
    height: p
  }, e[10] = p, e[11] = y) : y = e[11];
  const C = y;
  let R;
  e[12] !== C || e[13] !== s ? (R = typeof s == "function" ? (V) => ({
    ...s(V),
    ...C
  }) : {
    ...s,
    ...C
  }, e[12] = C, e[13] = s, e[14] = R) : R = e[14];
  const S = R, E = `0 0 ${p} ${p}`;
  let P;
  e[15] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (P = {
    stroke: "hsl(var(--surface-inverse-surface) / 0.2)"
  }, e[15] = P) : P = e[15];
  let N;
  e[16] !== w || e[17] !== m || e[18] !== g ? (N = /* @__PURE__ */ x("circle", { cx: w, cy: w, r: m, strokeWidth: g, strokeLinecap: "butt", style: P }), e[16] = w, e[17] = m, e[18] = g, e[19] = N) : N = e[19];
  const I = `${h} ${h}`, M = NR[u];
  let T;
  e[20] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (T = {
    transform: "rotate(-90deg)",
    transformOrigin: "50% 50%"
  }, e[20] = T) : T = e[20];
  let k;
  e[21] !== w || e[22] !== b || e[23] !== m || e[24] !== g || e[25] !== M || e[26] !== I ? (k = /* @__PURE__ */ x("circle", { cx: w, cy: w, r: m, strokeWidth: g, strokeLinecap: "butt", strokeDasharray: I, strokeDashoffset: b, className: M, style: T }), e[21] = w, e[22] = b, e[23] = m, e[24] = g, e[25] = M, e[26] = I, e[27] = k) : k = e[27];
  let D;
  e[28] !== p || e[29] !== k || e[30] !== E || e[31] !== N ? (D = /* @__PURE__ */ j("svg", { width: p, height: p, viewBox: E, fill: "none", "aria-hidden": "true", children: [
    N,
    k
  ] }), e[28] = p, e[29] = k, e[30] = E, e[31] = N, e[32] = D) : D = e[32];
  let O;
  return e[33] !== n || e[34] !== o || e[35] !== f || e[36] !== r || e[37] !== S || e[38] !== D ? (O = /* @__PURE__ */ x(cf, { ...r, value: f, "aria-label": n, "aria-labelledby": o, style: S, children: D }), e[33] = n, e[34] = o, e[35] = f, e[36] = r, e[37] = S, e[38] = D, e[39] = O) : O = e[39], O;
}
let Lg = /* @__PURE__ */ (function(t) {
  return t.checked = "data-checked", t.unchecked = "data-unchecked", t.disabled = "data-disabled", t.readonly = "data-readonly", t.required = "data-required", t.valid = "data-valid", t.invalid = "data-invalid", t.touched = "data-touched", t.dirty = "data-dirty", t.filled = "data-filled", t.focused = "data-focused", t;
})({});
const Rc = {
  checked(t) {
    return t ? {
      [Lg.checked]: ""
    } : {
      [Lg.unchecked]: ""
    };
  },
  ...Lt,
  ...jn
}, uf = /* @__PURE__ */ v.createContext(void 0);
process.env.NODE_ENV !== "production" && (uf.displayName = "RadioGroupContext");
function IR() {
  return v.useContext(uf);
}
const df = /* @__PURE__ */ v.createContext(void 0);
process.env.NODE_ENV !== "production" && (df.displayName = "RadioRootContext");
function MR() {
  const t = v.useContext(df);
  if (t === void 0)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: RadioRootContext is missing. Radio parts must be placed within <Radio.Root>." : Xe(52));
  return t;
}
const g2 = /* @__PURE__ */ v.forwardRef(function(e, n) {
  const {
    render: o,
    className: r,
    disabled: s = !1,
    readOnly: i = !1,
    required: a = !1,
    "aria-labelledby": l,
    value: c,
    inputRef: u,
    nativeButton: d = !1,
    id: f,
    style: p,
    ...g
  } = e, m = IR(), {
    disabled: h,
    readOnly: b,
    required: w,
    form: y,
    checkedValue: C,
    touched: R = !1,
    validation: S,
    name: E
  } = m ?? {}, P = m?.setCheckedValue ?? ht, N = m?.setTouched ?? ht, I = m?.registerControlRef ?? ht, M = m?.registerInputRef ?? ht, {
    setDirty: T,
    validityData: k,
    setTouched: D,
    setFilled: O,
    state: V,
    disabled: _
  } = Xt(), A = H1(), {
    labelId: F,
    getDescriptionProps: H
  } = un(), Y = _ || A.disabled || h || s, B = b || i, U = w || a, q = y, W = m ? C === c : c === "", K = v.useMemo(() => ga(c), [c]), te = v.useRef(null), z = v.useRef(null), Q = ge((ie) => {
    ie && I(ie, Y);
  }), ee = ln(u, z, M);
  xe(() => {
    z.current?.checked && O(!0);
  }, [O]), xe(() => {
    if (z.current) {
      if (Y && W) {
        M(null);
        return;
      }
      te.current && I(te.current, Y), M(z.current);
    }
  }, [W, Y, I, M]);
  const ae = St(), X = mr({
    id: f,
    implicit: !1,
    controlRef: te
  }), se = d ? void 0 : X, ue = Mu(l, F, z, !d, se), re = {
    role: "radio",
    "aria-checked": W,
    "aria-required": U || void 0,
    "aria-readonly": B || void 0,
    "aria-labelledby": ue,
    [_d]: W ? "" : void 0,
    id: d ? X : ae,
    onKeyDown(ie) {
      ie.key === "Enter" && ie.preventDefault();
    },
    onClick(ie) {
      ie.defaultPrevented || Y || B || (ie.preventDefault(), z.current?.dispatchEvent(new PointerEvent("click", {
        bubbles: !0,
        shiftKey: ie.shiftKey,
        ctrlKey: ie.ctrlKey,
        altKey: ie.altKey,
        metaKey: ie.metaKey
      })));
    },
    onFocus(ie) {
      ie.defaultPrevented || Y || B || !R || (z.current?.click(), N(!1));
    }
  }, {
    getButtonProps: ne,
    buttonRef: oe
  } = Ft({
    disabled: Y,
    native: d
  }), me = {
    type: "radio",
    ref: ee,
    form: q,
    id: se,
    name: E,
    tabIndex: -1,
    style: E ? Lr : $o,
    "aria-hidden": !0,
    ...c !== void 0 ? {
      value: K
    } : yt,
    disabled: Y,
    checked: W,
    required: U,
    readOnly: B,
    onChange(ie) {
      if (ie.nativeEvent.defaultPrevented || Y || B || c === void 0)
        return;
      const pe = Pe(Et, ie.nativeEvent);
      pe.isCanceled || (D(!0), T(c !== k.initialValue), O(!0), P(c, pe));
    },
    onFocus() {
      te.current?.focus();
    }
  }, de = v.useMemo(() => ({
    ...V,
    required: U,
    disabled: Y,
    readOnly: B,
    checked: W
  }), [V, Y, B, W, U]), he = de, $ = m !== void 0, Z = [n, te, oe, Q], L = [re, H, S?.getValidationProps ?? yt, g, ne], G = Te("span", e, {
    enabled: !$,
    state: de,
    ref: Z,
    props: L,
    stateAttributesMapping: Rc
  });
  return /* @__PURE__ */ j(df.Provider, {
    value: he,
    children: [$ ? /* @__PURE__ */ x(Md, {
      tag: "span",
      render: o,
      className: r,
      style: p,
      state: de,
      refs: Z,
      props: L,
      stateAttributesMapping: Rc
    }) : G, /* @__PURE__ */ x("input", {
      ...me,
      suppressHydrationWarning: !0
    })]
  });
});
process.env.NODE_ENV !== "production" && (g2.displayName = "RadioRoot");
const m2 = /* @__PURE__ */ v.forwardRef(function(e, n) {
  const {
    render: o,
    className: r,
    style: s,
    keepMounted: i = !1,
    ...a
  } = e, l = MR(), c = l.checked, {
    mounted: u,
    transitionStatus: d,
    setMounted: f
  } = Yn(c), p = {
    ...l,
    transitionStatus: d
  }, g = v.useRef(null), m = i || u, h = Te("span", e, {
    ref: [n, g],
    state: p,
    props: a,
    stateAttributesMapping: Rc
  });
  return Bt({
    open: c,
    ref: g,
    onComplete() {
      c || f(!1);
    }
  }), m ? h : null;
});
process.env.NODE_ENV !== "production" && (m2.displayName = "RadioIndicator");
const TR = [E1], h2 = /* @__PURE__ */ v.forwardRef(function(e, n) {
  const {
    render: o,
    className: r,
    disabled: s,
    readOnly: i,
    required: a,
    onValueChange: l,
    value: c,
    defaultValue: u,
    form: d,
    name: f,
    inputRef: p,
    id: g,
    style: m,
    ...h
  } = e, {
    setTouched: b,
    setFocused: w,
    shouldValidateOnChange: y,
    validationMode: C,
    name: R,
    disabled: S,
    state: E,
    validation: P,
    setDirty: N,
    setFilled: I,
    validityData: M
  } = Xt(), {
    labelId: T
  } = un(), {
    clearErrors: k
  } = Co(), D = j1(!0), O = S || s, V = R ?? f, _ = St(g), [A, F] = sn({
    controlled: c,
    default: u,
    name: "RadioGroup",
    state: "value"
  }), H = ge(l), Y = ge((re, ne) => {
    H(re, ne), !ne.isCanceled && F(re);
  }), B = v.useRef(null), U = v.useRef(null), q = v.useRef(null);
  function W(re) {
    let ne;
    return p && (typeof p == "function" ? ne = p(re) : p.current = re), U.current = re, P.inputRef.current = re, ne;
  }
  const K = ge((re, ne = !1) => {
    if (re) {
      if (ne) {
        B.current === re && (B.current = null);
        return;
      }
      B.current == null && (B.current = re);
    }
  }), te = ge((re) => {
    if (!re || re.disabled)
      return;
    q.current || (q.current = re);
    const ne = U.current;
    if (re.checked || ne == null || ne.disabled)
      return W(re);
  }), z = ge(() => A ?? null);
  Ur(B, {
    id: _,
    value: A,
    getValue: z
  }), po(A, () => {
    k(V), N(A !== M.initialValue), I(A != null), y() ? P.commit(A) : P.commit(A, !0);
    const re = q.current;
    A == null && re && !re.disabled && W(re);
  });
  const [Q, ee] = v.useState(!1), ae = h["aria-labelledby"] ?? T ?? D?.legendId, X = {
    ...E,
    disabled: O ?? !1,
    required: a ?? !1,
    readOnly: i ?? !1
  }, se = v.useMemo(() => ({
    ...E,
    checkedValue: A,
    disabled: O,
    form: d,
    validation: P,
    name: V,
    onValueChange: H,
    readOnly: i,
    registerControlRef: K,
    registerInputRef: te,
    required: a,
    setCheckedValue: Y,
    setTouched: ee,
    touched: Q
  }), [A, O, d, P, E, V, H, i, K, te, a, Y, ee, Q]), ue = {
    role: "radiogroup",
    "aria-required": a || void 0,
    "aria-disabled": O || void 0,
    "aria-readonly": i || void 0,
    "aria-labelledby": ae,
    onFocus() {
      w(!0);
    },
    onBlur(re) {
      De(re.currentTarget, re.relatedTarget) || (b(!0), w(!1), C === "onBlur" && P.commit(A));
    },
    onKeyDownCapture(re) {
      re.key.startsWith("Arrow") && (b(!0), ee(!0), w(!0));
    }
  };
  return /* @__PURE__ */ x(uf.Provider, {
    value: se,
    children: /* @__PURE__ */ x(Bb, {
      render: o,
      className: r,
      style: m,
      state: X,
      props: [ue, P.getValidationProps, h],
      refs: [n],
      stateAttributesMapping: jn,
      enableHomeAndEndKeys: !1,
      modifierKeys: TR
    })
  });
});
process.env.NODE_ENV !== "production" && (h2.displayName = "RadioGroup");
function kR() {
  const t = J.c(1);
  let e;
  return t[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (e = /* @__PURE__ */ x("svg", { viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", "aria-hidden": "true", focusable: "false", className: "w-full h-full", children: /* @__PURE__ */ x("path", { d: "M15 8C15 4.13438 11.8656 1 8 1C4.13438 1 1 4.13438 1 8C1 11.8656 4.13438 15 8 15C11.8656 15 15 11.8656 15 8ZM0 8C0 3.58125 3.58125 0 8 0C12.4187 0 16 3.58125 16 8C16 12.4187 12.4187 16 8 16C3.58125 16 0 12.4187 0 8Z", fill: "currentColor" }) }), t[0] = e) : e = t[0], e;
}
function OR() {
  const t = J.c(1);
  let e;
  return t[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (e = /* @__PURE__ */ x("svg", { viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", "aria-hidden": "true", focusable: "false", className: "w-full h-full", children: /* @__PURE__ */ x("path", { d: "M8 16C3.58125 16 0 12.4187 0 8C0 3.58125 3.58125 0 8 0C12.4187 0 16 3.58125 16 8C16 12.4187 12.4187 16 8 16ZM8 1.5C4.40937 1.5 1.5 4.40937 1.5 8C1.5 11.5906 4.40937 14.5 8 14.5C11.5906 14.5 14.5 11.5906 14.5 8C14.5 4.40937 11.5906 1.5 8 1.5ZM8 11C6.34375 11 5 9.65625 5 8C5 6.34375 6.34375 5 8 5C9.65625 5 11 6.34375 11 8C11 9.65625 9.65625 11 8 11Z", fill: "currentColor" }) }), t[0] = e) : e = t[0], e;
}
const b2 = xa({}), DR = ye([
  "relative",
  "shrink-0",
  "inline-flex",
  "items-center",
  "justify-center",
  "rounded-full",
  "group",
  // disabled
  "data-[disabled]:pointer-events-none",
  // focus
  "focus-visible:outline-none",
  "focus-visible:ring-[1.5px]",
  "focus-visible:ring-radio-focus-ring",
  "cursor-[inherit]",
  // coarse touch target
  "[@media(pointer:coarse)]:before:content-['']",
  "[@media(pointer:coarse)]:before:absolute"
], {
  variants: {
    size: {
      sm: ["w-(--icon-sm)", "h-(--icon-sm)", "[@media(pointer:coarse)]:before:inset-[-12px]"],
      md: ["w-(--icon-md)", "h-(--icon-md)", "[@media(pointer:coarse)]:before:inset-[-10px]"]
    }
  },
  defaultVariants: {
    size: "sm"
  }
}), _R = ye(["absolute", "inset-0", "rounded-full", "flex", "items-center", "justify-center", "[[data-checked]_&]:hidden", "group-hover:bg-radio-outline-hover-background", "group-active:bg-radio-outline-pressed-background"]), VR = ye(["flex", "items-center", "justify-center", "text-radio-outline-default-border", "group-hover:text-radio-outline-hover-border", "group-active:text-radio-outline-pressed-border", "[[data-disabled]_&]:text-radio-outline-disabled-border", "[[data-error]_&]:text-error"], {
  variants: {
    size: {
      sm: ["w-[calc(var(--icon-sm)*0.8)]", "h-[calc(var(--icon-sm)*0.8)]"],
      md: ["w-[calc(var(--icon-md)*0.8)]", "h-[calc(var(--icon-md)*0.8)]"]
    }
  },
  defaultVariants: {
    size: "sm"
  }
}), AR = ye(["flex", "items-center", "justify-center", "text-radio-filled-default-background", "group-hover:text-radio-filled-hover-background", "group-active:text-radio-filled-pressed-background", "[[data-disabled]_&]:text-radio-filled-disabled-background", "[[data-error]_&]:text-error"], {
  variants: {
    size: {
      sm: ["w-[calc(var(--icon-sm)*0.8)]", "h-[calc(var(--icon-sm)*0.8)]"],
      md: ["w-[calc(var(--icon-md)*0.8)]", "h-[calc(var(--icon-md)*0.8)]"]
    }
  },
  defaultVariants: {
    size: "sm"
  }
}), v2 = ye(["text-text-default", "font-(family-name:--font-family-label)", "font-(number:--font-weight-medium)", "text-(length:--font-size-label-large)", "leading-(--font-line-height-20)", "tracking-(--font-letter-spacing-default)"]), FR = ye(["text-text-subtext", "font-(family-name:--font-family-body)", "font-(number:--font-weight-regular)", "text-(length:--font-size-body-medium)", "leading-(--font-line-height-20)", "tracking-(--font-letter-spacing-default)"]), LR = ye(["flex", "flex-col", "gap-(--spacing-8)"], {
  variants: {
    disabled: {
      true: ["cursor-not-allowed"],
      false: ["cursor-pointer"]
    }
  },
  defaultVariants: {
    disabled: !1
  }
}), $R = ye([], {
  variants: {
    size: {
      sm: ["pl-[calc(var(--icon-sm)+var(--spacing-8))]"],
      md: ["pl-[calc(var(--icon-md)+var(--spacing-8))]"]
    }
  },
  defaultVariants: {
    size: "sm"
  }
});
function GN(t) {
  const e = J.c(28);
  let n, o, r, s, i, a;
  e[0] !== t ? ({
    label: s,
    error: r,
    disabled: o,
    size: a,
    children: n,
    ...i
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r, e[4] = s, e[5] = i, e[6] = a) : (n = e[1], o = e[2], r = e[3], s = e[4], i = e[5], a = e[6]);
  const l = a === void 0 ? "sm" : a, c = bn();
  let u;
  e[7] !== o || e[8] !== r || e[9] !== l ? (u = {
    error: r,
    disabled: o,
    size: l
  }, e[7] = o, e[8] = r, e[9] = l, e[10] = u) : u = e[10];
  let d;
  e[11] !== c || e[12] !== s ? (d = s && /* @__PURE__ */ x("span", { id: `${c}-label`, className: v2(), children: s }), e[11] = c, e[12] = s, e[13] = d) : d = e[13];
  const f = s ? `${c}-label` : i["aria-labelledby"], p = i["aria-label"], g = r || void 0, m = o || void 0;
  let h;
  e[14] !== n || e[15] !== o || e[16] !== i || e[17] !== f || e[18] !== p || e[19] !== g || e[20] !== m ? (h = /* @__PURE__ */ x(h2, { ...i, disabled: o, "aria-labelledby": f, "aria-label": p, "aria-invalid": g, "aria-disabled": m, className: "flex flex-col gap-(--spacing-8)", children: n }), e[14] = n, e[15] = o, e[16] = i, e[17] = f, e[18] = p, e[19] = g, e[20] = m, e[21] = h) : h = e[21];
  let b;
  e[22] !== d || e[23] !== h ? (b = /* @__PURE__ */ j("div", { className: "flex flex-col gap-(--spacing-8)", children: [
    d,
    h
  ] }), e[22] = d, e[23] = h, e[24] = b) : b = e[24];
  let w;
  return e[25] !== u || e[26] !== b ? (w = /* @__PURE__ */ x(b2, { value: u, children: b }), e[25] = u, e[26] = b, e[27] = w) : w = e[27], w;
}
function jN(t) {
  const e = J.c(53);
  let n, o, r, s;
  e[0] !== t ? ({
    label: r,
    description: n,
    disabled: o,
    ...s
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r, e[4] = s) : (n = e[1], o = e[2], r = e[3], s = e[4]);
  const {
    error: i,
    disabled: a,
    size: l
  } = Jg(b2), c = a || o, u = bn();
  let d;
  e[5] !== n || e[6] !== u || e[7] !== s ? (d = [s["aria-describedby"], n ? `${u}-description` : void 0].filter(Boolean).join(" ") || void 0, e[5] = n, e[6] = u, e[7] = s, e[8] = d) : d = e[8];
  const f = d;
  let p;
  e[9] !== c ? (p = LR({
    disabled: c
  }), e[9] = c, e[10] = p) : p = e[10];
  const g = r ? void 0 : s["aria-label"], m = r ? `${u}-label` : void 0, h = i ? "" : void 0;
  let b;
  e[11] !== s ? (b = (O) => {
    s.onKeyDown?.(O), !O.defaultPrevented && O.key === " " && (O.preventDefault(), O.currentTarget.click());
  }, e[11] = s, e[12] = b) : b = e[12];
  let w;
  e[13] !== l ? (w = le(DR({
    size: l
  })), e[13] = l, e[14] = w) : w = e[14];
  let y;
  e[15] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (y = _R(), e[15] = y) : y = e[15];
  let C;
  e[16] !== l ? (C = VR({
    size: l
  }), e[16] = l, e[17] = C) : C = e[17];
  let R;
  e[18] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (R = /* @__PURE__ */ x(kR, {}), e[18] = R) : R = e[18];
  let S;
  e[19] !== C ? (S = /* @__PURE__ */ x("span", { className: y, children: /* @__PURE__ */ x("span", { className: C, children: R }) }), e[19] = C, e[20] = S) : S = e[20];
  let E;
  e[21] !== l ? (E = AR({
    size: l
  }), e[21] = l, e[22] = E) : E = e[22];
  let P;
  e[23] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (P = /* @__PURE__ */ x(OR, {}), e[23] = P) : P = e[23];
  let N;
  e[24] !== E ? (N = /* @__PURE__ */ x(m2, { className: E, children: P }), e[24] = E, e[25] = N) : N = e[25];
  let I;
  e[26] !== f || e[27] !== c || e[28] !== s || e[29] !== S || e[30] !== N || e[31] !== g || e[32] !== m || e[33] !== h || e[34] !== b || e[35] !== w ? (I = /* @__PURE__ */ j(g2, { ...s, disabled: c, "aria-label": g, "aria-labelledby": m, "aria-describedby": f, "data-error": h, onKeyDown: b, className: w, children: [
    S,
    N
  ] }), e[26] = f, e[27] = c, e[28] = s, e[29] = S, e[30] = N, e[31] = g, e[32] = m, e[33] = h, e[34] = b, e[35] = w, e[36] = I) : I = e[36];
  let M;
  e[37] !== u || e[38] !== c || e[39] !== r ? (M = r && /* @__PURE__ */ x("span", { id: `${u}-label`, className: le(v2(), c && "opacity-[0.54]"), children: r }), e[37] = u, e[38] = c, e[39] = r, e[40] = M) : M = e[40];
  let T;
  e[41] !== I || e[42] !== M ? (T = /* @__PURE__ */ j("div", { className: "inline-flex items-center gap-(--spacing-8)", children: [
    I,
    M
  ] }), e[41] = I, e[42] = M, e[43] = T) : T = e[43];
  let k;
  e[44] !== n || e[45] !== u || e[46] !== c || e[47] !== l ? (k = n && /* @__PURE__ */ x("span", { id: `${u}-description`, className: le(FR(), c && "opacity-[0.54]", $R({
    size: l
  })), children: n }), e[44] = n, e[45] = u, e[46] = c, e[47] = l, e[48] = k) : k = e[48];
  let D;
  return e[49] !== T || e[50] !== k || e[51] !== p ? (D = /* @__PURE__ */ j("label", { className: p, children: [
    T,
    k
  ] }), e[49] = T, e[50] = k, e[51] = p, e[52] = D) : D = e[52], D;
}
function zR(t) {
  const {
    openOnInputClick: e = !1,
    value: n,
    defaultValue: o,
    onValueChange: r,
    mode: s = "list",
    itemToStringValue: i,
    ...a
  } = t, l = s === "inline" || s === "both", c = s === "inline" || s === "none", u = n !== void 0, [d, f] = v.useState(o ?? ""), [p, g] = v.useState("");
  v.useEffect(() => {
    u && g("");
  }, [n, u]);
  let m;
  l && p !== "" ? m = p : u ? m = n ?? "" : m = d;
  const h = ge((S, E) => {
    g(""), u || f(S), r?.(S, E);
  }), b = Xb(), w = v.useMemo(() => a.filter !== void 0 ? a.filter : b.contains, [a.filter, b]), y = String(u ? n : d).trim(), C = v.useMemo(() => s !== "both" ? c ? null : w : w === null ? null : (S, E, P) => w(S, y, P), [w, s, y, c]), R = ge((S, E) => {
    t.onItemHighlighted?.(S, E), E.reason !== _y && (l ? S == null ? g("") : g(qt(S, i)) : g(""));
  });
  return /* @__PURE__ */ x(Qb, {
    ...a,
    itemToStringLabel: i,
    openOnInputClick: e,
    selectionMode: "none",
    fillInputOnItemPress: !0,
    filter: C,
    autoComplete: s,
    inputValue: m,
    defaultInputValue: o,
    onInputValueChange: h,
    onItemHighlighted: R
  });
}
const HR = qd, BR = Qa, WR = ye(["w-[min(540px,calc(100vw_-_var(--spacing-32)))]", "max-h-[min(640px,calc(100vh_-_var(--spacing-40)))]", "flex", "flex-col", "gap-(--spacing-10)", "outline-none", "[outline:none]", "focus:outline-none", "data-[starting-style]:opacity-0", "data-[starting-style]:scale-95", "data-[ending-style]:opacity-0", "data-[ending-style]:scale-95", "transition-[opacity,transform]", "duration-100", "ease-in-out"]), UR = ye(["fixed", "inset-0", "z-50", "bg-surface/40", "backdrop-blur-search-overlay", "data-[starting-style]:opacity-0", "data-[ending-style]:opacity-0", "transition-opacity", "duration-100", "ease-in-out"]), YR = ye(["flex", "h-(--spacing-40)", "w-full", "items-center", "justify-between", "gap-(--spacing-8)", "rounded-(--radius-sm)", "border", "border-solid", "border-input-default-outline", "bg-input-default-background", "px-(--spacing-10)", "py-(--spacing-10)", "shadow-elevation-1", "transition-colors", "duration-200", "ease-in-out", "[&:has(input:focus)]:border-input-active-outline", "hover:bg-input-hover-background", "hover:border-input-hover-outline", "active:border-input-pressed-outline", "[&:has(input:disabled)]:opacity-50", "[&:has(input:disabled)]:cursor-not-allowed"]), GR = ye(["min-w-0", "flex-1", "border-0", "bg-transparent", "p-0", "font-(family-name:--font-family-body)", "text-(length:--font-size-body-medium)", "font-(number:--font-weight-regular)", "leading-(--font-line-height-20)", "tracking-(--font-letter-spacing-default)", "text-input-text-default", "outline-none", "placeholder:text-input-text-placeholder", "disabled:cursor-not-allowed"]), jR = ye(["min-h-0", "max-h-[min(520px,calc(100vh_-_160px))]", "overflow-y-auto", "overscroll-contain", "outline-none", "[outline:none]", "focus:outline-none", "focus-visible:outline-none", "rounded-(--radius-sm)", "bg-surface-container-lowest", "py-(--spacing-20)", "px-(--spacing-10)", "shadow-elevation-3"]), KR = ye(["flex", "flex-col", "gap-(--spacing-16)", "outline-none", "[outline:none]", "focus:outline-none", "focus-visible:outline-none"]), qR = ye(["flex", "flex-col", "gap-(--spacing-4)"]), XR = ye(["relative", "z-10", "flex", "h-(--spacing-24)", "items-center", "justify-between", "gap-(--spacing-8)", "px-(--spacing-10)", "font-(family-name:--font-family-label)", "text-(length:--font-size-body-medium)", "font-(number:--font-weight-medium)", "leading-(--font-line-height-20)", "tracking-(--font-letter-spacing-default)", "text-menu-text-subtle"]), ZR = ye(["flex", "h-(--spacing-40)", "w-full", "items-center", "gap-(--spacing-8)", "rounded-(--radius-sm)", "bg-transparent", "py-(--spacing-4)", "pl-(--spacing-10)", "pr-(--spacing-8)", "font-(family-name:--font-family-body)", "text-(length:--font-size-body-medium)", "font-(number:--font-weight-medium)", "leading-(--font-line-height-24)", "tracking-(--font-letter-spacing-default)", "text-menu-text-default", "outline-none", "cursor-pointer", "select-none", "transition-colors", "duration-200", "ease-in-out", "hover:bg-menu-item-hover", "active:bg-menu-item-pressed", "data-[highlighted]:bg-menu-item-hover", "data-[disabled]:pointer-events-none", "data-[disabled]:cursor-default", "data-[disabled]:opacity-50"]), QR = ye(["inline-flex", "h-(--spacing-32)", "shrink-0", "items-center", "justify-center", "gap-(--spacing-8)", "rounded-(--radius-sm)", "border", "border-solid", "border-button-outline-default-border", "bg-button-outline-default-background", "px-(--spacing-12)", "font-(family-name:--font-family-label)", "text-(length:--font-size-body-medium)", "font-(number:--font-weight-medium)", "leading-(--font-line-height-20)", "tracking-(--font-letter-spacing-default)", "text-button-outline-default-text", "outline-none", "cursor-pointer", "select-none", "transition-colors", "duration-200", "ease-in-out", "hover:bg-button-outline-hover-background", "hover:border-button-outline-hover-border", "active:bg-button-outline-pressed-background", "active:border-button-outline-pressed-border", "focus-visible:ring-2", "focus-visible:ring-offset-1", "focus-visible:ring-offset-surface", "focus-visible:ring-button-focus-ring"]), JR = ye(["inline-flex", "size-(--spacing-32)", "shrink-0", "items-center", "justify-center", "rounded-(--radius-sm)", "border", "border-solid", "border-transparent", "bg-transparent", "text-button-ghost-default-text", "outline-none", "cursor-pointer", "transition-colors", "duration-200", "ease-in-out", "hover:bg-button-ghost-hover-background", "active:bg-button-ghost-pressed-background"]);
function e7(t) {
  return t.map((e) => ({
    value: e.label,
    items: e.items.map((n) => ({
      ...n,
      groupLabel: e.label
    }))
  }));
}
function t7(t) {
  return t.every((e) => e.items.length === 0);
}
function Gl(t, e) {
  return t.find((n) => n.label === e);
}
function $g(t) {
  return `${t.groupLabel}:${t.id}`;
}
function KN(t) {
  const e = J.c(55), {
    open: n,
    onOpenChange: o,
    query: r,
    onQueryChange: s,
    groups: i,
    placeholder: a,
    hotkey: l,
    emptyLabel: c,
    disabled: u,
    "aria-label": d,
    onItemSelect: f,
    onItemRemove: p
  } = t, g = a === void 0 ? "Search" : a, m = c === void 0 ? "No results found." : c, h = d === void 0 ? "Search" : d, b = i.filter(r7), w = e7(b), y = t7(b), C = !!l && r.length === 0, R = w.at(-1)?.value, [S, E] = Mt();
  let P;
  e[0] !== S ? (P = (re) => $g(re) === S, e[0] = S, e[1] = P) : P = e[1];
  const N = w.flatMap(o7).find(P);
  let I;
  e[2] !== i || e[3] !== f ? (I = function(ne, oe) {
    if (ne.target instanceof Element && ne.target.closest("[data-search-remove]"))
      return;
    const me = Gl(i, oe.groupLabel);
    !me || oe.disabled || f(oe, me);
  }, e[2] = i, e[3] = f, e[4] = I) : I = e[4];
  const M = I;
  let T;
  e[5] !== i || e[6] !== p ? (T = function(ne) {
    const oe = Gl(i, ne.groupLabel);
    !oe || ne.disabled || p?.(ne, oe);
  }, e[5] = i, e[6] = p, e[7] = T) : T = e[7];
  const k = T;
  let D;
  e[8] !== E ? (D = function(ne) {
    const oe = ne ? $g(ne) : void 0;
    E((me) => me === oe ? me : oe);
  }, e[8] = E, e[9] = D) : D = e[9];
  const O = D;
  let V;
  e[10] !== k ? (V = function(ne, oe) {
    ne.preventDefault(), ne.stopPropagation(), k(oe);
  }, e[10] = k, e[11] = V) : V = e[11];
  const _ = V;
  let A;
  e[12] !== k || e[13] !== N || e[14] !== r ? (A = function(ne) {
    !N?.removable || N.disabled || !(ne.key === "Delete" || ne.key === "Backspace" && r.length === 0) || (ne.preventDefault(), ne.stopPropagation(), k(N));
  }, e[12] = k, e[13] = N, e[14] = r, e[15] = A) : A = e[15];
  const F = A;
  let H;
  e[16] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (H = function(ne) {
    if (!ne.removable)
      return;
    const oe = ne.chip ? `, ${ne.chip}` : "", me = ne.removeAriaLabel ? `${ne.removeAriaLabel}. Press Delete.` : "Press Delete to remove.";
    return `${ne.label}${oe}. ${me}`;
  }, e[16] = H) : H = e[16];
  const Y = H;
  let B;
  e[17] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (B = /* @__PURE__ */ x(Fa, { className: le(UR()) }), e[17] = B) : B = e[17];
  let U;
  e[18] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (U = le(WR()), e[18] = U) : U = e[18];
  let q;
  e[19] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (q = le(YR()), e[19] = q) : q = e[19];
  let W;
  e[20] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (W = /* @__PURE__ */ x("span", { className: "inline-flex shrink-0 text-input-text-placeholder", children: /* @__PURE__ */ x(Ye, { name: "search", size: "sm", tone: "inherit" }) }), e[20] = W) : W = e[20];
  let K;
  e[21] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (K = le(GR()), e[21] = K) : K = e[21];
  let te;
  e[22] !== u || e[23] !== F || e[24] !== g ? (te = /* @__PURE__ */ x(Kd, { placeholder: g, disabled: u, className: K, onKeyDown: F }), e[22] = u, e[23] = F, e[24] = g, e[25] = te) : te = e[25];
  let z;
  e[26] !== l || e[27] !== C ? (z = C && /* @__PURE__ */ x(z9, { "aria-hidden": "true", children: l }), e[26] = l, e[27] = C, e[28] = z) : z = e[28];
  let Q;
  e[29] !== te || e[30] !== z ? (Q = /* @__PURE__ */ j(HR, { className: q, children: [
    W,
    te,
    z
  ] }), e[29] = te, e[30] = z, e[31] = Q) : Q = e[31];
  let ee;
  e[32] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (ee = le(jR()), e[32] = ee) : ee = e[32];
  let ae;
  e[33] !== m || e[34] !== i || e[35] !== M || e[36] !== _ || e[37] !== y || e[38] !== R ? (ae = /* @__PURE__ */ x("div", { className: ee, children: y ? /* @__PURE__ */ x("div", { className: "flex h-(--spacing-40) items-center px-(--spacing-10) font-(family-name:--font-family-body) text-(length:--font-size-body-medium) leading-(--font-line-height-20) text-menu-text-subtle", children: m }) : /* @__PURE__ */ x(Za, { className: le(KR()), children: (re) => {
    const ne = Gl(i, re.value);
    return /* @__PURE__ */ j(p0, { children: [
      /* @__PURE__ */ j(o2, { items: re.items, className: le(qR()), children: [
        /* @__PURE__ */ j(r2, { className: le(XR(), ne?.action && "pr-(--spacing-4)"), children: [
          /* @__PURE__ */ x("span", { className: "min-w-0 flex-1 truncate", children: re.value }),
          ne?.action && /* @__PURE__ */ j(Un, { className: le(QR()), "aria-label": ne.action["aria-label"], onClick: ne.action.onClick, children: [
            ne.action.label,
            /* @__PURE__ */ x(Ye, { name: "x-close", size: "xs", tone: "inherit" })
          ] })
        ] }),
        /* @__PURE__ */ x(n2, { children: (oe) => /* @__PURE__ */ j(BR, { value: oe, disabled: oe.disabled, className: le(ZR()), "aria-label": Y(oe), onClick: (me) => M(me, oe), children: [
          /* @__PURE__ */ j("span", { className: "flex min-w-0 flex-1 items-center gap-(--spacing-8)", children: [
            /* @__PURE__ */ x("span", { className: "min-w-0 truncate", children: oe.label }),
            oe.chip && /* @__PURE__ */ x(er, { label: oe.chip, tone: "neutral" })
          ] }),
          oe.removable && /* @__PURE__ */ x("span", { "aria-hidden": "true", className: le(JR()), "data-search-remove": "", "data-testid": `search-remove-${oe.id}`, onPointerDown: (me) => _(me, oe), children: /* @__PURE__ */ x(Ye, { name: "x-close", size: "sm", tone: "inherit" }) })
        ] }, oe.id) })
      ] }),
      re.value !== R && /* @__PURE__ */ x(Ya, { variant: "middle-inset" })
    ] }, re.value);
  } }) }), e[33] = m, e[34] = i, e[35] = M, e[36] = _, e[37] = y, e[38] = R, e[39] = ae) : ae = e[39];
  let X;
  e[40] !== w || e[41] !== u || e[42] !== O || e[43] !== s || e[44] !== r || e[45] !== Q || e[46] !== ae ? (X = /* @__PURE__ */ j(zR, { open: !0, inline: !0, mode: "none", items: w, itemToStringValue: n7, value: r, onValueChange: s, onItemHighlighted: O, disabled: u, children: [
    Q,
    ae
  ] }), e[40] = w, e[41] = u, e[42] = O, e[43] = s, e[44] = r, e[45] = Q, e[46] = ae, e[47] = X) : X = e[47];
  let se;
  e[48] !== h || e[49] !== X ? (se = /* @__PURE__ */ j(Qs, { children: [
    B,
    /* @__PURE__ */ x(ei, { className: "fixed inset-0 z-50 flex items-start justify-center px-(--spacing-16) pt-[12vh]", children: /* @__PURE__ */ x(La, { "aria-label": h, className: U, children: X }) })
  ] }), e[48] = h, e[49] = X, e[50] = se) : se = e[50];
  let ue;
  return e[51] !== o || e[52] !== n || e[53] !== se ? (ue = /* @__PURE__ */ x($a, { open: n, onOpenChange: o, modal: !0, children: se }), e[51] = o, e[52] = n, e[53] = se, e[54] = ue) : ue = e[54], ue;
}
function n7(t) {
  return t.label;
}
function o7(t) {
  return t.items;
}
function r7(t) {
  return t.items.length > 0;
}
function s7(t) {
  if (!(t instanceof HTMLElement)) return !1;
  const e = t.tagName.toLowerCase();
  return e === "input" || e === "textarea" || e === "select" || t.isContentEditable;
}
function i7(t, e) {
  const [n, o] = e.toLowerCase().split("+");
  return !n || !o ? !1 : !!(n === "mod" ? t.metaKey || t.ctrlKey : n === "meta" ? t.metaKey : n === "ctrl" ? t.ctrlKey : n === "alt" ? t.altKey : n === "shift" && t.shiftKey) && t.key.toLowerCase() === o;
}
function qN(t) {
  const e = J.c(5), {
    key: n,
    enabled: o,
    onOpen: r
  } = t, s = o === void 0 ? !0 : o;
  let i, a;
  e[0] !== s || e[1] !== n || e[2] !== r ? (i = () => {
    if (!s)
      return;
    const l = function(u) {
      s7(u.target) || i7(u, n) && (u.preventDefault(), r());
    };
    return document.addEventListener("keydown", l), () => document.removeEventListener("keydown", l);
  }, a = [s, n, r], e[0] = s, e[1] = n, e[2] = r, e[3] = i, e[4] = a) : (i = e[3], a = e[4]), rr(i, a);
}
const a7 = ye(["aw-skeleton", "relative", "block", "overflow-hidden", "bg-surface-container"], {
  variants: {
    radius: {
      none: "rounded-(--radius-none)",
      sm: "rounded-(--radius-sm)",
      md: "rounded-(--radius-md)",
      lg: "rounded-(--radius-lg)",
      xl: "rounded-(--radius-xl)",
      full: "rounded-(--radius-full)"
    }
  },
  defaultVariants: {
    radius: "sm"
  }
});
function XN(t) {
  const e = J.c(25);
  let n, o, r, s, i, a, l;
  e[0] !== t ? ({
    radius: i,
    width: l,
    height: o,
    className: n,
    style: s,
    "aria-hidden": a,
    ...r
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r, e[4] = s, e[5] = i, e[6] = a, e[7] = l) : (n = e[1], o = e[2], r = e[3], s = e[4], i = e[5], a = e[6], l = e[7]);
  const c = i === void 0 ? "sm" : i, u = a === void 0 ? !0 : a;
  let d;
  e[8] !== l ? (d = l !== void 0 ? {
    width: l
  } : void 0, e[8] = l, e[9] = d) : d = e[9];
  let f;
  e[10] !== o ? (f = o !== void 0 ? {
    height: o
  } : void 0, e[10] = o, e[11] = f) : f = e[11];
  let p;
  e[12] !== s || e[13] !== d || e[14] !== f ? (p = {
    ...s,
    ...d,
    ...f
  }, e[12] = s, e[13] = d, e[14] = f, e[15] = p) : p = e[15];
  const g = p;
  let m;
  e[16] !== n || e[17] !== c ? (m = le(a7({
    radius: c
  }), n), e[16] = n, e[17] = c, e[18] = m) : m = e[18];
  let h;
  return e[19] !== u || e[20] !== r || e[21] !== c || e[22] !== g || e[23] !== m ? (h = /* @__PURE__ */ x("div", { ...r, "data-slot": "skeleton", "data-radius": c, "aria-hidden": u, className: m, style: g }), e[19] = u, e[20] = r, e[21] = c, e[22] = g, e[23] = m, e[24] = h) : h = e[24], h;
}
const l7 = 5, c7 = 200;
function u7(t, e, n) {
  const o = [...t], [r] = o.splice(e, 1);
  return o.splice(n, 0, r), o;
}
function is(t, e, n) {
  return `${t}, position ${e + 1} of ${n}`;
}
function jl(t, e, n) {
  const o = [...t.tops], r = t.ids.map((a, l) => l), [s] = r.splice(e, 1);
  r.splice(n, 0, s);
  let i = t.tops[0] ?? 0;
  return r.forEach((a, l) => {
    o[a] = i, i += t.heights[a] + (t.gaps[l] ?? 0);
  }), o;
}
function Kl(t, e, n) {
  const r = {
    ArrowUp: (s) => s - 1,
    ArrowDown: (s) => s + 1,
    Home: () => 0,
    End: (s, i) => i
  }[t];
  return r ? Math.max(0, Math.min(n, r(e, n))) : void 0;
}
function d7({
  items: t,
  getItemId: e,
  getItemLabel: n,
  onReorder: o,
  onDragEnd: r
}) {
  const [s, i] = v.useState(null), [a, l] = v.useState(!1), [c, u] = v.useState(""), d = v.useId(), f = v.useRef(/* @__PURE__ */ new Map()), p = v.useRef(null), g = v.useRef(null), m = v.useRef(/* @__PURE__ */ new Map()), h = v.useRef(null), b = v.useRef(null), w = v.useRef(null), y = v.useRef(null), C = v.useRef([]), R = v.useRef({
    items: t,
    getItemId: e,
    getItemLabel: n,
    onReorder: o,
    onDragEnd: r
  });
  R.current = {
    items: t,
    getItemId: e,
    getItemLabel: n,
    onReorder: o,
    onDragEnd: r
  };
  function S(z, Q) {
    Q ? f.current.set(z, Q) : f.current.delete(z);
  }
  function E(z) {
    const Q = m.current.get(z);
    if (Q) return Q;
    const ee = (ae) => S(z, ae);
    return m.current.set(z, ee), ee;
  }
  function P(z) {
    const {
      items: Q,
      getItemId: ee,
      getItemLabel: ae
    } = R.current, X = Q.find((se) => ee(se) === z);
    return X ? ae(X) : "";
  }
  function N(z) {
    b.current = z, i(z);
  }
  function I(z) {
    typeof document > "u" || (document.body.style.cursor = "grabbing", document.body.style.userSelect = "none");
  }
  function M() {
    if (typeof document > "u") return;
    const z = w.current;
    z && (document.body.style.cursor = z.previousBodyCursor, document.body.style.userSelect = z.previousBodyUserSelect);
  }
  function T() {
    p.current?.abort(), p.current = null, g.current?.abort(), g.current = null, y.current && (clearTimeout(y.current), y.current = null), h.current = null, M(), w.current = null, N(null);
  }
  function k() {
    for (const z of C.current)
      cancelAnimationFrame(z);
    C.current = [];
  }
  function D() {
    k();
    const z = requestAnimationFrame(() => {
      const Q = requestAnimationFrame(() => {
        C.current = [], l(!1);
      });
      C.current = [Q];
    });
    C.current = [z];
  }
  function O(z, Q) {
    y.current && (clearTimeout(y.current), y.current = null), p.current?.abort(), p.current = null, h.current = null;
    const ee = b.current;
    if (!ee) {
      T();
      return;
    }
    N({
      ...ee,
      delta: z,
      settling: !0
    }), y.current = setTimeout(() => {
      l(!0), Q?.(), T(), D();
    }, c7);
  }
  function V() {
    const z = b.current;
    if (!z) {
      T();
      return;
    }
    if (z.settling) return;
    const Q = w.current;
    if (!Q) {
      T();
      return;
    }
    g.current?.abort(), g.current = null;
    const ae = jl(Q, z.fromIndex, z.overIndex)[z.fromIndex] - Q.tops[z.fromIndex];
    O(ae, () => {
      const {
        items: X,
        getItemId: se,
        onReorder: ue,
        onDragEnd: re
      } = R.current;
      if (u(`Dropped ${is(P(z.id), z.overIndex, X.length)}`), z.overIndex === z.fromIndex) return;
      const ne = X.findIndex((he) => se(he) === z.id), oe = Q.ids[z.overIndex], me = X.findIndex((he) => se(he) === oe);
      if (ne < 0 || me < 0 || ne === me) return;
      const de = u7(X, ne, me);
      ue(de), re?.(de);
    });
  }
  function _() {
    const z = b.current;
    if (!z) {
      T();
      return;
    }
    z.settling || (u(`Reordering cancelled. ${is(P(z.id), z.fromIndex, R.current.items.length)}`), N({
      ...z,
      delta: 0,
      overIndex: z.fromIndex
    }), O(0));
  }
  function A(z, Q, ee = !0) {
    const {
      items: ae,
      getItemId: X
    } = R.current, se = ae.findIndex((he) => X(he) === z);
    if (se < 0) return;
    const ue = ae.map((he) => X(he)), re = ue.map((he) => f.current.get(he)?.getBoundingClientRect()), ne = re.map((he) => he ? he.top + he.height / 2 : 0), oe = re.map((he, $) => {
      const Z = re[$ + 1];
      return he && Z ? Z.top - (he.top + he.height) : 0;
    }), me = re.map((he) => he?.height ?? 0), de = re.map((he) => he?.top ?? 0);
    w.current = {
      centers: ne,
      gaps: oe,
      heights: me,
      ids: ue,
      previousBodyCursor: typeof document > "u" ? "" : document.body.style.cursor,
      previousBodyUserSelect: typeof document > "u" ? "" : document.body.style.userSelect,
      startY: Q,
      tops: de
    }, ee && I(), N({
      id: z,
      fromIndex: se,
      overIndex: se,
      delta: 0,
      settling: !1
    }), u(`Picked up ${is(P(z), se, ae.length)}`);
  }
  function F(z) {
    const ee = f.current.get(z)?.getBoundingClientRect();
    A(z, ee ? ee.top + ee.height / 2 : 0, !1), q(z);
  }
  function H(z) {
    const Q = b.current, ee = w.current;
    if (!Q || Q.settling || !ee) return;
    const ae = z - ee.startY, X = ee.centers[Q.fromIndex] + ae;
    let se = 0, ue = Number.POSITIVE_INFINITY;
    for (let re = 0; re < ee.centers.length; re++) {
      const ne = Math.abs(X - ee.centers[re]);
      ne < ue && (ue = ne, se = re);
    }
    se !== Q.overIndex && u(is(P(Q.id), se, R.current.items.length)), N({
      ...Q,
      delta: ae,
      overIndex: se
    });
  }
  function Y(z) {
    const Q = b.current, ee = w.current;
    if (!Q || Q.settling || !ee) return;
    z !== Q.overIndex && u(is(P(Q.id), z, R.current.items.length));
    const ae = jl(ee, Q.fromIndex, z);
    N({
      ...Q,
      delta: ae[Q.fromIndex] - ee.tops[Q.fromIndex],
      overIndex: z
    });
  }
  function B(z, Q) {
    if (z.pointerType === "mouse" && z.button !== 0 || b.current || h.current) return;
    z.currentTarget.setPointerCapture?.(z.pointerId), h.current = {
      id: Q,
      x: z.clientX,
      y: z.clientY
    };
    const ee = new AbortController();
    p.current = ee;
    const {
      signal: ae
    } = ee;
    window.addEventListener("pointermove", (X) => {
      const se = h.current;
      if (se && !b.current) {
        if (Math.hypot(X.clientX - se.x, X.clientY - se.y) < l7)
          return;
        A(se.id, se.y);
      }
      b.current && (X.preventDefault(), H(X.clientY));
    }, {
      signal: ae
    }), window.addEventListener("pointerup", V, {
      signal: ae
    }), window.addEventListener("pointercancel", _, {
      signal: ae
    }), window.addEventListener("blur", _, {
      signal: ae
    }), document.addEventListener("visibilitychange", () => {
      document.visibilityState === "hidden" && _();
    }, {
      signal: ae
    }), window.addEventListener("keydown", (X) => {
      X.key === "Escape" && (X.preventDefault(), _());
    }, {
      signal: ae
    });
  }
  function U(z, Q) {
    const ee = b.current;
    if (ee?.id !== Q) return;
    if (z.key === "Tab") {
      _();
      return;
    }
    if (z.key === " " || z.key === "Enter") {
      z.preventDefault(), V();
      return;
    }
    if (z.key === "Escape") {
      z.preventDefault(), _();
      return;
    }
    const ae = Kl(z.key, ee.overIndex, R.current.items.length - 1);
    ae !== void 0 && (z.preventDefault(), Y(ae));
  }
  function q(z) {
    if (g.current?.abort(), typeof document > "u") return;
    const Q = new AbortController();
    g.current = Q;
    const {
      signal: ee
    } = Q;
    document.addEventListener("keydown", (ae) => U(ae, z), {
      signal: ee
    }), document.addEventListener("focusin", (ae) => {
      if (b.current?.id !== z) return;
      const se = ae.target, ue = f.current.get(z)?.querySelector('[data-slot="sortable-handle"]');
      se instanceof Node && ue?.contains(se) || _();
    }, {
      signal: ee
    });
  }
  function W(z, Q) {
    const ee = b.current;
    if (z.key === " " || z.key === "Enter") {
      if (z.preventDefault(), z.stopPropagation(), ee?.id === Q) {
        V();
        return;
      }
      ee || F(Q);
      return;
    }
    if (z.key === "Escape" && ee?.id === Q) {
      z.preventDefault(), z.stopPropagation(), _();
      return;
    }
    const {
      items: ae
    } = R.current, X = ae.length - 1;
    if (ee?.id === Q) {
      const se = Kl(z.key, ee.overIndex, X);
      if (se === void 0) return;
      z.preventDefault(), z.stopPropagation(), Y(se);
      return;
    }
    Kl(z.key, 0, X) !== void 0 && (z.preventDefault(), z.stopPropagation());
  }
  function K(z, Q) {
    return {
      "aria-label": `Reorder ${Q}`,
      "aria-describedby": d,
      "aria-pressed": s?.id === z,
      "data-slot": "sortable-handle",
      role: "button",
      tabIndex: 0,
      onPointerDown: (ee) => B(ee, z),
      onKeyDown: (ee) => W(ee, z),
      onClick: (ee) => ee.stopPropagation()
    };
  }
  function te(z, Q) {
    if (!s) return;
    if (z === s.id) return `translateY(${s.delta}px)`;
    const ee = w.current;
    if (!ee) return;
    const {
      fromIndex: ae,
      overIndex: X
    } = s, ue = jl(ee, ae, X)[Q] - ee.tops[Q];
    return ue === 0 ? void 0 : `translateY(${ue}px)`;
  }
  return v.useEffect(() => () => {
    p.current?.abort(), p.current = null, y.current && (clearTimeout(y.current), y.current = null), g.current?.abort(), g.current = null;
    for (const Q of C.current)
      cancelAnimationFrame(Q);
    C.current = [], h.current = null;
    const z = w.current;
    typeof document < "u" && z && (document.body.style.cursor = z.previousBodyCursor, document.body.style.userSelect = z.previousBodyUserSelect), w.current = null;
  }, []), {
    draggingId: s?.id ?? null,
    settling: s?.settling ?? !1,
    committing: a,
    getRowRef: E,
    getHandleProps: K,
    getItemTransform: te,
    announcement: c,
    instructionsId: d
  };
}
const f7 = ye(["relative", "transition-transform duration-200 ease-out", "motion-reduce:transition-none"]), p7 = ye(["flex size-(--spacing-20) shrink-0 items-center justify-center", "rounded-(--radius-sm)", "text-text-subtext", "cursor-grab touch-none", "active:cursor-grabbing", "focus-visible:outline-none", "focus-visible:ring-2", "focus-visible:ring-offset-1", "focus-visible:ring-offset-surface", "focus-visible:ring-button-focus-ring"]), g7 = ye(["flex w-full items-stretch", "data-[dragging]:shadow-elevation-1"]);
function ZN(t) {
  const e = J.c(8);
  let n, o;
  e[0] !== t ? ({
    className: n,
    ...o
  } = t, e[0] = t, e[1] = n, e[2] = o) : (n = e[1], o = e[2]);
  let r;
  e[3] !== n ? (r = le(g7(), n), e[3] = n, e[4] = r) : r = e[4];
  let s;
  return e[5] !== o || e[6] !== r ? (s = /* @__PURE__ */ x("div", { "data-slot": "sortable-list-item", className: r, ...o }), e[5] = o, e[6] = r, e[7] = s) : s = e[7], s;
}
function m7(t) {
  const e = J.c(7);
  let n, o;
  if (e[0] !== t ? ({
    visible: o,
    ...n
  } = t, e[0] = t, e[1] = n, e[2] = o) : (n = e[1], o = e[2]), !(o === void 0 ? !0 : o))
    return null;
  let s, i;
  e[3] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (s = p7(), i = /* @__PURE__ */ x(Ye, { name: "grip-drag", size: "md", tone: "secondary", "aria-hidden": !0 }), e[3] = s, e[4] = i) : (s = e[3], i = e[4]);
  let a;
  return e[5] !== n ? (a = /* @__PURE__ */ x("div", { className: "flex w-(--spacing-40) shrink-0 items-center justify-center", children: /* @__PURE__ */ x("button", { ...n, type: "button", className: s, children: i }) }), e[5] = n, e[6] = a) : a = e[6], a;
}
function h7(t) {
  const e = J.c(36), {
    items: n,
    getItemId: o,
    getItemLabel: r,
    onReorder: s,
    onDragEnd: i,
    className: a,
    children: l
  } = t;
  let c;
  e[0] !== o || e[1] !== r || e[2] !== n || e[3] !== i || e[4] !== s ? (c = {
    items: n,
    getItemId: o,
    getItemLabel: r,
    onReorder: s,
    onDragEnd: i
  }, e[0] = o, e[1] = r, e[2] = n, e[3] = i, e[4] = s, e[5] = c) : c = e[5];
  const {
    draggingId: u,
    settling: d,
    committing: f,
    getRowRef: p,
    getHandleProps: g,
    getItemTransform: m,
    announcement: h,
    instructionsId: b
  } = d7(c);
  let w;
  if (e[6] !== l || e[7] !== f || e[8] !== u || e[9] !== g || e[10] !== o || e[11] !== r || e[12] !== m || e[13] !== p || e[14] !== n || e[15] !== d) {
    let S;
    e[17] !== l || e[18] !== f || e[19] !== u || e[20] !== g || e[21] !== o || e[22] !== r || e[23] !== m || e[24] !== p || e[25] !== d ? (S = (E, P) => {
      const N = o(E), I = r(E), M = u === N, T = g(N, I), k = /* @__PURE__ */ x(m7, { ...T });
      return /* @__PURE__ */ x("div", { ref: p(N), "data-slot": "sortable-item", "data-dragging": M ? "" : void 0, style: {
        transform: m(N, P)
      }, className: le(f7(), f && "transition-none", M && "z-10", M && !d && "transition-none"), children: l(E, {
        handle: k,
        handleProps: T,
        isDragging: M
      }) }, N);
    }, e[17] = l, e[18] = f, e[19] = u, e[20] = g, e[21] = o, e[22] = r, e[23] = m, e[24] = p, e[25] = d, e[26] = S) : S = e[26], w = n.map(S), e[6] = l, e[7] = f, e[8] = u, e[9] = g, e[10] = o, e[11] = r, e[12] = m, e[13] = p, e[14] = n, e[15] = d, e[16] = w;
  } else
    w = e[16];
  let y;
  e[27] !== b ? (y = /* @__PURE__ */ x("span", { id: b, className: "sr-only", children: "Press Space or Enter to pick up, arrow keys to move, Space or Enter to drop, or Escape to cancel." }), e[27] = b, e[28] = y) : y = e[28];
  let C;
  e[29] !== h ? (C = /* @__PURE__ */ x("span", { "aria-live": "polite", "aria-atomic": "true", className: "sr-only", children: h }), e[29] = h, e[30] = C) : C = e[30];
  let R;
  return e[31] !== a || e[32] !== w || e[33] !== y || e[34] !== C ? (R = /* @__PURE__ */ j("div", { "data-slot": "sortable-list", className: a, children: [
    w,
    y,
    C
  ] }), e[31] = a, e[32] = w, e[33] = y, e[34] = C, e[35] = R) : R = e[35], R;
}
const QN = h7, b7 = ye("text-surface-on-surface", {
  variants: {
    tone: {
      base: ["bg-surface-container-lowest"],
      neutral: ["bg-surface-container"],
      positive: ["bg-positive-container", "text-positive-on-container"],
      warning: ["bg-accessibility-warning-container", "text-warning-on-container"],
      negative: ["bg-negative-container", "text-negative-on-container"],
      informative: ["bg-informative-container", "text-informative-on-container"]
    },
    padding: {
      none: "p-0",
      compact: "p-(--spacing-12)",
      comfortable: "px-(--spacing-20) py-(--spacing-16)"
    },
    radius: {
      none: "rounded-(--radius-none)",
      sm: "rounded-(--radius-sm)",
      md: "rounded-(--radius-md)",
      lg: "rounded-(--radius-lg)",
      xl: "rounded-(--radius-xl)",
      full: "rounded-(--radius-full)"
    },
    aspect: {
      auto: null,
      square: "aspect-square"
    },
    centered: {
      true: "grid place-items-center",
      false: null
    },
    width: {
      auto: null,
      content: "w-fit",
      full: "w-full"
    }
  },
  defaultVariants: {
    tone: "base",
    padding: "comfortable",
    radius: "sm",
    aspect: "auto",
    centered: !1,
    width: "auto"
  }
});
function JN(t) {
  const e = J.c(26);
  let n, o, r, s, i, a, l, c;
  e[0] !== t ? ({
    tone: r,
    padding: s,
    radius: i,
    aspect: a,
    centered: l,
    width: c,
    children: n,
    ...o
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r, e[4] = s, e[5] = i, e[6] = a, e[7] = l, e[8] = c) : (n = e[1], o = e[2], r = e[3], s = e[4], i = e[5], a = e[6], l = e[7], c = e[8]);
  const u = r === void 0 ? "base" : r, d = s === void 0 ? "comfortable" : s, f = i === void 0 ? "sm" : i, p = a === void 0 ? "auto" : a, g = l === void 0 ? !1 : l, m = c === void 0 ? "auto" : c, h = g || void 0;
  let b;
  e[9] !== p || e[10] !== g || e[11] !== d || e[12] !== f || e[13] !== u || e[14] !== m ? (b = le(b7({
    tone: u,
    padding: d,
    radius: f,
    aspect: p,
    centered: g,
    width: m
  })), e[9] = p, e[10] = g, e[11] = d, e[12] = f, e[13] = u, e[14] = m, e[15] = b) : b = e[15];
  let w;
  return e[16] !== p || e[17] !== n || e[18] !== d || e[19] !== o || e[20] !== f || e[21] !== h || e[22] !== b || e[23] !== u || e[24] !== m ? (w = /* @__PURE__ */ x("div", { "data-slot": "surface", "data-tone": u, "data-padding": d, "data-radius": f, "data-aspect": p, "data-centered": h, "data-width": m, className: b, ...o, children: n }), e[16] = p, e[17] = n, e[18] = d, e[19] = o, e[20] = f, e[21] = h, e[22] = b, e[23] = u, e[24] = m, e[25] = w) : w = e[25], w;
}
const ff = /* @__PURE__ */ v.createContext(void 0);
process.env.NODE_ENV !== "production" && (ff.displayName = "SwitchRootContext");
function v7() {
  const t = v.useContext(ff);
  if (t === void 0)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: SwitchRootContext is missing. Switch parts must be placed within <Switch.Root>." : Xe(63));
  return t;
}
let zg = /* @__PURE__ */ (function(t) {
  return t.checked = "data-checked", t.unchecked = "data-unchecked", t.disabled = "data-disabled", t.readonly = "data-readonly", t.required = "data-required", t.valid = "data-valid", t.invalid = "data-invalid", t.touched = "data-touched", t.dirty = "data-dirty", t.filled = "data-filled", t.focused = "data-focused", t;
})({});
const y2 = {
  ...jn,
  checked(t) {
    return t ? {
      [zg.checked]: ""
    } : {
      [zg.unchecked]: ""
    };
  }
}, x2 = /* @__PURE__ */ v.forwardRef(function(e, n) {
  const {
    checked: o,
    className: r,
    defaultChecked: s,
    "aria-labelledby": i,
    form: a,
    id: l,
    inputRef: c,
    name: u,
    nativeButton: d = !1,
    onCheckedChange: f,
    readOnly: p = !1,
    required: g = !1,
    disabled: m = !1,
    render: h,
    uncheckedValue: b,
    value: w,
    style: y,
    ...C
  } = e, {
    clearErrors: R
  } = Co(), {
    state: S,
    setTouched: E,
    setDirty: P,
    validityData: N,
    setFilled: I,
    setFocused: M,
    shouldValidateOnChange: T,
    validationMode: k,
    disabled: D,
    name: O,
    validation: V
  } = Xt(), {
    labelId: _
  } = un(), A = D || m, F = O ?? u, H = ge(f), Y = v.useRef(null), B = ln(Y, c, V.inputRef), U = v.useRef(null), q = St(), W = mr({
    id: l,
    implicit: !1,
    controlRef: U
  }), K = d ? void 0 : W, [te, z] = sn({
    controlled: o,
    default: !!s,
    name: "Switch",
    state: "checked"
  });
  Ur(U, {
    id: q,
    value: te
  }), xe(() => {
    Y.current && I(Y.current.checked);
  }, [Y, I]), po(te, () => {
    R(F), P(te !== N.initialValue), I(te), T() ? V.commit(te) : V.commit(te, !0);
  });
  const {
    getButtonProps: Q,
    buttonRef: ee
  } = Ft({
    disabled: A,
    native: d
  }), ae = Mu(i, _, Y, !d, K), X = {
    id: d ? W : q,
    role: "switch",
    "aria-checked": te,
    "aria-readonly": p || void 0,
    "aria-required": g || void 0,
    "aria-labelledby": ae,
    onFocus() {
      A || M(!0);
    },
    onBlur() {
      const ne = Y.current;
      !ne || A || (E(!0), M(!1), k === "onBlur" && V.commit(ne.checked));
    },
    onClick(ne) {
      p || A || (ne.preventDefault(), Y.current?.dispatchEvent(new PointerEvent("click", {
        bubbles: !0,
        shiftKey: ne.shiftKey,
        ctrlKey: ne.ctrlKey,
        altKey: ne.altKey,
        metaKey: ne.metaKey
      })));
    }
  }, se = v.useMemo(() => on(
    {
      checked: te,
      disabled: A,
      form: a,
      id: K,
      name: F,
      required: g,
      style: F ? Lr : $o,
      tabIndex: -1,
      type: "checkbox",
      "aria-hidden": !0,
      ref: B,
      onChange(ne) {
        if (ne.nativeEvent.defaultPrevented)
          return;
        if (p) {
          ne.preventDefault();
          return;
        }
        const oe = ne.currentTarget.checked, me = Pe(Et, ne.nativeEvent);
        H?.(oe, me), !me.isCanceled && z(oe);
      },
      onFocus() {
        U.current?.focus();
      }
    },
    V.getInputValidationProps,
    // React <19 sets an empty value if `undefined` is passed explicitly
    // To avoid this, we only set the value if it's defined
    w !== void 0 ? {
      value: w
    } : yt
  ), [te, A, a, B, K, F, H, p, g, z, V, w]), ue = v.useMemo(() => ({
    ...S,
    checked: te,
    disabled: A,
    readOnly: p,
    required: g
  }), [S, te, A, p, g]), re = Te("span", e, {
    state: ue,
    ref: [n, U, ee],
    props: [X, V.getValidationProps, C, Q],
    stateAttributesMapping: y2
  });
  return /* @__PURE__ */ j(ff.Provider, {
    value: ue,
    children: [re, !te && F && b !== void 0 && /* @__PURE__ */ x("input", {
      type: "hidden",
      form: a,
      name: F,
      value: b
    }), /* @__PURE__ */ x("input", {
      ...se,
      suppressHydrationWarning: !0
    })]
  });
});
process.env.NODE_ENV !== "production" && (x2.displayName = "SwitchRoot");
const w2 = /* @__PURE__ */ v.forwardRef(function(e, n) {
  const {
    render: o,
    className: r,
    style: s,
    ...i
  } = e, {
    state: a
  } = Xt(), l = v7(), c = {
    ...a,
    ...l
  };
  return Te("span", e, {
    state: c,
    ref: n,
    stateAttributesMapping: y2,
    props: i
  });
});
process.env.NODE_ENV !== "production" && (w2.displayName = "SwitchThumb");
const y7 = ye(["inline-flex", "items-start", "gap-(--spacing-8)"], {
  variants: {
    disabled: {
      true: ["opacity-[0.54]", "cursor-not-allowed"],
      false: ["cursor-pointer"]
    }
  },
  defaultVariants: {
    disabled: !1
  }
}), x7 = ye(["relative", "shrink-0", "w-[44px]", "h-(--spacing-24)", "rounded-full", "bg-surface-container-highest", "data-[checked]:bg-primary", "transition-colors", "duration-200", "ease-in-out", "motion-reduce:transition-none", "focus-visible:outline-none", "focus-visible:ring-2", "focus-visible:ring-offset-2", "focus-visible:ring-tertiary-tertiary", "cursor-[inherit]", "[@media(pointer:coarse)]:before:content-['']", "[@media(pointer:coarse)]:before:absolute", "[@media(pointer:coarse)]:before:inset-x-0", "[@media(pointer:coarse)]:before:inset-y-[-12px]"]), w7 = ye(["absolute", "top-(--spacing-2)", "w-(--spacing-20)", "h-(--spacing-20)", "rounded-full", "bg-surface-container-lowest", "shadow-elevation-1", "translate-x-(--spacing-2)", "data-[checked]:translate-x-[22px]", "transition-transform", "duration-150", "ease-in-out", "motion-reduce:transition-none"]), C7 = ye(["text-text-default", "font-(family-name:--font-family-body)", "font-(number:--font-weight-medium)", "text-(length:--font-size-body-medium)", "leading-(--font-line-height-20)", "tracking-(--font-letter-spacing-default)"]), S7 = ye(["text-text-subtle", "font-(family-name:--font-family-body)", "font-(number:--font-weight-regular)", "text-(length:--font-size-body-small)", "leading-(--font-line-height-16)"]);
function eI(t) {
  const e = J.c(25);
  let n, o, r, s, i;
  e[0] !== t ? ({
    label: r,
    description: n,
    disabled: i,
    id: o,
    ...s
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r, e[4] = s, e[5] = i) : (n = e[1], o = e[2], r = e[3], s = e[4], i = e[5]);
  const a = i === void 0 ? !1 : i, l = bn(), c = o ?? l;
  let u;
  e[6] !== a ? (u = le(y7({
    disabled: a
  })), e[6] = a, e[7] = u) : u = e[7];
  const d = r ? `${c}-label` : void 0, f = n ? `${c}-description` : void 0;
  let p;
  e[8] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (p = x7(), e[8] = p) : p = e[8];
  let g;
  e[9] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (g = /* @__PURE__ */ x(w2, { className: w7() }), e[9] = g) : g = e[9];
  let m;
  e[10] !== a || e[11] !== s || e[12] !== c || e[13] !== d || e[14] !== f ? (m = /* @__PURE__ */ x(x2, { ...s, id: c, disabled: a, "aria-labelledby": d, "aria-describedby": f, className: p, children: g }), e[10] = a, e[11] = s, e[12] = c, e[13] = d, e[14] = f, e[15] = m) : m = e[15];
  let h;
  e[16] !== n || e[17] !== r || e[18] !== c ? (h = (r || n) && /* @__PURE__ */ j("div", { className: "flex flex-col gap-(--spacing-4)", children: [
    r && /* @__PURE__ */ x("span", { id: `${c}-label`, className: C7(), children: r }),
    n && /* @__PURE__ */ x("span", { id: `${c}-description`, className: S7(), children: n })
  ] }), e[16] = n, e[17] = r, e[18] = c, e[19] = h) : h = e[19];
  let b;
  return e[20] !== c || e[21] !== u || e[22] !== m || e[23] !== h ? (b = /* @__PURE__ */ j("label", { htmlFor: c, className: u, children: [
    m,
    h
  ] }), e[20] = c, e[21] = u, e[22] = m, e[23] = h, e[24] = b) : b = e[24], b;
}
/**
   * table-core
   *
   * Copyright (c) TanStack
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE.md file in the root directory of this source tree.
   *
   * @license MIT
   */
function To(t, e) {
  return typeof t == "function" ? t(e) : t;
}
function yn(t, e) {
  return (n) => {
    e.setState((o) => ({
      ...o,
      [t]: To(n, o[t])
    }));
  };
}
function Ja(t) {
  return t instanceof Function;
}
function R7(t) {
  return Array.isArray(t) && t.every((e) => typeof e == "number");
}
function E7(t, e) {
  const n = [], o = (r) => {
    r.forEach((s) => {
      n.push(s);
      const i = e(s);
      i != null && i.length && o(i);
    });
  };
  return o(t), n;
}
function Je(t, e, n) {
  let o = [], r;
  return (s) => {
    let i;
    n.key && n.debug && (i = Date.now());
    const a = t(s);
    if (!(a.length !== o.length || a.some((u, d) => o[d] !== u)))
      return r;
    o = a;
    let c;
    if (n.key && n.debug && (c = Date.now()), r = e(...a), n == null || n.onChange == null || n.onChange(r), n.key && n.debug && n != null && n.debug()) {
      const u = Math.round((Date.now() - i) * 100) / 100, d = Math.round((Date.now() - c) * 100) / 100, f = d / 16, p = (g, m) => {
        for (g = String(g); g.length < m; )
          g = " " + g;
        return g;
      };
      console.info(`%c⏱ ${p(d, 5)} /${p(u, 5)} ms`, `
            font-size: .6rem;
            font-weight: bold;
            color: hsl(${Math.max(0, Math.min(120 - 120 * f, 120))}deg 100% 31%);`, n?.key);
    }
    return r;
  };
}
function et(t, e, n, o) {
  return {
    debug: () => {
      var r;
      return (r = t?.debugAll) != null ? r : t[e];
    },
    key: process.env.NODE_ENV === "development" && n,
    onChange: o
  };
}
function P7(t, e, n, o) {
  const r = () => {
    var i;
    return (i = s.getValue()) != null ? i : t.options.renderFallbackValue;
  }, s = {
    id: `${e.id}_${n.id}`,
    row: e,
    column: n,
    getValue: () => e.getValue(o),
    renderValue: r,
    getContext: Je(() => [t, n, e, s], (i, a, l, c) => ({
      table: i,
      column: a,
      row: l,
      cell: c,
      getValue: c.getValue,
      renderValue: c.renderValue
    }), et(t.options, "debugCells", "cell.getContext"))
  };
  return t._features.forEach((i) => {
    i.createCell == null || i.createCell(s, n, e, t);
  }, {}), s;
}
function N7(t, e, n, o) {
  var r, s;
  const a = {
    ...t._getDefaultColumnDef(),
    ...e
  }, l = a.accessorKey;
  let c = (r = (s = a.id) != null ? s : l ? typeof String.prototype.replaceAll == "function" ? l.replaceAll(".", "_") : l.replace(/\./g, "_") : void 0) != null ? r : typeof a.header == "string" ? a.header : void 0, u;
  if (a.accessorFn ? u = a.accessorFn : l && (l.includes(".") ? u = (f) => {
    let p = f;
    for (const m of l.split(".")) {
      var g;
      p = (g = p) == null ? void 0 : g[m], process.env.NODE_ENV !== "production" && p === void 0 && console.warn(`"${m}" in deeply nested key "${l}" returned undefined.`);
    }
    return p;
  } : u = (f) => f[a.accessorKey]), !c)
    throw process.env.NODE_ENV !== "production" ? new Error(a.accessorFn ? "Columns require an id when using an accessorFn" : "Columns require an id when using a non-string header") : new Error();
  let d = {
    id: `${String(c)}`,
    accessorFn: u,
    parent: o,
    depth: n,
    columnDef: a,
    columns: [],
    getFlatColumns: Je(() => [!0], () => {
      var f;
      return [d, ...(f = d.columns) == null ? void 0 : f.flatMap((p) => p.getFlatColumns())];
    }, et(t.options, "debugColumns", "column.getFlatColumns")),
    getLeafColumns: Je(() => [t._getOrderColumnsFn()], (f) => {
      var p;
      if ((p = d.columns) != null && p.length) {
        let g = d.columns.flatMap((m) => m.getLeafColumns());
        return f(g);
      }
      return [d];
    }, et(t.options, "debugColumns", "column.getLeafColumns"))
  };
  for (const f of t._features)
    f.createColumn == null || f.createColumn(d, t);
  return d;
}
const Qt = "debugHeaders";
function Hg(t, e, n) {
  var o;
  let s = {
    id: (o = n.id) != null ? o : e.id,
    column: e,
    index: n.index,
    isPlaceholder: !!n.isPlaceholder,
    placeholderId: n.placeholderId,
    depth: n.depth,
    subHeaders: [],
    colSpan: 0,
    rowSpan: 0,
    headerGroup: null,
    getLeafHeaders: () => {
      const i = [], a = (l) => {
        l.subHeaders && l.subHeaders.length && l.subHeaders.map(a), i.push(l);
      };
      return a(s), i;
    },
    getContext: () => ({
      table: t,
      header: s,
      column: e
    })
  };
  return t._features.forEach((i) => {
    i.createHeader == null || i.createHeader(s, t);
  }), s;
}
const I7 = {
  createTable: (t) => {
    t.getHeaderGroups = Je(() => [t.getAllColumns(), t.getVisibleLeafColumns(), t.getState().columnPinning.left, t.getState().columnPinning.right], (e, n, o, r) => {
      var s, i;
      const a = (s = o?.map((d) => n.find((f) => f.id === d)).filter(Boolean)) != null ? s : [], l = (i = r?.map((d) => n.find((f) => f.id === d)).filter(Boolean)) != null ? i : [], c = n.filter((d) => !(o != null && o.includes(d.id)) && !(r != null && r.includes(d.id)));
      return $i(e, [...a, ...c, ...l], t);
    }, et(t.options, Qt, "getHeaderGroups")), t.getCenterHeaderGroups = Je(() => [t.getAllColumns(), t.getVisibleLeafColumns(), t.getState().columnPinning.left, t.getState().columnPinning.right], (e, n, o, r) => (n = n.filter((s) => !(o != null && o.includes(s.id)) && !(r != null && r.includes(s.id))), $i(e, n, t, "center")), et(t.options, Qt, "getCenterHeaderGroups")), t.getLeftHeaderGroups = Je(() => [t.getAllColumns(), t.getVisibleLeafColumns(), t.getState().columnPinning.left], (e, n, o) => {
      var r;
      const s = (r = o?.map((i) => n.find((a) => a.id === i)).filter(Boolean)) != null ? r : [];
      return $i(e, s, t, "left");
    }, et(t.options, Qt, "getLeftHeaderGroups")), t.getRightHeaderGroups = Je(() => [t.getAllColumns(), t.getVisibleLeafColumns(), t.getState().columnPinning.right], (e, n, o) => {
      var r;
      const s = (r = o?.map((i) => n.find((a) => a.id === i)).filter(Boolean)) != null ? r : [];
      return $i(e, s, t, "right");
    }, et(t.options, Qt, "getRightHeaderGroups")), t.getFooterGroups = Je(() => [t.getHeaderGroups()], (e) => [...e].reverse(), et(t.options, Qt, "getFooterGroups")), t.getLeftFooterGroups = Je(() => [t.getLeftHeaderGroups()], (e) => [...e].reverse(), et(t.options, Qt, "getLeftFooterGroups")), t.getCenterFooterGroups = Je(() => [t.getCenterHeaderGroups()], (e) => [...e].reverse(), et(t.options, Qt, "getCenterFooterGroups")), t.getRightFooterGroups = Je(() => [t.getRightHeaderGroups()], (e) => [...e].reverse(), et(t.options, Qt, "getRightFooterGroups")), t.getFlatHeaders = Je(() => [t.getHeaderGroups()], (e) => e.map((n) => n.headers).flat(), et(t.options, Qt, "getFlatHeaders")), t.getLeftFlatHeaders = Je(() => [t.getLeftHeaderGroups()], (e) => e.map((n) => n.headers).flat(), et(t.options, Qt, "getLeftFlatHeaders")), t.getCenterFlatHeaders = Je(() => [t.getCenterHeaderGroups()], (e) => e.map((n) => n.headers).flat(), et(t.options, Qt, "getCenterFlatHeaders")), t.getRightFlatHeaders = Je(() => [t.getRightHeaderGroups()], (e) => e.map((n) => n.headers).flat(), et(t.options, Qt, "getRightFlatHeaders")), t.getCenterLeafHeaders = Je(() => [t.getCenterFlatHeaders()], (e) => e.filter((n) => {
      var o;
      return !((o = n.subHeaders) != null && o.length);
    }), et(t.options, Qt, "getCenterLeafHeaders")), t.getLeftLeafHeaders = Je(() => [t.getLeftFlatHeaders()], (e) => e.filter((n) => {
      var o;
      return !((o = n.subHeaders) != null && o.length);
    }), et(t.options, Qt, "getLeftLeafHeaders")), t.getRightLeafHeaders = Je(() => [t.getRightFlatHeaders()], (e) => e.filter((n) => {
      var o;
      return !((o = n.subHeaders) != null && o.length);
    }), et(t.options, Qt, "getRightLeafHeaders")), t.getLeafHeaders = Je(() => [t.getLeftHeaderGroups(), t.getCenterHeaderGroups(), t.getRightHeaderGroups()], (e, n, o) => {
      var r, s, i, a, l, c;
      return [...(r = (s = e[0]) == null ? void 0 : s.headers) != null ? r : [], ...(i = (a = n[0]) == null ? void 0 : a.headers) != null ? i : [], ...(l = (c = o[0]) == null ? void 0 : c.headers) != null ? l : []].map((u) => u.getLeafHeaders()).flat();
    }, et(t.options, Qt, "getLeafHeaders"));
  }
};
function $i(t, e, n, o) {
  var r, s;
  let i = 0;
  const a = function(f, p) {
    p === void 0 && (p = 1), i = Math.max(i, p), f.filter((g) => g.getIsVisible()).forEach((g) => {
      var m;
      (m = g.columns) != null && m.length && a(g.columns, p + 1);
    }, 0);
  };
  a(t);
  let l = [];
  const c = (f, p) => {
    const g = {
      depth: p,
      id: [o, `${p}`].filter(Boolean).join("_"),
      headers: []
    }, m = [];
    f.forEach((h) => {
      const b = [...m].reverse()[0], w = h.column.depth === g.depth;
      let y, C = !1;
      if (w && h.column.parent ? y = h.column.parent : (y = h.column, C = !0), b && b?.column === y)
        b.subHeaders.push(h);
      else {
        const R = Hg(n, y, {
          id: [o, p, y.id, h?.id].filter(Boolean).join("_"),
          isPlaceholder: C,
          placeholderId: C ? `${m.filter((S) => S.column === y).length}` : void 0,
          depth: p,
          index: m.length
        });
        R.subHeaders.push(h), m.push(R);
      }
      g.headers.push(h), h.headerGroup = g;
    }), l.push(g), p > 0 && c(m, p - 1);
  }, u = e.map((f, p) => Hg(n, f, {
    depth: i,
    index: p
  }));
  c(u, i - 1), l.reverse();
  const d = (f) => f.filter((g) => g.column.getIsVisible()).map((g) => {
    let m = 0, h = 0, b = [0];
    g.subHeaders && g.subHeaders.length ? (b = [], d(g.subHeaders).forEach((y) => {
      let {
        colSpan: C,
        rowSpan: R
      } = y;
      m += C, b.push(R);
    })) : m = 1;
    const w = Math.min(...b);
    return h = h + w, g.colSpan = m, g.rowSpan = h, {
      colSpan: m,
      rowSpan: h
    };
  });
  return d((r = (s = l[0]) == null ? void 0 : s.headers) != null ? r : []), l;
}
const M7 = (t, e, n, o, r, s, i) => {
  let a = {
    id: e,
    index: o,
    original: n,
    depth: r,
    parentId: i,
    _valuesCache: {},
    _uniqueValuesCache: {},
    getValue: (l) => {
      if (a._valuesCache.hasOwnProperty(l))
        return a._valuesCache[l];
      const c = t.getColumn(l);
      if (c != null && c.accessorFn)
        return a._valuesCache[l] = c.accessorFn(a.original, o), a._valuesCache[l];
    },
    getUniqueValues: (l) => {
      if (a._uniqueValuesCache.hasOwnProperty(l))
        return a._uniqueValuesCache[l];
      const c = t.getColumn(l);
      if (c != null && c.accessorFn)
        return c.columnDef.getUniqueValues ? (a._uniqueValuesCache[l] = c.columnDef.getUniqueValues(a.original, o), a._uniqueValuesCache[l]) : (a._uniqueValuesCache[l] = [a.getValue(l)], a._uniqueValuesCache[l]);
    },
    renderValue: (l) => {
      var c;
      return (c = a.getValue(l)) != null ? c : t.options.renderFallbackValue;
    },
    subRows: [],
    getLeafRows: () => E7(a.subRows, (l) => l.subRows),
    getParentRow: () => a.parentId ? t.getRow(a.parentId, !0) : void 0,
    getParentRows: () => {
      let l = [], c = a;
      for (; ; ) {
        const u = c.getParentRow();
        if (!u) break;
        l.push(u), c = u;
      }
      return l.reverse();
    },
    getAllCells: Je(() => [t.getAllLeafColumns()], (l) => l.map((c) => P7(t, a, c, c.id)), et(t.options, "debugRows", "getAllCells")),
    _getAllCellsByColumnId: Je(() => [a.getAllCells()], (l) => l.reduce((c, u) => (c[u.column.id] = u, c), {}), et(t.options, "debugRows", "getAllCellsByColumnId"))
  };
  for (let l = 0; l < t._features.length; l++) {
    const c = t._features[l];
    c == null || c.createRow == null || c.createRow(a, t);
  }
  return a;
}, T7 = {
  createColumn: (t, e) => {
    t._getFacetedRowModel = e.options.getFacetedRowModel && e.options.getFacetedRowModel(e, t.id), t.getFacetedRowModel = () => t._getFacetedRowModel ? t._getFacetedRowModel() : e.getPreFilteredRowModel(), t._getFacetedUniqueValues = e.options.getFacetedUniqueValues && e.options.getFacetedUniqueValues(e, t.id), t.getFacetedUniqueValues = () => t._getFacetedUniqueValues ? t._getFacetedUniqueValues() : /* @__PURE__ */ new Map(), t._getFacetedMinMaxValues = e.options.getFacetedMinMaxValues && e.options.getFacetedMinMaxValues(e, t.id), t.getFacetedMinMaxValues = () => {
      if (t._getFacetedMinMaxValues)
        return t._getFacetedMinMaxValues();
    };
  }
}, C2 = (t, e, n) => {
  var o, r;
  const s = n == null || (o = n.toString()) == null ? void 0 : o.toLowerCase();
  return !!(!((r = t.getValue(e)) == null || (r = r.toString()) == null || (r = r.toLowerCase()) == null) && r.includes(s));
};
C2.autoRemove = (t) => zn(t);
const S2 = (t, e, n) => {
  var o;
  return !!(!((o = t.getValue(e)) == null || (o = o.toString()) == null) && o.includes(n));
};
S2.autoRemove = (t) => zn(t);
const R2 = (t, e, n) => {
  var o;
  return ((o = t.getValue(e)) == null || (o = o.toString()) == null ? void 0 : o.toLowerCase()) === n?.toLowerCase();
};
R2.autoRemove = (t) => zn(t);
const E2 = (t, e, n) => {
  var o;
  return (o = t.getValue(e)) == null ? void 0 : o.includes(n);
};
E2.autoRemove = (t) => zn(t);
const P2 = (t, e, n) => !n.some((o) => {
  var r;
  return !((r = t.getValue(e)) != null && r.includes(o));
});
P2.autoRemove = (t) => zn(t) || !(t != null && t.length);
const N2 = (t, e, n) => n.some((o) => {
  var r;
  return (r = t.getValue(e)) == null ? void 0 : r.includes(o);
});
N2.autoRemove = (t) => zn(t) || !(t != null && t.length);
const I2 = (t, e, n) => t.getValue(e) === n;
I2.autoRemove = (t) => zn(t);
const M2 = (t, e, n) => t.getValue(e) == n;
M2.autoRemove = (t) => zn(t);
const pf = (t, e, n) => {
  let [o, r] = n;
  const s = t.getValue(e);
  return s >= o && s <= r;
};
pf.resolveFilterValue = (t) => {
  let [e, n] = t, o = typeof e != "number" ? parseFloat(e) : e, r = typeof n != "number" ? parseFloat(n) : n, s = e === null || Number.isNaN(o) ? -1 / 0 : o, i = n === null || Number.isNaN(r) ? 1 / 0 : r;
  if (s > i) {
    const a = s;
    s = i, i = a;
  }
  return [s, i];
};
pf.autoRemove = (t) => zn(t) || zn(t[0]) && zn(t[1]);
const fo = {
  includesString: C2,
  includesStringSensitive: S2,
  equalsString: R2,
  arrIncludes: E2,
  arrIncludesAll: P2,
  arrIncludesSome: N2,
  equals: I2,
  weakEquals: M2,
  inNumberRange: pf
};
function zn(t) {
  return t == null || t === "";
}
const k7 = {
  getDefaultColumnDef: () => ({
    filterFn: "auto"
  }),
  getInitialState: (t) => ({
    columnFilters: [],
    ...t
  }),
  getDefaultOptions: (t) => ({
    onColumnFiltersChange: yn("columnFilters", t),
    filterFromLeafRows: !1,
    maxLeafRowFilterDepth: 100
  }),
  createColumn: (t, e) => {
    t.getAutoFilterFn = () => {
      const n = e.getCoreRowModel().flatRows[0], o = n?.getValue(t.id);
      return typeof o == "string" ? fo.includesString : typeof o == "number" ? fo.inNumberRange : typeof o == "boolean" || o !== null && typeof o == "object" ? fo.equals : Array.isArray(o) ? fo.arrIncludes : fo.weakEquals;
    }, t.getFilterFn = () => {
      var n, o;
      return Ja(t.columnDef.filterFn) ? t.columnDef.filterFn : t.columnDef.filterFn === "auto" ? t.getAutoFilterFn() : (
        // @ts-ignore
        (n = (o = e.options.filterFns) == null ? void 0 : o[t.columnDef.filterFn]) != null ? n : fo[t.columnDef.filterFn]
      );
    }, t.getCanFilter = () => {
      var n, o, r;
      return ((n = t.columnDef.enableColumnFilter) != null ? n : !0) && ((o = e.options.enableColumnFilters) != null ? o : !0) && ((r = e.options.enableFilters) != null ? r : !0) && !!t.accessorFn;
    }, t.getIsFiltered = () => t.getFilterIndex() > -1, t.getFilterValue = () => {
      var n;
      return (n = e.getState().columnFilters) == null || (n = n.find((o) => o.id === t.id)) == null ? void 0 : n.value;
    }, t.getFilterIndex = () => {
      var n, o;
      return (n = (o = e.getState().columnFilters) == null ? void 0 : o.findIndex((r) => r.id === t.id)) != null ? n : -1;
    }, t.setFilterValue = (n) => {
      e.setColumnFilters((o) => {
        const r = t.getFilterFn(), s = o?.find((u) => u.id === t.id), i = To(n, s ? s.value : void 0);
        if (Bg(r, i, t)) {
          var a;
          return (a = o?.filter((u) => u.id !== t.id)) != null ? a : [];
        }
        const l = {
          id: t.id,
          value: i
        };
        if (s) {
          var c;
          return (c = o?.map((u) => u.id === t.id ? l : u)) != null ? c : [];
        }
        return o != null && o.length ? [...o, l] : [l];
      });
    };
  },
  createRow: (t, e) => {
    t.columnFilters = {}, t.columnFiltersMeta = {};
  },
  createTable: (t) => {
    t.setColumnFilters = (e) => {
      const n = t.getAllLeafColumns(), o = (r) => {
        var s;
        return (s = To(e, r)) == null ? void 0 : s.filter((i) => {
          const a = n.find((l) => l.id === i.id);
          if (a) {
            const l = a.getFilterFn();
            if (Bg(l, i.value, a))
              return !1;
          }
          return !0;
        });
      };
      t.options.onColumnFiltersChange == null || t.options.onColumnFiltersChange(o);
    }, t.resetColumnFilters = (e) => {
      var n, o;
      t.setColumnFilters(e ? [] : (n = (o = t.initialState) == null ? void 0 : o.columnFilters) != null ? n : []);
    }, t.getPreFilteredRowModel = () => t.getCoreRowModel(), t.getFilteredRowModel = () => (!t._getFilteredRowModel && t.options.getFilteredRowModel && (t._getFilteredRowModel = t.options.getFilteredRowModel(t)), t.options.manualFiltering || !t._getFilteredRowModel ? t.getPreFilteredRowModel() : t._getFilteredRowModel());
  }
};
function Bg(t, e, n) {
  return (t && t.autoRemove ? t.autoRemove(e, n) : !1) || typeof e > "u" || typeof e == "string" && !e;
}
const O7 = (t, e, n) => n.reduce((o, r) => {
  const s = r.getValue(t);
  return o + (typeof s == "number" ? s : 0);
}, 0), D7 = (t, e, n) => {
  let o;
  return n.forEach((r) => {
    const s = r.getValue(t);
    s != null && (o > s || o === void 0 && s >= s) && (o = s);
  }), o;
}, _7 = (t, e, n) => {
  let o;
  return n.forEach((r) => {
    const s = r.getValue(t);
    s != null && (o < s || o === void 0 && s >= s) && (o = s);
  }), o;
}, V7 = (t, e, n) => {
  let o, r;
  return n.forEach((s) => {
    const i = s.getValue(t);
    i != null && (o === void 0 ? i >= i && (o = r = i) : (o > i && (o = i), r < i && (r = i)));
  }), [o, r];
}, A7 = (t, e) => {
  let n = 0, o = 0;
  if (e.forEach((r) => {
    let s = r.getValue(t);
    s != null && (s = +s) >= s && (++n, o += s);
  }), n) return o / n;
}, F7 = (t, e) => {
  if (!e.length)
    return;
  const n = e.map((s) => s.getValue(t));
  if (!R7(n))
    return;
  if (n.length === 1)
    return n[0];
  const o = Math.floor(n.length / 2), r = n.sort((s, i) => s - i);
  return n.length % 2 !== 0 ? r[o] : (r[o - 1] + r[o]) / 2;
}, L7 = (t, e) => Array.from(new Set(e.map((n) => n.getValue(t))).values()), $7 = (t, e) => new Set(e.map((n) => n.getValue(t))).size, z7 = (t, e) => e.length, ql = {
  sum: O7,
  min: D7,
  max: _7,
  extent: V7,
  mean: A7,
  median: F7,
  unique: L7,
  uniqueCount: $7,
  count: z7
}, H7 = {
  getDefaultColumnDef: () => ({
    aggregatedCell: (t) => {
      var e, n;
      return (e = (n = t.getValue()) == null || n.toString == null ? void 0 : n.toString()) != null ? e : null;
    },
    aggregationFn: "auto"
  }),
  getInitialState: (t) => ({
    grouping: [],
    ...t
  }),
  getDefaultOptions: (t) => ({
    onGroupingChange: yn("grouping", t),
    groupedColumnMode: "reorder"
  }),
  createColumn: (t, e) => {
    t.toggleGrouping = () => {
      e.setGrouping((n) => n != null && n.includes(t.id) ? n.filter((o) => o !== t.id) : [...n ?? [], t.id]);
    }, t.getCanGroup = () => {
      var n, o;
      return ((n = t.columnDef.enableGrouping) != null ? n : !0) && ((o = e.options.enableGrouping) != null ? o : !0) && (!!t.accessorFn || !!t.columnDef.getGroupingValue);
    }, t.getIsGrouped = () => {
      var n;
      return (n = e.getState().grouping) == null ? void 0 : n.includes(t.id);
    }, t.getGroupedIndex = () => {
      var n;
      return (n = e.getState().grouping) == null ? void 0 : n.indexOf(t.id);
    }, t.getToggleGroupingHandler = () => {
      const n = t.getCanGroup();
      return () => {
        n && t.toggleGrouping();
      };
    }, t.getAutoAggregationFn = () => {
      const n = e.getCoreRowModel().flatRows[0], o = n?.getValue(t.id);
      if (typeof o == "number")
        return ql.sum;
      if (Object.prototype.toString.call(o) === "[object Date]")
        return ql.extent;
    }, t.getAggregationFn = () => {
      var n, o;
      if (!t)
        throw new Error();
      return Ja(t.columnDef.aggregationFn) ? t.columnDef.aggregationFn : t.columnDef.aggregationFn === "auto" ? t.getAutoAggregationFn() : (n = (o = e.options.aggregationFns) == null ? void 0 : o[t.columnDef.aggregationFn]) != null ? n : ql[t.columnDef.aggregationFn];
    };
  },
  createTable: (t) => {
    t.setGrouping = (e) => t.options.onGroupingChange == null ? void 0 : t.options.onGroupingChange(e), t.resetGrouping = (e) => {
      var n, o;
      t.setGrouping(e ? [] : (n = (o = t.initialState) == null ? void 0 : o.grouping) != null ? n : []);
    }, t.getPreGroupedRowModel = () => t.getFilteredRowModel(), t.getGroupedRowModel = () => (!t._getGroupedRowModel && t.options.getGroupedRowModel && (t._getGroupedRowModel = t.options.getGroupedRowModel(t)), t.options.manualGrouping || !t._getGroupedRowModel ? t.getPreGroupedRowModel() : t._getGroupedRowModel());
  },
  createRow: (t, e) => {
    t.getIsGrouped = () => !!t.groupingColumnId, t.getGroupingValue = (n) => {
      if (t._groupingValuesCache.hasOwnProperty(n))
        return t._groupingValuesCache[n];
      const o = e.getColumn(n);
      return o != null && o.columnDef.getGroupingValue ? (t._groupingValuesCache[n] = o.columnDef.getGroupingValue(t.original), t._groupingValuesCache[n]) : t.getValue(n);
    }, t._groupingValuesCache = {};
  },
  createCell: (t, e, n, o) => {
    t.getIsGrouped = () => e.getIsGrouped() && e.id === n.groupingColumnId, t.getIsPlaceholder = () => !t.getIsGrouped() && e.getIsGrouped(), t.getIsAggregated = () => {
      var r;
      return !t.getIsGrouped() && !t.getIsPlaceholder() && !!((r = n.subRows) != null && r.length);
    };
  }
};
function B7(t, e, n) {
  if (!(e != null && e.length) || !n)
    return t;
  const o = t.filter((s) => !e.includes(s.id));
  return n === "remove" ? o : [...e.map((s) => t.find((i) => i.id === s)).filter(Boolean), ...o];
}
const W7 = {
  getInitialState: (t) => ({
    columnOrder: [],
    ...t
  }),
  getDefaultOptions: (t) => ({
    onColumnOrderChange: yn("columnOrder", t)
  }),
  createColumn: (t, e) => {
    t.getIndex = Je((n) => [hs(e, n)], (n) => n.findIndex((o) => o.id === t.id), et(e.options, "debugColumns", "getIndex")), t.getIsFirstColumn = (n) => {
      var o;
      return ((o = hs(e, n)[0]) == null ? void 0 : o.id) === t.id;
    }, t.getIsLastColumn = (n) => {
      var o;
      const r = hs(e, n);
      return ((o = r[r.length - 1]) == null ? void 0 : o.id) === t.id;
    };
  },
  createTable: (t) => {
    t.setColumnOrder = (e) => t.options.onColumnOrderChange == null ? void 0 : t.options.onColumnOrderChange(e), t.resetColumnOrder = (e) => {
      var n;
      t.setColumnOrder(e ? [] : (n = t.initialState.columnOrder) != null ? n : []);
    }, t._getOrderColumnsFn = Je(() => [t.getState().columnOrder, t.getState().grouping, t.options.groupedColumnMode], (e, n, o) => (r) => {
      let s = [];
      if (!(e != null && e.length))
        s = r;
      else {
        const i = [...e], a = [...r];
        for (; a.length && i.length; ) {
          const l = i.shift(), c = a.findIndex((u) => u.id === l);
          c > -1 && s.push(a.splice(c, 1)[0]);
        }
        s = [...s, ...a];
      }
      return B7(s, n, o);
    }, et(t.options, "debugTable", "_getOrderColumnsFn"));
  }
}, Xl = () => ({
  left: [],
  right: []
}), U7 = {
  getInitialState: (t) => ({
    columnPinning: Xl(),
    ...t
  }),
  getDefaultOptions: (t) => ({
    onColumnPinningChange: yn("columnPinning", t)
  }),
  createColumn: (t, e) => {
    t.pin = (n) => {
      const o = t.getLeafColumns().map((r) => r.id).filter(Boolean);
      e.setColumnPinning((r) => {
        var s, i;
        if (n === "right") {
          var a, l;
          return {
            left: ((a = r?.left) != null ? a : []).filter((d) => !(o != null && o.includes(d))),
            right: [...((l = r?.right) != null ? l : []).filter((d) => !(o != null && o.includes(d))), ...o]
          };
        }
        if (n === "left") {
          var c, u;
          return {
            left: [...((c = r?.left) != null ? c : []).filter((d) => !(o != null && o.includes(d))), ...o],
            right: ((u = r?.right) != null ? u : []).filter((d) => !(o != null && o.includes(d)))
          };
        }
        return {
          left: ((s = r?.left) != null ? s : []).filter((d) => !(o != null && o.includes(d))),
          right: ((i = r?.right) != null ? i : []).filter((d) => !(o != null && o.includes(d)))
        };
      });
    }, t.getCanPin = () => t.getLeafColumns().some((o) => {
      var r, s, i;
      return ((r = o.columnDef.enablePinning) != null ? r : !0) && ((s = (i = e.options.enableColumnPinning) != null ? i : e.options.enablePinning) != null ? s : !0);
    }), t.getIsPinned = () => {
      const n = t.getLeafColumns().map((a) => a.id), {
        left: o,
        right: r
      } = e.getState().columnPinning, s = n.some((a) => o?.includes(a)), i = n.some((a) => r?.includes(a));
      return s ? "left" : i ? "right" : !1;
    }, t.getPinnedIndex = () => {
      var n, o;
      const r = t.getIsPinned();
      return r ? (n = (o = e.getState().columnPinning) == null || (o = o[r]) == null ? void 0 : o.indexOf(t.id)) != null ? n : -1 : 0;
    };
  },
  createRow: (t, e) => {
    t.getCenterVisibleCells = Je(() => [t._getAllVisibleCells(), e.getState().columnPinning.left, e.getState().columnPinning.right], (n, o, r) => {
      const s = [...o ?? [], ...r ?? []];
      return n.filter((i) => !s.includes(i.column.id));
    }, et(e.options, "debugRows", "getCenterVisibleCells")), t.getLeftVisibleCells = Je(() => [t._getAllVisibleCells(), e.getState().columnPinning.left], (n, o) => (o ?? []).map((s) => n.find((i) => i.column.id === s)).filter(Boolean).map((s) => ({
      ...s,
      position: "left"
    })), et(e.options, "debugRows", "getLeftVisibleCells")), t.getRightVisibleCells = Je(() => [t._getAllVisibleCells(), e.getState().columnPinning.right], (n, o) => (o ?? []).map((s) => n.find((i) => i.column.id === s)).filter(Boolean).map((s) => ({
      ...s,
      position: "right"
    })), et(e.options, "debugRows", "getRightVisibleCells"));
  },
  createTable: (t) => {
    t.setColumnPinning = (e) => t.options.onColumnPinningChange == null ? void 0 : t.options.onColumnPinningChange(e), t.resetColumnPinning = (e) => {
      var n, o;
      return t.setColumnPinning(e ? Xl() : (n = (o = t.initialState) == null ? void 0 : o.columnPinning) != null ? n : Xl());
    }, t.getIsSomeColumnsPinned = (e) => {
      var n;
      const o = t.getState().columnPinning;
      if (!e) {
        var r, s;
        return !!((r = o.left) != null && r.length || (s = o.right) != null && s.length);
      }
      return !!((n = o[e]) != null && n.length);
    }, t.getLeftLeafColumns = Je(() => [t.getAllLeafColumns(), t.getState().columnPinning.left], (e, n) => (n ?? []).map((o) => e.find((r) => r.id === o)).filter(Boolean), et(t.options, "debugColumns", "getLeftLeafColumns")), t.getRightLeafColumns = Je(() => [t.getAllLeafColumns(), t.getState().columnPinning.right], (e, n) => (n ?? []).map((o) => e.find((r) => r.id === o)).filter(Boolean), et(t.options, "debugColumns", "getRightLeafColumns")), t.getCenterLeafColumns = Je(() => [t.getAllLeafColumns(), t.getState().columnPinning.left, t.getState().columnPinning.right], (e, n, o) => {
      const r = [...n ?? [], ...o ?? []];
      return e.filter((s) => !r.includes(s.id));
    }, et(t.options, "debugColumns", "getCenterLeafColumns"));
  }
};
function Y7(t) {
  return t || (typeof document < "u" ? document : null);
}
const zi = {
  size: 150,
  minSize: 20,
  maxSize: Number.MAX_SAFE_INTEGER
}, Zl = () => ({
  startOffset: null,
  startSize: null,
  deltaOffset: null,
  deltaPercentage: null,
  isResizingColumn: !1,
  columnSizingStart: []
}), G7 = {
  getDefaultColumnDef: () => zi,
  getInitialState: (t) => ({
    columnSizing: {},
    columnSizingInfo: Zl(),
    ...t
  }),
  getDefaultOptions: (t) => ({
    columnResizeMode: "onEnd",
    columnResizeDirection: "ltr",
    onColumnSizingChange: yn("columnSizing", t),
    onColumnSizingInfoChange: yn("columnSizingInfo", t)
  }),
  createColumn: (t, e) => {
    t.getSize = () => {
      var n, o, r;
      const s = e.getState().columnSizing[t.id];
      return Math.min(Math.max((n = t.columnDef.minSize) != null ? n : zi.minSize, (o = s ?? t.columnDef.size) != null ? o : zi.size), (r = t.columnDef.maxSize) != null ? r : zi.maxSize);
    }, t.getStart = Je((n) => [n, hs(e, n), e.getState().columnSizing], (n, o) => o.slice(0, t.getIndex(n)).reduce((r, s) => r + s.getSize(), 0), et(e.options, "debugColumns", "getStart")), t.getAfter = Je((n) => [n, hs(e, n), e.getState().columnSizing], (n, o) => o.slice(t.getIndex(n) + 1).reduce((r, s) => r + s.getSize(), 0), et(e.options, "debugColumns", "getAfter")), t.resetSize = () => {
      e.setColumnSizing((n) => {
        let {
          [t.id]: o,
          ...r
        } = n;
        return r;
      });
    }, t.getCanResize = () => {
      var n, o;
      return ((n = t.columnDef.enableResizing) != null ? n : !0) && ((o = e.options.enableColumnResizing) != null ? o : !0);
    }, t.getIsResizing = () => e.getState().columnSizingInfo.isResizingColumn === t.id;
  },
  createHeader: (t, e) => {
    t.getSize = () => {
      let n = 0;
      const o = (r) => {
        if (r.subHeaders.length)
          r.subHeaders.forEach(o);
        else {
          var s;
          n += (s = r.column.getSize()) != null ? s : 0;
        }
      };
      return o(t), n;
    }, t.getStart = () => {
      if (t.index > 0) {
        const n = t.headerGroup.headers[t.index - 1];
        return n.getStart() + n.getSize();
      }
      return 0;
    }, t.getResizeHandler = (n) => {
      const o = e.getColumn(t.column.id), r = o?.getCanResize();
      return (s) => {
        if (!o || !r || (s.persist == null || s.persist(), Ql(s) && s.touches && s.touches.length > 1))
          return;
        const i = t.getSize(), a = t ? t.getLeafHeaders().map((b) => [b.column.id, b.column.getSize()]) : [[o.id, o.getSize()]], l = Ql(s) ? Math.round(s.touches[0].clientX) : s.clientX, c = {}, u = (b, w) => {
          typeof w == "number" && (e.setColumnSizingInfo((y) => {
            var C, R;
            const S = e.options.columnResizeDirection === "rtl" ? -1 : 1, E = (w - ((C = y?.startOffset) != null ? C : 0)) * S, P = Math.max(E / ((R = y?.startSize) != null ? R : 0), -0.999999);
            return y.columnSizingStart.forEach((N) => {
              let [I, M] = N;
              c[I] = Math.round(Math.max(M + M * P, 0) * 100) / 100;
            }), {
              ...y,
              deltaOffset: E,
              deltaPercentage: P
            };
          }), (e.options.columnResizeMode === "onChange" || b === "end") && e.setColumnSizing((y) => ({
            ...y,
            ...c
          })));
        }, d = (b) => u("move", b), f = (b) => {
          u("end", b), e.setColumnSizingInfo((w) => ({
            ...w,
            isResizingColumn: !1,
            startOffset: null,
            startSize: null,
            deltaOffset: null,
            deltaPercentage: null,
            columnSizingStart: []
          }));
        }, p = Y7(n), g = {
          moveHandler: (b) => d(b.clientX),
          upHandler: (b) => {
            p?.removeEventListener("mousemove", g.moveHandler), p?.removeEventListener("mouseup", g.upHandler), f(b.clientX);
          }
        }, m = {
          moveHandler: (b) => (b.cancelable && (b.preventDefault(), b.stopPropagation()), d(b.touches[0].clientX), !1),
          upHandler: (b) => {
            var w;
            p?.removeEventListener("touchmove", m.moveHandler), p?.removeEventListener("touchend", m.upHandler), b.cancelable && (b.preventDefault(), b.stopPropagation()), f((w = b.touches[0]) == null ? void 0 : w.clientX);
          }
        }, h = j7() ? {
          passive: !1
        } : !1;
        Ql(s) ? (p?.addEventListener("touchmove", m.moveHandler, h), p?.addEventListener("touchend", m.upHandler, h)) : (p?.addEventListener("mousemove", g.moveHandler, h), p?.addEventListener("mouseup", g.upHandler, h)), e.setColumnSizingInfo((b) => ({
          ...b,
          startOffset: l,
          startSize: i,
          deltaOffset: 0,
          deltaPercentage: 0,
          columnSizingStart: a,
          isResizingColumn: o.id
        }));
      };
    };
  },
  createTable: (t) => {
    t.setColumnSizing = (e) => t.options.onColumnSizingChange == null ? void 0 : t.options.onColumnSizingChange(e), t.setColumnSizingInfo = (e) => t.options.onColumnSizingInfoChange == null ? void 0 : t.options.onColumnSizingInfoChange(e), t.resetColumnSizing = (e) => {
      var n;
      t.setColumnSizing(e ? {} : (n = t.initialState.columnSizing) != null ? n : {});
    }, t.resetHeaderSizeInfo = (e) => {
      var n;
      t.setColumnSizingInfo(e ? Zl() : (n = t.initialState.columnSizingInfo) != null ? n : Zl());
    }, t.getTotalSize = () => {
      var e, n;
      return (e = (n = t.getHeaderGroups()[0]) == null ? void 0 : n.headers.reduce((o, r) => o + r.getSize(), 0)) != null ? e : 0;
    }, t.getLeftTotalSize = () => {
      var e, n;
      return (e = (n = t.getLeftHeaderGroups()[0]) == null ? void 0 : n.headers.reduce((o, r) => o + r.getSize(), 0)) != null ? e : 0;
    }, t.getCenterTotalSize = () => {
      var e, n;
      return (e = (n = t.getCenterHeaderGroups()[0]) == null ? void 0 : n.headers.reduce((o, r) => o + r.getSize(), 0)) != null ? e : 0;
    }, t.getRightTotalSize = () => {
      var e, n;
      return (e = (n = t.getRightHeaderGroups()[0]) == null ? void 0 : n.headers.reduce((o, r) => o + r.getSize(), 0)) != null ? e : 0;
    };
  }
};
let Hi = null;
function j7() {
  if (typeof Hi == "boolean") return Hi;
  let t = !1;
  try {
    const e = {
      get passive() {
        return t = !0, !1;
      }
    }, n = () => {
    };
    window.addEventListener("test", n, e), window.removeEventListener("test", n);
  } catch {
    t = !1;
  }
  return Hi = t, Hi;
}
function Ql(t) {
  return t.type === "touchstart";
}
const K7 = {
  getInitialState: (t) => ({
    columnVisibility: {},
    ...t
  }),
  getDefaultOptions: (t) => ({
    onColumnVisibilityChange: yn("columnVisibility", t)
  }),
  createColumn: (t, e) => {
    t.toggleVisibility = (n) => {
      t.getCanHide() && e.setColumnVisibility((o) => ({
        ...o,
        [t.id]: n ?? !t.getIsVisible()
      }));
    }, t.getIsVisible = () => {
      var n, o;
      const r = t.columns;
      return (n = r.length ? r.some((s) => s.getIsVisible()) : (o = e.getState().columnVisibility) == null ? void 0 : o[t.id]) != null ? n : !0;
    }, t.getCanHide = () => {
      var n, o;
      return ((n = t.columnDef.enableHiding) != null ? n : !0) && ((o = e.options.enableHiding) != null ? o : !0);
    }, t.getToggleVisibilityHandler = () => (n) => {
      t.toggleVisibility == null || t.toggleVisibility(n.target.checked);
    };
  },
  createRow: (t, e) => {
    t._getAllVisibleCells = Je(() => [t.getAllCells(), e.getState().columnVisibility], (n) => n.filter((o) => o.column.getIsVisible()), et(e.options, "debugRows", "_getAllVisibleCells")), t.getVisibleCells = Je(() => [t.getLeftVisibleCells(), t.getCenterVisibleCells(), t.getRightVisibleCells()], (n, o, r) => [...n, ...o, ...r], et(e.options, "debugRows", "getVisibleCells"));
  },
  createTable: (t) => {
    const e = (n, o) => Je(() => [o(), o().filter((r) => r.getIsVisible()).map((r) => r.id).join("_")], (r) => r.filter((s) => s.getIsVisible == null ? void 0 : s.getIsVisible()), et(t.options, "debugColumns", n));
    t.getVisibleFlatColumns = e("getVisibleFlatColumns", () => t.getAllFlatColumns()), t.getVisibleLeafColumns = e("getVisibleLeafColumns", () => t.getAllLeafColumns()), t.getLeftVisibleLeafColumns = e("getLeftVisibleLeafColumns", () => t.getLeftLeafColumns()), t.getRightVisibleLeafColumns = e("getRightVisibleLeafColumns", () => t.getRightLeafColumns()), t.getCenterVisibleLeafColumns = e("getCenterVisibleLeafColumns", () => t.getCenterLeafColumns()), t.setColumnVisibility = (n) => t.options.onColumnVisibilityChange == null ? void 0 : t.options.onColumnVisibilityChange(n), t.resetColumnVisibility = (n) => {
      var o;
      t.setColumnVisibility(n ? {} : (o = t.initialState.columnVisibility) != null ? o : {});
    }, t.toggleAllColumnsVisible = (n) => {
      var o;
      n = (o = n) != null ? o : !t.getIsAllColumnsVisible(), t.setColumnVisibility(t.getAllLeafColumns().reduce((r, s) => ({
        ...r,
        [s.id]: n || !(s.getCanHide != null && s.getCanHide())
      }), {}));
    }, t.getIsAllColumnsVisible = () => !t.getAllLeafColumns().some((n) => !(n.getIsVisible != null && n.getIsVisible())), t.getIsSomeColumnsVisible = () => t.getAllLeafColumns().some((n) => n.getIsVisible == null ? void 0 : n.getIsVisible()), t.getToggleAllColumnsVisibilityHandler = () => (n) => {
      var o;
      t.toggleAllColumnsVisible((o = n.target) == null ? void 0 : o.checked);
    };
  }
};
function hs(t, e) {
  return e ? e === "center" ? t.getCenterVisibleLeafColumns() : e === "left" ? t.getLeftVisibleLeafColumns() : t.getRightVisibleLeafColumns() : t.getVisibleLeafColumns();
}
const q7 = {
  createTable: (t) => {
    t._getGlobalFacetedRowModel = t.options.getFacetedRowModel && t.options.getFacetedRowModel(t, "__global__"), t.getGlobalFacetedRowModel = () => t.options.manualFiltering || !t._getGlobalFacetedRowModel ? t.getPreFilteredRowModel() : t._getGlobalFacetedRowModel(), t._getGlobalFacetedUniqueValues = t.options.getFacetedUniqueValues && t.options.getFacetedUniqueValues(t, "__global__"), t.getGlobalFacetedUniqueValues = () => t._getGlobalFacetedUniqueValues ? t._getGlobalFacetedUniqueValues() : /* @__PURE__ */ new Map(), t._getGlobalFacetedMinMaxValues = t.options.getFacetedMinMaxValues && t.options.getFacetedMinMaxValues(t, "__global__"), t.getGlobalFacetedMinMaxValues = () => {
      if (t._getGlobalFacetedMinMaxValues)
        return t._getGlobalFacetedMinMaxValues();
    };
  }
}, X7 = {
  getInitialState: (t) => ({
    globalFilter: void 0,
    ...t
  }),
  getDefaultOptions: (t) => ({
    onGlobalFilterChange: yn("globalFilter", t),
    globalFilterFn: "auto",
    getColumnCanGlobalFilter: (e) => {
      var n;
      const o = (n = t.getCoreRowModel().flatRows[0]) == null || (n = n._getAllCellsByColumnId()[e.id]) == null ? void 0 : n.getValue();
      return typeof o == "string" || typeof o == "number";
    }
  }),
  createColumn: (t, e) => {
    t.getCanGlobalFilter = () => {
      var n, o, r, s;
      return ((n = t.columnDef.enableGlobalFilter) != null ? n : !0) && ((o = e.options.enableGlobalFilter) != null ? o : !0) && ((r = e.options.enableFilters) != null ? r : !0) && ((s = e.options.getColumnCanGlobalFilter == null ? void 0 : e.options.getColumnCanGlobalFilter(t)) != null ? s : !0) && !!t.accessorFn;
    };
  },
  createTable: (t) => {
    t.getGlobalAutoFilterFn = () => fo.includesString, t.getGlobalFilterFn = () => {
      var e, n;
      const {
        globalFilterFn: o
      } = t.options;
      return Ja(o) ? o : o === "auto" ? t.getGlobalAutoFilterFn() : (e = (n = t.options.filterFns) == null ? void 0 : n[o]) != null ? e : fo[o];
    }, t.setGlobalFilter = (e) => {
      t.options.onGlobalFilterChange == null || t.options.onGlobalFilterChange(e);
    }, t.resetGlobalFilter = (e) => {
      t.setGlobalFilter(e ? void 0 : t.initialState.globalFilter);
    };
  }
}, Z7 = {
  getInitialState: (t) => ({
    expanded: {},
    ...t
  }),
  getDefaultOptions: (t) => ({
    onExpandedChange: yn("expanded", t),
    paginateExpandedRows: !0
  }),
  createTable: (t) => {
    let e = !1, n = !1;
    t._autoResetExpanded = () => {
      var o, r;
      if (!e) {
        t._queue(() => {
          e = !0;
        });
        return;
      }
      if ((o = (r = t.options.autoResetAll) != null ? r : t.options.autoResetExpanded) != null ? o : !t.options.manualExpanding) {
        if (n) return;
        n = !0, t._queue(() => {
          t.resetExpanded(), n = !1;
        });
      }
    }, t.setExpanded = (o) => t.options.onExpandedChange == null ? void 0 : t.options.onExpandedChange(o), t.toggleAllRowsExpanded = (o) => {
      o ?? !t.getIsAllRowsExpanded() ? t.setExpanded(!0) : t.setExpanded({});
    }, t.resetExpanded = (o) => {
      var r, s;
      t.setExpanded(o ? {} : (r = (s = t.initialState) == null ? void 0 : s.expanded) != null ? r : {});
    }, t.getCanSomeRowsExpand = () => t.getPrePaginationRowModel().flatRows.some((o) => o.getCanExpand()), t.getToggleAllRowsExpandedHandler = () => (o) => {
      o.persist == null || o.persist(), t.toggleAllRowsExpanded();
    }, t.getIsSomeRowsExpanded = () => {
      const o = t.getState().expanded;
      return o === !0 || Object.values(o).some(Boolean);
    }, t.getIsAllRowsExpanded = () => {
      const o = t.getState().expanded;
      return typeof o == "boolean" ? o === !0 : !(!Object.keys(o).length || t.getRowModel().flatRows.some((r) => !r.getIsExpanded()));
    }, t.getExpandedDepth = () => {
      let o = 0;
      return (t.getState().expanded === !0 ? Object.keys(t.getRowModel().rowsById) : Object.keys(t.getState().expanded)).forEach((s) => {
        const i = s.split(".");
        o = Math.max(o, i.length);
      }), o;
    }, t.getPreExpandedRowModel = () => t.getSortedRowModel(), t.getExpandedRowModel = () => (!t._getExpandedRowModel && t.options.getExpandedRowModel && (t._getExpandedRowModel = t.options.getExpandedRowModel(t)), t.options.manualExpanding || !t._getExpandedRowModel ? t.getPreExpandedRowModel() : t._getExpandedRowModel());
  },
  createRow: (t, e) => {
    t.toggleExpanded = (n) => {
      e.setExpanded((o) => {
        var r;
        const s = o === !0 ? !0 : !!(o != null && o[t.id]);
        let i = {};
        if (o === !0 ? Object.keys(e.getRowModel().rowsById).forEach((a) => {
          i[a] = !0;
        }) : i = o, n = (r = n) != null ? r : !s, !s && n)
          return {
            ...i,
            [t.id]: !0
          };
        if (s && !n) {
          const {
            [t.id]: a,
            ...l
          } = i;
          return l;
        }
        return o;
      });
    }, t.getIsExpanded = () => {
      var n;
      const o = e.getState().expanded;
      return !!((n = e.options.getIsRowExpanded == null ? void 0 : e.options.getIsRowExpanded(t)) != null ? n : o === !0 || o?.[t.id]);
    }, t.getCanExpand = () => {
      var n, o, r;
      return (n = e.options.getRowCanExpand == null ? void 0 : e.options.getRowCanExpand(t)) != null ? n : ((o = e.options.enableExpanding) != null ? o : !0) && !!((r = t.subRows) != null && r.length);
    }, t.getIsAllParentsExpanded = () => {
      let n = !0, o = t;
      for (; n && o.parentId; )
        o = e.getRow(o.parentId, !0), n = o.getIsExpanded();
      return n;
    }, t.getToggleExpandedHandler = () => {
      const n = t.getCanExpand();
      return () => {
        n && t.toggleExpanded();
      };
    };
  }
}, Ec = 0, Pc = 10, Jl = () => ({
  pageIndex: Ec,
  pageSize: Pc
}), Q7 = {
  getInitialState: (t) => ({
    ...t,
    pagination: {
      ...Jl(),
      ...t?.pagination
    }
  }),
  getDefaultOptions: (t) => ({
    onPaginationChange: yn("pagination", t)
  }),
  createTable: (t) => {
    let e = !1, n = !1;
    t._autoResetPageIndex = () => {
      var o, r;
      if (!e) {
        t._queue(() => {
          e = !0;
        });
        return;
      }
      if ((o = (r = t.options.autoResetAll) != null ? r : t.options.autoResetPageIndex) != null ? o : !t.options.manualPagination) {
        if (n) return;
        n = !0, t._queue(() => {
          t.resetPageIndex(), n = !1;
        });
      }
    }, t.setPagination = (o) => {
      const r = (s) => To(o, s);
      return t.options.onPaginationChange == null ? void 0 : t.options.onPaginationChange(r);
    }, t.resetPagination = (o) => {
      var r;
      t.setPagination(o ? Jl() : (r = t.initialState.pagination) != null ? r : Jl());
    }, t.setPageIndex = (o) => {
      t.setPagination((r) => {
        let s = To(o, r.pageIndex);
        const i = typeof t.options.pageCount > "u" || t.options.pageCount === -1 ? Number.MAX_SAFE_INTEGER : t.options.pageCount - 1;
        return s = Math.max(0, Math.min(s, i)), {
          ...r,
          pageIndex: s
        };
      });
    }, t.resetPageIndex = (o) => {
      var r, s;
      t.setPageIndex(o ? Ec : (r = (s = t.initialState) == null || (s = s.pagination) == null ? void 0 : s.pageIndex) != null ? r : Ec);
    }, t.resetPageSize = (o) => {
      var r, s;
      t.setPageSize(o ? Pc : (r = (s = t.initialState) == null || (s = s.pagination) == null ? void 0 : s.pageSize) != null ? r : Pc);
    }, t.setPageSize = (o) => {
      t.setPagination((r) => {
        const s = Math.max(1, To(o, r.pageSize)), i = r.pageSize * r.pageIndex, a = Math.floor(i / s);
        return {
          ...r,
          pageIndex: a,
          pageSize: s
        };
      });
    }, t.setPageCount = (o) => t.setPagination((r) => {
      var s;
      let i = To(o, (s = t.options.pageCount) != null ? s : -1);
      return typeof i == "number" && (i = Math.max(-1, i)), {
        ...r,
        pageCount: i
      };
    }), t.getPageOptions = Je(() => [t.getPageCount()], (o) => {
      let r = [];
      return o && o > 0 && (r = [...new Array(o)].fill(null).map((s, i) => i)), r;
    }, et(t.options, "debugTable", "getPageOptions")), t.getCanPreviousPage = () => t.getState().pagination.pageIndex > 0, t.getCanNextPage = () => {
      const {
        pageIndex: o
      } = t.getState().pagination, r = t.getPageCount();
      return r === -1 ? !0 : r === 0 ? !1 : o < r - 1;
    }, t.previousPage = () => t.setPageIndex((o) => o - 1), t.nextPage = () => t.setPageIndex((o) => o + 1), t.firstPage = () => t.setPageIndex(0), t.lastPage = () => t.setPageIndex(t.getPageCount() - 1), t.getPrePaginationRowModel = () => t.getExpandedRowModel(), t.getPaginationRowModel = () => (!t._getPaginationRowModel && t.options.getPaginationRowModel && (t._getPaginationRowModel = t.options.getPaginationRowModel(t)), t.options.manualPagination || !t._getPaginationRowModel ? t.getPrePaginationRowModel() : t._getPaginationRowModel()), t.getPageCount = () => {
      var o;
      return (o = t.options.pageCount) != null ? o : Math.ceil(t.getRowCount() / t.getState().pagination.pageSize);
    }, t.getRowCount = () => {
      var o;
      return (o = t.options.rowCount) != null ? o : t.getPrePaginationRowModel().rows.length;
    };
  }
}, ec = () => ({
  top: [],
  bottom: []
}), J7 = {
  getInitialState: (t) => ({
    rowPinning: ec(),
    ...t
  }),
  getDefaultOptions: (t) => ({
    onRowPinningChange: yn("rowPinning", t)
  }),
  createRow: (t, e) => {
    t.pin = (n, o, r) => {
      const s = o ? t.getLeafRows().map((l) => {
        let {
          id: c
        } = l;
        return c;
      }) : [], i = r ? t.getParentRows().map((l) => {
        let {
          id: c
        } = l;
        return c;
      }) : [], a = /* @__PURE__ */ new Set([...i, t.id, ...s]);
      e.setRowPinning((l) => {
        var c, u;
        if (n === "bottom") {
          var d, f;
          return {
            top: ((d = l?.top) != null ? d : []).filter((m) => !(a != null && a.has(m))),
            bottom: [...((f = l?.bottom) != null ? f : []).filter((m) => !(a != null && a.has(m))), ...Array.from(a)]
          };
        }
        if (n === "top") {
          var p, g;
          return {
            top: [...((p = l?.top) != null ? p : []).filter((m) => !(a != null && a.has(m))), ...Array.from(a)],
            bottom: ((g = l?.bottom) != null ? g : []).filter((m) => !(a != null && a.has(m)))
          };
        }
        return {
          top: ((c = l?.top) != null ? c : []).filter((m) => !(a != null && a.has(m))),
          bottom: ((u = l?.bottom) != null ? u : []).filter((m) => !(a != null && a.has(m)))
        };
      });
    }, t.getCanPin = () => {
      var n;
      const {
        enableRowPinning: o,
        enablePinning: r
      } = e.options;
      return typeof o == "function" ? o(t) : (n = o ?? r) != null ? n : !0;
    }, t.getIsPinned = () => {
      const n = [t.id], {
        top: o,
        bottom: r
      } = e.getState().rowPinning, s = n.some((a) => o?.includes(a)), i = n.some((a) => r?.includes(a));
      return s ? "top" : i ? "bottom" : !1;
    }, t.getPinnedIndex = () => {
      var n, o;
      const r = t.getIsPinned();
      if (!r) return -1;
      const s = (n = r === "top" ? e.getTopRows() : e.getBottomRows()) == null ? void 0 : n.map((i) => {
        let {
          id: a
        } = i;
        return a;
      });
      return (o = s?.indexOf(t.id)) != null ? o : -1;
    };
  },
  createTable: (t) => {
    t.setRowPinning = (e) => t.options.onRowPinningChange == null ? void 0 : t.options.onRowPinningChange(e), t.resetRowPinning = (e) => {
      var n, o;
      return t.setRowPinning(e ? ec() : (n = (o = t.initialState) == null ? void 0 : o.rowPinning) != null ? n : ec());
    }, t.getIsSomeRowsPinned = (e) => {
      var n;
      const o = t.getState().rowPinning;
      if (!e) {
        var r, s;
        return !!((r = o.top) != null && r.length || (s = o.bottom) != null && s.length);
      }
      return !!((n = o[e]) != null && n.length);
    }, t._getPinnedRows = (e, n, o) => {
      var r;
      return ((r = t.options.keepPinnedRows) == null || r ? (
        //get all rows that are pinned even if they would not be otherwise visible
        //account for expanded parent rows, but not pagination or filtering
        (n ?? []).map((i) => {
          const a = t.getRow(i, !0);
          return a.getIsAllParentsExpanded() ? a : null;
        })
      ) : (
        //else get only visible rows that are pinned
        (n ?? []).map((i) => e.find((a) => a.id === i))
      )).filter(Boolean).map((i) => ({
        ...i,
        position: o
      }));
    }, t.getTopRows = Je(() => [t.getRowModel().rows, t.getState().rowPinning.top], (e, n) => t._getPinnedRows(e, n, "top"), et(t.options, "debugRows", "getTopRows")), t.getBottomRows = Je(() => [t.getRowModel().rows, t.getState().rowPinning.bottom], (e, n) => t._getPinnedRows(e, n, "bottom"), et(t.options, "debugRows", "getBottomRows")), t.getCenterRows = Je(() => [t.getRowModel().rows, t.getState().rowPinning.top, t.getState().rowPinning.bottom], (e, n, o) => {
      const r = /* @__PURE__ */ new Set([...n ?? [], ...o ?? []]);
      return e.filter((s) => !r.has(s.id));
    }, et(t.options, "debugRows", "getCenterRows"));
  }
}, eE = {
  getInitialState: (t) => ({
    rowSelection: {},
    ...t
  }),
  getDefaultOptions: (t) => ({
    onRowSelectionChange: yn("rowSelection", t),
    enableRowSelection: !0,
    enableMultiRowSelection: !0,
    enableSubRowSelection: !0
    // enableGroupingRowSelection: false,
    // isAdditiveSelectEvent: (e: unknown) => !!e.metaKey,
    // isInclusiveSelectEvent: (e: unknown) => !!e.shiftKey,
  }),
  createTable: (t) => {
    t.setRowSelection = (e) => t.options.onRowSelectionChange == null ? void 0 : t.options.onRowSelectionChange(e), t.resetRowSelection = (e) => {
      var n;
      return t.setRowSelection(e ? {} : (n = t.initialState.rowSelection) != null ? n : {});
    }, t.toggleAllRowsSelected = (e) => {
      t.setRowSelection((n) => {
        e = typeof e < "u" ? e : !t.getIsAllRowsSelected();
        const o = {
          ...n
        }, r = t.getPreGroupedRowModel().flatRows;
        return e ? r.forEach((s) => {
          s.getCanSelect() && (o[s.id] = !0);
        }) : r.forEach((s) => {
          delete o[s.id];
        }), o;
      });
    }, t.toggleAllPageRowsSelected = (e) => t.setRowSelection((n) => {
      const o = typeof e < "u" ? e : !t.getIsAllPageRowsSelected(), r = {
        ...n
      };
      return t.getRowModel().rows.forEach((s) => {
        Nc(r, s.id, o, !0, t);
      }), r;
    }), t.getPreSelectedRowModel = () => t.getCoreRowModel(), t.getSelectedRowModel = Je(() => [t.getState().rowSelection, t.getCoreRowModel()], (e, n) => Object.keys(e).length ? tc(t, n) : {
      rows: [],
      flatRows: [],
      rowsById: {}
    }, et(t.options, "debugTable", "getSelectedRowModel")), t.getFilteredSelectedRowModel = Je(() => [t.getState().rowSelection, t.getFilteredRowModel()], (e, n) => Object.keys(e).length ? tc(t, n) : {
      rows: [],
      flatRows: [],
      rowsById: {}
    }, et(t.options, "debugTable", "getFilteredSelectedRowModel")), t.getGroupedSelectedRowModel = Je(() => [t.getState().rowSelection, t.getSortedRowModel()], (e, n) => Object.keys(e).length ? tc(t, n) : {
      rows: [],
      flatRows: [],
      rowsById: {}
    }, et(t.options, "debugTable", "getGroupedSelectedRowModel")), t.getIsAllRowsSelected = () => {
      const e = t.getFilteredRowModel().flatRows, {
        rowSelection: n
      } = t.getState();
      let o = !!(e.length && Object.keys(n).length);
      return o && e.some((r) => r.getCanSelect() && !n[r.id]) && (o = !1), o;
    }, t.getIsAllPageRowsSelected = () => {
      const e = t.getPaginationRowModel().flatRows.filter((r) => r.getCanSelect()), {
        rowSelection: n
      } = t.getState();
      let o = !!e.length;
      return o && e.some((r) => !n[r.id]) && (o = !1), o;
    }, t.getIsSomeRowsSelected = () => {
      var e;
      const n = Object.keys((e = t.getState().rowSelection) != null ? e : {}).length;
      return n > 0 && n < t.getFilteredRowModel().flatRows.length;
    }, t.getIsSomePageRowsSelected = () => {
      const e = t.getPaginationRowModel().flatRows;
      return t.getIsAllPageRowsSelected() ? !1 : e.filter((n) => n.getCanSelect()).some((n) => n.getIsSelected() || n.getIsSomeSelected());
    }, t.getToggleAllRowsSelectedHandler = () => (e) => {
      t.toggleAllRowsSelected(e.target.checked);
    }, t.getToggleAllPageRowsSelectedHandler = () => (e) => {
      t.toggleAllPageRowsSelected(e.target.checked);
    };
  },
  createRow: (t, e) => {
    t.toggleSelected = (n, o) => {
      const r = t.getIsSelected();
      e.setRowSelection((s) => {
        var i;
        if (n = typeof n < "u" ? n : !r, t.getCanSelect() && r === n)
          return s;
        const a = {
          ...s
        };
        return Nc(a, t.id, n, (i = o?.selectChildren) != null ? i : !0, e), a;
      });
    }, t.getIsSelected = () => {
      const {
        rowSelection: n
      } = e.getState();
      return gf(t, n);
    }, t.getIsSomeSelected = () => {
      const {
        rowSelection: n
      } = e.getState();
      return Ic(t, n) === "some";
    }, t.getIsAllSubRowsSelected = () => {
      const {
        rowSelection: n
      } = e.getState();
      return Ic(t, n) === "all";
    }, t.getCanSelect = () => {
      var n;
      return typeof e.options.enableRowSelection == "function" ? e.options.enableRowSelection(t) : (n = e.options.enableRowSelection) != null ? n : !0;
    }, t.getCanSelectSubRows = () => {
      var n;
      return typeof e.options.enableSubRowSelection == "function" ? e.options.enableSubRowSelection(t) : (n = e.options.enableSubRowSelection) != null ? n : !0;
    }, t.getCanMultiSelect = () => {
      var n;
      return typeof e.options.enableMultiRowSelection == "function" ? e.options.enableMultiRowSelection(t) : (n = e.options.enableMultiRowSelection) != null ? n : !0;
    }, t.getToggleSelectedHandler = () => {
      const n = t.getCanSelect();
      return (o) => {
        var r;
        n && t.toggleSelected((r = o.target) == null ? void 0 : r.checked);
      };
    };
  }
}, Nc = (t, e, n, o, r) => {
  var s;
  const i = r.getRow(e, !0);
  n ? (i.getCanMultiSelect() || Object.keys(t).forEach((a) => delete t[a]), i.getCanSelect() && (t[e] = !0)) : delete t[e], o && (s = i.subRows) != null && s.length && i.getCanSelectSubRows() && i.subRows.forEach((a) => Nc(t, a.id, n, o, r));
};
function tc(t, e) {
  const n = t.getState().rowSelection, o = [], r = {}, s = function(i, a) {
    return i.map((l) => {
      var c;
      const u = gf(l, n);
      if (u && (o.push(l), r[l.id] = l), (c = l.subRows) != null && c.length && (l = {
        ...l,
        subRows: s(l.subRows)
      }), u)
        return l;
    }).filter(Boolean);
  };
  return {
    rows: s(e.rows),
    flatRows: o,
    rowsById: r
  };
}
function gf(t, e) {
  var n;
  return (n = e[t.id]) != null ? n : !1;
}
function Ic(t, e, n) {
  var o;
  if (!((o = t.subRows) != null && o.length)) return !1;
  let r = !0, s = !1;
  return t.subRows.forEach((i) => {
    if (!(s && !r) && (i.getCanSelect() && (gf(i, e) ? s = !0 : r = !1), i.subRows && i.subRows.length)) {
      const a = Ic(i, e);
      a === "all" ? s = !0 : (a === "some" && (s = !0), r = !1);
    }
  }), r ? "all" : s ? "some" : !1;
}
const Mc = /([0-9]+)/gm, tE = (t, e, n) => T2(Fo(t.getValue(n)).toLowerCase(), Fo(e.getValue(n)).toLowerCase()), nE = (t, e, n) => T2(Fo(t.getValue(n)), Fo(e.getValue(n))), oE = (t, e, n) => mf(Fo(t.getValue(n)).toLowerCase(), Fo(e.getValue(n)).toLowerCase()), rE = (t, e, n) => mf(Fo(t.getValue(n)), Fo(e.getValue(n))), sE = (t, e, n) => {
  const o = t.getValue(n), r = e.getValue(n);
  return o > r ? 1 : o < r ? -1 : 0;
}, iE = (t, e, n) => mf(t.getValue(n), e.getValue(n));
function mf(t, e) {
  return t === e ? 0 : t > e ? 1 : -1;
}
function Fo(t) {
  return typeof t == "number" ? isNaN(t) || t === 1 / 0 || t === -1 / 0 ? "" : String(t) : typeof t == "string" ? t : "";
}
function T2(t, e) {
  const n = t.split(Mc).filter(Boolean), o = e.split(Mc).filter(Boolean);
  for (; n.length && o.length; ) {
    const r = n.shift(), s = o.shift(), i = parseInt(r, 10), a = parseInt(s, 10), l = [i, a].sort();
    if (isNaN(l[0])) {
      if (r > s)
        return 1;
      if (s > r)
        return -1;
      continue;
    }
    if (isNaN(l[1]))
      return isNaN(i) ? -1 : 1;
    if (i > a)
      return 1;
    if (a > i)
      return -1;
  }
  return n.length - o.length;
}
const as = {
  alphanumeric: tE,
  alphanumericCaseSensitive: nE,
  text: oE,
  textCaseSensitive: rE,
  datetime: sE,
  basic: iE
}, aE = {
  getInitialState: (t) => ({
    sorting: [],
    ...t
  }),
  getDefaultColumnDef: () => ({
    sortingFn: "auto",
    sortUndefined: 1
  }),
  getDefaultOptions: (t) => ({
    onSortingChange: yn("sorting", t),
    isMultiSortEvent: (e) => e.shiftKey
  }),
  createColumn: (t, e) => {
    t.getAutoSortingFn = () => {
      const n = e.getFilteredRowModel().flatRows.slice(10);
      let o = !1;
      for (const r of n) {
        const s = r?.getValue(t.id);
        if (Object.prototype.toString.call(s) === "[object Date]")
          return as.datetime;
        if (typeof s == "string" && (o = !0, s.split(Mc).length > 1))
          return as.alphanumeric;
      }
      return o ? as.text : as.basic;
    }, t.getAutoSortDir = () => {
      const n = e.getFilteredRowModel().flatRows[0];
      return typeof n?.getValue(t.id) == "string" ? "asc" : "desc";
    }, t.getSortingFn = () => {
      var n, o;
      if (!t)
        throw new Error();
      return Ja(t.columnDef.sortingFn) ? t.columnDef.sortingFn : t.columnDef.sortingFn === "auto" ? t.getAutoSortingFn() : (n = (o = e.options.sortingFns) == null ? void 0 : o[t.columnDef.sortingFn]) != null ? n : as[t.columnDef.sortingFn];
    }, t.toggleSorting = (n, o) => {
      const r = t.getNextSortingOrder(), s = typeof n < "u" && n !== null;
      e.setSorting((i) => {
        const a = i?.find((p) => p.id === t.id), l = i?.findIndex((p) => p.id === t.id);
        let c = [], u, d = s ? n : r === "desc";
        if (i != null && i.length && t.getCanMultiSort() && o ? a ? u = "toggle" : u = "add" : i != null && i.length && l !== i.length - 1 ? u = "replace" : a ? u = "toggle" : u = "replace", u === "toggle" && (s || r || (u = "remove")), u === "add") {
          var f;
          c = [...i, {
            id: t.id,
            desc: d
          }], c.splice(0, c.length - ((f = e.options.maxMultiSortColCount) != null ? f : Number.MAX_SAFE_INTEGER));
        } else u === "toggle" ? c = i.map((p) => p.id === t.id ? {
          ...p,
          desc: d
        } : p) : u === "remove" ? c = i.filter((p) => p.id !== t.id) : c = [{
          id: t.id,
          desc: d
        }];
        return c;
      });
    }, t.getFirstSortDir = () => {
      var n, o;
      return ((n = (o = t.columnDef.sortDescFirst) != null ? o : e.options.sortDescFirst) != null ? n : t.getAutoSortDir() === "desc") ? "desc" : "asc";
    }, t.getNextSortingOrder = (n) => {
      var o, r;
      const s = t.getFirstSortDir(), i = t.getIsSorted();
      return i ? i !== s && ((o = e.options.enableSortingRemoval) == null || o) && // If enableSortRemove, enable in general
      (!(n && (r = e.options.enableMultiRemove) != null) || r) ? !1 : i === "desc" ? "asc" : "desc" : s;
    }, t.getCanSort = () => {
      var n, o;
      return ((n = t.columnDef.enableSorting) != null ? n : !0) && ((o = e.options.enableSorting) != null ? o : !0) && !!t.accessorFn;
    }, t.getCanMultiSort = () => {
      var n, o;
      return (n = (o = t.columnDef.enableMultiSort) != null ? o : e.options.enableMultiSort) != null ? n : !!t.accessorFn;
    }, t.getIsSorted = () => {
      var n;
      const o = (n = e.getState().sorting) == null ? void 0 : n.find((r) => r.id === t.id);
      return o ? o.desc ? "desc" : "asc" : !1;
    }, t.getSortIndex = () => {
      var n, o;
      return (n = (o = e.getState().sorting) == null ? void 0 : o.findIndex((r) => r.id === t.id)) != null ? n : -1;
    }, t.clearSorting = () => {
      e.setSorting((n) => n != null && n.length ? n.filter((o) => o.id !== t.id) : []);
    }, t.getToggleSortingHandler = () => {
      const n = t.getCanSort();
      return (o) => {
        n && (o.persist == null || o.persist(), t.toggleSorting == null || t.toggleSorting(void 0, t.getCanMultiSort() ? e.options.isMultiSortEvent == null ? void 0 : e.options.isMultiSortEvent(o) : !1));
      };
    };
  },
  createTable: (t) => {
    t.setSorting = (e) => t.options.onSortingChange == null ? void 0 : t.options.onSortingChange(e), t.resetSorting = (e) => {
      var n, o;
      t.setSorting(e ? [] : (n = (o = t.initialState) == null ? void 0 : o.sorting) != null ? n : []);
    }, t.getPreSortedRowModel = () => t.getGroupedRowModel(), t.getSortedRowModel = () => (!t._getSortedRowModel && t.options.getSortedRowModel && (t._getSortedRowModel = t.options.getSortedRowModel(t)), t.options.manualSorting || !t._getSortedRowModel ? t.getPreSortedRowModel() : t._getSortedRowModel());
  }
}, lE = [
  I7,
  K7,
  W7,
  U7,
  T7,
  k7,
  q7,
  //depends on ColumnFaceting
  X7,
  //depends on ColumnFiltering
  aE,
  H7,
  //depends on RowSorting
  Z7,
  Q7,
  J7,
  eE,
  G7
];
function cE(t) {
  var e, n;
  process.env.NODE_ENV !== "production" && (t.debugAll || t.debugTable) && console.info("Creating Table Instance...");
  const o = [...lE, ...(e = t._features) != null ? e : []];
  let r = {
    _features: o
  };
  const s = r._features.reduce((f, p) => Object.assign(f, p.getDefaultOptions == null ? void 0 : p.getDefaultOptions(r)), {}), i = (f) => r.options.mergeOptions ? r.options.mergeOptions(s, f) : {
    ...s,
    ...f
  };
  let l = {
    ...{},
    ...(n = t.initialState) != null ? n : {}
  };
  r._features.forEach((f) => {
    var p;
    l = (p = f.getInitialState == null ? void 0 : f.getInitialState(l)) != null ? p : l;
  });
  const c = [];
  let u = !1;
  const d = {
    _features: o,
    options: {
      ...s,
      ...t
    },
    initialState: l,
    _queue: (f) => {
      c.push(f), u || (u = !0, Promise.resolve().then(() => {
        for (; c.length; )
          c.shift()();
        u = !1;
      }).catch((p) => setTimeout(() => {
        throw p;
      })));
    },
    reset: () => {
      r.setState(r.initialState);
    },
    setOptions: (f) => {
      const p = To(f, r.options);
      r.options = i(p);
    },
    getState: () => r.options.state,
    setState: (f) => {
      r.options.onStateChange == null || r.options.onStateChange(f);
    },
    _getRowId: (f, p, g) => {
      var m;
      return (m = r.options.getRowId == null ? void 0 : r.options.getRowId(f, p, g)) != null ? m : `${g ? [g.id, p].join(".") : p}`;
    },
    getCoreRowModel: () => (r._getCoreRowModel || (r._getCoreRowModel = r.options.getCoreRowModel(r)), r._getCoreRowModel()),
    // The final calls start at the bottom of the model,
    // expanded rows, which then work their way up
    getRowModel: () => r.getPaginationRowModel(),
    //in next version, we should just pass in the row model as the optional 2nd arg
    getRow: (f, p) => {
      let g = (p ? r.getPrePaginationRowModel() : r.getRowModel()).rowsById[f];
      if (!g && (g = r.getCoreRowModel().rowsById[f], !g))
        throw process.env.NODE_ENV !== "production" ? new Error(`getRow could not find row with ID: ${f}`) : new Error();
      return g;
    },
    _getDefaultColumnDef: Je(() => [r.options.defaultColumn], (f) => {
      var p;
      return f = (p = f) != null ? p : {}, {
        header: (g) => {
          const m = g.header.column.columnDef;
          return m.accessorKey ? m.accessorKey : m.accessorFn ? m.id : null;
        },
        // footer: props => props.header.column.id,
        cell: (g) => {
          var m, h;
          return (m = (h = g.renderValue()) == null || h.toString == null ? void 0 : h.toString()) != null ? m : null;
        },
        ...r._features.reduce((g, m) => Object.assign(g, m.getDefaultColumnDef == null ? void 0 : m.getDefaultColumnDef()), {}),
        ...f
      };
    }, et(t, "debugColumns", "_getDefaultColumnDef")),
    _getColumnDefs: () => r.options.columns,
    getAllColumns: Je(() => [r._getColumnDefs()], (f) => {
      const p = function(g, m, h) {
        return h === void 0 && (h = 0), g.map((b) => {
          const w = N7(r, b, h, m), y = b;
          return w.columns = y.columns ? p(y.columns, w, h + 1) : [], w;
        });
      };
      return p(f);
    }, et(t, "debugColumns", "getAllColumns")),
    getAllFlatColumns: Je(() => [r.getAllColumns()], (f) => f.flatMap((p) => p.getFlatColumns()), et(t, "debugColumns", "getAllFlatColumns")),
    _getAllFlatColumnsById: Je(() => [r.getAllFlatColumns()], (f) => f.reduce((p, g) => (p[g.id] = g, p), {}), et(t, "debugColumns", "getAllFlatColumnsById")),
    getAllLeafColumns: Je(() => [r.getAllColumns(), r._getOrderColumnsFn()], (f, p) => {
      let g = f.flatMap((m) => m.getLeafColumns());
      return p(g);
    }, et(t, "debugColumns", "getAllLeafColumns")),
    getColumn: (f) => {
      const p = r._getAllFlatColumnsById()[f];
      return process.env.NODE_ENV !== "production" && !p && console.error(`[Table] Column with id '${f}' does not exist.`), p;
    }
  };
  Object.assign(r, d);
  for (let f = 0; f < r._features.length; f++) {
    const p = r._features[f];
    p == null || p.createTable == null || p.createTable(r);
  }
  return r;
}
function uE() {
  return (t) => Je(() => [t.options.data], (e) => {
    const n = {
      rows: [],
      flatRows: [],
      rowsById: {}
    }, o = function(r, s, i) {
      s === void 0 && (s = 0);
      const a = [];
      for (let c = 0; c < r.length; c++) {
        const u = M7(t, t._getRowId(r[c], c, i), r[c], c, s, void 0, i?.id);
        if (n.flatRows.push(u), n.rowsById[u.id] = u, a.push(u), t.options.getSubRows) {
          var l;
          u.originalSubRows = t.options.getSubRows(r[c], c), (l = u.originalSubRows) != null && l.length && (u.subRows = o(u.originalSubRows, s + 1, u));
        }
      }
      return a;
    };
    return n.rows = o(e), n;
  }, et(t.options, "debugTable", "getRowModel", () => t._autoResetPageIndex()));
}
function dE(t) {
  const e = [], n = (o) => {
    var r;
    e.push(o), (r = o.subRows) != null && r.length && o.getIsExpanded() && o.subRows.forEach(n);
  };
  return t.rows.forEach(n), {
    rows: e,
    flatRows: t.flatRows,
    rowsById: t.rowsById
  };
}
function fE(t) {
  return (e) => Je(() => [e.getState().pagination, e.getPrePaginationRowModel(), e.options.paginateExpandedRows ? void 0 : e.getState().expanded], (n, o) => {
    if (!o.rows.length)
      return o;
    const {
      pageSize: r,
      pageIndex: s
    } = n;
    let {
      rows: i,
      flatRows: a,
      rowsById: l
    } = o;
    const c = r * s, u = c + r;
    i = i.slice(c, u);
    let d;
    e.options.paginateExpandedRows ? d = {
      rows: i,
      flatRows: a,
      rowsById: l
    } : d = dE({
      rows: i,
      flatRows: a,
      rowsById: l
    }), d.flatRows = [];
    const f = (p) => {
      d.flatRows.push(p), p.subRows.length && p.subRows.forEach(f);
    };
    return d.rows.forEach(f), d;
  }, et(e.options, "debugTable", "getPaginationRowModel"));
}
function pE() {
  return (t) => Je(() => [t.getState().sorting, t.getPreSortedRowModel()], (e, n) => {
    if (!n.rows.length || !(e != null && e.length))
      return n;
    const o = t.getState().sorting, r = [], s = o.filter((l) => {
      var c;
      return (c = t.getColumn(l.id)) == null ? void 0 : c.getCanSort();
    }), i = {};
    s.forEach((l) => {
      const c = t.getColumn(l.id);
      c && (i[l.id] = {
        sortUndefined: c.columnDef.sortUndefined,
        invertSorting: c.columnDef.invertSorting,
        sortingFn: c.getSortingFn()
      });
    });
    const a = (l) => {
      const c = l.map((u) => ({
        ...u
      }));
      return c.sort((u, d) => {
        for (let p = 0; p < s.length; p += 1) {
          var f;
          const g = s[p], m = i[g.id], h = m.sortUndefined, b = (f = g?.desc) != null ? f : !1;
          let w = 0;
          if (h) {
            const y = u.getValue(g.id), C = d.getValue(g.id), R = y === void 0, S = C === void 0;
            if (R || S) {
              if (h === "first") return R ? -1 : 1;
              if (h === "last") return R ? 1 : -1;
              w = R && S ? 0 : R ? h : -h;
            }
          }
          if (w === 0 && (w = m.sortingFn(u, d, g.id)), w !== 0)
            return b && (w *= -1), m.invertSorting && (w *= -1), w;
        }
        return u.index - d.index;
      }), c.forEach((u) => {
        var d;
        r.push(u), (d = u.subRows) != null && d.length && (u.subRows = a(u.subRows));
      }), c;
    };
    return {
      rows: a(n.rows),
      flatRows: r,
      rowsById: n.rowsById
    };
  }, et(t.options, "debugTable", "getSortedRowModel", () => t._autoResetPageIndex()));
}
/**
   * react-table
   *
   * Copyright (c) TanStack
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE.md file in the root directory of this source tree.
   *
   * @license MIT
   */
function Wg(t, e) {
  return t ? gE(t) ? /* @__PURE__ */ v.createElement(t, e) : t : null;
}
function gE(t) {
  return mE(t) || typeof t == "function" || hE(t);
}
function mE(t) {
  return typeof t == "function" && (() => {
    const e = Object.getPrototypeOf(t);
    return e.prototype && e.prototype.isReactComponent;
  })();
}
function hE(t) {
  return typeof t == "object" && typeof t.$$typeof == "symbol" && ["react.memo", "react.forward_ref"].includes(t.$$typeof.description);
}
function bE(t) {
  const e = {
    state: {},
    // Dummy state
    onStateChange: () => {
    },
    // noop
    renderFallbackValue: null,
    ...t
  }, [n] = v.useState(() => ({
    current: cE(e)
  })), [o, r] = v.useState(() => n.current.initialState);
  return n.current.setOptions((s) => ({
    ...s,
    ...t,
    state: {
      ...o,
      ...t.state
    },
    // Similarly, we'll maintain both our internal state and any user-provided
    // state.
    onStateChange: (i) => {
      r(i), t.onStateChange == null || t.onStateChange(i);
    }
  })), n.current;
}
const vE = {
  starting: "169px",
  text: "170px",
  doubleLine: "250px",
  chip: "90px",
  chipText: "250px",
  currency: "130px",
  icon: "52px",
  button: "191px",
  toggle: "207px",
  dropdown: "182px",
  input: "var(--table-input-cell-width)",
  calendar: "208px",
  expand: "80px",
  endingSpacer: "8px"
}, yE = ye(["w-full", "caption-bottom", "border-collapse", "bg-table-row-light-surface", "text-text-default", "font-(family-name:--font-family-body)", "text-(length:--font-size-body-medium)", "leading-(--font-line-height-20)", "@max-[480px]/data-table:[--table-input-cell-width:167px]", "@max-[480px]/data-table:[--table-row-height:56px]"], {
  variants: {
    size: {
      sm: ["[--table-input-cell-width:167px]", "[--table-row-height:56px]"],
      md: ["[--table-input-cell-width:167px]", "[--table-row-height:68px]"],
      lg: ["[--table-input-cell-width:208px]", "[--table-row-height:84px]"]
    }
  },
  defaultVariants: {
    size: "md"
  }
}), xE = ye(["relative", "border-b", "border-table-outline", "transition-[box-shadow]", "duration-200", "ease-in-out", "data-[interactive]:cursor-pointer", "data-[selected]:bg-table-row-select"], {
  variants: {
    section: {
      header: ["h-(--spacing-40)"],
      body: ["h-(--table-row-height)", "hover:z-[1]", "hover:shadow-elevation-2"]
    }
  },
  defaultVariants: {
    section: "body"
  }
}), wE = ye(["[&>td:first-child]:relative", "[&>td:first-child]:before:pointer-events-none", "[&>td:first-child]:before:absolute", "[&>td:first-child]:before:inset-y-0", "[&>td:first-child]:before:left-0", "[&>td:first-child]:before:w-(--spacing-4)", "[&>td:first-child]:before:content-['']"], {
  variants: {
    tone: {
      brand: "[&>td:first-child]:before:bg-primary",
      positive: "[&>td:first-child]:before:bg-positive",
      warning: "[&>td:first-child]:before:bg-accessibility-warning",
      negative: "[&>td:first-child]:before:bg-negative",
      informative: "[&>td:first-child]:before:bg-informative"
    }
  }
}), k2 = ye([], {
  variants: {
    align: {
      left: "text-left",
      center: "text-center",
      right: "text-right"
    }
  },
  defaultVariants: {
    align: "left"
  }
}), CE = ye(["h-(--spacing-40)", "whitespace-nowrap", "border-b", "border-table-outline", "bg-table-header-surface", "py-0", "align-middle", "font-(family-name:--font-family-label)", "text-(length:--font-size-label-small)", "font-(number:--font-weight-semibold)", "leading-(--font-line-height-16)", "text-table-header-text"], {
  variants: {
    variant: {
      default: ["px-(--spacing-16)"],
      starting: ["pl-(--spacing-24)", "pr-(--spacing-16)"],
      spacer: ["p-0"]
    }
  },
  defaultVariants: {
    variant: "default"
  }
}), SE = ye(["h-(--table-row-height)", "min-w-0", "px-(--spacing-16)", "py-0", "align-middle", "text-text-default"], {
  variants: {
    variant: {
      starting: ["pl-(--spacing-24)", "pr-(--spacing-16)"],
      text: null,
      doubleLine: null,
      chip: null,
      chipText: null,
      currency: ["font-(family-name:--font-family-label)"],
      icon: ["px-(--spacing-16)", "text-center"],
      button: null,
      toggle: null,
      dropdown: null,
      input: null,
      calendar: null,
      expand: ["px-(--spacing-16)", "text-center"],
      endingSpacer: ["p-0"]
    }
  },
  defaultVariants: {
    variant: "text"
  }
});
function O2(t, e) {
  return t !== void 0 ? typeof t == "number" ? `${t}px` : t : e ? vE[e] : void 0;
}
function D2(t, e) {
  return e ? {
    ...t,
    width: e,
    minWidth: e
  } : t;
}
function _2(t) {
  if (t === "compact") return "@max-[480px]/data-table:hidden";
  if (t === "comfortable") return "@max-[768px]/data-table:hidden";
  if (t === "expanded") return "@max-[1024px]/data-table:hidden";
  if (t === "wide") return "@max-[1280px]/data-table:hidden";
}
function RE(t) {
  const e = J.c(11);
  let n, o, r;
  e[0] !== t ? ({
    size: r,
    style: o,
    ...n
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r) : (n = e[1], o = e[2], r = e[3]);
  const s = r === void 0 ? "md" : r;
  let i;
  e[4] !== s ? (i = yE({
    size: s
  }), e[4] = s, e[5] = i) : i = e[5];
  let a;
  return e[6] !== n || e[7] !== s || e[8] !== o || e[9] !== i ? (a = /* @__PURE__ */ x("table", { "data-slot": "table", "data-size": s, className: i, style: o, ...n }), e[6] = n, e[7] = s, e[8] = o, e[9] = i, e[10] = a) : a = e[10], a;
}
function EE(t) {
  const e = J.c(2);
  let n;
  return e[0] !== t ? (n = /* @__PURE__ */ x("thead", { "data-slot": "table-header", ...t }), e[0] = t, e[1] = n) : n = e[1], n;
}
function PE(t) {
  const e = J.c(2);
  let n;
  return e[0] !== t ? (n = /* @__PURE__ */ x("tbody", { "data-slot": "table-body", ...t }), e[0] = t, e[1] = n) : n = e[1], n;
}
function nc(t) {
  const e = J.c(17);
  let n, o, r, s, i, a;
  e[0] !== t ? ({
    accentTone: n,
    selected: i,
    interactive: a,
    section: s,
    children: o,
    ...r
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r, e[4] = s, e[5] = i, e[6] = a) : (n = e[1], o = e[2], r = e[3], s = e[4], i = e[5], a = e[6]);
  const l = i === void 0 ? !1 : i, c = a === void 0 ? !1 : a, u = l ? "" : void 0, d = c ? "" : void 0, f = l || void 0;
  let p;
  e[7] !== n || e[8] !== s ? (p = le(xE({
    section: s
  }), s !== "header" && n && wE({
    tone: n
  })), e[7] = n, e[8] = s, e[9] = p) : p = e[9];
  let g;
  return e[10] !== o || e[11] !== r || e[12] !== u || e[13] !== d || e[14] !== f || e[15] !== p ? (g = /* @__PURE__ */ x("tr", { "data-slot": "table-row", "data-selected": u, "data-interactive": d, "aria-selected": f, className: p, ...r, children: o }), e[10] = o, e[11] = r, e[12] = u, e[13] = d, e[14] = f, e[15] = p, e[16] = g) : g = e[16], g;
}
function NE(t) {
  return t || "none";
}
function Ug(t, e) {
  return t ? t === e ? "text-primary" : "text-icon-disabled" : "text-icon-main";
}
function IE(t) {
  const e = J.c(13), {
    direction: n
  } = t;
  let o;
  e[0] !== n ? (o = le("absolute left-(--spacing-2) top-[3px] inline-flex", Ug(n, "ascending")), e[0] = n, e[1] = o) : o = e[1];
  let r;
  e[2] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (r = /* @__PURE__ */ x(Ye, { name: "chevron-up", size: "xs", tone: "inherit" }), e[2] = r) : r = e[2];
  let s;
  e[3] !== o ? (s = /* @__PURE__ */ x("span", { className: o, children: r }), e[3] = o, e[4] = s) : s = e[4];
  let i;
  e[5] !== n ? (i = le("absolute left-(--spacing-2) top-[9px] inline-flex", Ug(n, "descending")), e[5] = n, e[6] = i) : i = e[6];
  let a;
  e[7] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (a = /* @__PURE__ */ x(Ye, { name: "chevron-down", size: "xs", tone: "inherit" }), e[7] = a) : a = e[7];
  let l;
  e[8] !== i ? (l = /* @__PURE__ */ x("span", { className: i, children: a }), e[8] = i, e[9] = l) : l = e[9];
  let c;
  return e[10] !== s || e[11] !== l ? (c = /* @__PURE__ */ j("span", { "aria-hidden": "true", className: "relative block h-[28px] w-(--spacing-20) shrink-0", children: [
    s,
    l
  ] }), e[10] = s, e[11] = l, e[12] = c) : c = e[12], c;
}
function ME(t) {
  const e = J.c(72);
  let n, o, r, s, i, a, l, c, u, d, f, p;
  e[0] !== t ? ({
    align: n,
    children: o,
    leadingCheckbox: s,
    sortable: c,
    sortDirection: u,
    tooltip: d,
    hideBelow: r,
    variant: f,
    width: p,
    style: l,
    onSort: i,
    ...a
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r, e[4] = s, e[5] = i, e[6] = a, e[7] = l, e[8] = c, e[9] = u, e[10] = d, e[11] = f, e[12] = p) : (n = e[1], o = e[2], r = e[3], s = e[4], i = e[5], a = e[6], l = e[7], c = e[8], u = e[9], d = e[10], f = e[11], p = e[12]);
  const g = c === void 0 ? !1 : c, m = u === void 0 ? !1 : u;
  let h, b, w, y, C;
  if (e[13] !== n || e[14] !== o || e[15] !== r || e[16] !== s || e[17] !== i || e[18] !== m || e[19] !== g || e[20] !== l || e[21] !== d || e[22] !== f || e[23] !== p) {
    const S = O2(p);
    let E;
    e[29] !== d ? (E = d ? /* @__PURE__ */ x(va, { label: d, showArrow: !1, children: /* @__PURE__ */ x("button", { type: "button", className: "inline-flex shrink-0 items-center border-0 bg-transparent p-0 text-icon-secondary outline-none focus-visible:ring-2 focus-visible:ring-button-focus-ring focus-visible:ring-offset-1 focus-visible:ring-offset-surface", "aria-label": d, children: /* @__PURE__ */ x(Ye, { name: "circle-info", size: "xs", tone: "inherit" }) }) }) : null, e[29] = d, e[30] = E) : E = e[30];
    const P = E, N = n === "right" && "justify-end", I = n === "center" && "justify-center";
    let M;
    e[31] !== N || e[32] !== I ? (M = le("flex min-w-0 items-center gap-(--spacing-8)", N, I), e[31] = N, e[32] = I, e[33] = M) : M = e[33];
    let T;
    e[34] !== o ? (T = /* @__PURE__ */ x("span", { className: "min-w-0 truncate", children: o }), e[34] = o, e[35] = T) : T = e[35];
    let k;
    e[36] !== m || e[37] !== g ? (k = g && /* @__PURE__ */ x(IE, { direction: m }), e[36] = m, e[37] = g, e[38] = k) : k = e[38];
    let D;
    e[39] !== M || e[40] !== T || e[41] !== k ? (D = /* @__PURE__ */ j("span", { className: M, children: [
      T,
      k
    ] }), e[39] = M, e[40] = T, e[41] = k, e[42] = D) : D = e[42];
    const O = D, V = n === "right" && "justify-end", _ = n === "center" && "justify-center";
    let A;
    e[43] !== V || e[44] !== _ ? (A = le("flex min-w-0 items-center gap-(--spacing-12)", V, _), e[43] = V, e[44] = _, e[45] = A) : A = e[45];
    let F;
    e[46] !== s ? (F = s && /* @__PURE__ */ x("span", { className: "inline-flex shrink-0", children: s }), e[46] = s, e[47] = F) : F = e[47];
    let H;
    e[48] !== n || e[49] !== O || e[50] !== i || e[51] !== g ? (H = g ? /* @__PURE__ */ x("button", { type: "button", onClick: i, className: le("flex h-full min-w-0 items-center bg-transparent p-0 text-inherit", "border-0 outline-none cursor-pointer", "focus-visible:ring-2 focus-visible:ring-button-focus-ring focus-visible:ring-offset-1 focus-visible:ring-offset-surface", n === "right" && "justify-end", n === "center" && "justify-center"), children: O }) : O, e[48] = n, e[49] = O, e[50] = i, e[51] = g, e[52] = H) : H = e[52];
    let Y;
    e[53] !== A || e[54] !== F || e[55] !== H || e[56] !== P ? (Y = /* @__PURE__ */ j("span", { className: A, children: [
      F,
      H,
      P
    ] }), e[53] = A, e[54] = F, e[55] = H, e[56] = P, e[57] = Y) : Y = e[57], h = Y, b = "table-head", e[58] !== m || e[59] !== g ? (w = g ? NE(m) : void 0, e[58] = m, e[59] = g, e[60] = w) : w = e[60], e[61] !== n || e[62] !== r || e[63] !== f ? (y = le(CE({
      variant: f
    }), k2({
      align: n
    }), _2(r)), e[61] = n, e[62] = r, e[63] = f, e[64] = y) : y = e[64], C = D2(l, S), e[13] = n, e[14] = o, e[15] = r, e[16] = s, e[17] = i, e[18] = m, e[19] = g, e[20] = l, e[21] = d, e[22] = f, e[23] = p, e[24] = h, e[25] = b, e[26] = w, e[27] = y, e[28] = C;
  } else
    h = e[24], b = e[25], w = e[26], y = e[27], C = e[28];
  let R;
  return e[65] !== h || e[66] !== a || e[67] !== b || e[68] !== w || e[69] !== y || e[70] !== C ? (R = /* @__PURE__ */ x("th", { "data-slot": b, "aria-sort": w, className: y, style: C, ...a, children: h }), e[65] = h, e[66] = a, e[67] = b, e[68] = w, e[69] = y, e[70] = C, e[71] = R) : R = e[71], R;
}
function TE(t) {
  const e = J.c(31);
  let n, o, r, s, i, a, l, c;
  e[0] !== t ? ({
    align: n,
    variant: l,
    hideBelow: r,
    width: c,
    style: i,
    children: o,
    emptyFallback: a,
    ...s
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r, e[4] = s, e[5] = i, e[6] = a, e[7] = l, e[8] = c) : (n = e[1], o = e[2], r = e[3], s = e[4], i = e[5], a = e[6], l = e[7], c = e[8]);
  const u = a === void 0 ? "--" : a, d = l ?? "text";
  let f, p, g, m, h;
  if (e[9] !== n || e[10] !== o || e[11] !== r || e[12] !== d || e[13] !== i || e[14] !== c) {
    const y = O2(c, d);
    f = o == null || typeof o == "string" && o.trim() === "", p = "table-cell", g = d, e[20] !== n || e[21] !== r || e[22] !== d ? (m = le(SE({
      variant: d
    }), k2({
      align: n
    }), _2(r)), e[20] = n, e[21] = r, e[22] = d, e[23] = m) : m = e[23], h = D2(i, y), e[9] = n, e[10] = o, e[11] = r, e[12] = d, e[13] = i, e[14] = c, e[15] = f, e[16] = p, e[17] = g, e[18] = m, e[19] = h;
  } else
    f = e[15], p = e[16], g = e[17], m = e[18], h = e[19];
  const b = d === "endingSpacer" ? null : f ? u : o;
  let w;
  return e[24] !== s || e[25] !== p || e[26] !== g || e[27] !== m || e[28] !== h || e[29] !== b ? (w = /* @__PURE__ */ x("td", { "data-slot": p, "data-variant": g, className: m, style: h, ...s, children: b }), e[24] = s, e[25] = p, e[26] = g, e[27] = m, e[28] = h, e[29] = b, e[30] = w) : w = e[30], w;
}
function V2(t) {
  const e = J.c(2), {
    children: n
  } = t;
  let o;
  return e[0] !== n ? (o = /* @__PURE__ */ x("div", { className: "flex min-w-0 flex-col gap-(--spacing-2)", children: n }), e[0] = n, e[1] = o) : o = e[1], o;
}
function hf(t) {
  const e = J.c(2), {
    children: n
  } = t;
  let o;
  return e[0] !== n ? (o = /* @__PURE__ */ x("span", { className: "min-w-0 truncate font-(family-name:--font-family-body) text-(length:--font-size-body-medium) font-(number:--font-weight-medium) leading-(--font-line-height-20) text-text-default", children: n }), e[0] = n, e[1] = o) : o = e[1], o;
}
function bf(t) {
  const e = J.c(2), {
    children: n
  } = t;
  let o;
  return e[0] !== n ? (o = /* @__PURE__ */ x("span", { className: "min-w-0 truncate font-(family-name:--font-family-body) text-(length:--font-size-body-small) font-(number:--font-weight-regular) leading-(--font-line-height-16) text-text-subtext", children: n }), e[0] = n, e[1] = o) : o = e[1], o;
}
function kE(t) {
  const e = J.c(15), {
    status: n,
    checkbox: o,
    thumbnail: r,
    avatar: s,
    icon: i,
    primary: a,
    secondary: l,
    chip: c
  } = t;
  let u;
  e[0] !== a ? (u = /* @__PURE__ */ x(hf, { children: a }), e[0] = a, e[1] = u) : u = e[1];
  let d;
  e[2] !== c || e[3] !== l ? (d = (l || c) && /* @__PURE__ */ j("div", { className: "flex min-w-0 flex-wrap items-center gap-(--spacing-4) pt-(--spacing-4)", children: [
    l && /* @__PURE__ */ x(bf, { children: l }),
    c && /* @__PURE__ */ x("span", { className: "shrink-0", children: c })
  ] }), e[2] = c, e[3] = l, e[4] = d) : d = e[4];
  let f;
  e[5] !== u || e[6] !== d ? (f = /* @__PURE__ */ j("div", { className: "flex min-w-0 flex-col justify-center", children: [
    u,
    d
  ] }), e[5] = u, e[6] = d, e[7] = f) : f = e[7];
  let p;
  return e[8] !== s || e[9] !== o || e[10] !== i || e[11] !== n || e[12] !== f || e[13] !== r ? (p = /* @__PURE__ */ j("div", { className: "flex min-w-0 items-center gap-(--spacing-8)", children: [
    n,
    o,
    r,
    s,
    i,
    f
  ] }), e[8] = s, e[9] = o, e[10] = i, e[11] = n, e[12] = f, e[13] = r, e[14] = p) : p = e[14], p;
}
function OE(t) {
  const e = J.c(15), {
    leadingIcon: n,
    main: o,
    supporting: r,
    trailingIcon: s
  } = t;
  let i;
  e[0] !== n ? (i = n && /* @__PURE__ */ x("span", { className: "shrink-0", children: n }), e[0] = n, e[1] = i) : i = e[1];
  let a;
  e[2] !== o ? (a = /* @__PURE__ */ x(hf, { children: o }), e[2] = o, e[3] = a) : a = e[3];
  let l;
  e[4] !== r ? (l = r && /* @__PURE__ */ x(bf, { children: r }), e[4] = r, e[5] = l) : l = e[5];
  let c;
  e[6] !== a || e[7] !== l ? (c = /* @__PURE__ */ j(V2, { children: [
    a,
    l
  ] }), e[6] = a, e[7] = l, e[8] = c) : c = e[8];
  let u;
  e[9] !== s ? (u = s && /* @__PURE__ */ x("span", { className: "shrink-0", children: s }), e[9] = s, e[10] = u) : u = e[10];
  let d;
  return e[11] !== i || e[12] !== c || e[13] !== u ? (d = /* @__PURE__ */ j("div", { className: "flex min-w-0 items-center gap-(--spacing-8)", children: [
    i,
    c,
    u
  ] }), e[11] = i, e[12] = c, e[13] = u, e[14] = d) : d = e[14], d;
}
function DE(t) {
  const e = J.c(7), {
    chip: n,
    secondary: o
  } = t;
  let r;
  e[0] !== n ? (r = /* @__PURE__ */ x("span", { className: "shrink-0", children: n }), e[0] = n, e[1] = r) : r = e[1];
  let s;
  e[2] !== o ? (s = o && /* @__PURE__ */ x("span", { className: "min-w-0 truncate text-text-subtext", children: o }), e[2] = o, e[3] = s) : s = e[3];
  let i;
  return e[4] !== r || e[5] !== s ? (i = /* @__PURE__ */ j("div", { className: "flex min-w-0 items-center gap-(--spacing-8)", children: [
    r,
    s
  ] }), e[4] = r, e[5] = s, e[6] = i) : i = e[6], i;
}
const Yg = Object.assign(TE, {
  ChipText: DE,
  Primary: hf,
  Secondary: bf,
  Stack: V2,
  Starting: kE,
  Text: OE
});
function _E(t) {
  return t === "asc" ? "ascending" : t === "desc" ? "descending" : !1;
}
function VE() {
  return import.meta.env?.DEV ?? !1;
}
function tI({
  ariaLabel: t,
  columns: e,
  data: n,
  size: o = "md",
  getRowId: r,
  sorting: s,
  onSortingChange: i,
  manualSorting: a = !1,
  rowSelection: l,
  onRowSelectionChange: c,
  enableRowSelection: u,
  getRowAccentTone: d,
  pagination: f,
  manualPagination: p = !1,
  emptyMessage: g = "No results.",
  variant: m = "fullWidth"
}) {
  const h = u ?? !!(l || c), b = {
    ...s !== void 0 ? {
      sorting: s
    } : {},
    ...l !== void 0 ? {
      rowSelection: l
    } : {},
    ...f !== void 0 ? {
      pagination: {
        pageIndex: Math.max(0, f.currentPage - 1),
        pageSize: f.rowsPerPage
      }
    } : {}
  }, w = bE({
    data: n,
    columns: e,
    defaultColumn: {
      enableSorting: !1
    },
    getRowId: r,
    state: b,
    enableRowSelection: h,
    onSortingChange: i,
    onRowSelectionChange: c,
    manualSorting: a,
    manualPagination: p,
    getCoreRowModel: uE(),
    ...a ? {} : {
      getSortedRowModel: pE()
    },
    ...f !== void 0 && !p ? {
      getPaginationRowModel: fE()
    } : {},
    ...f !== void 0 ? {
      pageCount: f.totalPages
    } : {}
  }), y = w.getVisibleLeafColumns(), C = y[0], R = C?.columnDef.meta;
  return VE() && C && R?.cellVariant !== "starting" && console.warn("DataTable expects the first visible column to use meta.cellVariant = 'starting' to match the table design-system contract."), /* @__PURE__ */ j("div", { "data-slot": "data-table", "data-variant": m, className: le("@container/data-table w-full", m === "card" && ["overflow-hidden", "rounded-(--radius-sm)", "border", "border-outline-subtle", "bg-surface", "shadow-elevation-1"]), children: [
    /* @__PURE__ */ x("div", { "data-slot": "data-table-scroll", className: "w-full overflow-x-auto bg-table-row-light-surface pb-(--spacing-8)", children: /* @__PURE__ */ j(RE, { size: o, "aria-label": t, children: [
      /* @__PURE__ */ x(EE, { children: w.getHeaderGroups().map((S) => /* @__PURE__ */ x(nc, { section: "header", children: S.headers.map((E) => {
        const P = E.column.columnDef.meta, N = E.column.getCanSort(), I = E.column.getToggleSortingHandler(), M = P?.cellVariant === "starting", T = E.column.id === C?.id, k = h && M && T && !E.isPlaceholder, D = w.getIsAllPageRowsSelected(), O = w.getIsSomePageRowsSelected();
        return /* @__PURE__ */ x(ME, { colSpan: E.colSpan, scope: "col", align: P?.headerAlign ?? P?.align, variant: M ? "starting" : void 0, width: P?.width, tooltip: P?.tooltip, hideBelow: P?.hideBelow, leadingCheckbox: k ? /* @__PURE__ */ x(c4, { "aria-label": "Select all visible rows", checked: D, indeterminate: O && !D, onCheckedChange: (V) => w.toggleAllPageRowsSelected(!!V) }) : void 0, sortable: N, sortDirection: _E(E.column.getIsSorted()), onSort: N && I ? (V) => I(V) : void 0, children: E.isPlaceholder ? null : Wg(E.column.columnDef.header, E.getContext()) }, E.id);
      }) }, S.id)) }),
      /* @__PURE__ */ x(PE, { children: w.getRowModel().rows.length > 0 ? w.getRowModel().rows.map((S) => /* @__PURE__ */ x(nc, { accentTone: d?.(S.original), selected: S.getIsSelected(), children: S.getVisibleCells().map((E) => {
        const P = E.column.columnDef.meta;
        return /* @__PURE__ */ x(Yg, { variant: P?.cellVariant, align: P?.align, width: P?.width, hideBelow: P?.hideBelow, "data-hide-below": P?.hideBelow, children: Wg(E.column.columnDef.cell, E.getContext()) }, E.id);
      }) }, S.id)) : /* @__PURE__ */ x(nc, { children: /* @__PURE__ */ x(Yg, { colSpan: y.length, emptyFallback: null, children: /* @__PURE__ */ x("div", { className: "flex h-(--table-row-height) items-center justify-center text-text-subtext", children: g }) }) }) })
    ] }) }),
    f && /* @__PURE__ */ x("div", { "data-slot": "data-table-pagination", className: le(m === "card" && "bg-table-row-light-surface"), children: /* @__PURE__ */ x(yR, { ...f }) })
  ] });
}
const AE = ["flex", "flex-row", "items-center", "border-b", "border-outline-variant"].join(" ");
function nI(t) {
  const e = J.c(6);
  let n, o;
  e[0] !== t ? ({
    children: n,
    ...o
  } = t, e[0] = t, e[1] = n, e[2] = o) : (n = e[1], o = e[2]);
  let r;
  return e[3] !== n || e[4] !== o ? (r = /* @__PURE__ */ x(Fd, { className: AE, ...o, children: n }), e[3] = n, e[4] = o, e[5] = r) : r = e[5], r;
}
const FE = [
  // Layout
  "inline-flex",
  "flex-row",
  "items-center",
  "gap-(--spacing-8)",
  "px-(--spacing-12)",
  "py-(--spacing-6)",
  "rounded-tl-(--radius-sm)",
  "rounded-tr-(--radius-sm)",
  // Typography base
  "font-(family-name:--font-family-body)",
  "text-(length:--font-size-body-large)",
  "leading-(--font-line-height-24)",
  "tracking-(--font-letter-spacing-default)",
  "whitespace-nowrap",
  "outline-none",
  "cursor-pointer",
  "select-none",
  "relative",
  // Transitions
  "transition-colors",
  "duration-200",
  "ease-in-out",
  // Hover state (pointer devices only, not on disabled)
  "not-data-[disabled]:hover:bg-surface-hover",
  // Pressed state
  "not-data-[disabled]:active:bg-surface-pressed",
  // Focus ring
  "focus-visible:ring-2",
  "focus-visible:ring-button-focus-ring",
  // Disabled state
  "data-[disabled]:opacity-50",
  "data-[disabled]:pointer-events-none",
  "data-[disabled]:cursor-default"
].join(" "), LE = ["text-text-subtext", "after:absolute", "after:bottom-0", "after:left-0", "after:right-0", "after:h-(--spacing-2)", "after:translate-y-px", "after:bg-transparent", "after:transition-colors", "after:duration-200", "after:ease-in-out", "group", "data-[active]:text-text-default", "data-[active]:after:bg-primary"].join(" ");
function oI(t) {
  const e = J.c(18);
  let n, o, r, s;
  e[0] !== t ? ({
    icon: r,
    chipLabel: o,
    children: n,
    ...s
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r, e[4] = s) : (n = e[1], o = e[2], r = e[3], s = e[4]);
  let i;
  e[5] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (i = le(FE, LE), e[5] = i) : i = e[5];
  let a;
  e[6] !== r ? (a = r && /* @__PURE__ */ x(Ye, { name: r, size: "sm", tone: "inherit" }), e[6] = r, e[7] = a) : a = e[7];
  const l = typeof n == "string" ? n : void 0;
  let c;
  e[8] !== n || e[9] !== l ? (c = /* @__PURE__ */ x("span", { "data-text": l, className: "relative flex flex-col items-center group-data-[active]:font-semibold before:content-[attr(data-text)] before:font-semibold before:invisible before:h-0 before:overflow-hidden before:pointer-events-none", children: n }), e[8] = n, e[9] = l, e[10] = c) : c = e[10];
  let u;
  e[11] !== o ? (u = o != null && /* @__PURE__ */ x(er, { tone: "neutral", label: o, "aria-hidden": !0 }), e[11] = o, e[12] = u) : u = e[12];
  let d;
  return e[13] !== s || e[14] !== a || e[15] !== c || e[16] !== u ? (d = /* @__PURE__ */ j(Ad, { className: i, ...s, children: [
    a,
    c,
    u
  ] }), e[13] = s, e[14] = a, e[15] = c, e[16] = u, e[17] = d) : d = e[17], d;
}
function rI(t) {
  const e = J.c(6);
  let n, o;
  e[0] !== t ? ({
    children: n,
    ...o
  } = t, e[0] = t, e[1] = n, e[2] = o) : (n = e[1], o = e[2]);
  let r;
  return e[3] !== n || e[4] !== o ? (r = /* @__PURE__ */ x(Hb, { className: "outline-none", ...o, children: n }), e[3] = n, e[4] = o, e[5] = r) : r = e[5], r;
}
function sI(t) {
  const e = J.c(6);
  let n, o;
  e[0] !== t ? ({
    children: n,
    ...o
  } = t, e[0] = t, e[1] = n, e[2] = o) : (n = e[1], o = e[2]);
  let r;
  return e[3] !== n || e[4] !== o ? (r = /* @__PURE__ */ x(Dd, { ...o, children: n }), e[3] = n, e[4] = o, e[5] = r) : r = e[5], r;
}
const $E = ye([
  "inline-flex",
  "items-center",
  "justify-center",
  "gap-(--spacing-4)",
  "h-(--spacing-24)",
  "rounded-(--radius-sm)",
  "px-(--spacing-6)",
  "py-(--spacing-4)",
  "border",
  "border-solid",
  "whitespace-nowrap",
  "overflow-hidden",
  "text-ellipsis",
  "font-(family-name:--font-family-body)",
  "font-(number:--font-weight-medium)",
  "text-(length:--font-size-label-medium)",
  "leading-(--font-line-height-16)",
  "cursor-pointer",
  "select-none",
  "transition-colors",
  "duration-200",
  "ease-in-out",
  "outline-none",
  "[&_svg]:pointer-events-none",
  "[&_svg]:shrink-0",
  // Default state
  "bg-tag-default-background",
  "border-tag-default-outline",
  "text-tag-default-text",
  // Hover state
  "hover:bg-tag-hover-background",
  "hover:border-tag-hover-outline",
  // Pressed state
  "active:bg-tag-pressed-background",
  "active:border-tag-pressed-outline",
  // Focus state
  "focus-visible:ring-2",
  "focus-visible:ring-offset-1",
  "focus-visible:ring-offset-tag-default-background",
  "focus-visible:ring-tag-focus-ring"
]), zE = {
  neutral: "text-tag-icon-default",
  brand: "text-tag-icon-brand",
  positive: "text-tag-icon-positive",
  warning: "text-tag-icon-warning",
  negative: "text-tag-icon-negative"
};
function Gg(t) {
  const e = J.c(20);
  let n, o, r, s, i;
  e[0] !== t ? ({
    children: n,
    icon: o,
    iconTone: s,
    disabled: i,
    ...r
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r, e[4] = s, e[5] = i) : (n = e[1], o = e[2], r = e[3], s = e[4], i = e[5]);
  const a = s === void 0 ? "neutral" : s, l = i === void 0 ? !1 : i, c = o ? a : void 0;
  let u;
  e[6] !== l ? (u = le($E(), l && "opacity-50 pointer-events-none cursor-default"), e[6] = l, e[7] = u) : u = e[7];
  const d = l || void 0, f = l ? -1 : void 0;
  let p;
  e[8] !== o || e[9] !== a ? (p = o && /* @__PURE__ */ x("span", { className: le("inline-flex items-center", zE[a]), children: /* @__PURE__ */ x(Ye, { name: o, size: "xs", tone: "inherit" }) }), e[8] = o, e[9] = a, e[10] = p) : p = e[10];
  let g;
  return e[11] !== n || e[12] !== l || e[13] !== r || e[14] !== c || e[15] !== u || e[16] !== d || e[17] !== f || e[18] !== p ? (g = /* @__PURE__ */ j(Un, { "data-slot": "tag", "data-icon-tone": c, className: u, disabled: l, "aria-disabled": d, tabIndex: f, ...r, children: [
    p,
    n
  ] }), e[11] = n, e[12] = l, e[13] = r, e[14] = c, e[15] = u, e[16] = d, e[17] = f, e[18] = p, e[19] = g) : g = e[19], g;
}
const HE = ye(["flex", "w-full", "flex-col"]), BE = ye(["relative", "flex", "flex-col", "gap-(--spacing-32)", "w-full", "rounded-(--radius-sm)", "border", "border-solid", "border-input-default-outline", "bg-input-default-background", "p-(--spacing-16)", "transition-colors", "duration-200", "ease-in-out", "[&:not([data-disabled=true]):focus-within]:border-input-active-outline", "[&_[data-slot=icon-button]]:text-icon-main"], {
  variants: {
    hasAlert: {
      true: ["rounded-t-none"],
      false: []
    },
    disabled: {
      true: ["opacity-50", "cursor-not-allowed", "[&_textarea]:cursor-not-allowed", "[&_[data-slot=button]:disabled]:opacity-100", "[&_[data-slot=icon-button]:disabled]:opacity-100"],
      false: []
    }
  },
  defaultVariants: {
    hasAlert: !1,
    disabled: !1
  }
}), WE = ye(["[&>div]:rounded-b-none"]), UE = ye(["w-full", "outline-none", "bg-transparent", "resize-none", "text-(length:--font-size-body-medium)", "leading-(--font-line-height-20)", "text-text-default", "placeholder:text-input-text-placeholder"]), YE = ye(["flex", "w-full", "flex-col", "gap-(--spacing-16)"]), GE = ye(["relative", "flex", "flex-col", "gap-(--spacing-12)"]), jE = ye(["inline-flex", "h-(--spacing-24)", "items-center", "font-(family-name:--font-family-label)", "font-(number:--font-weight-semibold)", "text-(length:--font-size-label-sm)", "leading-(--font-line-height-16)", "text-text-subtle", "uppercase"]), KE = ye(["flex", "flex-wrap", "items-center", "gap-(--spacing-8)"]), qE = ye(["flex", "items-center", "justify-between", "gap-(--spacing-32)"]);
function iI(t) {
  const e = J.c(48), {
    value: n,
    onChange: o,
    placeholder: r,
    "aria-label": s,
    disabled: i,
    onSend: a,
    onUpload: l,
    alert: c,
    suggestedUpdates: u
  } = t, d = s === void 0 ? "Message" : s;
  let f;
  e[0] !== u ? (f = u === void 0 ? [] : u, e[0] = u, e[1] = f) : f = e[1];
  const p = f, g = kt(null), [m, h] = Mt(!1);
  let b;
  e[2] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (b = function(z) {
    const Q = g.current;
    if (!Q)
      return;
    Object.getOwnPropertyDescriptor(window.HTMLTextAreaElement.prototype, "value")?.set?.call(Q, z), Q.dispatchEvent(new Event("input", {
      bubbles: !0
    }));
  }, e[2] = b) : b = e[2];
  const w = b;
  let y;
  e[3] !== a ? (y = function() {
    a?.(), w("");
  }, e[3] = a, e[4] = y) : y = e[4];
  const C = y;
  let R;
  e[5] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (R = function(z) {
    w(z.value), g.current?.focus();
  }, e[5] = R) : R = e[5];
  const S = R;
  let E;
  e[6] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (E = function() {
    h(XE);
  }, e[6] = E) : E = e[6];
  const P = E;
  let N;
  e[7] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (N = function(z) {
    z.key === "Escape" && z.currentTarget.blur();
  }, e[7] = N) : N = e[7];
  const I = N, M = !!c;
  let T;
  e[8] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (T = HE(), e[8] = T) : T = e[8];
  let k;
  e[9] !== c || e[10] !== M ? (k = M ? /* @__PURE__ */ x("div", { className: WE(), children: c }) : null, e[9] = c, e[10] = M, e[11] = k) : k = e[11];
  const D = i || void 0;
  let O;
  e[12] !== i || e[13] !== M ? (O = BE({
    disabled: i,
    hasAlert: M
  }), e[12] = i, e[13] = M, e[14] = O) : O = e[14];
  let V;
  e[15] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (V = YE(), e[15] = V) : V = e[15];
  let _;
  e[16] !== i || e[17] !== p || e[18] !== m ? (_ = p.length > 0 && /* @__PURE__ */ x(ZE, { disabled: i, suggestedUpdates: p, suggestedUpdatesCollapsed: m, onToggleSuggestedUpdates: P, onSelectSuggestedUpdate: S }), e[16] = i, e[17] = p, e[18] = m, e[19] = _) : _ = e[19];
  let A;
  e[20] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (A = UE(), e[20] = A) : A = e[20];
  let F;
  e[21] !== d || e[22] !== i || e[23] !== o || e[24] !== r || e[25] !== n ? (F = /* @__PURE__ */ x("textarea", { ref: g, value: n, onChange: o, onKeyDown: I, placeholder: r, disabled: i, "aria-label": d, className: A }), e[21] = d, e[22] = i, e[23] = o, e[24] = r, e[25] = n, e[26] = F) : F = e[26];
  let H;
  e[27] !== _ || e[28] !== F ? (H = /* @__PURE__ */ j("div", { className: V, children: [
    _,
    F
  ] }), e[27] = _, e[28] = F, e[29] = H) : H = e[29];
  let Y;
  e[30] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (Y = qE(), e[30] = Y) : Y = e[30];
  let B;
  e[31] !== i || e[32] !== l ? (B = /* @__PURE__ */ x(Kt, { icon: "upload", variant: "ghost", size: "sm", "aria-label": "Upload file", disabled: i, onClick: l }), e[31] = i, e[32] = l, e[33] = B) : B = e[33];
  let U;
  e[34] !== i || e[35] !== C ? (U = /* @__PURE__ */ x(Hn, { type: "button", variant: "primary", size: "sm", icon: "send", disabled: i, onClick: C, children: "Send" }), e[34] = i, e[35] = C, e[36] = U) : U = e[36];
  let q;
  e[37] !== B || e[38] !== U ? (q = /* @__PURE__ */ j("div", { className: Y, children: [
    B,
    U
  ] }), e[37] = B, e[38] = U, e[39] = q) : q = e[39];
  let W;
  e[40] !== D || e[41] !== O || e[42] !== H || e[43] !== q ? (W = /* @__PURE__ */ j("div", { "data-disabled": D, className: O, children: [
    H,
    q
  ] }), e[40] = D, e[41] = O, e[42] = H, e[43] = q, e[44] = W) : W = e[44];
  let K;
  return e[45] !== k || e[46] !== W ? (K = /* @__PURE__ */ j("div", { className: T, children: [
    k,
    W
  ] }), e[45] = k, e[46] = W, e[47] = K) : K = e[47], K;
}
function XE(t) {
  return !t;
}
function ZE(t) {
  const e = J.c(39), {
    disabled: n,
    suggestedUpdates: o,
    suggestedUpdatesCollapsed: r,
    onToggleSuggestedUpdates: s,
    onSelectSuggestedUpdate: i
  } = t;
  let a;
  e[0] !== o ? (a = {
    items: o,
    maxRows: 2,
    minVisibleItems: 0
  }, e[0] = o, e[1] = a) : a = e[1];
  const {
    containerRef: l,
    measuringContainerRef: c,
    reservedStartRef: u,
    reservedEndRef: d,
    itemRefs: f,
    visibleItems: p
  } = M1(a);
  let g;
  e[2] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (g = GE(), e[2] = g) : g = e[2];
  let m;
  e[3] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (m = KE(), e[3] = m) : m = e[3];
  let h;
  e[4] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (h = jE(), e[4] = h) : h = e[4];
  let b;
  e[5] !== u ? (b = /* @__PURE__ */ x("span", { ref: u, className: h, children: "Suggested Updates" }), e[5] = u, e[6] = b) : b = e[6];
  let w;
  e[7] !== n || e[8] !== i || e[9] !== r || e[10] !== p ? (w = !r && p.map((D) => /* @__PURE__ */ x(Gg, { type: "button", disabled: n, onClick: () => i(D), children: D.label }, `${D.label}-${D.value}`)), e[7] = n, e[8] = i, e[9] = r, e[10] = p, e[11] = w) : w = e[11];
  const y = r ? "eye-watching" : "eye-slash-regular", C = r ? "Show suggested updates" : "Hide suggested updates", R = !r, S = r ? "Show" : "Hide";
  let E;
  e[12] !== n || e[13] !== s || e[14] !== S || e[15] !== y || e[16] !== C || e[17] !== R ? (E = /* @__PURE__ */ x(Hn, { type: "button", variant: "ghost", size: "sm", icon: y, "aria-label": C, "aria-expanded": R, disabled: n, onClick: s, children: S }), e[12] = n, e[13] = s, e[14] = S, e[15] = y, e[16] = C, e[17] = R, e[18] = E) : E = e[18];
  let P;
  e[19] !== d || e[20] !== E ? (P = /* @__PURE__ */ x("span", { ref: d, className: "inline-flex", children: E }), e[19] = d, e[20] = E, e[21] = P) : P = e[21];
  let N;
  e[22] !== l || e[23] !== P || e[24] !== b || e[25] !== w ? (N = /* @__PURE__ */ j("div", { ref: l, className: m, children: [
    b,
    w,
    P
  ] }), e[22] = l, e[23] = P, e[24] = b, e[25] = w, e[26] = N) : N = e[26];
  let I;
  if (e[27] !== f || e[28] !== o) {
    let D;
    e[30] !== f ? (D = (O, V) => /* @__PURE__ */ x("span", { ref: (_) => {
      f.current[V] = _;
    }, className: "inline-flex w-max", children: /* @__PURE__ */ x(Gg, { type: "button", disabled: !0, children: O.label }) }, `${O.label}-${O.value}`), e[30] = f, e[31] = D) : D = e[31], I = o.map(D), e[27] = f, e[28] = o, e[29] = I;
  } else
    I = e[29];
  let M;
  e[32] !== c || e[33] !== I ? (M = /* @__PURE__ */ x("div", { "aria-hidden": "true", className: "pointer-events-none invisible absolute left-0 top-0 h-0 overflow-hidden", children: /* @__PURE__ */ x("div", { ref: c, className: "inline-flex w-max items-center gap-(--spacing-8)", children: I }) }), e[32] = c, e[33] = I, e[34] = M) : M = e[34];
  let T;
  e[35] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (T = /* @__PURE__ */ x(Ya, {}), e[35] = T) : T = e[35];
  let k;
  return e[36] !== N || e[37] !== M ? (k = /* @__PURE__ */ j("div", { className: g, children: [
    N,
    M,
    T
  ] }), e[36] = N, e[37] = M, e[38] = k) : k = e[38], k;
}
const QE = ye(["relative", "flex", "w-full", "min-h-[132px]", "overflow-hidden", "rounded-(--radius-sm)", "border", "border-solid", "border-input-default-outline", "bg-input-default-background", "p-(--spacing-16)", "transition-colors", "duration-200", "ease-in-out", "[&:not([data-disabled=true]):not(:focus-within):not(:has([readonly]))]:active:border-input-pressed-outline", "[&:not([data-disabled=true]):focus-within:not(:has([readonly]))]:border-input-active-outline"], {
  variants: {
    hasError: {
      true: ["border-input-error-outline"],
      false: []
    }
  },
  defaultVariants: {
    hasError: !1
  }
}), JE = ye(["flex-1", "min-w-0", "w-full", "min-h-[98px]", "border-0", "outline-none", "bg-transparent", "resize-y", "overflow-auto", "text-(length:--font-size-body-medium)", "leading-(--font-line-height-20)", "text-text-default", "placeholder:text-input-text-placeholder", "disabled:cursor-not-allowed", "read-only:cursor-default", "read-only:resize-none"]);
function jg(t) {
  return typeof t == "string" || typeof t == "number" ? String(t) : Array.isArray(t) ? t.join(",") : "";
}
function aI(t) {
  const e = J.c(81);
  let n, o, r, s, i, a, l, c, u, d, f, p, g, m, h, b, w, y;
  e[0] !== t ? ({
    id: l,
    label: c,
    error: a,
    tooltip: w,
    required: h,
    disabled: i,
    readOnly: m,
    maxLength: u,
    value: y,
    defaultValue: s,
    placeholder: p,
    tabIndex: b,
    onChange: d,
    onKeyDown: f,
    "aria-describedby": n,
    "aria-label": o,
    "aria-labelledby": r,
    ...g
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r, e[4] = s, e[5] = i, e[6] = a, e[7] = l, e[8] = c, e[9] = u, e[10] = d, e[11] = f, e[12] = p, e[13] = g, e[14] = m, e[15] = h, e[16] = b, e[17] = w, e[18] = y) : (n = e[1], o = e[2], r = e[3], s = e[4], i = e[5], a = e[6], l = e[7], c = e[8], u = e[9], d = e[10], f = e[11], p = e[12], g = e[13], m = e[14], h = e[15], b = e[16], w = e[17], y = e[18]);
  const C = bn(), R = l ?? C;
  let S;
  e[19] !== s ? (S = () => jg(s), e[19] = s, e[20] = S) : S = e[20];
  const [E, P] = Mt(S), N = y !== void 0, I = !!a && !m, M = u !== void 0 && !m && !I, T = !m, k = `${R}-footer`;
  let D;
  e[21] !== n || e[22] !== k || e[23] !== I || e[24] !== M ? (D = [n, I || M ? k : void 0].filter(Boolean).join(" ") || void 0, e[21] = n, e[22] = k, e[23] = I, e[24] = M, e[25] = D) : D = e[25];
  const O = D, V = c || r ? o : o ?? "Text area";
  let _;
  e[26] !== E || e[27] !== N || e[28] !== y ? (_ = N ? jg(y) : E, e[26] = E, e[27] = N, e[28] = y, e[29] = _) : _ = e[29];
  const A = _;
  let F;
  e[30] !== N || e[31] !== d ? (F = function(oe) {
    N || P(oe.currentTarget.value), d?.(oe);
  }, e[30] = N, e[31] = d, e[32] = F) : F = e[32];
  const H = F;
  let Y;
  e[33] !== f ? (Y = function(oe) {
    f?.(oe), !oe.defaultPrevented && oe.key === "Escape" && oe.currentTarget.blur();
  }, e[33] = f, e[34] = Y) : Y = e[34];
  const B = Y;
  let U;
  e[35] !== c || e[36] !== h || e[37] !== R || e[38] !== w ? (U = c && /* @__PURE__ */ x(qr, { htmlFor: R, label: c, required: h, tooltip: w }), e[35] = c, e[36] = h, e[37] = R, e[38] = w, e[39] = U) : U = e[39];
  const q = i || void 0;
  let W;
  e[40] !== i || e[41] !== I ? (W = le(QE({
    hasError: I
  }), i && "opacity-50 cursor-not-allowed"), e[40] = i, e[41] = I, e[42] = W) : W = e[42];
  const K = m ? void 0 : p, te = m ? -1 : b, z = h || void 0, Q = I || void 0, ee = m || void 0;
  let ae;
  e[43] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (ae = JE(), e[43] = ae) : ae = e[43];
  let X;
  e[44] !== V || e[45] !== r || e[46] !== s || e[47] !== O || e[48] !== i || e[49] !== H || e[50] !== B || e[51] !== u || e[52] !== g || e[53] !== m || e[54] !== h || e[55] !== te || e[56] !== z || e[57] !== Q || e[58] !== ee || e[59] !== K || e[60] !== R || e[61] !== y ? (X = /* @__PURE__ */ x(Tu, { render: /* @__PURE__ */ x("textarea", { ...g, id: R, value: y, defaultValue: s, placeholder: K, required: h, disabled: i, readOnly: m, maxLength: u, tabIndex: te, onChange: H, onKeyDown: B, "aria-label": V, "aria-labelledby": r, "aria-required": z, "aria-invalid": Q, "aria-readonly": ee, "aria-describedby": O, className: ae }) }), e[44] = V, e[45] = r, e[46] = s, e[47] = O, e[48] = i, e[49] = H, e[50] = B, e[51] = u, e[52] = g, e[53] = m, e[54] = h, e[55] = te, e[56] = z, e[57] = Q, e[58] = ee, e[59] = K, e[60] = R, e[61] = y, e[62] = X) : X = e[62];
  let se;
  e[63] !== X || e[64] !== q || e[65] !== W ? (se = /* @__PURE__ */ x("div", { "data-disabled": q, className: W, children: X }), e[63] = X, e[64] = q, e[65] = W, e[66] = se) : se = e[66];
  let ue;
  e[67] !== a || e[68] !== k || e[69] !== I || e[70] !== u || e[71] !== M || e[72] !== T || e[73] !== A ? (ue = T && /* @__PURE__ */ j("div", { "data-testid": "textarea-footer", className: "flex justify-between items-center min-h-(--spacing-20) mt-(--spacing-4) gap-(--spacing-8)", children: [
    /* @__PURE__ */ x("div", { className: "flex-1 min-w-0", children: I && /* @__PURE__ */ x(br, { id: k, match: !0, className: "truncate text-(length:--font-size-body-medium) leading-(--font-line-height-20) text-input-error-text", children: a }) }),
    M && /* @__PURE__ */ j("span", { id: k, "aria-live": "polite", className: "shrink-0 text-(length:--font-size-body-small) leading-(--font-line-height-16) text-input-text-supporting whitespace-nowrap", children: [
      A.length,
      "/",
      u
    ] })
  ] }), e[67] = a, e[68] = k, e[69] = I, e[70] = u, e[71] = M, e[72] = T, e[73] = A, e[74] = ue) : ue = e[74];
  let re;
  return e[75] !== i || e[76] !== I || e[77] !== se || e[78] !== ue || e[79] !== U ? (re = /* @__PURE__ */ j(hr, { invalid: I, disabled: i, className: "flex flex-col w-full", children: [
    U,
    se,
    ue
  ] }), e[75] = i, e[76] = I, e[77] = se, e[78] = ue, e[79] = U, e[80] = re) : re = e[80], re;
}
const eP = {
  xs: "size-(--spacing-40)",
  sm: "size-[60px]",
  md: "size-(--spacing-80)",
  lg: "size-[104px]",
  xl: "size-[120px]"
}, tP = {
  xs: 40,
  sm: 60,
  md: 80,
  lg: 104,
  xl: 120
}, nP = {
  xs: "6 6",
  sm: "8 6",
  md: "8 6",
  lg: "8 6",
  xl: "8 6"
}, oP = {
  xs: 4,
  sm: 4,
  md: 0,
  lg: 2,
  xl: 0
};
function lI(t) {
  const e = J.c(18), {
    size: n,
    src: o,
    alt: r,
    selected: s,
    onClick: i,
    "aria-label": a
  } = t, l = n === void 0 ? "md" : n, c = eP[l], u = l === "sm" ? "focus-visible:ring-offset-1" : "focus-visible:ring-offset-2", f = !!o && !!i, p = s !== void 0, g = s && "outline-solid outline-2 outline-primary outline-offset-2";
  let m;
  e[0] !== u || e[1] !== f || e[2] !== g ? (m = le("relative inline-flex items-center justify-center shrink-0 overflow-hidden", "rounded-(--radius-sm)", g, f && ["cursor-pointer", "focus-visible:outline-none", "focus-visible:ring-2", u, "focus-visible:ring-datavis-blue-30"]), e[0] = u, e[1] = f, e[2] = g, e[3] = m) : m = e[3];
  const h = m;
  let b;
  e[4] !== r || e[5] !== l || e[6] !== c || e[7] !== o ? (b = o ? /* @__PURE__ */ x("img", { src: o, alt: r, className: le(c, "object-cover") }) : /* @__PURE__ */ j("div", { "data-slot": "thumbnail-frame", className: le(c, "relative flex items-center justify-center rounded-(--radius-sm) bg-surface-container-lowest text-icon-main"), children: [
    /* @__PURE__ */ x(rP, { size: l }),
    /* @__PURE__ */ x(Ye, { name: "image-regular", size: l, tone: "inherit" })
  ] }), e[4] = r, e[5] = l, e[6] = c, e[7] = o, e[8] = b) : b = e[8];
  const w = b;
  if (f) {
    const C = p ? s : void 0;
    let R;
    return e[9] !== a || e[10] !== i || e[11] !== h || e[12] !== C || e[13] !== w ? (R = /* @__PURE__ */ x(Un, { type: "button", className: h, "aria-label": a, "aria-pressed": C, onClick: i, children: w }), e[9] = a, e[10] = i, e[11] = h, e[12] = C, e[13] = w, e[14] = R) : R = e[14], R;
  }
  let y;
  return e[15] !== h || e[16] !== w ? (y = /* @__PURE__ */ x("div", { className: h, children: w }), e[15] = h, e[16] = w, e[17] = y) : y = e[17], y;
}
function rP(t) {
  const e = J.c(12), {
    size: n
  } = t, o = tP[n], r = o - 0.5, s = r - 3.5, i = nP[n], a = oP[n], l = `M 4 ${0.5} H ${s} A ${3.5} ${3.5} 0 0 1 ${r} 4`, c = `M ${r} 4 V ${s} A ${3.5} ${3.5} 0 0 1 ${s} ${r}`, u = `M ${s} ${r} H 4 A ${3.5} ${3.5} 0 0 1 ${0.5} ${s}`, d = `M ${0.5} ${s} V 4 A ${3.5} ${3.5} 0 0 1 4 ${0.5}`;
  let f;
  e[0] !== l || e[1] !== c || e[2] !== u || e[3] !== d ? (f = [l, c, u, d], e[0] = l, e[1] = c, e[2] = u, e[3] = d, e[4] = f) : f = e[4];
  const p = f, g = `0 0 ${o} ${o}`;
  let m;
  e[5] !== i || e[6] !== a || e[7] !== p ? (m = p.map((b) => /* @__PURE__ */ x("path", { "data-slot": "thumbnail-empty-stroke", className: "stroke-outline-subtle", d: b, strokeDasharray: i, strokeDashoffset: a, strokeLinecap: "butt", strokeLinejoin: "miter", strokeWidth: "1" }, b)), e[5] = i, e[6] = a, e[7] = p, e[8] = m) : m = e[8];
  let h;
  return e[9] !== g || e[10] !== m ? (h = /* @__PURE__ */ x("svg", { "aria-hidden": "true", className: "pointer-events-none absolute inset-0 size-full", fill: "none", viewBox: g, children: m }), e[9] = g, e[10] = m, e[11] = h) : h = e[11], h;
}
function A2(t) {
  const [e, n] = t.split(":").map(Number), o = e < 12 ? "AM" : "PM";
  return `${e === 0 ? 12 : e > 12 ? e - 12 : e}:${String(n).padStart(2, "0")} ${o}`;
}
function li(t) {
  const [e, n] = t.split(":").map(Number), o = e < 12 ? "AM" : "PM", r = e === 0 ? 12 : e > 12 ? e - 12 : e;
  return {
    hour: String(r).padStart(2, "0"),
    minute: String(n).padStart(2, "0"),
    period: o
  };
}
function sP(t) {
  const e = Number(t.hour);
  let n = t.period === "PM" ? e + 12 : e;
  return t.period === "AM" && e === 12 && (n = 0), t.period === "PM" && e === 12 && (n = 12), `${String(n).padStart(2, "0")}:${t.minute}`;
}
function Kg(t) {
  const e = t.trim().match(/^(\d{1,2}):(\d{2})\s*(AM|PM)$/i);
  if (!e) return null;
  let n = parseInt(e[1], 10);
  const o = parseInt(e[2], 10), r = e[3].toUpperCase();
  return n < 1 || n > 12 || o < 0 || o > 59 ? null : (r === "AM" ? n === 12 && (n = 0) : n !== 12 && (n += 12), `${String(n).padStart(2, "0")}:${String(o).padStart(2, "0")}`);
}
function iP(t, e, n) {
  const o = [];
  for (let r = 0; r < 1440; r += t) {
    const s = Math.floor(r / 60), i = r % 60, a = `${String(s).padStart(2, "0")}:${String(i).padStart(2, "0")}`;
    e && a < e || n && a > n || o.push({
      value: a,
      label: A2(a)
    });
  }
  return o;
}
function aP(t, e) {
  const n = /* @__PURE__ */ new Set();
  return t.forEach((o) => {
    const r = li(o.value);
    n.add(r[e]);
  }), [...n];
}
function lP(t, e) {
  const n = li(t.value);
  return n.hour === e.hour && n.minute === e.minute && n.period === e.period;
}
function cP({
  options: t,
  currentParts: e,
  column: n,
  partValue: o
}) {
  const r = {
    ...e,
    [n]: o
  }, s = t.find((i) => lP(i, r));
  return s ? s.value : t.find((i) => li(i.value)[n] === o)?.value ?? t[0]?.value ?? sP(r);
}
function uP(t, e) {
  return li(t?.value ?? e[0]?.value ?? "00:00");
}
function oc({
  options: t,
  currentParts: e,
  column: n
}) {
  return aP(t, n).map((o) => ({
    kind: n,
    value: `${n}-${o}`,
    label: o,
    partValue: o,
    nextValue: cP({
      options: t,
      currentParts: e,
      column: n,
      partValue: o
    })
  }));
}
const dP = ye(["flex", "items-center", "gap-(--spacing-4)", "w-[228px]", "rounded-(--radius-sm)", "border", "border-solid", "border-input-default-outline", "bg-input-default-background", "px-(--spacing-10)", "transition-colors", "duration-200", "ease-in-out", "cursor-text", "[&:not(:focus-within)]:hover:bg-input-hover-background", "[&:not(:focus-within)]:hover:border-input-hover-outline", "active:border-input-pressed-outline", "focus-within:border-input-active-outline"], {
  variants: {
    size: {
      sm: ["h-(--spacing-32)", "py-(--spacing-6)"],
      md: ["h-(--spacing-40)", "py-(--spacing-10)"]
    },
    hasError: {
      true: ["border-input-error-outline", "[&:not(:focus-within)]:hover:border-input-error-outline"],
      false: []
    }
  },
  defaultVariants: {
    size: "md",
    hasError: !1
  }
});
function F2(t, e) {
  return e[t.kind] === t.partValue;
}
function fP(t, e) {
  return t.kind === "time" && e.kind === "time" ? t.value === e.value : t.kind !== "time" && e.kind === "time" ? F2(t, li(e.value)) : t.value === e.value;
}
function rc(t) {
  const e = J.c(19), {
    option: n,
    selectedParts: o
  } = t;
  let r, s, i, a, l;
  e[0] !== n || e[1] !== o ? (s = F2(n, o), r = Qa, i = n, a = `${n.kind} ${n.label}`, l = le(or({}), "justify-center px-(--spacing-8)", s && "bg-menu-item-selected"), e[0] = n, e[1] = o, e[2] = r, e[3] = s, e[4] = i, e[5] = a, e[6] = l) : (r = e[2], s = e[3], i = e[4], a = e[5], l = e[6]);
  let c;
  e[7] !== n.label ? (c = /* @__PURE__ */ x("span", { className: "min-w-0 flex-1 text-center", children: n.label }), e[7] = n.label, e[8] = c) : c = e[8];
  let u;
  e[9] !== n.kind || e[10] !== s ? (u = s && n.kind === "period" && /* @__PURE__ */ x("span", { className: "inline-flex shrink-0 text-menu-icon-secondary", children: /* @__PURE__ */ x(Ye, { name: "check-mark", size: "xs", tone: "inherit" }) }), e[9] = n.kind, e[10] = s, e[11] = u) : u = e[11];
  let d;
  return e[12] !== r || e[13] !== i || e[14] !== a || e[15] !== l || e[16] !== c || e[17] !== u ? (d = /* @__PURE__ */ j(r, { value: i, "aria-label": a, className: l, children: [
    c,
    u
  ] }), e[12] = r, e[13] = i, e[14] = a, e[15] = l, e[16] = c, e[17] = u, e[18] = d) : d = e[18], d;
}
function sc() {
  const t = J.c(1);
  let e;
  return t[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (e = /* @__PURE__ */ x("div", { "aria-hidden": "true", className: "h-[36px]" }), t[0] = e) : e = t[0], e;
}
function cI(t) {
  const e = J.c(80), {
    value: n,
    onValueChange: o,
    id: r,
    label: s,
    placeholder: i,
    size: a,
    required: l,
    description: c,
    tooltip: u,
    error: d,
    disabled: f,
    minuteStep: p,
    minTime: g,
    maxTime: m,
    name: h,
    "data-testid": b
  } = t, w = i === void 0 ? "--:--" : i, y = a === void 0 ? "md" : a, C = f === void 0 ? !1 : f, R = p === void 0 ? 15 : p, [S, E] = Mt(!1), P = bn(), N = r ?? P, I = bn(), M = !!d;
  let T, k, D, O;
  if (e[0] !== m || e[1] !== g || e[2] !== R || e[3] !== n) {
    T = iP(R, g, m), k = n ? {
      ...T.find((be) => be.value === n) ?? {
        value: n,
        label: A2(n)
      },
      kind: "time"
    } : null, D = uP(k, T);
    const ie = {
      hour: oc({
        options: T,
        currentParts: D,
        column: "hour"
      }),
      minute: oc({
        options: T,
        currentParts: D,
        column: "minute"
      }),
      period: oc({
        options: T,
        currentParts: D,
        column: "period"
      })
    }, pe = Math.max(ie.hour.length, ie.minute.length, ie.period.length);
    O = Array.from({
      length: pe
    }, (be, Re) => ({
      hour: ie.hour[Re],
      minute: ie.minute[Re],
      period: ie.period[Re]
    })), e[0] = m, e[1] = g, e[2] = R, e[3] = n, e[4] = T, e[5] = k, e[6] = D, e[7] = O;
  } else
    T = e[4], k = e[5], D = e[6], O = e[7];
  const V = O;
  let _;
  e[8] !== T || e[9] !== o || e[10] !== n ? (_ = function(pe) {
    const be = Kg(pe.currentTarget.value);
    be !== null && be !== n && T.some((Re) => Re.value === be) && o(be);
  }, e[8] = T, e[9] = o, e[10] = n, e[11] = _) : _ = e[11];
  const A = _;
  let F;
  e[12] !== T || e[13] !== o || e[14] !== n ? (F = function(pe) {
    const be = pe.currentTarget.value.trim();
    if (be === "") {
      n !== null && o(null);
      return;
    }
    const Re = Kg(be);
    Re !== null && Re !== n && T.some((_e) => _e.value === Re) && o(Re);
  }, e[12] = T, e[13] = o, e[14] = n, e[15] = F) : F = e[15];
  const H = F;
  let Y;
  e[16] !== o ? (Y = function(pe) {
    if (pe === null) {
      o(null);
      return;
    }
    o(pe.kind === "time" ? pe.value : pe.nextValue);
  }, e[16] = o, e[17] = Y) : Y = e[17];
  const B = Y, U = C && "pointer-events-none";
  let q;
  e[18] !== U ? (q = le("flex flex-col w-fit", U), e[18] = U, e[19] = q) : q = e[19];
  let W;
  e[20] !== N || e[21] !== s || e[22] !== l || e[23] !== u ? (W = s && /* @__PURE__ */ x(qr, { htmlFor: N, label: s, required: l, tooltip: u }), e[20] = N, e[21] = s, e[22] = l, e[23] = u, e[24] = W) : W = e[24];
  let K;
  e[25] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (K = (ie, pe) => {
    E(!ie && pe.reason === "item-press" ? !0 : ie);
  }, e[25] = K) : K = e[25];
  let te;
  e[26] !== C || e[27] !== M || e[28] !== y ? (te = le(dP({
    size: y,
    hasError: M
  }), C && "opacity-50"), e[26] = C, e[27] = M, e[28] = y, e[29] = te) : te = e[29];
  const z = s ? void 0 : "Choose time", Q = l || void 0, ee = M || void 0, ae = c || d ? I : void 0, X = M && "text-input-error-text";
  let se;
  e[30] !== X ? (se = le("flex-1", "min-w-0", "outline-none", "bg-transparent", "text-(length:--font-size-body-medium)", "leading-(--font-line-height-20)", "text-input-text-default", "placeholder:text-input-text-placeholder", X), e[30] = X, e[31] = se) : se = e[31];
  let ue;
  e[32] !== b || e[33] !== H || e[34] !== A || e[35] !== N || e[36] !== w || e[37] !== z || e[38] !== Q || e[39] !== ee || e[40] !== ae || e[41] !== se ? (ue = /* @__PURE__ */ x(Kd, { id: N, "data-testid": b, placeholder: w, "aria-autocomplete": "list", "aria-label": z, "aria-required": Q, "aria-invalid": ee, "aria-describedby": ae, onChange: A, onBlur: H, className: se }), e[32] = b, e[33] = H, e[34] = A, e[35] = N, e[36] = w, e[37] = z, e[38] = Q, e[39] = ee, e[40] = ae, e[41] = se, e[42] = ue) : ue = e[42];
  let re;
  e[43] !== C || e[44] !== k ? (re = k !== null && !C && /* @__PURE__ */ x(sf, { "aria-label": "Clear time", className: "flex items-center justify-center size-(--spacing-16) rounded-(--radius-xs) text-icon-secondary outline-none focus-visible:ring-2 focus-visible:ring-button-focus-ring", children: /* @__PURE__ */ x(Ye, { name: "x-close", size: "xs", tone: "inherit" }) }), e[43] = C, e[44] = k, e[45] = re) : re = e[45];
  let ne;
  e[46] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (ne = /* @__PURE__ */ x(Xd, { "aria-label": "Open time picker", className: "flex items-center justify-center size-(--spacing-16) rounded-(--radius-xs) disabled:opacity-50 outline-none focus-visible:ring-2 focus-visible:ring-button-focus-ring", children: /* @__PURE__ */ x(Ye, { name: "clock-seven", size: "xs", tone: "secondary" }) }), e[46] = ne) : ne = e[46];
  let oe;
  e[47] !== re ? (oe = /* @__PURE__ */ j("div", { className: "flex shrink-0 items-center gap-(--spacing-6)", children: [
    re,
    ne
  ] }), e[47] = re, e[48] = oe) : oe = e[48];
  let me;
  e[49] !== te || e[50] !== ue || e[51] !== oe ? (me = /* @__PURE__ */ j(qd, { className: te, children: [
    ue,
    oe
  ] }), e[49] = te, e[50] = ue, e[51] = oe, e[52] = me) : me = e[52];
  let de;
  e[53] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (de = Ua({
    size: "auto",
    className: "w-[228px]"
  }), e[53] = de) : de = e[53];
  let he;
  e[54] !== V || e[55] !== D ? (he = /* @__PURE__ */ x(Jd, { children: /* @__PURE__ */ x(ef, { sideOffset: 4, className: "w-(--anchor-width)", children: /* @__PURE__ */ x(tf, { className: de, children: /* @__PURE__ */ x(Za, { "aria-label": "Select a time", className: "flex flex-col gap-(--spacing-2) outline-none", children: V.map((ie) => /* @__PURE__ */ j(c2, { className: "grid grid-cols-3 gap-(--spacing-2)", children: [
    ie.hour ? /* @__PURE__ */ x(rc, { option: ie.hour, selectedParts: D }) : /* @__PURE__ */ x(sc, {}),
    ie.minute ? /* @__PURE__ */ x(rc, { option: ie.minute, selectedParts: D }) : /* @__PURE__ */ x(sc, {}),
    ie.period ? /* @__PURE__ */ x(rc, { option: ie.period, selectedParts: D }) : /* @__PURE__ */ x(sc, {})
  ] }, [ie.hour?.value ?? "empty-hour", ie.minute?.value ?? "empty-minute", ie.period?.value ?? "empty-period"].join("-"))) }) }) }) }), e[54] = V, e[55] = D, e[56] = he) : he = e[56];
  let $;
  e[57] !== C || e[58] !== B || e[59] !== h || e[60] !== S || e[61] !== l || e[62] !== k || e[63] !== me || e[64] !== he ? ($ = /* @__PURE__ */ j(Jb, { open: S, onOpenChange: K, value: k, onValueChange: B, isItemEqualToValue: fP, itemToStringLabel: gP, itemToStringValue: pP, disabled: C, required: l, name: h, grid: !0, filter: null, autoComplete: "none", children: [
    me,
    he
  ] }), e[57] = C, e[58] = B, e[59] = h, e[60] = S, e[61] = l, e[62] = k, e[63] = me, e[64] = he, e[65] = $) : $ = e[65];
  let Z;
  e[66] !== c || e[67] !== I || e[68] !== d || e[69] !== M ? (Z = M ? /* @__PURE__ */ x(br, { match: !0, id: I, className: "text-(length:--font-size-body-small) leading-(--font-line-height-16) text-input-error-text", children: d }) : c ? /* @__PURE__ */ x(Yr, { id: I, className: "text-(length:--font-size-body-small) leading-(--font-line-height-16) text-input-text-supporting", children: c }) : null, e[66] = c, e[67] = I, e[68] = d, e[69] = M, e[70] = Z) : Z = e[70];
  let L;
  e[71] !== Z ? (L = /* @__PURE__ */ x("div", { "data-testid": "time-picker-subtext-row", className: "min-h-(--spacing-20) mt-(--spacing-4)", children: Z }), e[71] = Z, e[72] = L) : L = e[72];
  let G;
  return e[73] !== C || e[74] !== M || e[75] !== q || e[76] !== W || e[77] !== $ || e[78] !== L ? (G = /* @__PURE__ */ j(hr, { invalid: M, disabled: C, className: q, children: [
    W,
    $,
    L
  ] }), e[73] = C, e[74] = M, e[75] = q, e[76] = W, e[77] = $, e[78] = L, e[79] = G) : G = e[79], G;
}
function pP(t) {
  return t.kind === "time" ? t.value : t.nextValue;
}
function gP(t) {
  return t.label;
}
const el = /* @__PURE__ */ v.createContext(void 0);
process.env.NODE_ENV !== "production" && (el.displayName = "ToastContext");
function vf() {
  const t = v.useContext(el);
  if (!t)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: useToastManager must be used within <Toast.Provider>." : Xe(73));
  return t;
}
let qg = 0;
function L2(t) {
  return qg += 1, `${t}-${Math.random().toString(36).slice(2, 6)}-${qg}`;
}
function ic(t, e) {
  if (typeof t == "string")
    return {
      description: t
    };
  if (typeof t == "function") {
    const n = t(e);
    return typeof n == "string" ? {
      description: n
    } : n;
  }
  return t;
}
const Bi = Mw((t) => t.toasts, (t) => {
  const e = /* @__PURE__ */ new Map();
  let n = 0, o = 0;
  return t.forEach((r, s) => {
    const i = r.transitionStatus === "ending";
    e.set(r.id, {
      value: r,
      domIndex: s,
      visibleIndex: i ? -1 : n,
      offsetY: o
    }), o += r.height || 0, i || (n += 1);
  }), e;
}), Qn = {
  toasts: ce((t) => t.toasts),
  isEmpty: ce((t) => t.toasts.length === 0),
  toast: ce(Bi, (t, e) => t.get(e)?.value),
  toastIndex: ce(Bi, (t, e) => t.get(e)?.domIndex ?? -1),
  toastOffsetY: ce(Bi, (t, e) => t.get(e)?.offsetY ?? 0),
  toastVisibleIndex: ce(Bi, (t, e) => t.get(e)?.visibleIndex ?? -1),
  hovering: ce((t) => t.hovering),
  focused: ce((t) => t.focused),
  expanded: ce((t) => t.hovering || t.focused),
  expandedOrOutOfFocus: ce((t) => t.hovering || t.focused || !t.isWindowFocused),
  prevFocusElement: ce((t) => t.prevFocusElement)
};
class mP extends ur {
  timers = /* @__PURE__ */ new Map();
  areTimersPaused = !1;
  constructor(e) {
    super(e, {}, Qn);
  }
  setFocused(e) {
    this.set("focused", e);
  }
  setHovering(e) {
    this.set("hovering", e);
  }
  setIsWindowFocused(e) {
    this.set("isWindowFocused", e);
  }
  setPrevFocusElement(e) {
    this.set("prevFocusElement", e);
  }
  setViewport = (e) => {
    this.set("viewport", e);
  };
  disposeEffect = () => () => {
    this.timers.forEach((e) => {
      e.timeout?.clear();
    }), this.timers.clear();
  };
  removeToast(e, n = {}) {
    const o = Qn.toastIndex(this.state, e);
    if (o === -1)
      return;
    const r = this.state.toasts[o];
    n.skipOnRemove || r?.onRemove?.();
    const s = [...this.state.toasts];
    s.splice(o, 1), this.setToasts(s);
  }
  addToast = (e) => {
    const {
      timeout: n,
      limit: o
    } = this.state, r = e.id || L2("toast");
    if (e.id) {
      const c = Qn.toast(this.state, e.id);
      if (c)
        if (c.transitionStatus === "ending")
          this.removeToast(e.id, {
            skipOnRemove: !0
          });
        else {
          const {
            id: u,
            transitionStatus: d,
            ...f
          } = e;
          return this.updateToastInternal(e.id, f, {
            resetTimer: !0,
            markUpdated: !0
          }), e.id;
        }
    }
    const s = {
      ...e,
      id: r,
      updateKey: 0,
      transitionStatus: "starting"
    }, i = [s, ...this.state.toasts], a = i.filter((c) => c.transitionStatus !== "ending");
    if (a.length > o) {
      const c = a.length - o, u = a.slice(-c), d = new Set(u.map((f) => f.id));
      this.setToasts(i.map((f) => {
        const p = d.has(f.id);
        return f.limited !== p ? {
          ...f,
          limited: p
        } : f;
      }));
    } else
      this.setToasts(i.map((c) => c.limited ? {
        ...c,
        limited: !1
      } : c));
    const l = s.timeout ?? n;
    return s.type !== "loading" && l > 0 && this.scheduleTimer(r, l, () => this.closeToast(r)), Qn.expandedOrOutOfFocus(this.state) && this.pauseTimers(), r;
  };
  updateToast = (e, n) => {
    this.updateToastInternal(e, n, {
      markUpdated: !0
    });
  };
  updateToastInternal = (e, n, o = {}) => {
    const {
      timeout: r,
      toasts: s
    } = this.state, i = Qn.toast(this.state, e) ?? null;
    if (!i || i.transitionStatus === "ending")
      return;
    const a = {
      ...i,
      ...n,
      ...o.markUpdated && {
        updateKey: (i.updateKey ?? 0) + 1
      }
    };
    this.setToasts(s.map((m) => m.id === e ? a : m));
    const l = a.timeout ?? r, c = i?.timeout ?? r, u = Object.hasOwn(n, "timeout"), d = a.transitionStatus !== "ending" && a.type !== "loading" && l > 0, f = this.timers.has(e), p = c !== l, g = i?.type === "loading";
    if (!d && f) {
      this.timers.get(e)?.timeout?.clear(), this.timers.delete(e);
      return;
    }
    if (d && (!f || p || u || g || o.resetTimer)) {
      const m = this.timers.get(e);
      m && (m.timeout?.clear(), this.timers.delete(e)), this.scheduleTimer(e, l, () => this.closeToast(e)), Qn.expandedOrOutOfFocus(this.state) && this.pauseTimers();
    }
  };
  closeToast = (e) => {
    const n = e === void 0, {
      limit: o,
      toasts: r
    } = this.state;
    let s;
    if (n)
      s = r, this.timers.forEach((c) => {
        c.timeout?.clear();
      }), this.timers.clear();
    else {
      const c = Qn.toast(this.state, e);
      if (!c)
        return;
      s = [c];
      const u = this.timers.get(e);
      u?.timeout && (u.timeout.clear(), this.timers.delete(e));
    }
    let i = 0;
    const l = {
      toasts: r.map((c) => {
        if (n || c.id === e)
          return {
            ...c,
            transitionStatus: "ending",
            height: 0
          };
        if (c.transitionStatus === "ending")
          return c;
        const u = i >= o;
        return i += 1, c.limited !== u ? {
          ...c,
          limited: u
        } : c;
      })
    };
    (n || r.length === 1) && (l.hovering = !1, l.focused = !1), this.update(l), s.forEach((c) => {
      c.transitionStatus !== "ending" && c.onClose?.();
    }), this.handleFocusManagement(e);
  };
  promiseToast = (e, n) => {
    const o = ic(n.loading), r = this.addToast({
      ...o,
      type: "loading"
    }), s = e.then((i) => {
      const a = ic(n.success, i);
      return this.updateToast(r, {
        ...a,
        type: "success",
        timeout: a.timeout
      }), i;
    }).catch((i) => {
      const a = ic(n.error, i);
      return this.updateToast(r, {
        ...a,
        type: "error",
        timeout: a.timeout
      }), Promise.reject(i);
    });
    return {}.hasOwnProperty.call(n, "setPromise") && n.setPromise(s), s;
  };
  pauseTimers() {
    this.areTimersPaused || (this.areTimersPaused = !0, this.timers.forEach((e) => {
      if (e.timeout) {
        e.timeout.clear();
        const n = Date.now() - e.start, o = e.delay - n;
        e.remaining = o > 0 ? o : 0;
      }
    }));
  }
  resumeTimers() {
    this.areTimersPaused && (this.areTimersPaused = !1, this.timers.forEach((e, n) => {
      e.remaining = e.remaining > 0 ? e.remaining : e.delay, e.timeout ??= gn.create(), e.timeout.start(e.remaining, () => {
        this.timers.delete(n), e.callback();
      }), e.start = Date.now();
    }));
  }
  restoreFocusToPrevElement() {
    this.state.prevFocusElement?.focus({
      preventScroll: !0
    });
  }
  handleDocumentPointerDown = (e) => {
    if (e.pointerType !== "touch")
      return;
    const n = gt(e);
    De(this.state.viewport, n) || (this.resumeTimers(), this.update({
      hovering: !1,
      focused: !1
    }));
  };
  scheduleTimer(e, n, o) {
    const r = Date.now(), s = !Qn.expandedOrOutOfFocus(this.state), i = s ? gn.create() : void 0;
    i?.start(n, () => {
      this.timers.delete(e), o();
    }), this.timers.set(e, {
      timeout: i,
      start: s ? r : 0,
      delay: n,
      remaining: n,
      callback: o
    });
  }
  setToasts(e) {
    const n = {
      toasts: e
    };
    e.length === 0 && (n.hovering = !1, n.focused = !1), this.update(n);
  }
  handleFocusManagement(e) {
    const n = zt(Ke(this.state.viewport));
    if (!this.state.viewport || !De(this.state.viewport, n) || !oa(n))
      return;
    if (e === void 0) {
      this.restoreFocusToPrevElement();
      return;
    }
    const o = Qn.toasts(this.state), r = Qn.toastIndex(this.state, e);
    let s = null, i = r + 1;
    for (; i < o.length; ) {
      if (o[i].transitionStatus !== "ending") {
        s = o[i];
        break;
      }
      i += 1;
    }
    if (!s)
      for (i = r - 1; i >= 0; ) {
        if (o[i].transitionStatus !== "ending") {
          s = o[i];
          break;
        }
        i -= 1;
      }
    s ? s.ref?.current?.focus() : this.restoreFocusToPrevElement();
  }
}
const yf = function(e) {
  const {
    children: n,
    timeout: o = 5e3,
    limit: r = 3,
    toastManager: s
  } = e, i = Pt(() => new mP({
    timeout: o,
    limit: r,
    viewport: null,
    toasts: [],
    hovering: !1,
    focused: !1,
    isWindowFocused: !0,
    prevFocusElement: null
  })).current;
  return Ar(i.disposeEffect), v.useEffect(function() {
    return s ? s[" subscribe"](({
      action: c,
      options: u
    }) => {
      const d = u.id;
      c === "promise" && u.promise ? i.promiseToast(u.promise, u) : c === "update" && d ? i.updateToast(d, u) : c === "close" ? i.closeToast(d) : i.addToast(u);
    }) : void 0;
  }, [i, o, s]), i.useSyncedValues({
    timeout: o,
    limit: r
  }), /* @__PURE__ */ x(el.Provider, {
    value: i,
    children: n
  });
};
process.env.NODE_ENV !== "production" && (yf.displayName = "ToastProvider");
let hP = /* @__PURE__ */ (function(t) {
  return t.frontmostHeight = "--toast-frontmost-height", t;
})({});
const $2 = /* @__PURE__ */ v.forwardRef(function(e, n) {
  const {
    render: o,
    className: r,
    style: s,
    children: i,
    ...a
  } = e, l = vf(), c = Vt(), u = v.useRef(!1), d = v.useRef(!1), f = v.useRef(!1), p = l.useState("isEmpty"), g = l.useState("toasts"), m = l.useState("focused"), h = l.useState("expanded"), b = l.useState("prevFocusElement"), w = g[0]?.height ?? 0, y = v.useMemo(() => g.some((_) => _.transitionStatus === "ending"), [g]);
  v.useEffect(() => {
    const _ = l.state.viewport;
    if (!_)
      return;
    function A(H) {
      p || H.key === "F6" && gt(H) !== _ && (H.preventDefault(), l.setPrevFocusElement(zt(Ke(_))), _?.focus({
        preventScroll: !0
      }), l.pauseTimers(), l.setFocused(!0));
    }
    const F = vt(_);
    return rt(F, "keydown", A);
  }, [l, p]), v.useEffect(() => {
    const _ = l.state.viewport;
    if (!_ || p)
      return;
    const A = vt(_);
    function F(Y) {
      gt(Y) === A && (l.setIsWindowFocused(!1), l.pauseTimers());
    }
    function H(Y) {
      if (Y.relatedTarget)
        return;
      const B = gt(Y), U = zt(Ke(_));
      (B === A || !De(_, B) || !oa(U)) && l.resumeTimers(), c.start(0, () => l.setIsWindowFocused(!0));
    }
    return $n(rt(A, "blur", F, !0), rt(A, "focus", H, !0));
  }, [
    l,
    c,
    // `store.state.viewport` isn't available on the first render,
    // since the portal node hasn't yet been created.
    // By adding this dependency, we ensure the window listeners
    // are added when toasts have been created, once the ref is available.
    p
  ]), v.useEffect(() => {
    const _ = l.state.viewport;
    if (!_ || p)
      return;
    const A = Ke(_);
    return rt(A, "pointerdown", l.handleDocumentPointerDown, !0);
  }, [p, l]);
  function C(_) {
    const A = l.state.viewport;
    A && (u.current = !0, _.relatedTarget === A ? g[0]?.ref?.current?.focus() : l.restoreFocusToPrevElement());
  }
  function R(_) {
    _.key === "Tab" && _.shiftKey && gt(_.nativeEvent) === l.state.viewport && (_.preventDefault(), l.restoreFocusToPrevElement(), l.resumeTimers());
  }
  function S() {
    const _ = l.state.toasts.some((A) => A.transitionStatus === "ending");
    !l.state.isWindowFocused || _ || f.current || !d.current || (l.resumeTimers(), l.setHovering(!1), d.current = !1);
  }
  v.useEffect(S, [y, l]);
  function E() {
    l.pauseTimers(), l.setHovering(!0), d.current = !1;
  }
  function P() {
    y || f.current ? d.current = !0 : (l.resumeTimers(), l.setHovering(!1));
  }
  function N(_) {
    _.pointerType === "touch" && (f.current = !0);
  }
  function I(_) {
    _.pointerType === "touch" && (f.current = !1, S());
  }
  function M() {
    if (u.current) {
      u.current = !1;
      return;
    }
    m || oa(zt(Ke(l.state.viewport))) && (l.setFocused(!0), l.pauseTimers());
  }
  function T(_) {
    !m || De(l.state.viewport, _.relatedTarget) || (l.setFocused(!1), l.resumeTimers());
  }
  const k = {
    tabIndex: -1,
    role: "region",
    "aria-live": "polite",
    "aria-atomic": !1,
    "aria-relevant": "additions text",
    "aria-label": "Notifications",
    onMouseEnter: E,
    onMouseMove: E,
    onMouseLeave: P,
    onFocus: M,
    onBlur: T,
    onKeyDown: R,
    onClick: M,
    onPointerDown: N,
    onPointerUp: I,
    onPointerCancel: I
  }, D = {
    expanded: h
  }, O = Te("div", e, {
    ref: [n, l.setViewport],
    state: D,
    props: [k, {
      style: {
        [hP.frontmostHeight]: w ? `${w}px` : void 0
      }
    }, a, {
      children: /* @__PURE__ */ j(v.Fragment, {
        children: [!p && b && /* @__PURE__ */ x(Mn, {
          onFocus: C
        }), i, !p && b && /* @__PURE__ */ x(Mn, {
          onFocus: C
        })]
      })
    }]
  }), V = v.useMemo(() => g.filter((_) => _.priority === "high"), [g]);
  return /* @__PURE__ */ j(v.Fragment, {
    children: [!p && b && /* @__PURE__ */ x(Mn, {
      onFocus: C
    }), O, !m && V.length > 0 && /* @__PURE__ */ x("div", {
      style: $o,
      children: V.map((_) => /* @__PURE__ */ j("div", {
        role: "alert",
        "aria-atomic": !0,
        children: [/* @__PURE__ */ x("div", {
          children: _.title
        }), /* @__PURE__ */ x("div", {
          children: _.description
        })]
      }, _.id))
    })]
  });
});
process.env.NODE_ENV !== "production" && ($2.displayName = "ToastViewport");
const xf = /* @__PURE__ */ v.createContext(void 0);
process.env.NODE_ENV !== "production" && (xf.displayName = "ToastRootContext");
function tl() {
  const t = v.useContext(xf);
  if (!t)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: ToastRootContext is missing. Toast parts must be used within <Toast.Root>." : Xe(66));
  return t;
}
let jo = /* @__PURE__ */ (function(t) {
  return t.index = "--toast-index", t.offsetY = "--toast-offset-y", t.height = "--toast-height", t.swipeMovementX = "--toast-swipe-movement-x", t.swipeMovementY = "--toast-swipe-movement-y", t;
})({});
const bP = {
  ...Lt,
  swipeDirection(t) {
    return t ? {
      "data-swipe-direction": t
    } : null;
  }
}, ls = 40, vP = 10, No = 0.5, yP = 1, xP = `${qm},${px}`;
function Xg(t, e, n) {
  switch (t) {
    case "up":
      return -n;
    case "down":
      return n;
    case "left":
      return -e;
    case "right":
      return e;
    default:
      return 0;
  }
}
function wP(t) {
  const n = vt(t).getComputedStyle(t).transform;
  let o = 0, r = 0, s = 1;
  if (n && n !== "none") {
    const i = n.match(/matrix(?:3d)?\(([^)]+)\)/);
    if (i) {
      const a = i[1].split(", ").map(parseFloat);
      a.length === 6 ? (o = a[4], r = a[5], s = Math.sqrt(a[0] * a[0] + a[1] * a[1])) : a.length === 16 && (o = a[12], r = a[13], s = a[0]);
    }
  }
  return {
    x: o,
    y: r,
    scale: s
  };
}
const z2 = /* @__PURE__ */ v.forwardRef(function(e, n) {
  const {
    toast: o,
    render: r,
    className: s,
    swipeDirection: i = ["down", "right"],
    style: a,
    ...l
  } = e, c = o.positionerProps?.anchor !== void 0;
  let u = [];
  c || (u = Array.isArray(i) ? i : [i]);
  const d = u.length > 0, f = vf(), [p, g] = v.useState(void 0), [m, h] = v.useState(!1), [b, w] = v.useState(!1), [y, C] = v.useState(!1), [R, S] = v.useState({
    x: 0,
    y: 0
  }), [E, P] = v.useState({
    x: 0,
    y: 0,
    scale: 1
  }), [N, I] = v.useState(), [M, T] = v.useState(), [k, D] = v.useState(null), O = v.useRef(null), V = v.useRef({
    x: 0,
    y: 0
  }), _ = v.useRef({
    x: 0,
    y: 0,
    scale: 1
  }), A = v.useRef(void 0), F = v.useRef(0), H = v.useRef(!1), Y = v.useRef({
    x: 0,
    y: 0
  }), B = v.useRef(!1), U = f.useState("toastIndex", o.id), q = f.useState("toastVisibleIndex", o.id), W = f.useState("toastOffsetY", o.id), K = f.useState("focused"), te = f.useState("expanded");
  Bt({
    open: o.transitionStatus !== "ending",
    ref: O,
    onComplete() {
      o.transitionStatus === "ending" && f.removeToast(o.id);
    }
  });
  const z = ge(($ = !1) => {
    const Z = O.current;
    if (!Z)
      return;
    const L = Z.style.height;
    Z.style.height = "auto";
    const G = Z.offsetHeight;
    Z.style.height = L;
    function ie() {
      f.updateToastInternal(o.id, {
        ref: O,
        height: G,
        ...o.transitionStatus === "starting" ? {
          transitionStatus: void 0
        } : {}
      });
    }
    $ ? tn.flushSync(ie) : ie();
  });
  xe(z, [z]);
  function Q($, Z) {
    let L = $, G = Z;
    return !u.includes("left") && !u.includes("right") ? L = $ > 0 ? $ ** No : -(Math.abs($) ** No) : (!u.includes("right") && $ > 0 && (L = $ ** No), !u.includes("left") && $ < 0 && (L = -(Math.abs($) ** No))), !u.includes("up") && !u.includes("down") ? G = Z > 0 ? Z ** No : -(Math.abs(Z) ** No) : (!u.includes("down") && Z > 0 && (G = Z ** No), !u.includes("up") && Z < 0 && (G = -(Math.abs(Z) ** No))), {
      x: L,
      y: G
    };
  }
  function ee($) {
    if ($.button !== 0)
      return;
    $.pointerType === "touch" && f.pauseTimers();
    const Z = gt($.nativeEvent);
    if (!(Z && Z.closest(`button,a,input,textarea,[role="button"],${xP}`))) {
      if (H.current = !1, A.current = void 0, F.current = 0, V.current = {
        x: $.clientX,
        y: $.clientY
      }, Y.current = V.current, O.current) {
        const G = wP(O.current);
        _.current = G, P(G), S({
          x: G.x,
          y: G.y
        });
      }
      f.setHovering(!0), h(!0), w(!1), D(null), B.current = !0, O.current?.setPointerCapture($.pointerId);
    }
  }
  function ae($) {
    if (!m)
      return;
    $.preventDefault(), B.current && (V.current = {
      x: $.clientX,
      y: $.clientY
    }, B.current = !1);
    const {
      clientY: Z,
      clientX: L,
      movementX: G,
      movementY: ie
    } = $;
    (ie < 0 && Z > Y.current.y || ie > 0 && Z < Y.current.y) && (Y.current = {
      x: Y.current.x,
      y: Z
    }), (G < 0 && L > Y.current.x || G > 0 && L < Y.current.x) && (Y.current = {
      x: L,
      y: Y.current.y
    });
    const pe = L - V.current.x, be = Z - V.current.y, Re = Z - Y.current.y, _e = L - Y.current.x;
    if (!b && Math.sqrt(pe * pe + be * be) >= yP && (w(!0), k === null)) {
      const tt = u.includes("left") || u.includes("right"), ut = u.includes("up") || u.includes("down");
      if (tt && ut) {
        const at = Math.abs(pe), $e = Math.abs(be);
        D(at > $e ? "horizontal" : "vertical");
      }
    }
    let ke;
    if (!A.current)
      k === "vertical" ? be > 0 ? ke = "down" : be < 0 && (ke = "up") : k === "horizontal" ? pe > 0 ? ke = "right" : pe < 0 && (ke = "left") : Math.abs(pe) >= Math.abs(be) ? ke = pe > 0 ? "right" : "left" : ke = be > 0 ? "down" : "up", ke && u.includes(ke) && (A.current = ke, F.current = Xg(ke, pe, be), g(ke));
    else {
      const Ze = A.current, tt = Xg(Ze, _e, Re);
      tt > ls ? (H.current = !1, g(Ze)) : !(u.includes("left") && u.includes("right")) && !(u.includes("up") && u.includes("down")) && F.current - tt >= vP && (H.current = !0);
    }
    const Se = Q(pe, be);
    let Ie = _.current.x, Le = _.current.y;
    k === "horizontal" ? (u.includes("left") || u.includes("right")) && (Ie += Se.x) : (k === "vertical" || (u.includes("left") || u.includes("right")) && (Ie += Se.x), (u.includes("up") || u.includes("down")) && (Le += Se.y)), S({
      x: Ie,
      y: Le
    });
  }
  function X($) {
    if (!m)
      return;
    if (h(!1), w(!1), D(null), O.current?.releasePointerCapture($.pointerId), H.current) {
      S({
        x: E.x,
        y: E.y
      }), g(void 0);
      return;
    }
    let Z = !1;
    const L = R.x - E.x, G = R.y - E.y;
    let ie;
    for (const pe of u) {
      switch (pe) {
        case "right":
          L > ls && (Z = !0, ie = "right");
          break;
        case "left":
          L < -ls && (Z = !0, ie = "left");
          break;
        case "down":
          G > ls && (Z = !0, ie = "down");
          break;
        case "up":
          G < -ls && (Z = !0, ie = "up");
          break;
      }
      if (Z)
        break;
    }
    Z ? (g(ie), C(!0), f.closeToast(o.id)) : (S({
      x: E.x,
      y: E.y
    }), g(void 0));
  }
  function se() {
    m && (h(!1), w(!1), D(null), S({
      x: E.x,
      y: E.y
    }), g(void 0));
  }
  function ue($) {
    if ($.key === "Escape") {
      if (!O.current || !De(O.current, zt(Ke(O.current))))
        return;
      f.closeToast(o.id);
    }
  }
  v.useEffect(() => {
    if (!d)
      return;
    const $ = O.current;
    if (!$)
      return;
    function Z(L) {
      De($, gt(L)) && L.preventDefault();
    }
    return rt($, "touchmove", Z, {
      passive: !1
    });
  }, [d]);
  function re() {
    if (!m && R.x === E.x && R.y === E.y && !y)
      return {
        [jo.swipeMovementX]: "0px",
        [jo.swipeMovementY]: "0px"
      };
    const $ = R.x - E.x, Z = R.y - E.y;
    return {
      transition: m ? "none" : void 0,
      // While swiping, freeze the element at its current visual transform so it doesn't snap to the
      // end position.
      transform: m ? `translateX(${R.x}px) translateY(${R.y}px) scale(${E.scale})` : void 0,
      [jo.swipeMovementX]: `${$}px`,
      [jo.swipeMovementY]: `${Z}px`
    };
  }
  const ne = o.priority === "high", oe = {
    role: ne ? "alertdialog" : "dialog",
    tabIndex: 0,
    "aria-modal": !1,
    "aria-labelledby": N,
    "aria-describedby": M,
    "aria-hidden": ne && !K ? !0 : void 0,
    onPointerDown: d ? ee : void 0,
    onPointerMove: d ? ae : void 0,
    onPointerUp: d ? X : void 0,
    onPointerCancel: d ? se : void 0,
    onKeyDown: ue,
    inert: gr(o.limited),
    style: {
      ...re(),
      [jo.index]: o.transitionStatus === "ending" ? U : q,
      [jo.offsetY]: `${W}px`,
      [jo.height]: o.height ? `${o.height}px` : void 0
    }
  }, me = v.useMemo(() => ({
    rootRef: O,
    toast: o,
    titleId: N,
    setTitleId: I,
    descriptionId: M,
    setDescriptionId: T,
    swiping: m,
    swipeDirection: p,
    recalculateHeight: z,
    index: U,
    visibleIndex: q,
    expanded: te
  }), [o, N, M, m, p, z, U, q, te]), de = {
    transitionStatus: o.transitionStatus,
    expanded: te,
    limited: o.limited || !1,
    type: o.type,
    swiping: me.swiping,
    swipeDirection: me.swipeDirection
  }, he = Te("div", e, {
    ref: [n, me.rootRef],
    state: de,
    stateAttributesMapping: bP,
    props: [oe, l]
  });
  return /* @__PURE__ */ x(xf.Provider, {
    value: me,
    children: he
  });
});
process.env.NODE_ENV !== "production" && (z2.displayName = "ToastRoot");
const H2 = /* @__PURE__ */ v.forwardRef(function(e, n) {
  const {
    render: o,
    className: r,
    style: s,
    ...i
  } = e, {
    visibleIndex: a,
    expanded: l,
    recalculateHeight: c
  } = tl(), u = v.useRef(null);
  xe(() => {
    const g = u.current;
    if (!g || (c(), typeof ResizeObserver != "function" || typeof MutationObserver != "function"))
      return;
    const m = new ResizeObserver(() => c(!0)), h = new MutationObserver(() => c(!0));
    return m.observe(g), h.observe(g, {
      childList: !0,
      subtree: !0,
      characterData: !0
    }), () => {
      m.disconnect(), h.disconnect();
    };
  }, [c]);
  const d = a > 0;
  return Te("div", e, {
    ref: [n, u],
    state: {
      expanded: l,
      behind: d
    },
    props: i
  });
});
process.env.NODE_ENV !== "production" && (H2.displayName = "ToastContent");
const B2 = /* @__PURE__ */ v.forwardRef(function(e, n) {
  const {
    render: o,
    className: r,
    style: s,
    id: i,
    children: a,
    ...l
  } = e, {
    toast: c,
    setDescriptionId: u
  } = tl(), d = a ?? c.description, f = !!d, p = wo(i);
  xe(() => {
    if (f)
      return u(p), () => {
        u(void 0);
      };
  }, [f, p, u]);
  const g = {
    type: c.type
  }, m = Te("p", e, {
    ref: n,
    state: g,
    props: {
      ...l,
      id: p,
      children: d
    }
  });
  return f ? m : null;
});
process.env.NODE_ENV !== "production" && (B2.displayName = "ToastDescription");
const Tc = /* @__PURE__ */ v.forwardRef(function(e, n) {
  const {
    render: o,
    className: r,
    style: s,
    disabled: i,
    nativeButton: a = !0,
    ...l
  } = e, c = vf(), {
    toast: u
  } = tl(), d = c.useState("expanded"), [f, p] = v.useState(!1), {
    getButtonProps: g,
    buttonRef: m
  } = Ft({
    disabled: i,
    native: a
  }), h = {
    type: u.type
  };
  return Te("button", e, {
    ref: [n, m],
    state: h,
    props: [{
      "aria-hidden": !d && !f,
      onClick() {
        c.closeToast(u.id);
      },
      onFocus() {
        p(!0);
      },
      onBlur() {
        p(!1);
      }
    }, l, g]
  });
});
process.env.NODE_ENV !== "production" && (Tc.displayName = "ToastClose");
const kc = /* @__PURE__ */ v.forwardRef(function(e, n) {
  const {
    render: o,
    className: r,
    style: s,
    disabled: i,
    nativeButton: a = !0,
    ...l
  } = e, {
    toast: c
  } = tl(), u = c.actionProps?.children ?? l.children, d = !!u, {
    getButtonProps: f,
    buttonRef: p
  } = Ft({
    disabled: i,
    native: a
  }), g = {
    type: c.type
  }, m = Te("button", e, {
    ref: [n, p],
    state: g,
    props: [l, c.actionProps, f, {
      children: u
    }]
  });
  return d ? m : null;
});
process.env.NODE_ENV !== "production" && (kc.displayName = "ToastAction");
const CP = Va;
function SP() {
  const t = v.useContext(el);
  if (!t)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: useToastManager must be used within <Toast.Provider>." : Xe(73));
  const e = t.useState("toasts");
  return v.useMemo(() => ({
    toasts: e,
    add: t.addToast,
    close: t.closeToast,
    update: t.updateToast,
    promise: t.promiseToast
  }), [e, t]);
}
function RP() {
  const t = /* @__PURE__ */ new Set();
  function e(n) {
    t.forEach((o) => o(n));
  }
  return {
    // This should be private aside from ToastProvider needing to access it.
    // https://x.com/drosenwasser/status/1816947740032872664
    " subscribe": function(o) {
      return t.add(o), () => {
        t.delete(o);
      };
    },
    add(n) {
      const o = n.id || L2("toast"), r = {
        ...n,
        id: o,
        transitionStatus: "starting"
      };
      return e({
        action: "add",
        options: r
      }), o;
    },
    close(n) {
      e({
        action: "close",
        options: {
          id: n
        }
      });
    },
    update(n, o) {
      e({
        action: "update",
        options: {
          ...o,
          id: n
        }
      });
    },
    promise(n, o) {
      let r = n;
      return e({
        action: "promise",
        options: {
          ...o,
          promise: n,
          setPromise(s) {
            r = s;
          }
        }
      }), r;
    }
  };
}
const EP = ye(["rounded-(--radius-sm)", "outline-none", "transition-[opacity,transform,height]", "duration-200", "ease-in-out", "motion-reduce:transition-none", "shadow-elevation-3", "[&[data-starting-style]]:translate-y-2", "[&[data-starting-style]]:opacity-0", "[&[data-ending-style]]:translate-y-2", "[&[data-ending-style]]:opacity-0", "[&[data-limited]]:pointer-events-none", "[&[data-limited]]:opacity-0"], {
  variants: {
    variant: {
      default: ["bg-surface-inverse-surface", "text-surface-inverse-on-surface"],
      error: ["bg-error", "text-error-on-error"]
    },
    placement: {
      static: ["relative", "w-full", "max-w-[344px]"],
      viewport: ["w-full"]
    }
  },
  defaultVariants: {
    variant: "default",
    placement: "static"
  }
}), PP = ye(["flex", "min-h-[48px]", "w-full", "items-center", "pl-(--spacing-10)"], {
  variants: {
    hasClose: {
      true: "pr-(--spacing-4)",
      false: "pr-(--spacing-8)"
    },
    layout: {
      inline: "gap-(--spacing-10)",
      "inline-action": "gap-(--spacing-4)",
      stacked: "items-start gap-(--spacing-10)"
    }
  },
  defaultVariants: {
    hasClose: !1,
    layout: "inline"
  }
}), NP = ye(["m-0", "min-w-0", "font-(family-name:--font-family-body)", "text-(length:--font-size-body-medium)", "font-(number:--font-weight-regular)", "leading-(--font-line-height-20)", "tracking-(--font-letter-spacing-default)", "text-current", "overflow-hidden", "[display:-webkit-box]", "[-webkit-box-orient:vertical]", "[-webkit-line-clamp:2]"]), IP = ye("min-w-0 flex-1 py-(--spacing-10)", {
  variants: {
    layout: {
      inline: "block",
      "inline-action": "block",
      stacked: "flex flex-col items-stretch gap-(--spacing-4)"
    }
  },
  defaultVariants: {
    layout: "inline"
  }
}), MP = ye("shrink-0 py-(--spacing-10)", {
  variants: {
    variant: {
      default: "text-primary-inverse-primary",
      error: "text-error-on-error"
    }
  },
  defaultVariants: {
    variant: "default"
  }
}), TP = ye(["inline-flex", "h-(--spacing-40)", "shrink-0", "items-center", "justify-center", "gap-(--spacing-8)", "whitespace-nowrap", "rounded-(--radius-sm)", "border-0", "bg-transparent", "px-(--spacing-12)", "py-0", "font-(family-name:--font-family-label)", "text-(length:--font-size-label-large)", "font-(number:--font-weight-medium)", "leading-(--font-line-height-20)", "tracking-(--font-letter-spacing-default)", "cursor-pointer", "select-none", "transition-colors", "duration-200", "ease-in-out", "outline-none", "focus-visible:ring-2", "focus-visible:ring-offset-1", "focus-visible:ring-button-focus-ring", "disabled:pointer-events-none", "disabled:opacity-40", "[&_svg]:pointer-events-none", "[&_svg]:shrink-0"], {
  variants: {
    variant: {
      default: ["text-primary-inverse-primary", "hover:bg-surface-inverse-surface-hover", "active:bg-surface-inverse-surface-pressed", "focus-visible:ring-offset-surface-inverse-surface"],
      error: ["text-error-on-error", "hover:bg-toast-error-button-hover-background", "active:bg-toast-error-button-pressed-background", "focus-visible:ring-offset-error"]
    }
  },
  defaultVariants: {
    variant: "default"
  }
}), kP = ye(["inline-flex", "size-[48px]", "shrink-0", "items-center", "justify-center", "rounded-(--radius-sm)", "border-0", "bg-transparent", "p-0", "cursor-pointer", "select-none", "transition-colors", "duration-200", "ease-in-out", "outline-none", "focus-visible:ring-2", "focus-visible:ring-offset-1", "focus-visible:ring-button-focus-ring", "disabled:pointer-events-none", "disabled:opacity-40", "[&_svg]:pointer-events-none", "[&_svg]:shrink-0"], {
  variants: {
    variant: {
      default: ["text-surface-inverse-on-surface", "hover:bg-surface-inverse-surface-hover", "active:bg-surface-inverse-surface-pressed", "focus-visible:ring-offset-surface-inverse-surface"],
      error: ["text-error-on-error", "hover:bg-toast-error-button-hover-background", "active:bg-toast-error-button-pressed-background", "focus-visible:ring-offset-error"]
    }
  },
  defaultVariants: {
    variant: "default"
  }
}), OP = le("fixed", "[left:0]", "[right:0]", "mx-auto", "bottom-(--spacing-24)", "z-[var(--z-toast,400)]", "h-(--toast-frontmost-height)", "w-[min(344px,calc(100vw_-_var(--spacing-32)))]"), DP = 10;
function Zg({
  children: t,
  variant: e,
  disabled: n = !1,
  ...o
}) {
  return /* @__PURE__ */ x(Un, { className: le(TP({
    variant: e
  })), disabled: n, "aria-disabled": n || void 0, tabIndex: n ? -1 : void 0, ...o, children: t });
}
function Qg({
  variant: t,
  disabled: e = !1,
  "aria-label": n = "Dismiss notification",
  ...o
}) {
  return /* @__PURE__ */ x(Un, { className: le(kP({
    variant: t
  })), disabled: e, "aria-disabled": e || void 0, "aria-label": n, tabIndex: e ? -1 : void 0, ...o, children: /* @__PURE__ */ x(Ye, { name: "x-close", size: "sm", tone: "inherit" }) });
}
const W2 = RP();
function _P(t) {
  return t === "error" ? "error" : "default";
}
const VP = {
  add(t, e = {}) {
    const {
      variant: n = "default",
      action: o,
      icon: r = !1,
      onDismiss: s,
      timeout: i
    } = e;
    return W2.add({
      description: t,
      type: n,
      priority: n === "error" ? "high" : "low",
      ...i !== void 0 && {
        timeout: i
      },
      data: {
        action: o,
        icon: r,
        onDismiss: s
      }
    });
  },
  error(t, e = {}) {
    return VP.add(t, {
      ...e,
      variant: "error"
    });
  }
};
function U2(t) {
  const e = J.c(73);
  let n, o, r, s;
  e[0] !== t ? ({
    toast: s,
    onActionComplete: n,
    placement: r,
    ...o
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r, e[4] = s) : (n = e[1], o = e[2], r = e[3], s = e[4]);
  const i = r === void 0 ? "static" : r;
  let a, l, c, u, d, f, p, g, m, h, b, w, y, C, R, S, E;
  if (e[5] !== n || e[6] !== i || e[7] !== o || e[8] !== s) {
    E = _P(s.type), c = s.data?.action;
    const V = s.data?.icon ?? !1, _ = !!s.data?.onDismiss;
    f = c && c.label.length >= DP ? "stacked" : c ? "inline-action" : "inline", p = f === "stacked" && _, g = _ && !p;
    let A;
    e[26] !== c || e[27] !== n ? (A = function() {
      c?.onClick(), n?.();
    }, e[26] = c, e[27] = n, e[28] = A) : A = e[28], u = A;
    let F;
    e[29] !== s.data ? (F = function() {
      s.data?.onDismiss?.();
    }, e[29] = s.data, e[30] = F) : F = e[30], d = F, l = z2, b = s, e[31] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (w = ["down", "right"], e[31] = w) : w = e[31], y = E === "error" ? "alert" : "status", C = E === "error" ? "assertive" : "polite", R = le(EP({
      variant: E,
      placement: i
    })), S = o, a = H2, e[32] !== f || e[33] !== _ ? (m = le(PP({
      hasClose: _,
      layout: f
    })), e[32] = f, e[33] = _, e[34] = m) : m = e[34], h = V && /* @__PURE__ */ x("span", { "data-slot": "toast-leading-icon", className: le(MP({
      variant: E
    })), children: /* @__PURE__ */ x(Ye, { name: E === "error" ? "circle-exclamation" : "circle-check-regular", size: "md", tone: "inherit" }) }), e[5] = n, e[6] = i, e[7] = o, e[8] = s, e[9] = a, e[10] = l, e[11] = c, e[12] = u, e[13] = d, e[14] = f, e[15] = p, e[16] = g, e[17] = m, e[18] = h, e[19] = b, e[20] = w, e[21] = y, e[22] = C, e[23] = R, e[24] = S, e[25] = E;
  } else
    a = e[9], l = e[10], c = e[11], u = e[12], d = e[13], f = e[14], p = e[15], g = e[16], m = e[17], h = e[18], b = e[19], w = e[20], y = e[21], C = e[22], R = e[23], S = e[24], E = e[25];
  let P;
  e[35] !== f ? (P = le(IP({
    layout: f
  })), e[35] = f, e[36] = P) : P = e[36];
  let N;
  e[37] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (N = /* @__PURE__ */ x(B2, { className: le(NP()) }), e[37] = N) : N = e[37];
  let I;
  e[38] !== c || e[39] !== u || e[40] !== d || e[41] !== f || e[42] !== p || e[43] !== E ? (I = c && f === "stacked" && /* @__PURE__ */ j("div", { className: "flex w-full items-center justify-end", children: [
    /* @__PURE__ */ x(kc, { render: /* @__PURE__ */ x(Zg, { variant: E, onClick: u }), children: c.label }),
    p && /* @__PURE__ */ x(Tc, { render: /* @__PURE__ */ x(Qg, { variant: E, "aria-hidden": void 0, onClick: d }) })
  ] }), e[38] = c, e[39] = u, e[40] = d, e[41] = f, e[42] = p, e[43] = E, e[44] = I) : I = e[44];
  let M;
  e[45] !== P || e[46] !== I ? (M = /* @__PURE__ */ j("div", { className: P, children: [
    N,
    I
  ] }), e[45] = P, e[46] = I, e[47] = M) : M = e[47];
  let T;
  e[48] !== c || e[49] !== u || e[50] !== f || e[51] !== E ? (T = c && f === "inline-action" && /* @__PURE__ */ x(kc, { render: /* @__PURE__ */ x(Zg, { variant: E, onClick: u }), children: c.label }), e[48] = c, e[49] = u, e[50] = f, e[51] = E, e[52] = T) : T = e[52];
  let k;
  e[53] !== d || e[54] !== g || e[55] !== E ? (k = g && /* @__PURE__ */ x(Tc, { render: /* @__PURE__ */ x(Qg, { variant: E, "aria-hidden": void 0, onClick: d }) }), e[53] = d, e[54] = g, e[55] = E, e[56] = k) : k = e[56];
  let D;
  e[57] !== a || e[58] !== M || e[59] !== T || e[60] !== k || e[61] !== m || e[62] !== h ? (D = /* @__PURE__ */ j(a, { className: m, children: [
    h,
    M,
    T,
    k
  ] }), e[57] = a, e[58] = M, e[59] = T, e[60] = k, e[61] = m, e[62] = h, e[63] = D) : D = e[63];
  let O;
  return e[64] !== l || e[65] !== D || e[66] !== b || e[67] !== w || e[68] !== y || e[69] !== C || e[70] !== R || e[71] !== S ? (O = /* @__PURE__ */ x(l, { toast: b, swipeDirection: w, role: y, "aria-live": C, className: R, ...S, children: D }), e[64] = l, e[65] = D, e[66] = b, e[67] = w, e[68] = y, e[69] = C, e[70] = R, e[71] = S, e[72] = O) : O = e[72], O;
}
function uI(t) {
  const e = J.c(20);
  let n, o, r, s, i, a;
  e[0] !== t ? ({
    variant: a,
    description: o,
    action: n,
    icon: r,
    onDismiss: s,
    ...i
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r, e[4] = s, e[5] = i, e[6] = a) : (n = e[1], o = e[2], r = e[3], s = e[4], i = e[5], a = e[6]);
  const l = bn(), c = a ?? "default", u = a === "error" ? "high" : "low";
  let d;
  e[7] !== n || e[8] !== r || e[9] !== s ? (d = {
    action: n,
    icon: r,
    onDismiss: s
  }, e[7] = n, e[8] = r, e[9] = s, e[10] = d) : d = e[10];
  let f;
  e[11] !== o || e[12] !== l || e[13] !== c || e[14] !== u || e[15] !== d ? (f = {
    id: l,
    description: o,
    type: c,
    priority: u,
    data: d
  }, e[11] = o, e[12] = l, e[13] = c, e[14] = u, e[15] = d, e[16] = f) : f = e[16];
  let p;
  return e[17] !== i || e[18] !== f ? (p = /* @__PURE__ */ x(yf, { timeout: 0, limit: 1, children: /* @__PURE__ */ x(U2, { toast: f, ...i }) }), e[17] = i, e[18] = f, e[19] = p) : p = e[19], p;
}
function AP() {
  const t = J.c(4), e = SP();
  let n;
  t[0] !== e ? (n = e.toasts.map((r) => /* @__PURE__ */ x(U2, { onActionComplete: () => e.close(r.id), toast: r, placement: "viewport" }, r.id)), t[0] = e, t[1] = n) : n = t[1];
  let o;
  return t[2] !== n ? (o = /* @__PURE__ */ x(CP, { children: /* @__PURE__ */ x($2, { className: OP, children: n }) }), t[2] = n, t[3] = o) : o = t[3], o;
}
const Y2 = /* @__PURE__ */ v.createContext(void 0);
process.env.NODE_ENV !== "production" && (Y2.displayName = "ToggleGroupContext");
function FP(t = !0) {
  const e = v.useContext(Y2);
  if (e === void 0 && !t)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: ToggleGroupContext is missing. ToggleGroup parts must be placed within <ToggleGroup>." : Xe(7));
  return e;
}
const G2 = /* @__PURE__ */ v.forwardRef(function(e, n) {
  const {
    className: o,
    defaultPressed: r = !1,
    disabled: s = !1,
    form: i,
    // never participates in form validation
    onPressedChange: a,
    pressed: l,
    render: c,
    type: u,
    // cannot change button type
    value: d,
    nativeButton: f = !0,
    style: p,
    ...g
  } = e, m = St(d || void 0), h = FP(), b = h?.value ?? [], w = h ? void 0 : r, y = (s || h?.disabled) ?? !1;
  process.env.NODE_ENV !== "production" && xe(() => {
    h && d === void 0 && h.isValueInitialized && Vo("A `<Toggle>` component rendered in a `<ToggleGroup>` has no explicit `value` prop.", "This will cause issues between the Toggle Group and Toggle values.", "Provide the `<Toggle>` with a `value` prop matching the `<ToggleGroup>` values prop type.");
  }, [h, d, h?.isValueInitialized]);
  const [C, R] = sn({
    controlled: h ? m !== void 0 && b.indexOf(m) > -1 : l,
    default: w,
    name: "Toggle",
    state: "pressed"
  }), S = ge((k, D) => {
    m && h?.setGroupValue?.(m, k, D), a?.(k, D);
  }), {
    getButtonProps: E,
    buttonRef: P
  } = Ft({
    disabled: y,
    native: f
  }), N = {
    disabled: y,
    pressed: C
  }, I = [P, n], M = [{
    "aria-pressed": C,
    onClick(k) {
      const D = !C, O = Pe(Et, k.nativeEvent);
      S(D, O), !O.isCanceled && R(D);
    }
  }, g, E], T = Te("button", e, {
    enabled: !h,
    state: N,
    ref: I,
    props: M
  });
  return h ? /* @__PURE__ */ x(Md, {
    tag: "button",
    render: c,
    className: o,
    style: p,
    state: N,
    refs: I,
    props: M
  }) : T;
});
process.env.NODE_ENV !== "production" && (G2.displayName = "Toggle");
const LP = ye(["inline-flex", "items-center", "justify-center", "overflow-hidden", "whitespace-nowrap", "shrink-0", "gap-(--spacing-8)", "rounded-(--radius-sm)", "border", "border-solid", "cursor-pointer", "select-none", "transition-colors", "duration-200", "ease-in-out", "outline-none", "font-(family-name:--font-family-label)", "font-(number:--font-weight-medium)", "text-(length:--font-size-body-medium)", "leading-(--font-line-height-20)", "[&_svg]:pointer-events-none", "[&_svg]:shrink-0", "focus-visible:ring-2", "focus-visible:ring-offset-1", "focus-visible:ring-offset-surface", "focus-visible:ring-button-focus-ring"], {
  variants: {
    variant: {
      outline: ["bg-button-outline-default-background", "text-button-outline-default-text", "border-button-outline-default-border", "hover:bg-button-outline-hover-background", "hover:border-button-outline-hover-border", "active:bg-button-outline-pressed-background", "active:border-button-outline-pressed-border", "data-[pressed]:border-2", "data-[pressed]:border-primary", "data-[pressed]:text-primary"],
      ghost: ["bg-transparent", "text-button-ghost-default-text", "border-transparent", "hover:bg-button-ghost-hover-background", "active:bg-button-ghost-pressed-background", "data-[pressed]:text-primary"]
    }
  },
  defaultVariants: {
    variant: "outline"
  }
});
function dI(t) {
  const e = J.c(23);
  let n, o, r, s, i;
  e[0] !== t ? ({
    icon: n,
    label: o,
    variant: s,
    disabled: i,
    ...r
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r, e[4] = s, e[5] = i) : (n = e[1], o = e[2], r = e[3], s = e[4], i = e[5]);
  const a = s === void 0 ? "outline" : s, l = i === void 0 ? !1 : i;
  let c;
  e[6] !== l || e[7] !== o || e[8] !== a ? (c = le(LP({
    variant: a
  }), o ? "h-(--spacing-32) px-(--spacing-12)" : "size-(--spacing-32)", l && "opacity-40 pointer-events-none cursor-not-allowed"), e[6] = l, e[7] = o, e[8] = a, e[9] = c) : c = e[9];
  const u = l || void 0, d = l ? -1 : void 0;
  let f;
  e[10] !== o ? (f = o && /* @__PURE__ */ x("span", { className: "min-w-0 overflow-hidden text-ellipsis whitespace-nowrap", children: o }), e[10] = o, e[11] = f) : f = e[11];
  let p;
  e[12] !== n ? (p = /* @__PURE__ */ x(Ye, { name: n, size: "xs", tone: "inherit" }), e[12] = n, e[13] = p) : p = e[13];
  let g;
  return e[14] !== l || e[15] !== r || e[16] !== c || e[17] !== u || e[18] !== d || e[19] !== f || e[20] !== p || e[21] !== a ? (g = /* @__PURE__ */ j(G2, { "data-slot": "toggle", "data-variant": a, className: c, disabled: l, "aria-disabled": u, tabIndex: d, ...r, children: [
    f,
    p
  ] }), e[14] = l, e[15] = r, e[16] = c, e[17] = u, e[18] = d, e[19] = f, e[20] = p, e[21] = a, e[22] = g) : g = e[22], g;
}
const $P = {
  photo: {
    icon: "image-regular",
    accept: "image/png,image/jpeg",
    acceptedFormatsLabel: "PNG, JPG",
    buttonLabel: "Select Image"
  },
  file: {
    icon: "upload",
    accept: "application/pdf,text/plain",
    acceptedFormatsLabel: "PDF, TXT",
    buttonLabel: "Select File"
  }
};
function fI(t) {
  const e = J.c(45);
  let n, o, r, s, i, a, l, c, u, d, f;
  e[0] !== t ? ({
    variant: c,
    accept: n,
    acceptedFormatsLabel: o,
    maxSizeLabel: u,
    multiple: d,
    disabled: f,
    buttonLabel: r,
    guidanceLabel: i,
    onFilesSelected: a,
    className: s,
    ...l
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r, e[4] = s, e[5] = i, e[6] = a, e[7] = l, e[8] = c, e[9] = u, e[10] = d, e[11] = f) : (n = e[1], o = e[2], r = e[3], s = e[4], i = e[5], a = e[6], l = e[7], c = e[8], u = e[9], d = e[10], f = e[11]);
  const p = c === void 0 ? "photo" : c, g = u === void 0 ? "5 MB" : u, m = d === void 0 ? !1 : d, h = f === void 0 ? !1 : f, b = bn(), w = bn(), y = kt(null), C = $P[p], R = o ?? C.acceptedFormatsLabel, S = r ?? C.buttonLabel, E = n ?? C.accept, P = i ?? `Upload ${R} up to ${g}`;
  let N;
  e[12] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (N = function() {
    y.current?.click();
  }, e[12] = N) : N = e[12];
  const I = N;
  let M;
  e[13] !== a ? (M = function(q) {
    const W = Array.from(q.currentTarget.files ?? []);
    W.length > 0 && a?.(W), q.currentTarget.value = "";
  }, e[13] = a, e[14] = M) : M = e[14];
  const T = M, k = h || void 0, D = h && "opacity-50";
  let O;
  e[15] !== s || e[16] !== D ? (O = le("flex", "w-[480px]", "max-w-full", "relative", "flex-col", "items-center", "justify-center", "gap-(--spacing-24)", "rounded-(--radius-sm)", "bg-surface-container-lowest", "px-(--spacing-16)", "py-(--spacing-24)", D, s), e[15] = s, e[16] = D, e[17] = O) : O = e[17];
  let V;
  e[18] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (V = /* @__PURE__ */ x(zP, {}), e[18] = V) : V = e[18];
  let _;
  e[19] !== C.icon ? (_ = /* @__PURE__ */ x("span", { "data-slot": "upload-icon", className: "text-text-subtext", children: /* @__PURE__ */ x(Ye, { name: C.icon, size: "lg", tone: "inherit", "aria-hidden": !0 }) }), e[19] = C.icon, e[20] = _) : _ = e[20];
  let A;
  e[21] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (A = le("m-0", "text-center", "font-(family-name:--font-family-label)", "font-(number:--font-weight-medium)", "text-(length:--font-size-body-medium)", "leading-(--font-line-height-20)", "text-text-subtext"), e[21] = A) : A = e[21];
  let F;
  e[22] !== w || e[23] !== P ? (F = /* @__PURE__ */ x("p", { id: w, className: A, children: P }), e[22] = w, e[23] = P, e[24] = F) : F = e[24];
  let H;
  e[25] !== h || e[26] !== w || e[27] !== S ? (H = /* @__PURE__ */ x(Hn, { variant: "outline", size: "md", disabled: h, onClick: I, type: "button", "aria-describedby": w, children: S }), e[25] = h, e[26] = w, e[27] = S, e[28] = H) : H = e[28];
  let Y;
  e[29] !== h || e[30] !== T || e[31] !== b || e[32] !== m || e[33] !== E || e[34] !== S ? (Y = /* @__PURE__ */ x("input", { ref: y, id: b, className: "sr-only", type: "file", accept: E, multiple: m, disabled: h, tabIndex: -1, "aria-label": S, onChange: T }), e[29] = h, e[30] = T, e[31] = b, e[32] = m, e[33] = E, e[34] = S, e[35] = Y) : Y = e[35];
  let B;
  return e[36] !== l || e[37] !== _ || e[38] !== F || e[39] !== H || e[40] !== Y || e[41] !== k || e[42] !== O || e[43] !== p ? (B = /* @__PURE__ */ j("div", { "data-slot": "upload", "data-variant": p, "data-disabled": k, className: O, ...l, children: [
    V,
    _,
    F,
    H,
    Y
  ] }), e[36] = l, e[37] = _, e[38] = F, e[39] = H, e[40] = Y, e[41] = k, e[42] = O, e[43] = p, e[44] = B) : B = e[44], B;
}
function zP() {
  const t = J.c(1);
  let e;
  return t[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (e = /* @__PURE__ */ x("svg", { "aria-hidden": "true", className: "pointer-events-none absolute inset-0 size-full", fill: "none", preserveAspectRatio: "none", viewBox: "0 0 480 188", children: /* @__PURE__ */ x("rect", { className: "stroke-outline-subtle", x: "0.5", y: "0.5", width: "479", height: "187", rx: "4", strokeDasharray: "8 6", strokeLinecap: "butt", strokeWidth: "1", vectorEffect: "non-scaling-stroke" }) }), t[0] = e) : e = t[0], e;
}
const j2 = xa(void 0);
function HP(t) {
  return t === "light" || t === "dark";
}
function BP(t, e) {
  if (typeof window > "u")
    return e;
  try {
    const n = localStorage.getItem(t);
    return HP(n) ? n : e;
  } catch {
    return e;
  }
}
function WP(t) {
  const e = J.c(18), {
    children: n,
    defaultTheme: o,
    storageKey: r
  } = t, s = o === void 0 ? "light" : o, i = r === void 0 ? "assetwatch-ui-theme" : r;
  let a;
  e[0] !== s || e[1] !== i ? (a = () => BP(i, s), e[0] = s, e[1] = i, e[2] = a) : a = e[2];
  const [l, c] = Mt(a);
  let u, d;
  e[3] !== l ? (u = () => {
    const w = window.document.documentElement;
    w.classList.remove("light", "dark"), w.classList.add(l);
  }, d = [l], e[3] = l, e[4] = u, e[5] = d) : (u = e[4], d = e[5]), rr(u, d);
  let f;
  e[6] !== i ? (f = (w) => {
    localStorage.setItem(i, w), c(w);
  }, e[6] = i, e[7] = f) : f = e[7];
  const p = f;
  let g;
  e[8] !== p || e[9] !== l ? (g = () => {
    p(l === "light" ? "dark" : "light");
  }, e[8] = p, e[9] = l, e[10] = g) : g = e[10];
  const m = g;
  let h;
  e[11] !== p || e[12] !== l || e[13] !== m ? (h = {
    theme: l,
    setTheme: p,
    toggleTheme: m
  }, e[11] = p, e[12] = l, e[13] = m, e[14] = h) : h = e[14];
  let b;
  return e[15] !== n || e[16] !== h ? (b = /* @__PURE__ */ x(j2.Provider, { value: h, children: n }), e[15] = n, e[16] = h, e[17] = b) : b = e[17], b;
}
function pI() {
  const t = em(j2);
  if (t === void 0)
    throw new Error("useTheme must be used within a ThemeProvider");
  return t;
}
function gI(t) {
  const e = J.c(5), {
    children: n,
    defaultTheme: o,
    storageKey: r
  } = t;
  let s;
  e[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (s = /* @__PURE__ */ x(AP, {}), e[0] = s) : s = e[0];
  let i;
  return e[1] !== n || e[2] !== o || e[3] !== r ? (i = /* @__PURE__ */ x(tb, { delay: 300, timeout: 400, children: /* @__PURE__ */ x(yf, { toastManager: W2, timeout: 5e3, limit: 1, children: /* @__PURE__ */ j(WP, { defaultTheme: o, storageKey: r, children: [
    n,
    s
  ] }) }) }), e[1] = n, e[2] = o, e[3] = r, e[4] = i) : i = e[4], i;
}
export {
  aN as Accordion,
  JP as ActionItemCard,
  Nf as Alert,
  lN as AnchorLink,
  cN as AnchorNav,
  oN as AssetStatusCard,
  rN as AssetTimeline,
  HN as AssetWatchLogo,
  gI as AssetWatchUiProvider,
  dN as Avatar,
  fN as Badge,
  pN as Banner,
  gN as Breadcrumb,
  hN as BreadcrumbItem,
  bN as BreadcrumbLink,
  mN as BreadcrumbList,
  vN as BreadcrumbPage,
  yN as BreadcrumbSeparator,
  Hn as Button,
  Pa as Card,
  Dv as CardBorderFill,
  KP as CardImageSlot,
  xN as Carousel,
  iI as ChatTextarea,
  c4 as Checkbox,
  er as Chip,
  YN as CircularProgress,
  qP as Container,
  tI as DataTable,
  wN as DatePicker,
  ON as DateRangeFilter,
  CN as Dialog,
  XP as Display,
  Ya as Divider,
  SN as Drawer,
  IN as DrawerBody,
  EN as DrawerClose,
  PN as DrawerContent,
  MN as DrawerFooter,
  NN as DrawerHeader,
  RN as DrawerTrigger,
  TN as FilterPanel,
  AN as Form,
  LN as FormActionColumnHeader,
  L9 as FormFooter,
  FN as FormSection,
  tr as Group,
  ZP as Headline,
  xC as HoverCard,
  CC as HoverCardContent,
  wC as HoverCardTrigger,
  Ye as Icon,
  Kt as IconButton,
  Dl as InlineLink,
  $N as Input,
  eN as InsightCard,
  z9 as Kbd,
  QP as Label,
  zN as ListCard,
  BN as MenuButton,
  tN as MetricCard,
  Sp as Modal,
  WN as MultiSelect,
  yR as Pagination,
  UN as Progress,
  Cr as RELEASE_STATUS,
  ds as RELEASE_STATUS_LABEL,
  jN as Radio,
  GN as RadioGroup,
  iN as ReleaseInfoModal,
  sN as STATUS_DISPLAY,
  KN as Search,
  VN as SegmentedFilter,
  lR as Select,
  _N as SelectedFilters,
  nN as ServiceCard,
  kN as SingleFilter,
  XN as Skeleton,
  DN as SortGroupFilter,
  QN as SortableList,
  m7 as SortableListHandle,
  ZN as SortableListItem,
  vs as Stack,
  JN as Surface,
  eI as Switch,
  RE as Table,
  PE as TableBody,
  Yg as TableCell,
  hf as TableCellPrimary,
  bf as TableCellSecondary,
  V2 as TableCellStack,
  DE as TableChipTextCellContent,
  ME as TableHead,
  EE as TableHeader,
  nc as TableRow,
  kE as TableStartingCellContent,
  OE as TableTextCellContent,
  sI as Tabs,
  rI as TabsContent,
  nI as TabsList,
  oI as TabsTrigger,
  Gg as Tag,
  ys as Text,
  aI as Textarea,
  lI as Thumbnail,
  cI as TimePicker,
  Vr as Title,
  uI as Toast,
  dI as Toggle,
  va as Tooltip,
  Q8 as TooltipIcon,
  gm as Trend,
  fI as Upload,
  VP as toast,
  uN as useAnchorNav,
  M1 as useOverflowItems,
  qN as useSearchHotkey,
  pI as useTheme
};
//# sourceMappingURL=index.js.map
